webpackJsonp([1],{

/***/ "+HSI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPGRADE_TEXT = exports.UPGRADE_TEXT = {
  workouts: {
    icon: 'icon-workouts',
    iconColor: 'teal-dark',
    title: 'Coaching Zone Workouts',
    slug: 'voome-workouts',
    videoId: '5779090549001',
    items: [{
      title: 'Workout Videos',
      description: 'Work up a sweat and have fun with the best trainers, in the comfort of your own home.'
    }, {
      title: 'Express Workouts',
      description: '10-30 min workouts tailored to your fitness level, with timed exercises and expert instruction.'
    }, {
      title: 'Tailored to your fitness level',
      description: 'You\'ll find all our workouts totally doable, with a few hidden challenges to keep you on your toes!'
    }]
  },

  nutrition: {
    icon: 'icon-recipes',
    iconColor: 'green-mid',
    title: 'Coaching Zone Nutrition',
    slug: 'voome-nutrition',
    videoId: '5779089995001',
    items: [{
      title: 'Simple, healthy, delicious recipes',
      description: 'With over 1000 recipes to choose from, you\'ll never be short of ideas.'
    }, {
      title: 'Meal Plans',
      description: 'Creating a meal plan and shopping list for you and your family has never been easier.'
    }, {
      title: 'Tailored for you',
      description: 'Cooking for one or for the family? Lactose intolerant, vegetarian or gluten free? We\'ve got you covered.'
    }]
  }
};

/***/ }),

/***/ "+IQY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgramWorkout = undefined;

var _member = __webpack_require__("1OIp");

var _workout = __webpack_require__("Toxe");

var _completions = __webpack_require__("XI2E");

var ProgramWorkout = exports.ProgramWorkout = {
  template: '\n    <div class="program-workout">\n      <workout>\n        <workout-nav-left>\n          <button-back>\n            Week {{ $ctrl.weekNumber }}\n          </button-back>\n        </workout-nav-left>\n        <workout-header>\n          <div class="container mt-4 mb-3">\n            <completer\n              title="Introduction"\n              is-complete="$ctrl.isComplete"\n              on-toggle="$ctrl.workoutToggleComplete(\n                $ctrl.exercisePlanId,\n                $ctrl.id,\n                $ctrl.subscription.voomeProductId,\n                $ctrl.workout.week,\n                \'Session \' + $ctrl.workout.week,\n                $ctrl.isComplete\n              )">\n            </completer>\n          </div>\n        </workout-header>\n      </workout>\n    </div>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();
      },
      mapState: function mapState(state) {
        var _state$router$current = state.router.currentParams,
            exercisePlanId = _state$router$current.exercisePlanId,
            id = _state$router$current.id,
            weekNumber = _state$router$current.weekNumber;

        var workout = (0, _workout.selectWorkout)(state.workout, id);
        var subscription = (0, _member.selectSubscription)(state.member);
        var printUri = (0, _workout.workoutPrintUri)(id, exercisePlanId, subscription.id);

        return {
          exercisePlanId: exercisePlanId,
          id: id,
          weekNumber: weekNumber,
          printUri: printUri,
          subscription: subscription,
          workout: workout,
          isComplete: (0, _completions.selectWorkoutIsComplete)(state, workout)
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          workoutToggleComplete: _completions.workoutToggleComplete
        };
      }
    };
  }]
};

/***/ }),

/***/ "+IY6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ProgramNotStarted = exports.ProgramNotStarted = {
  transclude: true,

  bindings: {
    hasStarted: '<'
  },

  template: '\n    <div class="program-not-started">\n      <div class="overlay text-center" ng-if="!$ctrl.hasStarted">\n        <div class="container">\n          <div class="col-md-6 mx-auto">\n            <h5>Ready to start?</h5>\n            <p class="my-3">\n              Ready to start? Press start to access your workouts and meal plans.\n            </p>\n            <button class="btn btn-pill btn-lg theme-btn w-100"\n              data-toggle="modal"\n              data-target="#modalStartProgram">\n              <span class="font-weight-bold text-uppercase">\n                <i class="fa fa-angle-double-right" aria-hidden="true"></i>\n                Start your program\n                <i class="fa fa-angle-double-left" aria-hidden="true"></i>\n              </span>\n            </button>\n          </div>\n        </div>\n      </div>\n      <div class="content" ng-transclude></div>\n    </div>'
};

/***/ }),

/***/ "+JvR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FormTextarea = exports.FormTextarea = {
  bindings: {
    customClass: '@',
    errors: '<',
    form: '<',
    name: '@',
    minlength: '@',
    onUpdate: '&',
    pattern: '@',
    placeholder: '@',
    required: '@',
    rows: '@',
    value: '<'
  },

  template: '\n    <textarea class="form-control {{ $ctrl.customClass }}"\n      ng-class="{\n        \'is-valid\': $ctrl.form[$ctrl.name].$touched && $ctrl.form[$ctrl.name].$valid,\n        \'is-invalid\': $ctrl.form[$ctrl.name].$touched && $ctrl.form[$ctrl.name].$invalid,\n      }"\n      id="{{ $ctrl.name }}"\n      name="{{ $ctrl.name }}"\n      pattern="{{ $ctrl.pattern }}"\n      placeholder="{{ $ctrl.placeholder }}"\n      minlength="{{ $ctrl.minlength }}"\n      rows="{{ $ctrl.rows }}"\n      ng-value="$ctrl.value"\n      ng-model="$ctrl.form.data[$ctrl.name]"\n      ng-init="$ctrl.form.data[$ctrl.name] = $ctrl.value"\n      ng-required="{{ $ctrl.required }}"\n      ng-change="$ctrl.onChange()"></textarea>\n    <form-errors\n      field="$ctrl.form[$ctrl.name]"\n      errors="$ctrl.errors"/>',

  controller: function controller() {
    return {
      // For some reason ng-value is not updating ng-model when $ctrl.value
      // resolves. $onChanges is essentially doing this manually.
      $onChanges: function $onChanges() {
        var field = this.form[this.name];

        if (this.value && field && !field.$viewValue) {
          field.$setViewValue(this.value);
        }
      },


      // The $setViewValue within $onChanges will fire the ng-change so only
      // call onUpdate when $ctrl.value has actually changed.
      onChange: function onChange() {
        var key = this.name;
        var value = this.form.data[this.name];
        var field = this.form[this.name];

        if (field.$valid && value !== this.value) {
          this.onUpdate({ key: key, value: value });
        }
      }
    };
  }
};

/***/ }),

/***/ "+VBr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignupFormBilling = undefined;

var _constants = __webpack_require__("qI5z");

var SignupFormBilling = exports.SignupFormBilling = {
  bindings: {
    isDisabled: '<',
    isLoading: '<',
    chargifyData: '<',
    chargifyFields: '<',
    chargifySubscriptionId: '<',
    product: '<',
    text: '<',
    title: '@',
    onCancel: '&',
    onUpdate: '&'
  },

  template: '\n    <form class="voome-form"\n      ng-class="{ \'disabled\': $ctrl.isDisabled }"\n      id="chargifyForm"\n      name="form"\n      action="{{ $ctrl.action }}"\n      method="post"\n      novalidate>\n      <row class="text-danger">IMPORTANT NOTE: THERE WILL BE NO CHARGE MADE TO THIS CARD, IT IS AN AUTHORIZATION FOR ACCESS ONLY</row>\n      <fieldset>\n        <div class="d-flex justify-content-between">\n          <strong>\n            {{ $ctrl.title }}\n          </strong>\n          <i class="logo logo-credit-cards">\n            Visa - Amex - Mastercard\n          </i>\n        </div>\n        <hr class="mt-1">\n        <div class="mb-3">\n          <form-group-row>\n            <form-group-left>\n              <form-label for="cardNumber">\n                Number\n                <span class="text-gray"\n                  ng-if="$ctrl.isDev">\n                  ({{ form.cardNumber.$viewValue.length || 0 }})\n                </span>\n              </form-label>\n            </form-group-left>\n            <form-group-right>\n              <div class="input-group">\n                <div class="input-group-prepend">\n                  <div class="input-group-text">\n                    <i class="fa fa-lock"></i>\n                  </div>\n                </div>\n                <input class="form-control"\n                  ng-class="{\n                    \'is-valid\': $ctrl.chargifyData.cardNumber && form.cardNumber.$valid,\n                    \'is-invalid\': $ctrl.chargifyData.cardNumber && form.cardNumber.$invalid\n                  }"\n                  id="cardNumber"\n                  name="cardNumber"\n                  type="tel"\n                  ng-value="$ctrl.chargifyData.cardNumber"\n                  ng-disabled="$ctrl.isDisabled || $ctrl.isLoading"\n                  ng-model="cardNumber"\n                  ng-change="$ctrl.onUpdate({\n                    key: \'cardNumber\',\n                    value: form.cardNumber.$viewValue\n                  })"\n                  focus-if="!$ctrl.isDisabled"\n                  credit-card-number\n                  required>\n              </div>\n              <form-errors\n                field="form.cardNumber"\n                errors="{\n                  required: \'This is a required field.\',\n                  creditCardNumber: \'Must be a valid credit card number.\',\n                }">\n              </form-errors>\n            </form-group-right>\n          </form-group-row>\n          <form-group-row>\n            <form-group-left>\n              <form-label for="expirationMonth">\n                Expiration Date\n              </form-label>\n            </form-group-left>\n            <form-group-right>\n              <div class="form-row">\n                <div class="col">\n                  <select class="form-control"\n                    ng-class="{\n                      \'is-valid\': $ctrl.chargifyData.expirationMonth && form.expirationMonth.$valid,\n                      \'is-invalid\': $ctrl.chargifyData.expirationMonth && form.expirationMonth.$invalid,\n                    }"\n                    id="expirationMonth"\n                    name="expirationMonth"\n                    ng-disabled="$ctrl.isDisabled || $ctrl.isLoading"\n                    ng-value="$ctrl.chargifyData.expirationMonth || \'\'"\n                    ng-model="expirationMonth"\n                    ng-change="$ctrl.onUpdate({\n                      key: \'expirationMonth\',\n                      value: form.expirationMonth.$viewValue\n                    })"\n                    credit-card-date="{\n                      month: form.expirationMonth,\n                      year: form.expirationYear\n                    }"\n                    required>\n                    <option value="">Month</option>\n                    <option\n                      ng-repeat="option in $ctrl.months track by $index"\n                      value="{{ option }}">\n                      {{ option | padStart:2:0 }}\n                    </option>\n                  </select>\n                </div>\n                <div class="col">\n                  <select class="form-control"\n                    ng-class="{\n                      \'is-valid\': $ctrl.chargifyData.expirationYear && form.expirationYear.$valid,\n                      \'is-invalid\': $ctrl.chargifyData.expirationYear && form.expirationYear.$invalid,\n                    }"\n                    id="expirationYear"\n                    name="expirationYear"\n                    ng-disabled="$ctrl.isDisabled || $ctrl.isLoading"\n                    ng-value="$ctrl.chargifyData.expirationYear || \'\'"\n                    ng-model="expirationYear"\n                    ng-change="$ctrl.onUpdate({\n                      key: \'expirationYear\',\n                      value: form.expirationYear.$viewValue\n                    })"\n                    credit-card-date="{\n                      month: form.expirationMonth,\n                      year: form.expirationYear\n                    }"\n                    required>\n                    <option value="">Year</option>\n                    <option\n                      ng-repeat="option in $ctrl.years track by $index"\n                      value="{{ option }}">\n                      {{ option | padStart:2:0 }}\n                    </option>\n                  </select>\n                </div>\n                <div class="invalid-feedback d-flex px-2"\n                  ng-show="(form.expirationMonth.$touched && form.expirationMonth.$invalid) || (form.expirationYear.$touched && form.expirationYear.$invalid)">\n                  Must be a valid month/year expiration date.\n                </div>\n              </div>\n            </form-group-right>\n          </form-group-row>\n        </div>\n        <hr>\n      </fieldset>\n      <div class="row justify-content-end">\n        <div class="col-md-8">\n          <div class="form-group mb-4"\n            ng-if="!$ctrl.chargifyData.subscriptionId">\n            <div class="custom-control custom-checkbox my-1 mr-sm-2">\n              <input class="custom-control-input"\n                id="termsAndConditions"\n                type="checkbox"\n                name="termsAndConditions"\n                ng-disabled="$ctrl.isDisabled || $ctrl.isLoading"\n                ng-model="$ctrl.termsAndConditions"\n                required>\n              <label\n                class="custom-control-label small"\n                for="termsAndConditions">\n                I have read and agree to the\n                <a href="#"\n                  data-toggle="modal"\n                  data-target="#modalTerms">\n                  terms & conditions.\n                </a>\n              </label>\n            </div>\n            <modal target="modalTerms">\n              <modal-title>Terms & Conditions</modal-title>\n              <modal-body>\n                <terms-conditions></terms-conditions>\n              </modal-body>\n            </modal>\n            <div class="custom-control custom-checkbox my-1 mr-sm-2"\n              ng-if="$ctrl.text.couponTitle && $ctrl.text.couponTermsUri">\n              <input class="custom-control-input"\n                id="termsAndConditionsCoupon"\n                type="checkbox"\n                name="termsAndConditionsCoupon"\n                ng-disabled="$ctrl.isDisabled || $ctrl.isLoading"\n                ng-model="$ctrl.termsAndConditionsCoupon"\n                required>\n              <label\n                class="custom-control-label small"\n                for="termsAndConditionsCoupon">\n                I have read and agree to the\n                <a ng-href="{{ $ctrl.text.couponTermsUri }}" target="_blank">\n                  {{ $ctrl.text.couponTitle }} terms & conditions\n                </a>\n              </label>\n            </div>\n          </div>\n          <input\n            type="hidden"\n            name="{{ name }}"\n            value="{{ $ctrl.chargifyData[key] }}"\n            ng-if="$ctrl.chargifyData[key]"\n            ng-repeat="(key, name) in $ctrl.chargifyFields track by $index">\n          <button-primary\n            ng-type="submit"\n            ng-disabled="$ctrl.isDisabled || $ctrl.isLoading || form.$invalid"\n            ng-click="form.$valid && $ctrl.onSubmit()">\n            <spinner is-loading="$ctrl.isLoading && form.$valid">\n              <span ng-hide="$ctrl.chargifyData.subscriptionId">Submit</span>\n              <span ng-show="$ctrl.chargifyData.subscriptionId">Submit</span>\n            </spinner>\n          </button-primary>\n          <span class="pl-2" ng-hide="$ctrl.chargifySubscriptionId">\n            <button-link\n              ng-disabled="$ctrl.isDisabled || $ctrl.isLoading"\n              ng-click="$ctrl.onCancel()">\n              Cancel\n            </button-link>\n          </span>\n        </div>\n      </div>\n    </form>',

  controller: ["$sce", "$ngRedux", "$scope", function controller($sce, $ngRedux, $scope) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        this.months = _constants.SIGNUP_MONTHS;
        this.years = _constants.SIGNUP_YEARS;
        this.isDev = _constants.SIGNUP_IS_DEV;
      },
      $onChanges: function $onChanges() {
        var endpoint = this.chargifySubscriptionId ? 'subscriptions/' + this.chargifySubscriptionId + '/card_update' : 'signups';

        this.action = $sce.trustAsResourceUrl('https://api.chargify.com/api/v2/' + endpoint);
      },
      onSubmit: function onSubmit() {
        // Disable inputs so only the hidden chargifyFields are submitted.
        this.isDisabled = true;

        // Show spinners, etc.
        this.isLoading = true;

        // Submit the form on the next tick.
        setTimeout(function () {
          return document.getElementById('chargifyForm').submit();
        });
      }
    };
  }]
};

/***/ }),

/***/ "+VK4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Hack = __webpack_require__("fNHm");

Object.defineProperty(exports, 'NutritionHack', {
  enumerable: true,
  get: function get() {
    return _Hack.NutritionHack;
  }
});

var _Hacks = __webpack_require__("R1nc");

Object.defineProperty(exports, 'NutritionHacks', {
  enumerable: true,
  get: function get() {
    return _Hacks.NutritionHacks;
  }
});

var _MealPlans = __webpack_require__("/Mzg");

Object.defineProperty(exports, 'NutritionMealPlans', {
  enumerable: true,
  get: function get() {
    return _MealPlans.NutritionMealPlans;
  }
});

var _MealPlan = __webpack_require__("OMXv");

Object.defineProperty(exports, 'NutritionMealPlan', {
  enumerable: true,
  get: function get() {
    return _MealPlan.NutritionMealPlan;
  }
});

var _Nutrition = __webpack_require__("bLnr");

Object.defineProperty(exports, 'Nutrition', {
  enumerable: true,
  get: function get() {
    return _Nutrition.Nutrition;
  }
});

var _Recipe = __webpack_require__("eDzR");

Object.defineProperty(exports, 'NutritionRecipe', {
  enumerable: true,
  get: function get() {
    return _Recipe.NutritionRecipe;
  }
});

var _Recipes = __webpack_require__("lBa9");

Object.defineProperty(exports, 'NutritionRecipes', {
  enumerable: true,
  get: function get() {
    return _Recipes.NutritionRecipes;
  }
});

/***/ }),

/***/ "+qIz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterMain = exports.FooterDashboard = undefined;

var _FooterDashboard = __webpack_require__("nnw8");

Object.defineProperty(exports, 'FooterDashboard', {
  enumerable: true,
  get: function get() {
    return _FooterDashboard.FooterDashboard;
  }
});

var _FooterMain = __webpack_require__("tmhC");

Object.defineProperty(exports, 'FooterMain', {
  enumerable: true,
  get: function get() {
    return _FooterMain.FooterMain;
  }
});

__webpack_require__("R5Cs");

/***/ }),

/***/ "/FTs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.httpClient = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _settings = __webpack_require__("Ll2K");

var _humps = __webpack_require__("qJdz");

var _memberStorage = __webpack_require__("xopG");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleRequest = function handleRequest(config) {
  var data = (0, _humps.decamelizeKeys)(config.data);
  var params = (0, _humps.decamelizeKeys)(config.params);
  return _extends({}, config, { data: data, params: params });
};

var handleResponse = function handleResponse(response) {
  var data = response.config.skipCamelize ? response.data : (0, _humps.camelizeKeys)(response.data);
  var pagination = getPagination(response);

  return _extends({}, response, { data: data, pagination: pagination });
};

var handleReject = function handleReject(error) {
  // We dont have access to the store here so manually redirect.
  if (/40(1|3)/.test(error.response.status)) {
    _memberStorage.memberStorage.remove();

    setTimeout(function () {
      window.location.pathname !== '/' ? window.location.assign('/') : error.response.config.url.includes('login') // Dont reload on failed login
      ? undefined : window.location.reload(true);
    });
  }

  return Promise.reject(error);
};

var getPagination = function getPagination(_ref) {
  var config = _ref.config,
      _ref$headers = _ref.headers,
      headers = _ref$headers === undefined ? {} : _ref$headers;

  var xPagination = headers['x-pagination'];

  if (xPagination) {
    var _ref2 = config.params || 1,
        page = _ref2.page;

    var pagination = (0, _humps.camelizeKeys)(JSON.parse(xPagination));

    return _extends({}, pagination, {
      page: parseInt(page, 10),
      perPage: Math.ceil(pagination.total / pagination.totalPages)
    });
  }
};

var httpClient = exports.httpClient = _axios2.default.create({
  baseURL: _settings.hosts.api,
  withCredentials: true
});

httpClient.interceptors.request.use(handleRequest);
httpClient.interceptors.response.use(handleResponse, handleReject);

/***/ }),

/***/ "/H0G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScrollTopOnChange = __webpack_require__("Ok8I");

Object.defineProperty(exports, 'ScrollTopOnChange', {
  enumerable: true,
  get: function get() {
    return _ScrollTopOnChange.ScrollTopOnChange;
  }
});

/***/ }),

/***/ "/Jcz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var RatingStars = exports.RatingStars = {
  bindings: {
    size: '@',
    rating: '<',
    isEnabled: '<',
    onClick: '&'
  },

  template: '\n    <div class="rating-stars"\n      ng-class="{ \'rating-stars--hover\': $ctrl.isEnabled }">\n      <i class="fa fa-star"\n        ng-repeat="i in [5,4,3,2,1] track by $index"\n        ng-click="$ctrl.onClick({ value: i })"\n        ng-class="{\n          \'fa-lg\': $ctrl.size === \'md\',\n          \'fa-3x\': $ctrl.size === \'lg\',\n          \'active\': i <= $ctrl.rating,\n        }">\n      </i>\n    </div>'
};

/***/ }),

/***/ "/MvA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalUpgrade = exports.ModalPopup = exports.Modal = undefined;

var _Modal = __webpack_require__("Xpbu");

Object.defineProperty(exports, 'Modal', {
  enumerable: true,
  get: function get() {
    return _Modal.Modal;
  }
});

var _Popup = __webpack_require__("rixY");

Object.defineProperty(exports, 'ModalPopup', {
  enumerable: true,
  get: function get() {
    return _Popup.ModalPopup;
  }
});

var _Upgrade = __webpack_require__("UwM0");

Object.defineProperty(exports, 'ModalUpgrade', {
  enumerable: true,
  get: function get() {
    return _Upgrade.ModalUpgrade;
  }
});

__webpack_require__("FL69");

/***/ }),

/***/ "/Mzg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NutritionMealPlans = undefined;

var _reduxUiRouter = __webpack_require__("Zb/7");

var _member = __webpack_require__("1OIp");

var _mealPlan = __webpack_require__("KLwp");

var NutritionMealPlans = exports.NutritionMealPlans = {
  template: '\n    <div class="nutrition-recipes">\n      <ui-view>\n        <div class="container pt-4">\n          <div class="row">\n            <div class="col-md-3">\n              <meal-plan-aside\n                active="$ctrl.type"\n                subscription-id="$ctrl.subscriptionId"\n                total-by-voome="$ctrl.byVoome.total"\n                total-mine="$ctrl.mine.total"\n                on-click="$ctrl.onStateGo(\'nutrition.mealPlans\', { type: type, page: undefined })">\n              </meal-plan-aside>\n            </div>\n            <div class="col-md-9">\n              <h3 class="text-center"\n                ng-show="$ctrl.isLoading">\n                <spinner is-loading="$ctrl.isLoading">\n                  Loading Meal Plans\n                </spinner>\n              </h3>\n              <div class="row mb-4">\n                <div ng-repeat="id in $ctrl.pagination.result track by $index"\n                  class="col-md-6 col-lg-4 mb-4 pointer"\n                  ng-click="$ctrl.onStateGo(\'nutrition.mealPlans.detail\', { mealPlanId: id, type: undefined, page: undefined })">\n                  <meal-plan-card\n                    count="$ctrl.mealPlans[id].recipeCount"\n                    date="$ctrl.mealPlans[id].updatedAt"\n                    image="$ctrl.mealPlans[id].heroImage.medium"\n                    title="$ctrl.mealPlans[id].title"\n                    by-voome="$ctrl.type === \'byVoome\'">\n                  </meal-plan-card>\n                </div>\n                <div class="col-sm-8 mt-5 mx-auto"\n                  ng-show="!$ctrl.isLoading && !$ctrl.pagination.result.length">\n                  <div class="card rounded text-center py-3 px-4 mb-5">\n                    <i class="fa fa-2x icon icon-recipes"></i>\n                    <h4 class="text-gray">\n                      You have created no meal plans.\n                    </h4>\n                    <p class="mb-1">\n                      Create a new plan or browse the Ready-made Plans.\n                    </p>\n                  </div>\n                </div>\n                <div class="w-100 px-3">\n                  <pagination-row\n                    on-update-param="$ctrl.onStateGo(\'nutrition.mealPlans\', { type: $ctrl.type, page: value })"\n                    pagination="$ctrl.pagination">\n                  </pagination-row>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </ui-view>\n    </div>',

  controller: ["$ngRedux", "$anchorScroll", function controller($ngRedux, $anchorScroll) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        var isEdit = /edit|detail/.test(this.name);

        // Fetch Coaching Zone meal plans
        if (!this.byVoome.total && !isEdit) {
          this.fetchMealPlansByVoome(this.subscriptionId, this.page);
        }

        // Fetch Coaching Zone meal plans
        if (!this.mine.total && !isEdit) {
          this.fetchMealPlansMine(this.subscriptionId, this.page);
        }

        // Jump to the top of the page.
        $anchorScroll();
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();
      },
      onStateGo: function onStateGo(key, params) {
        this.stateGo(key, params);
      },
      mapState: function mapState(_ref) {
        var mealPlan = _ref.mealPlan,
            member = _ref.member,
            router = _ref.router;

        var type = router.currentParams.type || 'byVoome';
        var page = router.currentParams.page || 1;
        var name = router.currentState.name;


        var byVoome = (0, _mealPlan.selectPaginationByType)(mealPlan, 'byVoome', type === 'byVoome' ? page : 1);

        var mine = (0, _mealPlan.selectPaginationByType)(mealPlan, 'mine', type === 'mine' ? page : 1);

        return {
          byVoome: byVoome,
          mine: mine,
          page: page,
          type: type,
          name: name,
          mealPlans: (0, _mealPlan.selectMealPlans)(mealPlan),
          pagination: type === 'byVoome' ? byVoome : mine,
          hasAccess: (0, _member.selectHasNutritionSubscription)(member),
          isLoading: mealPlan.isLoading,
          level: (0, _member.selectMemberLevel)(member),
          subscriptionId: (0, _member.selectSubscription)(member).id
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          fetchMealPlansMine: _mealPlan.fetchMealPlansMine,
          fetchMealPlansByVoome: _mealPlan.fetchMealPlansByVoome,
          stateGo: _reduxUiRouter.stateGo
        };
      }
    };
  }]
};

/***/ }),

/***/ "/Xzk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CurrentDay = __webpack_require__("A7fB");

Object.defineProperty(exports, 'CurrentDay', {
  enumerable: true,
  get: function get() {
    return _CurrentDay.CurrentDay;
  }
});

/***/ }),

/***/ "/kGf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SignupSelectorWeekly = exports.SignupSelectorWeekly = {
  bindings: {
    isActive: '<',
    isDisabled: '<',
    product: '<',
    products: '<',
    text: '<',
    onChange: '&',
    onSelectBundle: '&'
  },

  template: '\n    <div class="signup-weekly dropdown mb-4">\n      <div class="px-3 px-md-5">\n        <strong>Your Subscription</strong>\n        <hr class="mt-1">\n      </div>\n      <div class="px-3 px-md-5">\n        <div ng-repeat="product in $ctrl.products track by $index"\n          ng-show="$ctrl.product.type === \'bundle\' || $ctrl.product.id === product.id">\n          <signup-tile-weekly\n            color="$ctrl.text[product.name].color"\n            icon="$ctrl.text[product.name].icon"\n            is-bundle="$ctrl.product.type === \'bundle\'"\n            is-coupon="$ctrl.product.coupon !== undefined"\n            price-in-cents="product.priceInCents"\n            title="product.name"\n            on-click="$ctrl.onChange({ product: product })">\n          </signup-tile-weekly>\n          <hr class="mt-3">\n        </div>\n        <table class="d-flex justify-content-end mb-3 w-100 signup-total">\n          <tr ng-show="$ctrl.product.discountInCents">\n            <td class="pr-3 pb-1">\n              <strong>Was</strong>\n            </td>\n            <td></td>\n            <td class="pl-1 pb-1">\n              <strong>\n                {{ $ctrl.product.priceInCents / 100 | currency }}/wk\n              </strong>\n            </td>\n          </tr>\n          <tr class="text-orange"\n            ng-show="$ctrl.product.discountInCents">\n            <td class="pr-3 pb-2">\n              <strong>Bundle Saving 25%</strong>\n            </td>\n            <td class="pb-2">-</td>\n            <td class="pl-1 pb-2">\n              <strong>\n                {{ $ctrl.product.discountInCents / 100 | currency }}\n              </strong>\n            </td>\n          </tr>\n          <tr>\n            <td class="pr-3">\n              <h5 class="text-black m-0">Weekly Cost</h5>\n            </td>\n            <td></td>\n            <td class="pl-1">\n              <h2 ng-class="{\n                \'text-orange\': $ctrl.product.type === \'bundle\',\n                \'text-black\': $ctrl.product.type !== \'bundle\'\n              }">\n                <signup-price value="$ctrl.product.totalInCents">\n                </signup-price>\n              </h2>\n            </td>\n          </tr>\n          <tr ng-show="$ctrl.text[$ctrl.product.name].bundle && $ctrl.isActive">\n            <td class="pt-4" colspan="3">\n              <a href="#" ng-click="$ctrl.onSelectBundle()">\n                {{ $ctrl.text[$ctrl.product.name].bundle }}\n              </a>\n            </td>\n          </tr>\n        </table>\n      </div>\n    </div>'
};

/***/ }),

/***/ "/m0/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mround = exports.convertWeight = exports.calculateBmi = exports.calculateMet = exports.calculateMetFor = exports.calculateAge = exports.calculateDaysElapsed = undefined;

var _toNumber2 = __webpack_require__("kxzG");

var _toNumber3 = _interopRequireDefault(_toNumber2);

var _each2 = __webpack_require__("9uKM");

var _each3 = _interopRequireDefault(_each2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MET_DEFAULTS = {
  F: {
    age: 35,
    weight: 75,
    height: 165
  },
  M: {
    age: 35,
    weight: 85,
    height: 175
  }
};

var WEIGHT_ROUND_MULTIPLES = [{ threshold: 30, multiple: 5 }, { threshold: 10, multiple: 2.5 }, { threshold: 0, multiple: 0.5 }];

var MILLISECONDS_IN_DAY = 1000 * 60 * 60 * 24;

var calculateDaysElapsed = exports.calculateDaysElapsed = function calculateDaysElapsed(startedAt) {
  if (startedAt) {
    var today = new Date();
    today.setHours(0, 0, 0, 0);

    var startDay = new Date(startedAt);
    startDay.setHours(0, 0, 0, 0);

    return Math.ceil((today - startDay) / MILLISECONDS_IN_DAY);
  }

  return 0;
};

var calculateAge = exports.calculateAge = function calculateAge(birthday) {
  var today = new Date();
  var birthDate = new Date(birthday);
  var monthDiff = today.getMonth() - birthDate.getMonth();

  var age = today.getFullYear() - birthDate.getFullYear();

  if (monthDiff < 0 || monthDiff === 0 && today.getDate() < birthDate.getDate()) {
    age = age - 1;
  }

  return age;
};

var calculateMetFor = exports.calculateMetFor = function calculateMetFor(member, met, totalTime) {
  var gender = member.profile.gender || 'F';
  var age = calculateAge(member.profile.birthday);
  var duration = totalTime.hours * 60 * 60 + totalTime.minutes * 60 + totalTime.seconds;

  return calculateMet(gender, {
    weight: member.startWeightInKg,
    height: member.profile.height,
    age: age,
    met: met,
    duration: duration
  });
};

var calculateMet = exports.calculateMet = function calculateMet(gender, params) {
  params = _extends({}, MET_DEFAULTS[gender], params);

  if (params.duration) {
    var rmr = void 0;

    if (gender === 'M') {
      rmr = 88.362 + 13.397 * (0, _toNumber3.default)(params.weight) + 4.799 * (0, _toNumber3.default)(params.height) - 5.677 * (0, _toNumber3.default)(params.age);
    } else {
      rmr = 447.593 + 9.247 * (0, _toNumber3.default)(params.weight) + 3.098 * (0, _toNumber3.default)(params.height) - 4.33 * (0, _toNumber3.default)(params.age);
    }

    var caloriesBurnt = rmr / 1440 * (0, _toNumber3.default)(params.met) * (0, _toNumber3.default)(params.duration / 60);

    return Math.max(0, caloriesBurnt);
  } else {
    return 0;
  }
};

var calculateBmi = exports.calculateBmi = function calculateBmi() {
  var weight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var metres = height / 100;
  var bmi = weight / (metres * metres);
  return mround(weight / (metres * metres), 0.1);
};

var convertWeight = exports.convertWeight = function convertWeight(weight, gender) {
  var round = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (gender === 'F') {
    return weight;
  }

  // Gender bias
  var genderBias = 1.25;
  weight = weight * genderBias;

  // Rounding
  if (round) {
    (0, _each3.default)(WEIGHT_ROUND_MULTIPLES, function (data) {
      if (weight > data.threshold) {
        weight = mround(weight, data.multiple);
        return false;
      }
    });
  }

  return weight;
};

var mround = exports.mround = function mround(number, multiple) {
  var multiplier = 1 / multiple;
  return Math.round(number * multiplier) / multiplier;
};

/***/ }),

/***/ "/pf/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Containers = undefined;

var _App = __webpack_require__("61pe");

var _CreditCardUpdate = __webpack_require__("eEKx");

var _Dashboard = __webpack_require__("AVJU");

var _Login = __webpack_require__("5qOZ");

var _Logout = __webpack_require__("WwQF");

var _MealPlan = __webpack_require__("zGDm");

var _MealPlanEdit = __webpack_require__("qEui");

var _MealPlanBasic = __webpack_require__("IIqr");

var _Profile = __webpack_require__("15A6");

var _Recipe = __webpack_require__("pfqY");

var _ResetPassword = __webpack_require__("GCmo");

var _Reviews = __webpack_require__("k5Y8");

var _ShoppingList = __webpack_require__("qe1y");

var _Signup = __webpack_require__("Vj7r");

var _Upgrade = __webpack_require__("6Q/l");

var _WelcomeSteps = __webpack_require__("TjzY");

var _Workout = __webpack_require__("lN3W");

var _WorkoutPlayer = __webpack_require__("Nz84");

var _Favourites = __webpack_require__("cQwx");

var _Nutrition = __webpack_require__("+VK4");

var _Program = __webpack_require__("d6NY");

var _Workouts = __webpack_require__("rPD4");

var Containers = exports.Containers = angular.module('App.Containers', []).component('app', _App.App).component('creditCardUpdate', _CreditCardUpdate.CreditCardUpdate).component('dashboard', _Dashboard.Dashboard).component('favourites', _Favourites.Favourites).component('favouritesRecipes', _Favourites.FavouritesRecipes).component('favouritesVideos', _Favourites.FavouritesVideos).component('favouritesWorkouts', _Favourites.FavouritesWorkouts).component('login', _Login.Login).component('logout', _Logout.Logout).component('mealPlan', _MealPlan.MealPlan).component('mealPlanEdit', _MealPlanEdit.MealPlanEdit).component('mealPlanBasic', _MealPlanBasic.MealPlanBasic).component('nutrition', _Nutrition.Nutrition).component('nutritionHack', _Nutrition.NutritionHack).component('nutritionHacks', _Nutrition.NutritionHacks).component('nutritionMealPlans', _Nutrition.NutritionMealPlans).component('nutritionMealPlan', _Nutrition.NutritionMealPlan).component('nutritionRecipe', _Nutrition.NutritionRecipe).component('nutritionRecipes', _Nutrition.NutritionRecipes).component('profile', _Profile.Profile).component('program', _Program.Program).component('programGraduation', _Program.ProgramGraduation).component('programIntro', _Program.ProgramIntro).component('programMealPlan', _Program.ProgramMealPlan).component('programNav', _Program.ProgramNav).component('programRecipe', _Program.ProgramRecipe).component('programRedirect', _Program.ProgramRedirect).component('programWeek', _Program.ProgramWeek).component('programWorkout', _Program.ProgramWorkout).component('recipe', _Recipe.Recipe).component('resetPassword', _ResetPassword.ResetPassword).component('reviews', _Reviews.Reviews).component('shoppingList', _ShoppingList.ShoppingList).component('signup', _Signup.Signup).component('upgrade', _Upgrade.Upgrade).component('welcomeSteps', _WelcomeSteps.WelcomeSteps).component('workout', _Workout.Workout).component('workoutPlayer', _WorkoutPlayer.WorkoutPlayer).component('workouts', _Workouts.Workouts).component('workoutsHack', _Workouts.workoutsHack).component('workoutsHacks', _Workouts.workoutsHacks).component('workoutsExpress', _Workouts.WorkoutsExpress).component('workoutsVideo', _Workouts.WorkoutsVideo).component('workoutsVideos', _Workouts.WorkoutsVideos).component('workoutsDetail', _Workouts.WorkoutsDetail).name;

/***/ }),

/***/ "/sbO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SignupTileProgram = exports.SignupTileProgram = {
  bindings: {
    product: '<'
  },

  template: '\n    <div class="d-flex align-items-center"\n      ng-class="\'theme-\' + $ctrl.product.name | kebabCase">\n      <div class="theme-program-overview d-none d-sm-block"></div>\n      <div class="signup-tile-content">\n        <span class="h4 d-none d-sm-block">{{ $ctrl.product.name }}</span>\n        <strong class="d-sm-none">{{ $ctrl.product.name }}</strong>\n        <span class="d-block">\n          by {{ $ctrl.product.author.screenName }}\n        </span>\n      </div>\n      <div class="ml-auto">\n        <div class="cost" ng-hide="$ctrl.product.discountInCents > 0">\n          {{ $ctrl.product.priceInCents / 100 | currency }}\n        </div>\n        <div class="cost" ng-show="$ctrl.product.discountInCents > 0">\n          {{ $ctrl.product.totalInCents / 100 | currency }}\n          <del class="text-warning">\n            {{ $ctrl.product.priceInCents / 100 | currency }}\n          </del>\n        </div>\n      </div>\n    </div>'
};

/***/ }),

/***/ "/uzO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SignupIcon = exports.SignupIcon = {
  transclude: true,

  bindings: {
    color: '<'
  },

  template: '\n    <div class="signup-icon">\n      <div class="d-flex justify-content-center align-items-center rounded-circle rounded-circle--50 bg-{{$ctrl.color}}">\n        <span class="h2 font-weight-normal text-white m-0" ng-transclude></span>\n      </div>\n    </div>'
};

/***/ }),

/***/ "0120":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/termsConditions.b06ca4b39e8a21cd63d6fb5bce25bcfc.html";

/***/ }),

/***/ "0AY2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WorkoutPlayerVideo = exports.WorkoutPlayerTimer = exports.WorkoutPlayerSleeper = exports.WorkoutPlayerProgressBar = exports.WorkoutPlayerInstructions = exports.WorkoutPlayerHeader = exports.WorkoutPlayerFinishModal = exports.WorkoutPlayerFinished = exports.WorkoutPlayerCountdown = exports.WorkoutPlayerControls = exports.WorkoutPlayerContextPanel = exports.WorkoutPlayerContextItem = undefined;

var _WorkoutPlayerContextItem = __webpack_require__("ggN2");

Object.defineProperty(exports, 'WorkoutPlayerContextItem', {
  enumerable: true,
  get: function get() {
    return _WorkoutPlayerContextItem.WorkoutPlayerContextItem;
  }
});

var _WorkoutPlayerContextPanel = __webpack_require__("1Kic");

Object.defineProperty(exports, 'WorkoutPlayerContextPanel', {
  enumerable: true,
  get: function get() {
    return _WorkoutPlayerContextPanel.WorkoutPlayerContextPanel;
  }
});

var _WorkoutPlayerControls = __webpack_require__("6tnr");

Object.defineProperty(exports, 'WorkoutPlayerControls', {
  enumerable: true,
  get: function get() {
    return _WorkoutPlayerControls.WorkoutPlayerControls;
  }
});

var _WorkoutPlayerCountdown = __webpack_require__("vsDG");

Object.defineProperty(exports, 'WorkoutPlayerCountdown', {
  enumerable: true,
  get: function get() {
    return _WorkoutPlayerCountdown.WorkoutPlayerCountdown;
  }
});

var _WorkoutPlayerFinished = __webpack_require__("EaOo");

Object.defineProperty(exports, 'WorkoutPlayerFinished', {
  enumerable: true,
  get: function get() {
    return _WorkoutPlayerFinished.WorkoutPlayerFinished;
  }
});

var _WorkoutPlayerFinishModal = __webpack_require__("E2e5");

Object.defineProperty(exports, 'WorkoutPlayerFinishModal', {
  enumerable: true,
  get: function get() {
    return _WorkoutPlayerFinishModal.WorkoutPlayerFinishModal;
  }
});

var _WorkoutPlayerHeader = __webpack_require__("IdCd");

Object.defineProperty(exports, 'WorkoutPlayerHeader', {
  enumerable: true,
  get: function get() {
    return _WorkoutPlayerHeader.WorkoutPlayerHeader;
  }
});

var _WorkoutPlayerInstructions = __webpack_require__("L/ed");

Object.defineProperty(exports, 'WorkoutPlayerInstructions', {
  enumerable: true,
  get: function get() {
    return _WorkoutPlayerInstructions.WorkoutPlayerInstructions;
  }
});

var _WorkoutPlayerProgressBar = __webpack_require__("HYmQ");

Object.defineProperty(exports, 'WorkoutPlayerProgressBar', {
  enumerable: true,
  get: function get() {
    return _WorkoutPlayerProgressBar.WorkoutPlayerProgressBar;
  }
});

var _WorkoutPlayerSleeper = __webpack_require__("oqTz");

Object.defineProperty(exports, 'WorkoutPlayerSleeper', {
  enumerable: true,
  get: function get() {
    return _WorkoutPlayerSleeper.WorkoutPlayerSleeper;
  }
});

var _WorkoutPlayerTimer = __webpack_require__("Mts3");

Object.defineProperty(exports, 'WorkoutPlayerTimer', {
  enumerable: true,
  get: function get() {
    return _WorkoutPlayerTimer.WorkoutPlayerTimer;
  }
});

var _WorkoutPlayerVideo = __webpack_require__("fJ9R");

Object.defineProperty(exports, 'WorkoutPlayerVideo', {
  enumerable: true,
  get: function get() {
    return _WorkoutPlayerVideo.WorkoutPlayerVideo;
  }
});

__webpack_require__("NDF/");

/***/ }),

/***/ "0Dnv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decorateWorkoutSteps = exports.decorateWorkout = undefined;

var _some2 = __webpack_require__("mGzp");

var _some3 = _interopRequireDefault(_some2);

var _range2 = __webpack_require__("tVBY");

var _range3 = _interopRequireDefault(_range2);

var _map2 = __webpack_require__("2247");

var _map3 = _interopRequireDefault(_map2);

var _each2 = __webpack_require__("9uKM");

var _each3 = _interopRequireDefault(_each2);

var _camelCase2 = __webpack_require__("NRb0");

var _camelCase3 = _interopRequireDefault(_camelCase2);

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__("0xDb");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var displayAttrs = ['weight', 'level', 'inclineNumber', 'speed', 'distance', 'alternate', 'eachSide'];

function buildSteps(items) {
  var steps = [];

  (0, _each3.default)(items, function (item) {
    if (item.items) {
      steps.push.apply(steps, buildSteps(item.items));
    } else {
      steps.push(item);
    }
  });

  return steps;
}

function duplicateReps(items) {
  var repsCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var newItems = [];
  var length = items.length;

  (0, _each3.default)(items, function (item, i) {
    item = _extends({}, item);

    (0, _each3.default)((0, _range3.default)(0, repsCount), function (j) {
      newItems[i + j * length] = _extends({}, item, {
        duplicate: j > 0,
        roundNumber: j + 1,
        roundCount: repsCount
      });
    });

    if (item.items) {
      item.items = duplicateReps(item.items, item.repsCount);
    }

    newItems[i] = item;
  });

  return newItems;
}

function duplicateSets(items) {
  var newItems = [];

  if (items) {
    var _loop = function _loop() {
      var item = _extends({}, items[index]);

      if (item.items) {
        item.items = duplicateSets(item.items);
      }

      (0, _each3.default)((0, _range3.default)(0, item.setsCount), function (i) {
        if (i > 0) {
          var dup = _extends({}, item, { setNumber: i + 1 });
          newItems.splice(index + i, 0, dup);
        } else {
          item.setNumber = 1;
          newItems[index] = item;
        }
      });

      newItems[index] = item;
    };

    for (var index = items.length - 1; index >= 0; index--) {
      _loop();
    }
  }

  return newItems;
}

function setStepDisplayAttrs(step) {
  if (!step) {
    return;
  }

  step = _extends({}, step);

  // Normalise attributes
  step.speed = step.speedKms || step.speedMetric;
  step.distance = step.distanceKms || step.distanceMetric;

  // // Weight conversion
  // var weight_captions = [];
  // if (step.weight_base) {
  //   weight_captions.push($filter('convertWeight')(step.weight_base, step.weight_unit, gender));
  // }
  // if (step.weight_range) {
  //   weight_captions.push($filter('convertWeight')(step.weight_base + step.weight_range, step.weight_unit, gender));
  // }
  // if (weight_captions.length > 0) {
  //   step.weight = [weight_captions.join('-'), step.weight_unit].join(' ');
  // }

  var attrs = [];
  var timeAttr = step.repsCount && step.repsCount > 0 ? 'reps' : 'time';

  for (var i in displayAttrs) {
    var attr = displayAttrs[i];
    var val = step[attr];

    var length = void 0;

    if (val && parseInt(val) !== 0) {
      length = attrs.unshift(attr);
    }

    if (length === 2) {
      break;
    }
  }

  attrs.unshift(timeAttr);
  step.displayAttributes = attrs;

  return step;
}

function setStepFirstInGroup(step, prevStep) {
  step = _extends({}, step);

  if (!prevStep || prevStep.group.name !== step.group.name) {
    step.firstInGroup = true;
  }

  return step;
}

function setTimeFormats(obj) {
  // TODO: API is returning different responses, check to see if we can get them
  // all the same.
  if (obj.hoursMinutesSeconds && typeof obj.totalTime === 'number') {
    var _obj$hoursMinutesSeco = _slicedToArray(obj.hoursMinutesSeconds, 3),
        hours = _obj$hoursMinutesSeco[0],
        minutes = _obj$hoursMinutesSeco[1],
        seconds = _obj$hoursMinutesSeco[2];

    obj.totalTime = { hours: hours, minutes: minutes, seconds: seconds };
  }

  obj.totalTimeSet = (0, _some3.default)(obj.totalTime, function (time) {
    return time > 0;
  });

  if (obj.totalTimeSet) {
    obj.totalTimeDigital = (0, _utils.format)(obj.totalTime, 'digital');
    obj.totalTimeMinutes = (0, _utils.format)(obj.totalTime, 'minutes');
    obj.totalTimeVerbose = (0, _utils.format)(obj.totalTime, 'verbose');
  }
}

function setNoteForItem(item) {
  var parts = [];

  if (item.eachSide) {
    parts.push('Each Side');
  }

  if (item.alternate) {
    parts.push('Alternate L/R');
  }

  if (item.amrap) {
    parts.push('AMRAP');
  }

  item.formattedNote = parts.join(', ');
}

function setMetaForItem(item) {
  if (item.meta) {
    (0, _each3.default)(item.meta, function (meta) {
      var key = (0, _camelCase3.default)(meta.name + '_' + meta.type);
      item[key] = meta.display;
    });
  }
}

function decorateWorkoutItems(items) {
  (0, _each3.default)(items, function (item) {
    setNoteForItem(item);
    setMetaForItem(item);
    setTimeFormats(item);

    if (item.items) {
      decorateWorkoutItems(item.items);
    }
  });
}

function decorateWorkoutPlayerItems(container, exercises, group) {
  var prevRest = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 5;

  (0, _each3.default)(container.items, function (item) {
    if (item.items) {
      if (item.name === 'Transition') {
        prevRest = item.totalTimeInSeconds;
      }

      decorateWorkoutPlayerItems(item, exercises, group || item, prevRest);
    } else {
      item.group = group;
      item.parentItem = container;
      item.exercise = exercises[item.exerciseId];

      var nextRest = item.restSeconds;
      item.restSeconds = prevRest;
      prevRest = nextRest;
    }
  });
}

function decorateWorkoutPlayerSteps(steps) {
  var prevStep = void 0;

  return (0, _map3.default)(steps, function (step) {
    step = setStepDisplayAttrs(step);
    step = setStepFirstInGroup(step, prevStep);

    prevStep = step;

    return step;
  });
}

var decorateWorkout = exports.decorateWorkout = function decorateWorkout(workout) {
  if (!workout) {
    return {};
  }

  setTimeFormats(workout);
  decorateWorkoutItems(workout.items);

  return _extends({}, workout);
};

var decorateWorkoutSteps = exports.decorateWorkoutSteps = function decorateWorkoutSteps(workout, exercises) {
  if (!workout || !exercises) {
    return [];
  }

  // Decorate the items in the workout
  decorateWorkoutItems(workout.items);
  decorateWorkoutPlayerItems(workout, exercises);

  // Start manipulating the items
  var items = workout.items;

  items = duplicateReps(items);
  items = duplicateSets(items);

  // Flatten the items into steps
  return decorateWorkoutPlayerSteps(buildSteps(items));
};

/***/ }),

/***/ "0KaM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0TMH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SearchFilterBadge = exports.SearchFilterBadge = {
  bindings: {
    name: '<',
    type: '@'
  },

  template: '\n    <div class="search-filter-badge badge badge-pill pointer pl-4 mb-1"\n      ng-class="{\n        \'theme-bg theme-color-light\': !$ctrl.type,\n        \'border border-blue-cz blue-cz pr-2\': $ctrl.type === \'clear\'\n      }">\n      <i class="fa fa-times-circle"></i>\n      {{ $ctrl.name }}\n    </div>'
};

/***/ }),

/***/ "0Uha":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ProfileFieldsPassword = exports.ProfileFieldsPassword = {
  bindings: {
    form: '<',
    isUpdate: '<',
    hasError: '<',
    message: '<'
  },

  template: '\n    <alert\n      type="{{ $ctrl.hasError ? \'danger\' : \'success\' }}"\n      ng-show="$ctrl.message">\n      {{ $ctrl.message }}\n    </alert>\n    <form-group-row ng-if="$ctrl.isUpdate">\n      <form-group-left>\n        <form-label for="currentPassword">\n          Current Password\n        </form-label>\n      </form-group-left>\n      <form-group-right>\n        <form-input\n          form="$ctrl.form"\n          type="password"\n          name="currentPassword"\n          value="$ctrl.form.data.currentPassword"\n          required="true"\n          errors="{ required: \'This is a required field.\' }"/>\n      </form-group-right>\n    </form-group-row>\n    <form-group-row>\n      <form-group-left>\n        <form-label for="password">\n          <span ng-show="$ctrl.isUpdate">New</span> Password\n        </form-label>\n      </form-group-left>\n      <form-group-right>\n        <form-input\n          form="$ctrl.form"\n          type="password"\n          name="password"\n          value="$ctrl.form.data.password"\n          required="true"\n          minlength="6"\n          errors="{\n            required: \'This is a required field.\',\n            minlength: \'Must be at least 6 characters.\',\n          }"/>\n      </form-group-right>\n    </form-group-row>\n    <form-group-row>\n      <form-group-left>\n        <form-label for="passwordComfirmation">\n          Confirm Password\n        </form-label>\n      </form-group-left>\n      <form-group-right>\n        <input class="form-control"\n          ng-class="{\n            \'is-valid\': $ctrl.form.passwordComfirmation.$touched && $ctrl.form.passwordComfirmation.$valid,\n            \'is-invalid\': $ctrl.form.passwordComfirmation.$touched && $ctrl.form.passwordComfirmation.$invalid\n          }"\n          id="password-confirmation"\n          type="password"\n          name="passwordComfirmation"\n          match="$ctrl.form.password"\n          ng-model="$ctrl.form.data.passwordConfirmation"\n          ng-required="true">\n        <form-errors field="$ctrl.form.passwordComfirmation" errors="{\n          required: \'This is a required field.\',\n          match: \'Passwords must match.\',\n        }"/>\n      </form-group-right>\n    </form-group-row>'
};

/***/ }),

/***/ "0Yy9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decorateProduct = undefined;

var _map2 = __webpack_require__("2247");

var _map3 = _interopRequireDefault(_map2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__("0xDb");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var decorateProduct = exports.decorateProduct = function decorateProduct(product, startedAt) {
  var daysElapsed = (0, _utils.calculateDaysElapsed)(startedAt);
  var currentWeek = Math.floor(daysElapsed / 7) + 1;
  var currentDay = daysElapsed % 7 + 1;
  var percentElapsed = Math.min(Math.max(daysElapsed / (product.weeks.length * 7) * 100, 0), 100);
  var isGraduated = percentElapsed === 100;
  var weeks = (0, _map3.default)(product.weeks, function (week, index) {
    week.weekNumber = index + 1;
    return week;
  });

  return _extends({}, product, {
    weeks: weeks,
    startedAt: startedAt,
    currentWeek: currentWeek,
    currentDay: currentDay,
    daysElapsed: daysElapsed,
    isGraduated: isGraduated,
    percentElapsed: percentElapsed
  });
};

/***/ }),

/***/ "0qr5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Spinner = __webpack_require__("YtHA");

Object.defineProperty(exports, 'Spinner', {
  enumerable: true,
  get: function get() {
    return _Spinner.Spinner;
  }
});

/***/ }),

/***/ "0uvG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BoxCorner = exports.BoxArrowRow = undefined;

var _BoxArrowRow = __webpack_require__("OSxN");

Object.defineProperty(exports, 'BoxArrowRow', {
  enumerable: true,
  get: function get() {
    return _BoxArrowRow.BoxArrowRow;
  }
});

var _BoxCorner = __webpack_require__("LSoI");

Object.defineProperty(exports, 'BoxCorner', {
  enumerable: true,
  get: function get() {
    return _BoxCorner.BoxCorner;
  }
});

__webpack_require__("620k");

/***/ }),

/***/ "0xDb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _anchorStorage = __webpack_require__("MO+i");

Object.defineProperty(exports, 'anchorStorage', {
  enumerable: true,
  get: function get() {
    return _anchorStorage.anchorStorage;
  }
});

var _assetSrc = __webpack_require__("47dG");

Object.defineProperty(exports, 'assetSrc', {
  enumerable: true,
  get: function get() {
    return _assetSrc.assetSrc;
  }
});

var _authCheck = __webpack_require__("yfcf");

Object.defineProperty(exports, 'authCheck', {
  enumerable: true,
  get: function get() {
    return _authCheck.authCheck;
  }
});

var _clearModal = __webpack_require__("xA6u");

Object.defineProperty(exports, 'clearModal', {
  enumerable: true,
  get: function get() {
    return _clearModal.clearModal;
  }
});

var _confettiWidget = __webpack_require__("1ejn");

Object.defineProperty(exports, 'confettiWidget', {
  enumerable: true,
  get: function get() {
    return _confettiWidget.confettiWidget;
  }
});

var _dataLayer = __webpack_require__("YcV4");

Object.defineProperty(exports, 'dataLayer', {
  enumerable: true,
  get: function get() {
    return _dataLayer.dataLayer;
  }
});

var _facebook = __webpack_require__("p0QZ");

Object.defineProperty(exports, 'facebookInit', {
  enumerable: true,
  get: function get() {
    return _facebook.facebookInit;
  }
});

var _httpClient = __webpack_require__("/FTs");

Object.defineProperty(exports, 'httpClient', {
  enumerable: true,
  get: function get() {
    return _httpClient.httpClient;
  }
});

var _memberStorage = __webpack_require__("xopG");

Object.defineProperty(exports, 'memberStorage', {
  enumerable: true,
  get: function get() {
    return _memberStorage.memberStorage;
  }
});

var _schema = __webpack_require__("csWH");

Object.defineProperty(exports, 'schemaPagination', {
  enumerable: true,
  get: function get() {
    return _schema.schemaPagination;
  }
});
Object.defineProperty(exports, 'normalizePagination', {
  enumerable: true,
  get: function get() {
    return _schema.normalizePagination;
  }
});

var _proxyCookie = __webpack_require__("T7JS");

Object.defineProperty(exports, 'proxyCookie', {
  enumerable: true,
  get: function get() {
    return _proxyCookie.proxyCookie;
  }
});

var _raven = __webpack_require__("fXn8");

Object.defineProperty(exports, 'raven', {
  enumerable: true,
  get: function get() {
    return _raven.raven;
  }
});

var _transitionAnchorScroll = __webpack_require__("1OER");

Object.defineProperty(exports, 'transitionAnchorScroll', {
  enumerable: true,
  get: function get() {
    return _transitionAnchorScroll.transitionAnchorScroll;
  }
});

var _videoStorage = __webpack_require__("i/0x");

Object.defineProperty(exports, 'videoStorage', {
  enumerable: true,
  get: function get() {
    return _videoStorage.videoStorage;
  }
});

var _virtualPageview = __webpack_require__("JaUt");

Object.defineProperty(exports, 'virtualPageview', {
  enumerable: true,
  get: function get() {
    return _virtualPageview.virtualPageview;
  }
});

var _calculators = __webpack_require__("/m0/");

Object.defineProperty(exports, 'calculateDaysElapsed', {
  enumerable: true,
  get: function get() {
    return _calculators.calculateDaysElapsed;
  }
});
Object.defineProperty(exports, 'calculateAge', {
  enumerable: true,
  get: function get() {
    return _calculators.calculateAge;
  }
});
Object.defineProperty(exports, 'calculateMetFor', {
  enumerable: true,
  get: function get() {
    return _calculators.calculateMetFor;
  }
});
Object.defineProperty(exports, 'calculateMet', {
  enumerable: true,
  get: function get() {
    return _calculators.calculateMet;
  }
});
Object.defineProperty(exports, 'calculateBmi', {
  enumerable: true,
  get: function get() {
    return _calculators.calculateBmi;
  }
});
Object.defineProperty(exports, 'convertWeight', {
  enumerable: true,
  get: function get() {
    return _calculators.convertWeight;
  }
});
Object.defineProperty(exports, 'mround', {
  enumerable: true,
  get: function get() {
    return _calculators.mround;
  }
});

var _stateParams = __webpack_require__("GwJZ");

Object.defineProperty(exports, 'stateParamsForProgram', {
  enumerable: true,
  get: function get() {
    return _stateParams.stateParamsForProgram;
  }
});
Object.defineProperty(exports, 'stateParamsForSubscription', {
  enumerable: true,
  get: function get() {
    return _stateParams.stateParamsForSubscription;
  }
});
Object.defineProperty(exports, 'stateParamsForWeekly', {
  enumerable: true,
  get: function get() {
    return _stateParams.stateParamsForWeekly;
  }
});
Object.defineProperty(exports, 'stateParamsForWelcome', {
  enumerable: true,
  get: function get() {
    return _stateParams.stateParamsForWelcome;
  }
});

var _timeFormat = __webpack_require__("RxC4");

Object.defineProperty(exports, 'datesForWeek', {
  enumerable: true,
  get: function get() {
    return _timeFormat.datesForWeek;
  }
});
Object.defineProperty(exports, 'format', {
  enumerable: true,
  get: function get() {
    return _timeFormat.format;
  }
});
Object.defineProperty(exports, 'formatDigital', {
  enumerable: true,
  get: function get() {
    return _timeFormat.formatDigital;
  }
});
Object.defineProperty(exports, 'formatMinutes', {
  enumerable: true,
  get: function get() {
    return _timeFormat.formatMinutes;
  }
});
Object.defineProperty(exports, 'formatVerbose', {
  enumerable: true,
  get: function get() {
    return _timeFormat.formatVerbose;
  }
});
Object.defineProperty(exports, 'formatDateString', {
  enumerable: true,
  get: function get() {
    return _timeFormat.formatDateString;
  }
});
Object.defineProperty(exports, 'padNumber', {
  enumerable: true,
  get: function get() {
    return _timeFormat.padNumber;
  }
});
Object.defineProperty(exports, 'yearDigits', {
  enumerable: true,
  get: function get() {
    return _timeFormat.yearDigits;
  }
});

/***/ }),

/***/ "11wa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormLogin = __webpack_require__("pxBL");

Object.defineProperty(exports, 'FormLogin', {
  enumerable: true,
  get: function get() {
    return _FormLogin.FormLogin;
  }
});

/***/ }),

/***/ "121k":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ButtonLink = exports.ButtonLink = {
  transclude: true,

  bindings: {
    type: '@',
    ngDisabled: '<'
  },

  template: '\n    <button class="btn btn-link p-0"\n      type="{{ $ctrl.ngType || \'button\' }}"\n      ng-disabled="$ctrl.ngDisabled"\n      ng-transclude>\n    </button>'
};

/***/ }),

/***/ "15A6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Profile = undefined;

var _map2 = __webpack_require__("2247");

var _map3 = _interopRequireDefault(_map2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _auth = __webpack_require__("wnLK");

var _utils = __webpack_require__("0xDb");

var _constants = __webpack_require__("qI5z");

var _member = __webpack_require__("1OIp");

var _signup = __webpack_require__("FQ9i");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Profile = exports.Profile = {
  template: '\n    <div class="profile">\n      <main class="main-content theme-mid bg-gray-dashboard">\n        <div class="container">\n          <section class="profile-content row py-4">\n            <div class="position-relative w-100">\n              <div class="avatar avatar--md theme-avatar-circle">\n                <image-circle src="$ctrl.member.profile.avatarUrl.original">\n                </image-circle>\n              </div>\n              <div class="profile-containers bg-cz-profile-theme p-3">\n                <div class="mb-3">\n                <h1>{{$ctrl.member.error}}</h1>\n                  <profile-container\n                    on-click="$ctrl.onToggleEditing(0)"\n                    is-editing="$ctrl.isEditing[0]">\n                    <form class="pt-5 pb-3"\n                      name="fieldsForm"\n                      ng-submit="$ctrl.onSubmit()"\n                      novalidate>\n                      <profile-fields\n                        form="fieldsForm"\n                        member="$ctrl.member"\n                        is-editing="$ctrl.isEditing[0]"\n                        on-update="$ctrl.updateMemberField(key, value)"\n                        on-upload-complete="$ctrl.fetchMember($ctrl.member.id)">\n                      </profile-fields>\n                      <profile-actions\n                        is-loading="$ctrl.isLoading"\n                        ng-show="$ctrl.isEditing[0]"\n                        on-cancel="$ctrl.onCancel($ctrl.member.id)">\n                      </profile-actions>\n                    </form>\n                    <div class="d-flex justify-content-between justify-content-md-center"\n                      ng-hide="$ctrl.isEditing[0]">\n                      <button-link data-toggle="modal" data-target="#modalChangePassword">\n                        Change Password\n                      </button-link>\n                      <modal target="modalChangePassword">\n                        <modal-title>\n                          <span class="text-center">Change Password</span>\n                        </modal-title>\n                        <modal-body>\n                          <form class="voome-form"\n                            name="form"\n                            autocomplete="off"\n                            ng-submit="$ctrl.updateMemberPassword($ctrl.member.id, form.data)"\n                            novalidate>\n                            <profile-fields-password\n                              form="form"\n                              is-update="true"\n                              has-error="$ctrl.error"\n                              message="$ctrl.message">\n                            </profile-fields-password>\n                            <div class="modal-footer pb-0 d-flex justify-content-center">\n                              <button-primary\n                                is-inverse="true"\n                                data-dismiss="modal"\n                                on-click="$ctrl.resetForm(form)">\n                                Cancel\n                              </button-primary>\n                              <button-primary\n                                ng-type="submit"\n                                ng-disabled="form.$invalid">\n                                <spinner is-loading="$ctrl.isLoading">\n                                  Submit\n                                </spinner>\n                              </button-primary>\n                            </div>\n                          </form>\n                        </modal-body>\n                      </modal>\n                      <span class="px-3 text-light"></span>\n                      <button-link ng-click="$ctrl.authLogout()">\n                        <i class="fa fa-sign-out"></i> Logout\n                      </button-link>\n                    </div>\n                  </profile-container>\n                </div>\n                <div class="mb-3">\n                  <profile-container\n                    on-click="$ctrl.onToggleEditing(1)"\n                    is-editing="$ctrl.isEditing[1]">\n                    <form name="fieldsMoreForm"\n                      ng-submit="$ctrl.onSubmit()"\n                      novalidate>\n                      <profile-fields-more\n                        form="fieldsMoreForm"\n                        member="$ctrl.member"\n                        is-editing="$ctrl.isEditing[1]"\n                        on-update="$ctrl.updateMemberField(key, value)">\n                      </profile-fields-more>\n                      <profile-actions\n                        is-loading="$ctrl.isLoading"\n                        ng-show="$ctrl.isEditing[1]"\n                        on-cancel="$ctrl.onCancel($ctrl.member.id)">\n                      </profile-actions>\n                    </form>\n                  </profile-container>\n                </div>\n                  <profile-container\n                    on-click="$ctrl.onToggleEditing(2)"\n                    is-editing="$ctrl.isEditing[2]">\n                    <form name="nutrititonForm"\n                      ng-submit="$ctrl.onSubmit()"\n                      novalidate>\n                      <profile-fields-nutrition\n                        form="nutrititonForm"\n                        member="$ctrl.member"\n                        is-editing="$ctrl.isEditing[2]"\n                        questions="$ctrl.nutritionQuestions"\n                        on-update="$ctrl.updateMemberField(key, value)">\n                      </profile-fields-nutrition>\n                      <profile-actions\n                        is-loading="$ctrl.isLoading"\n                        ng-show="$ctrl.isEditing[2]"\n                        on-cancel="$ctrl.onCancel($ctrl.member.id)">\n                      </profile-actions>\n                    </form>\n                  </profile-container>\n                \n              </div>\n            </div>\n          </section>\n        </div>\n      </main>\n      <modal\n        target="modifySubscriptionModal"\n        on-hidden="$ctrl.reload()">\n        <modal-title>\n          Subscription Modified\n        </modal-title>\n        <modal-body>\n          <div class="text-center">\n            <p>\n              You have successfully modified your subscription to\n              <br>\n              {{ $ctrl.product.name }}\n            </p>\n            <p>\n              <button-primary on-click="$ctrl.reload()">\n                Continue\n              </button-primary>\n            </p>\n          </div>\n        </modal-body>\n      </modal>\n    </div>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        this.isEditing = [false, false, false, false];
        this.billing = {
          reasons: _constants.PROFILE_CANCELLATION_REASONS,
          type: 'history'
        };

        if (!this.invoices) {
          var _memberStorage$get = _utils.memberStorage.get(),
              memberId = _memberStorage$get.memberId,
              voomeProductId = _memberStorage$get.voomeProductId;

          this.fetchInvoices(memberId, voomeProductId);
        }

        // Ensure we have an upto date member
        this.fetchMember(_utils.memberStorage.get().memberId);

        // Check ability to update credit card.
        this.checkStatus();
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();

        if (this.unsubscribe) {
          this.unsubscribe();
        }
      },
      onSubmit: function onSubmit() {
        this.updateMember(this.member);
        this.onToggleEditing();
      },
      onCancel: function onCancel(memberId) {
        this.fetchMember(memberId);
        this.onToggleEditing();
      },
      onToggleEditing: function onToggleEditing(index) {
        this.isEditing = (0, _map3.default)(this.isEditing, function (value, key) {
          return key === index ? !value : false;
        });
      },
      onToggleBilling: function onToggleBilling(type, subscription) {
        this.billing = _extends({}, this.billing, {
          type: type,
          subscription: subscription
        });

        // Reset the update password form.
        this.reset();
      },
      onCancelSubscription: function onCancelSubscription(member, subscription, data) {
        var params = {
          reason: data.reasonOther ? data.reasonOther : data.reasonAnswer,
          password: data.reasonPassword
        };

        this.cancelSubscription(member.id, subscription.id, params);
        this.onCancelSuccess(subscription.voomeProductId);
      },
      onCancelSuccess: function onCancelSuccess(voomeProductId) {
        var _this = this;

        this.unsubscribe = $ngRedux.subscribe(function () {
          var _$ngRedux$getState = $ngRedux.getState(),
              member = _$ngRedux$getState.member;

          var subscription = (0, _member.selectSubscription)(member, voomeProductId);

          if (subscription.status === 'delayed_cancelled') {
            _this.unsubscribe();
            _this.onToggleBilling('history', subscription);
          }
        });
      },
      onDowngradeSubscription: function onDowngradeSubscription(subscription, data) {
        var id = subscription.id,
            voomeProductId = subscription.voomeProductId;

        this.onDowngradeSuccess(voomeProductId);
        this.downgradeSubscription(id, data.voomeProductId);
      },
      onDowngradeSuccess: function onDowngradeSuccess(voomeProductId) {
        var _this2 = this;

        this.unsubscribe = $ngRedux.subscribe(function () {
          var _$ngRedux$getState2 = $ngRedux.getState(),
              member = _$ngRedux$getState2.member,
              signup = _$ngRedux$getState2.signup;

          var currentSubscription = (0, _member.selectSubscription)(member);

          if (currentSubscription.voomeProductId !== voomeProductId) {
            _this2.unsubscribe();
            $('#modifySubscriptionModal').modal('show');
          }
        });
      },
      reload: function reload() {
        window.location.reload();
      },
      mapState: function mapState(_ref) {
        var member = _ref.member,
            signup = _ref.signup;

        var nutritionQuestions = (0, _member.selectHasNutritionSubscription)(member) ? (0, _member.selectNutritionQuestions)(member) : undefined;

        var workoutQuestions = (0, _member.selectHasWorkoutSubscription)(member) ? (0, _member.selectWorkoutQuestions)(member) : undefined;

        var isLoading = member.isLoading,
            error = member.error,
            message = member.message;

        var subscription = (0, _member.selectSubscription)(member);

        return {
          nutritionQuestions: nutritionQuestions,
          workoutQuestions: workoutQuestions,
          isLoading: isLoading,
          error: error,
          message: message,
          subscription: subscription,
          member: (0, _member.selectMember)(member),
          subscriptions: (0, _member.selectSubscriptions)(member),
          product: (0, _signup.selectProduct)(signup, subscription.voomeProductId)
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          authLogout: _auth.authLogout,
          checkStatus: _signup.checkStatus,
          cancelSubscription: _member.cancelSubscription,
          fetchMember: _member.fetchMember,
          fetchInvoices: _member.fetchInvoices,
          downgradeSubscription: _member.downgradeSubscription,
          reset: _signup.reset,
          resumeSubscription: _member.resumeSubscription,
          selectNutritionQuestions: _member.selectNutritionQuestions,
          setup: _signup.setup,
          updateChargifyData: _signup.updateChargifyData,
          updateMember: _member.updateMember,
          updateMemberPassword: _member.updateMemberPassword,
          updateMemberField: _member.updateMemberField
        };
      }
    };
  }]
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "1BYA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgramIntro = undefined;

var _member = __webpack_require__("1OIp");

var _product = __webpack_require__("5AvL");

var ProgramIntro = exports.ProgramIntro = {
  template: '\n    <section class="program-intro pb-5">\n      <program-nav></program-nav>\n      <div class="bg-container-overlay theme-program-overview bg-opaque-md"></div>\n      <div class="program-intro-content container">\n        <div class="row">\n          <div class="col-md-6 text-center">\n            <h2 class="theme-program-logo theme-program-logo--dark">\n              <span class="text-black">{{ $ctrl.program.name }}</span>\n            </h2>\n            <p>{{ $ctrl.program.description }}</p>\n            <video-player-resumable video-id="$ctrl.program.productMeta.introVideo.brightcoveId">\n            </video-player-resumable>\n          </div>\n        </div>\n      </div>\n      <button-full-width\n        modal-target="#modalRestartProgram"\n        ng-if="$ctrl.program.startedAt && ($ctrl.program.daysElapsed >= 0)">\n        Restart\n      </button-full-width>\n      <button-full-width\n        modal-target="#modalStartProgram"\n        ng-if="!$ctrl.program.startedAt || ($ctrl.program.daysElapsed < 0)">\n        <span ng-if="!$ctrl.program.startedAt">\n          Start your program\n        </span>\n        <span ng-if="$ctrl.program.startedAt">\n          Your program will start\n          <span ng-if="$ctrl.program.daysElapsed <= -2">in {{ -$ctrl.program.daysElapsed }} days</span>\n          <span ng-if="$ctrl.program.daysElapsed === -1">tomorrow</span>\n        </span>\n      </button-full-width>\n    </section>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, {});
        this.unsubscribe = connect(this);
      },
      $onDestroy: function $onDestroy() {
        this.unsubscribe();
      },
      mapState: function mapState(_ref) {
        var member = _ref.member,
            product = _ref.product;

        return {
          member: (0, _member.selectMember)(member),
          program: (0, _product.selectProduct)(product)
        };
      }
    };
  }]
};

/***/ }),

/***/ "1Fbq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ProgramRestartModal = exports.ProgramRestartModal = {
  bindings: {
    subscription: '<',
    weeks: '<',
    onSubmit: '&'
  },

  template: '\n    <div\n      id="modalRestartProgram"\n      class="modal fade"\n      tabindex="-1"\n      role="dialog"\n      aria-labelledby="Restart Program"\n      aria-hidden="true">\n      <div class="modal-dialog" role="document">\n        <form\n          name="form"\n          ng-submit="$ctrl.onSubmit({ data: form.data })"\n          novalidate>\n          <form-input\n            form="form"\n            type="hidden"\n            name="id"\n            value="$ctrl.subscription.id"/>\n          <form-input\n            form="form"\n            type="hidden"\n            name="voomeProductId"\n            value="$ctrl.subscription.voomeProductId"/>\n          <div class="modal-content">\n            <div class="modal-header text-center">\n              <h5 class="modal-title m-auto">\n                Restart Program\n              </h5>\n              <button type="button" class="close" data-dismiss="modal" aria-label="Close">\n                <span aria-hidden="true">&times;</span>\n              </button>\n            </div>\n            <div class="modal-body text-left">\n              <p>You can restart the program or jump backwards/forwards to the start of any week. This will take you to the beginning of the week selected below.</p>\n              <form-radio-list\n                form="form"\n                name="week"\n                value="form.data.week"\n                list="$ctrl.weeks"\n                list-item-key="weekNumber"\n                list-item-title="title"\n                list-item-class="list-inline-item w-100 btn-radio-list"\n                on-update="$ctrl.onUpdate(key, value)">\n              </form-radio-list>\n            </div>\n            <div class="modal-footer d-flex justify-content-center">\n              <button-primary is-inverse="true" data-dismiss="modal">\n                Cancel\n              </button-primary>\n              <button-primary\n                ng-type="submit"\n                ng-disabled="!form.data.week">\n                Restart\n              </button-primary>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>',

  controller: ["$scope", function controller($scope) {
    'ngInject';

    return {
      onUpdate: function onUpdate(key, value) {
        $scope.form.data.week = value;
      }
    };
  }]
};

/***/ }),

/***/ "1Kic":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var WorkoutPlayerContextPanel = exports.WorkoutPlayerContextPanel = {
  bindings: {
    workout: '<',
    steps: '<',
    currentStep: '<',
    currentStepIndex: '<',
    exercises: '<',
    onClick: '&'
  },

  template: '\n    <div class="workout-player-context-panel">\n      <div class="context-panel-inner">\n        <div\n          ng-repeat="group in $ctrl.workout.items track by $index"\n          ng-if="group.name !== \'Transition\'">\n          <h3 class="group-title">\n            <span class="bar"></span>\n            <span>{{ group.name }}</span>\n            <span class="bar"></span>\n          </h3>\n          <ul class="list-unstyled">\n            <li\n              ng-repeat="item in group.items track by $index"\n              ng-if="item.name !== \'Transition\' && !item.duplicate",\n              ng-class="{ \'active\': item.id === $ctrl.currentStep.id || item.id === $ctrl.currentStep.parentId }"\n              ng-switch="item.items.length > 0"\n              ng-attr-id="{{ \'item-\' + item.id }}">\n              <!-- Single item -->\n              <div class="single-item"\n                ng-switch-when="false"\n                ng-click="(item.id === $ctrl.currentStep.id) && $ctrl.onClick()">\n                <workout-player-context-item\n                  data="$ctrl.exercises[item.exerciseId]">\n                </workout-player-context-item>\n              </div>\n              <!-- Super set -->\n              <div ng-switch-when="true">\n                <div class="superset">\n                  {{ item.repsCount }}x {{ item.name }}\n                  <span class="sets">\n                    {{ $ctrl.data.getSetTitle(item) }}\n                  </span>\n                </div>\n                <ul class="list-unstyled">\n                  <li\n                    ng-repeat="leaf in item.items track by $index"\n                    ng-if="!leaf.duplicate"\n                    ng-class="{\'active\': leaf.id === $ctrl.currentStep.id}"\n                    ng-attr-id="{{ \'item-\' + leaf.id }}">\n                    <div class="single-item"\n                      ng-click="(leaf.id === $ctrl.currentStep.id) && $ctrl.onClick()">\n                      <workout-player-context-item\n                        data="$ctrl.exercises[leaf.exerciseId]">\n                      </workout-player-context-item>\n                    </div>\n                  </li>\n                </ul>\n              </div>\n            </li>\n          </ul>\n        </div>\n      </div>\n    </div>',

  controller: ["$element", function controller($element) {
    'ngInject';

    return {
      $onChanges: function $onChanges(changes) {
        if (this.currentStep && changes.currentStepIndex) {
          this.animate(this.currentStep.id);
        }
      },
      animate: function animate(id) {
        var $el = $element.find('#item-' + id);

        var offset = 0;

        if ($el.index() === 0) {
          offset = $element.find('.group-title').height();
        }

        if ($el.position()) {
          offset = offset - $el.position().top;
        }

        $element.find('.context-panel-inner').animate({ translateY: offset }, {
          speed: 400,
          step: function animateContextPanel(now) {
            $(this).css('transform', 'translate3d(0, ' + now + 'px, 0)');
          }
        });
      }
    };
  }]
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "1LWp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1OER":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transitionAnchorScroll = undefined;

var _utils = __webpack_require__("0xDb");

var transitionAnchorScroll = exports.transitionAnchorScroll = ["$anchorScroll", "$location", "$timeout", "$transitions", function transitionAnchorScroll($anchorScroll, $location, $timeout, $transitions) {
  'ngInject';

  $transitions.onSuccess('*', function ($transition$) {
    var _anchorStorage$get = _utils.anchorStorage.get(),
        name = _anchorStorage$get.name,
        hash = _anchorStorage$get.hash;

    var targetName = $transition$.targetState().name();

    if (name === targetName && hash) {
      _utils.anchorStorage.remove();
      $location.hash(hash);
    }

    $timeout(function () {
      return $anchorScroll();
    });
  });
}];

/***/ }),

/***/ "1OIp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectIsProductWithRequirements = exports.selectIsProductLowFodmap = exports.selectPrintTooltip = exports.selectWorkoutQuestions = exports.selectNutritionQuestions = exports.selectIsMatched = exports.selectHasProgramSubscription = exports.selectHasWeeklySubscription = exports.selectHasSubscriptionWithSlug = exports.selectHasBundleSubscription = exports.selectHasWorkoutSubscription = exports.selectHasNutritionSubscription = exports.selectSubscriptionHasStarted = exports.selectSubscriptionFallback = exports.selectSubscriptionWithFallback = exports.selectSubscription = exports.selectSubscriptions = exports.selectMemberIsVegetarian = exports.selectMemberLevel = exports.selectInvoices = exports.selectMember = exports.resetPasswordUpdate = exports.resetPasswordCreate = exports.resetPasswordInit = exports.changeSubscription = exports.resumeSubscription = exports.cancelSubscription = exports.restartSubscription = exports.startSubscription = exports.upgradeSubscription = exports.downgradeSubscription = exports.updateMemberPassword = exports.updateMemberField = exports.updateMemberStep = exports.updateMember = exports.fetchInvoices = exports.fetchMember = exports.memberLogic = exports.initialState = undefined;

var _sortBy2 = __webpack_require__("KBYM");

var _sortBy3 = _interopRequireDefault(_sortBy2);

var _reverse2 = __webpack_require__("dbov");

var _reverse3 = _interopRequireDefault(_reverse2);

var _pick2 = __webpack_require__("w9Mt");

var _pick3 = _interopRequireDefault(_pick2);

var _mapValues2 = __webpack_require__("94Kh");

var _mapValues3 = _interopRequireDefault(_mapValues2);

var _map2 = __webpack_require__("2247");

var _map3 = _interopRequireDefault(_map2);

var _intersection2 = __webpack_require__("Aemx");

var _intersection3 = _interopRequireDefault(_intersection2);

var _includes2 = __webpack_require__("q+Dy");

var _includes3 = _interopRequireDefault(_includes2);

var _has2 = __webpack_require__("umy1");

var _has3 = _interopRequireDefault(_has2);

var _get2 = __webpack_require__("Q7hp");

var _get3 = _interopRequireDefault(_get2);

var _findKey2 = __webpack_require__("PtNq");

var _findKey3 = _interopRequireDefault(_findKey2);

var _find2 = __webpack_require__("kbi+");

var _find3 = _interopRequireDefault(_find2);

var _filter2 = __webpack_require__("RyI1");

var _filter3 = _interopRequireDefault(_filter2);

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;

var _normalizr = __webpack_require__("vNPR");

var _reduxLogic = __webpack_require__("E0Bt");

var _reduxUiRouter = __webpack_require__("Zb/7");

var _settings = __webpack_require__("Ll2K");

var _auth = __webpack_require__("wnLK");

var _decorators = __webpack_require__("SPxS");

var _constants = __webpack_require__("qI5z");

var _utils = __webpack_require__("0xDb");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Action Types
var FETCH = '@@app/member/FETCH';
var FETCH_REDIRECT = '@@app/member/FETCH_REDIRECT';
var FETCH_SUCCESS = '@@app/member/FETCH_SUCCESS';
var FETCH_ERROR = '@@app/member/FETCH_ERROR';
var FETCH_INVOICES = '@@app/member/FETCH_INVOICES';
var FETCH_INVOICES_SUCCESS = '@@app/member/FETCH_INVOICES_SUCCESS';

var UPDATE = '@@app/member/UPDATE';
var UPDATE_SUCCESS = '@@app/member/UPDATE_SUCCESS';
var UPDATE_ERROR = '@@app/member/UPDATE_ERROR';
var UPDATE_FIELD = '@@app/member/UPDATE_FIELD';
var UPDATE_PASSWORD = '@@app/member/UPDATE_PASSWORD';
var UPDATE_SUBSCRIPTION = '@@app/member/UPDATE_SUBSCRIPTION';

var START_SUBSCRIPTION = '@@app/member/START_SUBSCRIPTION';
var RESTART_SUBSCRIPTION = '@@app/member/RESTART_SUBSCRIPTION';
var CHANGE_SUBSCRIPTION = '@@app/member/CHANGE_SUBSCRIPTION';
var RELOAD_PROGRAM = '@@app/member/RELOAD_PROGRAM';

var RESET_PASSWORD_INIT = '@@app/member/RESET_PASSWORD_INIT';
var RESET_PASSWORD_CREATE = '@@app/member/RESET_PASSWORD_CREATE';
var RESET_PASSWORD_UPDATE = '@@app/member/RESET_PASSWORD_UPDATE';
var RESET_PASSWORD_SUCCESS = '@@app/member/RESET_PASSWORD_SUCCESS';
var RESET_PASSWORD_ERROR = '@@app/member/RESET_PASSWORD_ERROR';

var DOWNGRADE_SUBSCRIPTION = '@@app/member/DOWNGRADE_SUBSCRIPTION';
var UPGRADE_SUBSCRIPTION = '@@app/member/UPGRADE_SUBSCRIPTION';
var MIGRATE_SUBSCRIPTION_ERROR = '@@app/member/MIGRATE_SUBSCRIPTION_ERROR';
var MIGRATE_SUBSCRIPTION_SUCCESS = '@@app/member/MIGRATE_SUBSCRIPTION_SUCCESS';

var CANCEL_SUBSCRIPTION = '@@app/member/CANCEL_SUBSCRIPTION';
var CANCEL_SUBSCRIPTION_ERROR = '@@app/member/CANCEL_SUBSCRIPTION_ERROR';
var RESUME_SUBSCRIPTION = '@@app/member/RESUME_SUBSCRIPTION';

var CANCEL = '@@app/member/CANCEL';

// Initial State
var initialState = exports.initialState = {
  isLoading: false,
  error: false,
  success: false,
  message: '',
  entities: {
    invoices: [],
    members: {},
    subscriptions: {}
  },
  result: null
};

// Observables
var fetchLogic = (0, _reduxLogic.createLogic)({
  type: FETCH,
  debounce:  false ? 0 : 500,
  latest: true,
  processOptions: {
    successType: FETCH_SUCCESS,
    failType: FETCH_ERROR
  },
  process: function process(_ref) {
    var action = _ref.action,
        httpClient = _ref.httpClient,
        memberStorage = _ref.memberStorage;

    return httpClient.get('/v1/voome/members/' + action.payload.memberId).then(function (response) {
      var subscription = new _normalizr.schema.Entity('subscriptions');
      var member = new _normalizr.schema.Entity('members', {
        subscriptions: [subscription]
      });

      return (0, _normalizr.normalize)((0, _decorators.decorateMember)(response.data), member);
    }).catch(function () {
      return {
        message: 'An error occured fetching the member'
      };
    });
  }
});

var fetchInvoicesLogic = (0, _reduxLogic.createLogic)({
  type: FETCH_INVOICES,
  processOptions: {
    successType: FETCH_INVOICES_SUCCESS,
    failType: FETCH_ERROR
  },
  process: function process(_ref2) {
    var action = _ref2.action,
        httpClient = _ref2.httpClient;

    return httpClient.get('/v1/voome/members/' + action.payload.memberId + '/invoices');
  }
});

var resetPasswordCreateLogic = (0, _reduxLogic.createLogic)({
  type: RESET_PASSWORD_CREATE,
  processOptions: {
    successType: RESET_PASSWORD_SUCCESS,
    failType: RESET_PASSWORD_ERROR
  },
  process: function process(_ref3) {
    var action = _ref3.action,
        httpClient = _ref3.httpClient;
    var _action$payload = action.payload,
        email = _action$payload.email,
        theme = _action$payload.theme,
        callbackUrl = _action$payload.callbackUrl;

    var member = { email: email };

    var onSuccess = function onSuccess() {
      var message = 'An email has been sent to ' + email + '. Follow the\n        directions within the email to reset your password.';
      return { message: message };
    };

    return httpClient.post('/v1/password', { member: member, callbackUrl: callbackUrl, theme: theme }).then(onSuccess);
  }
});

var resetPasswordUpdateLogic = (0, _reduxLogic.createLogic)({
  type: RESET_PASSWORD_UPDATE,
  process: function process(_ref4, dispatch, done) {
    var action = _ref4.action,
        httpClient = _ref4.httpClient;

    var member = (0, _pick3.default)(action.payload, ['email', 'password', 'resetPasswordToken']);

    var onSuccess = function onSuccess() {
      var message = 'The password for ' + member.email + ' has been updated.\n        You can now login with your new password';

      dispatch({ type: RESET_PASSWORD_SUCCESS, payload: { message: message } });
    };

    var onFail = function onFail(_ref5) {
      var response = _ref5.response;

      var error = (0, _get3.default)(response, 'data.error.reset_password_token[0]');
      var message = error === 'is invalid' ? 'Reset password token is no longer valid' : 'An error occured updating your password';

      dispatch({
        type: RESET_PASSWORD_ERROR,
        payload: {
          message: message + ', try submitting your email again.'
        }
      });

      dispatch((0, _reduxUiRouter.stateGo)('resetPassword', {
        reset_password_token: undefined
      }));
    };

    return httpClient.put('/v1/password', { member: member }).then(onSuccess).catch(onFail).then(done);
  }
});

var updateMemberLogic = (0, _reduxLogic.createLogic)({
  type: UPDATE,
  cancelType: CANCEL,
  process: function process(_ref6, dispatch, done) {
    var action = _ref6.action,
        getState = _ref6.getState,
        httpClient = _ref6.httpClient;

    var memberId = (0, _get3.default)(action.payload.member, 'id');
    var member = (0, _pick3.default)(action.payload.member, ['birthday', 'country', 'email', 'firstName', 'gender', 'lastName', 'password', 'postcode', 'profile', 'voomeProfile', 'screenName', 'startWeightInKg']);

    var onSuccess = function onSuccess() {
      var step = action.payload.step;


      if (step) {
        var _selectSubscription = selectSubscription(getState().member),
            id = _selectSubscription.id;

        var subscription = { id: id, step: step };

        dispatch({
          type: UPDATE_SUBSCRIPTION,
          payload: { subscription: subscription, memberId: memberId }
        });
      } else {
        dispatch(fetchMember(memberId));
      }
    };

    var onFail = function onFail() {
      dispatch({
        type: UPDATE_ERROR,
        error: true,
        payload: {
          message: 'An error occured updating. Please try again.'
        }
      });
    };

    httpClient.put('/v3/members/' + memberId, { member: member }).then(onSuccess).catch(onFail).then(done);
  }
});

var updateSubscriptionLogic = (0, _reduxLogic.createLogic)({
  type: [UPDATE_SUBSCRIPTION, START_SUBSCRIPTION, RESTART_SUBSCRIPTION],
  process: function process(_ref7, dispatch, done) {
    var action = _ref7.action,
        httpClient = _ref7.httpClient;
    var _action$payload2 = action.payload,
        subscription = _action$payload2.subscription,
        memberId = _action$payload2.memberId;
    var startDate = subscription.startDate,
        week = subscription.week,
        voomeProductId = subscription.voomeProductId;


    var onSuccess = function onSuccess() {
      switch (action.type) {
        case START_SUBSCRIPTION:
          dispatch({
            type: RELOAD_PROGRAM,
            payload: {
              voomeProductId: voomeProductId,
              weekNumber: startDate === (0, _utils.formatDateString)(new Date()) ? 1 : 0
            }
          });
          break;

        case RESTART_SUBSCRIPTION:
          dispatch({
            type: RELOAD_PROGRAM,
            payload: {
              voomeProductId: voomeProductId,
              weekNumber: week
            }
          });
          break;

        default:
          dispatch(fetchMember(memberId));
          break;
      }
    };

    var onFail = function onFail() {
      dispatch({
        type: UPDATE_ERROR,
        error: true,
        payload: {
          message: 'An error occured updating. Please try again.'
        }
      });
    };

    var params = { subscription: subscription };
    var endpoint = '/v1/voome/subscriptions/' + subscription.id;

    switch (action.type) {
      case START_SUBSCRIPTION:
        params = { startDate: startDate };
        endpoint += '/start';
        break;

      case RESTART_SUBSCRIPTION:
        params = { week: week };
        endpoint += '/restart';
        break;
    }

    return httpClient.put(endpoint, params).then(onSuccess).catch(onFail).then(done);
  }
});

var cancelSubscriptionLogic = (0, _reduxLogic.createLogic)({
  type: CANCEL_SUBSCRIPTION,
  process: function process(_ref8, dispatch, done) {
    var action = _ref8.action,
        httpClient = _ref8.httpClient;
    var _action$payload3 = action.payload,
        memberId = _action$payload3.memberId,
        subscriptionId = _action$payload3.subscriptionId,
        params = _action$payload3.params;

    var endpoint = '/v1/voome/subscriptions/' + subscriptionId + '/delayed-cancel';
    var onSuccess = function onSuccess() {
      return dispatch(fetchMember(memberId));
    };
    var onFail = function onFail() {
      return dispatch({ type: CANCEL_SUBSCRIPTION_ERROR });
    };

    return httpClient.put(endpoint, params).then(onSuccess).catch(onFail).then(done);
  }
});

var migrateSubscriptionLogic = (0, _reduxLogic.createLogic)({
  type: [DOWNGRADE_SUBSCRIPTION, UPGRADE_SUBSCRIPTION],
  processOptions: {
    successType: MIGRATE_SUBSCRIPTION_SUCCESS,
    failType: MIGRATE_SUBSCRIPTION_ERROR
  },
  process: function process(_ref9) {
    var action = _ref9.action,
        dataLayer = _ref9.dataLayer,
        httpClient = _ref9.httpClient;
    var _action$payload4 = action.payload,
        step = _action$payload4.step,
        subscriptionId = _action$payload4.subscriptionId,
        voomeProductId = _action$payload4.voomeProductId;

    var endpoint = '/v1/voome/subscriptions/' + subscriptionId + '/migrate';
    var type = action.type === DOWNGRADE_SUBSCRIPTION ? 'downgrade' : 'upgrade';

    var onSuccess = function onSuccess(response) {
      _utils.memberStorage.setKey('voomeProductId', voomeProductId);
      dataLayer.track(type, response.data);
      return response.data;
    };

    return httpClient.put(endpoint, { voomeProductId: voomeProductId, step: step }).then(onSuccess);
  }
});

var resumeSubscriptionLogic = (0, _reduxLogic.createLogic)({
  type: RESUME_SUBSCRIPTION,
  process: function process(_ref10, dispatch, done) {
    var action = _ref10.action,
        httpClient = _ref10.httpClient;
    var _action$payload5 = action.payload,
        memberId = _action$payload5.memberId,
        subscriptionId = _action$payload5.subscriptionId;

    var endpoint = '/v1/voome/subscriptions/' + subscriptionId + '/resume';
    var onSuccess = function onSuccess() {
      return dispatch(fetchMember(memberId));
    };

    return httpClient.put(endpoint).then(onSuccess).then(done);
  }
});

var reloadProgramLogic = (0, _reduxLogic.createLogic)({
  type: RELOAD_PROGRAM,
  process: function process(_ref11, dispatch, done) {
    var action = _ref11.action,
        memberStorage = _ref11.memberStorage;
    var _action$payload6 = action.payload,
        voomeProductId = _action$payload6.voomeProductId,
        weekNumber = _action$payload6.weekNumber;


    var name = 'program';
    var params = { voomeProductId: voomeProductId };
    var uri = '/program/' + voomeProductId;

    if (weekNumber > 0) {
      name = 'program.week.detail';
      params.weekNumber = weekNumber;
      uri = '/program/' + voomeProductId + '/week/' + weekNumber;
    }

    memberStorage.setKey('redirectTo', { name: name, params: params });
    window.location.assign(uri);
    done();
  }
});

var changeSubscriptionLogic = (0, _reduxLogic.createLogic)({
  type: CHANGE_SUBSCRIPTION,
  process: function process(_ref12, dispatch, done) {
    var action = _ref12.action,
        memberStorage = _ref12.memberStorage;
    var subscription = action.payload.subscription;

    var _stateParamsForSubscr = (0, _utils.stateParamsForSubscription)(subscription),
        name = _stateParamsForSubscr.name,
        params = _stateParamsForSubscr.params;

    memberStorage.setKey('voomeProductId', subscription.voomeProductId);
    dispatch((0, _reduxUiRouter.stateGo)(name, params));
    done();
  }
});

var updatePasswordLogic = (0, _reduxLogic.createLogic)({
  type: UPDATE_PASSWORD,
  process: function process(_ref13, dispatch, done) {
    var action = _ref13.action,
        httpClient = _ref13.httpClient;
    var _action$payload7 = action.payload,
        memberId = _action$payload7.memberId,
        params = _action$payload7.params;

    var member = (0, _pick3.default)(params, ['currentPassword', 'password', 'passwordConfirmation']);

    var onSuccess = function onSuccess() {
      // Not great.. but having issues handling the modal form.
      window.location.assign('/profile');
    };

    var onFail = function onFail(_ref14) {
      var response = _ref14.response;

      var error = (0, _get3.default)(response, 'data.errors.current_password[0]');
      var message = error === 'is invalid' ? 'Incorrect password' : 'An error occured';

      dispatch({
        type: UPDATE_ERROR,
        payload: {
          message: message + ', please try again.'
        }
      });
    };

    return httpClient.put('v1/members/' + memberId + '/update-password', { member: member }).then(onSuccess).catch(onFail).then(done);
  }
});

var memberLogic = exports.memberLogic = [changeSubscriptionLogic, fetchInvoicesLogic, fetchLogic, cancelSubscriptionLogic, migrateSubscriptionLogic, reloadProgramLogic, resetPasswordCreateLogic, resetPasswordUpdateLogic, resumeSubscriptionLogic, updateMemberLogic, updatePasswordLogic, updateSubscriptionLogic];

// Action Creators
var fetchMember = exports.fetchMember = function fetchMember(memberId) {
  return { type: FETCH, payload: { memberId: memberId } };
};

var fetchInvoices = exports.fetchInvoices = function fetchInvoices(memberId, voomeProductId) {
  return { type: FETCH_INVOICES, payload: { memberId: memberId, voomeProductId: voomeProductId } };
};

var updateMember = exports.updateMember = function updateMember(member) {
  return { type: UPDATE, payload: { member: member } };
};

var updateMemberStep = exports.updateMemberStep = function updateMemberStep(member) {
  var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  return { type: UPDATE, payload: { member: member, step: step } };
};

var updateMemberField = exports.updateMemberField = function updateMemberField(key, value) {
  return { type: UPDATE_FIELD, payload: { key: key, value: value } };
};

var updateMemberPassword = exports.updateMemberPassword = function updateMemberPassword(memberId, params) {
  return { type: UPDATE_PASSWORD, payload: { memberId: memberId, params: params } };
};

var downgradeSubscription = exports.downgradeSubscription = function downgradeSubscription(subscriptionId, voomeProductId) {
  return {
    type: DOWNGRADE_SUBSCRIPTION,
    payload: { subscriptionId: subscriptionId, voomeProductId: voomeProductId }
  };
};

var upgradeSubscription = exports.upgradeSubscription = function upgradeSubscription(subscriptionId, voomeProductId) {
  return {
    type: UPGRADE_SUBSCRIPTION,
    payload: { step: 2, subscriptionId: subscriptionId, voomeProductId: voomeProductId }
  };
};

var startSubscription = exports.startSubscription = function startSubscription(subscription) {
  return { type: START_SUBSCRIPTION, payload: { subscription: subscription } };
};

var restartSubscription = exports.restartSubscription = function restartSubscription(subscription) {
  return { type: RESTART_SUBSCRIPTION, payload: { subscription: subscription } };
};

var cancelSubscription = exports.cancelSubscription = function cancelSubscription(memberId, subscriptionId, params) {
  return {
    type: CANCEL_SUBSCRIPTION,
    payload: { memberId: memberId, subscriptionId: subscriptionId, params: params }
  };
};

var resumeSubscription = exports.resumeSubscription = function resumeSubscription(memberId, subscriptionId) {
  return {
    type: RESUME_SUBSCRIPTION,
    payload: { memberId: memberId, subscriptionId: subscriptionId }
  };
};

var changeSubscription = exports.changeSubscription = function changeSubscription(subscription) {
  return { type: CHANGE_SUBSCRIPTION, payload: { subscription: subscription } };
};

var resetPasswordInit = exports.resetPasswordInit = function resetPasswordInit() {
  return { type: RESET_PASSWORD_INIT };
};

var resetPasswordCreate = exports.resetPasswordCreate = function resetPasswordCreate(payload) {
  return { type: RESET_PASSWORD_CREATE, payload: payload };
};

var resetPasswordUpdate = exports.resetPasswordUpdate = function resetPasswordUpdate(payload) {
  return { type: RESET_PASSWORD_UPDATE, payload: payload };
};

// Selectors
var selectMember = exports.selectMember = function selectMember(state) {
  return state.entities.members[state.result];
};

var selectInvoices = exports.selectInvoices = function selectInvoices(state) {
  return state.entities.invoices;
};

var selectMemberLevel = exports.selectMemberLevel = function selectMemberLevel(state) {
  return (0, _get3.default)(selectMember(state), 'voomeProfile.level', 0);
};

var selectMemberIsVegetarian = exports.selectMemberIsVegetarian = function selectMemberIsVegetarian(state) {
  return (0, _get3.default)(selectMember(state), 'profile.vegetarian', false);
};

var selectSubscriptions = exports.selectSubscriptions = function selectSubscriptions(state) {
  var invoices = selectInvoices(state);

  return (0, _mapValues3.default)(state.entities.subscriptions, function (subscription) {
    return _extends({}, subscription, {
      invoices: (0, _filter3.default)(invoices, {
        billableId: subscription.id,
        billableType: 'Voome::Subscription'
      })
    });
  });
};

var selectSubscription = exports.selectSubscription = function selectSubscription(state, voomeProductId) {
  return (0, _find3.default)(selectSubscriptions(state), {
    voomeProductId: parseInt(voomeProductId || _utils.memberStorage.get().voomeProductId, 10)
  }) || {};
};

var selectSubscriptionWithFallback = exports.selectSubscriptionWithFallback = function selectSubscriptionWithFallback(state) {
  var subscription = selectSubscription(state);

  return subscription.status === 'active' ? subscription : selectSubscriptionFallback(state);
};

var selectSubscriptionFallback = exports.selectSubscriptionFallback = function selectSubscriptionFallback(state) {
  var subscriptions = (0, _reverse3.default)((0, _sortBy3.default)(selectSubscriptions(state), 'startedAt'));

  return subscriptions.length > 0 ? (0, _find3.default)(subscriptions, { status: 'active' }) || subscriptions[0] : {};
};

var selectSubscriptionHasStarted = exports.selectSubscriptionHasStarted = function selectSubscriptionHasStarted(state, voomeProductId) {
  var subscription = selectSubscription(state, voomeProductId) || {};
  return subscription.startedAt ? true : false;
};

var selectHasNutritionSubscription = exports.selectHasNutritionSubscription = function selectHasNutritionSubscription(state) {
  return selectHasBundleSubscription(state) || selectHasSubscriptionWithSlug(state, 'voome-nutrition');
};

var selectHasWorkoutSubscription = exports.selectHasWorkoutSubscription = function selectHasWorkoutSubscription(state) {
  return selectHasBundleSubscription(state) || selectHasSubscriptionWithSlug(state, 'voome-workouts');
};

var selectHasBundleSubscription = exports.selectHasBundleSubscription = function selectHasBundleSubscription(state) {
  return selectHasSubscriptionWithSlug(state, 'voome-bundle');
};

var selectHasSubscriptionWithSlug = exports.selectHasSubscriptionWithSlug = function selectHasSubscriptionWithSlug(state, slug) {
  return !!(0, _findKey3.default)(selectSubscriptions(state), function (item) {
    return item.slug === slug;
  });
};

var selectHasWeeklySubscription = exports.selectHasWeeklySubscription = function selectHasWeeklySubscription(state) {
  return !!(0, _findKey3.default)(selectSubscriptions(state), function (item) {
    return item.isWeekly;
  });
};

var selectHasProgramSubscription = exports.selectHasProgramSubscription = function selectHasProgramSubscription(state) {
  return !!(0, _findKey3.default)(selectSubscriptions(state), function (item) {
    return !item.isWeekly;
  });
};

var selectIsMatched = exports.selectIsMatched = function selectIsMatched(state, tags) {
  var preferenceNames = selectMember(state).voomeProfile.preferenceNames;

  return (0, _intersection3.default)(tags, preferenceNames).length >= 3;
};

var selectNutritionQuestions = exports.selectNutritionQuestions = function selectNutritionQuestions(state) {
  var member = selectMember(state);

  return member.voomeProfile ? _constants.PROFILE_NUTRITION.map(function (item) {
    return mapAnswerToQuestion(item, member.voomeProfile.preferences);
  }) : [];
};

var selectWorkoutQuestions = exports.selectWorkoutQuestions = function selectWorkoutQuestions(state) {
  var member = selectMember(state);

  return member.voomeProfile ? _constants.PROFILE_WORKOUT.map(function (item) {
    return mapAnswerToQuestion(item, member.voomeProfile.preferences);
  }) : [];
};

var selectPrintTooltip = exports.selectPrintTooltip = function selectPrintTooltip(state) {
  var _selectSubscription2 = selectSubscription(state),
      canPrint = _selectSubscription2.canPrint,
      printsRemained = _selectSubscription2.printsRemained,
      isTrial = _selectSubscription2.isTrial;

  return canPrint && isTrial && 'You can print ' + printsRemained + ' more times in your free trial week.';
};

var selectIsProductLowFodmap = exports.selectIsProductLowFodmap = function selectIsProductLowFodmap(state, voomeProductId) {
  var subscription = selectSubscription(state, voomeProductId) || {};

  return (0, _has3.default)(subscription.productDietaryPreference, 'lowFODMAP') && subscription.productDietaryPreference.lowFODMAP;
};

var selectIsProductWithRequirements = exports.selectIsProductWithRequirements = function selectIsProductWithRequirements(state, voomeProductId) {
  var subscription = selectSubscription(state, voomeProductId) || {};
  var dietaryPreference = (0, _filter3.default)(subscription.productDietaryPreference, function (p) {
    return p === true;
  });

  return dietaryPreference && dietaryPreference.length > 0 || (0, _includes3.default)(_constants.SPECIAL_REQUIREMENT_PRODUCTS, subscription.slug);
};

// Helpers
var mapAnswerToQuestion = function mapAnswerToQuestion(item, preferences) {
  var answers = (0, _map3.default)((0, _filter3.default)(preferences[item.key], 'active'), 'name');

  return _extends({}, item, {
    answer: answers.length ? answers.join(', ') : 'Not Set'
  });
};

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case FETCH:
    case UPDATE:
    case RESET_PASSWORD_INIT:
    case RESET_PASSWORD_CREATE:
    case RESET_PASSWORD_UPDATE:
    case DOWNGRADE_SUBSCRIPTION:
    case UPGRADE_SUBSCRIPTION:
    case CANCEL_SUBSCRIPTION:
    case RESUME_SUBSCRIPTION:
      return _extends({}, state, {
        error: false,
        success: false,
        isLoading: true,
        message: ''
      });

    case FETCH_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        error: false,
        success: true,
        result: payload.result,
        entities: _extends({}, state.entities, payload.entities)
      });

    case FETCH_INVOICES_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        error: false,
        success: true,
        entities: _extends({}, state.entities, {
          invoices: payload.data
        })
      });

    case FETCH_ERROR:
    case UPDATE_ERROR:
    case RESET_PASSWORD_ERROR:
      return _extends({}, state, {
        error: true,
        success: false,
        isLoading: false,
        message: payload.message
      });

    case UPDATE_FIELD:
      var _payload$key$split = payload.key.split('.'),
          _payload$key$split2 = _slicedToArray(_payload$key$split, 3),
          key1 = _payload$key$split2[0],
          key2 = _payload$key$split2[1],
          key3 = _payload$key$split2[2];

      var memberId = state.result;
      var member = state.entities.members[memberId];

      return _extends({}, state, {
        entities: _extends({}, state.entities, {
          members: _extends({}, state.entities.members, _defineProperty({}, memberId, _extends({}, member, _defineProperty({}, key1, key2 ? key3 ? _extends({}, member[key1], _defineProperty({}, key2, _extends({}, member[key1][key2], _defineProperty({}, key3, payload.value)))) : _extends({}, member[key1], _defineProperty({}, key2, payload.value)) : payload.value))))
        })
      });

    case RESET_PASSWORD_SUCCESS:
      return _extends({}, state, {
        error: false,
        success: true,
        isLoading: false,
        message: payload.message
      });

    case CANCEL_SUBSCRIPTION_ERROR:
      return _extends({}, state, {
        error: true,
        success: false,
        isLoading: false,
        message: 'Cancellation failed. Please try again'
      });

    case MIGRATE_SUBSCRIPTION_SUCCESS:
      return _extends({}, state, {
        error: false,
        success: true,
        isLoading: false,
        message: '',
        entities: _extends({}, state.entities, {
          subscriptions: _extends({}, state.entities.subscriptions, _defineProperty({}, payload.id, _extends({}, state.entities.subscriptions[payload.id], payload)))
        })
      });

    case MIGRATE_SUBSCRIPTION_ERROR:
      return _extends({}, state, {
        error: true,
        success: false,
        isLoading: false,
        message: 'An error occurred changing your subscription. Reload the page and please try again'
      });

    default:
      return state;
  }
}

/***/ }),

/***/ "1YcG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProfileFieldsWorkout = exports.ProfileFieldsPassword = exports.ProfileFieldsNutrition = exports.ProfileFieldsMore = exports.ProfileFieldsDowngrade = exports.ProfileFieldsCancel = exports.ProfileFields = exports.ProfileContainer = exports.ProfileBilling = exports.ProfileActions = undefined;

var _ProfileActions = __webpack_require__("iaqb");

Object.defineProperty(exports, 'ProfileActions', {
  enumerable: true,
  get: function get() {
    return _ProfileActions.ProfileActions;
  }
});

var _ProfileBilling = __webpack_require__("Opf4");

Object.defineProperty(exports, 'ProfileBilling', {
  enumerable: true,
  get: function get() {
    return _ProfileBilling.ProfileBilling;
  }
});

var _ProfileContainer = __webpack_require__("xv9u");

Object.defineProperty(exports, 'ProfileContainer', {
  enumerable: true,
  get: function get() {
    return _ProfileContainer.ProfileContainer;
  }
});

var _ProfileFields = __webpack_require__("cCvp");

Object.defineProperty(exports, 'ProfileFields', {
  enumerable: true,
  get: function get() {
    return _ProfileFields.ProfileFields;
  }
});

var _ProfileFieldsCancel = __webpack_require__("48Ir");

Object.defineProperty(exports, 'ProfileFieldsCancel', {
  enumerable: true,
  get: function get() {
    return _ProfileFieldsCancel.ProfileFieldsCancel;
  }
});

var _ProfileFieldsDowngrade = __webpack_require__("5I3b");

Object.defineProperty(exports, 'ProfileFieldsDowngrade', {
  enumerable: true,
  get: function get() {
    return _ProfileFieldsDowngrade.ProfileFieldsDowngrade;
  }
});

var _ProfileFieldsMore = __webpack_require__("DOwP");

Object.defineProperty(exports, 'ProfileFieldsMore', {
  enumerable: true,
  get: function get() {
    return _ProfileFieldsMore.ProfileFieldsMore;
  }
});

var _ProfileFieldsNutrition = __webpack_require__("Rza+");

Object.defineProperty(exports, 'ProfileFieldsNutrition', {
  enumerable: true,
  get: function get() {
    return _ProfileFieldsNutrition.ProfileFieldsNutrition;
  }
});

var _ProfileFieldsPassword = __webpack_require__("0Uha");

Object.defineProperty(exports, 'ProfileFieldsPassword', {
  enumerable: true,
  get: function get() {
    return _ProfileFieldsPassword.ProfileFieldsPassword;
  }
});

var _ProfileFieldsWorkout = __webpack_require__("JU/9");

Object.defineProperty(exports, 'ProfileFieldsWorkout', {
  enumerable: true,
  get: function get() {
    return _ProfileFieldsWorkout.ProfileFieldsWorkout;
  }
});

__webpack_require__("cCsY");

/***/ }),

/***/ "1ejn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// Confetti canvas animation
// https://codepen.io/linrock/pen/Amdhr
// Usage: confettiWidget(<wrappername>);
var confettiWidget = exports.confettiWidget = function confettiWidget(wrapperID) {
  var Confetti = void 0,
      canvas = void 0,
      confetti = void 0,
      context = void 0,
      drawCircle = void 0,
      i = void 0,
      range = void 0,
      resizeWindow = void 0,
      wrapper = void 0,
      xpos = void 0;

  var NUM_CONFETTI = 50;
  var COLORS = [[85, 71, 106], [174, 61, 99], [219, 56, 83], [244, 92, 68], [248, 182, 70]];
  var PI_2 = 2 * Math.PI;

  var wrapID = typeof wrapperID !== 'undefined' ? wrapperID : 'confetti-widget';
  wrapper = document.getElementById(wrapID);

  if (!wrapper) {
    return;
  }

  canvas = document.createElement('canvas');
  canvas.className = 'confetti-canvas';
  wrapper.appendChild(canvas);
  wrapper.className = 'confetti-widget';
  context = canvas.getContext('2d');

  // ------------------------------------------
  // Window events
  window.w = 0;
  window.h = 0;

  resizeWindow = function resizeWindow() {
    if ((typeof wrapper === 'undefined' ? 'undefined' : _typeof(wrapper)) !== undefined) {
      window.w = canvas.width = wrapper.offsetWidth;
      return window.h = canvas.height = wrapper.offsetHeight;
    }
  };

  window.addEventListener('resize', resizeWindow, false);

  // ------------------------------------------
  // Util
  range = function range(a, b) {
    return (b - a) * Math.random() + a;
  };

  drawCircle = function drawCircle(x, y, r, style) {
    context.beginPath();
    context.arc(x, y, r, 0, PI_2, false);
    context.fillStyle = style;
    return context.fill();
  };

  xpos = 0.5;

  // document.onmousemove = function(e) {
  //   return xpos = e.pageX / w;
  // };

  // ------------------------------------------
  // Animation frame
  window.requestAnimationFrame = function () {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
      return window.setTimeout(callback, 1000 / 60);
    };
  }();

  // ------------------------------------------
  // Confetti
  Confetti = function () {
    function Confetti() {
      this.style = COLORS[~~range(0, 5)];
      this.rgb = 'rgba(' + this.style[0] + ',' + this.style[1] + ',' + this.style[2];
      this.r = ~~range(2, 6);
      this.r2 = 2 * this.r;
      this.replace();
    }

    Confetti.prototype.replace = function () {
      this.opacity = 0;
      this.dop = 0.03 * range(1, 4);
      this.x = range(-this.r2, w - this.r2);
      this.y = range(-20, h - this.r2);
      this.xmax = w - this.r;
      this.ymax = h - this.r;
      this.vx = range(0, 2) + 8 * xpos - 5;
      return this.vy = 0.7 * this.r + range(-1, 1);
    };

    Confetti.prototype.draw = function () {
      var ref;
      this.x += this.vx;
      this.y += this.vy;
      this.opacity += this.dop;
      if (this.opacity > 1) {
        this.opacity = 1;
        this.dop *= -1;
      }
      if (this.opacity < 0 || this.y > this.ymax) {
        this.replace();
      }
      if (!(0 < (ref = this.x) && ref < this.xmax)) {
        this.x = (this.x + this.xmax) % this.xmax;
      }
      return drawCircle(~~this.x, ~~this.y, this.r, this.rgb + ',' + this.opacity + ')');
    };

    return Confetti;
  }();

  confetti = function () {
    var j, ref, results;
    results = [];
    for (i = j = 1, ref = NUM_CONFETTI; 1 <= ref ? j <= ref : j >= ref; i = 1 <= ref ? ++j : --j) {
      results.push(new Confetti());
    }
    return results;
  }();

  // ------------------------------------------
  // Canvas animation step
  var step = function step() {
    var c, j, len, results;
    requestAnimationFrame(step);
    context.clearRect(0, 0, w, h);
    results = [];
    for (j = 0, len = confetti.length; j < len; j++) {
      c = confetti[j];
      results.push(c.draw());
    }
    return results;
  };

  step();

  return {
    startAnimation: function startAnimation() {
      return setTimeout(resizeWindow, 1000);
    },

    cancelAnimation: function cancelAnimation() {
      window.cancelRequestAnimFrame = function () {
        return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.mozCancelRequestAnimationFrame || window.oCancelRequestAnimationFrame || window.msCancelRequestAnimationFrame || clearTimeout;
      }();

      for (var i = 1; i < 99999; i++) {
        window.cancelRequestAnimFrame(i);
      }
    }
  };
};

/***/ }),

/***/ "1nGQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Carousel = undefined;

var _Carousel = __webpack_require__("Q90x");

Object.defineProperty(exports, 'Carousel', {
  enumerable: true,
  get: function get() {
    return _Carousel.Carousel;
  }
});

__webpack_require__("vK7p");

/***/ }),

/***/ "1sOY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WelcomeStepProfile = exports.WelcomeStepProfile = {
  bindings: {
    member: '<',
    isLoading: '<',
    onSubmit: '&',
    onUpdate: '&',
    onUploadComplete: '&'
  },

  template: '\n    <div class="welcome-step-profile py-4">\n      <h1 class="h2 text-center text-white mb-4">\n        Create your profile\n      </h1>\n      <section class="theme-light p-3 mb-5">\n        <form class="voome-form"\n          name="form"\n          ng-submit="$ctrl.onSubmit({ data: $ctrl.member })"\n          novalidate>\n          <div class="mb-3">\n            <profile-container is-editing="true">\n              <profile-fields\n                form="form"\n                member="$ctrl.member"\n                is-editing="true"\n                on-update="$ctrl.onUpdate({ key: key, value: value })"\n                on-upload-complete="$ctrl.onUploadComplete()">\n              </profile-fields>\n            </profile-container>\n          </div>\n          <div class="mb-3">\n            <profile-container is-editing="true">\n              <profile-fields-more\n                form="form"\n                member="$ctrl.member"\n                is-editing="true"\n                on-update="$ctrl.onUpdate({ key: key, value: value })">\n              </profile-fields-more>\n            </profile-container>\n          </div>\n          <div class="text-center">\n            <button-primary\n              ng-type="submit"\n              ng-disabled="$ctrl.isLoading || form.$invalid">\n              <spinner is-loading="$ctrl.isLoading">\n                Next\n              </spinner>\n            </button-primary>\n          </div>\n        </form>\n      </section>\n    </div>'
};

/***/ }),

/***/ "1sRP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1yqr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgramWeek = undefined;

var _reduxUiRouter = __webpack_require__("Zb/7");

var _utils = __webpack_require__("0xDb");

var _videoResume = __webpack_require__("jkIW");

var _reviews = __webpack_require__("jnnR");

var _member = __webpack_require__("1OIp");

var _product = __webpack_require__("5AvL");

var _mealPlan = __webpack_require__("KLwp");

var _completions = __webpack_require__("XI2E");

var ProgramWeek = exports.ProgramWeek = {
  template: '\n    <div class="program-week"\n      ng-init="$ctrl.showComments = false"\n      ng-if="$ctrl.member">\n      <program-nav></program-nav>\n      <div class="overview-row"\n        ng-class="{\n          \'mb-0\': $ctrl.week.weeklyVideos.length && !$ctrl.showComments && $ctrl.hasStarted\n        }">\n        <program-week-overview\n          is-loading="$ctrl.reviewsIsLoading"\n          heading="$ctrl.week.title"\n          description="$ctrl.week.prepTips"\n          video-id="$ctrl.week.introVideo.brightcoveId"\n          comments-count="$ctrl.reviewsStats.reviewsCount"\n          comments-new-count="$ctrl.reviewsStats.newReviewsCount"\n          replies-count="$ctrl.reviewsStats.repliesCount"\n          toggle-comments="$ctrl.onToggleComments()">\n        </program-week-overview>\n      </div>\n      <div class="program-section-row bg-gray-100 border border-y"\n        id="comments"\n        ng-show="$ctrl.showComments">\n        <div class="py-3 py-md-5 container" ng-if="$ctrl.week.introVideo">\n          <reviews\n            wording-singular="Comment"\n            wording-plural="Comments"\n            reviewable-type="BrightcoveVideo"\n            reviewable-id="$ctrl.week.introVideo.id"\n            form-top="true"\n            on-cancel="$ctrl.showComments = false">\n          </reviews>\n        </div>\n      </div>\n      <program-not-started has-started="$ctrl.hasStarted">\n        <div class="mb-4" ng-if="$ctrl.week.weeklyVideos.length">\n          <program-week-videos\n            week-number="$ctrl.week.weekNumber"\n            items="$ctrl.week.weeklyVideos"\n            video-resume=$ctrl.videoResume>\n          </program-week-videos>\n        </div>\n        <div class="d-flex"\n          ng-class="{\n            \'flex-column\': !$ctrl.isNutrition,\n            \'flex-column-reverse\': $ctrl.isNutrition\n          }">\n          <div class="bg-gray-100 border border-y"\n            ng-class="{ \'program-section-row\': !$ctrl.isNutrition }">\n            <program-week-workouts\n              completions="$ctrl.completions.items.workouts"\n              member="$ctrl.member"\n              voome-product-id="$ctrl.voomeProductId"\n              week-number="$ctrl.week.weekNumber"\n              items="$ctrl.workouts"\n              on-card-click="$ctrl.stateGo(\'program.week.workout\', { id, exercisePlanId })"\n              on-completer-toggle="$ctrl.workoutToggleComplete(exercisePlanId, dayId, voomeProductId, weekNumber, title, isComplete)">\n            </program-week-workouts>\n          </div>\n          <div class="bg-gray-100 border border-y"\n            ng-class="{ \'program-section-row\': $ctrl.isNutrition }">\n            <program-week-meal-plan\n              completions="$ctrl.completions.items.meals"\n              program="$ctrl.program"\n              week-number="$ctrl.week.weekNumber"\n              is-loading="$ctrl.mealPlanIsLoading"\n              meal-plan-id="$ctrl.mealPlanId"\n              meal-plan-list="$ctrl.mealPlanList"\n              on-card-click="$ctrl.stateGo(\'program.week.recipe\', { recipeId })"\n              on-completer-toggle="$ctrl.mealPlanToggleComplete(mealPlanId, dayString, voomeProductId, weekNumber, title, isComplete)">\n            </program-week-meal-plan>\n          </div>\n        </div>\n      </program-not-started>\n      <completer-notification\n        week-number="$ctrl.week.weekNumber"\n        count="$ctrl.completions.total"\n        total="$ctrl.workouts.length + $ctrl.week.mealPlan.daysCount"\n        heading="$ctrl.recentlyCompleted.title">\n      </completer-notification>\n    </div>',

  controller: ["$ngRedux", "$location", "$anchorScroll", function controller($ngRedux, $location, $anchorScroll) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        // Fetch the meal plan for the week.
        if (!this.mealPlanList.length) {
          var _$ngRedux$getState = $ngRedux.getState(),
              product = _$ngRedux$getState.product,
              router = _$ngRedux$getState.router;

          var weekNumber = router.currentParams.weekNumber;


          this.fetchMealPlanForWeek({
            level: this.level,
            mealPlanId: this.mealPlanId,
            memberId: this.member.id,
            subscriptionId: this.subscriptionId,
            weekId: this.week.id
          });
        }

        // Fetch review stats for the intro video.
        this.fetchReviewsStats(this.member.id, this.voomeProductId, this.week.introVideo && this.week.introVideo.id, 'BrightcoveVideo');
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();
        this.clearComplete();
      },
      onToggleComments: function onToggleComments() {
        this.showComments = !this.showComments;

        if (this.showComments) {
          $location.hash('comments');
          $anchorScroll();
        } else {
          $location.hash(null);
        }
      },
      mapState: function mapState(state) {
        var reviews = state.reviews,
            router = state.router,
            mealPlan = state.mealPlan,
            videoResume = state.videoResume,
            member = state.member,
            product = state.product;
        var _router$currentParams = router.currentParams,
            voomeProductId = _router$currentParams.voomeProductId,
            weekNumber = _router$currentParams.weekNumber;

        var program = (0, _product.selectProduct)(product);
        var week = (0, _product.selectWeek)(product, weekNumber);
        var isNutrition = program.productMeta.programType === 'Nutrition';

        var mealPlanId = (0, _mealPlan.selectMealPlanIdForWeek)(mealPlan, week && week.id) || (0, _product.selectDefaultMealPlanId)(product, weekNumber, (0, _member.selectMemberIsVegetarian)(member));

        return {
          isNutrition: isNutrition,
          mealPlanId: mealPlanId,
          program: program,
          voomeProductId: voomeProductId,

          // Member
          hasStarted: (0, _member.selectSubscriptionHasStarted)(member, voomeProductId),
          level: (0, _member.selectMemberLevel)(member),
          member: (0, _member.selectMember)(member),
          subscriptionId: (0, _member.selectSubscription)(member).id,

          // Program
          workouts: (0, _product.selectWeekWorkouts)(product, weekNumber),
          week: (0, _product.selectWeek)(product, weekNumber),

          // Completions
          completions: (0, _completions.selectCompletions)(state, weekNumber),
          recentlyCompleted: (0, _completions.selectRecentlyCompleted)(state),

          // Meal Plan
          mealPlanIsLoading: mealPlan.isLoading,
          mealPlanList: (0, _mealPlan.selectMealPlanList)(mealPlan, mealPlanId),

          // Reviews
          reviewsStats: (0, _reviews.selectReviewsStats)(reviews),
          reviewsIsLoading: reviews.isLoading,

          // Videos
          videoResume: (0, _videoResume.selectVideos)(videoResume)
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          clearComplete: _completions.clearComplete,
          fetchMealPlan: _mealPlan.fetchMealPlan,
          fetchMealPlanSwaps: _mealPlan.fetchMealPlanSwaps,
          fetchMealPlanForWeek: _mealPlan.fetchMealPlanForWeek,
          fetchReviewsStats: _reviews.fetchReviewsStats,
          mealPlanToggleComplete: _completions.mealPlanToggleComplete,
          workoutToggleComplete: _completions.workoutToggleComplete,
          stateGo: _reduxUiRouter.stateGo
        };
      }
    };
  }]
};

/***/ }),

/***/ "2FJL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var toMinutes = exports.toMinutes = function toMinutes() {
  return function (value) {
    return Math.round(value / 60);
  };
};

/***/ }),

/***/ "2O33":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExerciseSet = exports.Exercise = undefined;

var _Exercise = __webpack_require__("7PQy");

Object.defineProperty(exports, 'Exercise', {
  enumerable: true,
  get: function get() {
    return _Exercise.Exercise;
  }
});

var _ExerciseSet = __webpack_require__("K8ga");

Object.defineProperty(exports, 'ExerciseSet', {
  enumerable: true,
  get: function get() {
    return _ExerciseSet.ExerciseSet;
  }
});

__webpack_require__("MZTQ");

/***/ }),

/***/ "2P+a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rootReducer = exports.rootLogic = undefined;

var _redux = __webpack_require__("2KeS");

var _reduxUiRouter = __webpack_require__("Zb/7");

var _auth = __webpack_require__("wnLK");

var _auth2 = _interopRequireDefault(_auth);

var _completions = __webpack_require__("XI2E");

var _completions2 = _interopRequireDefault(_completions);

var _favourite = __webpack_require__("GfAe");

var _favourite2 = _interopRequireDefault(_favourite);

var _filters = __webpack_require__("ZTBt");

var _filters2 = _interopRequireDefault(_filters);

var _mealPlan = __webpack_require__("KLwp");

var _mealPlan2 = _interopRequireDefault(_mealPlan);

var _member = __webpack_require__("1OIp");

var _member2 = _interopRequireDefault(_member);

var _product = __webpack_require__("5AvL");

var _product2 = _interopRequireDefault(_product);

var _recipe = __webpack_require__("mew7");

var _recipe2 = _interopRequireDefault(_recipe);

var _recipesSimilar = __webpack_require__("WQxS");

var _recipesSimilar2 = _interopRequireDefault(_recipesSimilar);

var _redirect = __webpack_require__("8G1E");

var _reviews = __webpack_require__("jnnR");

var _reviews2 = _interopRequireDefault(_reviews);

var _search = __webpack_require__("j94E");

var _search2 = _interopRequireDefault(_search);

var _shoppingList = __webpack_require__("as7P");

var _shoppingList2 = _interopRequireDefault(_shoppingList);

var _signup = __webpack_require__("FQ9i");

var _signup2 = _interopRequireDefault(_signup);

var _theme = __webpack_require__("ZID5");

var _theme2 = _interopRequireDefault(_theme);

var _videoResume = __webpack_require__("jkIW");

var _videoResume2 = _interopRequireDefault(_videoResume);

var _workout = __webpack_require__("Toxe");

var _workout2 = _interopRequireDefault(_workout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Combine logic
var rootLogic = exports.rootLogic = [].concat(_toConsumableArray(_auth.authLogic), _toConsumableArray(_completions.completionsLogic), _toConsumableArray(_favourite.favouriteLogic), _toConsumableArray(_filters.filtersLogic), _toConsumableArray(_mealPlan.mealPlanLogic), _toConsumableArray(_member.memberLogic), _toConsumableArray(_product.productLogic), _toConsumableArray(_signup.signupLogic), _toConsumableArray(_recipe.recipeLogic), _toConsumableArray(_recipesSimilar.recipesSimilarLogic), _toConsumableArray(_redirect.redirectLogic), _toConsumableArray(_reviews.reviewsLogic), _toConsumableArray(_search.searchLogic), _toConsumableArray(_shoppingList.shoppingListLogic), _toConsumableArray(_videoResume.videoResumeLogic), _toConsumableArray(_workout.workoutLogic));

// Combine reducers
var rootReducer = exports.rootReducer = (0, _redux.combineReducers)({
  auth: _auth2.default,
  completions: _completions2.default,
  favourite: _favourite2.default,
  filters: _filters2.default,
  mealPlan: _mealPlan2.default,
  member: _member2.default,
  product: _product2.default,
  recipe: _recipe2.default,
  recipesSimilar: _recipesSimilar2.default,
  reviews: _reviews2.default,
  router: _reduxUiRouter.router,
  search: _search2.default,
  shoppingList: _shoppingList2.default,
  signup: _signup2.default,
  theme: _theme2.default,
  videoResume: _videoResume2.default,
  workout: _workout2.default
});

/***/ }),

/***/ "2ZKt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PaginationRow = __webpack_require__("RwmI");

Object.defineProperty(exports, 'PaginationRow', {
  enumerable: true,
  get: function get() {
    return _PaginationRow.PaginationRow;
  }
});

/***/ }),

/***/ "2ZXJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SignupSelectorProgram = exports.SignupSelectorProgram = {
  bindings: {
    isDisabled: '<',
    hasDropdown: '<',
    product: '<',
    products: '<',
    onChange: '&'
  },

  template: '\n    <div class="signup-selector-program px-3 px-md-5">\n      <div class="dropdown mb-4"\n        ng-class="{\n          \'signup-product--static\': !$ctrl.hasDropdown,\n          \'disabled\': $ctrl.isDisabled\n        }">\n        <a class="signup-tile dropdown-toggler d-block border rounded w-100"\n          data-toggle="dropdown">\n          <signup-tile-program\n            product="$ctrl.product"\n            ng-show="$ctrl.product">\n          </signup-tile-program>\n          <div ng-hide="$ctrl.product" class="px-0 py-1 p-sm-3">\n            <span class="h2 text-black font-weight-regular">\n              Choose a program\n            </span>\n          </div>\n          <i class="fa fa-chevron-down"></i>\n        </a>\n        <div class="dropdown-menu border rounded w-100"\n          ng-show="$ctrl.hasDropdown && !$ctrl.isDisabled">\n          <div class="dropdown-item signup-tile"\n            ng-repeat="product in $ctrl.products track by $index"\n            ng-class="{ active: $ctrl.product.id === product.id }"\n            ng-click="$ctrl.onChange({ voomeProductId: product.id })">\n            <signup-tile-program product="product"></signup-tile-program>\n          </div>\n        </div>\n      </div>\n    </div>'
};

/***/ }),

/***/ "2ft5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecipeRow = exports.RecipePreview = exports.RecipeOptions = exports.RecipeDetail = undefined;

var _RecipeDetail = __webpack_require__("obSp");

Object.defineProperty(exports, 'RecipeDetail', {
  enumerable: true,
  get: function get() {
    return _RecipeDetail.RecipeDetail;
  }
});

var _RecipeOptions = __webpack_require__("ehyk");

Object.defineProperty(exports, 'RecipeOptions', {
  enumerable: true,
  get: function get() {
    return _RecipeOptions.RecipeOptions;
  }
});

var _RecipePreview = __webpack_require__("gPEb");

Object.defineProperty(exports, 'RecipePreview', {
  enumerable: true,
  get: function get() {
    return _RecipePreview.RecipePreview;
  }
});

var _RecipeRow = __webpack_require__("pC/s");

Object.defineProperty(exports, 'RecipeRow', {
  enumerable: true,
  get: function get() {
    return _RecipeRow.RecipeRow;
  }
});

__webpack_require__("1LWp");

/***/ }),

/***/ "2kBn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ImageCircle = exports.ImageCircle = {
  bindings: {
    src: '<'
  },

  template: '\n    <div class="image-circle">\n      <image-background src="$ctrl.src"></image-background>\n    </div>'
};

/***/ }),

/***/ "2kdB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.workoutsHack = undefined;

var _reduxUiRouter = __webpack_require__("Zb/7");

var _utils = __webpack_require__("0xDb");

var _member = __webpack_require__("1OIp");

var _workout = __webpack_require__("Toxe");

var _favourite = __webpack_require__("GfAe");

var workoutsHack = exports.workoutsHack = {
  template: '\n    <div class="pb-3">\n      <collection-header\n        collection="$ctrl.collection"\n        is-loading="$ctrl.isLoading">\n      </collection-header>\n      <div class="container pb-3">\n        <div class="row mb-4">\n          <div class="col-md-6 pt-3"\n            ng-repeat="item in $ctrl.collection.workouts track by $index">\n            <card-workout\n              description="item.collectionDescriptionHtml"\n              member="$ctrl.member"\n              type="horizontal"\n              workout="item"\n              on-click="$ctrl.onClick($ctrl.hackId, item)">\n            </card-workout>\n          </div>\n        </div>\n      </div>\n    </div>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var _this = this;

        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        // Wait for parent hacks collection to finish loading before fetching
        this.interval = setInterval(function () {
          if (!_this.isLoading) {
            clearInterval(_this.interval);

            if (!_this.collection || !_this.collection.workouts.length) {
              _this.fetchWorkoutCollection(_this.hackId);
            }
          }
        }, 500);
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();

        if (this.interval) {
          clearInterval(this.interval);
        }
      },
      onClick: function onClick(hackId, _ref) {
        var id = _ref.id,
            exercisePlanId = _ref.exercisePlanId,
            name = _ref.name;

        this.stateGo('workouts.hacks.exercise', {
          hackId: hackId,
          id: id,
          exercisePlanId: exercisePlanId
        });

        _utils.anchorStorage.set($ngRedux.getState(), name);
      },
      mapState: function mapState(_ref2) {
        var favourite = _ref2.favourite,
            member = _ref2.member,
            workout = _ref2.workout,
            router = _ref2.router;
        var hackId = router.currentParams.hackId;


        return {
          hackId: hackId,
          isLoading: workout.isLoading,
          member: (0, _member.selectMember)(member),
          collection: (0, _favourite.mapIsFavouriteWorkouts)((0, _workout.selectWorkoutCollection)(workout, hackId), (0, _favourite.selectFavouriteWorkoutIds)(favourite))
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          fetchWorkoutCollection: _workout.fetchWorkoutCollection,
          stateGo: _reduxUiRouter.stateGo
        };
      }
    };
  }]
};

/***/ }),

/***/ "2zOm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MealPlanRecipe = exports.MealPlanRecipe = {
  bindings: {
    meal: '<',
    isActive: '<',
    onPreview: '&',
    onRemove: '&'
  },

  template: '\n    <div class="meal-plan-recipe-row">\n      <recipe-row\n        recipe="$ctrl.meal.recipe"\n        left-overs="$ctrl.meal.leftOvers"\n        cookup="$ctrl.meal.cookup"\n        on-preview="$ctrl.onPreview({ recipe: recipe })">\n        <button class="btn btn-link btn-sm p-0 ml-2 border-0"\n          type="button"\n          ng-show="$ctrl.isActive"\n          ng-click="$ctrl.onRemove()">\n          <i class="fa fa-2x fa-times-circle text-danger m-0"></i>\n        </button>\n      </recipe-row>\n    </div>'
};

/***/ }),

/***/ "3/7M":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DashboardCarousel = exports.DashboardCarousel = {
  transclude: {
    carouselBody: '?dashboardCarouselBody',
    carouselFooter: '?dashboardCarouselFooter',
    carouselHeader: '?dashboardCarouselHeader'
  },

  template: '\n    <div class="dashboard-carousel pt-3 bg-white">\n      <div class="container pt-3 pt-md-4">\n        <div class="dashboard-carousel-header"\n          ng-transclude="carouselHeader">\n        </div>\n        <div class="dashboard-carousel-body mb-md-3"\n          ng-transclude="carouselBody">\n        </div>\n        <div class="dashboard-carousel-footer">\n          <div class="d-flex justify-content-center align-items-center pb-3"\n            ng-transclude="carouselFooter">\n          </div>\n        </div>\n      </div>\n    </div>'
};

/***/ }),

/***/ "39a0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Bl9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3ITV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SearchOrder = exports.SearchOrder = {
  bindings: {
    list: '<',
    title: '@',
    onClick: '&'
  },

  template: '\n    <div class="search-order btn-group d-flex justify-content-between align-items-center">\n      <small>{{ $ctrl.title }}</small>\n      <button class="btn btn-link dropdown-toggle d-flex align-items-center pr-1"\n        type="button"\n        data-toggle="dropdown">\n        <small ng-repeat="item in $ctrl.list | filter: { checked: true }">\n          {{ item.name }}\n        </small>\n      </button>\n      <div class="dropdown-menu dropdown-menu-right">\n        <button class="btn-link dropdown-item btn btn-link rounded-0"\n          type="button"\n          ng-repeat="item in $ctrl.list | filter: { checked: false }"\n          ng-click="$ctrl.onClick({ value: item.value })">\n          {{ item.name }}\n        </button>\n      </div>\n    </div>'
};

/***/ }),

/***/ "3nT6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FavouritesVideos = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxUiRouter = __webpack_require__("Zb/7");

var _utils = __webpack_require__("0xDb");

var _member = __webpack_require__("1OIp");

var _favourite = __webpack_require__("GfAe");

var FavouritesVideos = exports.FavouritesVideos = {
  template: '\n    <ui-view>\n      <div class="favourite-videos py-3 py-md-4">\n        <div class="container pt-1 pb-3">\n          <div class="row pt-2">\n            <div class="col-sm-6 col-lg-4 pb-4"\n              ng-repeat="item in $ctrl.pagination.result track by $index">\n              <card-video\n                heading="item.title"\n                duration-in-mins="item.time"\n                image="item.thumbnailUrl.large"\n                is-favourite="item.isFavourite"\n                on-click="$ctrl.onClick(item)"\n                on-favourite="$ctrl.toggleFavouriteVideo({\n                  memberId: $ctrl.member.id,\n                  videoId: item.id,\n                  isFavourite: item.isFavourite\n                })">\n              </card-video>\n            </div>\n            <div class="col-sm-5 mx-auto mt-3"\n              ng-hide="$ctrl.pagination.result.length">\n              <favourite-no-result\n                is-loading="$ctrl.isLoading">\n              </favourite-no-result>\n            </div>\n          </div>\n          <pagination-row\n            on-update-param="$ctrl.onUpdatePage(value)"\n            pagination="$ctrl.pagination">\n          </pagination-row>\n        </div>\n      </div>\n    </ui-view>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        if (this.shouldFetch) {
          this.fetchFavouriteVideos(this.params);
        }
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();
      },
      onClick: function onClick(_ref) {
        var id = _ref.id,
            title = _ref.title;

        this.stateGo('favourites.videos.detail', {
          videoId: id,
          page: undefined,
          order: undefined
        });

        _utils.anchorStorage.set($ngRedux.getState(), title);
      },
      onUpdatePage: function onUpdatePage(page) {
        this.stateGo('favourites.videos', { page: page });
      },
      mapState: function mapState(_ref2) {
        var favourite = _ref2.favourite,
            member = _ref2.member,
            router = _ref2.router;

        var stateMember = (0, _member.selectMember)(member);

        var params = _extends({}, router.currentParams, {
          memberId: stateMember.id
        });

        var pagination = (0, _favourite.selectFavouriteVideos)(favourite, params);
        var result = pagination.result;
        var isLoading = favourite.isLoading;


        return {
          isLoading: isLoading,
          pagination: pagination,
          params: params,
          member: stateMember,
          shouldFetch: (0, _favourite.selectFavouriteVideosReload)(favourite, result)
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          fetchFavouriteVideos: _favourite.fetchFavouriteVideos,
          stateGo: _reduxUiRouter.stateGo,
          toggleFavouriteVideo: _favourite.toggleFavouriteVideo
        };
      }
    };
  }]
};

/***/ }),

/***/ "3o3y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var IngredientsCheck = exports.IngredientsCheck = {
  bindings: {
    ingredient: '<',
    checked: '<'
  },

  template: '\n    <div\n      class="checklist-item py-1 py-md-0"\n      ng-class="{ \'checked\': $ctrl.checked }">\n      <i class="fa fa-li fa-check-square-o mt-1 mt-md-0"\n        ng-class="$ctrl.checked ? \'fa-check-square-o\' : \'fa-square-o\'">\n      </i>\n      <span>{{ $ctrl.ingredient.displayString }}</span>\n    </div>'
};

/***/ }),

/***/ "3w8S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MealPlanTags = undefined;

var _reject2 = __webpack_require__("YqDm");

var _reject3 = _interopRequireDefault(_reject2);

var _map2 = __webpack_require__("2247");

var _map3 = _interopRequireDefault(_map2);

var _filter2 = __webpack_require__("RyI1");

var _filter3 = _interopRequireDefault(_filter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isVegetarianOrSingle = function isVegetarianOrSingle(tag) {
  return (/vegetarian|single/i.test(tag)
  );
};

var firstCharacter = function firstCharacter(tag) {
  return tag[0];
};

var dietTags = function dietTags(tags) {
  return (0, _map3.default)((0, _filter3.default)(tags, isVegetarianOrSingle), firstCharacter).join(', ');
};

var regularTags = function regularTags(tags) {
  return (0, _map3.default)((0, _reject3.default)(tags, isVegetarianOrSingle), firstCharacter).join(', ');
};

var MealPlanTags = exports.MealPlanTags = {
  transclude: true,

  bindings: {
    tags: '<',
    type: '@'
  },

  template: '\n    <span class="meal-plan-tags" ng-show="$ctrl.tagNames !== \'\'">\n      <span class="px-1" ng-transclude></span>\n      {{ $ctrl.tagNames }}\n    </span>',

  controller: function controller() {
    return {
      $onInit: function $onInit() {
        this.tagNames = this.type === 'diet' ? dietTags(this.tags) : regularTags(this.tags);
      }
    };
  }
};

/***/ }),

/***/ "42VI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MealPlanDayCalories = exports.MealPlanDayCalories = {
  bindings: {
    day: '<',
    meals: '<',
    recipes: '<'
  },

  template: '{{ $ctrl.calories }} Cal',

  controller: function controller() {
    'ngInject';

    return {
      $onChanges: function $onChanges(changes) {
        this.calories = this.calculateCalories(this.day.meals, this.meals, this.recipes);
      },
      calculateCalories: function calculateCalories() {
        var mealIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var meals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var recipes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        return mealIds.reduce(function (sum, mealId) {
          var recipe = recipes[meals[mealId].recipeId];
          return sum + (recipe && recipe.caloriesPerServe || 0);
        }, 0);
      }
    };
  }
};

/***/ }),

/***/ "47WH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardBadgeFlame = undefined;

var _member = __webpack_require__("1OIp");

var CardBadgeFlame = exports.CardBadgeFlame = {
  bindings: {
    tags: '<'
  },

  template: '\n    <card-badge\n      icon="icon-voome-flame"\n      ng-if="$ctrl.isMatched">\n    </card-badge>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var _$ngRedux$getState = $ngRedux.getState(),
            member = _$ngRedux$getState.member;

        this.isMatched = (0, _member.selectIsMatched)(member, this.tags);
      }
    };
  }]
};

/***/ }),

/***/ "47dG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assetSrc = undefined;

var _memoize2 = __webpack_require__("zGZ6");

var _memoize3 = _interopRequireDefault(_memoize2);

var _settings = __webpack_require__("Ll2K");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var assetSrc = exports.assetSrc = (0, _memoize3.default)(function (path) {
  if (path && !/https?:\/\//.test(path)) {
    return '' + _settings.hosts.api + path;
  }

  return path;
});

/***/ }),

/***/ "48Ir":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ProfileFieldsCancel = exports.ProfileFieldsCancel = {
  bindings: {
    hasError: '<',
    message: '<',
    form: '<',
    reasons: '<',
    subscription: '<',
    onSubmit: '&',
    onCancel: '&'
  },

  template: '\n    <div class="profile-cancel">\n      <div class="row">\n        <div class="col-md-4">\n          <h5>Cancel Subscription</h5>\n          <p>Sorry to see you go.</p>\n          <p>\n            To cancel your subscription, please tell us why and then enter\n            your password.\n          </p>\n        </div>\n        <div class="col-md-8">\n          <alert type="danger" ng-show="$ctrl.hasError">\n            {{ $ctrl.message }}\n          </alert>\n          <form-group-row>\n            <form-group-left>\n              <form-label for="reason">\n                Reason\n              </form-label>\n            </form-group-left>\n            <form-group-right>\n              <form-select\n                form="$ctrl.form"\n                name="reasonAnswer"\n                required="true"\n                errors="{ required: \'This is a required field.\' }">\n                <option value="">-- Select a reason --</option>\n                <option\n                  value="{{ reason }}"\n                  ng-repeat="reason in $ctrl.reasons track by $index">\n                  {{ reason }}\n                </option>\n              </form-select>\n              <div class="mt-2"\n                ng-show="$ctrl.form.data.reasonAnswer === \'Another reason\'">\n                <form-textarea\n                  form="$ctrl.form"\n                  name="reasonOther"\n                  required="true"\n                  placeholder="In a few words, please tell us why."\n                  rows="4">\n                </form-textarea>\n              </div>\n            </form-group-right>\n          </form-group-row>\n          <hr>\n          <form-group-row>\n            <form-group-left>\n              <form-label for="password">\n                Password\n              </form-label>\n            </form-group-left>\n            <form-group-right>\n              <form-input\n                form="$ctrl.form"\n                type="password"\n                name="reasonPassword"\n                required="true"\n                errors="{ required: \'This is a required field.\' }">\n              </form-input>\n            </form-group-right>\n          </form-group-row>\n          <hr>\n          <p class="text-green-dark">\n            Cancellation will take effect at the end of your next billing period\n            - {{ $ctrl.subscription.nextBillingDate | date:\'dd/MM/yyyy\' }}.\n          </p>\n          <p>\n            Your Coaching Zone subscription will remain active until the end of your\n            <strong>current</strong> billing week. If you decide to reactivate\n            your subscription at a later date, you\'ll have full access to all\n            your content again.\n          </p>\n        </div>\n      </div>\n    </div>'
};

/***/ }),

/***/ "5AvL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchProduct = exports.getGraduationData = exports.selectProductBackParams = exports.selectWeekWorkouts = exports.selectWorkouts = exports.selectMealPlanIsDefault = exports.selectDefaultMealPlanId = exports.selectWeek = exports.selectWeeks = exports.selectProduct = exports.selectProducts = exports.productLogic = exports.initialState = undefined;

var _camelCase2 = __webpack_require__("NRb0");

var _camelCase3 = _interopRequireDefault(_camelCase2);

var _map2 = __webpack_require__("2247");

var _map3 = _interopRequireDefault(_map2);

var _find2 = __webpack_require__("kbi+");

var _find3 = _interopRequireDefault(_find2);

var _get2 = __webpack_require__("Q7hp");

var _get3 = _interopRequireDefault(_get2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;

var _reduxLogic = __webpack_require__("E0Bt");

var _normalizr = __webpack_require__("vNPR");

var _decorators = __webpack_require__("SPxS");

var _constants = __webpack_require__("qI5z");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Action Types
var FETCH = '@@app/product/FETCH';
var FETCH_SUCCESS = '@@app/product/FETCH_SUCCESS';
var FETCH_ERROR = '@@app/product/FETCH_ERROR';
var CANCEL = '@@app/product/CANCEL';

// Initial State
var initialState = exports.initialState = {
  entities: {
    products: {},
    weeks: {},
    workouts: {}
  },
  loading: false,
  result: 0
};

// Observables
var productfetchLogic = (0, _reduxLogic.createLogic)({
  type: FETCH,
  cancelType: CANCEL,
  processOptions: {
    successType: FETCH_SUCCESS,
    failType: FETCH_ERROR
  },
  process: function process(_ref) {
    var action = _ref.action,
        httpClient = _ref.httpClient;
    var _action$payload = action.payload,
        voomeProductId = _action$payload.voomeProductId,
        startedAt = _action$payload.startedAt;


    return httpClient.get('/v1/voome/products/' + voomeProductId).then(function (_ref2) {
      var data = _ref2.data;

      var workout = new _normalizr.schema.Entity('workouts');
      var week = new _normalizr.schema.Entity('weeks', { workouts: [workout] });
      var products = new _normalizr.schema.Entity('products', { weeks: [week] });
      return (0, _normalizr.normalize)((0, _decorators.decorateProduct)(data, startedAt), products);
    });
  }
});

var productLogic = exports.productLogic = [productfetchLogic];

// Selectors
var selectProducts = exports.selectProducts = function selectProducts(state) {
  return state.entities.products;
};

var selectProduct = exports.selectProduct = function selectProduct(state, id) {
  return (0, _get3.default)(selectProducts(state), id || state.result);
};

var selectWeeks = exports.selectWeeks = function selectWeeks(state) {
  return state.entities.weeks;
};

var selectWeek = exports.selectWeek = function selectWeek(state, weekNumber) {
  return (0, _find3.default)(selectWeeks(state), { weekNumber: weekNumber });
};

var selectDefaultMealPlanId = exports.selectDefaultMealPlanId = function selectDefaultMealPlanId(state, weekNumber, isVegetarian) {
  var week = selectWeek(state, weekNumber);

  if (week && week.mealPlan) {
    return isVegetarian ? week.vegetarianMealPlan.id : week.mealPlan.id;
  }
};

var selectMealPlanIsDefault = exports.selectMealPlanIsDefault = function selectMealPlanIsDefault(state, weekNumber, mealPlanId) {
  var week = selectWeek(state, weekNumber);

  if (week && week.mealPlan) {
    return mealPlanId === week.vegetarianMealPlan.id || mealPlanId === week.mealPlan.id;
  }
};

var selectWorkouts = exports.selectWorkouts = function selectWorkouts(state) {
  return state.entities.workouts;
};

var selectWeekWorkouts = exports.selectWeekWorkouts = function selectWeekWorkouts(state, weekNumber) {
  var week = selectWeek(state, weekNumber);
  var workouts = selectWorkouts(state);

  if (!week || !workouts) {
    return;
  }

  return (0, _map3.default)(week.workouts, function (id) {
    return workouts[id];
  });
};

var selectProductBackParams = exports.selectProductBackParams = function selectProductBackParams(state, router) {
  var prevParams = router.prevParams,
      prevState = router.prevState;
  var name = prevState.name;

  var params = _extends({}, prevParams);

  if (!params.voomeProductId || !params.weekNumber) {
    var product = selectProduct(state);

    if (product) {
      params.voomeProductId = product.id;
      params.weekNumber = product.currentWeek > product.weeks.length ? 1 : product.currentWeek;
    }
  }

  if (name === 'program.week.mealPlan') {
    return {
      title: 'Meal Plan',
      href: router.href('program.week.mealPlan', params)
    };
  } else {
    return {
      title: 'Week ' + params.weekNumber,
      href: router.href('program.week.detail', params)
    };
  }
};

// Helpers
var getGraduationData = exports.getGraduationData = function getGraduationData(title) {
  return _constants.GRADUATION_DATA[(0, _camelCase3.default)(title)] || _constants.GRADUATION_DATA.fallback;
};

// Action Creators
var fetchProduct = exports.fetchProduct = function fetchProduct(voomeProductId, startedAt) {
  return { type: FETCH, payload: { voomeProductId: voomeProductId, startedAt: startedAt } };
};

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case FETCH:
      return _extends({}, state, {
        loading: true
      });

    case FETCH_SUCCESS:
      return _extends({}, state, {
        entities: payload.entities,
        loading: false,
        result: payload.result
      });

    default:
      return state;
  }
}

/***/ }),

/***/ "5Fjo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SearchFilterRecipes = exports.SearchFilterRecipes = {
  bindings: {
    filters: '<',
    onClick: '&'
  },

  template: '\n    <div class="search-filter-recipes">\n      <search-filter\n        title="Protein"\n        type="radio"\n        list="$ctrl.filters[\'Protein\']"\n        on-click="$ctrl.onClick({ item: item, type: type, list: list, key: \'filters\'})">\n      </search-filter>\n      <search-filter\n        title="Time"\n        type="radio"\n        list="$ctrl.filters[\'Time\']"\n        on-click="$ctrl.onClick({ item: item, type: type, list: list, key: \'filters\'})">\n      </search-filter>\n      <search-filter\n        title="Meal Type"\n        type="checkbox"\n        list="$ctrl.filters[\'Meal Type\']"\n        on-click="$ctrl.onClick({ item: item, type: type, list: list, key: \'filters\'})">\n      </search-filter>\n      <search-filter\n        title="Meal"\n        type="radio"\n        list="$ctrl.filters[\'Meal\']"\n        on-click="$ctrl.onClick({ item: item, type: type, list: list, key: \'filters\'})">\n      </search-filter>\n      <search-filter\n        title="Serves"\n        type="radio"\n        list="$ctrl.filters[\'Serves\']"\n        on-click="$ctrl.onClick({ item: item, type: type, list: list, key: \'serves\'})">\n      </search-filter>\n      <search-filter\n        title="Dietary Preferences"\n        type="radio"\n        list="$ctrl.filters[\'Dietary Preferences\']"\n        on-click="$ctrl.onClick({ item: item, type: type, list: list, key: \'filters\'})">\n      </search-filter>\n      <search-filter\n        title="Nutrition Preferences"\n        type="radio"\n        list="$ctrl.filters[\'Nutrition Values\']"\n        on-click="$ctrl.onClick({ item: item, type: type, list: list, key: \'filters\'})">\n      </search-filter>\n      <search-filter\n        title="Other"\n        type="radio"\n        list="$ctrl.filters[\'Other\']"\n        on-click="$ctrl.onClick({ item: item, type: type, list: list, key: \'filters\'})">\n      </search-filter>\n    </div>'
};

/***/ }),

/***/ "5I3b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ProfileFieldsDowngrade = exports.ProfileFieldsDowngrade = {
  bindings: {
    hasError: '<',
    message: '<',
    form: '<',
    subscription: '<',
    products: '<',
    onSubmit: '&',
    onCancel: '&'
  },

  template: '\n    <div class="profile-cancel">\n      <div class="row">\n        <div class="col-md-4">\n          <h5>Modify Subscription</h5>\n          <p>\n            To modify your subscription, please select the product you would\n            like to change to.\n          </p>\n        </div>\n        <div class="col-md-8">\n          <alert type="danger" ng-show="$ctrl.hasError">\n            {{ $ctrl.message }}\n          </alert>\n          <form-group-row>\n            <form-group-left>\n              <form-label for="productId">\n                Modify to:\n              </form-label>\n            </form-group-left>\n            <form-group-right>\n              <form-select\n                form="$ctrl.form"\n                name="voomeProductId"\n                required="true"\n                errors="{ required: \'This is a required field.\' }"\n                on-update="$ctrl.onUpdate(key, value)">\n                <option value="">-- Select a product --</option>\n                <option\n                  value="{{ product.id }}"\n                  ng-repeat="product in $ctrl.products track by $index">\n                  {{ product.name }} - <signup-price value="product.totalInCents"></signup-price>\n                </option>\n              </form-select>\n              <p class="mt-3 text-danger"\n                ng-show="$ctrl.downgradeProduct">\n                On submitting you will no longer be able to access\n                {{ $ctrl.downgradeProduct.name }}.\n              </p>\n            </form-group-right>\n          </form-group-row>\n        </div>\n      </div>\n    </div>',

  controller: function controller() {
    return {
      onUpdate: function onUpdate(key, value) {
        var downgradeProducts = this.products.filter(function (item) {
          return item.id !== parseInt(value, 10);
        });

        this.downgradeProduct = downgradeProducts.length ? downgradeProducts[0] : undefined;
      }
    };
  }
};

/***/ }),

/***/ "5qOZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Login = undefined;

var _auth = __webpack_require__("wnLK");

var Login = exports.Login = {
  template: '\n    <div class="login">\n      <div class="main-content theme-mid pt-4 bg-gray-dashboard">\n        <div class="container align-items-center justify-content-center pb-5">\n          <div class="row">\n            <div class="col-lg-6 mx-auto px-2 px-sm-0">\n              <header class="text-center pt-2 pb-4"\n                ng-hide="$ctrl.facebookAccessToken">\n                <h1 class="h2 text-blue-cz-mid">\n                  Login into Coaching Zone\n                </h1>\n              </header>\n              <header class="text-center pt-2 pb-2"\n                ng-show="$ctrl.facebookAccessToken">\n                <divider-zig-zag>\n                  <h1 class="h2 text-white">\n                    Link account with Facebook\n                  </h1>\n                </divider-zig-zag>\n                <div class="text-white">\n                  <p>To sign in with Facebook we need to link it to your Coaching Zone account.</p>\n                  <p>Don\'t worry - you only need to do this once and we won\'t post anything without your permission.</p>\n                </div>\n              </header>\n              <section class="p-3 theme-light">\n                <div class="container px-3 px-lg-4 pt-4 pb-3 bg-white">\n                  <div scroll-top-on-change="$ctrl.message">\n                    <alert type="{{ $ctrl.error ? \'danger\' : \'success\' }}"\n                      ng-if="$ctrl.message">\n                      {{ $ctrl.message }}\n                    </alert>\n                  </div>\n                  <form-login\n                    on-submit="$ctrl.authLogin(data, $ctrl.facebookAccessToken)"\n                    is-loading="$ctrl.isLoading">\n                  </form-login>\n                </div>\n              </section>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>',

  controller: ["$ngRedux", "$timeout", function controller($ngRedux, $timeout) {
    'ngInject';

    window.checkLoginState = function () {
      return $ngRedux.dispatch((0, _auth.authLoginFacebook)());
    };

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.unsubscribe = connect(this);
      },
      $onDestroy: function $onDestroy() {
        this.unsubscribe();
      },
      mapState: function mapState(_ref) {
        var auth = _ref.auth;
        var facebookAccessToken = auth.facebookAccessToken,
            error = auth.error,
            isLoading = auth.isLoading,
            message = auth.message;

        var isWelcomeMessage = /Welcome/.test(message);

        return {
          facebookAccessToken: facebookAccessToken,
          error: error,
          isLoading: isLoading,
          isWelcomeMessage: isWelcomeMessage,
          message: message
        };
      },
      mapDispatch: function mapDispatch() {
        return { authLogin: _auth.authLogin };
      }
    };
  }]
};

/***/ }),

/***/ "5tcl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Alert = __webpack_require__("ByHG");

Object.defineProperty(exports, 'Alert', {
  enumerable: true,
  get: function get() {
    return _Alert.Alert;
  }
});

/***/ }),

/***/ "6+My":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoPlayer = exports.script = undefined;

var _settings = __webpack_require__("Ll2K");

var _utils = __webpack_require__("0xDb");

var _uuid = __webpack_require__("DlMc");

var _uuid2 = _interopRequireDefault(_uuid);

var _jquery = __webpack_require__("7t+N");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var accountId = _settings.brightcove.accountId,
    playerId = _settings.brightcove.playerId;
var script = exports.script = {
  uri: '//players.brightcove.net/' + accountId + '/' + playerId + '_default/index.min.js',
  isLoaded: false,
  isLoading: false
};

var VideoPlayer = exports.VideoPlayer = {
  bindings: {
    autoplay: '<',
    index: '<',
    poster: '<',
    videoId: '<',
    onLoad: '&'
  },

  template: '\n    <div class="video-player">\n      <video class="video-js"\n        id="{{$ctrl.videoPlayerId}}"\n        data-account="' + accountId + '"\n        data-player="' + playerId + '"\n        data-embed="default"\n        playsinline\n        controls>\n      </video>\n    </div>',

  controller: ["$interval", "$timeout", "$window", function controller($interval, $timeout, $window) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        this.videoPlayerId = _uuid2.default.v4();
      },
      $onChanges: function $onChanges() {
        var changes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _changes$videoId = changes.videoId,
            currentValue = _changes$videoId.currentValue,
            previousValue = _changes$videoId.previousValue;


        if (currentValue && currentValue !== previousValue) {
          this.initPlayer();
        }
      },
      $onDestroy: function $onDestroy() {
        script.isLoaded = false;
        script.isLoading = false;

        if (this.player) {
          this.removeListeners();
          this.player.dispose();
        }
      },
      initPlayer: function initPlayer() {
        var _this = this;

        if (script.isLoading || script.isLoaded) {
          var interval = $interval(function () {
            if (script.isLoaded) {
              _this.setPlayer();
              $interval.cancel(interval);
            }
          }, 100);
        } else {
          this.loadScript();
        }
      },
      loadScript: function loadScript() {
        var _this2 = this;

        if (!script.isLoading) {
          script.isLoading = true;

          return _jquery2.default.getScript(script.uri).then(function () {
            script.isLoaded = true;
            _this2.setPlayer();
          });
        }
      },
      setPlayer: function setPlayer() {
        var _this3 = this;

        this.player = $window.videojs(this.videoPlayerId);
        this.player.controlBar.hide();
        this.player.ready(function () {
          return _this3.onReady();
        });
      },
      setPosterImage: function setPosterImage(poster) {
        var _this4 = this;

        var src = (0, _utils.assetSrc)(poster);

        // Set poster if the image loads successfully
        (0, _jquery2.default)('<img>').prop('src', src).on('load', function () {
          return _this4.player.posterImage.setSrc(src);
        });
      },
      onReady: function onReady() {
        var _this5 = this;

        this.addListeners();
        this.player.catalog.getVideo(this.videoId, function (error, response) {
          return _this5.onGetVideo(response);
        });
      },
      onGetVideo: function onGetVideo(response) {
        var _this6 = this;

        this.player.catalog.load(response);

        if (this.poster) {
          this.setPosterImage(this.poster);
        }

        if (this.onLoad) {
          this.onLoad({ player: this.player });
        }

        if (this.autoplay) {
          $timeout(function () {
            var videoPromise = _this6.player.play();

            // Shut the error messages up.
            if (videoPromise && videoPromise.catch) {
              videoPromise.catch(function () {});
            }
          });
        }
      },
      onEnded: function onEnded() {
        if (this.player) {
          this.removeListeners();
        }
      },
      onError: function onError() {
        var _this7 = this;

        var _player$error = this.player.error(),
            code = _player$error.code;

        // Filter out videos of the type that errored and re-load.


        if (code === 4) {
          var sources = this.player.mediainfo.sources.filter(function (_ref) {
            var type = _ref.type;
            return type !== _this7.player.currentType();
          });

          this.player.src(sources);
          this.player.load();
        }
      },
      onPlay: function onPlay() {
        this.player.controlBar.show();
      },
      addListeners: function addListeners() {
        var _this8 = this;

        this.player.on('ended', function () {
          return _this8.onEnded();
        });
        this.player.on('error', function () {
          return _this8.onError();
        });
        this.player.on('play', function () {
          return _this8.onPlay();
        });
      },
      removeListeners: function removeListeners() {
        this.player.off('ended');
        this.player.off('error');
        this.player.off('play');
      }
    };
  }]
};

/***/ }),

/***/ "61pe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = undefined;

var _utils = __webpack_require__("0xDb");

var _member = __webpack_require__("1OIp");

var _signup = __webpack_require__("FQ9i");

var App = exports.App = {
  template: '\n    <div class="{{ $ctrl.theme.base }} {{ $ctrl.theme.slug }}"\n      ng-switch="$ctrl.theme.navType">\n      <div class="sticky-top">\n        <div ng-switch-when="main">\n          <nav-main\n            avatar-src="$ctrl.member.profile.avatarUrl.thumb"\n            items="$ctrl.theme.navMain"\n            product="$ctrl.product"\n            subscriptions="$ctrl.subscriptions"\n            subscription="$ctrl.subscription"\n            on-click-subscription="$ctrl.changeSubscription(subscription)">\n          </nav-main>\n        </div>\n        <nav-plain ng-switch-when="plain">\n        </nav-plain>\n      </div>\n      <ui-view></ui-view>\n    </div>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();
      },
      mapState: function mapState(_ref) {
        var member = _ref.member,
            router = _ref.router,
            signup = _ref.signup,
            theme = _ref.theme;

        var voomeProductId = router.currentParams.voomeProductId || _utils.memberStorage.get().voomeProductId;

        return {
          theme: theme,
          member: (0, _member.selectMember)(member),
          product: (0, _signup.selectProduct)(signup, voomeProductId),
          subscription: (0, _member.selectSubscription)(member, voomeProductId),
          subscriptions: (0, _member.selectSubscriptions)(member)
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          changeSubscription: _member.changeSubscription
        };
      }
    };
  }]
};

/***/ }),

/***/ "620k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6MmS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WorkoutsVideos = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxUiRouter = __webpack_require__("Zb/7");

var _utils = __webpack_require__("0xDb");

var _member = __webpack_require__("1OIp");

var _workout = __webpack_require__("Toxe");

var _favourite = __webpack_require__("GfAe");

var _filters = __webpack_require__("ZTBt");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var WorkoutsVideos = {
  template: '\n    <ui-view>\n      <div class="py-3 py-md-4 bg-gray-100">\n        <div class="container">\n          <div class="row">\n            <div class="col-md-3 pt-md-2">\n              <nav-mobile-sidebar\n                heading="Filter"\n                is-active="$ctrl.filtersIsActive"\n                on-click="$ctrl.toggleFiltersIsActive()">\n                <search-filter-videos\n                  filters="$ctrl.filters"\n                  on-click="$ctrl.onUpdateParam(key, value)">\n                </search-filter-videos>\n              </nav-mobile-sidebar>\n            </div>\n            <div class="col-md-9">\n              <div class="mobile-filter-row row d-flex d-md-none py-2 px-3 bg-white">\n                <button class="btn btn-link p-0 d-inline-flex"\n                  ng-click="$ctrl.toggleFiltersIsActive()">\n                  <i class="fa fa-sliders"></i>\n                  <span class="h6 text-green-dark mb-0">Filter</span>\n                </button>\n              </div>\n              <search-filter-results\n                query="$ctrl.search.params.q"\n                filters="$ctrl.checkedFilters"\n                on-clear-all="$ctrl.onClearAll()"\n                on-update-param="$ctrl.onUpdateParam(key, value)"\n                on-update-filter="$ctrl.onUpdateFilter(item)">\n              </search-filter-results>\n              <search-results\n                on-update-param="$ctrl.onUpdateParam(key, value)"\n                order="$ctrl.sortBy"\n                pagination="$ctrl.pagination"\n                type="workouts">\n                <div class="row">\n                  <div class="col-sm-6 pb-3"\n                    ng-repeat="item in $ctrl.results track by $index">\n                    <card-video\n                      heading="item.title"\n                      duration-in-mins="item.time"\n                      image="item.thumbnailUrl.large"\n                      is-favourite="item.isFavourite"\n                      on-click="$ctrl.onClick(item)"\n                      on-favourite="$ctrl.toggleFavouriteVideo({\n                        memberId: $ctrl.member.id,\n                        videoId: item.id,\n                        isFavourite: item.isFavourite\n                      })">\n                    </card-video>\n                  </div>\n                </div>\n              </search-results>\n            </div>\n          </div>\n        </div>\n      </div>\n    </ui-view>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        if (!this.videos) {
          this.fetchWorkoutVideos(this.params);
        }
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();
      },
      onClick: function onClick(_ref) {
        var id = _ref.id,
            title = _ref.title;

        this.stateGo('workouts.videos.detail', { videoId: id });
        _utils.anchorStorage.set($ngRedux.getState(), title);
      },
      onClearAll: function onClearAll() {
        this.stateGo('workouts.videos', {
          type: undefined,
          equipmentRequired: undefined,
          time: undefined
        });
      },
      onUpdateFilter: function onUpdateFilter(item) {
        var _params = this.params,
            undefined = _params[item.key],
            params = _objectWithoutProperties(_params, [item.key]);

        var type = params.type,
            equipmentRequired = params.equipmentRequired,
            time = params.time;


        this.stateGo('workouts.videos', { type: type, equipmentRequired: equipmentRequired, time: time });
      },
      onUpdateParam: function onUpdateParam(key) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        this.stateGo('workouts.videos', _extends({}, this.params, _defineProperty({}, key, value)));
      },
      mapState: function mapState(_ref2) {
        var favourite = _ref2.favourite,
            filters = _ref2.filters,
            member = _ref2.member,
            router = _ref2.router,
            workout = _ref2.workout;

        var params = router.currentParams;
        var order = params.order,
            page = params.page;

        var pagination = (0, _workout.selectWorkoutVideos)(workout, page);

        return {
          page: page,
          pagination: pagination,
          params: params,
          filters: (0, _filters.selectFiltersVideosGrouped)(filters, params),
          filtersIsActive: filters.isActive,
          checkedFilters: (0, _filters.selectFiltersVideosChecked)(filters, params),
          hasAccess: (0, _member.selectHasWorkoutSubscription)(member),
          isLoading: workout.isLoading,
          member: (0, _member.selectMember)(member),
          results: (0, _favourite.mapIsFavouriteVideos)(pagination.result, (0, _favourite.selectFavouriteVideoIds)(favourite)),
          sortBy: (0, _filters.selectSortByVideos)(filters, order)
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          fetchWorkoutVideos: _workout.fetchWorkoutVideos,
          stateGo: _reduxUiRouter.stateGo,
          toggleFavouriteVideo: _favourite.toggleFavouriteVideo,
          toggleFiltersIsActive: _filters.toggleFiltersIsActive
        };
      }
    };
  }]
};
exports.WorkoutsVideos = WorkoutsVideos;

/***/ }),

/***/ "6Q/l":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Upgrade = undefined;

var _reduxUiRouter = __webpack_require__("Zb/7");

var _constants = __webpack_require__("qI5z");

var _signup = __webpack_require__("FQ9i");

var _member = __webpack_require__("1OIp");

var Upgrade = exports.Upgrade = {
  template: '',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();

        if (this.unsubscribe) {
          this.unsubscribe();
        }
      },
      onSubmit: function onSubmit(subscriptionId, voomeProductId) {
        var _this = this;

        this.upgradeSubscription(subscriptionId, voomeProductId);

        this.unsubscribe = $ngRedux.subscribe(function () {
          var subscription = (0, _member.selectSubscription)($ngRedux.getState().member);
          var slug = _this.upgradeText.slug;


          if (subscription.voomeProductId === voomeProductId) {
            _this.unsubscribe();
            _this.stateGo('welcomeUpgrade', { slug: slug });
          }
        });
      },
      mapState: function mapState(_ref) {
        var member = _ref.member,
            router = _ref.router,
            signup = _ref.signup;

        var key = router.currentState.name.split('.')[0];
        var subscription = (0, _member.selectSubscription)(member);
        var voomeProduct = (0, _signup.selectUpgradeProduct)(signup, subscription.voomeProductId);

        return {
          errorMessage: member.error && member.message,
          isLoading: member.isLoading,
          isBundleUpgrade: (0, _member.selectHasNutritionSubscription)(member) || (0, _member.selectHasWorkoutSubscription)(member),
          showModal: !(0, _member.selectHasBundleSubscription)(member),
          subscriptionId: subscription.id,
          upgradeText: _constants.UPGRADE_TEXT[key],
          voomeProductId: voomeProduct.id
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          upgradeSubscription: _member.upgradeSubscription,
          stateGo: _reduxUiRouter.stateGo
        };
      }
    };
  }]
};

/***/ }),

/***/ "6cDV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6tnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WorkoutPlayerControls = exports.WorkoutPlayerControls = {
  bindings: {
    playing: '<',
    completed: '<',
    continuous: '<',
    previousStep: '<',
    nextStep: '<',
    onToggle: '&',
    onToggleContinuous: '&',
    onRestart: '&',
    onBack: '&',
    onNext: '&',
    onFinish: '&'
  },

  template: '\n    <div class="d-flex">\n      <div class="text-center switch-content">\n        <label class="switch">\n          <input\n            type="checkbox"\n            ng-model="$ctrl.continuous"\n            ng-change="$ctrl.onToggleContinuous()">\n          <i></i>\n        </label>\n        <p>AutoPlay</p>\n      </div>\n      <div class="workout-player-controls-inner d-flex">\n        <button class="back-btn"\n          type="button"\n          ng-class="{ \'disabled\': !$ctrl.previousStep }"\n          ng-click="$ctrl.previousStep && $ctrl.onBack()">\n          Back\n        </button>\n        <button class="play-btn"\n          type="button"\n          ng-click="$ctrl.onToggle()"\n          ng-hide="$ctrl.completed">\n          <i class="fa"\n            ng-class="$ctrl.playing ? \'fa-pause\' : \'fa-play\'">\n          </i>\n        </button>\n        <button class="play-btn"\n          type="button"\n          ng-click="$ctrl.onRestart()"\n          ng-show="$ctrl.completed">\n          <i class="fa fa-rotate-left"></i>\n        </button>\n        <button class="next-btn"\n          type="button"\n          ng-click="$ctrl.onNext()">\n          {{ $ctrl.nextStep && \'Next\' || \'Finish\' }}\n        </button>\n      </div>\n    </div>'
};

/***/ }),

/***/ "6txZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7PQy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Exercise = exports.Exercise = {
  bindings: {
    data: '<',
    workout: '<',
    exercise: '<',
    gender: '<',
    params: '<',
    index: '<',
    onClick: '&'
  },

  template: '\n    <div class="exercise">\n      <div class="exercise-content">\n        <div ng-if="$ctrl.exercise.video.brightcoveId">\n          <a class="exercise-thumb d-block"\n            href="#"\n            data-toggle="modal"\n            data-target="#modalVideoExercise"\n            ng-attr-title="Demo - {{ $ctrl.exercise.name }}"\n            ng-click="$ctrl.onClick({ item: $ctrl.exercise.video })">\n            <span class="fa-wrapper">\n              <i class="fa fa-play"></i>\n            </span>\n            <img ng-src="{{ $ctrl.exercise.icon.thumb2x | assetSrc }}"/>\n          </a>\n        </div>\n        <div ng-if="!$ctrl.exercise.video.brightcoveId">\n          <img ng-src="{{ $ctrl.exercise.icon.thumb2x | assetSrc }}"/>\n        </div>\n        <section>\n          <h4>\n            <a\n              ng-if="$ctrl.workout.autoplayable"\n              ui-sref="workoutPlayer({ exercisePlanId: $ctrl.params.exercisePlanId, id: $ctrl.params.id, itemId: $ctrl.data.id })"\n              brightcove-supported="replace">\n              {{ $ctrl.exercise.name }}\n            </a>\n            <span ng-if="!$ctrl.workout.autoplayable">\n              {{ $ctrl.exercise.name }}\n            </span>\n          </h4>\n          <ul class="workout-stats">\n            <li ng-if="$ctrl.data.totalTimeSet">\n              <small>Time</small>\n              <b>{{ $ctrl.data.totalTimeDigital }}</b>\n            </li>\n            <li ng-if="$ctrl.data.levelNumber || $ctrl.data.level" class="dash">\n              <small>Level</small>\n              <b>{{ $ctrl.data.levelNumber || $ctrl.data.level }}</b>\n            </li>\n            <li ng-if="$ctrl.data.inclineNumber || $ctrl.data.incline" class="dash">\n              <small>Incline</small>\n              <b>{{ $ctrl.data.inclineNumber || $ctrl.data.incline }}</b>\n            </li>\n            <li ng-if="$ctrl.data.speedKms || $ctrl.data.speedMetric" class="dash">\n              <small>Speed</small>\n              <b>{{ $ctrl.data.speedMetric || $ctrl.data.speedKms }}</b>\n            </li>\n            <li ng-if="$ctrl.data.distanceKms || $ctrl.data.distanceMetric" class="dash">\n              <small>Distance</small>\n              <b>{{ $ctrl.data.distanceMetric || $ctrl.data.distanceKms }}</b>\n            </li>\n            <li ng-if="$ctrl.data.sets || $ctrl.data.setsCount" class="times">\n              <small>Sets</small>\n              <b>{{ $ctrl.data.setsCount || $ctrl.data.sets }}</b>\n            </li>\n            <li ng-if="$ctrl.data.reps || $ctrl.data.repsCount" class="times">\n              <small>Reps</small>\n              <b>{{ $ctrl.data.repsCount || $ctrl.data.reps }}</b>\n            </li>\n            <li ng-if="$ctrl.data.weightBase" class="times">\n              <small>Weight</small>\n              <b>\n                {{ $ctrl.data.weightBase | convertWeight: $ctrl.gender }}\n                <span ng-show="$ctrl.data.weightRange">\n                  -{{ $ctrl.data.weightBase + $ctrl.data.weightRange | convertWeight: $ctr.gender }}\n                </span>\n                kg\n              </b>\n            </li>\n          </ul>\n          <div>\n            <span ng-show="$ctrl.data.note" ng-bind-html="$ctrl.data.note" class="note"></span>\n            <span ng-show="$ctrl.data.formattedNote" class="note">\n              {{ $ctrl.data.formattedNote }}\n            </span>\n          </div>\n        </section>\n      </div>\n    </div>'
};

/***/ }),

/***/ "8G1E":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setRedirect = exports.goRedirect = exports.redirectLogic = undefined;

var _reduxLogic = __webpack_require__("E0Bt");

var _store = __webpack_require__("Y4FN");

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

// Actions
var GO = '@@app/redirect/GO';
var SET = '@@app/redirect/SET';

var goLogic = (0, _reduxLogic.createLogic)({
  type: GO,
  process: function process(_ref, dispatch, done) {
    _objectDestructuringEmpty(_ref);

    var _store$get = _store2.default.get('redirect'),
        path = _store$get.path;

    window.location.assign(path);
    done();
  }
});

var setLogic = (0, _reduxLogic.createLogic)({
  type: SET,
  process: function process(_ref2, dispatch, done) {
    var action = _ref2.action;
    var path = action.payload.path;

    _store2.default.set('redirect', path);
    done();
  }
});

var redirectLogic = exports.redirectLogic = [goLogic, setLogic];

// Action Creators
var goRedirect = exports.goRedirect = function goRedirect(path) {
  return { type: GO, payload: { path: path } };
};

var setRedirect = exports.setRedirect = function setRedirect(path) {
  return { type: SET, payload: { path: path } };
};

/***/ }),

/***/ "8N+6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var VideoPlaylist = exports.VideoPlaylist = {
  transclude: true,

  bindings: {
    autoplay: '<',
    continuous: '<',
    list: '<',
    loop: '<'
  },

  template: '\n    <div class="video-playlist row">\n      <div class="col-lg-8 mb-1">\n        <video-player\n          autoplay="$ctrl.autoplay"\n          video-id="$ctrl.list[$ctrl.index].id"\n          on-complete="$ctrl.setIndex($ctrl.index + 1)">\n        </video-player>\n        <div class="mt-4" ng-transclude></div>\n      </div>\n      <div class="col-lg-4">\n        <div class="list-group">\n          <a class="list-group-item list-group-item-action list-group-item--no-radius d-flex p-0 mb-1 border-0"\n            href="#"\n            ng-class="{\n              \'active\': $ctrl.index === $index,\n              \'bg-gray-100\': $ctrl.index !== $index\n            }"\n            ng-click="$ctrl.setIndex($index)"\n            ng-repeat="item in $ctrl.list track by $index">\n            <div class="list-group-item--image">\n              <img ng-src="{{ item.thumbnailUrl.largeThumb | assetSrc }}">\n            </div>\n            <div class="list-group-item--content p-3">\n              <div class="d-flex w-100 justify-content-between">\n                <h6 ng-class="{\n                  \'mb-0\': !item.description && !item.duration,\n                  \'mb-1\': item.description || item.duration,\n                  \'text-dark\': $ctrl.index !== $index,\n                }">\n                  {{ item.title }}\n                </h6>\n              </div>\n              <p\n                ng-class="{ \'mb-1\': item.duration }"\n                ng-if="item.description">\n                {{ item.description }}\n              </p>\n              <small ng-if="item.duration">\n                {{ item.duration }}\n              </small>\n            </div>\n          </a>\n        </div>\n      </div>\n    </div>',

  controller: ["$timeout", function controller($timeout) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        this.index = 0;
      },
      $onDestroy: function $onDestroy() {
        this.player && this.player.off('complete');
      },
      onLoad: function onLoad(player) {
        var _this = this;

        this.player = player;
        this.player.on('ended', function () {
          return _this.setIndex(_this.index + 1);
        });
      },
      setIndex: function setIndex(index) {
        var _this2 = this;

        $timeout(function () {
          if (!_this2.list[index]) {
            _this2.autoplay = _this2.loop && _this2.continuous;
            _this2.index = 0;
          } else {
            _this2.autoplay = _this2.autoplay || _this2.continuous;
            _this2.index = index;
          }
        });
      }
    };
  }]
};

/***/ }),

/***/ "8q0z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8uL4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignupVerifying = exports.SignupTileWeekly = exports.SignupTileProgram = exports.SignupSelectorProgram = exports.SignupSelectorWeekly = exports.SignupPrice = exports.SignupIcon = exports.SignupFormPersonal = exports.SignupFormBilling = exports.SignupFooter = exports.SignupAside = undefined;

var _SignupAside = __webpack_require__("kQjX");

Object.defineProperty(exports, 'SignupAside', {
  enumerable: true,
  get: function get() {
    return _SignupAside.SignupAside;
  }
});

var _SignupFooter = __webpack_require__("9eWm");

Object.defineProperty(exports, 'SignupFooter', {
  enumerable: true,
  get: function get() {
    return _SignupFooter.SignupFooter;
  }
});

var _SignupFormBilling = __webpack_require__("+VBr");

Object.defineProperty(exports, 'SignupFormBilling', {
  enumerable: true,
  get: function get() {
    return _SignupFormBilling.SignupFormBilling;
  }
});

var _SignupFormPersonal = __webpack_require__("tz8s");

Object.defineProperty(exports, 'SignupFormPersonal', {
  enumerable: true,
  get: function get() {
    return _SignupFormPersonal.SignupFormPersonal;
  }
});

var _SignupIcon = __webpack_require__("/uzO");

Object.defineProperty(exports, 'SignupIcon', {
  enumerable: true,
  get: function get() {
    return _SignupIcon.SignupIcon;
  }
});

var _SignupPrice = __webpack_require__("UmzV");

Object.defineProperty(exports, 'SignupPrice', {
  enumerable: true,
  get: function get() {
    return _SignupPrice.SignupPrice;
  }
});

var _SignupSelectorWeekly = __webpack_require__("/kGf");

Object.defineProperty(exports, 'SignupSelectorWeekly', {
  enumerable: true,
  get: function get() {
    return _SignupSelectorWeekly.SignupSelectorWeekly;
  }
});

var _SignupSelectorProgram = __webpack_require__("2ZXJ");

Object.defineProperty(exports, 'SignupSelectorProgram', {
  enumerable: true,
  get: function get() {
    return _SignupSelectorProgram.SignupSelectorProgram;
  }
});

var _SignupTileProgram = __webpack_require__("/sbO");

Object.defineProperty(exports, 'SignupTileProgram', {
  enumerable: true,
  get: function get() {
    return _SignupTileProgram.SignupTileProgram;
  }
});

var _SignupTileWeekly = __webpack_require__("d1/9");

Object.defineProperty(exports, 'SignupTileWeekly', {
  enumerable: true,
  get: function get() {
    return _SignupTileWeekly.SignupTileWeekly;
  }
});

var _SignupVerifying = __webpack_require__("nVnU");

Object.defineProperty(exports, 'SignupVerifying', {
  enumerable: true,
  get: function get() {
    return _SignupVerifying.SignupVerifying;
  }
});

__webpack_require__("i6qM");

/***/ }),

/***/ "8yhO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Completer = exports.Completer = {
  bindings: {
    title: '@',
    isComplete: '<',
    onToggle: '&'
  },

  template: '\n    <div class="completer clearfix"\n      ng-class="{ \'complete\': $ctrl.isComplete }">\n      <div class="completer-action"\n        ng-click="$ctrl.onToggle()">\n        <span class="completer-state">\n          <i class="fa fa-check"></i>\n        </span>\n        <span class="completer-title text-uppercase">\n          {{ $ctrl.title }}\n        </span>\n      </div>\n    </div>'
};

/***/ }),

/***/ "9eWm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SignupFooter = exports.SignupFooter = {
  bindings: {
    text: '<'
  },

  template: '\n    <ol class="signup-footer pt-5 px-5 mb-0 text-white">\n      <li class="small" ng-show="$ctrl.text.firstPaymentInDays == 0">\n        Your card will be charged immediately.\n      </li>\n      <li class="small" ng-show="$ctrl.text.firstPaymentInDays > 0">\n        Your card will be charged {{ $ctrl.text.firstPaymentInDays }} days. If\n        you cancel before then you won\'t be charged.\n      </li>\n      <li class="small">\n        Currency of transaction is Australian Dollars (AUD).\n      </li>\n      <li class="small">\n        12WBT Trading Pty Ltd. is an Australian owned business located in\n        Australia (ABN - 31 154 009 622). Address: PO Box 1055, Darlinghurst\n        NSW 1300\n      </li>\n      <li class="small">\n        When purchasing from 12WBT Trading Pty Ltd. your financial details are\n        passed through a secure server using the latest 256-bit SSL (secure\n        sockets layer) encryption technology. If you have any questions\n        regarding our security policy, please contact our customer service\n        support centre which is <a href="mailto:support@voome.com.au" class="text-white">\n        support@voome.com.au</a>.\n      </li>\n    </ol>'
};

/***/ }),

/***/ "9qtj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RatingStars = undefined;

var _RatingStars = __webpack_require__("/Jcz");

Object.defineProperty(exports, 'RatingStars', {
  enumerable: true,
  get: function get() {
    return _RatingStars.RatingStars;
  }
});

__webpack_require__("CCj3");

/***/ }),

/***/ "9u01":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FavouritesRecipes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxUiRouter = __webpack_require__("Zb/7");

var _utils = __webpack_require__("0xDb");

var _filters = __webpack_require__("ZTBt");

var _member = __webpack_require__("1OIp");

var _favourite = __webpack_require__("GfAe");

var FavouritesRecipes = exports.FavouritesRecipes = {
  template: '\n    <ui-view>\n      <div class="favourite-recipes py-3 py-md-4">\n        <div class="container pb-3">\n          <div class="d-flex align-items-center justify-content-end">\n            <search-order\n              ng-show="$ctrl.pagination.result.length"\n              title="Sort by:"\n              list="$ctrl.sortBy"\n              on-click="$ctrl.onUpdateOrder(value)">\n            </search-order>\n          </div>\n          <div class="row pt-2">\n            <div class="col-sm-6 col-md-4 col-lg-3 pb-3"\n              ng-repeat="item in $ctrl.pagination.result track by $index">\n              <card-recipe\n                recipe="item"\n                on-click="$ctrl.onClick(item)">\n              </card-recipe>\n            </div>\n            <div class="col-sm-5 mx-auto mt-3"\n              ng-hide="$ctrl.pagination.result.length">\n              <favourite-no-result\n                is-loading="$ctrl.isLoading">\n              </favourite-no-result>\n            </div>\n          </div>\n          <pagination-row\n            on-update-param="$ctrl.onUpdatePage(value)"\n            pagination="$ctrl.pagination">\n          </pagination-row>\n        </div>\n      </div>\n    </ui-view>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        if (this.shouldFetch) {
          this.fetchFavouriteRecipes(this.params);
        }
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();
      },
      onClick: function onClick(_ref) {
        var id = _ref.id,
            name = _ref.name;

        this.stateGo('nutrition.favouritesRecipes.detail', { recipeId: id });
        _utils.anchorStorage.set($ngRedux.getState(), name);
      },
      onUpdateOrder: function onUpdateOrder(order) {
        this.stateGo('favourites.recipes', { order: order, page: undefined });
      },
      onUpdatePage: function onUpdatePage(page) {
        this.stateGo('favourites.recipes', { page: page });
      },
      mapState: function mapState(_ref2) {
        var member = _ref2.member,
            router = _ref2.router,
            favourite = _ref2.favourite,
            filters = _ref2.filters;

        var params = _extends({}, router.currentParams, {
          level: (0, _member.selectMemberLevel)(member),
          memberId: (0, _member.selectMember)(member).id
        });

        var pagination = (0, _favourite.selectFavouriteRecipes)(favourite, params);
        var result = pagination.result;
        var isLoading = favourite.isLoading;


        return {
          isLoading: isLoading,
          pagination: pagination,
          params: params,
          shouldFetch: (0, _favourite.selectFavouriteRecipesReload)(favourite, result),
          sortBy: (0, _filters.selectSortByRecipes)(filters, params.order)
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          fetchFavouriteRecipes: _favourite.fetchFavouriteRecipes,
          stateGo: _reduxUiRouter.stateGo
        };
      }
    };
  }]
};

/***/ }),

/***/ "A7fB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CurrentDay = exports.CurrentDay = {
  transclude: true,

  bindings: {
    type: '@'
  },

  template: '\n    <span class="current-day">\n      {{ $ctrl.today | date: $ctrl.key }}\n      <ng-transclude></ng-transclude>\n    </span>',

  controller: function controller() {
    'ngInject';

    return {
      $onInit: function $onInit() {
        this.today = new Date();
        this.key = this.type === 'short' ? 'EEE' : 'EEEE';
      }
    };
  }
};

/***/ }),

/***/ "A83q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MealPlanCreateButton = undefined;

var _reduxUiRouter = __webpack_require__("Zb/7");

var _mealPlan = __webpack_require__("KLwp");

var _member = __webpack_require__("1OIp");

var MealPlanCreateButton = exports.MealPlanCreateButton = {
  transclude: true,

  bindings: {
    style: '@',
    subscriptionId: '<'
  },

  template: '\n    <span ng-switch="$ctrl.style">\n      <span ng-switch-when="link">\n        <button-link ng-click="$ctrl.onClick($ctrl.subscriptionId)">\n          <ng-transclude></ng-transclude>\n        </button-link>\n      </span>\n      <span ng-switch-when="button">\n        <button-primary\n          ng-click="$ctrl.onClick($ctrl.subscriptionId)">\n          <ng-transclude></ng-transclude>\n        </button-primary>\n      </span>\n    </span>',

  controller: ["$ngRedux", "$state", function controller($ngRedux, $state) {
    'ngInject';

    return {
      $onDestroy: function $onDestroy() {
        this.unsubscribe && this.unsubscribe();
      },
      onClick: function onClick(subscriptionId) {
        var _this = this;

        this.unsubscribe = $ngRedux.subscribe(function () {
          return _this.redirectOnCreate();
        });
        $ngRedux.dispatch((0, _mealPlan.createMealPlan)(subscriptionId));
      },
      redirectOnCreate: function redirectOnCreate() {
        var _$ngRedux$getState = $ngRedux.getState(),
            mealPlan = _$ngRedux$getState.mealPlan,
            member = _$ngRedux$getState.member;

        if (mealPlan.result) {
          this.unsubscribe();

          // TODO: do a hard redirect to edit, due to some issues with the state
          // updating and a race condition.
          window.location.assign($state.href('nutrition.mealPlans.detail.edit', {
            mealPlanId: mealPlan.result,
            day: 'Monday',
            level: (0, _member.selectMemberLevel)(member)
          }));

          // $ngRedux.dispatch(
          //   stateGo('nutrition.mealPlans.detail.edit', {
          //     mealPlanId: mealPlan.result,
          //     day: 'Monday',
          //     level: selectMemberLevel(member),
          //   })
          // );
        }
      }
    };
  }]
};

/***/ }),

/***/ "AFkJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollectionHeader = undefined;

var _CollectionHeader = __webpack_require__("Zv82");

Object.defineProperty(exports, 'CollectionHeader', {
  enumerable: true,
  get: function get() {
    return _CollectionHeader.CollectionHeader;
  }
});

__webpack_require__("W5nB");

/***/ }),

/***/ "AOsR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormReview = undefined;

var _settings = __webpack_require__("Ll2K");

var FormReview = exports.FormReview = {
  bindings: {
    wordingRating: '@',
    wordingSingular: '@',
    onSubmit: '&',
    onCancel: '&'
  },

  template: '\n    <form class="form-review voome-form"\n      name="form"\n      ng-submit="$ctrl.onReview(form)"\n      novalidate>\n      <div class="form-group">\n        <form-label for="review">\n          Write your {{ $ctrl.wordingSingular | lowercase }}\n        </form-label>\n        <a href="' + _settings.hosts.public + '/faqs/" class="float-right">\n          Need help?\n        </a>\n        <form-textarea\n          name="review"\n          form="form"\n          rows="5"\n          errors="{ required: \'This field is required\' }"\n          required="true">\n        </form-textarea>\n        <div class="mt-3 d-flex flex-row"\n          ng-if="$ctrl.wordingRating">\n          <input name="rating" type="hidden" value="form.data.rating">\n          <span>{{ $ctrl.wordingRating }}:</span>\n          <p class="ml-2">\n            <rating-stars\n              size="md"\n              rating="form.data.rating"\n              is-enabled="true"\n              on-click="form.data.rating = value">\n            </rating-stars>\n          </p>\n        </div>\n      </div>\n      <button class="btn btn-link pl-0"\n        type="button"\n        ng-click="$ctrl.onCancel(); $ctrl.reset(form)">\n        Cancel\n      </button>\n      <button class="btn btn-pill theme-btn"\n        type="submit"\n        ng-disabled="form.$invalid">\n        Post {{ $ctrl.wordingSingular }}\n      </button>\n    </form>',

  controller: ["$timeout", function controller($timeout) {
    'ngInject';

    return {
      onReview: function onReview(form) {
        this.onSubmit({ data: form.data });
        this.reset(form);
      },
      onReviewCancel: function onReviewCancel(form) {
        this.onCancel();
        this.reset(form);
      },
      reset: function reset(form) {
        form.data.review = undefined;
        form.data.rating = undefined;

        $timeout(function () {
          form.$setPristine();
          form.$setUntouched();
        });
      }
    };
  }]
};

/***/ }),

/***/ "AVJU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dashboard = undefined;

var _favourite = __webpack_require__("GfAe");

var _recipe = __webpack_require__("mew7");

var _workout = __webpack_require__("Toxe");

var _member = __webpack_require__("1OIp");

var _mealPlan = __webpack_require__("KLwp");

var Dashboard = exports.Dashboard = {
  template: '\n    <div class="dashboard">\n      <div class="main-content bg-gray-dashboard d-flex flex-column">\n        <div class="mb-3"\n          ng-class="{\n            \'order-1\': $ctrl.hasNutrition,\n            \'order-2\': !$ctrl.hasNutrition\n          }">\n          <div ng-show="true">\n            <dashboard-nutrition-container\n              active-card="1"\n              index="$ctrl.dayIndex"\n              recipe-inspiration="$ctrl.recipeInspiration"\n              recipe-collection="$ctrl.recipeCollection"\n              meal-plan="$ctrl.mealPlan"\n              meal-plan-list="$ctrl.mealPlanList"\n              meal-plans-current="$ctrl.mealPlansCurrent"\n              meal-plans-total="$ctrl.mealPlansTotal"\n              subscription-id="$ctrl.subscription.id">\n            </dashboard-nutrition-container>\n          </div>\n          <div ng-show="$ctrl.hasWorkout && !$ctrl.hasNutrition">\n            <dashboard-nutrition-upgrade recipe-collection="$ctrl.recipeCollection">\n            </dashboard-nutrition-upgrade>\n          </div>\n        </div>\n        <div class="order-3 mb-3 pt-4 pb-4 bg-gray-dashboard">\n          <footer-dashboard></footer-dashboard>\n        </div>\n      </div>\n    </div>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);
        this.dayIndex = new Date().getDay();

        if (!this.recipeInspiration.length) {
          this.fetchRecipeInspiration(this.member.id, this.level);
        }

        if (!this.mealPlan.id) {
          this.fetchMealPlanActive();
        }

        if (!this.mealPlansCurrent.length) {
          this.fetchMealPlansCurrent(this.subscription.id);
        }

        if (!this.mealPlansTotal) {
          this.fetchMealPlansByVoome(this.subscription.id);
        }

        if (!this.recipeCollection) {
          this.fetchRecipeCollection('current', this.subscription.voomeProductId);
        }

        if (!this.workoutInspiration.length) {
          this.fetchWorkoutInspiration(this.member.id);
        }

        if (!this.workoutCollection) {
          this.fetchWorkoutCollection('current', this.subscription.voomeProductId);
        }

        if (!this.workoutVideo) {
          this.fetchWorkoutVideoCurrent(this.subscription.voomeProductId);
        }
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();
      },
      mapState: function mapState(_ref) {
        var favourite = _ref.favourite,
            mealPlan = _ref.mealPlan,
            member = _ref.member,
            recipe = _ref.recipe,
            workout = _ref.workout;

        var favouriteRecipeIds = (0, _favourite.selectFavouriteRecipeIds)(favourite);
        var favouriteWorkoutIds = (0, _favourite.selectFavouriteWorkoutIds)(favourite);

        return {
          level: (0, _member.selectMemberLevel)(member),
          member: (0, _member.selectMember)(member),
          subscription: (0, _member.selectSubscription)(member),
          hasNutrition: (0, _member.selectHasNutritionSubscription)(member),
          hasWorkout: (0, _member.selectHasWorkoutSubscription)(member),

          // Recipe Inspiration
          recipeInspiration: (0, _favourite.mapIsFavouriteRecipes)((0, _recipe.selectRecipeInspiration)(recipe), favouriteRecipeIds),

          // Recipe Collection
          recipeCollection: (0, _favourite.mapIsFavouriteRecipes)((0, _recipe.selectRecipeCollection)(recipe, recipe.result), favouriteRecipeIds),

          // Mealplans
          mealPlan: (0, _mealPlan.selectMealPlan)(mealPlan, mealPlan.active),
          mealPlanList: (0, _mealPlan.selectMealPlanList)(mealPlan, mealPlan.active),
          mealPlansCurrent: (0, _mealPlan.selectMealPlansCurrent)(mealPlan),
          mealPlansTotal: (0, _mealPlan.selectPaginationByType)(mealPlan, 'byVoome').total,

          workoutInspiration: (0, _favourite.mapIsFavouriteWorkouts)((0, _workout.selectWorkoutInspiration)(workout), favouriteWorkoutIds),

          workoutCollection: (0, _favourite.mapIsFavouriteWorkouts)((0, _workout.selectWorkoutCollection)(workout, workout.result), favouriteWorkoutIds),

          // Workout video
          workoutVideo: (0, _workout.selectWorkoutVideo)(workout, workout.currentVideoId)
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          fetchMealPlan: _mealPlan.fetchMealPlan,
          fetchMealPlanActive: _mealPlan.fetchMealPlanActive,
          fetchMealPlansByVoome: _mealPlan.fetchMealPlansByVoome,
          fetchMealPlansCurrent: _mealPlan.fetchMealPlansCurrent,
          fetchRecipeCollection: _recipe.fetchRecipeCollection,
          fetchRecipeInspiration: _recipe.fetchRecipeInspiration,
          fetchWorkoutCollection: _workout.fetchWorkoutCollection,
          fetchWorkoutInspiration: _workout.fetchWorkoutInspiration,
          fetchWorkoutVideoCurrent: _workout.fetchWorkoutVideoCurrent
        };
      }
    };
  }]
};

/***/ }),

/***/ "AYAf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AZVq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonPrint = exports.ButtonPrimary = exports.ButtonPlay = exports.ButtonLink = exports.ButtonFullWidth = exports.ButtonBlock = exports.ButtonBack = undefined;

var _ButtonBack = __webpack_require__("J1Ct");

Object.defineProperty(exports, 'ButtonBack', {
  enumerable: true,
  get: function get() {
    return _ButtonBack.ButtonBack;
  }
});

var _ButtonBlock = __webpack_require__("sAsw");

Object.defineProperty(exports, 'ButtonBlock', {
  enumerable: true,
  get: function get() {
    return _ButtonBlock.ButtonBlock;
  }
});

var _ButtonFullWidth = __webpack_require__("Ede+");

Object.defineProperty(exports, 'ButtonFullWidth', {
  enumerable: true,
  get: function get() {
    return _ButtonFullWidth.ButtonFullWidth;
  }
});

var _ButtonLink = __webpack_require__("121k");

Object.defineProperty(exports, 'ButtonLink', {
  enumerable: true,
  get: function get() {
    return _ButtonLink.ButtonLink;
  }
});

var _ButtonPlay = __webpack_require__("fD+P");

Object.defineProperty(exports, 'ButtonPlay', {
  enumerable: true,
  get: function get() {
    return _ButtonPlay.ButtonPlay;
  }
});

var _ButtonPrimary = __webpack_require__("lcW8");

Object.defineProperty(exports, 'ButtonPrimary', {
  enumerable: true,
  get: function get() {
    return _ButtonPrimary.ButtonPrimary;
  }
});

var _ButtonPrint = __webpack_require__("G7cR");

Object.defineProperty(exports, 'ButtonPrint', {
  enumerable: true,
  get: function get() {
    return _ButtonPrint.ButtonPrint;
  }
});

__webpack_require__("6cDV");

/***/ }),

/***/ "AjmZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavSub = exports.NavProductTitle = exports.NavPlain = exports.NavMobileSidebar = exports.NavPage = exports.NavMain = exports.NavLogo = exports.NavItem = exports.NavFullscreen = exports.NavDropdown = exports.NavChildren = undefined;

var _NavChildren = __webpack_require__("xkTB");

Object.defineProperty(exports, 'NavChildren', {
  enumerable: true,
  get: function get() {
    return _NavChildren.NavChildren;
  }
});

var _NavDropdown = __webpack_require__("mHZh");

Object.defineProperty(exports, 'NavDropdown', {
  enumerable: true,
  get: function get() {
    return _NavDropdown.NavDropdown;
  }
});

var _NavFullscreen = __webpack_require__("Uw4W");

Object.defineProperty(exports, 'NavFullscreen', {
  enumerable: true,
  get: function get() {
    return _NavFullscreen.NavFullscreen;
  }
});

var _NavItem = __webpack_require__("or7O");

Object.defineProperty(exports, 'NavItem', {
  enumerable: true,
  get: function get() {
    return _NavItem.NavItem;
  }
});

var _NavLogo = __webpack_require__("Xcm0");

Object.defineProperty(exports, 'NavLogo', {
  enumerable: true,
  get: function get() {
    return _NavLogo.NavLogo;
  }
});

var _NavMain = __webpack_require__("V+lE");

Object.defineProperty(exports, 'NavMain', {
  enumerable: true,
  get: function get() {
    return _NavMain.NavMain;
  }
});

var _NavPage = __webpack_require__("M3Et");

Object.defineProperty(exports, 'NavPage', {
  enumerable: true,
  get: function get() {
    return _NavPage.NavPage;
  }
});

var _NavMobileSidebar = __webpack_require__("tdVs");

Object.defineProperty(exports, 'NavMobileSidebar', {
  enumerable: true,
  get: function get() {
    return _NavMobileSidebar.NavMobileSidebar;
  }
});

var _NavPlain = __webpack_require__("py1b");

Object.defineProperty(exports, 'NavPlain', {
  enumerable: true,
  get: function get() {
    return _NavPlain.NavPlain;
  }
});

var _NavProductTitle = __webpack_require__("g+GI");

Object.defineProperty(exports, 'NavProductTitle', {
  enumerable: true,
  get: function get() {
    return _NavProductTitle.NavProductTitle;
  }
});

var _NavSub = __webpack_require__("fIwf");

Object.defineProperty(exports, 'NavSub', {
  enumerable: true,
  get: function get() {
    return _NavSub.NavSub;
  }
});

__webpack_require__("WoY2");

/***/ }),

/***/ "AqLc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardWorkout = exports.CardVideo = exports.CardRecipe = exports.CardPlain = exports.CardImage = exports.CardCollection = exports.CardBook = exports.CardBadgeFlame = exports.CardBadge = exports.Card = undefined;

var _Card = __webpack_require__("WLBs");

Object.defineProperty(exports, 'Card', {
  enumerable: true,
  get: function get() {
    return _Card.Card;
  }
});

var _CardBadge = __webpack_require__("nnql");

Object.defineProperty(exports, 'CardBadge', {
  enumerable: true,
  get: function get() {
    return _CardBadge.CardBadge;
  }
});

var _CardBadgeFlame = __webpack_require__("47WH");

Object.defineProperty(exports, 'CardBadgeFlame', {
  enumerable: true,
  get: function get() {
    return _CardBadgeFlame.CardBadgeFlame;
  }
});

var _CardBook = __webpack_require__("Gpi/");

Object.defineProperty(exports, 'CardBook', {
  enumerable: true,
  get: function get() {
    return _CardBook.CardBook;
  }
});

var _CardCollection = __webpack_require__("rEmd");

Object.defineProperty(exports, 'CardCollection', {
  enumerable: true,
  get: function get() {
    return _CardCollection.CardCollection;
  }
});

var _CardImage = __webpack_require__("Z6Nm");

Object.defineProperty(exports, 'CardImage', {
  enumerable: true,
  get: function get() {
    return _CardImage.CardImage;
  }
});

var _CardPlain = __webpack_require__("lCsa");

Object.defineProperty(exports, 'CardPlain', {
  enumerable: true,
  get: function get() {
    return _CardPlain.CardPlain;
  }
});

var _CardRecipe = __webpack_require__("UUvd");

Object.defineProperty(exports, 'CardRecipe', {
  enumerable: true,
  get: function get() {
    return _CardRecipe.CardRecipe;
  }
});

var _CardVideo = __webpack_require__("ZKJ1");

Object.defineProperty(exports, 'CardVideo', {
  enumerable: true,
  get: function get() {
    return _CardVideo.CardVideo;
  }
});

var _CardWorkout = __webpack_require__("VMkk");

Object.defineProperty(exports, 'CardWorkout', {
  enumerable: true,
  get: function get() {
    return _CardWorkout.CardWorkout;
  }
});

__webpack_require__("E5hx");

/***/ }),

/***/ "BTk+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormReview = __webpack_require__("AOsR");

Object.defineProperty(exports, 'FormReview', {
  enumerable: true,
  get: function get() {
    return _FormReview.FormReview;
  }
});

/***/ }),

/***/ "BZr3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CreditCard = __webpack_require__("Ea+A");

Object.defineProperty(exports, 'CreditCardNumber', {
  enumerable: true,
  get: function get() {
    return _CreditCard.CreditCardNumber;
  }
});
Object.defineProperty(exports, 'CreditCardDate', {
  enumerable: true,
  get: function get() {
    return _CreditCard.CreditCardDate;
  }
});

/***/ }),

/***/ "Bw88":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertWeight = undefined;

var _memoize2 = __webpack_require__("zGZ6");

var _memoize3 = _interopRequireDefault(_memoize2);

var _utils = __webpack_require__("0xDb");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var convertWeight = exports.convertWeight = function convertWeight() {
  return (0, _memoize3.default)(function (weight, gender) {
    return (0, _utils.convertWeight)(weight, gender || 'F');
  }, function (weight, gender) {
    return weight + '-' + gender;
  });
};

/***/ }),

/***/ "ByHG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Alert = exports.Alert = {
  transclude: true,

  bindings: {
    type: '@'
  },

  template: '\n    <div class="alert alert-{{ $ctrl.type }} text-center mb-4">\n      <ng-transclude></ng-transclude>\n    </div>'
};

/***/ }),

/***/ "C+C0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _WelcomeStepActions = __webpack_require__("FEoJ");

Object.defineProperty(exports, 'WelcomeStepActions', {
  enumerable: true,
  get: function get() {
    return _WelcomeStepActions.WelcomeStepActions;
  }
});

var _WelcomeStepBundle = __webpack_require__("YRlT");

Object.defineProperty(exports, 'WelcomeStepBundle', {
  enumerable: true,
  get: function get() {
    return _WelcomeStepBundle.WelcomeStepBundle;
  }
});

var _WelcomeStepNutrition = __webpack_require__("cMck");

Object.defineProperty(exports, 'WelcomeStepNutrition', {
  enumerable: true,
  get: function get() {
    return _WelcomeStepNutrition.WelcomeStepNutrition;
  }
});

var _WelcomeStepPassword = __webpack_require__("eAOE");

Object.defineProperty(exports, 'WelcomeStepPassword', {
  enumerable: true,
  get: function get() {
    return _WelcomeStepPassword.WelcomeStepPassword;
  }
});

var _WelcomeStepProfile = __webpack_require__("1sOY");

Object.defineProperty(exports, 'WelcomeStepProfile', {
  enumerable: true,
  get: function get() {
    return _WelcomeStepProfile.WelcomeStepProfile;
  }
});

var _WelcomeStepPrograms = __webpack_require__("wUEi");

Object.defineProperty(exports, 'WelcomeStepPrograms', {
  enumerable: true,
  get: function get() {
    return _WelcomeStepPrograms.WelcomeStepPrograms;
  }
});

var _WelcomeStepWorkout = __webpack_require__("Dogx");

Object.defineProperty(exports, 'WelcomeStepWorkout', {
  enumerable: true,
  get: function get() {
    return _WelcomeStepWorkout.WelcomeStepWorkout;
  }
});

/***/ }),

/***/ "CCj3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CMyD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReviewReply = exports.Review = undefined;

var _Review = __webpack_require__("HsA4");

Object.defineProperty(exports, 'Review', {
  enumerable: true,
  get: function get() {
    return _Review.Review;
  }
});

var _ReviewReply = __webpack_require__("lQ93");

Object.defineProperty(exports, 'ReviewReply', {
  enumerable: true,
  get: function get() {
    return _ReviewReply.ReviewReply;
  }
});

__webpack_require__("RQBS");

/***/ }),

/***/ "CQlg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DOwP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ProfileFieldsMore = exports.ProfileFieldsMore = {
  bindings: {
    form: '<',
    member: '<',
    onUpdate: '&',
    isEditing: '<'
  },

  template: '\n    <div class="row">\n      <div class="col-md-4">\n        <h5>More about you</h5>\n        <p>Please tell us a bit more about yourself.</p>\n      </div>\n      <div class="col-md-8">\n        <form-group-row>\n          <form-group-left>\n            <form-label for="profile.birthday">\n              Date of birth\n            </form-label>\n          </form-group-left>\n          <form-group-right>\n            <form-select-date\n              form="$ctrl.form"\n              name="profile.birthday"\n              value="$ctrl.member.profile.birthday"\n              year-start="-18"\n              year-number="80"\n              required="true"\n              ng-show="$ctrl.isEditing"\n              on-update="$ctrl.onUpdate({ key: key, value: value })"\n              errors="{\n                required: \'This is a required field.\',\n                date: \'Must be a valid date.\'\n              }">\n            </form-select-date>\n            <div class="col-form-label pb-0" ng-hide="$ctrl.isEditing">\n              {{ $ctrl.member.profile.birthday | date:\'dd-MM-yyyy\' }}\n            </div>\n          </form-group-right>\n        </form-group-row>\n        <hr>\n        <form-group-row>\n          <form-group-left>\n            <form-label for="profile.gender">\n              Gender\n            </form-label>\n          </form-group-left>\n          <form-group-right>\n            <form-select\n              form="$ctrl.form"\n              name="profile.gender"\n              value="$ctrl.member.profile.gender"\n              required="true"\n              ng-show="$ctrl.isEditing"\n              on-update="$ctrl.onUpdate({ key: key, value: value })"\n              errors="{ required: \'This is a required field.\' }">\n              <option value="">-- Select --</option>\n              <option value="F">Female</option>\n              <option value="M">Male</option>\n            </form-select>\n            <div class="col-form-label pb-0" ng-hide="$ctrl.isEditing">\n              <span class="text-gray-900">\n                {{ $ctrl.member.profile.gender === \'F\' ? \'Female\' : \'Male\' }}\n              </span>\n            </div>\n          </form-group-right>\n        </form-group-row>\n        <hr>\n        <form-group-row>\n          <form-group-left>\n            <form-label for="startWeightInKg">\n              Weight <span class="text-gray">(kg)<span>\n            </form-label>\n          </form-group-left>\n          <form-group-right>\n            <form-input\n              type="number"\n              form="$ctrl.form"\n              name="startWeightInKg"\n              value="$ctrl.member.startWeightInKg"\n              minlength="1"\n              required="true"\n              ng-show="$ctrl.isEditing"\n              on-update="$ctrl.onUpdate({ key: key, value: value })"\n              errors="{ required: \'This is a required field.\' }"/>\n            <div class="col-form-label pb-0" ng-hide="$ctrl.isEditing">\n              <span class="text-gray-900">\n                {{ $ctrl.member.startWeightInKg }}\n              </span>\n            </div>\n          </form-group-right>\n        </form-group-row>\n        <hr>\n        <form-group-row>\n          <form-group-left>\n            <form-label for="profile.height">\n              Height <span class="text-gray">(cm)<span>\n            </form-label>\n          </form-group-left>\n          <form-group-right>\n            <form-input\n              type="number"\n              form="$ctrl.form"\n              name="profile.height"\n              value="$ctrl.member.profile.height"\n              minlength="1"\n              required="true"\n              ng-show="$ctrl.isEditing"\n              on-update="$ctrl.onUpdate({ key: key, value: value })"\n              errors="{ required: \'This is a required field.\' }"/>\n            <div class="col-form-label pb-0" ng-hide="$ctrl.isEditing">\n              <span class="text-gray-900">\n                {{ $ctrl.member.profile.height }}\n              </span>\n            </div>\n          </form-group-right>\n        </form-group-row>\n      </div>\n    </div>'
};

/***/ }),

/***/ "Dlh9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var locationProvider = exports.locationProvider = ["$locationProvider", function locationProvider($locationProvider) {
  'ngInject';

  $locationProvider.html5Mode(true);
}];

/***/ }),

/***/ "Dogx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WelcomeStepWorkout = exports.WelcomeStepWorkout = {
  transclude: true,

  bindings: {
    isLoading: '<',
    member: '<',
    scrollTo: '&',
    onSubmit: '&',
    onUpdate: '&'
  },

  template: '\n    <div class="welcome-step-workout">\n      <h1 class="h2 text-center text-white my-4">\n        Your Workout Profile\n      </h1>\n      <section class="theme-light p-3 mb-5">\n        <form class="voome-form voome-form--workout"\n          name="form"\n          ng-submit="$ctrl.onSubmit({ data: $ctrl.member })"\n          novalidate>\n          <speech-bubble-workout\n            form="form"\n            member="$ctrl.member"\n            scroll-to="$ctrl.scrollTo({ id: id })"\n            on-complete="$ctrl.isComplete = true"\n            on-update="$ctrl.onUpdate({ key: key, value: value })">\n          </speech-bubble-workout>\n          <div class="d-flex justify-content-center pt-4"\n            ng-show="$ctrl.isComplete">\n            <ng-transclude></ng-transclude>\n          </div>\n        </form>\n      </section>\n    </div>'
};

/***/ }),

/***/ "DzvN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SearchFilterWorkouts = exports.SearchFilterWorkouts = {
  bindings: {
    filters: '<',
    onClick: '&'
  },

  template: '\n    <div class="search-filter-workouts">\n      <search-filter\n        title="Location"\n        type="radio"\n        list="$ctrl.filters[\'Location\']"\n        on-click="$ctrl.onClick({ item: item, type: type, list: list, key: \'filters\'})">\n      </search-filter>\n      <search-filter\n        title="Level"\n        type="radio"\n        list="$ctrl.filters[\'Level\']"\n        on-click="$ctrl.onClick({ item: item, type: type, list: list, key: \'filters\'})">\n      </search-filter>\n      <search-filter\n        title="Intensity"\n        type="checkbox"\n        list="$ctrl.filters[\'Intensity\']"\n        on-click="$ctrl.onClick({ item: item, type: type, list: list, key: \'filters\'})">\n      </search-filter>\n      <search-filter\n        title="Type"\n        type="radio"\n        list="$ctrl.filters[\'Type\']"\n        on-click="$ctrl.onClick({ item: item, type: type, list: list, key: \'filters\'})">\n      </search-filter>\n      <search-filter\n        title="Body Focus"\n        type="radio"\n        list="$ctrl.filters[\'Body Focus\']"\n        on-click="$ctrl.onClick({ item: item, type: type, list: list, key: \'filters\'})">\n      </search-filter>\n      <search-filter\n        title="Theme"\n        type="radio"\n        list="$ctrl.filters[\'Theme\']"\n        on-click="$ctrl.onClick({ item: item, type: type, list: list, key: \'filters\'})">\n      </search-filter>\n    </div>'
};

/***/ }),

/***/ "E2e5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WorkoutPlayerFinishModal = exports.WorkoutPlayerFinishModal = {
  bindings: {
    isFinished: '<',
    onFinish: '&'
  },

  template: '\n    <a\n      href="#"\n      ng-click="$ctrl.show()"\n      ng-if="!$ctrl.isFinished">\n      Finish\n    </a>\n    <div class="modal fade"\n      tabindex="-1"\n      role="dialog"\n      aria-hidden="true">\n      <div class="modal-dialog" role="document">\n        <div class="modal-content">\n          <div class="modal-header text-center">\n            <h5 class="modal-title m-auto">\n              Are you sure you are done?\n            </h5>\n          </div>\n          <div class="modal-footer justify-content-center">\n            <button-primary ng-click="$ctrl.onFinish(); $ctrl.hide()">\n              Yes\n            </button-primary>\n            <button-primary\n              is-inverse="\'true\'"\n              data-dismiss="modal">\n              No\n            </button-primary>\n          </div>\n        </div>\n      </div>\n    </div>',

  controller: ["$element", function controller($element) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        this.modal = $element.find('.modal');
      },
      show: function show() {
        this.modal.modal();
      },
      hide: function hide() {
        this.modal.modal('hide');
      }
    };
  }]
};

/***/ }),

/***/ "E5hx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ea+A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreditCardDate = exports.CreditCardNumber = undefined;

var _cardValidator = __webpack_require__("y0t6");

var _cardValidator2 = _interopRequireDefault(_cardValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreditCardNumber = exports.CreditCardNumber = function CreditCardNumber() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link() {
      arguments[3].$validators.creditCardNumber = function (value) {
        var numberValidation = _cardValidator2.default.number(value);
        var isAccepted = /visa|american-express|master-card/.test(numberValidation.card && numberValidation.card.type);

        return isAccepted && numberValidation.isValid;
      };
    }
  };
};

var CreditCardDate = exports.CreditCardDate = function CreditCardDate() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link($scope, $element, $attrs, $model) {
      $model.$validators.creditCardDate = function (value) {
        var _$scope$$eval = $scope.$eval($attrs.creditCardDate),
            month = _$scope$$eval.month,
            year = _$scope$$eval.year;

        if (month && year && month.$viewValue && year.$viewValue) {
          var _cardValidator$expira = _cardValidator2.default.expirationDate({
            month: month.$viewValue,
            year: year.$viewValue
          }),
              isValid = _cardValidator$expira.isValid;

          month.$setValidity('creditCardDate', isValid);
          year.$setValidity('creditCardDate', isValid);

          return isValid;
        } else {
          return true;
        }
      };
    }
  };
};

/***/ }),

/***/ "EaOo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WorkoutPlayerFinished = exports.WorkoutPlayerFinished = {
  bindings: {
    workout: '<',
    member: '<',
    voomeProductId: '<'
  },

  template: '\n    <div class="workout-player-finished">\n      <h4 class="workout-player-finished-title text-center my-3">\n        <i class="fa fa-check-circle-o"></i>\n        Workout Done!\n      </h4>\n      <div class="workout-player-summary">\n        <span class="workout-player-summary-img"></span>\n        <div class="workout-player-summary-content">\n          <h2 class="workout-player-summary-title">\n            {{ $ctrl.workout.name }}\n          </h2>\n          <ul class="workout-player-summary-meta list-inline">\n            <li>\n              <i class="fa icon-calories-burnt"></i>\n              <workout-calories-burnt\n                member="$ctrl.member"\n                met="$ctrl.workout.met"\n                total-time="$ctrl.workout.totalTime">\n              </workout-calories-burnt> Cal\n            </li>\n            <li ng-if="$ctrl.workout.totalTimeVerbose">\n              <i class="fa icon-time"></i>\n              {{ $ctrl.workout.totalTimeVerbose }}\n            </li>\n          </ul>\n        </div>\n      </div>\n      <div class="workout-player-footer">\n        <div class="workout-player-caption px-4">\n          <a class="back-btn"\n            ui-sref="program({ voomeProductId: $ctrl.voomeProductId })">\n            <i class="fa fa-home"></i> Home\n          </a>\n        </div>\n      </div>\n    </div>'
};

/***/ }),

/***/ "Ede+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ButtonFullWidth = exports.ButtonFullWidth = {
  transclude: true,

  bindings: {
    modalTarget: '@',
    onClick: '&'
  },

  template: '\n    <button\n      type="button"\n      class="btn btn-lg btn-full-width theme-btn font-weight-bold sm-word-wrap rounded-0 w-100 py-3"\n      ng-attr-data-toggle="{{ $ctrl.modalTarget ? \'modal\' : \'\' }}"\n      data-target="{{ $ctrl.modalTarget }}"\n      ng-click="$ctrl.onClick()">\n      <i class="fa fa-angle-double-right" aria-hidden="true"></i>\n      <ng-transclude></ng-transclude>\n      <i class="fa fa-angle-double-left" aria-hidden="true"></i>\n    </button>'
};

/***/ }),

/***/ "Esjb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WorkoutsDetail = exports.WorkoutsDetail = {
  template: "\n    <div class=\"workouts-detail bg-white\">\n      <workout>\n        <workout-nav-left>\n          <button-back></button-back>\n        </workout-nav-left>\n      </workout>\n    </div>"
};

/***/ }),

/***/ "FEoJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WelcomeStepActions = exports.WelcomeStepActions = {
  transclude: true,

  bindings: {
    isLoading: '<',
    onCancel: '&'
  },

  template: '\n    <div class="welcome-step-actions">\n      <button-primary\n        class="mr-1"\n        ng-click="$ctrl.onCancel()"\n        is-inverse="true">\n        Cancel\n      </button-primary>\n      <button-primary\n        ng-type="submit"\n        ng-disabled="$ctrl.isLoading">\n        <spinner is-loading="$ctrl.isLoading">\n          <ng-transclude>Done</ng-transclude>\n        </spinner>\n      </button-primary>\n    </div>'
};

/***/ }),

/***/ "FL69":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FQ9i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifyCreditCard = exports.verify = exports.updateChargifyData = exports.update = exports.submitTransactionData = exports.setupChargifyError = exports.setup = exports.restore = exports.reset = exports.checkStatus = exports.fetchProducts = exports.getWeeklyProductText = exports.parseVerifyParams = exports.parseSetupParams = exports.getTransactionData = exports.selectUpgradeProduct = exports.selectProductsByType = exports.selectProductBySlug = exports.selectProduct = exports.selectProducts = exports.signupLogic = exports.initialState = undefined;

var _pickBy2 = __webpack_require__("6PBa");

var _pickBy3 = _interopRequireDefault(_pickBy2);

var _pick2 = __webpack_require__("w9Mt");

var _pick3 = _interopRequireDefault(_pick2);

var _mapKeys2 = __webpack_require__("g7Do");

var _mapKeys3 = _interopRequireDefault(_mapKeys2);

var _kebabCase2 = __webpack_require__("Ex7i");

var _kebabCase3 = _interopRequireDefault(_kebabCase2);

var _isEmpty2 = __webpack_require__("lHK6");

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _includes2 = __webpack_require__("q+Dy");

var _includes3 = _interopRequireDefault(_includes2);

var _findKey2 = __webpack_require__("PtNq");

var _findKey3 = _interopRequireDefault(_findKey2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;

var _reduxLogic = __webpack_require__("E0Bt");

var _reduxUiRouter = __webpack_require__("Zb/7");

var _normalizr = __webpack_require__("vNPR");

var _store = __webpack_require__("Y4FN");

var _store2 = _interopRequireDefault(_store);

var _auth = __webpack_require__("wnLK");

var _redirect = __webpack_require__("8G1E");

var _constants = __webpack_require__("qI5z");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

// Actions
var FETCH = '@@app/signup/FETCH';
var FETCH_SUCCESS = '@@app/signup/FETCH_SUCCESS';
var FETCH_ERROR = '@@app/signup/FETCH_ERROR';

var SETUP = '@@app/signup/SETUP';
var SETUP_SUCCESS = '@@app/signup/SETUP_SUCCESS';
var SETUP_ERROR = '@@app/signup/SETUP_ERROR';

var VERIFY = '@@app/signup/VERIFY';
var VERIFY_CREDITCARD = '@@app/signup/VERIFY_CREDITCARD';
var VERIFY_SUCCESS = '@@app/signup/VERIFY_SUCCESS';
var VERIFY_ERROR = '@@app/signup/VERIFY_ERROR';

var STATUS = '@@app/signup/STATUS';
var STATUS_SUCCESS = '@@app/signup/STATUS_SUCCESS';
var STATUS_ERROR = '@@app/signup/STATUS_ERROR';

var RESTORE = '@@app/signup/RESTORE';
var UPDATE = '@@app/signup/UPDATE';
var UPDATE_DATA = '@@app/signup/UPDATE_DATA';
var TRANSACTION = '@@app/signup/TRANSACTION';
var RESET = '@@app/signup/RESET';

var initialState = exports.initialState = {
  isDisabled: false,
  isLoading: false,
  coupon: null,
  message: null,
  step: 1,
  type: 'weekly',
  voomeProducts: null,
  voomeProductId: null,
  chargifyData: {
    apiId: null,
    timestamp: null,
    nonce: null,
    data: null,
    signature: null,
    email: null,
    emailConfirmation: null,
    firstName: null,
    lastName: null,
    cardNumber: null,
    expirationMonth: null,
    expirationYear: null,
    initialChargeInCents: null,
    subscriptionId: null,
    redirectUri: null
  }
};

// Observables
var chargifyStatusLogic = (0, _reduxLogic.createLogic)({
  type: STATUS,
  processOptions: {
    successType: STATUS_SUCCESS,
    failType: STATUS_ERROR
  },
  process: function process(_ref) {
    var httpClient = _ref.httpClient;

    var endpoint = '/v1/chargify-subscriptions/check-product';
    var params = { roundId: 1 };
    var onSuccess = function onSuccess(response) {
      return {
        isDisabled: (0, _isEmpty3.default)(response.data.product)
      };
    };

    return httpClient.get(endpoint, { params: params }).then(onSuccess);
  }
});

var fetchProductsLogic = (0, _reduxLogic.createLogic)({
  type: FETCH,
  processOptions: {
    successType: FETCH_SUCCESS,
    failType: FETCH_ERROR
  },
  process: function process(_ref2) {
    var httpClient = _ref2.httpClient,
        action = _ref2.action;

    var endpoint = '/v1/voome/products';
    var params = { coupon: action.payload.coupon };
    var onSuccess = function onSuccess(response) {
      return (0, _mapKeys3.default)(response.data, function (item) {
        item.coupon = params.coupon;
        return item.id;
      });
    };

    return httpClient.get(endpoint, { params: params }).then(onSuccess);
  }
});

var resetLogic = (0, _reduxLogic.createLogic)({
  type: RESET,
  process: function process(_ref3, dispatch, done) {
    _objectDestructuringEmpty(_ref3);

    _store2.default.remove('signup');
    done();
  }
});

var setupLogic = (0, _reduxLogic.createLogic)({
  type: SETUP,
  processOptions: {
    successType: SETUP_SUCCESS,
    failType: SETUP_ERROR
  },
  process: function process(_ref4) {
    var action = _ref4.action,
        httpClient = _ref4.httpClient;

    var endpoint = '/v1/voome/subscriptions/setup';
    var params = action.payload;
    params.voomeProductId = 33; //Coaching Zone product discount 100%
    var onSuccess = function onSuccess(response) {
      if (response.data.product) {
        var totalInCents = response.data.product.totalInCents;


        if (totalInCents) {
          _store2.default.set('signup', _extends({}, _store2.default.get('signup'), { totalInCents: totalInCents }));
        }
      }

      return response.data;
    };

    _store2.default.set('signup', params);

    return httpClient.post(endpoint, params).then(onSuccess);
  }
});

var setupChargifyErrorLogic = (0, _reduxLogic.createLogic)({
  type: SETUP_ERROR,
  transform: function transform(_ref5, next) {
    var action = _ref5.action;
    var _action$payload = action.payload,
        code = _action$payload.code,
        response = _action$payload.response;


    var prepend = code ? _constants.CHARGIFY_ERROR_CODES[code] : response.data && response.data.errors ? response.data.errors[0] : 'There was an error setting up';

    var message = prepend === 'You have already purchased this product' ? 'You already have a Coaching Zone account. <a href="/" target="_self">Click here</a> to login / reactivate your account' : prepend + '. Please try again.';

    next(_extends({}, action, {
      payload: _extends({}, action.payload, {
        message: message
      })
    }));
  }
});

var submitTransactionLogic = (0, _reduxLogic.createLogic)({
  type: TRANSACTION,
  process: function process(_ref6, dispatch, done) {
    var action = _ref6.action,
        dataLayer = _ref6.dataLayer;

    var data = _store2.default.get('signup');
    var _action$payload2 = action.payload,
        memberId = _action$payload2.memberId,
        subscription = _action$payload2.subscription;


    if (memberId && subscription && data) {
      data.memberId = memberId;
      data.subscriptionId = subscription.id;
      data.subscriptionTitle = subscription.title;
      dataLayer.track('transaction', getTransactionData(data));
    }

    dispatch(reset());
    done();
  }
});

var verifyLogic = (0, _reduxLogic.createLogic)({
  type: VERIFY,
  processOptions: {
    successType: VERIFY_SUCCESS,
    failType: VERIFY_ERROR
  },
  process: function process(_ref7) {
    var action = _ref7.action,
        httpClient = _ref7.httpClient;

    var endpoint = '/v1/voome/subscriptions/verify';
    var params = action.payload;
    var onSuccess = function onSuccess(response) {
      return response.data;
    };

    return httpClient.post(endpoint, params).then(onSuccess);
  }
});

var verifyCreditCardLogic = (0, _reduxLogic.createLogic)({
  type: VERIFY_CREDITCARD,
  process: function process(_ref8, dispatch, done) {
    var action = _ref8.action,
        httpClient = _ref8.httpClient;

    var endpoint = '/v1/voome/subscriptions/verify-card-update';
    var _action$payload3 = action.payload,
        params = _action$payload3.params,
        redirectTo = _action$payload3.redirectTo;


    var onSuccess = function onSuccess(response) {
      dispatch(reset());

      if (redirectTo.name) {
        redirectTo.name === 'dashboard' ? window.location.assign('/dashboard') : dispatch((0, _reduxUiRouter.stateGo)(redirectTo.name, redirectTo.params));
      }
    };

    var onFail = function onFail() {
      return dispatch({ type: VERIFY_ERROR });
    };

    return httpClient.post(endpoint, params).then(onSuccess).catch(onFail).then(done);
  }
});

var verifySuccessLogic = (0, _reduxLogic.createLogic)({
  type: VERIFY_SUCCESS,
  process: function process(_ref9, dispatch, done) {
    var action = _ref9.action,
        dataLayer = _ref9.dataLayer,
        memberStorage = _ref9.memberStorage;
    var _action$payload4 = action.payload,
        authToken = _action$payload4.authToken,
        memberId = _action$payload4.memberId;

    var _store$get = _store2.default.get('signup'),
        coupon = _store$get.coupon,
        email = _store$get.email,
        firstName = _store$get.firstName,
        lastName = _store$get.lastName,
        voomeProductId = _store$get.voomeProductId;

    dataLayer.track('paymentverified', {
      email: email,
      firstName: firstName,
      lastName: lastName,
      memberId: memberId,
      voomeProductId: voomeProductId
    });

    if (authToken) {
      memberStorage.set({ memberId: memberId, voomeProductId: voomeProductId });
      window.location.assign('/welcome');
    } else if ((0, _includes3.default)(_constants.SIGNUP_REDIRECT_LIST, coupon)) {
      dispatch((0, _redirect.goRedirect)());
    } else {
      var redirectTo = { name: 'welcome' };
      var message = 'Welcome back ' + firstName + '! As a returning Coaching Zone member, please login with your existing password. Forgot your password? Just click the \'forgot\' password link below.';
      memberStorage.set({ redirectTo: redirectTo, voomeProductId: voomeProductId });
      dispatch((0, _auth.authLogout)(message));
    }

    done();
  }
});

var signupLogic = exports.signupLogic = [chargifyStatusLogic, fetchProductsLogic, resetLogic, setupLogic, setupChargifyErrorLogic, submitTransactionLogic, verifyLogic, verifyCreditCardLogic, verifySuccessLogic];

// Selectors
var selectProducts = exports.selectProducts = function selectProducts(state) {
  return state.voomeProducts;
};

var selectProduct = exports.selectProduct = function selectProduct(state, voomeProductId) {
  var products = selectProducts(state) || {};
  var product = products[voomeProductId];

  return product ? _extends({}, product, {
    products: product.products.map(function (id) {
      return products[id];
    })
  }) : undefined;
};

var selectProductBySlug = exports.selectProductBySlug = function selectProductBySlug(state, slug) {
  var key = (0, _findKey3.default)(selectProducts(state), function (item) {
    return (0, _kebabCase3.default)(item.name) === slug;
  });

  return selectProduct(state, key);
};

var selectProductsByType = exports.selectProductsByType = function selectProductsByType(state) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'weekly';

  return (0, _pickBy3.default)(selectProducts(state), { type: type });
};

var selectUpgradeProduct = exports.selectUpgradeProduct = function selectUpgradeProduct(state, voomeProductId) {
  var products = selectProducts(state);
  var key = (0, _findKey3.default)(products, function (item) {
    return item.products.indexOf(voomeProductId) >= 0;
  });

  return key ? products[key] : {};
};

// Helpers
var getTransactionData = exports.getTransactionData = function getTransactionData(signup) {
  var memberId = signup.memberId,
      voomeProductId = signup.voomeProductId,
      subscriptionTitle = signup.subscriptionTitle,
      subscriptionId = signup.subscriptionId,
      email = signup.email,
      totalInCents = signup.totalInCents;


  var chargeInCents = parseFloat(totalInCents, 10);
  var taxInCents = Math.round(chargeInCents - chargeInCents / 1.1);
  var transactionTotal = (chargeInCents / 100).toFixed(2);
  var transactionTax = (taxInCents / 100).toFixed(2);
  var transactionTitle = (0, _kebabCase3.default)(subscriptionTitle);

  return {
    transactionId: subscriptionId,
    transactionMemberId: memberId,
    transactionEmail: email,
    transactionRegion: 'AU',
    transactionTitle: transactionTitle,
    transactionTotal: transactionTotal,
    transactionTax: transactionTax,
    transactionProducts: [{
      name: 'Voome Product',
      category: transactionTitle,
      method: 'CC',
      id: subscriptionId,
      price: transactionTotal,
      quantity: 1,
      sku: 'VPROD-' + transactionTitle.toUpperCase()
    }]
  };
};

var parseSetupParams = exports.parseSetupParams = function parseSetupParams() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _pick3.default)(params, ['email', 'firstName', 'lastName', 'programSignUp', 'redirectUri', 'subscriptionId']);
};

var parseVerifyParams = exports.parseVerifyParams = function parseVerifyParams() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _pick3.default)(params, ['api_id', 'call_id', 'nonce', 'result_code', 'signature', 'status_code', 'timestamp', 'voome_product_id']);
};

var getWeeklyProductText = exports.getWeeklyProductText = function getWeeklyProductText(_ref10) {
  var type = _ref10.type,
      name = _ref10.name,
      products = _ref10.products;

  return products && products.length ? products.map(function (product) {
    return _constants.SIGNUP_TEXT.weekly[product.name];
  }) : type === 'weekly' ? [_constants.SIGNUP_TEXT.weekly[name]] : undefined;
};

// Action Creators
var fetchProducts = exports.fetchProducts = function fetchProducts(coupon) {
  return { type: FETCH, payload: { coupon: coupon } };
};

var checkStatus = exports.checkStatus = function checkStatus() {
  return { type: STATUS };
};

var reset = exports.reset = function reset() {
  return { type: RESET };
};

var restore = exports.restore = function restore() {
  return { type: RESTORE, payload: _store2.default.get('signup') || {} };
};

var setup = exports.setup = function setup(params) {
  var voomeProductId = params.voomeProductId,
      chargifyData = params.chargifyData,
      coupon = params.coupon,
      utmParams = params.utmParams,
      campaignChannelMedium = params.campaignChannelMedium;


  return {
    type: SETUP,
    payload: _extends({}, parseSetupParams(chargifyData), {
      campaignChannelMedium: campaignChannelMedium,
      coupon: coupon,
      utmParams: utmParams,
      voomeProductId: voomeProductId
    })
  };
};

var setupChargifyError = exports.setupChargifyError = function setupChargifyError() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return { type: SETUP_ERROR, payload: { code: params.result_code || 4000 } };
};

var submitTransactionData = exports.submitTransactionData = function submitTransactionData(memberId, subscription) {
  return { type: TRANSACTION, payload: { memberId: memberId, subscription: subscription } };
};

var update = exports.update = function update(key, value) {
  return { type: UPDATE, payload: { key: key, value: value } };
};

var updateChargifyData = exports.updateChargifyData = function updateChargifyData(key, value) {
  return { type: UPDATE_DATA, payload: { key: key, value: value } };
};

var verify = exports.verify = function verify(payload) {
  return { type: VERIFY, payload: parseVerifyParams(payload) };
};

var verifyCreditCard = exports.verifyCreditCard = function verifyCreditCard(params, redirectTo) {
  return {
    type: VERIFY_CREDITCARD,
    payload: {
      params: parseVerifyParams(params),
      redirectTo: redirectTo
    }
  };
};

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case STATUS:
      return _extends({}, state, {
        isLoading: true
      });

    case FETCH:
      return _extends({}, state, {
        isLoading: true,
        coupon: payload.coupon,
        message: ''
      });

    case SETUP:
      return _extends({}, state, {
        isLoading: true,
        message: '',
        chargifyData: _extends({}, state.chargifyData, {
          email: payload.email || null,
          firstName: payload.firstName || null,
          lastName: payload.lastName || null,
          voomeProductId: payload.voomeProductId || null,
          redirectUri: payload.redirectUri || null,
          subscriptionId: payload.subscriptionId || null
        })
      });

    case RESTORE:
      return _extends({}, state, {
        voomeProductId: payload.voomeProductId,
        chargifyData: _extends({}, state.chargifyData, {
          email: payload.email || null,
          emailConfirmation: payload.email || null,
          firstName: payload.firstName || null,
          lastName: payload.lastName || null
        })
      });

    case UPDATE:
      return _extends({}, state, _defineProperty({
        message: ''
      }, payload.key, payload.value));

    case UPDATE_DATA:
      return _extends({}, state, {
        message: '',
        chargifyData: _extends({}, state.chargifyData, _defineProperty({}, payload.key, payload.value))
      });

    case VERIFY:
    case VERIFY_CREDITCARD:
      return _extends({}, state, {
        isLoading: true,
        step: 3
      });

    case RESET:
      return _extends({}, initialState, {
        voomeProducts: state.voomeProducts
      });

    case STATUS_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        isDisabled: payload.isDisabled
      });

    case FETCH_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        voomeProducts: _extends({}, state.voomeProducts, payload)
      });

    case SETUP_SUCCESS:
      var apiId = payload.apiId,
          data = payload.data,
          nonce = payload.nonce,
          signature = payload.signature,
          timestamp = payload.timestamp,
          product = payload.product;


      return _extends({}, state, {
        isLoading: false,
        step: 2,
        chargifyData: _extends({}, state.chargifyData, {
          apiId: apiId,
          data: data,
          nonce: nonce,
          signature: signature,
          timestamp: timestamp
        }),
        voomeProducts: product ? _extends({}, state.voomeProducts, _defineProperty({}, product.id, _extends({}, state.voomeProducts[product.id], {
          discountInCents: product.discountInCents,
          totalInCents: product.totalInCents
        }))) : _extends({}, state.voomeProducts)
      });

    case VERIFY_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        message: ''
      });

    case STATUS_ERROR:
      return _extends({}, state, {
        isLoading: false,
        isDisabled: true
      });

    case SETUP_ERROR:
      return _extends({}, state, {
        isLoading: false,
        step: 1,
        message: payload.message
      });

    case VERIFY_ERROR:
      return _extends({}, state, {
        isLoading: false,
        step: 1,
        message: '\n          An error occurred verifying your transaction. Please <a href="/profile/credit-card/resume" target="_self">Click here</a> to try again and if\n          the issues persists please contact support.'
      });

    default:
      return state;
  }
}

/***/ }),

/***/ "FeWv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DividerZigZag = exports.DividerZigZag = {
  transclude: true,

  template: "\n    <div class=\"divider-zig-zag\">\n      <ng-transclude></ng-transclude>\n      <hr class=\"divider m-0 border-0 d-inline-block\">\n    </div>"
};

/***/ }),

/***/ "Fp91":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormRadio = undefined;

var _set2 = __webpack_require__("4yG7");

var _set3 = _interopRequireDefault(_set2);

var _get2 = __webpack_require__("Q7hp");

var _get3 = _interopRequireDefault(_get2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormRadio = exports.FormRadio = {
  transclude: true,

  bindings: {
    form: '<',
    model: '<',
    key: '@',
    value: '@',
    onUpdate: '&'
  },

  template: '\n    <label>\n      <input\n        type="radio"\n        name="{{ $ctrl.key }}"\n        value="{{ $ctrl.value }}"\n        ng-model="$ctrl.form.data[$ctrl.key]"\n        ng-click="$ctrl.onUpdate({\n          key: $ctrl.key,\n          value: $ctrl.value,\n        })"/>\n      <span class="pl-1" ng-transclude></span>\n    </label>',

  controller: function controller() {
    return {
      $onChanges: function $onChanges(changes) {
        var newValue = (0, _get3.default)(changes, 'model.currentValue', '').toString();
        var oldValue = (0, _get3.default)(this.form.data, this.key);

        if (newValue.length && newValue !== oldValue) {
          (0, _set3.default)(this.form, ['data', this.key], newValue);
        }
      }
    };
  }
};

/***/ }),

/***/ "G7cR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ButtonPrint = exports.ButtonPrint = {
  transclude: true,

  bindings: {
    uri: '@',
    tooltip: '<'
  },

  template: '\n    <a class="btn btn-link px-1"\n      ng-href="{{ $ctrl.uri }}"\n      ng-show="$ctrl.uri"\n      data-toggle="tooltip-print">\n      <i class="fa fa-lg icon-print mr-0"></i>\n      <ng-transclude>Print</ng-transclude>\n    </a>',

  controller: function controller() {
    'ngInject';

    return {
      $onChanges: function $onChanges(_ref) {
        var tooltip = _ref.tooltip;

        if (tooltip && tooltip.currentValue) {
          $('[data-toggle="tooltip-print"]').tooltip('dispose');
          $('[data-toggle="tooltip-print"]').tooltip({
            placement: 'left',
            title: tooltip.currentValue
          });
        }
      },
      $onDestroy: function $onDestroy() {
        $('[data-toggle="tooltip-print"]').tooltip('hide');
      }
    };
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "GCmo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResetPassword = undefined;

var _member = __webpack_require__("1OIp");

var _theme = __webpack_require__("ZID5");

var ResetPassword = exports.ResetPassword = {
  template: '\n    <div class="login" ng-hide="$ctrl.auth.token">\n      <div class="main-content theme-mid pt-4">\n        <div class="container align-items-center justify-content-center pb-5">\n          <header class="text-center pt-2 pb-4">\n            <divider-zig-zag>\n              <h1 class="h2 text-white">\n                Reset your Password\n              </h1>\n            </divider-zig-zag>\n          </header>\n          <div class="row mb-4">\n            <div class="col-lg-6 mx-auto px-2 px-sm-0">\n              <section class="p-3 theme-light">\n                <div class="container px-3 px-lg-4 pt-5 pb-3 bg-white">\n                  <div scroll-top-on-change="$ctrl.member.message">\n                    <alert type="{{ $ctrl.member.error ? \'danger\' : \'success\' }}"\n                      ng-if="$ctrl.member.message">\n                      {{ $ctrl.member.message }}\n                    </alert>\n                  </div>\n                  <form-reset-password\n                    ng-if="!$ctrl.isUpdate"\n                    email="$ctrl.email"\n                    member="$ctrl.member"\n                    on-submit="$ctrl.resetPasswordCreate(data)">\n                  </form-reset-password>\n                  <form-reset-password\n                    ng-if="$ctrl.isUpdate"\n                    is-update="$ctrl.isUpdate"\n                    email="$ctrl.email"\n                    member="$ctrl.member"\n                    reset-password-token="$ctrl.resetPasswordToken"\n                    on-submit="$ctrl.resetPasswordUpdate(data)">\n                  </form-reset-password>\n                </div>\n              </section>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>',

  controller: ["$ngRedux", "$stateParams", function controller($ngRedux, $stateParams) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.unsubscribe = connect(this);

        this.email = $stateParams.email;
        this.resetPasswordToken = $stateParams.reset_password_token;
        this.isUpdate = this.email && this.resetPasswordToken;

        // Use the plain nav so member can't navigate.
        this.setNavType('plain');

        // Reset the form when there are no $stateParams
        if (!this.email && !this.resetPasswordToken) {
          this.resetPasswordInit();
        }
      },
      $onDestroy: function $onDestroy() {
        this.unsubscribe();
      },
      mapState: function mapState(_ref) {
        var member = _ref.member;

        return { member: member };
      },
      mapDispatch: function mapDispatch() {
        return {
          resetPasswordInit: _member.resetPasswordInit,
          resetPasswordCreate: _member.resetPasswordCreate,
          resetPasswordUpdate: _member.resetPasswordUpdate,
          setNavType: _theme.setNavType
        };
      }
    };
  }]
};

/***/ }),

/***/ "GL9b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GLK9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DividerZigZag = exports.DividerHr = undefined;

var _Hr = __webpack_require__("SkQs");

Object.defineProperty(exports, 'DividerHr', {
  enumerable: true,
  get: function get() {
    return _Hr.DividerHr;
  }
});

var _ZigZag = __webpack_require__("FeWv");

Object.defineProperty(exports, 'DividerZigZag', {
  enumerable: true,
  get: function get() {
    return _ZigZag.DividerZigZag;
  }
});

__webpack_require__("1sRP");

/***/ }),

/***/ "GfAe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectFavouriteWorkoutsReload = exports.selectFavouriteWorkouts = exports.selectFavouriteWorkoutIds = exports.selectFavouriteVideosReload = exports.selectFavouriteVideos = exports.selectFavouriteVideoIds = exports.selectFavouriteRecipesReload = exports.selectFavouriteRecipes = exports.selectFavouriteRecipeIds = exports.selectShouldReload = exports.selectFavourites = exports.mapIsFavouriteVideos = exports.mapIsFavouriteRecipes = exports.mapIsFavouriteWorkouts = exports.toggleFavouriteWorkout = exports.toggleFavouriteVideo = exports.toggleFavouriteRecipe = exports.fetchFavouriteWorkouts = exports.fetchFavouriteVideos = exports.fetchFavouriteRecipes = exports.fetchFavouriteWorkoutIds = exports.fetchFavouriteVideoIds = exports.fetchFavouriteRecipeIds = exports.initFavourites = exports.favouriteLogic = exports.initialState = undefined;

var _maxBy2 = __webpack_require__("K1hn");

var _maxBy3 = _interopRequireDefault(_maxBy2);

var _map2 = __webpack_require__("2247");

var _map3 = _interopRequireDefault(_map2);

var _includes2 = __webpack_require__("q+Dy");

var _includes3 = _interopRequireDefault(_includes2);

var _isArray2 = __webpack_require__("NGEn");

var _isArray3 = _interopRequireDefault(_isArray2);

var _filter2 = __webpack_require__("RyI1");

var _filter3 = _interopRequireDefault(_filter2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;

var _normalizr = __webpack_require__("vNPR");

var _reduxLogic = __webpack_require__("E0Bt");

var _utils = __webpack_require__("0xDb");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Action Types
var FETCH = '@@app/favourites/FETCH';
var FETCH_SUCCESS = '@@app/favourites/FETCH_SUCCESS';

var FETCH_IDS = '@@app/favourites/FETCH_IDS';
var FETCH_IDS_SUCCESS = '@@app/favourites/FETCH_IDS_SUCCESS';

var POST = '@@app/favourites/POST';
var POST_SUCCESS = '@@app/favourites/POST_SUCCESS';

var DELETE = '@@app/favourites/DELETE';
var DELETE_SUCCESS = '@@app/favourites/DELETE_SUCCESS';

var INIT = '@@app/favourites/INIT';
var ERROR = '@@app/favourites/ERROR';
var CANCEL = '@@app/favourites/CANCEL';

// Initial State
var initialState = exports.initialState = {
  isLoading: false,
  entities: {
    PlaylistVideo: {},
    recipes: {},
    workouts: {}
  },
  ids: {
    PlaylistVideo: [],
    recipes: [],
    workouts: []
  },
  pagination: {
    PlaylistVideo: {},
    recipes: {},
    workouts: {}
  }
};

// Observables
var deleteLogic = (0, _reduxLogic.createLogic)({
  type: DELETE,
  processOptions: {
    successType: DELETE_SUCCESS,
    failType: ERROR
  },
  process: function process(_ref) {
    var action = _ref.action,
        httpClient = _ref.httpClient;
    var _action$payload = action.payload,
        memberId = _action$payload.memberId,
        params = _action$payload.params;
    var itemId = params.itemId,
        itemType = params.itemType;

    // Hack till API is updated for workouts & recipes

    var endpoint = itemType === 'PlaylistVideo' ? '/v1/voome/members/' + memberId + '/favourites/undo' : '/v1/members/' + memberId + '/favourite_' + itemType + '/' + itemId;

    return httpClient.delete(endpoint, { params: params }).then(function () {
      return params;
    });
  }
});

var fetchIdsLogic = (0, _reduxLogic.createLogic)({
  type: FETCH_IDS,
  processOptions: {
    successType: FETCH_IDS_SUCCESS,
    failType: ERROR
  },
  process: function process(_ref2) {
    var action = _ref2.action,
        httpClient = _ref2.httpClient;
    var _action$payload2 = action.payload,
        memberId = _action$payload2.memberId,
        params = _action$payload2.params;
    var itemType = params.itemType;

    // Hack till API is updated for workouts & recipes

    var endpoint = itemType === 'PlaylistVideo' ? '/v1/voome/members/' + memberId + '/favourites/ids' : '/v1/members/' + memberId + '/favourite_' + itemType + '/ids';

    return httpClient.get(endpoint, { params: params }).then(function (_ref3) {
      var data = _ref3.data;
      return _extends({}, params, { data: data });
    });
  }
});

var fetchLogic = (0, _reduxLogic.createLogic)({
  type: FETCH,
  processOptions: {
    successType: FETCH_SUCCESS,
    failType: ERROR
  },
  process: function process(_ref4) {
    var action = _ref4.action,
        httpClient = _ref4.httpClient;
    var _action$payload3 = action.payload,
        memberId = _action$payload3.memberId,
        params = _action$payload3.params;
    var itemType = params.itemType,
        level = params.level,
        order = params.order,
        page = params.page;


    var onSuccess = function onSuccess(_ref5) {
      var data = _ref5.data,
          pagination = _ref5.pagination;

      // Hack till API is updated for workouts & recipes
      var legacyData = itemType === 'recipes' ? (0, _map3.default)(data, function (recipeVariations) {
        return (0, _maxBy3.default)(recipeVariations, 'serves');
      }) : data;

      var normalizedPagination = (0, _utils.normalizePagination)({
        pagination: pagination,
        data: legacyData,
        key: itemType,
        idAttribute: paginationKey(params)
      });

      return _extends({
        itemType: itemType
      }, normalizedPagination);
    };

    // Hack till API is updated for workouts & recipes
    var endpoint = itemType === 'PlaylistVideo' ? '/v1/voome/members/' + memberId + '/favourites' : '/v1/members/' + memberId + '/favourite_' + itemType;

    // Hack till API is updated for workouts & recipes
    var legacyParams = itemType === 'PlaylistVideo' ? params : itemType === 'recipes' ? { level: level, order: order, page: page } : { order: order, page: page };

    return httpClient.get(endpoint, { params: legacyParams }).then(onSuccess);
  }
});

var initLogic = (0, _reduxLogic.createLogic)({
  type: INIT,
  process: function process(_ref6, dispatch, done) {
    var action = _ref6.action,
        httpClient = _ref6.httpClient;
    var memberId = action.payload.memberId;


    dispatch(fetchFavouriteVideoIds(memberId));
    dispatch(fetchFavouriteRecipeIds(memberId));
    dispatch(fetchFavouriteWorkoutIds(memberId));

    done();
  }
});

var postLogic = (0, _reduxLogic.createLogic)({
  type: POST,
  processOptions: {
    successType: POST_SUCCESS,
    failType: ERROR
  },
  process: function process(_ref7) {
    var action = _ref7.action,
        httpClient = _ref7.httpClient;
    var _action$payload4 = action.payload,
        memberId = _action$payload4.memberId,
        params = _action$payload4.params;
    var itemId = params.itemId,
        itemType = params.itemType;

    // Hack till API is updated for workouts & recipes

    var endpoint = itemType === 'PlaylistVideo' ? '/v1/voome/members/' + memberId + '/favourites' : '/v1/members/' + memberId + '/favourite_' + itemType;

    // Hack till API is updated for workouts & recipes
    var legacyParams = itemType === 'PlaylistVideo' ? params : itemType === 'recipes' ? { memberId: memberId, recipeId: itemId } : { memberId: memberId, exercisePlanDayId: itemId };

    return httpClient.post(endpoint, legacyParams).then(function () {
      return params;
    });
  }
});

var favouriteLogic = exports.favouriteLogic = [deleteLogic, fetchLogic, fetchIdsLogic, initLogic, postLogic];

// Action Creators
var createFavourite = function createFavourite(_ref8) {
  var itemId = _ref8.itemId,
      itemType = _ref8.itemType,
      memberId = _ref8.memberId;

  return {
    type: POST,
    payload: {
      memberId: memberId,
      params: { itemId: itemId, itemType: itemType }
    }
  };
};

var deleteFavourite = function deleteFavourite(_ref9) {
  var itemId = _ref9.itemId,
      itemType = _ref9.itemType,
      memberId = _ref9.memberId;

  return {
    type: DELETE,
    payload: {
      memberId: memberId,
      params: { itemId: itemId, itemType: itemType }
    }
  };
};

var fetchFavourites = function fetchFavourites(_ref10) {
  var itemType = _ref10.itemType,
      level = _ref10.level,
      memberId = _ref10.memberId,
      order = _ref10.order,
      _ref10$page = _ref10.page,
      page = _ref10$page === undefined ? 1 : _ref10$page;

  return {
    type: FETCH,
    payload: {
      memberId: memberId,
      params: { itemType: itemType, level: level, order: order, page: page }
    }
  };
};

var fetchFavouriteIds = function fetchFavouriteIds(_ref11) {
  var itemType = _ref11.itemType,
      memberId = _ref11.memberId;

  return {
    type: FETCH_IDS,
    payload: {
      memberId: memberId,
      params: { itemType: itemType }
    }
  };
};

var toggleFavourite = function toggleFavourite(params) {
  return params.isFavourite ? deleteFavourite(params) : createFavourite(params);
};

var initFavourites = exports.initFavourites = function initFavourites(memberId) {
  return { type: INIT, payload: { memberId: memberId } };
};

var fetchFavouriteRecipeIds = exports.fetchFavouriteRecipeIds = function fetchFavouriteRecipeIds(memberId) {
  return fetchFavouriteIds({ memberId: memberId, itemType: 'recipes' });
};

var fetchFavouriteVideoIds = exports.fetchFavouriteVideoIds = function fetchFavouriteVideoIds(memberId) {
  return fetchFavouriteIds({ memberId: memberId, itemType: 'PlaylistVideo' });
};

var fetchFavouriteWorkoutIds = exports.fetchFavouriteWorkoutIds = function fetchFavouriteWorkoutIds(memberId) {
  return fetchFavouriteIds({ memberId: memberId, itemType: 'workouts' });
};

var fetchFavouriteRecipes = exports.fetchFavouriteRecipes = function fetchFavouriteRecipes(params) {
  return fetchFavourites(_extends({}, params, { itemType: 'recipes' }));
};

var fetchFavouriteVideos = exports.fetchFavouriteVideos = function fetchFavouriteVideos(params) {
  return fetchFavourites(_extends({}, params, { itemType: 'PlaylistVideo' }));
};

var fetchFavouriteWorkouts = exports.fetchFavouriteWorkouts = function fetchFavouriteWorkouts(params) {
  return fetchFavourites(_extends({}, params, { itemType: 'workouts' }));
};

var toggleFavouriteRecipe = exports.toggleFavouriteRecipe = function toggleFavouriteRecipe(params) {
  var memberId = params.memberId,
      isFavourite = params.isFavourite,
      recipeId = params.recipeId;


  return toggleFavourite({
    isFavourite: isFavourite,
    memberId: memberId,
    itemId: recipeId,
    itemType: 'recipes'
  });
};

var toggleFavouriteVideo = exports.toggleFavouriteVideo = function toggleFavouriteVideo(params) {
  var memberId = params.memberId,
      isFavourite = params.isFavourite,
      videoId = params.videoId;


  return toggleFavourite({
    isFavourite: isFavourite,
    memberId: memberId,
    itemId: videoId,
    itemType: 'PlaylistVideo'
  });
};

var toggleFavouriteWorkout = exports.toggleFavouriteWorkout = function toggleFavouriteWorkout(params) {
  var memberId = params.memberId,
      isFavourite = params.isFavourite,
      workoutId = params.workoutId;


  return toggleFavourite({
    isFavourite: isFavourite,
    memberId: memberId,
    itemId: workoutId,
    itemType: 'workouts'
  });
};

// Helpers
var paginationKey = function paginationKey(params) {
  // Ensure the pagination idAttribute is always the same.
  var level = params.level,
      order = params.order,
      _params$page = params.page,
      page = _params$page === undefined ? 1 : _params$page;

  var isDefined = function isDefined(v) {
    return v !== undefined && v !== null && v !== '';
  };
  return (0, _filter3.default)([page, level, order], isDefined).join('-');
};

var isFavourite = function isFavourite(data) {
  var ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return data ? _extends({}, data, {
    isFavourite: (0, _includes3.default)(ids, data.id)
  }) : undefined;
};

var mapIsFavourite = function mapIsFavourite(data) {
  var ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var key = arguments[2];

  var mapItems = function mapItems(items) {
    return (0, _map3.default)(items, function (item) {
      return isFavourite(item, ids);
    });
  };

  return data ? (0, _isArray3.default)(data) ? mapItems(data) : data[key] ? _extends({}, data, _defineProperty({}, key, mapItems(data[key]))) : isFavourite(data, ids) : undefined;
};

var mapIsFavouriteWorkouts = exports.mapIsFavouriteWorkouts = function mapIsFavouriteWorkouts(data) {
  var ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return mapIsFavourite(data, ids, 'workouts');
};

var mapIsFavouriteRecipes = exports.mapIsFavouriteRecipes = function mapIsFavouriteRecipes(data) {
  var ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return mapIsFavourite(data, ids, 'recipes');
};

var mapIsFavouriteVideos = exports.mapIsFavouriteVideos = function mapIsFavouriteVideos(data) {
  var ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return mapIsFavourite(data, ids, 'PlaylistVideo');
};

// Selectors
var selectFavourites = exports.selectFavourites = function selectFavourites(state, ids, params) {
  var itemType = params.itemType;

  var key = paginationKey(params);
  var pagination = state.pagination[itemType][key];

  return pagination ? _extends({}, pagination, {
    result: (0, _map3.default)(pagination.result, function (id) {
      return isFavourite(state.entities[params.itemType][id], ids);
    })
  }) : {};
};

var selectShouldReload = exports.selectShouldReload = function selectShouldReload(state, result, key) {
  return result === undefined || state.isLoading === false && state.pagination[key].reload === true;
};

var selectFavouriteRecipeIds = exports.selectFavouriteRecipeIds = function selectFavouriteRecipeIds(state) {
  return state.ids.recipes;
};

var selectFavouriteRecipes = exports.selectFavouriteRecipes = function selectFavouriteRecipes(state, params) {
  var itemType = 'recipes';
  var ids = selectFavouriteRecipeIds(state);
  return selectFavourites(state, ids, _extends({}, params, { itemType: itemType }));
};

var selectFavouriteRecipesReload = exports.selectFavouriteRecipesReload = function selectFavouriteRecipesReload(state, result) {
  return selectShouldReload(state, result, 'recipes');
};

var selectFavouriteVideoIds = exports.selectFavouriteVideoIds = function selectFavouriteVideoIds(state) {
  return state.ids.PlaylistVideo;
};

var selectFavouriteVideos = exports.selectFavouriteVideos = function selectFavouriteVideos(state, params) {
  var itemType = 'PlaylistVideo';
  var ids = selectFavouriteVideoIds(state);
  return selectFavourites(state, ids, _extends({}, params, { itemType: itemType }));
};

var selectFavouriteVideosReload = exports.selectFavouriteVideosReload = function selectFavouriteVideosReload(state, result) {
  return selectShouldReload(state, result, 'PlaylistVideo');
};

var selectFavouriteWorkoutIds = exports.selectFavouriteWorkoutIds = function selectFavouriteWorkoutIds(state) {
  return state.ids.workouts;
};

var selectFavouriteWorkouts = exports.selectFavouriteWorkouts = function selectFavouriteWorkouts(state, params) {
  var itemType = 'workouts';
  var ids = selectFavouriteWorkoutIds(state);
  return selectFavourites(state, ids, _extends({}, params, { itemType: itemType }));
};

var selectFavouriteWorkoutsReload = exports.selectFavouriteWorkoutsReload = function selectFavouriteWorkoutsReload(state, result) {
  return selectShouldReload(state, result, 'workouts');
};

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case INIT:
    case FETCH:
    case FETCH_IDS:
      return _extends({}, state, {
        isLoading: true
      });

    case FETCH_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        entities: _extends({}, state.entities, _defineProperty({}, payload.itemType, _extends({}, state.entities[payload.itemType], payload.entities[payload.itemType]))),
        pagination: _extends({}, state.pagination, _defineProperty({}, payload.itemType, _extends({}, state.pagination[payload.itemType], payload.entities.pagination)))
      });

    case FETCH_IDS_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        ids: _extends({}, state.ids, _defineProperty({}, payload.itemType, payload.data))
      });

    case POST_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        ids: _extends({}, state.ids, _defineProperty({}, payload.itemType, [].concat(_toConsumableArray(state.ids[payload.itemType]), [payload.itemId]))),
        pagination: _extends({}, state.pagination, _defineProperty({}, payload.itemType, _extends({}, state.pagination[payload.itemType], {
          reload: true
        })))
      });

    case DELETE_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        ids: _extends({}, state.ids, _defineProperty({}, payload.itemType, state.ids[payload.itemType].filter(function (id) {
          return id !== payload.itemId;
        }))),
        pagination: _extends({}, state.pagination, _defineProperty({}, payload.itemType, _extends({}, state.pagination[payload.itemType], {
          reload: true
        })))
      });

    default:
      return state;
  }
}

/***/ }),

/***/ "Gg4F":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompleterNotification = undefined;

var _get2 = __webpack_require__("Q7hp");

var _get3 = _interopRequireDefault(_get2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompleterNotification = exports.CompleterNotification = {
  bindings: {
    weekNumber: '<',
    heading: '<',
    count: '<',
    total: '<',
    visible: '<'
  },

  template: '\n    <div class="completer-notification"\n      ng-class="{ appear: $ctrl.visible }">\n      <progress-badge\n        number="$ctrl.weekNumber"\n        count="$ctrl.currentCount"\n        total="$ctrl.total"\n        size="lg">\n      </progress-badge>\n      <h3 class="mt-3 mb-1">\n        {{ $ctrl.currentHeading }} Completed\n      </h3>\n      <p class="mb-0">\n        Great, keep it up!\n      </p>\n    </div>',

  controller: ["$timeout", function controller($timeout) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        this.currentHeading = null;
        this.currentCount = this.count || 0;
      },
      $onChanges: function $onChanges(changes) {
        var _this = this;

        var heading = (0, _get3.default)(changes, 'heading.currentValue');
        var headingPrev = (0, _get3.default)(changes, 'heading.previousValue');

        if (heading && heading !== headingPrev) {
          this.visible = true;
          this.currentHeading = heading;

          $timeout(function () {
            return _this.animate();
          }, 200);
          $timeout(function () {
            return _this.hide();
          }, 2000);
        }
      },
      hide: function hide() {
        var _this2 = this;

        this.visible = false;
        $timeout(function () {
          return _this2.currentHeading = null;
        }, 500);
      },
      animate: function animate() {
        this.currentCount = this.count;
      }
    };
  }]
};

/***/ }),

/***/ "GmxU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gpi/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CardBook = exports.CardBook = {
  transclude: {
    left: 'leftPage',
    right: 'rightPage'
  },

  template: '\n    <section class="d-flex card-book">\n      <div class="left-page col-6" ng-transclude="left"></div>\n      <div class="right-page col-6" ng-transclude="right"></div>\n    </section>'
};

/***/ }),

/***/ "Gttd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GwJZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stateParamsForSubscription = exports.stateParamsForProgram = exports.stateParamsForUpdateCreditCard = exports.stateParamsForWeekly = exports.stateParamsForWelcome = undefined;

var _calculators = __webpack_require__("/m0/");

var stateParamsForWelcome = exports.stateParamsForWelcome = function stateParamsForWelcome() {
  return { name: 'welcome' };
};

var stateParamsForWeekly = exports.stateParamsForWeekly = function stateParamsForWeekly() {
  return { name: 'dashboard' };
};

var stateParamsForUpdateCreditCard = exports.stateParamsForUpdateCreditCard = function stateParamsForUpdateCreditCard(isVerify) {
  return {
    name: 'profileCreditCard',
    params: { action: isVerify ? 'verify' : 'resume' }
  };
};

var stateParamsForProgram = exports.stateParamsForProgram = function stateParamsForProgram(startedAt, weeksCount, voomeProductId) {
  var daysElapsed = (0, _calculators.calculateDaysElapsed)(startedAt);
  var weekNumber = Math.floor(daysElapsed / 7) + 1;

  return daysElapsed < 1 ? { name: 'program.intro', params: { voomeProductId: voomeProductId } } : weekNumber > weeksCount ? { name: 'program.graduation', params: { voomeProductId: voomeProductId } } : { name: 'program.week.detail', params: { voomeProductId: voomeProductId, weekNumber: weekNumber } };
};

var stateParamsForSubscription = exports.stateParamsForSubscription = function stateParamsForSubscription(subscription) {
  var redirectTo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (subscription) {
    var isWeekly = subscription.isWeekly,
        startedAt = subscription.startedAt,
        status = subscription.status,
        step = subscription.step,
        voomeProductId = subscription.voomeProductId,
        weeksCount = subscription.weeksCount;

    // Verify credit card is an edge case that doesn't have a redirectTo

    var isVerify = /credit-card\/verify/.test(window.location.pathname);
    var isUpdate = /^(cancelled|suspended)$/.test(status);

    return isUpdate || isVerify ? stateParamsForUpdateCreditCard(isVerify) : step < 3 ? stateParamsForWelcome() : redirectTo.name ? redirectTo : isWeekly ? stateParamsForWeekly() : stateParamsForProgram(startedAt, weeksCount, voomeProductId);
  } else {
    return {};
  }
};

/***/ }),

/***/ "HTVa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Favourites = undefined;

var _theme = __webpack_require__("ZID5");

var _member = __webpack_require__("1OIp");

var Favourites = exports.Favourites = {
  template: '\n    <div class="favourites--index bg-gray-100">\n      <ui-view autoscroll="false"></ui-view>\n    </div>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var _selectSubscription = (0, _member.selectSubscription)($ngRedux.getState().member),
            title = _selectSubscription.title;

        $ngRedux.dispatch((0, _theme.setNavChildren)('favourites', title));
      },
      $onDestroy: function $onDestroy() {
        $ngRedux.dispatch((0, _theme.setNavChildren)());
      }
    };
  }]
};

/***/ }),

/***/ "HYmQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WorkoutPlayerProgressBar = exports.WorkoutPlayerProgressBar = {
  bindings: {
    steps: '<',
    currentStep: '<',
    currentStepIndex: '<',
    time: '<'
  },

  template: '\n    <div class="workout-player-progress-bar">\n      <ul class="unstyled progress-bar-inner">\n        <li class="progress-item"\n          ng-repeat="step in $ctrl.steps track by $index"\n          ng-style="{ width: 100 / $ctrl.steps.length + \'%\' }"\n          ng-class="{\n            \'active-group\': step.group.name === $ctrl.currentStep.group.name || $index <= $ctrl.currentStepIndex,\n            \'active-step\': $index === $ctrl.currentStepIndex,\n            \'completed-step\': $index <= $ctrl.currentStepIndex - 1,\n            \'final-blast\': step.group.name.toLowerCase() === \'final blast\',\n            \'first-in-group\': step.firstInGroup\n          }">\n          <span ng-if="step.firstInGroup">{{ step.group.name }}</span>\n        </li>\n      </ul>\n      <span class="progress-pin" ng-style="{ left: $ctrl.left + \'%\' }"></span>\n      <span class="group-name">{{ $ctrl.currentStep.group.name }}</span>\n    </div>',

  controller: function controller() {
    'ngInject';

    return {
      $onChanges: function $onChanges() {
        if (this.currentStep) {
          this.progressPin();
        }
      },
      progressPin: function progressPin() {
        var width = 100 / this.steps.length;
        var startPos = width * this.currentStepIndex;
        var endPos = width * (this.currentStepIndex + 1);

        var progress = (endPos - startPos) / this.currentStep.totalTimeInSeconds * this.time;

        this.left = startPos + progress;
      }
    };
  }
};

/***/ }),

/***/ "HsA4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Review = exports.Review = {
  bindings: {
    review: '<',
    replies: '<',
    memberId: '<',
    onLike: '&',
    onSubmit: '&',
    onShowReplies: '&'
  },

  template: '\n    <div class="review d-block">\n      <review-reply\n        data="$ctrl.review"\n        is-user="$ctrl.memberId === $ctrl.review.member.id"\n        on-like="$ctrl.onLike({ reviewId: reviewId })"\n        on-reply="$ctrl.onReply($ctrl.review.id)"\n        on-show-replies="$ctrl.onShowReplies({ parentId: reviewId })">\n      </review-reply>\n      <div class="review-replies ml-5">\n        <review-reply\n          data="$ctrl.replies[replyId]"\n          is-user="$ctrl.memberId === $ctrl.replies[replyId].member.id"\n          on-like="$ctrl.onLike({ reviewId: reviewId })"\n          on-reply="$ctrl.onReply($ctrl.review.id)"\n          ng-repeat="replyId in $ctrl.review.replies track by $index">\n        </review-reply>\n        <form-review\n          data-form-id="{{ $ctrl.review.id }}"\n          wording-singular="Reply"\n          on-submit="$ctrl.onSubmit({ parentId: $ctrl.review.id, data: data })"\n          on-cancel="$ctrl.showForm = false"\n          ng-show="$ctrl.showForm">\n        </form-review>\n      </div>\n    </div>',

  controller: ["$timeout", function controller($timeout) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        this.showForm = false;
      },
      onReply: function onReply(id) {
        this.showForm = true;

        $timeout(function () {
          $('html, body').animate({
            scrollTop: $('[data-form-id="' + id + '"]').offset().top
          });
        });
      }
    };
  }]
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "I8RL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MealPlanSwaps = undefined;

var _recipesSimilar = __webpack_require__("WQxS");

var MealPlanSwaps = exports.MealPlanSwaps = {
  bindings: {
    recipe: '<',
    selected: '<',
    voomeProductId: '<',
    onPreview: '&',
    onRemove: '&',
    onRevert: '&',
    onSwap: '&'
  },

  template: '\n    <div class="meal-plan-swaps">\n      <h2 class="meal-plan-swaps-loading d-flex justify-content-center align-items-center mb-0"\n        ng-hide="$ctrl.similarRecipes.length > 0">\n        <spinner is-loading="true"></spinner>\n        <span class="ml-2">Loading</span>\n      </h2>\n      <div class="clearfix"\n        ng-show="$ctrl.similarRecipes.length > 0">\n        <div class="col-2">\n          <meal-plan-swap\n            recipe="$ctrl.recipe"\n            selected="$ctrl.selected"\n            on-swap="$ctrl.onRevert()"\n            on-preview="$ctrl.onPreview({ recipe: $ctrl.recipe })">\n          </meal-plan-swap>\n        </div>\n        <div class="col-2"\n          ng-repeat="recipe in $ctrl.similarRecipes track by $index">\n          <meal-plan-swap\n            recipe="recipe"\n            selected="$ctrl.selected"\n            on-swap="$ctrl.onSwap({ recipeContainerId: recipe.recipeContainerId })"\n            on-preview="$ctrl.onPreview({ recipe: recipe })">\n          </meal-plan-swap>\n        </div>\n        <div class="col-2">\n          <div class="card-wrapper"\n            ng-class="{ \'theme-border\': !$ctrl.selected }"\n            ng-click="$ctrl.onRemove()">\n            <div class="card card-voome card-borderless card-leftovers d-flex align-items-center justify-content-center">\n              <div class="card-block text-center px-2">\n                <i class="fa fa-times mb-2"></i>\n                <h6 class="text-black mb-0">\n                  Remove this recipe from this week\u2019s plan\n                </h6>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState.bind(this), this.mapDispatch());

        this.unsubscribe = connect(this);
        this.isLoading = true;

        if (this.recipe) {
          this.fetchRecipesSimilar(this.recipe.id, this.voomeProductId);
        }
      },
      $onDestroy: function $onDestroy() {
        this.unsubscribe();
      },
      mapState: function mapState(state) {
        return {
          similarRecipes: (0, _recipesSimilar.selectRecipesSimilar)(state, this.recipe.id)
        };
      },
      mapDispatch: function mapDispatch() {
        return { fetchRecipesSimilar: _recipesSimilar.fetchRecipesSimilar };
      }
    };
  }]
};

/***/ }),

/***/ "ICZV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MealPlanDays = exports.MealPlanDays = {
  bindings: {
    day: '<',
    days: '<',
    isSwapping: '<',
    isSwappingDay: '<',
    onUpdate: '&',
    onRemove: '&'
  },

  template: '\n    <div class="meal-plan-days">\n      <div class="d-flex border border-bottom pointer py-2"\n        ng-class="{ \'bg-white\': $ctrl.day === day.dayString }"\n        ng-repeat="day in $ctrl.days track by $index"\n        ng-click="$ctrl.onUpdate({ dayString: day.dayString })">\n        <div class="mx-1 mx-md-2 text-center">\n          <meal-plan-day-icon\n            is-active="$ctrl.day === day.dayString"\n            is-swapping="$ctrl.isSwapping && $ctrl.isSwappingDay === day.day"\n            count="day.meals.length">\n            {{ day.dayString | limitTo: 3 }}\n          </meal-plan-day-icon>\n        </div>\n        <div class="d-none d-md-flex scroll-x">\n          <div class="meal-plan-day-image pl-1 pointer"\n            ng-repeat="meal in day.meals track by $index">\n            <img\n              ng-src="{{ meal.recipe.imageUrl.thumb | assetSrc }}"\n              ng-click="$ctrl.onUpdate({ dayString: day.dayString })" />\n            <i class="fa fa-minus-circle text-red"\n              ng-click="$ctrl.onRemove({ mealId: meal.id, day: day.day })">\n            </i>\n          </div>\n        </div>\n      </div>\n    </div>'
};

/***/ }),

/***/ "IIqr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MealPlanBasic = undefined;

var _product = __webpack_require__("5AvL");

var _redirect = __webpack_require__("8G1E");

var _mealPlan = __webpack_require__("KLwp");

var _member = __webpack_require__("1OIp");

var MealPlanBasic = exports.MealPlanBasic = {
  template: '\n    <div class="meal-plan meal-plan--swap">\n      <main class="main-content border border-y bg-gray-100 pt-3 pb-5">\n        <div class="container mb-3">\n          <div class="row">\n            <div class="col-12 mx-auto" ng-hide="$ctrl.isLoading">\n              <div class="meal-plan-meta">\n                <div class="d-flex align-item-center mb-3"\n                  ng-class="{\n                    \'justify-content-between\': $ctrl.mealPlan.hasSwaps,\n                    \'justify-content-end\': !$ctrl.mealPlan.hasSwaps\n                  }">\n                  <button-link ng-click="$ctrl.resetMealPlan($ctrl.mealPlan.id)"\n                    ng-show="$ctrl.mealPlan.hasSwaps">\n                    Reset Meal Plan\n                  </button-link>\n                  <meal-plan-print\n                    pdfs="$ctrl.pdfs"\n                    level="$ctrl.level">\n                  </meal-plan-print>\n                </div>\n                <div class="mb-3" ng-show="$ctrl.hasCookup">\n                  <meal-plan-cook-more></meal-plan-cook-more>\n                </div>\n              </div>\n              <div class="d-md-flex mb-4"\n                ng-class="{ swapping: $ctrl.isSwapping }"\n                ng-repeat="day in $ctrl.days track by $index">\n                <div class="meal-plan-day pr-md-4 text-center">\n                  <meal-plan-day-icon\n                    is-swapping="$ctrl.isSwapping"\n                    count="day.meals.length">\n                    <span ng-show="$ctrl.week">\n                      Day {{ $index + 1 }}\n                    </span>\n                  </meal-plan-day-icon>\n                  <small class="meal-plan-day-cals d-block text-teal-dark font-weight-semibold mt-md-1">\n                    {{ day.calories }} Cal\n                  </small>\n                </div>\n                <div class="meal-plan-recipes">\n                  <div class="bg-white"\n                    ng-repeat="meal in day.meals track by $index">\n                    <meal-plan-recipe-swap\n                      meal="meal"\n                      voome-product-id="$ctrl.voomeProductId"\n                      is-product-low-fodmap="$ctrl.isProductLowFodmap"\n                      on-swap="$ctrl.swapMeal(mealPlanRecipeId, recipeContainerId)"\n                      on-remove="$ctrl.swapRemove(meal.id)"\n                      on-revert="$ctrl.swapRevert(meal.swappedMealId)"\n                      on-preview="$ctrl.onPreview(recipe)"\n                      on-learn-more="$ctrl.onLearnMore()">\n                    </meal-plan-recipe-swap>\n                  </div>\n                  <div class="bg-white h-100 d-flex justify-content-center align-items-center"\n                    ng-show="day.meals.length === 0">\n                    <strong>\n                      No meals added for day {{ $index + 1 }}\n                    </strong>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <recipe-preview\n          recipe-id="$ctrl.recipePreviewId"\n          show-on="$ctrl.recipePreviewShow">\n        </recipe-preview>\n      </main>\n    </div>',

  controller: ["$ngRedux", "$location", "$timeout", function controller($ngRedux, $location, $timeout) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        if (!this.mealPlan.id) {
          this.fetchMealPlanSwaps(this.mealPlanId, this.memberId, this.level);
        }
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();
      },
      onPreview: function onPreview(recipe) {
        var _this = this;

        this.recipePreviewId = recipe.id;
        this.recipePreviewShow = true;
        $timeout(function () {
          return _this.recipePreviewShow = false;
        });
      },
      onLearnMore: function onLearnMore() {
        this.setRedirect({ path: $location.path() });
      },
      mapState: function mapState(_ref) {
        var mealPlan = _ref.mealPlan,
            member = _ref.member,
            product = _ref.product,
            router = _ref.router;
        var _router$currentParams = router.currentParams,
            mealPlanId = _router$currentParams.mealPlanId,
            voomeProductId = _router$currentParams.voomeProductId,
            weekNumber = _router$currentParams.weekNumber;
        var isLoading = mealPlan.isLoading,
            isSwapping = mealPlan.isSwapping;

        var subscription = (0, _member.selectSubscription)(member);

        return {
          mealPlanId: mealPlanId,
          subscription: subscription,
          voomeProductId: voomeProductId,
          days: (0, _mealPlan.selectDays)(mealPlan, mealPlanId),
          hasCookup: (0, _mealPlan.selectMealsHasCookup)(mealPlan, mealPlanId),
          isLoading: isLoading && !isSwapping,
          isSwapping: isSwapping,
          level: (0, _member.selectMemberLevel)(member),
          mealPlan: (0, _mealPlan.selectMealPlan)(mealPlan, mealPlanId),
          memberId: (0, _member.selectMember)(member).id,
          pdfs: (0, _mealPlan.selectMealPlanPdfs)(mealPlan, mealPlanId, subscription.id),
          week: (0, _product.selectWeek)(product, weekNumber),
          isProductLowFodmap: (0, _member.selectIsProductLowFodmap)(member, voomeProductId)
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          fetchMealPlanSwaps: _mealPlan.fetchMealPlanSwaps,
          resetMealPlan: _mealPlan.resetMealPlan,
          swapRemove: _mealPlan.swapRemove,
          swapRevert: _mealPlan.swapRevert,
          swapMeal: _mealPlan.swapMeal,
          setRedirect: _redirect.setRedirect
        };
      }
    };
  }]
};

/***/ }),

/***/ "IdCd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WorkoutPlayerHeader = undefined;

var _logo = __webpack_require__("zxL1");

var _logo2 = _interopRequireDefault(_logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WorkoutPlayerHeader = exports.WorkoutPlayerHeader = {
  bindings: {
    isComplete: '<',
    isFinished: '<',
    onClickFinish: '&',
    onClickLogo: '&'
  },

  template: '\n    <div class="workout-player-header mx-2 mx-sm-0"\n      ng-class="{ \'workout-player-header-complete\': $ctrl.isComplete }">\n      <div class="row align-items-center justify-content-between">\n        <div class="col-5">\n          <button-back>\n            Workout<span class="d-none d-md-inline"> Overview</span>\n          </button-back>\n        </div>\n        <div class="col-2 text-center">\n          <button-link ng-click="$ctrl.onClickLogo()">\n            <nav-logo></nav-logo>\n          </button-link>\n        </div>\n        <div class="col-5 text-right">\n          <div class="pr-2 pr-md-0">\n            <workout-player-finish-modal\n              is-finished="$ctrl.isFinished"\n              on-finish="$ctrl.onClickFinish()">\n            </workout-player-finish-modal>\n          </div>\n        </div>\n      </div>\n    </div>'
};

/***/ }),

/***/ "J1Ct":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ButtonBack = exports.ButtonBack = {
  transclude: true,

  bindings: {
    onClick: '&'
  },

  template: '\n    <button class="btn btn-link p-0"\n      type="button"\n      ng-click="$ctrl.onClickBack()">\n      <i class="fa fa-chevron-left"></i>\n      <ng-transclude>Back</ng-transclude>\n    </button>',

  controller: ["$window", function controller($window) {
    'ngInject';

    return {
      onClickBack: function onClickBack() {
        if (this.onClick() === undefined) {
          $window.history.back();
        }
      }
    };
  }]
};

/***/ }),

/***/ "J8ve":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsConditions = undefined;

var _termsConditions = __webpack_require__("0120");

var _termsConditions2 = _interopRequireDefault(_termsConditions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TermsConditions = exports.TermsConditions = { templateUrl: _termsConditions2.default };

/***/ }),

/***/ "JU/9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ProfileFieldsWorkout = exports.ProfileFieldsWorkout = {
  bindings: {
    form: '<',
    member: '<',
    isEditing: '<',
    questions: '<',
    onUpdate: '&'
  },

  template: '\n    <div class="row">\n      <div class="col-md-4">\n        <h5>Workouts</h5>\n        <p>\n          Select your Workout Profile. We will use your settings to show you\n          daily workout inspiration.\n        </p>\n      </div>\n      <div class="col-md-8" ng-switch="$ctrl.isEditing">\n        <div ng-switch-when="false"\n          ng-repeat="item in $ctrl.questions track by $index">\n          <form-group-row>\n            <form-group-left>\n              <form-label>\n                {{ item.label }}\n              </form-label>\n            </form-group-left>\n            <form-group-right>\n              <div class="col-form-label pb-0">\n                {{ item.answer }}\n              </div>\n            </form-group-right>\n          </form-group-row>\n          <hr ng-hide="$last">\n        </div>\n        <div class="form-group"\n          ng-switch-when="true"\n          ng-repeat="item in $ctrl.questions track by $index">\n          <form-label>\n            {{ item.question }}\n          </form-label>\n          <form-fieldset\n            form="$ctrl.form"\n            key="voomeProfile.preferences.{{ item.key }}"\n            list="$ctrl.member.voomeProfile.preferences[item.key]"\n            type="{{ item.type }}"\n            on-update="$ctrl.onUpdate({ key: key, value: value })">\n          </form-fieldset>\n        </div>\n      </div>\n    </div>'
};

/***/ }),

/***/ "JY6D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FavouriteButton = exports.FavouriteButton = {
  bindings: {
    isFavourite: '<'
  },

  template: '\n    <button class="favourite-btn pointer" type="button">\n      <i class="fa pink-cz p-3 pointer"\n        ng-class="{\n          \'fa-heart\': $ctrl.isFavourite,\n          \'fa-heart-o\': !$ctrl.isFavourite\n        }">\n      </i>\n    </button>\n  '
};

/***/ }),

/***/ "JaUt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.virtualPageview = undefined;

var _dataLayer = __webpack_require__("YcV4");

var _memberStorage = __webpack_require__("xopG");

var virtualPageview = exports.virtualPageview = ["$ngRedux", "$location", "$transitions", function virtualPageview($ngRedux, $location, $transitions) {
  'ngInject';

  if (true) {
    $transitions.onSuccess('*', function ($transition$) {
      var _memberStorage$get = _memberStorage.memberStorage.get(),
          voomeProductId = _memberStorage$get.voomeProductId,
          memberId = _memberStorage$get.memberId;

      var path = $location.path();
      var absUrl = $location.absUrl();
      var virtualUrl = absUrl.substring(absUrl.indexOf(path));
      var visitorType = memberId ? 'Member' : 'Non Member';
      var pageType = $transition$.to().authenticate ? 'Logged in' : 'Not Logged in';

      _dataLayer.dataLayer.track('virtualPageView', {
        virtualUrl: virtualUrl,
        visitorType: visitorType,
        pageType: pageType,
        voomeProductId: voomeProductId
      });
    });
  }
}];

/***/ }),

/***/ "JrrQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompleterNotification = exports.Completer = undefined;

var _Completer = __webpack_require__("8yhO");

Object.defineProperty(exports, 'Completer', {
  enumerable: true,
  get: function get() {
    return _Completer.Completer;
  }
});

var _CompleterNotification = __webpack_require__("Gg4F");

Object.defineProperty(exports, 'CompleterNotification', {
  enumerable: true,
  get: function get() {
    return _CompleterNotification.CompleterNotification;
  }
});

__webpack_require__("iKpI");

/***/ }),

/***/ "K8ga":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ExerciseSet = exports.ExerciseSet = {
  bindings: {
    data: '<',
    workout: '<',
    exercises: '<',
    gender: '<',
    params: '<',
    onShowModal: '&'
  },

  template: '\n    <div class="exercise-set">\n      <div class="exercise-set-wrap p-sm-3">\n        <h4 class="exercise-set-header pt-3">\n          {{ $ctrl.data.name }}\n          <span ng-show="$ctrl.data.show_time" class="muted"> {{ $ctrl.data.total_time }}</span>\n        </h4>\n        <div class="reps"\n          ng-show="$ctrl.data.repsCount > 0 || $ctrl.data.note"\n          ng-class="{ \'no-reps\': $ctrl.data.repsCount == 0, \'no-items\': $ctrl.data.items.length == 0 }">\n          <h3 ng-if="$ctrl.data.repsCount > 0">\n            <span class="times">&times;</span>\n            {{ $ctrl.data.repsCount }}\n          </h3>\n          <p class="note"\n            ng-class="{ large: $ctrl.data.repsCount > 9 }"\n            ng-show="$ctrl.data.note"\n            ng-bind-html="$ctrl.data.note">\n          </p>\n        </div>\n        <div class="exercises">\n          <exercise\n            ng-repeat="item in $ctrl.data.items track by $index"\n            index="$index"\n            data="item"\n            workout="$ctrl.workout"\n            exercise="$ctrl.exercises[item.exerciseId]"\n            gender="$ctrl.gender"\n            params="$ctrl.params"\n            class="exercise-wrap"\n            on-click="$ctrl.onShowModal({ item: item })">\n          </exercise>\n        </div>\n      </div>\n    </div>'
};

/***/ }),

/***/ "KLwp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectHasMealPlanRecipe = exports.selectPageForMealPlanId = exports.selectShoppingListRecipes = exports.selectDays = exports.selectPaginationByType = exports.selectMealsHasCookup = exports.selectMealPlansCurrent = exports.selectMealPlansByType = exports.selectMealPlanPdfs = exports.selectMealPlanList = exports.selectMealPlanTitle = exports.selectMealPlanIsClone = exports.selectMealPlanIdForWeek = exports.selectMealPlan = exports.selectRecipes = exports.selectMealPlans = exports.deleteMeal = exports.createMeal = exports.swapRevert = exports.swapRemove = exports.swapMeal = exports.deactivateMealPlan = exports.activateMealPlan = exports.updateMealPlan = exports.resetMealPlan = exports.deleteMealPlan = exports.createMealPlan = exports.cloneMealPlan = exports.fetchMealPlanActive = exports.fetchMealPlansByVoome = exports.fetchMealPlansMine = exports.fetchMealPlansCurrent = exports.fetchMealPlanForWeek = exports.fetchMealPlanSwaps = exports.fetchMealPlan = exports.mealPlanLogic = exports.initialState = undefined;

var _some2 = __webpack_require__("mGzp");

var _some3 = _interopRequireDefault(_some2);

var _reject2 = __webpack_require__("YqDm");

var _reject3 = _interopRequireDefault(_reject2);

var _reduce2 = __webpack_require__("M+Z9");

var _reduce3 = _interopRequireDefault(_reduce2);

var _map2 = __webpack_require__("2247");

var _map3 = _interopRequireDefault(_map2);

var _findKey2 = __webpack_require__("PtNq");

var _findKey3 = _interopRequireDefault(_findKey2);

var _find2 = __webpack_require__("kbi+");

var _find3 = _interopRequireDefault(_find2);

var _filter2 = __webpack_require__("RyI1");

var _filter3 = _interopRequireDefault(_filter2);

var _flow2 = __webpack_require__("Kp45");

var _flow3 = _interopRequireDefault(_flow2);

var _flatMap2 = __webpack_require__("nfWN");

var _flatMap3 = _interopRequireDefault(_flatMap2);

var _camelCase2 = __webpack_require__("NRb0");

var _camelCase3 = _interopRequireDefault(_camelCase2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;

var _reduxLogic = __webpack_require__("E0Bt");

var _normalizr = __webpack_require__("vNPR");

var _settings = __webpack_require__("Ll2K");

var _utils = __webpack_require__("0xDb");

var _decorators = __webpack_require__("SPxS");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Action Types
var FETCH = '@@app/meal-plan/FETCH';
var FETCH_SUCCESS = '@@app/meal-plan/FETCH_SUCCESS';

var FETCH_ACTIVE = '@@app/meal-plan/FETCH_ACTIVE';
var FETCH_ACTIVE_SUCCESS = '@@app/meal-plan/FETCH_ACTIVE_SUCCESS';

var FETCH_SWAPS = '@@app/meal-plan/FETCH_SWAPS';
var FETCH_SWAPS_SUCCESS = '@@app/meal-plan/FETCH_SWAPS_SUCCESS';

var FETCH_ALL = '@@app/meal-plan/FETCH_ALL';
var FETCH_ALL_SUCCESS = '@@app/meal-plan/FETCH_ALL_SUCCESS';

var FETCH_WEEK = '@@app/meal-plan/FETCH_WEEK';
var FETCH_WEEK_SUCCESS = '@@app/meal-plan/FETCH_WEEK_SUCCESS';

var UPDATE = '@@app/meal-plan/UPDATE';
var UPDATE_SUCCESS = '@@app/meal-plan/UPDATE_SUCCESS';

var CLONE = '@@app/meal-plan/CLONE';
var CLONE_SUCCESS = '@@app/meal-plan/CLONE_SUCCESS';

var CREATE = '@@app/meal-plan/CREATE';
var CREATE_SUCCESS = '@@app/meal-plan/CREATE_SUCCESS';

var DELETE = '@@app/meal-plan/DELETE';
var DELETE_SUCCESS = '@@app/meal-plan/DELETE_SUCCESS';

var RESET = '@@app/meal-plan/RESET';
var RESET_SUCCESS = '@@app/meal-plan/RESET_SUCCESS';

var ACTIVATE = '@@app/meal-plan/ACTIVATE';
var ACTIVATE_SUCCESS = '@@app/meal-plan/ACTIVATE_SUCCESS';

var DEACTIVATE = '@@app/meal-plan/DEACTIVATE';
var DEACTIVATE_SUCCESS = '@@app/meal-plan/DEACTIVATE_SUCCESS';

var SWAP = '@@app/meal-plan/SWAP';
var SWAP_REVERT = '@@app/meal-plan/SWAP_REVERT';
var SWAP_SUCCESS = '@@app/meal-plan/SWAP_SUCCESS';

var CREATE_MEAL = '@@app/meal-plan/CREATE_MEAL';
var CREATE_MEAL_SUCCESS = '@@app/meal-plan/CREATE_MEAL_SUCCESS';

var DELETE_MEAL = '@@app/meal-plan/DELETE_MEAL';
var DELETE_MEAL_SUCCESS = '@@app/meal-plan/DELETE_MEAL_SUCCESS';

var ERROR = '@@app/meal-plan/ERROR';
var CANCEL = '@@app/meal-plan/CANCEL';

// Initial State
var initialState = exports.initialState = {
  isActivating: false,
  isCreating: false,
  isLoading: false,
  isSwapping: false,
  isSwappingDay: -1,
  entities: {
    mealPlans: {},
    recipes: null,
    byVoome: null,
    mine: null,
    current: null
  },
  result: null,
  active: null,
  level: 0
};

// Normalize
var mealPlanSchema = function mealPlanSchema() {
  return new _normalizr.schema.Entity('mealPlans', {
    recipes: [new _normalizr.schema.Entity('recipes')]
  });
};

var normalizeMealPlan = function normalizeMealPlan(data) {
  return data.id ? (0, _normalizr.normalize)(_extends({}, data, {
    recipes: (0, _decorators.decorateRecipes)(data.recipes)
  }), mealPlanSchema()) : {
    entities: {},
    result: null
  };
};

var normalizeMealPlans = function normalizeMealPlans(response, key) {
  var normalized = (0, _normalizr.normalize)(response.data, [mealPlanSchema()]);
  var result = normalized.result,
      entities = normalized.entities;


  var pagination = response.pagination ? response.pagination : {
    page: 1,
    totalPages: 1,
    total: result.length
  };

  return _extends({}, normalized, {
    key: key,
    entities: _extends({}, entities, _defineProperty({}, key, _defineProperty({}, pagination.page, _extends({}, pagination, {
      result: result
    }))))
  });
};

// Observables
var fetchLogic = (0, _reduxLogic.createLogic)({
  type: FETCH,
  processOptions: {
    successType: FETCH_SUCCESS,
    failType: ERROR
  },
  process: function process(_ref) {
    var action = _ref.action,
        httpClient = _ref.httpClient;
    var _action$payload = action.payload,
        level = _action$payload.level,
        mealPlanId = _action$payload.mealPlanId;

    var endpoint = '/v1/voome/meal-plans/' + mealPlanId;
    var params = { level: level };
    var onSuccess = function onSuccess(response) {
      return normalizeMealPlan(response.data);
    };
    return httpClient.get(endpoint, { params: params }).then(onSuccess);
  }
});

var fetchActiveLogic = (0, _reduxLogic.createLogic)({
  type: FETCH_ACTIVE,
  debounce: 500,
  latest: true,
  processOptions: {
    successType: FETCH_ACTIVE_SUCCESS,
    failType: ERROR
  },
  process: function process(_ref2) {
    var action = _ref2.action,
        httpClient = _ref2.httpClient;

    var endpoint = '/v1/voome/meal-plans/active';
    var onSuccess = function onSuccess(response) {
      return normalizeMealPlan(response.data);
    };
    return httpClient.get(endpoint).then(onSuccess);
  }
});

var fetchSwapsLogic = (0, _reduxLogic.createLogic)({
  type: FETCH_SWAPS,
  processOptions: {
    successType: FETCH_SUCCESS,
    failType: ERROR
  },
  process: function process(_ref3) {
    var action = _ref3.action,
        httpClient = _ref3.httpClient;
    var _action$payload2 = action.payload,
        level = _action$payload2.level,
        mealPlanId = _action$payload2.mealPlanId,
        memberId = _action$payload2.memberId;

    var endpoint = '/v2/voome/members/' + memberId + '/meal-plans/' + mealPlanId + '/swapped-meals';
    var params = { level: level };
    var onSuccess = function onSuccess(_ref4) {
      var data = _ref4.data;
      return normalizeMealPlan(_extends({}, data, { hasSwaps: mealsHasSwaps(mealsFlat(data)) }));
    };

    return httpClient.get(endpoint, { params: params }).then(onSuccess);
  }
});

var fetchWeekLogic = (0, _reduxLogic.createLogic)({
  type: FETCH_WEEK,
  process: function process(_ref5, dispatch, done) {
    var action = _ref5.action,
        httpClient = _ref5.httpClient;
    var _action$payload3 = action.payload,
        subscriptionId = _action$payload3.subscriptionId,
        weekId = _action$payload3.weekId,
        level = _action$payload3.level,
        memberId = _action$payload3.memberId;

    var endpoint = '/v1/voome/meal-plans/mine';
    var params = { subscriptionId: subscriptionId, weekId: weekId };

    var onSuccess = function onSuccess(_ref6) {
      var data = _ref6.data;

      var mealPlanId = data.length ? data[0].id : action.payload.mealPlanId;
      dispatch({ type: FETCH_WEEK_SUCCESS, payload: { mealPlanId: mealPlanId, weekId: weekId } });
      dispatch(fetchMealPlanSwaps(mealPlanId, memberId, level));
    };

    var onFail = function onFail() {
      return dispatch({ type: ERROR });
    };

    return httpClient.get(endpoint, { params: params }).then(onSuccess).catch(onFail).then(done);
  }
});

var fetchAllLogic = (0, _reduxLogic.createLogic)({
  type: FETCH_ALL,
  processOptions: {
    successType: FETCH_ALL_SUCCESS,
    failType: ERROR
  },
  process: function process(_ref7) {
    var action = _ref7.action,
        httpClient = _ref7.httpClient;
    var _action$payload4 = action.payload,
        key = _action$payload4.key,
        page = _action$payload4.page,
        subscriptionId = _action$payload4.subscriptionId,
        weekId = _action$payload4.weekId;

    var endpoint = '/v1/voome/meal-plans/' + key;
    var params = { page: page, subscriptionId: subscriptionId, weekId: weekId };
    var onSuccess = function onSuccess(response) {
      return normalizeMealPlans(response, (0, _camelCase3.default)(key));
    };
    return httpClient.get(endpoint, { params: params }).then(onSuccess);
  }
});

var updateLogic = (0, _reduxLogic.createLogic)({
  type: UPDATE,
  processOptions: {
    successType: UPDATE_SUCCESS,
    failType: ERROR
  },
  process: function process(_ref8) {
    var action = _ref8.action,
        httpClient = _ref8.httpClient;
    var _action$payload5 = action.payload,
        mealPlanId = _action$payload5.mealPlanId,
        mealPlan = _action$payload5.mealPlan;

    var endpoint = '/v1/voome/meal-plans/' + mealPlanId;
    return httpClient.put(endpoint, { mealPlan: mealPlan }).then(function () {
      return action.payload;
    });
  }
});

var resetLogic = (0, _reduxLogic.createLogic)({
  type: RESET,
  processOptions: {
    successType: RESET_SUCCESS,
    failType: ERROR
  },
  process: function process(_ref9) {
    var action = _ref9.action,
        httpClient = _ref9.httpClient;
    var mealPlanId = action.payload.mealPlanId;

    var endpoint = '/v1/voome/meal-plans/' + mealPlanId + '/meal-plan-recipe-swaps/reset';
    return httpClient.delete(endpoint);
  }
});

var revertLogic = (0, _reduxLogic.createLogic)({
  type: SWAP_REVERT,
  processOptions: {
    successType: SWAP_SUCCESS,
    failType: ERROR
  },
  process: function process(_ref10) {
    var action = _ref10.action,
        httpClient = _ref10.httpClient;

    return httpClient.delete('/v1/voome/meal-plan-recipe-swaps/' + action.payload.swappedMealId);
  }
});

var swapLogic = (0, _reduxLogic.createLogic)({
  type: SWAP,
  processOptions: {
    successType: SWAP_SUCCESS,
    failType: ERROR
  },
  process: function process(_ref11) {
    var action = _ref11.action,
        httpClient = _ref11.httpClient;
    var _action$payload6 = action.payload,
        mealPlanRecipeId = _action$payload6.mealPlanRecipeId,
        recipeContainerId = _action$payload6.recipeContainerId;

    var endpoint = '/v1/voome/meal-plan-recipe-swaps';
    var params = { mealPlanRecipeId: mealPlanRecipeId, recipeContainerId: recipeContainerId };
    return httpClient.post(endpoint, params);
  }
});

var swapSuccessLogic = (0, _reduxLogic.createLogic)({
  type: [RESET_SUCCESS, SWAP_SUCCESS],
  process: function process(_ref12, dispatch, done) {
    var action = _ref12.action,
        getState = _ref12.getState;
    var _getState$mealPlan = getState().mealPlan,
        result = _getState$mealPlan.result,
        level = _getState$mealPlan.level;

    var _memberStorage$get = _utils.memberStorage.get(),
        memberId = _memberStorage$get.memberId;

    dispatch(fetchMealPlanSwaps(result, memberId, level));
    done();
  }
});

var activateLogic = (0, _reduxLogic.createLogic)({
  type: ACTIVATE,
  processOptions: {
    successType: ACTIVATE_SUCCESS,
    failType: ERROR
  },
  process: function process(_ref13) {
    var action = _ref13.action,
        httpClient = _ref13.httpClient;
    var mealPlanId = action.payload.mealPlanId;

    var endpoint = '/v1/voome/meal-plans/' + mealPlanId + '/activate';
    var onSuccess = function onSuccess() {
      return action.payload;
    };
    return httpClient.put(endpoint).then(onSuccess);
  }
});

var deactivateLogic = (0, _reduxLogic.createLogic)({
  type: DEACTIVATE,
  processOptions: {
    successType: DEACTIVATE_SUCCESS,
    failType: ERROR
  },
  process: function process(_ref14) {
    var action = _ref14.action,
        httpClient = _ref14.httpClient;
    var mealPlanId = action.payload.mealPlanId;

    var endpoint = '/v1/voome/meal-plans/' + mealPlanId + '/deactivate';
    var onSuccess = function onSuccess() {
      return { mealPlanId: null };
    };
    return httpClient.put(endpoint).then(onSuccess);
  }
});

var cloneLogic = (0, _reduxLogic.createLogic)({
  type: CLONE,
  processOptions: {
    successType: CLONE_SUCCESS,
    failType: ERROR
  },
  process: function process(_ref15) {
    var action = _ref15.action,
        httpClient = _ref15.httpClient;
    var _action$payload7 = action.payload,
        mealPlanId = _action$payload7.mealPlanId,
        subscriptionId = _action$payload7.subscriptionId,
        weekId = _action$payload7.weekId;

    var endpoint = '/v1/voome/meal-plans/' + mealPlanId + '/clone';
    var params = { subscriptionId: subscriptionId, weekId: weekId };
    var onSuccess = function onSuccess(response) {
      return normalizeMealPlan(response.data);
    };
    return httpClient.get(endpoint, { params: params }).then(onSuccess);
  }
});

var createMealPlanLogic = (0, _reduxLogic.createLogic)({
  type: CREATE,
  processOptions: {
    successType: CREATE_SUCCESS,
    failType: ERROR
  },
  process: function process(_ref16) {
    var action = _ref16.action,
        httpClient = _ref16.httpClient;
    var subscriptionId = action.payload.subscriptionId;

    var endpoint = '/v1/voome/meal-plans';
    var params = { subscriptionId: subscriptionId };
    var onSuccess = function onSuccess(response) {
      return normalizeMealPlan(response.data);
    };
    return httpClient.post(endpoint, params).then(onSuccess);
  }
});

var deleteMealPlanLogic = (0, _reduxLogic.createLogic)({
  type: DELETE,
  processOptions: {
    successType: DELETE_SUCCESS,
    failType: ERROR
  },
  process: function process(_ref17) {
    var action = _ref17.action,
        httpClient = _ref17.httpClient;

    var endpoint = '/v1/voome/meal-plans/' + action.payload.mealPlanId;
    var onSuccess = function onSuccess() {
      return action.payload;
    };
    return httpClient.delete(endpoint).then(onSuccess);
  }
});

var createMealLogic = (0, _reduxLogic.createLogic)({
  type: CREATE_MEAL,
  processOptions: {
    successType: CREATE_MEAL_SUCCESS,
    failType: ERROR
  },
  process: function process(_ref18) {
    var action = _ref18.action,
        httpClient = _ref18.httpClient;
    var _action$payload8 = action.payload,
        day = _action$payload8.day,
        leftOvers = _action$payload8.leftOvers,
        mealPlanId = _action$payload8.mealPlanId,
        recipeId = _action$payload8.recipeId;

    var endpoint = '/v1/voome/meal-plans/' + mealPlanId + '/create-meal';
    var params = { leftOvers: leftOvers, day: day, recipeId: recipeId };
    var onSuccess = function onSuccess(response) {
      return normalizeMealPlan(response.data);
    };
    return httpClient.post(endpoint, params).then(onSuccess);
  }
});

var deleteMealLogic = (0, _reduxLogic.createLogic)({
  type: DELETE_MEAL,
  processOptions: {
    successType: DELETE_MEAL_SUCCESS,
    failType: ERROR
  },
  process: function process(_ref19) {
    var action = _ref19.action,
        httpClient = _ref19.httpClient;
    var _action$payload9 = action.payload,
        mealPlanId = _action$payload9.mealPlanId,
        mealPlanRecipeId = _action$payload9.mealPlanRecipeId;

    var endpoint = '/v1/voome/meal-plans/' + mealPlanId + '/destroy-meal';
    var params = { mealPlanRecipeId: mealPlanRecipeId };
    var onSuccess = function onSuccess() {
      return action.payload;
    };
    return httpClient.delete(endpoint, { params: params }).then(onSuccess);
  }
});

var mealPlanLogic = exports.mealPlanLogic = [activateLogic, deactivateLogic, createMealLogic, deleteMealLogic, cloneLogic, createMealPlanLogic, deleteMealPlanLogic, fetchLogic, fetchActiveLogic, fetchAllLogic, fetchSwapsLogic, fetchWeekLogic, resetLogic, revertLogic, swapLogic, swapSuccessLogic, updateLogic];

// Action Creators
var fetchMealPlan = exports.fetchMealPlan = function fetchMealPlan(mealPlanId, level) {
  return {
    type: FETCH,
    payload: { mealPlanId: mealPlanId, level: level }
  };
};

var fetchMealPlanSwaps = exports.fetchMealPlanSwaps = function fetchMealPlanSwaps(mealPlanId, memberId, level) {
  return {
    type: FETCH_SWAPS,
    payload: { mealPlanId: mealPlanId, memberId: memberId, level: level }
  };
};

var fetchMealPlanForWeek = exports.fetchMealPlanForWeek = function fetchMealPlanForWeek(payload) {
  return { type: FETCH_WEEK, payload: payload };
};

var fetchMealPlansCurrent = exports.fetchMealPlansCurrent = function fetchMealPlansCurrent(subscriptionId) {
  var key = 'current';
  return { type: FETCH_ALL, payload: { key: key, subscriptionId: subscriptionId } };
};

var fetchMealPlansMine = exports.fetchMealPlansMine = function fetchMealPlansMine(subscriptionId) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var weekId = arguments[2];

  var key = 'mine';
  return { type: FETCH_ALL, payload: { key: key, page: page, subscriptionId: subscriptionId, weekId: weekId } };
};

var fetchMealPlansByVoome = exports.fetchMealPlansByVoome = function fetchMealPlansByVoome(subscriptionId) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var key = 'by-voome';
  return { type: FETCH_ALL, payload: { key: key, page: page, subscriptionId: subscriptionId } };
};

var fetchMealPlanActive = exports.fetchMealPlanActive = function fetchMealPlanActive() {
  return { type: FETCH_ACTIVE };
};

var cloneMealPlan = exports.cloneMealPlan = function cloneMealPlan(mealPlanId, subscriptionId, weekId) {
  return {
    type: CLONE,
    payload: { mealPlanId: mealPlanId, subscriptionId: subscriptionId, weekId: weekId }
  };
};

var createMealPlan = exports.createMealPlan = function createMealPlan(subscriptionId) {
  return {
    type: CREATE,
    payload: { subscriptionId: subscriptionId }
  };
};

var deleteMealPlan = exports.deleteMealPlan = function deleteMealPlan(mealPlanId) {
  return {
    type: DELETE,
    payload: { mealPlanId: mealPlanId }
  };
};

var resetMealPlan = exports.resetMealPlan = function resetMealPlan(mealPlanId) {
  return { type: RESET, payload: { mealPlanId: mealPlanId } };
};

var updateMealPlan = exports.updateMealPlan = function updateMealPlan(mealPlanId, mealPlan) {
  return { type: UPDATE, payload: { mealPlanId: mealPlanId, mealPlan: mealPlan } };
};

var activateMealPlan = exports.activateMealPlan = function activateMealPlan(mealPlanId) {
  return { type: ACTIVATE, payload: { mealPlanId: mealPlanId } };
};

var deactivateMealPlan = exports.deactivateMealPlan = function deactivateMealPlan(mealPlanId) {
  return { type: DEACTIVATE, payload: { mealPlanId: mealPlanId } };
};

var swapMeal = exports.swapMeal = function swapMeal(mealPlanRecipeId, recipeContainerId) {
  return { type: SWAP, payload: { mealPlanRecipeId: mealPlanRecipeId, recipeContainerId: recipeContainerId } };
};

var swapRemove = exports.swapRemove = function swapRemove(mealId) {
  return swapMeal(mealId, 0);
};

var swapRevert = exports.swapRevert = function swapRevert(swappedMealId) {
  return { type: SWAP_REVERT, payload: { swappedMealId: swappedMealId } };
};

var createMeal = exports.createMeal = function createMeal(day, mealPlanId, recipeId, leftOvers) {
  return {
    type: CREATE_MEAL,
    payload: { day: day, leftOvers: leftOvers, mealPlanId: mealPlanId, recipeId: recipeId }
  };
};

var deleteMeal = exports.deleteMeal = function deleteMeal(mealPlanId, mealPlanRecipeId, day) {
  return {
    type: DELETE_MEAL,
    payload: { mealPlanId: mealPlanId, mealPlanRecipeId: mealPlanRecipeId, day: day }
  };
};

// Helpers
var mealsFlat = function mealsFlat(mealPlan) {
  return (0, _flatMap3.default)(mealPlan.days, 'meals');
};
var mealsWithoutLeftovers = function mealsWithoutLeftovers(meals) {
  return (0, _reject3.default)(meals, 'leftOvers');
};
var mealsWithRecipe = function mealsWithRecipe(meals) {
  return (0, _filter3.default)(meals, 'recipeId');
};
var mealsHasSwaps = function mealsHasSwaps(meals) {
  return (0, _some3.default)(meals, 'originalRecipeId');
};

// Selectors
var selectMealPlans = exports.selectMealPlans = function selectMealPlans(state) {
  return state.entities.mealPlans || {};
};

var selectRecipes = exports.selectRecipes = function selectRecipes(state) {
  return state.entities.recipes;
};

var selectMealPlan = exports.selectMealPlan = function selectMealPlan(state, mealPlanId) {
  return mealPlanId ? selectMealPlans(state)[mealPlanId] || {} : {};
};

var selectMealPlanIdForWeek = exports.selectMealPlanIdForWeek = function selectMealPlanIdForWeek(state, weekId) {
  var current = state.entities.current;

  return current ? current[weekId] : undefined;
};

var selectMealPlanIsClone = exports.selectMealPlanIsClone = function selectMealPlanIsClone(state, mealPlanId) {
  var mealPlan = selectMealPlan(state, mealPlanId);
  return mealPlan.associatedId && mealPlan.associatedType ? true : false;
};

var selectMealPlanTitle = exports.selectMealPlanTitle = function selectMealPlanTitle(state, mealPlanId, weekNumber) {
  var _selectMealPlan = selectMealPlan(state, mealPlanId),
      title = _selectMealPlan.title;

  return title || 'Meal Plan';
};

var selectMealPlanList = exports.selectMealPlanList = function selectMealPlanList(state, mealPlanId) {
  var decoratedMeals = function decoratedMeals(meals) {
    return (0, _map3.default)(meals, function (meal, index) {
      return _extends({}, meal, {
        day: meal.day === 0 ? 7 : meal.day,
        mealsInGroup: index === 0 ? meals.length : 0
      });
    });
  };

  return (0, _flatMap3.default)(selectDays(state, mealPlanId), function (day) {
    return decoratedMeals(mealsWithRecipe(day.meals));
  });
};

var selectMealPlanPdfs = exports.selectMealPlanPdfs = function selectMealPlanPdfs(state, mealPlanId, subscriptionId) {
  var mealPlan = selectMealPlan(state, mealPlanId);

  if (mealPlan.id && subscriptionId) {
    var prepend = _settings.hosts.api + '/v1/voome/subscriptions/' + subscriptionId + '/meal-plans/' + mealPlan.id;

    return {
      mealPlan: prepend + '/print',
      recipes: prepend + '/print-recipes',
      shoppingList: prepend + '/shopping-list'
    };
  }
};

var selectMealPlansByType = exports.selectMealPlansByType = function selectMealPlansByType(state, type) {
  var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  var _selectPaginationByTy = selectPaginationByType(state, type, page),
      result = _selectPaginationByTy.result;

  return (0, _map3.default)(result, function (id) {
    return selectMealPlan(state, id);
  });
};

var selectMealPlansCurrent = exports.selectMealPlansCurrent = function selectMealPlansCurrent(state) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  return selectMealPlansByType(state, 'current', page);
};

var selectMealsHasCookup = exports.selectMealsHasCookup = function selectMealsHasCookup(state, mealPlanId) {
  return (0, _some3.default)(mealsFlat(selectMealPlan(state, mealPlanId)), 'cookup');
};

var selectPaginationByType = exports.selectPaginationByType = function selectPaginationByType(state, type) {
  var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  return state.entities[type] ? state.entities[type][page] || {} : {};
};

var selectDays = exports.selectDays = function selectDays(state, mealPlanId) {
  var recipes = selectRecipes(state);

  var _selectMealPlan2 = selectMealPlan(state, mealPlanId),
      days = _selectMealPlan2.days;

  var calculateCalories = function calculateCalories(sum, meal) {
    var recipe = recipes[meal.recipeId];
    return sum + (recipe.caloriesPerServe || 0);
  };

  var recipe = function recipe(meal) {
    return _extends({}, meal, {
      recipe: recipes[meal.recipeId],
      originalRecipe: recipes[meal.originalRecipeId]
    });
  };

  var dayWithMeals = function dayWithMeals(day) {
    return _extends({}, day, {
      calories: (0, _reduce3.default)(mealsWithRecipe(day.meals), calculateCalories, 0),
      meals: (0, _map3.default)(day.meals, recipe)
    });
  };

  return (0, _map3.default)(days, dayWithMeals);
};

var selectShoppingListRecipes = exports.selectShoppingListRecipes = function selectShoppingListRecipes(state, mealPlanId) {
  var mealsFlow = (0, _flow3.default)([mealsFlat, mealsWithoutLeftovers, mealsWithRecipe]);

  return (0, _map3.default)(mealsFlow(selectMealPlan(state, mealPlanId)), function (meal) {
    return selectRecipes(state)[meal.recipeId];
  });
};

var selectPageForMealPlanId = exports.selectPageForMealPlanId = function selectPageForMealPlanId(state, mealPlanId, type) {
  var resultHasMealPlan = function resultHasMealPlan(item) {
    return item.result.indexOf(mealPlanId) > -1;
  };
  return (0, _findKey3.default)(state.entities[type], resultHasMealPlan);
};

var selectHasMealPlanRecipe = exports.selectHasMealPlanRecipe = function selectHasMealPlanRecipe(state, mealPlanId) {
  return (0, _some3.default)((0, _flatMap3.default)(selectDays(state, mealPlanId), function (day) {
    return day.meals;
  }), 'recipeId');
};

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type,
      payload = action.payload;


  var reduceEntities = function reduceEntities(stateEnities, payloadEntities) {
    return _extends({}, stateEnities, {
      byVoome: _extends({}, stateEnities.byVoome, payloadEntities.byVoome),
      mine: _extends({}, stateEnities.mine, payloadEntities.mine),
      mealPlans: _extends({}, stateEnities.mealPlans, payloadEntities.mealPlans),
      recipes: _extends({}, stateEnities.recipes, payloadEntities.recipes)
    });
  };

  switch (type) {
    case FETCH:
    case FETCH_SWAPS:
      return _extends({}, state, {
        isLoading: true,
        level: payload.level
      });

    case FETCH_WEEK:
      return _extends({}, state, {
        isLoading: true,
        level: payload.level,
        active: null
      });

    case FETCH_ACTIVE:
    case FETCH_ALL:
    case DELETE:
    case UPDATE:
      return _extends({}, state, {
        isLoading: true
      });

    case ACTIVATE:
    case DEACTIVATE:
      return _extends({}, state, {
        isActivating: true
      });

    case CLONE:
    case CREATE:
      return _extends({}, state, {
        isCreating: true,
        result: null
      });

    case RESET:
    case SWAP:
    case SWAP_REVERT:
      return _extends({}, state, {
        isSwapping: true
      });

    case CREATE_MEAL:
    case DELETE_MEAL:
      return _extends({}, state, {
        isSwapping: true,
        isSwappingDay: payload.day
      });

    // Success
    case FETCH_SUCCESS:
    case CREATE_SUCCESS:
    case CLONE_SUCCESS:
    case CREATE_MEAL_SUCCESS:
      // Might need to move this.
      return _extends({}, state, {
        isCreating: false,
        isLoading: false,
        isSwapping: false,
        isSwappingDay: -1,
        result: payload.result,
        entities: reduceEntities(state.entities, payload.entities)
      });

    case FETCH_WEEK_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        entities: _extends({}, state.entities, {
          current: _extends({}, state.entities.current, _defineProperty({}, payload.weekId, payload.mealPlanId))
        })
      });

    case FETCH_ACTIVE_SUCCESS:
      var entities = state.entities.mealPlans[payload.result] ? state.entities : reduceEntities(state.entities, payload.entities);

      return _extends({}, state, {
        isLoading: false,
        active: payload.result,
        entities: entities
      });

    case FETCH_ALL_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        result: null,
        entities: _extends({}, reduceEntities(state.entities, payload.entities), _defineProperty({}, payload.key, _extends({}, state.entities[payload.key], payload.entities[payload.key])))
      });

    case ACTIVATE_SUCCESS:
    case DEACTIVATE_SUCCESS:
      return _extends({}, state, {
        isActivating: false,
        active: payload.mealPlanId
      });

    case DELETE_MEAL_SUCCESS:
      var _action$payload10 = action.payload,
          day = _action$payload10.day,
          mealPlanId = _action$payload10.mealPlanId,
          mealPlanRecipeId = _action$payload10.mealPlanRecipeId;

      var mealPlan = state.entities.mealPlans[mealPlanId];
      var recipeId = void 0;

      var days = (0, _map3.default)(mealPlan.days, function (dayInfo) {
        if (dayInfo.day === day) {
          recipeId = (0, _find3.default)(dayInfo.meals, { id: mealPlanRecipeId }).recipeId;
          return _extends({}, dayInfo, {
            meals: (0, _reject3.default)(dayInfo.meals, { id: mealPlanRecipeId })
          });
        } else {
          return dayInfo;
        }
      });

      return _extends({}, state, {
        isSwapping: false,
        isSwappingDay: -1,
        entities: _extends({}, state.entities, {
          mealPlans: _extends({}, state.entities.mealPlans, _defineProperty({}, mealPlanId, _extends({}, mealPlan, {
            days: days,
            recipeCount: mealPlan.recipeCount - 1,
            recipes: (0, _reject3.default)(mealPlan.recipes, function (id) {
              return id === recipeId;
            })
          })))
        })
      });

    case DELETE_SUCCESS:
      // Destructuring technique to create a new immutable mealPlan with key
      // removed, key must be a string to work - go figure.
      var key = '' + payload.mealPlanId;

      var _state$entities$mealP = state.entities.mealPlans,
          _undefined = _state$entities$mealP[key],
          mealPlans = _objectWithoutProperties(_state$entities$mealP, [key]);

      return _extends({}, state, {
        isLoading: false,
        entities: _extends({}, state.entities, {
          mealPlans: mealPlans,
          mine: null
        })
      });

    case UPDATE_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        entities: _extends({}, state.entities, {
          mealPlans: _extends({}, state.entities.mealPlans, _defineProperty({}, payload.mealPlanId, _extends({}, state.entities.mealPlans[payload.mealPlanId], payload.mealPlan)))
        })
      });

    // Fail
    case ERROR:
      return _extends({}, state, {
        isCreating: false,
        isLoading: false,
        isSwapping: false,
        isSwappingDay: -1
      });

    default:
      return state;
  }
}

/***/ }),

/***/ "Kh7Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FormCheckboxToggle = exports.FormCheckboxToggle = {
  bindings: {
    form: '<',
    name: '@',
    value: '<',
    onUpdate: '&'
  },

  template: '\n    <label class="text-teal border-0 m-0 p-0">\n      <input\n        class="d-none"\n        type="checkbox"\n        name="{{ $ctrl.name }}"\n        ng-value="$ctrl.value"\n        ng-model="$ctrl.form.data[$ctrl.name]"\n        ng-click="$ctrl.onUpdate({\n          key: $ctrl.name,\n          value: !$ctrl.value,\n        })"/>\n      <i class="fa fa-2x"\n        ng-class="{\n          \'fa-toggle-on\': $ctrl.value,\n          \'fa-toggle-off\': !$ctrl.value\n        }"></i>\n    </label>',

  controller: function controller() {
    return {
      // For some reason ng-value is not updating ng-model when $ctrl.value
      // resolves. $onChanges is essentially doing this manually.
      $onChanges: function $onChanges() {
        var field = this.form[this.name];

        if (this.value && field && !field.$viewValue) {
          field.$setViewValue(this.value);
        }
      }
    };
  }
};

/***/ }),

/***/ "L/ed":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WorkoutPlayerInstructions = undefined;

var _get2 = __webpack_require__("Q7hp");

var _get3 = _interopRequireDefault(_get2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WorkoutPlayerInstructions = exports.WorkoutPlayerInstructions = {
  bindings: {
    step: '<',
    show: '<',
    onClose: '&'
  },

  template: '\n    <div class="workout-player-detail pb-4"\n      ng-show="$ctrl.show" id="exercise-details">\n      <div class="close-btn-container">\n        <div class="close-btn">\n          <button\n            type="button"\n            ng-click="$ctrl.onClose()"\n            class="btn-link">\n            Close Instructions\n            <i class="fa fa-times"></i>\n          </button>\n        </div>\n      </div>\n      <div class="exercise-info-container pt-3"\n        ng-bind-html="$ctrl.step.exercise.contentHtml">\n      </div>\n      <div class="mish-tips-container"\n        ng-show="$ctrl.step.exercise.mishTipsHtml">\n        <h3>Coaching Zone Tips</h3>\n        <div ng-bind-html="$ctrl.step.exercise.mishTipsHtml"></div>\n      </div>\n    </div>',

  controller: ["$element", function controller($element) {
    'ngInject';

    return {
      $onChanges: function $onChanges(changes) {
        if ((0, _get3.default)(changes, 'show.currentValue') === true) {
          $('html, body').animate({
            scrollTop: $element.offset().top
          });
        }
      }
    };
  }]
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "L1S1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MealPlanNav = exports.MealPlanNav = {
  bindings: {
    name: '<',
    isDisabled: '<',
    mealPlanName: '@',
    shoppingListName: '@',
    onClick: '&'
  },

  template: '\n    <div class="meal-plan-nav pill-toggle d-flex">\n      <button class="btn btn-sm btn-pill w-100"\n        ng-class="{ \'btn-primary\': $ctrl.name === $ctrl.mealPlanName }"\n        ng-disabled="$ctrl.isDisabled"\n        ng-click="$ctrl.onClick({ name: $ctrl.mealPlanName })">\n        Meal Plan\n      </button>\n      <button class="btn btn-sm btn-pill w-100"\n        ng-class="{ \'btn-primary\': $ctrl.name === $ctrl.shoppingListName }"\n        ng-disabled="$ctrl.isDisabled"\n        ng-click="$ctrl.onClick({ name: $ctrl.shoppingListName })">\n        Shopping List\n      </button>\n    </div>'
};

/***/ }),

/***/ "LSoI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BoxCorner = exports.BoxCorner = {
  bindings: {
    icon: '@'
  },

  template: '\n    <div class="box-corner theme-box-corner">\n      <i class="fa fa-{{ $ctrl.icon }} fa--box-corner"></i>\n    </div>'
};

/***/ }),

/***/ "Ll2K":
/***/ (function(module, exports) {

module.exports = settings;

/***/ }),

/***/ "Ltgl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FormLabelCheckbox = exports.FormLabelCheckbox = {
  transclude: true,

  bindings: {
    name: '<',
    active: '<',
    disabled: '<',
    model: '=?',
    value: '<',
    onClick: '&'
  },

  template: '\n    <label\n      class="radio-answer p-3 d-flex justify-content-center align-items-center text-center rounded"\n      ng-class="{\n        \'theme-mid theme-color bg-cz-theme-secondary\': $ctrl.active,\n        \'bg-whitesmoke\': !$ctrl.active,\n        \'text-dark\': !$ctrl.disabled && !$ctrl.active,\n        \'text-light\': $ctrl.disabled,\n      }">\n      <input\n        class="d-none"\n        type="checkbox"\n        name="{{ $ctrl.name }}"\n        value="{{ $ctrl.value }}"\n        ng-disabled="$ctrl.disabled"\n        ng-model="$ctrl.model"\n        ng-click="$ctrl.onClick({ value: $ctrl.value })">\n      <ng-transclude></ng-transclude>\n    </label>'
};

/***/ }),

/***/ "M3Et":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var NavPage = exports.NavPage = {
  transclude: {
    left: '?navLeft',
    right: '?navRight'
  },

  bindings: {
    active: '@'
  },

  template: '\n    <nav class="navbar navbar-page bg-gray-100 border border-y px-0 px-sm-2">\n      <div class="container">\n        <div class="d-flex justify-content-between w-100 px-1">\n          <div ng-transclude="left"></div>\n          <div ng-transclude="right"></div>\n        </div>\n      </div>\n    </nav>'
};

/***/ }),

/***/ "MO+i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.anchorStorage = undefined;

var _kebabCase2 = __webpack_require__("Ex7i");

var _kebabCase3 = _interopRequireDefault(_kebabCase2);

var _store = __webpack_require__("Y4FN");

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEY = 'anchor';

var anchorStorage = exports.anchorStorage = {
  get: function get() {
    return _store2.default.get(KEY) || {};
  },
  set: function set(state, value) {
    var name = state.router.currentState.name;

    var hash = (0, _kebabCase3.default)(value);
    _store2.default.set(KEY, { name: name, hash: hash });
  },
  remove: function remove() {
    _store2.default.remove(KEY);
  }
};

/***/ }),

/***/ "MZTQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mts3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WorkoutPlayerTimer = exports.WorkoutPlayerTimer = {
  bindings: {
    step: '<',
    elapsedTime: '<',
    countdown: '<',
    onStarted: '&',
    onCompleted: '&'
  },

  template: '\n    <div class="current-exercise-panel-inner">\n      <div class="attribute"\n        ng-repeat="attribute in $ctrl.step.displayAttributes track by $index">\n        <div class="timer-container" ng-if="$index === 0">\n          <strong class="timer-title">\n            {{ attribute }}\n          </strong>\n          <span class="sets-count text-uppercase"\n            ng-if="$ctrl.step.setsCount > 0">\n            <span class="pipe-divider">|</span>\n            Set\n            {{ $ctrl.step.setNumber }}\n            of\n            {{ $ctrl.step.setsCount }}\n          </span>\n          <div class="exercise-progress animated-progress-bar-container"></div>\n          <span class="timer-value">\n            <span ng-if="attribute === \'time\'">\n              {{ $ctrl.time | date: \'m:ss\' }}\n            </span>\n            <span ng-if="attribute !== \'time\'">\n              {{ $ctrl.step[attribute] || $ctrl[attribute] }}\n            </span>\n          </span>\n          <div class="amrap" ng-if="$ctrl.step.amrap">\n            AMRAP\n          </div>\n        </div>\n        <div class="meta-container" ng-if="$index > 0">\n          <span class="meta-name" ng-switch="attribute">\n            <span ng-switch-when="eachSide">\n              Side\n            </span>\n            <span ng-switch-when="inclineNumber">\n              Incline\n            </span>\n            <span ng-switch-default>\n              {{ attribute }}\n            </span>\n          </span>\n          <span class="meta-value" ng-switch="attribute">\n            <span ng-switch-when="eachSide">\n              {{ $ctrl.side }}\n            </span>\n            <span ng-switch-when="alternate">\n              {{ $ctrl.side }}\n            </span>\n            <span ng-switch-default>\n              {{ $ctrl.step[attribute] }}\n            </span>\n          </span>\n        </div>\n      </div>\n      <div class="meta-container amrap" ng-if="$ctrl.step.amrap">\n        AMRAP\n      </div>\n    </div>',

  controller: function controller() {
    'ngInject';

    return {
      $onInit: function $onInit() {
        this.started = false;
        this.completed = false;
      },
      $onChanges: function $onChanges(changesObj) {
        if (this.step && (changesObj.elapsedTime || changesObj.countdown)) {
          this.update();
        }
      },
      update: function update() {
        var step = this.step,
            elapsedTime = this.elapsedTime,
            countdown = this.countdown;

        // Callbacks for started/completed

        var started = countdown === 0;
        var completed = elapsedTime === step.totalTimeInSeconds;

        if (started && !this.started) {
          this.onStarted();
        }

        if (completed && !this.completed) {
          this.onCompleted();
        }

        this.started = started;
        this.completed = completed;

        this.setSide();
        this.setReps();
        this.setTime();
      },
      setSide: function setSide() {
        var completed = this.completed,
            elapsedTime = this.elapsedTime,
            started = this.started,
            step = this.step;

        // Side

        var side = '';

        // Alternate exercise
        if (step.alternate && ((Math.floor(elapsedTime / step.repTime) + 1) % 2 > 0 || elapsedTime === 0) && !completed) {
          side = 'Left';
        } else if (step.alternate && (Math.floor(elapsedTime / step.repTime) + 1) % 2 === 0 || completed) {
          side = 'Right';
        } else if (step.eachSide && elapsedTime < step.totalTimeInSeconds / 2) {
          side = 'Left';
        } else if (step.eachSide && elapsedTime >= step.totalTimeInSeconds / 2) {
          side = 'Right';
        }

        // Don't show specific side if we haven't started
        if (!started) {
          if (step.alternate) {
            side = 'L/R';
          } else if (step.eachSide) {
            side = 'Each';
          }
        }

        this.side = side;
      },
      setReps: function setReps() {
        var elapsedTime = this.elapsedTime,
            side = this.side,
            started = this.started,
            step = this.step;

        // Reps complete

        var reps = Math.floor(elapsedTime / step.repTime) + 1;

        if (step.eachSide && side === 'Right') {
          // Adjusting reps for the second half of side based exercise
          reps -= step.repsCount;
        }

        reps = started ? Math.min(reps, step.repsCount) + '/' + step.repsCount : step.repsCount;

        this.sameRep = this.reps === reps;
        this.reps = reps;
      },


      // Time remaining
      setTime: function setTime() {
        var elapsedTime = this.elapsedTime,
            side = this.side,
            step = this.step;


        var time = step.totalTimeInSeconds - elapsedTime;

        // Halve time for side based exercises
        if (step.eachSide && side === 'Left') {
          time -= step.totalTimeInSeconds / 2;
        }

        time = Math.max(time, 0);

        this.time = time * 1000;
      }
    };
  }
};

/***/ }),

/***/ "NCZo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBar = undefined;

var _size2 = __webpack_require__("4Fgk");

var _size3 = _interopRequireDefault(_size2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressBar = exports.ProgressBar = {
  bindings: {
    weeks: '<',
    percentage: '<',
    imgSrc: '<'
  },

  template: '\n    <div class="progress-bar">\n      <ol class="progress-bar-steps">\n        <li class="step"\n          ng-class="{ \'active\': $ctrl.isStepActive(0) }">\n          <div class="step-icon"></div>\n        </li>\n        <li class="step"\n          ng-class="{ \'active\': $ctrl.isStepActive(week.weekNumber) }"\n          ng-repeat="week in $ctrl.weeks track by $index">\n          <div class="step-icon"></div>\n        </li>\n      </ol>\n      <div class="progress-bar-line">\n        <div class="line" ng-style="{ width: $ctrl.percentage + \'%\' }"></div>\n        <div class="line-bg"></div>\n        <div class="line-avatar"\n          ng-style="{ left: $ctrl.percentage + \'%\' }">\n          <image-circle src="$ctrl.imgSrc"></image-circle>\n        </div>\n      </div>\n    </div>',

  controller: function controller() {
    return {
      isStepActive: function isStepActive(step) {
        return this.percentage >= step / (0, _size3.default)(this.weeks) * 100;
      }
    };
  }
};

/***/ }),

/***/ "NDF/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Nz84":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WorkoutPlayer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__("0xDb");

var _product = __webpack_require__("5AvL");

var _theme = __webpack_require__("ZID5");

var _member = __webpack_require__("1OIp");

var _workout = __webpack_require__("Toxe");

var WorkoutPlayer = exports.WorkoutPlayer = {
  template: '\n    <div class="workout-player-container">\n      <workout-player-header\n        is-complete="$ctrl.player.completed"\n        is-finished="$ctrl.finished"\n        on-click-finish="$ctrl.finished = true"\n        on-click-logo="$ctrl.changeSubscription($ctrl.subscription)">\n      </workout-player-header>\n      <div ng-hide="$ctrl.finished">\n        <workout-player-progress-bar\n          steps="$ctrl.steps"\n          current-step="$ctrl.currentStep"\n          current-step-index="$ctrl.currentStepIndex"\n          time="$ctrl.player.elapsedTime">\n        </workout-player-progress-bar>\n        <a class="workout-player-exercise-name"\n          href="#"\n          ng-click="$ctrl.toggleDetails()">\n          {{ $ctrl.currentStep.exercise.name }}\n          <i class="fa fa-info-circle"></i>\n        </a>\n        <div class="workout-player-video-container">\n          <div class="workout-player-video" ng-if="$ctrl.currentStep.exercise.video">\n            <workout-player-video\n              countdown-complete="$ctrl.player.started"\n              video-scale="{{ $ctrl.currentStep.exerciseVideo.scale }}"\n              video-id="{{ $ctrl.currentStep.video.brightcoveId }}"\n              autoplay="true"\n              playing="$ctrl.player.playing"\n              waiting="$ctrl.player.waiting"\n              on-play="$ctrl.play()"\n              on-wait="$ctrl.player.waiting = true"\n              on-resume="$ctrl.player.waiting = false">\n            </workout-player-video>\n          </div>\n          <div class="side-panels-container">\n            <workout-player-context-panel\n              workout="$ctrl.workout"\n              steps="$ctrl.steps"\n              current-step="$ctrl.currentStep"\n              current-step-index="$ctrl.currentStepIndex"\n              exercises="$ctrl.exercises"\n              on-click="$ctrl.toggleDetails()">\n            </workout-player-context-panel>\n            <div class="workout-player-current-exercise-panel"\n              ng-show="$ctrl.currentStep"\n              ng-class="{\n                \'final-blast\': $ctrl.currentStep.group.name.toLowerCase() === \'final blast\',\n                \'step-complete\': $ctrl.player.completed\n              }">\n              <workout-player-countdown\n                countdown="$ctrl.player.countdown"\n                playing="$ctrl.player.playing"\n                waiting="$ctrl.player.waiting">\n              </workout-player-countdown>\n              <workout-player-timer\n                step="$ctrl.currentStep"\n                elapsed-time="$ctrl.player.elapsedTime"\n                countdown="$ctrl.player.countdown"\n                on-started="$ctrl.started()"\n                on-completed="$ctrl.completed()">\n              </workout-player-timer>\n            </div>\n          </div>\n        </div>\n        <div class="workout-player-footer d-flex flex-column flex-md-row"\n          ng-class="{\n            \'final-blast\': $ctrl.currentStep.group.name.toLowerCase() === \'final blast\',\n            \'step-complete\': $ctrl.player.completed\n          }">\n          <div class="workout-player-caption py-2 py-md-0 flex-last flex-md-first"\n            ng-class="{ \'step-complete\': $ctrl.player.completed }">\n            <img\n              ng-src="{{ $ctrl.nextStep.exercise.icon.thumb2x | assetSrc }}"\n              ng-if="$ctrl.nextStep.exercise.icon">\n            <span>\n              <strong class="text-uppercase">Next:</strong>\n              {{ $ctrl.nextStep.exercise.name || \'Workout Complete\' }}\n            </span>\n          </div>\n          <div class="workout-player-controls d-flex ml-md-auto">\n            <workout-player-controls\n              playing="$ctrl.player.playing"\n              completed="$ctrl.player.completed"\n              continuous="$ctrl.continuous"\n              previous-step="$ctrl.previousStep"\n              next-step="$ctrl.nextStep"\n              on-toggle="$ctrl.toggle()"\n              on-toggle-continuous="$ctrl.continuous = !$ctrl.continuous"\n              on-restart="$ctrl.restartStep()"\n              on-back="$ctrl.goPrevious()"\n              on-next="$ctrl.goNext()">\n            </workout-player-controls>\n          </div>\n        </div>\n        <workout-player-instructions\n          step="$ctrl.currentStep"\n          show="$ctrl.showDetails"\n          on-close="$ctrl.showDetails = false">\n        </workout-player-instructions>\n      </div>\n      <div ng-show="$ctrl.finished">\n        <workout-player-finished\n          workout="$ctrl.workout"\n          member="$ctrl.member"\n          voome-product-id="$ctrl.voomeProductId">\n        </workout-player-finished>\n      </div>\n      <workout-player-sleeper\n        playing="$ctrl.player.playing"\n        on-play="$ctrl.play()"\n        on-pause="$ctrl.pause()">\n      </workout-player-sleeper>\n    </div>',

  controller: ["$ngRedux", "$interval", "$timeout", function controller($ngRedux, $interval, $timeout) {
    'ngInject';

    var ticker = void 0;
    var time = void 0;
    var timePrev = void 0;

    var initialPlayerState = {
      started: false,
      completed: false,
      elapsedTime: 0,
      countdown: null,
      waiting: true,
      autoplay: false
    };

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState.bind(this), this.mapDispatch());

        this.disconnect = connect(this);
        this.continuous = true;
        this.autoplay = true;

        this.initPlayer({
          playing: false,
          startPlaying: true
        });

        this.setNavType('none');
        this.fetchWorkout(this.exercisePlanId, this.id, this.itemId || 0);
      },
      $onDestroy: function $onDestroy() {
        this.setNavType('main');
        this.updateWorkoutStep(0);
        this.disconnect();
      },
      mapState: function mapState(state) {
        var _state$router$current = state.router.currentParams,
            exercisePlanId = _state$router$current.exercisePlanId,
            id = _state$router$current.id,
            itemId = _state$router$current.itemId;


        var product = (0, _product.selectProduct)(state.product);
        var currentStep = (0, _workout.selectCurrentStep)(state.workout);
        var currentStepIndex = state.workout.currentStepIndex;

        // TODO: look into removing this, dont want it in mapState
        this.updatePlayer(currentStep, currentStepIndex);

        return {
          id: id,
          exercisePlanId: exercisePlanId,
          itemId: itemId,
          currentStep: currentStep,
          currentStepIndex: currentStepIndex,
          exercises: (0, _workout.selectExercises)(state.workout),
          member: (0, _member.selectMember)(state.member),
          nextStep: (0, _workout.selectNextStep)(state.workout),
          previousStep: (0, _workout.selectPreviousStep)(state.workout),
          steps: (0, _workout.selectWorkoutSteps)(state.workout),
          subscription: (0, _member.selectSubscription)(state.member),
          voomeProductId: product && product.id,
          workout: (0, _workout.selectWorkout)(state.workout)
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          changeSubscription: _member.changeSubscription,
          fetchWorkout: _workout.fetchWorkout,
          nextWorkoutStep: _workout.nextWorkoutStep,
          previousWorkoutStep: _workout.previousWorkoutStep,
          setNavType: _theme.setNavType,
          updateWorkoutStep: _workout.updateWorkoutStep
        };
      },
      initPlayer: function initPlayer() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        this.player = _extends({}, initialPlayerState, options);
      },


      // TODO: check with DCAL if this can moved to $onInit.
      updatePlayer: function updatePlayer(step, stepIndex) {
        if (!step || !this.player) {
          return;
        }

        // If the step index has changed,
        // or we've flagged the player to restart
        if (stepIndex !== this.player.stepIndex || this.player.restart) {
          if (this.player.startPlaying) {
            this.playDelay();
          }

          this.initPlayer({
            countdown: step.restSeconds,
            playing: this.player.playing,
            stepIndex: stepIndex
          });

          // Sync the ticker with the player
          this.sync();
        }
      },
      start: function start() {
        var _this = this;

        this.clock();
        ticker = $interval(function () {
          return _this.tick();
        }, 1000);
      },
      stop: function stop() {
        if (ticker) {
          $interval.cancel(ticker);
          ticker = null;
        }
      },
      sync: function sync() {
        if (ticker) {
          this.stop();
          this.start();
        }
      },
      tick: function tick() {
        var timePassed = this.clock();

        if (timePassed > 0) {
          if (this.player.countdown > 0) {
            this.player.countdown = this.player.countdown - timePassed;
          } else {
            this.player.elapsedTime = this.player.elapsedTime + timePassed;
          }
        }
      },


      // Sets time to now.
      // Returns time passed since last clock.
      clock: function clock() {
        timePrev = time;
        time = Math.round(Date.now() / 1000);
        return timePrev ? time - timePrev : 0;
      },
      play: function play() {
        this.stop();
        this.start();
        this.player.playing = true;
      },
      pause: function pause() {
        this.stop();
        this.player.playing = false;
      },
      toggle: function toggle() {
        if (this.player.playing) {
          this.pause();
        } else {
          this.play();
        }

        if (this.player.playing && this.player.countdown > 0) {
          this.player.countdown = 5;
        }
      },
      playDelay: function playDelay() {
        var _this2 = this;

        var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;

        $timeout(function () {
          return _this2.play();
        }, delay);
      },
      started: function started() {
        this.player.started = true;
      },
      completed: function completed() {
        this.player.completed = true;
        this.pause();

        if (this.continuous) {
          this.goNext();
          this.playDelay();
        }
      },
      finish: function finish() {
        this.finished = true;
      },
      goPrevious: function goPrevious() {
        this.previousWorkoutStep(this.currentStepIndex);
      },
      goNext: function goNext() {
        if (this.nextStep) {
          this.nextWorkoutStep(this.currentStepIndex);
        } else {
          this.finish();
        }
      },
      restartStep: function restartStep() {
        this.player.restart = true;
        this.updateWorkoutStep(this.currentStepIndex);
        this.play();
      },
      toggleDetails: function toggleDetails() {
        this.showDetails = !this.showDetails;

        if (this.showDetails) {
          this.pause();
        }
      }
    };
  }]
};

/***/ }),

/***/ "O00g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DashboardNutritionMealPlan = exports.DashboardNutritionMealPlan = {
  bindings: {
    mealPlan: '<',
    mealPlanList: '<',
    mealPlansCurrent: '<',
    mealPlansTotal: '<',
    subscriptionId: '<'
  },

  template: '\n    <div class="dashboard-nutrition-meal-plan">\n      <div class="carousel-mealplan" ng-show="$ctrl.mealPlanList.length">\n        <dashboard-carousel>\n          <dashboard-carousel-header>\n            <h4>{{ $ctrl.mealPlan.title }}</h4>\n          </dashboard-carousel-header>\n          <dashboard-carousel-body>\n            <carousel\n              list="$ctrl.mealPlanList">\n              <div class="carousel-slide-wrapper"\n                ng-class="item.mealsInGroup > 0 ? \'carousel-slide-group carousel-slide-group-\' + item.mealsInGroup : \'\'"\n                ng-repeat="item in $ctrl.mealPlanList track by $index">\n                <div class="carousel-slide">\n                  <div class="completer clearfix">\n                    <div class="completer-action">\n                      <span class="completer-title text-uppercase pl-2">\n                        <span ng-show="item.mealsInGroup">{{ item.dayString }}</span>\n                      </span>\n                    </div>\n                  </div>\n                  <card-recipe\n                    recipe="item.recipe"\n                    is-leftover="item.leftOvers"\n                    on-click="$ctrl.stateGo(\'nutrition.recipes.detail\', { recipeId: item.recipeId })">\n                  </card-recipe>\n                </div>\n              </div>\n            </carousel>\n          </dashboard-carousel-body>\n          <dashboard-carousel-footer>\n            <a ui-sref="nutrition.mealPlans.detail({ mealPlanId: $ctrl.mealPlan.id})">\n              View and edit this plan\n            </a>\n            <span class="px-sm-2 text-gray">|</span>\n            <a ui-sref="nutrition.mealPlans({ type: \'mine\' })">My Plans</a>\n            <span class="px-sm-2 text-gray">|</span>\n            <a ui-sref="nutrition.mealPlans({ type: \'byVoome\' })">Ready-made Plans</a>\n          </dashboard-carousel-footer>\n        </dashboard-carousel>\n      </div>\n      <div ng-show="!$ctrl.mealPlanList.length && $ctrl.mealPlansCurrent.length">\n        <dashboard-carousel>\n          <dashboard-carousel-body>\n            <carousel list="[1,2,3]">\n              <div class="carousel-slide-wrapper"\n                ng-repeat="item in $ctrl.mealPlansCurrent track by $index">\n                <div class="carousel-slide">\n                  <div class="card-book-recipe">\n                    <card-book ng-click="$ctrl.stateGo(\'nutrition.mealPlans.detail\', { mealPlanId: item.id })">\n                      <left-page>\n                        <div class="px-4 pt-2">\n                          <i class="fa fa-2x icon-voome-flame text-green"></i>\n                          <h1 class="h6">{{ item.title }}</h1>\n                          <!-- <p ng-bind="item.description" class="small"></p> -->\n                          <p class="small text-muted pb-2 mb-0">\n                            {{ item.recipeCount }} meals\n                            <meal-plan-tags tags="item.tags" type="diet">|</meal-plan-tags>\n                            <meal-plan-tags tags="item.tags">|</meal-plan-tags>\n                          </p>\n                        </div>\n                      </left-page>\n                      <right-page>\n                        <image-background src="item.heroImage.medium"></image-background>\n                      </right-page>\n                    </card-book>\n                  </div>\n                </div>\n              </div>\n              <div class="carousel-slide-wrapper">\n                <div class="carousel-slide">\n                  <div class="card-book-empty">\n                    <card-book ng-click="$ctrl.stateGo(\'nutrition.mealPlans\')">\n                      <left-page>\n                        <div class="px-4 text-center">\n                          <p class="text-green-dark m-0">\n                            View All {{ $ctrl.mealPlansTotal }}\n                          </p>\n                          <h6 class="text-green-dark">\n                            Ready-made Plans\n                          </h6>\n                        </div>\n                      </left-page>\n                      <right-page>\n                        <i class="fa fa-4x icon-voome-flame text-green"></i>\n                      </right-page>\n                    </card-book>\n                  </div>\n                </div>\n              </div>\n            </carousel>\n          </dashboard-carousel-body>\n          <dashboard-carousel-footer>\n            <a ui-sref="nutrition.mealPlans({ type: \'mine\' })">My Plans</a>\n            <span class="px-sm-2">|</span>\n            <meal-plan-create-button\n              style="link"\n              subscription-id="$ctrl.subscriptionId">\n              Start a new plan\n            </meal-plan-create-button>\n          </dashboard-carousel-footer>\n        </dashboard-carousel>\n      </div>\n    </div>',

  controller: ["$state", function controller($state) {
    'ngInject';

    return {
      stateGo: $state.go
    };
  }]
};

/***/ }),

/***/ "OMXv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NutritionMealPlan = undefined;

var _reduxUiRouter = __webpack_require__("Zb/7");

var _member = __webpack_require__("1OIp");

var _mealPlan = __webpack_require__("KLwp");

var NutritionMealPlan = exports.NutritionMealPlan = {
  template: '\n    <div class="nutrition-meal-plan bg-white">\n      <header class="container text-center pt-4 pb-3">\n        <div class="row">\n          <div class="col-md-8 mx-auto">\n            <header class="mb-3"\n              ng-hide="$ctrl.isEditing">\n              <h2 class="m-0">\n                <spinner is-loading="$ctrl.isLoading">\n                  {{ $ctrl.mealPlan.title || \'Loading...\' }}\n                </spinner>\n              </h2>\n              <span>\n                <button-link\n                  ng-click="$ctrl.isEditing = true; title = null;"\n                  ng-show="$ctrl.mealPlan.associatedId">\n                  <small>Edit Name</small>\n                </button-link>\n              </span>\n            </header>\n            <form class="col-12 col-md-6 p-0 mx-auto d-flex flex-row align-items-center mb-3"\n              name="form"\n              ng-submit="$ctrl.updateMealPlan($ctrl.mealPlan.id, { title: title }); $ctrl.isEditing = false;"\n              ng-show="$ctrl.isEditing"\n              no-validate>\n              <label class="sr-only" for="mealPlanTitle">Username</label>\n              <div class="input-group mr-3">\n                <input class="form-control"\n                  id="mealPlanTitle"\n                  type="text"\n                  placeholder="{{ $ctrl.mealPlan.title }}"\n                  name="title"\n                  ng-model="title"\n                  ng-minLength="6"\n                  ng-required>\n                <div class="input-group-append">\n                  <div class="input-group-text">\n                    <button class="btn btn-link p-0"\n                      ng-disabled="form.$pristine || form.$invalid"\n                      type="submit">\n                      Submit\n                    </button>\n                  </div>\n                </div>\n              </div>\n              <button-link ng-click="$ctrl.isEditing = false">\n                Cancel\n              </button-link>\n            </form>\n            <p ng-if="$ctrl.mealPlan.description">\n              {{ $ctrl.mealPlan.description }}\n            </p>\n            <meal-plan-nav\n              name="$ctrl.name"\n              meal-plan-name="nutrition.mealPlans.detail"\n              shopping-list-name="nutrition.mealPlans.detail.shoppingList"\n              is-disabled="!$ctrl.mealPlan || $ctrl.mealPlan.recipeCount < 1"\n              on-click="$ctrl.stateGo(name)">\n            </meal-plan-nav>\n          </div>\n        </div>\n      </header>\n      <ui-view>\n        <meal-plan></meal-plan>\n      </ui-view>\n    </div>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        this.fetchMealPlan(this.mealPlanId, this.level);

        if (!this.active) {
          this.fetchMealPlanActive();
        }

        this.type = this.isClone ? 'mine' : 'byVoome';
      },
      $onDestroy: function $onDestroy() {
        if (location.pathname === '/nutrition/meal-plans') {
          this.stateGo('nutrition.mealPlans', { type: this.type });
        }

        this.disconnect();
      },
      mapState: function mapState(_ref) {
        var mealPlan = _ref.mealPlan,
            member = _ref.member,
            router = _ref.router;
        var mealPlanId = router.currentParams.mealPlanId;
        var name = router.currentState.name;
        var active = mealPlan.active,
            isLoading = mealPlan.isLoading;


        return {
          active: active,
          isLoading: isLoading,
          mealPlanId: mealPlanId,
          name: name,
          isClone: (0, _mealPlan.selectMealPlanIsClone)(mealPlan, mealPlanId),
          level: (0, _member.selectMemberLevel)(member),
          mealPlan: (0, _mealPlan.selectMealPlan)(mealPlan, mealPlanId)
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          fetchMealPlan: _mealPlan.fetchMealPlan,
          fetchMealPlanActive: _mealPlan.fetchMealPlanActive,
          stateGo: _reduxUiRouter.stateGo,
          updateMealPlan: _mealPlan.updateMealPlan
        };
      }
    };
  }]
};

/***/ }),

/***/ "OSxN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BoxArrowRow = exports.BoxArrowRow = {
  bindings: {
    arrowLeft: '<',
    color: '@'
  },

  template: '\n    <div class="box-arrow-row"\n      ng-class="{ \'theme-white\': $ctrl.color === \'white\' }">\n      <span class="box-arrow" style="left: {{ $ctrl.arrowLeft }}%"></span>\n    </div>'
};

/***/ }),

/***/ "OT8N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MealPlanCard = undefined;

var _utils = __webpack_require__("0xDb");

var MealPlanCard = exports.MealPlanCard = {
  transclude: true,

  bindings: {
    byVoome: '<',
    count: '<',
    date: '<',
    image: '<',
    tags: '<',
    title: '<'
  },

  template: '\n    <div class="meal-plan-card">\n      <div class="card p-2">\n        <image-background src="$ctrl.image">\n          <div class="voome-icon" ng-show="$ctrl.byVoome"></div>\n          <div class="h-100 d-flex justify-content-center align-items-center text-center">\n            <div class="card-block p-3 w-100">\n              <h4>{{ $ctrl.title }}</h4>\n              <p class="mb-0">\n                <span>{{ $ctrl.count }} meals</span>\n                <span ng-show="$ctrl.byVoome && $ctrl.tags.diet.length > 0">\n                  | {{ $ctrl.tags.diet }}\n                </span>\n                <span ng-show="$ctrl.byVoome && $ctrl.tags.meal.length > 0">\n                  | {{ $ctrl.tags.meal }}\n                </span>\n                <span ng-hide="$ctrl.byVoome">\n                  | {{ $ctrl.date | daysElapsed }}\n                </span>\n              </p>\n            </div>\n          </div>\n        </image-background>\n      </div>\n      <div class="card-stack card-stack--1"></div>\n      <div class="card-stack card-stack--2"></div>\n      <div class="card-stack card-stack--3"></div>\n      <ng-transclude></ng-transclude>\n    </div>'
};

/***/ }),

/***/ "Ok8I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ScrollTopOnChange = exports.ScrollTopOnChange = ["$anchorScroll", function ScrollTopOnChange($anchorScroll) {
  'ngInject';

  return {
    restrict: 'A',

    scope: {
      scrollTopOnChange: '='
    },

    link: function link($scope) {
      $scope.$watch('scrollTopOnChange', function (newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          $anchorScroll();
        }
      });
    }
  };
}];

/***/ }),

/***/ "Opf4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ProfileBilling = exports.ProfileBilling = {
  bindings: {
    isLoading: '<',
    subscription: '<',
    subscriptions: '<',
    onClickCancel: '&',
    onClickDowngrade: '&',
    onClickResume: '&'
  },

  template: '\n    <div class="row profile-billing">\n      <div class="col-md-4">\n        <h5>Billing History</h5>\n        <p>A record of any Coaching Zone purchases you\'ve made.</p>\n      </div>\n      <div class="col-md-8" ng-if="$ctrl.subscriptions">\n        <form-group-row>\n          <form-group-left>\n            Your Products\n          </form-group-left>\n          <form-group-right>\n            <select class="form-control"\n              ng-model="$ctrl.subscription"\n              ng-value="$ctrl.subscription.id"\n              ng-options="item as item.title for item in $ctrl.subscriptions track by item.id">\n              <option value="">-- Select Product --</option>\n            </select>\n          </form-group-right>\n        </form-group-row>\n        <div class="pt-2">\n          <form-group-row ng-if="$ctrl.subscription.isWeekly">\n            <form-group-right>\n              <p ng-show="$ctrl.subscription.status === \'active\'">\n                Next Billing Date -\n                <strong>{{ $ctrl.subscription.nextBillingDate | date: \'dd/MM/yyyy\' }}</strong>\n              </p>\n              <p ng-show="$ctrl.subscription.status === \'delayed_cancelled\'">\n                You have cancelled your subcription to {{ $ctrl.subscription.title }}\n                and will no longer be able to access {{ $ctrl.subscription.title }}\n                after {{ $ctrl.subscription.nextBillingDate | date:\'dd/MM/yyyy\' }}.\n                You can still login and reactivate your subscription at any time.\n                <span class="d-block pt-3">\n                  <button-link ng-click="$ctrl.onClickResume({ subscriptionId: $ctrl.subscription.id })">\n                    <spinner is-loading="$ctrl.isLoading">\n                      Resume Subscription\n                    <spinner>\n                  </button-link>\n                </span>\n              </p>\n              <p ng-show="$ctrl.subscription.status === \'past_due\'" class="text-danger">\n                <a ui-sref="profileCreditCard({ action: \'update\' })">\n                  Update Credit Card\n                </a><br />\n                We\'ve had a problem processing your payment. Please click the link above to update your credit card details or contact\n                <a href="mailto:support@voome.com.au">support@voome.com.au</a>\n              </p>\n              <p ng-show="$ctrl.subscription.status === \'active\' && $ctrl.subscription.chargifySubscriptionId">\n                <a ui-sref="profileCreditCard({ action: \'update\' })">\n                  Update Credit Card\n                </a>\n                <span ng-show="$ctrl.subscription.voomeProductType === \'bundle\'">\n                  <br>\n                  <button-link ng-click="$ctrl.onClickDowngrade({ subscription: $ctrl.subscription })">\n                    Modify Subscription\n                  </button-link>\n                </span>\n                <br>\n                <button-link ng-click="$ctrl.onClickCancel({ subscription: $ctrl.subscription })">\n                  Cancel Subscription\n                </button-link>\n              </p>\n            </form-group-right>\n          </form-group-row>\n          <h6 class="ml-md-2 mb-3 text-dark">Invoices</h6>\n          <div class="d-none d-md-block">\n            <table class="table">\n              <tr>\n                <th>Date</th>\n                <th>Description</th>\n                <th>Status</th>\n                <th>Amount</th>\n              </tr>\n              <tr\n                ng-show="$ctrl.subscription.invoices.length > 0"\n                ng-repeat="invoice in $ctrl.subscription.invoices track by $index">\n                <td>{{ invoice.createdAt | date:\'dd/MM/yyyy\' }}</td>\n                <td>{{ invoice.memo }}</td>\n                <td>{{ invoice.paymentStatus }}</td>\n                <td>{{ invoice.amountInCents / 100 | currency }}</td>\n              </tr>\n              <tr ng-hide="$ctrl.subscription.invoices.length > 0">\n                <td colspan="4">No Invoices available.</td>\n              </tr>\n            </table>\n          </div>\n          <div class="d-md-none">\n            <table class="table">\n              <tr\n                ng-show="$ctrl.subscription.invoices.length > 0"\n                ng-repeat="invoice in $ctrl.subscription.invoices track by $index">\n                <td class="pl-0">\n                  <strong>Date:</strong> {{ invoice.createdAt | date:\'dd/MM/yyyy\' }}<br>\n                  <strong>Description:</strong> {{ invoice.memo }}<br>\n                  <strong>Status:</strong> {{ invoice.paymentStatus }}<br>\n                  <strong>Amount:</strong> {{ invoice.amountInCents / 100 | currency }}\n                </td>\n              </tr>\n              <tr ng-hide="$ctrl.subscription.invoices.length > 0">\n                <td colspan="4">No Invoices available.</td>\n              </tr>\n            </table>\n          </div>\n        </div>\n      </div>\n    </div>'
};

/***/ }),

/***/ "Pb7N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SpeechBubble = exports.SpeechBubble = {
  transclude: true,

  bindings: {
    isAnswer: '<'
  },

  template: '\n    <div class="speech-bubble-row">\n      <label class="speech-bubble"\n        ng-class="{\n          \'question\': !$ctrl.isAnswer,\n          \'answer theme-mid text-cz\': $ctrl.isAnswer\n        }"\n        ng-transclude>\n      </label>\n    </div>'
};

/***/ }),

/***/ "Pnbr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SearchFilterResults = exports.SearchFilterResults = {
  bindings: {
    filters: '<',
    query: '<',
    onUpdateFilter: '&',
    onUpdateParam: '&',
    onClearAll: '&'
  },

  template: '\n    <div class="search-filter-results pt-3"\n      ng-show="$ctrl.filters.length || $ctrl.query.length">\n      <search-filter-badge\n        name="\'Clear All\'"\n        type="clear"\n        ng-click="$ctrl.onClearAll()">\n      </search-filter-badge>\n      <search-filter-badge\n        ng-show="$ctrl.query.length"\n        name="$ctrl.query"\n        ng-click="$ctrl.onUpdateParam({ key: \'q\', value: undefined })">\n      </search-filter-badge>\n      <search-filter-badge\n        name="item.name"\n        ng-click="$ctrl.onClickUpdate(item)"\n        ng-repeat="item in $ctrl.filters track by $index">\n      </search-filter-badge>\n    </div>',

  controller: function controller() {
    'ngInject';

    return {
      onClickUpdate: function onClickUpdate(item) {
        var key = item.type === 'Serves' ? 'serves' : 'filters';
        this.onUpdateFilter({ item: item, type: item.type, key: key });
      }
    };
  }
};

/***/ }),

/***/ "Q0Ca":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Filters = undefined;

var _utils = __webpack_require__("0xDb");

var _capitalize = __webpack_require__("T1tQ");

var _convertWeight = __webpack_require__("Bw88");

var _daysElapsed = __webpack_require__("yY4h");

var _humanize = __webpack_require__("cmZC");

var _kebabCase = __webpack_require__("vlms");

var _padStart = __webpack_require__("z6qu");

var _snakeCase = __webpack_require__("fQFf");

var _toMinutes = __webpack_require__("2FJL");

var Filters = exports.Filters = angular.module('App.filters', []).filter('assetSrc', function () {
  return _utils.assetSrc;
}).filter('capitalize', _capitalize.capitalize).filter('convertWeight', _convertWeight.convertWeight).filter('daysElapsed', _daysElapsed.daysElapsed).filter('humanize', _humanize.humanize).filter('kebabCase', _kebabCase.kebabCase).filter('padStart', _padStart.padStart).filter('snakeCase', _snakeCase.snakeCase).filter('toMinutes', _toMinutes.toMinutes).name;

/***/ }),

/***/ "Q73F":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoPlayerResumable = undefined;

var _throttle2 = __webpack_require__("+X65");

var _throttle3 = _interopRequireDefault(_throttle2);

var _utils = __webpack_require__("0xDb");

var _videoResume = __webpack_require__("jkIW");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VideoPlayerResumable = exports.VideoPlayerResumable = {
  bindings: {
    autoplay: '<',
    totalTime: '<',
    videoId: '<',
    onLoad: '&',
    onComplete: '&'
  },

  template: '\n    <div class="video-player-resumable">\n      <div ng-show="$ctrl.showResume">\n        <a class="btn btn-resume text-white" ng-click="$ctrl.resumeVideo()">\n          <i class="fa fa-play mr-1"></i> Resume video?\n        </a>\n      </div>\n      <video-player\n        video-id="$ctrl.videoId"\n        on-load="$ctrl.onLoadPlayer(player)">\n      </video-player>\n    </div>',

  controller: ["$ngRedux", "$timeout", function controller($ngRedux, $timeout) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState.bind(this), this.mapDispatch());

        this.unsubscribe = connect(this);
        this.fetchVideo();
      },
      $onChanges: function $onChanges(changes) {
        if (changes.videoId && changes.videoId.currentValue && this.fetchVideo) {
          this.fetchVideo();
        }
      },
      $onDestroy: function $onDestroy() {
        if (this.player) {
          this.player.off('ended');
          this.player.off('play');
          this.player.off('timeupdate');
        }

        this.isActive = false;
        this.unsubscribe();
      },
      mapDispatch: function mapDispatch() {
        return {
          destroyVideo: _videoResume.destroyVideo,
          fetchVideo: _videoResume.fetchVideo,
          updateVideo: _videoResume.updateVideo
        };
      },
      mapState: function mapState(state) {
        return {
          currentTime: (0, _videoResume.selectVideo)(state.videoResume, this.videoId)
        };
      },
      onLoadPlayer: function onLoadPlayer(player) {
        var _this = this;

        $timeout(function () {
          _this.player = player;
          _this.showResume = _this.currentTime > 0;
          _this.isActive = true;

          _this.player.on('play', function () {
            return _this.onPlay();
          });
          _this.player.on('ended', function () {
            return _this.onEnded();
          });
          _this.player.on('timeupdate', (0, _throttle3.default)(function () {
            return _this.onTimeupdate();
          }, 1000));

          _this.onLoad({ player: player });
        });
      },
      onPlay: function onPlay() {
        this.showResume = false;
      },
      onTimeupdate: function onTimeupdate() {
        if (this.isActive && this.player.remainingTime()) {
          this.updateVideo(this.videoId, Math.floor(this.player.currentTime()));
        }
      },
      onEnded: function onEnded() {
        this.destroyVideo(this.videoId);
      },
      resumeVideo: function resumeVideo() {
        var _this2 = this;

        // https://github.com/videojs/video.js/issues/4696
        var hackySafariFix = function hackySafariFix() {
          _this2.player.off('canplay');
          _this2.player.currentTime(_this2.currentTime);
        };

        this.player.on('canplay', function () {
          return hackySafariFix();
        });
        this.player.currentTime(this.currentTime);
        this.player.play();
      }
    };
  }]
};

/***/ }),

/***/ "Q90x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Carousel = undefined;

var _each2 = __webpack_require__("9uKM");

var _each3 = _interopRequireDefault(_each2);

var _size2 = __webpack_require__("4Fgk");

var _size3 = _interopRequireDefault(_size2);

var _get2 = __webpack_require__("Q7hp");

var _get3 = _interopRequireDefault(_get2);

var _debounce2 = __webpack_require__("O4Lo");

var _debounce3 = _interopRequireDefault(_debounce2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Move to containers
var Carousel = exports.Carousel = {
  transclude: true,

  bindings: {
    list: '<',
    settings: '<',
    isLoading: '<'
  },

  template: '\n    <div class="carousel-vm">\n      <h4 class="carousel-loading py-3" ng-show="$ctrl.isLoading">\n        <spinner is-loading="true">\n          Loading\n        </spinner>\n      </h4>\n      <div class="carousel-container" ng-hide="$ctrl.isLoading">\n        <div class="carousel-track-wrapper">\n          <div class="carousel-track" ng-transclude></div>\n        </div>\n        <div class="carousel-controls"\n          ng-show="$ctrl.listSize > $ctrl.slidesShowing">\n          <button class="carousel-prev"\n            type="button"\n            ng-click="$ctrl.prev()">\n            <i class="fa fa-chevron-left"></i>\n          </button>\n          <button class="carousel-next"\n            type="button"\n            ng-click="$ctrl.next()">\n            <i class="fa fa-chevron-right"></i>\n          </button>\n        </div>\n      </div>\n    </div>',

  controller: ["$element", "$timeout", "$window", function controller($element, $timeout, $window) {
    'ngInject';

    // Private methods

    var track = function track() {
      return $element.find('.carousel-track');
    };

    var trackWrapper = function trackWrapper() {
      return $element.find('.carousel-track-wrapper');
    };

    var slides = function slides() {
      return track().children();
    };

    var selected = function selected() {
      return track().find('.selected').first();
    };

    var guid = void 0;

    return {
      $onInit: function $onInit() {
        var _this = this;

        this.position = 0;

        this.setOptions();
        this.setToShow();
        this.checkMode();
        this.setSelected();

        // Watch window resize
        guid = Math.round(Math.random() * 100000);

        var onResize = (0, _debounce3.default)(function () {
          $timeout(function () {
            return _this.resize();
          });
        }, 100);

        $($window).on('resize.carousel' + guid, onResize);
      },
      $onDestroy: function $onDestroy() {
        $($window).off('resize.carousel' + guid);
      },
      $onChanges: function $onChanges(changes) {
        var _this2 = this;

        var list = (0, _get3.default)(changes, 'list.currentValue');

        this.listSize = (0, _size3.default)(list) || 0;

        if (this.listSize) {
          $timeout(function () {
            _this2.setDimensions();
            _this2.setSelected();
          });
        }
      },
      setOptions: function setOptions() {
        var defaults = {
          slidesToShow: 5,
          responsive: [{ slidesToShow: 4, breakpoint: 1200 }, { slidesToShow: 3, breakpoint: 992 }]
        };

        this.options = _extends({}, defaults, this.settings);
      },
      setToShow: function setToShow() {
        var slidesShowing = this.options.slidesToShow;

        if (this.options.responsive) {
          (0, _each3.default)(this.options.responsive, function (data) {
            if (window.innerWidth < data.breakpoint) {
              slidesShowing = data.slidesToShow;
            }
          });
        }

        this.slidesShowing = slidesShowing;
      },
      setSelected: function setSelected() {
        if (selected().length) {
          var position = slides().index(selected().parent());

          if (position > this.listSize - this.slidesShowing) {
            position = this.listSize - this.slidesShowing;
          }

          this.setPosition(position, this.listSize);
        }
      },
      setDimensions: function setDimensions() {
        var width = 0;
        var height = 0;

        slides().each(function (i, slide) {
          width += $(slide).outerWidth();
          height = Math.max(height, $(slide).outerHeight());
        });

        width = Math.ceil(width);

        track().width(width);
        trackWrapper().height(height);
      },
      setPosition: function setPosition(position) {
        var offset = 0;

        slides().each(function (i, slide) {
          if (i >= position) {
            return;
          }

          offset += $(slide).outerWidth();
        });

        track().animate({ xcoord: offset * -1 }, {
          duration: 300,
          step: function step(now, fx) {
            $(this).css({ transform: 'translate3d(' + now + 'px, 0, 0)' });
          }
        });

        // Set scrollbar for scrolling mode
        if (this.mode === 'scroll') {
          trackWrapper().scrollLeft(offset);
        }

        this.position = position;
      },
      prev: function prev() {
        this.changeSlide(this.position - 1, this.listSize);
      },
      next: function next() {
        this.changeSlide(this.position + 1, this.listSize);
      },
      changeSlide: function changeSlide(next, size) {
        if (next > size - this.slidesShowing || next > size) {
          next = 0;
        } else if (next < 0) {
          next = size - this.slidesShowing || size - 1;
        }

        this.setPosition(next);
      },
      resize: function resize() {
        this.setDimensions();
        this.setPosition(this.position);
        this.checkMode();

        if (this.options.responsive) {
          this.setToShow();
        }
      },
      checkMode: function checkMode() {
        var mode = trackWrapper().css('overflow') === 'auto' ? 'scroll' : 'fixed';

        if (this.mode === mode) {
          return;
        }

        // Reset scroll left offset
        if (mode === 'fixed') {
          trackWrapper().scrollLeft(0);
        }

        this.mode = mode;
      }
    };
  }]
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "R1nc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NutritionHacks = undefined;

var _reduxUiRouter = __webpack_require__("Zb/7");

var _recipe = __webpack_require__("mew7");

var _member = __webpack_require__("1OIp");

var NutritionHacks = exports.NutritionHacks = {
  template: '\n    <ui-view>\n      <div class="nutrition-collections pb-3 pb-md-4">\n        <div class="container">\n          <div class="row mb-2">\n            <div class="col-md-6 pt-3 pt-md-4"\n              ng-repeat="item in $ctrl.pagination.result track by $index">\n              <card-collection\n                heading="item.title"\n                description="item.strapLine"\n                img="item.coverImageUrl.magazine"\n                ng-click="$ctrl.onClick(item.id)">\n              </card-collection>\n            </div>\n          </div>\n          <div class="row mb-2">\n            <div class="col">\n              <pagination-row\n                on-update-param="$ctrl.onUpdatePage(value)"\n                pagination="$ctrl.pagination">\n              </pagination-row>\n            </div>\n          </div>\n        </div>\n      </div>\n    </ui-view>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        if (!this.pagination.page) {
          this.fetchRecipeCollections(this.subscriptionId, this.page);
        }
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();
      },
      onClick: function onClick(hackId) {
        this.stateGo('nutrition.hacks.recipes', { hackId: hackId, page: undefined });
      },
      onUpdatePage: function onUpdatePage(page) {
        this.stateGo('nutrition.hacks', { page: page });
      },
      mapState: function mapState(_ref) {
        var member = _ref.member,
            recipe = _ref.recipe,
            router = _ref.router;

        var page = router.currentParams.page || 1;

        return {
          page: page,
          hasAccess: (0, _member.selectHasNutritionSubscription)(member),
          subscriptionId: (0, _member.selectSubscription)(member).id,
          pagination: (0, _recipe.selectRecipeCollectionsPagination)(recipe, page)
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          fetchRecipeCollections: _recipe.fetchRecipeCollections,
          stateGo: _reduxUiRouter.stateGo
        };
      }
    };
  }]
};

/***/ }),

/***/ "R26J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgramRedirect = undefined;

var _reduxUiRouter = __webpack_require__("Zb/7");

var _utils = __webpack_require__("0xDb");

var _product = __webpack_require__("5AvL");

var _member = __webpack_require__("1OIp");

// This handles redirecting to the the mealPlan and ShoppingList which requires
// a mealPlanId. It will use the default mealPlanId for the program week.
var ProgramRedirect = exports.ProgramRedirect = {
  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var _$ngRedux$getState = $ngRedux.getState(),
            member = _$ngRedux$getState.member,
            product = _$ngRedux$getState.product,
            router = _$ngRedux$getState.router;

        var weekNumber = router.currentParams.weekNumber;

        var path = router.currentState.name.replace('Redirect', '');

        var isBasicMealPlan = (0, _member.selectHasWeeklySubscription)(member);
        var isVegetarian = (0, _member.selectMemberIsVegetarian)(member);
        var clonedMealPlanIds = isBasicMealPlan ? undefined : _utils.memberStorage.get().mealPlanIds;

        var mealPlanId = (0, _product.selectMealPlanId)(product, weekNumber, isVegetarian, clonedMealPlanIds);

        $ngRedux.dispatch((0, _reduxUiRouter.stateGo)(path, { mealPlanId: mealPlanId }));
      }
    };
  }]
};

/***/ }),

/***/ "R5Cs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RQBS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rfaq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ImageBackground = exports.ImageBackground = {
  transclude: true,

  bindings: {
    src: '<'
  },

  template: '\n    <div class="image-background"\n      ng-style="{ backgroundImage: $ctrl.backgroundImage }">\n      <ng-transclude></ng-transclude>\n    </div>',

  controller: ["$http", "$filter", "$scope", function controller($http, $filter, $scope) {
    'ngInject';

    return {
      $onChanges: function $onChanges(_ref) {
        var _this = this;

        var src = _ref.src;

        var hasChecked = false;

        if (!hasChecked && src.currentValue) {
          var backgroundImage = new Image();

          hasChecked = true;

          backgroundImage.onload = function () {
            $scope.$apply(function () {
              _this.backgroundImage = 'url("' + backgroundImage.src + '")';
            });
          };

          backgroundImage.src = $filter('assetSrc')(src.currentValue);
        }
      }
    };
  }]
};

/***/ }),

/***/ "RwmI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PaginationRow = exports.PaginationRow = {
  bindings: {
    onUpdateParam: '&',
    pagination: '<'
  },

  template: '\n    <div class="pagination-row d-flex my-3"\n      ng-if="$ctrl.pagination.previousPage || $ctrl.pagination.nextPage">\n      <button class="btn btn-pill theme-btn"\n        ng-class="{ \'disabled\': !$ctrl.pagination.previousPage }"\n        ng-click="$ctrl.onUpdateParam({ key: \'page\', value: $ctrl.pagination.previousPage })">\n        Prev\n      </button>\n      <span class="text-center py-1 w-100">\n        Page {{ $ctrl.pagination.page || 1 }} of {{ $ctrl.pagination.totalPages }}\n      </span>\n      <button class="btn btn-pill theme-btn"\n        ng-class="{ \'disabled\': !$ctrl.pagination.nextPage }"\n        ng-click="$ctrl.onUpdateParam({ key: \'page\', value: $ctrl.pagination.nextPage })">\n        Next\n      </button>\n    </div>'
};

/***/ }),

/***/ "RxC4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.datesForWeek = exports.padNumber = exports.formatDateString = exports.formatVerbose = exports.formatMinutes = exports.formatDigital = exports.format = exports.digitalToSeconds = exports.yearDigits = undefined;

var _range2 = __webpack_require__("tVBY");

var _range3 = _interopRequireDefault(_range2);

var _pad2 = __webpack_require__("WgQH");

var _pad3 = _interopRequireDefault(_pad2);

var _map2 = __webpack_require__("2247");

var _map3 = _interopRequireDefault(_map2);

var _compact2 = __webpack_require__("C2y9");

var _compact3 = _interopRequireDefault(_compact2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHORT_HAND = {
  hours: 'hr',
  minutes: 'min',
  seconds: 'sec'
};

var yearDigits = exports.yearDigits = parseInt(new Date().getFullYear().toString().slice(-2), 10);

var digitalToSeconds = exports.digitalToSeconds = function digitalToSeconds(minutes) {
  var parts = minutes.split(':');
  return parseInt(parts[0]) * 60 + parseInt(parts[1]);
};

var format = exports.format = function format(data, type) {
  if (type === 'digital') {
    return formatDigital(data);
  } else if (type === 'minutes') {
    return formatMinutes(data);
  } else if (type === 'seconds') {
    return digitalToSeconds(data);
  } else {
    return formatVerbose(data);
  }
};

var formatDigital = exports.formatDigital = function formatDigital(_ref) {
  var hours = _ref.hours,
      minutes = _ref.minutes,
      seconds = _ref.seconds;

  var time = [];

  if (hours > 0) {
    time.push(hours);
    time.push((0, _pad3.default)(minutes, 2, '0'));
  } else if (minutes > 0) {
    time.push(minutes);
  } else {
    time.push('0');
  }

  time.push((0, _pad3.default)(seconds, 2, '0'));

  return time.join(':');
};

var formatMinutes = exports.formatMinutes = function formatMinutes(_ref2) {
  var hours = _ref2.hours,
      minutes = _ref2.minutes;

  var time = 0;

  if (hours > 0) {
    time += hours * 60;
  }

  if (minutes > 0) {
    time += minutes;
  }

  return time + ' mins';
};

var formatVerbose = exports.formatVerbose = function formatVerbose(data) {
  var items = (0, _map3.default)(data, function (value, type) {
    if (value > 0) {
      return value + ' ' + SHORT_HAND[type];
    }
  });

  return (0, _compact3.default)(items).join(' ');
};

var formatDateString = exports.formatDateString = function formatDateString(date) {
  var year = date.getFullYear();
  var month = padNumber(date.getMonth() + 1);
  var day = padNumber(date.getDate());
  return year + '-' + month + '-' + day;
};

var padNumber = exports.padNumber = function padNumber(n) {
  return n < 10 ? '0' + n : '' + n;
};

var datesForWeek = exports.datesForWeek = function datesForWeek() {
  var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  var today = new Date();

  return (0, _map3.default)((0, _range3.default)(0, 7), function (i) {
    var date = new Date();

    var title = void 0;
    date.setDate(today.getDate() + i);

    if (i === 0) {
      title = 'Today';
    } else if (i === 1) {
      title = 'Tomorrow';
    } else {
      title = days[date.getDay()];
    }

    return {
      title: title,
      startDate: formatDateString(date)
    };
  });
};

/***/ }),

/***/ "Rza+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProfileFieldsNutrition = undefined;

var _nutritionPrograms = __webpack_require__("chzE");

var ProfileFieldsNutrition = exports.ProfileFieldsNutrition = {
  bindings: {
    form: '<',
    member: '<',
    isEditing: '<',
    questions: '<',
    onUpdate: '&'
  },

  template: '\n    <div class="row">\n      <div class="col-md-4">\n        <h5>Nutrition</h5>\n        <p>\n          Select your Nutrition Profile. Your recipes will be tailored to\n          match your settings.\n        </p>\n      </div>\n      <div class="col-md-8">\n        <div ng-hide="$ctrl.isEditing">\n          <form-group-row>\n            <form-group-left>\n              <form-label>\n                Calorie Level\n              </form-label>\n            </form-group-left>\n            <form-group-right>\n              <div class="col-form-label pb-0">\n                {{ $ctrl.currentTitle }}\n              </div>\n            </form-group-right>\n          </form-group-row>\n          <hr>\n          <form-group-row>\n            <form-group-left>\n              <form-label>\n                Are you vegetarian?\n              </form-label>\n            </form-group-left>\n            <form-group-right>\n              <div class="col-form-label pb-0"\n                ng-switch="$ctrl.member.profile.vegetarian">\n                <span ng-switch-when="true">Yes, I\'m vegetarian</span>\n                <span ng-switch-when="false">No, I\'m not vegetarian</span>\n              </div>\n            </form-group-right>\n          </form-group-row>\n          <div ng-repeat="item in $ctrl.questions track by $index">\n            <hr>\n            <form-group-row>\n              <form-group-left>\n                <form-label>\n                  {{ item.label }}\n                </form-label>\n              </form-group-left>\n              <form-group-right>\n                <div class="col-form-label pb-0">\n                  {{ item.answer }}\n                </div>\n              </form-group-right>\n            </form-group-row>\n          </div>\n        </div>\n        <div ng-show="$ctrl.isEditing">\n          <div class="form-group">\n            <form-label for="goal">\n              What best describes you?\n            </form-label>\n            <form-radio-list\n              form="$ctrl.form"\n              name="goal"\n              value="$ctrl.currentGoal"\n              list="$ctrl.nutrition.goals"\n              list-item-key="goal"\n              list-item-title="goal"\n              list-item-class="list-inline-item col-md-6"\n              on-update="$ctrl.onClick(key, value)">\n            </form-radio-list>\n          </div>\n          <hr>\n          <div class="form-group">\n            <form-label for="level">\n              Calorie Level\n            </form-label>\n            <div ng-if="$ctrl.isEditing" nutrition-bmi="$ctrl.member.bmi"></div>\n            <form-radio-list\n              form="$ctrl.form"\n              list="$ctrl.nutrition.programs"\n              name="nutritionProgramId"\n              key="voomeProfile.nutritionProgramId"\n              value="$ctrl.member.voomeProfile.nutritionProgramId"\n              list-item-key="id"\n              list-item-title="title"\n              list-item-class="list-inline-item col-md-6"\n              is-disabled="!$ctrl.member.voomeProfile.nutritionProgramId"\n              on-update="$ctrl.onUpdate({ key: key, value: value })"\n              required="true">\n            </form-radio-list>\n          </div>\n          <p class="px-2"\n            ng-repeat="item in $ctrl.nutrition.programs track by $index"\n            ng-if="item.id == $ctrl.member.voomeProfile.nutritionProgramId">\n            {{ item.description }}\n          <p>\n          <hr>\n          <div class="form-group">\n            <form-label for="vegetarian">\n              Are you vegetarian?\n              <span class="text-gray pl-3"\n                ng-switch="$ctrl.member.profile.vegetarian"\n                ng-hide="$ctrl.isEditing">\n                <span ng-switch-when="true">Yes, I\'m vegetarian</span>\n                <span ng-switch-when="false">No, I\'m not vegetarian</span>\n              </span>\n            </form-label>\n            <span class="d-block d-sm-inline pl-sm-3">\n              <span class="mx-2">\n                <form-radio\n                  form="$ctrl.form"\n                  model="$ctrl.member.profile.vegetarian"\n                  key="profile.vegetarian"\n                  value="true"\n                  on-update="$ctrl.onUpdate({ key: key, value: value })">\n                  Yes\n                </form-radio>\n              </span>\n              <span class="mx-2">\n                <form-radio\n                  form="$ctrl.form"\n                  model="$ctrl.member.profile.vegetarian"\n                  key="profile.vegetarian"\n                  value="false"\n                  on-update="$ctrl.onUpdate({ key: key, value: value })">\n                  No\n                </form-radio>\n              </span>\n            </span>\n          </div>\n          <hr>\n          <div class="form-group"\n            ng-repeat="item in $ctrl.questions track by $index">\n            <form-label>\n              {{ item.question }}\n            </form-label>\n            <form-fieldset\n              form="$ctrl.form"\n              key="voomeProfile.preferences.{{ item.key }}"\n              list="$ctrl.member.voomeProfile.preferences[item.key]"\n              type="{{ item.type }}"\n              on-update="$ctrl.onUpdate({ key: key, value: value })">\n            </form-fieldset>\n          </div>\n        </div>\n      </div>\n    </div>',

  controller: function controller() {
    return {
      $onInit: function $onInit() {
        if (this.member) {
          var id = this.member.voomeProfile.nutritionProgramId;

          if (id) {
            this.currentTitle = (0, _nutritionPrograms.selectNutritionProgram)({ id: id }).title;
          }

          this.nutrition = (0, _nutritionPrograms.selectNutritionPrograms)(this.member.profile.gender, this.currentGoal);
        }
      },
      onClick: function onClick(key, goal) {
        var bmi = this.member.bmi;
        var gender = this.member.profile.gender;

        var current = (0, _nutritionPrograms.selectNutritionProgram)({ goal: goal, gender: gender });

        this.currentGoal = current.goal;
        this.currentTitle = current.title;
        this.currentLevel = current.level;

        this.onUpdate({
          key: 'voomeProfile.nutritionProgramId',
          value: (0, _nutritionPrograms.selectNutritionProgramIdForBmi)(current.id, bmi)
        });
      }
    };
  }
};

/***/ }),

/***/ "S101":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormResetPassword = __webpack_require__("jJK1");

Object.defineProperty(exports, 'FormResetPassword', {
  enumerable: true,
  get: function get() {
    return _FormResetPassword.FormResetPassword;
  }
});

/***/ }),

/***/ "SPxS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decorateMember = __webpack_require__("kBHq");

Object.defineProperty(exports, 'decorateMember', {
  enumerable: true,
  get: function get() {
    return _decorateMember.decorateMember;
  }
});

var _decorateProduct = __webpack_require__("0Yy9");

Object.defineProperty(exports, 'decorateProduct', {
  enumerable: true,
  get: function get() {
    return _decorateProduct.decorateProduct;
  }
});

var _decorateRecipes = __webpack_require__("se24");

Object.defineProperty(exports, 'decorateRecipe', {
  enumerable: true,
  get: function get() {
    return _decorateRecipes.decorateRecipe;
  }
});
Object.defineProperty(exports, 'decorateRecipes', {
  enumerable: true,
  get: function get() {
    return _decorateRecipes.decorateRecipes;
  }
});

var _decorateWorkout = __webpack_require__("0Dnv");

Object.defineProperty(exports, 'decorateWorkout', {
  enumerable: true,
  get: function get() {
    return _decorateWorkout.decorateWorkout;
  }
});
Object.defineProperty(exports, 'decorateWorkoutSteps', {
  enumerable: true,
  get: function get() {
    return _decorateWorkout.decorateWorkoutSteps;
  }
});

/***/ }),

/***/ "Sfd5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SkQs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DividerHr = exports.DividerHr = {
  transclude: true,

  template: "\n    <div class=\"divider-hr\">\n      <span class=\"d-inline-block bg-white px-3\" ng-transclude></span>\n      <hr class=\"divider\">\n    </div>"
};

/***/ }),

/***/ "T1tQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalize = undefined;

var _capitalize3 = __webpack_require__("lGpV");

var _capitalize4 = _interopRequireDefault(_capitalize3);

var _memoize2 = __webpack_require__("zGZ6");

var _memoize3 = _interopRequireDefault(_memoize2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var capitalize = exports.capitalize = function capitalize() {
  return (0, _memoize3.default)(_capitalize4.default);
};

/***/ }),

/***/ "T7JS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.proxyCookie = undefined;

var _settings = __webpack_require__("Ll2K");

var _memberStorage = __webpack_require__("xopG");

var proxyCookie = exports.proxyCookie = ["$location", function proxyCookie($location) {
  'ngInject';

  var _memberStorage$get = _memberStorage.memberStorage.get(),
      hasSetCookie = _memberStorage$get.hasSetCookie;

  var isRootUrl = $location.$$url === '/';

  if (hasSetCookie && !isRootUrl) {
    return;
  } else {
    if ($location.search().cookie_set) {
      _memberStorage.memberStorage.setKey('hasSetCookie', true);
      $location.search('cookie_set', null);
    } else {
      var uri = _settings.hosts.api + '/proxy.html';
      var referrer = encodeURIComponent(window.location.href);
      window.location.assign(uri + '?set_cookie=true&referrer=' + referrer);
    }
  }
}];

/***/ }),

/***/ "TdT7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var IngredientsChecklist = exports.IngredientsChecklist = {
  bindings: {
    ingredients: '<',
    checked: '<',
    onToggle: '&'
  },

  template: '\n    <div class="ingredients-list px-3 text-left">\n      <div class="row">\n        <div class="col-md-6">\n          <ul class="fa-ul">\n            <li\n              ng-repeat="ingredient in $ctrl.ingredients track by $index"\n              ng-click="$ctrl.onToggle({ item: ingredient })"\n              ng-if="$index < ($ctrl.ingredients.length / 2)">\n              <ingredients-check\n                ingredient="ingredient"\n                checked="$ctrl.checked[ingredient.foodId]">\n              </ingredients-check>\n            </li>\n          </ul>\n        </div>\n        <div class="col-md-6">\n          <ul class="fa-ul">\n            <li\n              ng-repeat="ingredient in $ctrl.ingredients track by $index"\n              ng-click="$ctrl.onToggle({ item: ingredient })"\n              ng-if="$index >= ($ctrl.ingredients.length / 2)">\n              <ingredients-check\n                ingredient="ingredient"\n                checked="$ctrl.checked[ingredient.foodId]">\n              </ingredients-check>\n            </li>\n          </ul>\n        </div>\n      </div>\n    </div>'
};

/***/ }),

/***/ "TjzY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WelcomeSteps = undefined;

var _reduxUiRouter = __webpack_require__("Zb/7");

var _auth = __webpack_require__("wnLK");

var _theme = __webpack_require__("ZID5");

var _signup = __webpack_require__("FQ9i");

var _member = __webpack_require__("1OIp");

var WelcomeSteps = exports.WelcomeSteps = {
  template: '\n    <div class="h-100" ng-hide="$ctrl.auth.token">\n      <main class="main-content theme-mid"\n        scroll-top-on-change="$ctrl.step">\n        <div class="container">\n          <div class="row"\n            ng-switch="$ctrl.step">\n            <div class="col-12 mx-auto">\n              <welcome-step-password\n                ng-switch-when="0"\n                member="$ctrl.member"\n                is-loading="$ctrl.isLoading"\n                on-submit="$ctrl.onSubmit(data)">\n              </welcome-step-password>\n              <welcome-step-profile\n                ng-switch-when="1"\n                member="$ctrl.member"\n                is-loading="$ctrl.isLoading"\n                on-update="$ctrl.updateMemberField(key, value)"\n                on-upload-complete="$ctrl.fetchMember(id)"\n                on-submit="$ctrl.onSubmit(data)">\n              </welcome-step-profile>\n            </div>\n            <div class="col-12 col-lg-10 mx-auto" ng-switch-when="2">\n              <div ng-switch="$ctrl.voomeProductType">\n                <div ng-switch-when="program">\n                  <welcome-step-programs\n                    is-loading="$ctrl.isLoading"\n                    member="$ctrl.member"\n                    on-submit="$ctrl.onSubmit(data)"\n                    on-update="$ctrl.updateMemberField(key, value)"\n                    scroll-to="$ctrl.onScrollTo(id)">\n                    <welcome-step-actions\n                      on-cancel="$ctrl.onCancel()"\n                      is-loading="$ctrl.isLoading">\n                      Let\'s Start\n                    </welcome-step-actions>\n                  </welcome-step-programs>\n                </div>\n                <div ng-switch-when="weekly">\n                  <div ng-switch="$ctrl.slug">\n                    <div ng-switch-when="voome-nutrition">\n                      <welcome-step-nutrition\n                        member="$ctrl.member"\n                        is-loading="$ctrl.isLoading"\n                        is-show-modal="$ctrl.isShowModal"\n                        on-update="$ctrl.updateMemberField(key, value)"\n                        on-submit="$ctrl.onSubmit(data)"\n                        scroll-to="$ctrl.onScrollTo(id)">\n                        <welcome-step-actions\n                          on-cancel="$ctrl.onCancel()"\n                          is-loading="$ctrl.isLoading">\n                          Let\'s Start\n                        </welcome-step-actions>\n                      </welcome-step-nutrition>\n                    </div>\n                    <div ng-switch-when="voome-workouts">\n                      <welcome-step-workout\n                        member="$ctrl.member"\n                        is-loading="$ctrl.isLoading"\n                        on-update="$ctrl.updateMemberField(key, value)"\n                        on-submit="$ctrl.onSubmit(data)"\n                        scroll-to="$ctrl.onScrollTo(id)">\n                        <welcome-step-actions\n                          on-cancel="$ctrl.onCancel()"\n                          is-loading="$ctrl.isLoading">\n                          Let\'s Start\n                        </welcome-step-actions>\n                      </welcome-step-workout>\n                    </div>\n                  </div>\n                </div>\n                <div ng-switch-when="bundle">\n                  <welcome-step-bundle\n                    member="$ctrl.member"\n                    is-loading="$ctrl.isLoading"\n                    on-update="$ctrl.updateMemberField(key, value)"\n                    on-submit="$ctrl.onSubmit(data)"\n                    on-cancel="$ctrl.onCancel()"\n                    scroll-to="$ctrl.onScrollTo(id)">\n                  </welcome-step-bundle>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </main>\n    </div>',

  controller: ["$ngRedux", "$location", "$anchorScroll", "$window", function controller($ngRedux, $location, $anchorScroll, $window) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var _this = this;

        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        // Allow for the navbar when jumping to next question.
        $anchorScroll.yOffset = 65;

        $location.hash(null);
        this.setNavType('plain');

        // Redirect to landing page on step 3.
        this.unsubscribe = $ngRedux.subscribe(function () {
          if (_this.subscription && _this.step === 3) {
            _this.unsubscribe();
            _this.setNavType('main');
            _this.changeSubscription(_this.subscription);
          }
        });
      },
      $onDestroy: function $onDestroy() {
        $anchorScroll.yOffset = 0;
        this.disconnect();
        this.unsubscribe();
      },
      onScrollTo: function onScrollTo(id) {
        $location.hash(id);
        $anchorScroll();
      },
      onSubmit: function onSubmit() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var id = this.member.id;
        var _subscription = this.subscription,
            step = _subscription.step,
            isWeekly = _subscription.isWeekly,
            voomeProductId = _subscription.voomeProductId;


        switch (step) {
          case 0:
            var password = data.password;


            id && password ? this.updateMemberStep({ id: id, password: password }, 1) : this.authLogin(data);
            break;

          case 1:
            this.submitTransactionData(id, this.subscription);
            this.updateMemberStep(data, 2);
            break;

          case 2:
            this.updateMemberStep(data, 3);
            break;
        }
      },
      onCancel: function onCancel() {
        $window.location.reload();
      },
      mapState: function mapState(_ref) {
        var member = _ref.member,
            router = _ref.router,
            signup = _ref.signup;

        var subscription = (0, _member.selectSubscription)(member);
        var isUpgrade = router.currentState.name === 'welcomeUpgrade';
        var isLoading = member.isLoading;
        var step = subscription.step;

        // Adjust slug if its an upgrade.

        var slug = isUpgrade ? router.currentParams.slug : subscription.slug;

        // Adjust voomeProductType if its an upgrade.
        var voomeProductType = isUpgrade ? 'weekly' : subscription.voomeProductType;

        return {
          slug: slug,
          step: step,
          subscription: subscription,
          voomeProductType: voomeProductType,
          isLoading: isLoading,
          isShowModal: (0, _member.selectHasProgramSubscription)(member),
          member: (0, _member.selectMember)(member)
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          authLogin: _auth.authLogin,
          changeSubscription: _member.changeSubscription,
          fetchMember: _member.fetchMember,
          setNavType: _theme.setNavType,
          submitTransactionData: _signup.submitTransactionData,
          stateGo: _reduxUiRouter.stateGo,
          updateMember: _member.updateMember,
          updateMemberField: _member.updateMemberField,
          updateMemberStep: _member.updateMemberStep
        };
      }
    };
  }]
};

/***/ }),

/***/ "Toxe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nextWorkoutStep = exports.previousWorkoutStep = exports.updateWorkoutStep = exports.fetchWorkoutVideos = exports.fetchWorkoutVideoCurrent = exports.fetchWorkoutVideo = exports.fetchWorkoutInspiration = exports.fetchWorkoutCollection = exports.fetchWorkoutCollections = exports.fetchWorkout = exports.workoutPrintUri = exports.selectNextStep = exports.selectPreviousStep = exports.selectCurrentStep = exports.selectWorkoutSteps = exports.selectExercises = exports.selectWorkoutVideo = exports.selectWorkoutVideos = exports.selectWorkoutInspiration = exports.selectWorkoutCollection = exports.selectWorkoutCollectionsPagination = exports.selectWorkoutCollections = exports.selectWorkoutsByIds = exports.selectWorkout = exports.selectWorkouts = exports.workoutLogic = exports.normalizeWorkout = exports.initialState = undefined;

var _toNumber2 = __webpack_require__("kxzG");

var _toNumber3 = _interopRequireDefault(_toNumber2);

var _map2 = __webpack_require__("2247");

var _map3 = _interopRequireDefault(_map2);

var _get2 = __webpack_require__("Q7hp");

var _get3 = _interopRequireDefault(_get2);

var _findIndex2 = __webpack_require__("KgVm");

var _findIndex3 = _interopRequireDefault(_findIndex2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;

var _reduxLogic = __webpack_require__("E0Bt");

var _normalizr = __webpack_require__("vNPR");

var _settings = __webpack_require__("Ll2K");

var _decorators = __webpack_require__("SPxS");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Action Types
var CANCEL = '@@app/workout/CANCEL';
var UPDATE_STEP = '@@app/workoutPlayer/UPDATE_STEP';

var FETCH = '@@app/workout/FETCH';
var FETCH_SUCCESS = '@@app/workout/FETCH_SUCCESS';
var FETCH_ERROR = '@@app/workout/FETCH_ERROR';

var FETCH_COLLECTION = '@@app/workout/FETCH_COLLECTION';
var FETCH_COLLECTION_SUCCESS = '@@app/workout/FETCH_COLLECTION_SUCCESS';
var FETCH_COLLECTION_ERROR = '@@app/workout/FETCH_COLLECTION_ERROR';

var FETCH_COLLECTIONS = '@@app/workout/FETCH_COLLECTIONS';
var FETCH_COLLECTIONS_SUCCESS = '@@app/workout/FETCH_COLLECTIONS_SUCCESS';
var FETCH_COLLECTIONS_ERROR = '@@app/workout/FETCH_COLLECTIONS_ERROR';

var FETCH_INSPIRATION = '@@app/workout/FETCH_INSPIRATION';
var FETCH_INSPIRATION_SUCCESS = '@@app/workout/FETCH_INSPIRATION_SUCCESS';
var FETCH_INSPIRATION_ERROR = '@@app/workout/FETCH_INSPIRATION_ERROR';

var FETCH_VIDEOS = '@@app/workout/FETCH_VIDEOS';
var FETCH_VIDEOS_SUCCESS = '@@app/workout/FETCH_VIDEOS_SUCCESS';

var FETCH_VIDEO = '@@app/workout/FETCH_VIDEO';
var FETCH_VIDEO_CURRENT = '@@app/workout/FETCH_VIDEO_CURRENT';
var FETCH_VIDEO_SUCCESS = '@@app/workout/FETCH_VIDEO_SUCCESS';

// Initial State
var initialState = exports.initialState = {
  isLoading: false,
  result: undefined,
  currentStepIndex: 0,
  currentVideoId: null,
  entities: {
    exercises: {},
    workouts: {},
    collections: {},
    videos: {},
    inspiration: [],
    steps: []
  },
  pagination: {
    videos: {},
    collections: {}
  }
};

// Normalizr
var normalizeWorkout = exports.normalizeWorkout = function normalizeWorkout(data) {
  var exercise = new _normalizr.schema.Entity('exercises');
  var workout = new _normalizr.schema.Entity('workouts', {
    exercises: [exercise]
  });

  return (0, _normalizr.normalize)(data, workout);
};

// Observables
var fetchLogic = (0, _reduxLogic.createLogic)({
  type: FETCH,
  cancelType: CANCEL,
  processOptions: {
    successType: FETCH_SUCCESS,
    failType: FETCH_ERROR
  },
  process: function process(_ref) {
    var action = _ref.action,
        httpClient = _ref.httpClient;
    var _action$payload = action.payload,
        exercisePlanId = _action$payload.exercisePlanId,
        dayId = _action$payload.dayId,
        stepId = _action$payload.stepId;


    return httpClient.get('/v1/voome/exercise-plans/' + exercisePlanId + '/days/' + dayId).then(function (response) {
      return _extends({}, response, { stepId: stepId });
    });
  }
});

var transformFetchSuccessLogic = (0, _reduxLogic.createLogic)({
  type: FETCH_SUCCESS,
  transform: function transform(_ref2, next) {
    var action = _ref2.action;
    var _action$payload2 = action.payload,
        data = _action$payload2.data,
        stepId = _action$payload2.stepId;

    var payload = normalizeWorkout(data);
    var entities = payload.entities,
        result = payload.result;

    var workout = (0, _decorators.decorateWorkout)(entities.workouts[result]);

    // Rebuild workouts
    entities.workouts = _extends({}, entities.workouts, _defineProperty({}, result, workout));

    // Add steps for the workout player
    if (stepId !== undefined) {
      entities.steps = (0, _decorators.decorateWorkoutSteps)(workout, entities.exercises);
      var index = (0, _findIndex3.default)(entities.steps, { id: (0, _toNumber3.default)(stepId) });

      if (index > -1) {
        payload.currentStepIndex = index;
      }
    }

    next(_extends({}, action, { payload: _extends({}, payload, { entities: entities }) }));
  }
});

var fetchCollectionsLogic = (0, _reduxLogic.createLogic)({
  type: FETCH_COLLECTIONS,
  cancelType: CANCEL,
  processOptions: {
    successType: FETCH_COLLECTIONS_SUCCESS,
    failType: FETCH_COLLECTIONS_ERROR
  },
  process: function process(_ref3) {
    var action = _ref3.action,
        httpClient = _ref3.httpClient;
    var _action$payload3 = action.payload,
        subscriptionId = _action$payload3.subscriptionId,
        page = _action$payload3.page;

    var endpoint = '/v1/voome/workout-collections/all-ids';
    var params = { subscriptionId: subscriptionId, page: page };
    var collection = new _normalizr.schema.Entity('collections');

    return httpClient.get(endpoint, { params: params }).then(function (response) {
      var data = response.data,
          pagination = response.pagination;

      var _normalize = (0, _normalizr.normalize)(data, [collection]),
          entities = _normalize.entities,
          result = _normalize.result;

      return {
        entities: entities,
        pagination: _defineProperty({}, page, _extends({}, pagination, { result: result }))
      };
    });
  }
});

var fetchCollectionLogic = (0, _reduxLogic.createLogic)({
  type: FETCH_COLLECTION,
  cancelType: CANCEL,
  processOptions: {
    successType: FETCH_COLLECTION_SUCCESS,
    failType: FETCH_ERROR
  },
  process: function process(_ref4) {
    var action = _ref4.action,
        httpClient = _ref4.httpClient;
    var _action$payload4 = action.payload,
        key = _action$payload4.key,
        voomeProductId = _action$payload4.voomeProductId;

    var endpoint = '/v1/voome/workout-collections/' + key;
    var params = { voomeProductId: voomeProductId };

    var workout = new _normalizr.schema.Entity('workouts');
    var collection = new _normalizr.schema.Entity('collections', {
      workouts: [workout]
    });

    return httpClient.get(endpoint, { params: params }).then(function (response) {
      return (0, _normalizr.normalize)(response.data, collection);
    });
  }
});

var fetchInspirationLogic = (0, _reduxLogic.createLogic)({
  type: FETCH_INSPIRATION,
  cancelType: CANCEL,
  processOptions: {
    successType: FETCH_INSPIRATION_SUCCESS,
    failType: FETCH_INSPIRATION_ERROR
  },
  process: function process(_ref5) {
    var action = _ref5.action,
        httpClient = _ref5.httpClient;

    var workouts = [new _normalizr.schema.Entity('workouts')];
    var endpoint = '/v1/members/' + action.payload.memberId + '/voome-profile/fitness-inspo';

    return httpClient.get(endpoint).then(function (response) {
      return (0, _normalizr.normalize)((0, _map3.default)(response.data, _decorators.decorateWorkout), workouts);
    });
  }
});

var fetchVideosLogic = (0, _reduxLogic.createLogic)({
  type: FETCH_VIDEOS,
  cancelType: CANCEL,
  processOptions: {
    successType: FETCH_VIDEOS_SUCCESS,
    failType: FETCH_ERROR
  },
  process: function process(_ref6) {
    var action = _ref6.action,
        httpClient = _ref6.httpClient;

    var endpoint = '/v1/voome/workout-videos';
    var params = action.payload.params;

    var videoSchema = new _normalizr.schema.Entity('videos');

    var onSuccess = function onSuccess(_ref7) {
      var data = _ref7.data,
          pagination = _ref7.pagination;
      return _extends({}, (0, _normalizr.normalize)(data, [videoSchema]), {
        pagination: pagination
      });
    };

    return httpClient.get(endpoint, { params: params }).then(onSuccess);
  }
});

var fetchVideoLogic = (0, _reduxLogic.createLogic)({
  type: FETCH_VIDEO,
  cancelType: CANCEL,
  processOptions: {
    successType: FETCH_VIDEO_SUCCESS,
    failType: FETCH_ERROR
  },
  process: function process(_ref8) {
    var action = _ref8.action,
        httpClient = _ref8.httpClient;

    var endpoint = '/v1/voome/workout-videos/' + action.payload.videoId;
    return httpClient.get(endpoint);
  }
});

var fetchVideoCurrentLogic = (0, _reduxLogic.createLogic)({
  type: FETCH_VIDEO_CURRENT,
  cancelType: CANCEL,
  processOptions: {
    successType: FETCH_VIDEO_SUCCESS,
    failType: FETCH_ERROR
  },
  process: function process(_ref9) {
    var action = _ref9.action,
        httpClient = _ref9.httpClient;

    var endpoint = '/v1/voome/workout-videos/current';
    var params = { voomeProductId: action.payload.voomeProductId };
    var onSuccess = function onSuccess(response) {
      return _extends({}, response, {
        currentVideoId: response.data.id
      });
    };

    return httpClient.get(endpoint, { params: params }).then(onSuccess);
  }
});

var workoutLogic = exports.workoutLogic = [fetchCollectionsLogic, fetchCollectionLogic, fetchInspirationLogic, fetchLogic, fetchVideoLogic, fetchVideoCurrentLogic, fetchVideosLogic, transformFetchSuccessLogic];

// Selectors
var selectWorkouts = exports.selectWorkouts = function selectWorkouts(state) {
  return state.entities.workouts || {};
};

var selectWorkout = exports.selectWorkout = function selectWorkout(state, id) {
  return selectWorkouts(state)[id || state.result];
};

var selectWorkoutsByIds = exports.selectWorkoutsByIds = function selectWorkoutsByIds(state, ids) {
  return (0, _map3.default)(ids, function (id) {
    return selectWorkout(state, id);
  });
};

var selectWorkoutCollections = exports.selectWorkoutCollections = function selectWorkoutCollections(state) {
  return state.entities.collections;
};

var selectWorkoutCollectionsPagination = exports.selectWorkoutCollectionsPagination = function selectWorkoutCollectionsPagination(state, page) {
  var pagination = state.pagination.collections[page];

  return pagination ? _extends({}, pagination, {
    result: pagination.result.map(function (id) {
      return state.entities.collections[id];
    })
  }) : {};
};

var selectWorkoutCollection = exports.selectWorkoutCollection = function selectWorkoutCollection(state, hackId) {
  var collection = selectWorkoutCollections(state)[hackId];

  return collection ? _extends({}, collection, {
    workouts: selectWorkoutsByIds(state, collection.workouts)
  }) : undefined;
};

var selectWorkoutInspiration = exports.selectWorkoutInspiration = function selectWorkoutInspiration(state) {
  return selectWorkoutsByIds(state, state.entities.inspiration);
};

var selectWorkoutVideos = exports.selectWorkoutVideos = function selectWorkoutVideos(state) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var pagination = state.pagination.videos[page];

  return pagination ? _extends({}, pagination, {
    result: (0, _map3.default)(pagination.result, function (id) {
      return state.entities.videos[id];
    })
  }) : {};
};

var selectWorkoutVideo = exports.selectWorkoutVideo = function selectWorkoutVideo(state, videoId) {
  return state.entities.videos[videoId];
};

var selectExercises = exports.selectExercises = function selectExercises(state) {
  return state.entities.exercises;
};

var selectWorkoutSteps = exports.selectWorkoutSteps = function selectWorkoutSteps(state) {
  return state.entities.steps;
};

var selectCurrentStep = exports.selectCurrentStep = function selectCurrentStep(state) {
  return (0, _get3.default)(selectWorkoutSteps(state), state.currentStepIndex);
};

var selectPreviousStep = exports.selectPreviousStep = function selectPreviousStep(state) {
  return (0, _get3.default)(selectWorkoutSteps(state), state.currentStepIndex - 1);
};

var selectNextStep = exports.selectNextStep = function selectNextStep(state) {
  return (0, _get3.default)(selectWorkoutSteps(state), state.currentStepIndex + 1);
};

// Helpers
var workoutPrintUri = exports.workoutPrintUri = function workoutPrintUri(dayId, exercisePlanId, subscriptionId) {
  if (dayId && exercisePlanId && subscriptionId) {
    return [_settings.hosts.api, 'v1/voome/exercise-plans/' + exercisePlanId, 'days/' + dayId, 'print?subscription_id=' + subscriptionId + '&thumbnails=true'].join('/');
  }
};

// Action Creators
var fetchWorkout = exports.fetchWorkout = function fetchWorkout(exercisePlanId, dayId, stepId, currentStepIndex) {
  return {
    type: FETCH,
    payload: { exercisePlanId: exercisePlanId, dayId: dayId, stepId: stepId, currentStepIndex: currentStepIndex }
  };
};

var fetchWorkoutCollections = exports.fetchWorkoutCollections = function fetchWorkoutCollections(subscriptionId, page) {
  return { type: FETCH_COLLECTIONS, payload: { subscriptionId: subscriptionId, page: page } };
};

var fetchWorkoutCollection = exports.fetchWorkoutCollection = function fetchWorkoutCollection(key, voomeProductId) {
  return { type: FETCH_COLLECTION, payload: { key: key, voomeProductId: voomeProductId } };
};

var fetchWorkoutInspiration = exports.fetchWorkoutInspiration = function fetchWorkoutInspiration(memberId) {
  return { type: FETCH_INSPIRATION, payload: { memberId: memberId } };
};

var fetchWorkoutVideo = exports.fetchWorkoutVideo = function fetchWorkoutVideo(videoId) {
  return { type: FETCH_VIDEO, payload: { videoId: videoId } };
};

var fetchWorkoutVideoCurrent = exports.fetchWorkoutVideoCurrent = function fetchWorkoutVideoCurrent(voomeProductId) {
  return { type: FETCH_VIDEO_CURRENT, payload: { voomeProductId: voomeProductId } };
};

var fetchWorkoutVideos = exports.fetchWorkoutVideos = function fetchWorkoutVideos(params) {
  var _params$order = params.order,
      order = _params$order === undefined ? 'our_picks' : _params$order,
      _params$page = params.page,
      page = _params$page === undefined ? 1 : _params$page,
      type = params.type,
      equipmentRequired = params.equipmentRequired,
      time = params.time;


  return {
    type: FETCH_VIDEOS,
    payload: {
      params: {
        order: order,
        page: page,
        type: type,
        equipmentRequired: equipmentRequired,
        time: time
      }
    }
  };
};

var updateWorkoutStep = exports.updateWorkoutStep = function updateWorkoutStep(index) {
  return { type: UPDATE_STEP, payload: { index: index } };
};

var previousWorkoutStep = exports.previousWorkoutStep = function previousWorkoutStep(index) {
  return updateWorkoutStep(index - 1);
};

var nextWorkoutStep = exports.nextWorkoutStep = function nextWorkoutStep(index) {
  return updateWorkoutStep(index + 1);
};

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case FETCH:
    case FETCH_COLLECTIONS:
    case FETCH_COLLECTION:
    case FETCH_INSPIRATION:
    case FETCH_VIDEOS:
    case FETCH_VIDEO:
      return _extends({}, state, {
        isLoading: true
      });

    case FETCH_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        result: payload.result,
        currentStepIndex: payload.currentStepIndex || 0,
        entities: _extends({}, state.entities, {
          steps: payload.entities.steps,
          exercises: _extends({}, state.entities.exercises, payload.entities.exercises),
          workouts: _extends({}, state.entities.workouts, payload.entities.workouts)
        })
      });

    case FETCH_COLLECTIONS_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        pagination: _extends({}, state.pagination, {
          collections: _extends({}, state.pagination.collections, payload.pagination)
        }),
        entities: _extends({}, state.entities, {
          collections: _extends({}, state.entities.collections, payload.entities.collections)
        })
      });

    case FETCH_COLLECTION_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        result: payload.result,
        entities: _extends({}, state.entities, {
          collections: _extends({}, state.entities.collections, payload.entities.collections),
          workouts: _extends({}, state.entities.workouts, payload.entities.workouts)
        })
      });

    case FETCH_INSPIRATION_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        entities: _extends({}, state.entities, {
          inspiration: payload.result,
          workouts: _extends({}, state.entities.workouts, payload.entities.workouts)
        })
      });

    case FETCH_VIDEOS_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        entities: _extends({}, state.entities, {
          videos: _extends({}, payload.entities.videos, state.entities.videos)
        }),
        pagination: _extends({}, state.pagination, {
          videos: _extends({}, state.pagination.video, _defineProperty({}, payload.pagination.page, _extends({}, payload.pagination, {
            result: payload.result
          })))
        })
      });

    case FETCH_VIDEO_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        currentVideoId: payload.currentVideoId || state.currentVideoId,
        entities: _extends({}, state.entities, {
          videos: _extends({}, state.entities.videos, _defineProperty({}, payload.data.id, payload.data))
        })
      });

    case UPDATE_STEP:
      return _extends({}, state, {
        currentStepIndex: payload.index
      });

    default:
      return state;
  }
}

/***/ }),

/***/ "UP8H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var VideoProgress = exports.VideoProgress = {
  bindings: {
    progress: '<'
  },

  template: '\n    <div class="video-progress progress">\n      <div\n        class="progress-bar bg-danger"\n        role="progressbar"\n        ng-style="{ width: $ctrl.progress + \'%\'}"\n        aria-valuenow="{{ $ctrl.progress }}"\n        aria-valuemin="0"\n        aria-valuemax="100">\n      </div>\n    </div>'
};

/***/ }),

/***/ "UT8x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WorkoutRatings = exports.WorkoutRatings = {
  bindings: {
    rating: '<'
  },

  template: '\n    <ul class="d-flex justify-content-between align-items-center px-3 mb-3 bg-gray-100 list-unstyled workout-ratings">\n      <li class="h6 mb-0 mr-4">Member Rating</li>\n      <li ng-repeat="rating in [1,2,3,4,5] track by $index">\n        <i class="fa fa-2x fa-star"\n          ng-class="{\n            \'text-teal-dark\': $ctrl.rating >= rating,\n            \'text-gray-300\': $ctrl.rating < rating\n          }">\n        </i>\n      </li>\n    </ul>'
};

/***/ }),

/***/ "UUvd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardRecipe = undefined;

var _member = __webpack_require__("1OIp");

var _favourite = __webpack_require__("GfAe");

var CardRecipe = exports.CardRecipe = {
  bindings: {
    recipe: '<',
    description: '<',
    isLeftover: '<',
    type: '@',
    onClick: '&'
  },

  template: '\n    <div class="card-recipe card-wrapper pointer"\n      ng-class="{ \'card-horizontal\': $ctrl.type === \'horizontal\' }"\n      id="{{ $ctrl.recipe.name | kebabCase }}">\n      <card\n        heading="$ctrl.recipe.name"\n        description="$ctrl.description"\n        is-favourite="$ctrl.recipe.isFavourite"\n        img="$ctrl.recipe.image.magazine || $ctrl.recipe.imageUrl.magazine"\n        on-favourite="$ctrl.onFavourite($ctrl.recipe)"\n        on-click="$ctrl.onClick()">\n          <badges>\n            <card-badge-flame tags="$ctrl.recipe.categories">\n            </card-badge-flame>\n            <card-badge\n              text="V"\n              ng-if="$ctrl.recipe.isVegetarian">\n            </card-badge>\n            <card-badge\n              text="GF"\n              ng-if="$ctrl.recipe.isGlutenFree">\n            </card-badge>\n            <card-badge\n              text="LF"\n              ng-if="$ctrl.recipe.isLactoseFree">\n            </card-badge>\n            <card-badge\n              text="DF"\n              ng-if="$ctrl.recipe.isDiabeticFriendly">\n            </card-badge>\n            <card-badge\n              text="LFO"\n              ng-if="$ctrl.recipe.isLowFodmap">\n            </card-badge>\n            <card-badge\n              text="Leftovers"\n              ng-if="$ctrl.isLeftover">\n            </card-badge>\n          </badges>\n          <footer-left>\n            <i class="icon icon-time"></i>\n            <span>{{ $ctrl.recipe.cookingTimeMins + $ctrl.recipe.prepTimeMins }} min</span>\n          </footer-left>\n          <footer-right>\n            <i class="icon icon-calories"></i>\n            <span>{{ $ctrl.recipe.caloriesPerServe }} Cal</span>\n          </footer-right>\n        </card>\n      </div>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      onFavourite: function onFavourite(recipe) {
        var member = (0, _member.selectMember)($ngRedux.getState().member);

        $ngRedux.dispatch((0, _favourite.toggleFavouriteRecipe)({
          memberId: member.id,
          recipeId: recipe.id,
          isFavourite: recipe.isFavourite
        }));
      }
    };
  }]
};

/***/ }),

/***/ "UmzV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SignupPrice = exports.SignupPrice = {
  transclude: true,

  bindings: {
    priceInCents: '<value'
  },

  template: '\n    <div class="signup-price">\n      <span class="dollars"><span>$</span>{{ $ctrl.dollars }}</span>.{{ $ctrl.cents }}<ng-transclude></ng-transclude>\n    </div>',

  controller: function controller() {
    'ngInject';

    return {
      $onChanges: function $onChanges(_ref) {
        var priceInCents = _ref.priceInCents;

        if (priceInCents.currentValue) {
          var parts = (priceInCents.currentValue / 100).toString().split('.');
          this.dollars = parts[0];
          this.cents = parts[1];
        }
      }
    };
  }
};

/***/ }),

/***/ "Uw4W":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var NavFullscreen = exports.NavFullscreen = {
  transclude: true,

  bindings: {
    title: '<',
    onClick: '&'
  },

  template: '\n    <nav class="navbar navbar-dark theme-dark navbar--main">\n      <div class="container px-0 px-md-3 justify-content-between align-items-center">\n        <div class="navbar-brand--icon d-none d-md-block">\n        </div>\n        <h4 class="m-0 text-white">\n          {{ $ctrl.title }}\n        </h4>\n        <button class="btn btn-sm btn-pill bg-cz-theme-tertiary text-white"\n          ng-click="$ctrl.onClick()">\n          Done\n        </button>\n      </div>\n    </nav>'
};

/***/ }),

/***/ "UwM0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalUpgrade = undefined;

var _settings = __webpack_require__("Ll2K");

var ModalUpgrade = exports.ModalUpgrade = {
  bindings: {
    errorMessage: '<',
    text: '<',
    isBundleUpgrade: '<',
    isLoading: '<',
    onSubmit: '&'
  },

  template: '\n    <div class="modal modal-upgrade"\n      data-show="true"\n      data-keyboard="false"\n      data-backdrop="false"\n      tabindex="-1"\n      role="dialog"\n      aria-hidden="true">\n      <div class="modal-dialog modal-dialog-centered" role="document">\n        <div class="modal-content px-4 py-3">\n          <div class="modal-body" ng-hide="showConfirmation">\n            <header class="font-size-large text-teal-dark text-center">\n              Enhance your Coaching Zone by adding<br>\n              <strong>{{ $ctrl.text.title }}</strong> for only\n              <strong>{{ $ctrl.isBundleUpgrade ? \'$3\' : \'$6.99\' }} per week</strong>\n              {{showConfirmation}}\n            </header>\n            <div class="py-3">\n              <video-player video-id="$ctrl.text.videoId"></video-player>\n            </div>\n            <p ng-repeat="item in $ctrl.text.items track by $index">\n              <strong class="text-green-dark">\n                {{ item.title }}\n              </strong>\n              <br>\n              {{ item.description }}\n            </p>\n            <div class="text-center">\n              <button class="btn btn-pill bg-green text-teal-dark mb-3"\n                type="button"\n                ng-click="showConfirmation = true"\n                ng-show="$ctrl.isBundleUpgrade">\n                <strong>Upgrade Now</strong>\n              </button>\n              <button class="btn btn-pill bg-green text-teal-dark mb-3"\n                type="button"\n                ng-click="$ctrl.onUpgradeRedirect()"\n                ng-hide="$ctrl.isBundleUpgrade">\n                <strong>Upgrade Now</strong>\n              </button>\n              <p class="text-teal-dark">\n                <strong>\n                  For only {{ $ctrl.isBundleUpgrade ? \'$3\' : \'$6.99\' }} per week. Change or cancel anytime.</strong>\n              </p>\n              <a href="#" ng-click="$ctrl.onClickBack()">\n                No Thanks.\n              </a>\n            </div>\n          </div>\n          <div class="modal-body" ng-show="showConfirmation">\n            <div class="d-flex flex-row justify-content-between align-items-start">\n              <div class="pt-1">\n                <signup-icon color="$ctrl.text.iconColor">\n                  <i class="fa fa-lg text-white" ng-class="$ctrl.text.icon"></i>\n                </signup-icon>\n              </div>\n              <div class="pl-3">\n                <p>\n                  <strong ng-bind="$ctrl.text.title"></strong><br>\n                  You will be charged an additional <strong>$3/week</strong>\n                  commencing from your next invoice.\n                </p>\n                <p class="m-0">\n                  <a href="#" ng-click="showConfirmation = false">\n                    No Thanks.\n                  </a>\n                  <button class="btn btn-pill bg-green text-teal-dark ml-2"\n                    type="button"\n                    title="Upgrade Now"\n                    ng-click="$ctrl.onSubmit()">\n                    <spinner is-loading="$ctrl.isLoading">\n                      <strong>\n                        <span ng-hide="$ctrl.isLoading">Upgrade</span>\n                        <span ng-show="$ctrl.isLoading">Upgrading</span>\n                      </strong>\n                    </spinner>\n                  </button>\n                </p>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>',

  controller: ["$element", "$sce", "$state", function controller($element, $sce, $state) {
    'ngInject';

    var interval = void 0;

    var setBodyOverflow = function setBodyOverflow(value) {
      document.getElementsByTagName('body')[0].style.overflow = value;
    };

    var preventClosingModal = function preventClosingModal($el) {
      $el.attr('style', 'display: block');
    };

    return {
      $onInit: function $onInit() {
        var $el = $element.find('.modal');

        // Display the modal
        $el.modal();

        // Ensure the modal can't be closed by tampering with the style attr
        interval = setInterval(function () {
          return preventClosingModal($el);
        }, 500);

        // Fix scrolling issues with the modal
        setBodyOverflow('hidden');
      },
      $onDestroy: function $onDestroy() {
        clearInterval(interval);
        setBodyOverflow('auto');
      },
      onClickBack: function onClickBack() {
        window.history.back();
      },
      onUpgradeRedirect: function onUpgradeRedirect() {
        // Redirect to reset theme on signup page
        window.location.assign($state.href('signupWeekly', {
          slug: 'voome-nutrition',
          coupon: 'PROGRAM-UPGRADE'
        }));
      }
    };
  }]
};

/***/ }),

/***/ "V+lE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavMain = undefined;

var _size2 = __webpack_require__("4Fgk");

var _size3 = _interopRequireDefault(_size2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavMain = exports.NavMain = {
  bindings: {
    items: '<',
    avatarSrc: '<',
    product: '<',
    subscriptions: '<',
    subscription: '<',
    onClickSubscription: '&'
  },

  template: '\n    <nav class="navbar navbar-expand-lg navbar-dark bg-white py-md-0 navbar--main">\n      <div class="container">\n        <div class="d-flex justify-content-between align-items-center w-100 w-lg-0">\n          <div class="left-content">\n            <button class="navbar-toggler bg-cz-theme mr-3 border-0 p-0"\n              ng-show="$ctrl.items.length > 1 || $ctrl.subscriptonsLength > 1"\n              type="button"\n              data-toggle="collapse"\n              data-target="#navbarCollapse"\n              aria-controls="navbarCollapse"\n              aria-expanded="false"\n              aria-label="Toggle navigation">\n              <span class="navbar-toggler-icon"></span>\n            </button>\n            <button class="navbar-brand navbar-brand--icon btn btn-link border-0 pl-0"\n              type="button"\n              ng-click="$ctrl.onClickSubscription({ subscription: $ctrl.subscription })">\n              <nav-logo></nav-logo>\n            </button>\n          </div>\n          <div class="d-lg-none">\n            <a class="btn btn-link p-0" ui-sref="profile">\n              <image-circle src="$ctrl.avatarSrc"></image-circle>\n            </a>\n          </div>\n        </div>\n        <div id="navbarCollapse" class="collapse navbar-collapse">\n          <ul class="navbar-nav navbar-nav--list mr-auto align-self-end">\n            <li class="nav-item mr-3"\n              ng-repeat="item in $ctrl.items track by $index">\n              <small class="nav-upgrade text-uppercase text-green"\n                ng-if="item.upgrade">\n                Upgrade\n              </small>\n              <nav-item\n                child-path="item.childPath"\n                icon="item.icon"\n                path="item.path"\n                title="item.title">\n              </nav-item>\n            </li>\n          </ul>\n          <ul class="navbar-nav d-none d-lg-flex align-items-lg-center divider-left divider-right">\n            <li class="nav-item p-2 divider-left">\n              <a class="btn btn-link d-none d-md-block p-lg-0"\n                ui-sref="profile">\n                <image-circle src="$ctrl.avatarSrc"></image-circle>\n              </a>\n            </li>\n          </ul>\n        </div>\n      </div>\n    </nav>',

  controller: ["$ngRedux", "$state", function controller($ngRedux, $state) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var _this = this;

        // Force to add the following items to the header (Belgravia)
        this.items = [{ title: 'Home', path: 'dashboard' }, { title: 'Recipes', path: 'nutrition.recipes' }, { title: 'Meal Plans', path: 'nutrition.mealPlans' }, { title: 'Tips', path: 'nutrition.hacks' }, { title: 'Favourite Recipes', path: 'nutrition.favouritesRecipes' }];
        this.navBarCollapse = $('#navbarCollapse').on('show.bs.collapse', function () {
          return _this.subscribe();
        }).on('hide.bs.collapse', function () {
          return _this.unsubscribe();
        });
      },
      $onDestroy: function $onDestroy() {
        this.unsubscribe && this.unsubscribe();
      },


      // Need to fix selectSubscriptions to return an array but requires
      // fixes to every method that uses selectSubscriptions.
      $onChanges: function $onChanges(_ref) {
        var subscriptions = _ref.subscriptions;

        this.subscriptonsLength = (0, _size3.default)(subscriptions.currentValue);
      },
      subscribe: function subscribe() {
        var _this2 = this;

        var href = this.getRouterHref();

        this.unsubscribe = $ngRedux.subscribe(function () {
          if (href !== _this2.getRouterHref()) {
            _this2.unsubscribe();
            _this2.navBarCollapse.collapse('hide');
          }
        });
      },
      getRouterHref: function getRouterHref() {
        var _$ngRedux$getState$ro = $ngRedux.getState().router,
            currentState = _$ngRedux$getState$ro.currentState,
            currentParams = _$ngRedux$getState$ro.currentParams,
            href = _$ngRedux$getState$ro.href;


        return href(currentState.name, currentParams);
      }
    };
  }]
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "VMkk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardWorkout = undefined;

var _reduxUiRouter = __webpack_require__("Zb/7");

var _favourite = __webpack_require__("GfAe");

var _member = __webpack_require__("1OIp");

var CardWorkout = exports.CardWorkout = {
  bindings: {
    workout: '<',
    member: '<',
    description: '<',
    type: '@',
    onClick: '&'
  },

  template: '\n    <div class="card-workout card-wrapper pointer"\n      ng-class="{ \'card-horizontal\': $ctrl.type === \'horizontal\' }"\n      id="{{ $ctrl.workout.name | kebabCase }}">\n      <card\n        heading="$ctrl.workout.name"\n        description="$ctrl.description"\n        is-favourite="$ctrl.workout.isFavourite"\n        img="$ctrl.workout.imageUrl.magazine"\n        on-favourite="$ctrl.onFavourite($ctrl.member.id, $ctrl.workout)"\n        on-click="$ctrl.onClick()">\n          <badges>\n            <card-badge-flame tags="$ctrl.workout.categories">\n            </card-badge-flame>\n          </badges>\n          <footer-left>\n            <i class="icon icon-time"></i>\n            <span>{{ $ctrl.workout.totalTime.minutes }} min</span>\n          </footer-left>\n          <footer-right ng-if="$ctrl.workout.met">\n            <i class="icon icon-calories-burnt"></i>\n            <span>\n              <workout-calories-burnt\n                member="$ctrl.member"\n                met="$ctrl.workout.met"\n                total-time="$ctrl.workout.totalTime">\n              </workout-calories-burnt> Cal\n            </span>\n          </footer-right>\n        </card>\n      </div>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      onFavourite: function onFavourite(memberId, workout) {
        $ngRedux.dispatch((0, _favourite.toggleFavouriteWorkout)({
          memberId: memberId,
          workoutId: workout.id,
          isFavourite: workout.isFavourite
        }));
      }
    };
  }]
};

/***/ }),

/***/ "VMvO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DashboardNutritionInspiration = exports.DashboardNutritionInspiration = {
  bindings: {
    isLoading: '<',
    items: '<'
  },

  template: '\n    <div class="dashboard-nutrition-inspiration">\n      <dashboard-carousel>\n        <dashboard-carousel-header>\n          <h4>\n            <current-day>#FoodInspiration</current-day>\n          </h4>\n        </dashboard-carousel-header>\n        <dashboard-carousel-body>\n          <carousel list="$ctrl.items">\n            <div class="carousel-slide-wrapper"\n              ng-repeat="item in $ctrl.items track by $index">\n              <div class="carousel-slide">\n                <card-recipe\n                  recipe="item"\n                  on-click="$ctrl.onClick(item.id)">\n                </card-recipe>\n              </div>\n            </div>\n          </carousel>\n        </dashboard-carousel-body>\n        <dashboard-carousel-footer>\n          <span class="pl-2 small font-size-sm-base">\n            Based on your <a ui-sref="profile">Profile</a>\n            <span class="px-2 text-gray">|</span>\n            <a ui-sref="nutrition.recipes">All Recipes</a>\n          </span>\n        </dashboard-carousel-footer>\n      </dashboard-carousel>\n    </div>',

  controller: ["$state", function controller($state) {
    'ngInject';

    return {
      onClick: function onClick(recipeId) {
        $state.go('nutrition.recipes.detail', { recipeId: recipeId });
      }
    };
  }]
};

/***/ }),

/***/ "VPKl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormSelectDate = undefined;

var _range2 = __webpack_require__("tVBY");

var _range3 = _interopRequireDefault(_range2);

var _padStart2 = __webpack_require__("alKx");

var _padStart3 = _interopRequireDefault(_padStart2);

var _map2 = __webpack_require__("2247");

var _map3 = _interopRequireDefault(_map2);

var _get2 = __webpack_require__("Q7hp");

var _get3 = _interopRequireDefault(_get2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormSelectDate = exports.FormSelectDate = {
  bindings: {
    errors: '<',
    form: '<',
    name: '@',
    onUpdate: '&',
    required: '@',
    value: '<',
    yearStart: '<',
    yearNumber: '<'
  },

  template: '\n    <div class="d-flex justify-content-center form-select-date">\n      <select class="form-control"\n        name="day"\n        ng-model="$ctrl.day"\n        ng-options="day for day in $ctrl.days"\n        ng-change="$ctrl.onChange()">\n        <option value="">Day</option>\n      </select>\n      <select class="form-control mx-2"\n        name="month"\n        ng-model="$ctrl.month"\n        ng-options="(month | padStart:2:0) for month in $ctrl.months"\n        ng-change="$ctrl.onChange()">\n        <option value="">Month</option>\n      </select>\n      <select class="form-control"\n        name="year"\n        ng-model="$ctrl.year"\n        ng-options="year for year in $ctrl.years"\n        ng-change="$ctrl.onChange()">\n        <option value="">Year</option>\n      </select>\n    </div>\n    <input\n      type="date"\n      name="{{ $ctrl.name }}"\n      ng-hide="true"\n      ng-required="{{ $ctrl.required }}"\n      ng-model="$ctrl.date"/>\n    <form-errors field="$ctrl.form[$ctrl.name]" errors="$ctrl.errors"/>',

  controller: ["$timeout", function controller($timeout) {
    'ngInject';

    var padLeft0 = function padLeft0(value) {
      return (0, _padStart3.default)(value, 2, 0);
    };

    var getDate = function getDate(value) {
      return new Date(Date.parse(value));
    };

    return {
      $onInit: function $onInit() {
        var year = new Date().getFullYear() + (this.yearStart || 0);
        this.days = (0, _map3.default)((0, _range3.default)(1, 32), padLeft0);
        this.months = (0, _map3.default)((0, _range3.default)(1, 13), padLeft0);
        this.years = (0, _range3.default)(year, year - (this.yearNumber || 0));
      },
      $onChanges: function $onChanges(changes) {
        var value = (0, _get3.default)(changes, 'value.currentValue');

        if (value) {
          this.date = getDate(value);
          this.day = padLeft0(this.date.getDate());
          this.month = padLeft0(this.date.getMonth() + 1);
          this.year = this.date.getFullYear();
        }
      },
      onChange: function onChange() {
        var _this = this;

        var day = this.day,
            year = this.year,
            month = this.month;

        var field = this.form[this.name];

        if (!day || !year || !month) {
          field.$setTouched();
          field.$setValidity('required', !!(day || month || year));
          field.$setValidity('date', false);
        } else {
          this.date = getDate(year + '-' + month + '-' + day);

          $timeout(function () {
            if (field.$valid) {
              _this.onUpdate({ key: _this.name, value: field.$viewValue });
            }
          });
        }
      }
    };
  }]
};

/***/ }),

/***/ "Vj7r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Signup = undefined;

var _reduxUiRouter = __webpack_require__("Zb/7");

var _settings = __webpack_require__("Ll2K");

var _utils = __webpack_require__("0xDb");

var _member = __webpack_require__("1OIp");

var _signup = __webpack_require__("FQ9i");

var _constants = __webpack_require__("qI5z");

var Signup = exports.Signup = {
  template: '\n    <div class="signup">\n      <main class="main-content theme-mid pb-5">\n        <div class="container align-items-center justify-content-center pt-4 pb-5"\n          ng-switch="$ctrl.step">\n          <div ng-switch-when="3">\n            <signup-verifying>\n              Verifying Payment\n            </signup-verifying>\n          </div>\n          <div ng-switch-default>\n            <header class="text-center mb-4">\n              <h1 class="h2 text-blue-cz"\n                ng-bind="$ctrl.text.title">\n              </h1>\n            </header>\n            <section class="theme-light row">\n              <div class="col-lg-8 offset-2">\n                <div class="signup-content bg-white my-3 py-3 py-lg-5"\n                  scroll-top-on-change="$ctrl.message">\n                  <div class="px-3 px-md-5">\n                    <alert type="danger" ng-show="$ctrl.message">\n                      <span ng-bind-html="$ctrl.message"></span>\n                    </alert>\n                    <alert type="danger" ng-show="$ctrl.isDisabled">\n                      Sorry team! Due to site maintenance, sign ups cannot be\n                      accepted right now. Please try again in an hour.\n                    </alert>\n                    <alert type="info" ng-show="$ctrl.coupon === \'PROGRAM-UPGRADE\'">\n                      Thanks for choosing to upgrade, we just need to reconfirm your payment details.\n                    </alert>\n                  </div>\n                  <div ng-hide="$ctrl.isDisabled">\n                    <div class="px-3 px-md-5">\n                      <signup-form-personal\n                        is-disabled="$ctrl.step !== 1"\n                        is-loading="$ctrl.isLoading"\n                        chargify-data="$ctrl.chargifyData"\n                        product="$ctrl.product"\n                        text="$ctrl.text"\n                        member="$ctrl.member"\n                        on-update="$ctrl.updateChargifyData(key, value)"\n                        on-submit="$ctrl.setup({\n                          voomeProductId: $ctrl.product.id,\n                          chargifyData: $ctrl.chargifyData,\n                          coupon: $ctrl.coupon,\n                          utmParams: $ctrl.utmParams,\n                          campaignChannelMedium: $ctrl.campaignChannelMedium,\n                        })">\n                      </signup-form-personal>\n                      <signup-form-billing\n                        is-disabled="$ctrl.step !== 2"\n                        is-loading="$ctrl.isLoading"\n                        chargify-data="$ctrl.chargifyData"\n                        chargify-fields="$ctrl.chargifyFields"\n                        product="$ctrl.product"\n                        text="$ctrl.text"\n                        title="2. Billing Details"\n                        on-cancel="$ctrl.onCancel()"\n                        on-update="$ctrl.updateChargifyData(key, value)">\n                      </signup-form-billing>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </section>\n          </div>\n        </div>\n      </main>\n    </div>',

  controller: ["$ngRedux", "$window", function controller($ngRedux, $window) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var _this = this;

        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        // Set the fields to submit
        this.chargifyFields = _constants.SIGNUP_FIELDS;

        // Set the redirect
        this.updateChargifyData('redirectUri', _constants.SIGNUP_REDIRECT_URI);

        // Handle types/components
        var _$ngRedux$getState$ro = $ngRedux.getState().router,
            currentState = _$ngRedux$getState$ro.currentState,
            currentParams = _$ngRedux$getState$ro.currentParams;

        // Does the coupon exist in SIGNUP_TEXT_COUPON

        var coupon = _constants.SIGNUP_TEXT_COUPON[currentParams.coupon] ? currentParams.coupon : undefined;

        // Google tracking tags
        this.utmParams = currentParams.utm_params;
        this.campaignChannelMedium = currentParams.campaign_channel_medium;
        // Fetch all products.
        this.fetchProducts(currentParams.coupon);

        // Get Member if applicable
        if (_utils.memberStorage.get().memberId) {
          this.fetchMember(_utils.memberStorage.get().memberId);
        }

        // Restore a previous signup.
        this.restore();

        // Wait for product before handling slug / coupon params
        if (currentParams.slug) {
          this.unsubscribe = $ngRedux.subscribe(function () {
            return _this.onSubscribe();
          });
        }

        switch (currentState.name) {
          case 'signupPrograms':
          case 'signupProgramsDetail':
          case 'signupProgram':
            this.handleSetupProgram(currentParams);
            break;

          case 'signup':
          case 'signupWeekly':
            this.handleSetupWeekly();
            break;

          case 'signupVerify':
            this.handleVerify(currentParams);
            break;
        }
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();

        if (this.unsubscribe) {
          this.unsubscribe();
        }
      },
      onCancel: function onCancel() {
        $window.location.reload();
      },
      onSubscribe: function onSubscribe() {
        var _$ngRedux$getState = $ngRedux.getState(),
            router = _$ngRedux$getState.router,
            signup = _$ngRedux$getState.signup;

        var slug = router.currentParams.slug;

        // Preference coupon over slug

        var product = (0, _signup.selectProductBySlug)(signup, slug);

        if (product) {
          this.unsubscribe();
          this.update('voomeProductId', product.id);
        }
      },
      onChangeWeekly: function onChangeWeekly(_ref) {
        var name = _ref.name;
        var currentParams = $ngRedux.getState().router.currentParams;

        var slug = currentParams.slug === 'voome-bundle' ? name === 'Voome Workouts' ? 'voome-nutrition' : 'voome-workouts' : 'voome-bundle';

        this.stateGo('signupWeekly', { slug: slug });
      },
      handleSetupProgram: function handleSetupProgram(_ref2) {
        var voomeProductId = _ref2.voomeProductId;

        this.checkStatus();
        this.update('type', 'program');

        if (voomeProductId) {
          this.hasDropdown = false;
          this.update('voomeProductId', voomeProductId);
        } else {
          this.hasDropdown = true;
        }
      },
      handleSetupWeekly: function handleSetupWeekly() {
        this.checkStatus();
        this.update('type', 'weekly');
      },
      handleVerify: function handleVerify(params) {
        params.status_code === '200' ? this.verify(params) : this.setupChargifyError(params);
      },
      mapState: function mapState(_ref3) {
        var member = _ref3.member,
            signup = _ref3.signup;
        var isDisabled = signup.isDisabled,
            isLoading = signup.isLoading,
            coupon = signup.coupon,
            message = signup.message,
            step = signup.step,
            type = signup.type,
            voomeProductId = signup.voomeProductId,
            chargifyData = signup.chargifyData;


        return {
          isDisabled: isDisabled,
          isLoading: isLoading,
          coupon: coupon,
          message: message,
          step: step,
          type: type,
          chargifyData: chargifyData,
          member: (0, _member.selectMember)(member),
          product: (0, _signup.selectProduct)(signup, voomeProductId),
          products: (0, _signup.selectProductsByType)(signup, type),
          text: coupon ? _constants.SIGNUP_TEXT_COUPON[coupon] : _constants.SIGNUP_TEXT[type]
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          checkStatus: _signup.checkStatus,
          fetchMember: _member.fetchMember,
          fetchProducts: _signup.fetchProducts,
          reset: _signup.reset,
          restore: _signup.restore,
          setup: _signup.setup,
          setupChargifyError: _signup.setupChargifyError,
          stateGo: _reduxUiRouter.stateGo,
          update: _signup.update,
          updateChargifyData: _signup.updateChargifyData,
          verify: _signup.verify
        };
      }
    };
  }]
};

/***/ }),

/***/ "VvkJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WorkoutsExpress = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxUiRouter = __webpack_require__("Zb/7");

var _utils = __webpack_require__("0xDb");

var _member = __webpack_require__("1OIp");

var _favourite = __webpack_require__("GfAe");

var _filters = __webpack_require__("ZTBt");

var _search = __webpack_require__("j94E");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var WorkoutsExpress = exports.WorkoutsExpress = {
  template: '\n    <ui-view>\n      <div class="py-3 py-md-4 bg-gray-100">\n        <div class="container">\n          <div class="row">\n            <div class="col-md-3 pt-md-2">\n              <nav-mobile-sidebar\n                heading="Filter"\n                is-active="$ctrl.filtersIsActive"\n                on-click="$ctrl.toggleFiltersIsActive()">\n                <search-form class="d-none d-md-block mb-2"\n                  placeholder="find workouts"\n                  query="$ctrl.params.q"\n                  on-submit="$ctrl.onUpdateParam(\'q\', query)">\n                </search-form>\n                <search-filter-workouts\n                  filters="$ctrl.filters"\n                  on-click="$ctrl.onUpdateFilter(item, type, key, list)">\n                </search-filter-workouts>\n              </nav-mobile-sidebar>\n            </div>\n            <div class="col-md-9">\n              <div class="mobile-filter-row row d-flex d-md-none py-2 px-3 bg-white">\n                <button class="btn btn-link p-0 d-inline-flex"\n                  ng-click="$ctrl.toggleFiltersIsActive()">\n                  <i class="fa fa-sliders"></i>\n                  <span class="h6 text-green-dark mb-0">Filter</span>\n                </button>\n                <search-form\n                  class="d-inline-flex ml-auto"\n                  placeholder="find workouts"\n                  query="$ctrl.params.q"\n                  on-submit="$ctrl.onUpdateParam(\'q\', query)">\n                </search-form>\n              </div>\n              <search-filter-results\n                query="$ctrl.search.params.q"\n                filters="$ctrl.checkedFilters"\n                on-clear-all="$ctrl.onClearAll()"\n                on-update-param="$ctrl.onUpdateParam(key, value)"\n                on-update-filter="$ctrl.onUpdateFilter(item, type, key)">\n              </search-filter-results>\n              <search-results\n                on-update-param="$ctrl.onUpdateParam(key, value)"\n                order="$ctrl.sortBy"\n                pagination="$ctrl.pagination"\n                type="workouts">\n                <div class="row">\n                  <div class="col-sm-6 col-lg-4 pb-3"\n                    ng-repeat="item in $ctrl.results track by $index">\n                    <card-workout\n                      workout="item"\n                      member="$ctrl.member"\n                      on-click="$ctrl.onClick(item)">\n                    </card-workout>\n                  </div>\n                </div>\n              </search-results>\n            </div>\n          </div>\n        </div>\n      </div>\n    </ui-view>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    var EMPTY_PARAMS = {
      filters: undefined,
      level: undefined,
      order: undefined,
      page: undefined,
      q: undefined,
      serves: undefined
    };

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.unsubscribe = connect(this);

        var _$ngRedux$getState = $ngRedux.getState(),
            router = _$ngRedux$getState.router,
            filters = _$ngRedux$getState.filters;

        var currentParams = router.currentParams;

        // Search for workouts using the current route params.

        this.searchWorkouts(currentParams);

        // Fetch the filters
        if (!filters.workouts.length) {
          this.fetchFiltersWorkouts();
        }

        // Hide mobile sidebar
        this.showMobileSidebar = false;
      },
      $onDestroy: function $onDestroy() {
        this.unsubscribe();
      },
      onClearAll: function onClearAll() {
        this.stateGo('workouts.express', EMPTY_PARAMS);
      },
      onClick: function onClick(_ref) {
        var id = _ref.id,
            exercisePlanId = _ref.exercisePlanId,
            name = _ref.name;

        this.stateGo('workouts.express.detail', _extends({}, EMPTY_PARAMS, {
          id: id,
          exercisePlanId: exercisePlanId
        }));

        _utils.anchorStorage.set($ngRedux.getState(), name);
      },
      onUpdateFilter: function onUpdateFilter(item, type, key) {
        var list = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

        this.onUpdateParam(key, (0, _filters.updateFilters)(item.id, type, this.params[key], list));
      },
      onUpdateParam: function onUpdateParam(key) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        var page = value !== this.params[key] || key === 'q' ? undefined : this.params.page;

        this.stateGo('workouts.express', _extends({}, this.params, _defineProperty({
          page: page
        }, key, value)));
      },
      mapState: function mapState(_ref2) {
        var favourite = _ref2.favourite,
            filters = _ref2.filters,
            member = _ref2.member,
            router = _ref2.router,
            search = _ref2.search;
        var order = router.currentParams.order;

        var filterParams = router.currentParams.filters;

        return {
          search: search,
          member: (0, _member.selectMember)(member),
          hasAccess: (0, _member.selectHasWorkoutSubscription)(member),

          // Search
          filters: (0, _filters.selectFiltersWorkoutsGrouped)(filters, filterParams),
          filtersIsActive: filters.isActive,
          checkedFilters: (0, _filters.selectFiltersWorkoutsChecked)(filters, filterParams),
          sortBy: (0, _filters.selectSortByWorkouts)(filters, order),
          pagination: (0, _search.selectSearchPagination)(search),
          params: (0, _search.selectSearchParams)(search),
          results: (0, _favourite.mapIsFavouriteWorkouts)((0, _search.selectSearchResults)(search), (0, _favourite.selectFavouriteWorkoutIds)(favourite))
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          fetchFiltersWorkouts: _filters.fetchFiltersWorkouts,
          resetSearch: _search.resetSearch,
          searchWorkouts: _search.searchWorkouts,
          stateGo: _reduxUiRouter.stateGo,
          toggleFiltersIsActive: _filters.toggleFiltersIsActive
        };
      }
    };
  }]
};

/***/ }),

/***/ "W5nB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WLBs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Card = exports.Card = {
  transclude: {
    badges: '?badges',
    left: '?footerLeft',
    right: '?footerRight'
  },

  bindings: {
    heading: '<',
    description: '<',
    isFavourite: '<',
    img: '<',
    cardClass: '<',
    onFavourite: '&',
    onClick: '&'
  },

  template: '\n    <div class="card card-voome card-borderless" ng-class="$ctrl.cardClass">\n      <favourite-button\n        is-favourite="$ctrl.isFavourite"\n        ng-click="$ctrl.onFavourite()"\n        ng-if="$ctrl.isFavourite !== undefined">\n      </favourite-button>\n      <div class="card-img-wrapper" ng-click="$ctrl.onClick()">\n        <image-background src="$ctrl.img">\n          <div class="card-badge-wrapper" ng-transclude="badges"></div>\n        </image-background>\n      </div>\n      <div class="card-block card-title mb-0 d-flex justify-content-center align-items-center"\n        ng-if="$ctrl.heading"\n        ng-click="$ctrl.onClick()">\n        <span class="title word-wrap">{{ $ctrl.heading }}</span>\n      </div>\n      <div class="card-footer"\n        ng-click="$ctrl.onClick()">\n        <div class="card-footer-left" ng-transclude="left"></div>\n        <div class="card-footer-right" ng-transclude="right"></div>\n      </div>\n    </div>\n    <div class="card-description my-3"\n      ng-if="$ctrl.description"\n      ng-bind-html="$ctrl.description">\n    </div>'
};

/***/ }),

/***/ "WOni":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MealPlanCookMore = exports.MealPlanCookMore = {
  template: "\n    <div class=\"meal-plan-cook-more\">\n      Where you see the \"cook more\" symbol <i class=\"fa fa-lg icon-cookup pl-1\"></i>,\n      it means you are cooking the meal for the next day as well.\n    </div>"
};

/***/ }),

/***/ "WQxS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectRecipesSimilar = exports.recipesSimilarLogic = undefined;

var _map2 = __webpack_require__("2247");

var _map3 = _interopRequireDefault(_map2);

var _get2 = __webpack_require__("Q7hp");

var _get3 = _interopRequireDefault(_get2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.fetchRecipesSimilar = fetchRecipesSimilar;
exports.default = recipesSimilarReducer;

var _reduxLogic = __webpack_require__("E0Bt");

var _normalizr = __webpack_require__("vNPR");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Action Types
var FETCH = '@@app/recipesSimilar/FETCH';
var FETCH_SUCCESS = '@@app/recipesSimilar/FETCH_SUCCESS';
var FETCH_ERROR = '@@app/recipesSimilar/FETCH_ERROR';

// Initial State
var initialState = {
  entities: {},
  result: {},
  isLoading: false
};

// Observables
var fetchRecipesSimilarLogic = (0, _reduxLogic.createLogic)({
  type: FETCH,
  processOptions: {
    successType: FETCH_SUCCESS,
    failType: FETCH_ERROR
  },
  process: function process(_ref) {
    var action = _ref.action,
        httpClient = _ref.httpClient;
    var payload = action.payload;


    return httpClient.get('/v1/voome/recipes/' + payload.recipeId + '/similar', {
      params: { voomeProductId: payload.voomeProductId }
    }).then(function (_ref2) {
      var data = _ref2.data;

      var recipes = new _normalizr.schema.Entity('recipes');
      return _extends({}, (0, _normalizr.normalize)(data, [recipes]), { recipeId: payload.recipeId });
    });
  }
});

var recipesSimilarLogic = exports.recipesSimilarLogic = [fetchRecipesSimilarLogic];

// Selectors
var selectRecipesSimilar = exports.selectRecipesSimilar = function selectRecipesSimilar(_ref3, recipeId) {
  var recipesSimilar = _ref3.recipesSimilar;

  var recipeIds = (0, _get3.default)(recipesSimilar, ['result', recipeId], []);
  return (0, _map3.default)(recipeIds, function (id) {
    return (0, _get3.default)(recipesSimilar, ['entities', 'recipes', id]);
  });
};

// Action Creators
function fetchRecipesSimilar(recipeId, voomeProductId) {
  return { type: FETCH, payload: { recipeId: recipeId, voomeProductId: voomeProductId } };
}

// Reducer
function recipesSimilarReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case FETCH:
      return _extends({}, state, {
        isLoading: true
      });

    case FETCH_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        entities: {
          recipes: _extends({}, state.entities.recipes, payload.entities.recipes)
        },
        result: _extends({}, state.result, _defineProperty({}, payload.recipeId, payload.result))
      });

    default:
      return _extends({}, state);
  }
}

/***/ }),

/***/ "WbE4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MealPlanServes = exports.MealPlanServes = {
  bindings: {
    recipe: '<',
    onAddRecipe: '&',
    onClose: '&'
  },

  template: '\n    <div class="meal-plan-serves d-flex align-items-center justify-content-center">\n      <div class="content text-center">\n        <p class="mb-0">\n          <small>How many serves?</small>\n        </p>\n        <button class="btn btn-pill btn-primary border-0 ml-1 py-1"\n          ng-repeat="item in $ctrl.recipe.variations | orderBy: \'serves\' track by $index"\n          ng-click="$ctrl.onAddRecipe({ recipeId: item.id, leftOvers: false })">\n          <i class="fa icon-serves text-white"></i>x{{ item.serves }}\n        </button>\n        <button class="btn btn-pill bg-white border-pink-cz-mid py-1"\n          ng-click="$ctrl.onAddRecipe({ recipeId: $ctrl.recipe.id, leftOvers: true })">\n          <small class="text-pink-cz">Leftovers</small>\n        </button>\n      </div>\n      <div class="meta">\n        <button class="btn btn-link p-0"\n          ng-click="$ctrl.onClose()">\n          <i class="fa fa-2x fa-times-circle m-0"></i>\n        </button>\n      </div>\n    </div>'
};

/***/ }),

/***/ "WoY2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WwQF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logout = undefined;

var _auth = __webpack_require__("wnLK");

var Logout = exports.Logout = {
  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        $ngRedux.dispatch((0, _auth.authLogout)());
      }
    };
  }]
};

/***/ }),

/***/ "X/VX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoProgress = exports.VideoPlaylist = exports.VideoPlayerResumable = exports.VideoPlayer = undefined;

var _VideoPlayer = __webpack_require__("6+My");

Object.defineProperty(exports, 'VideoPlayer', {
  enumerable: true,
  get: function get() {
    return _VideoPlayer.VideoPlayer;
  }
});

var _VideoPlayerResumable = __webpack_require__("Q73F");

Object.defineProperty(exports, 'VideoPlayerResumable', {
  enumerable: true,
  get: function get() {
    return _VideoPlayerResumable.VideoPlayerResumable;
  }
});

var _VideoPlaylist = __webpack_require__("8N+6");

Object.defineProperty(exports, 'VideoPlaylist', {
  enumerable: true,
  get: function get() {
    return _VideoPlaylist.VideoPlaylist;
  }
});

var _VideoProgress = __webpack_require__("UP8H");

Object.defineProperty(exports, 'VideoProgress', {
  enumerable: true,
  get: function get() {
    return _VideoProgress.VideoProgress;
  }
});

__webpack_require__("r93F");

/***/ }),

/***/ "X/jt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageCircle = exports.ImageBackground = undefined;

var _Background = __webpack_require__("Rfaq");

Object.defineProperty(exports, 'ImageBackground', {
  enumerable: true,
  get: function get() {
    return _Background.ImageBackground;
  }
});

var _Circle = __webpack_require__("2kBn");

Object.defineProperty(exports, 'ImageCircle', {
  enumerable: true,
  get: function get() {
    return _Circle.ImageCircle;
  }
});

__webpack_require__("39a0");

/***/ }),

/***/ "XC7J":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/three-beeps.e5bb6ce0e67c67d64b1d663d1fd7c91e.mp3";

/***/ }),

/***/ "XI2E":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectWorkoutIsComplete = exports.selectRecentlyCompleted = exports.selectCompletions = exports.completionsLogic = exports.initialState = undefined;

var _unset2 = __webpack_require__("CVqg");

var _unset3 = _interopRequireDefault(_unset2);

var _get2 = __webpack_require__("Q7hp");

var _get3 = _interopRequireDefault(_get2);

var _first2 = __webpack_require__("y9NZ");

var _first3 = _interopRequireDefault(_first2);

var _find2 = __webpack_require__("kbi+");

var _find3 = _interopRequireDefault(_find2);

var _each2 = __webpack_require__("9uKM");

var _each3 = _interopRequireDefault(_each2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.completionsFetch = completionsFetch;
exports.workoutComplete = workoutComplete;
exports.workoutUncomplete = workoutUncomplete;
exports.workoutToggleComplete = workoutToggleComplete;
exports.mealPlanComplete = mealPlanComplete;
exports.mealPlanUncomplete = mealPlanUncomplete;
exports.mealPlanToggleComplete = mealPlanToggleComplete;
exports.clearComplete = clearComplete;
exports.default = completionReducer;

var _reduxLogic = __webpack_require__("E0Bt");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = exports.initialState = {
  loading: false,
  entities: {},
  recentlyCompleted: {}
};

var completionTypes = [{
  model: 'ExercisePlanDayV2',
  type: 'workouts',
  idenitifer: 'itemId'
}, {
  model: 'MealPlanRecipe',
  type: 'meals',
  idenitifer: 'item.dayString'
}];

// Actions

var FETCH = '@@app/completions/FETCH';
var FETCH_SUCCESS = '@@app/completions/FETCH_SUCCESS';
var FETCH_ERROR = '@@app/completions/FETCH_ERROR';

var COMPLETE_SUCCESS = '@@app/completions/COMPLETE_SUCCESS';
var COMPLETE_ERROR = '@@app/completions/COMPLETE_ERROR';
var COMPLETE_CLEAR = '@@app/completions/COMPLETE_CLEAR';
var UNCOMPLETE_SUCCESS = '@@app/completions/UNCOMPLETE_SUCCESS';
var UNCOMPLETE_ERROR = '@@app/completions/UNCOMPLETE_ERROR';

var WORKOUT_COMPLETE = '@@app/completions/WORKOUT_COMPLETE';
var WORKOUT_UNCOMPLETE = '@@app/completions/WORKOUT_UNCOMPLETE';
var MEAL_PLAN_COMPLETE = '@@app/completions/MEAL_PLAN_COMPLETE';
var MEAL_PLAN_UNCOMPLETE = '@@app/completions/MEAL_PLAN_UNCOMPLETE';

// Helpers
function complete(obj, completion) {
  var itemType = completion.itemType,
      referenceName = completion.referenceName;

  var _completionType = completionType(itemType),
      type = _completionType.type,
      idenitifer = _completionType.idenitifer;

  var id = (0, _get3.default)(completion, idenitifer);

  // Reference name is week number in this case
  obj[referenceName] = obj[referenceName] || { items: {}, total: 0 };
  obj[referenceName].items[type] = obj[referenceName].items[type] || {};

  // Only incrememnt total if it hasn't been set already
  if (!obj[referenceName].items[type][id]) {
    obj[referenceName].items[type][id] = true;
    obj[referenceName].total += 1;
  }

  return _extends({}, obj);
}

function uncomplete(obj, completion) {
  var itemType = completion.itemType,
      referenceName = completion.referenceName;

  var _completionType2 = completionType(itemType),
      type = _completionType2.type,
      idenitifer = _completionType2.idenitifer;

  var id = (0, _get3.default)(completion, idenitifer);

  (0, _unset3.default)(obj, [referenceName, 'items', type, id]);

  if ((0, _get3.default)(obj, [referenceName, 'total']) > 0) {
    obj[referenceName].total -= 1;
  }

  return _extends({}, obj);
}

function completionType(type) {
  return (0, _find3.default)(completionTypes, { model: type }) || (0, _find3.default)(completionTypes, { type: type });
}

// Observables
var completedFetchLogic = (0, _reduxLogic.createLogic)({
  type: FETCH,
  process: function process(_ref, dispatch, done) {
    var action = _ref.action,
        httpClient = _ref.httpClient;
    var _action$payload = action.payload,
        memberId = _action$payload.memberId,
        voomeProductId = _action$payload.voomeProductId,
        weekNumber = _action$payload.weekNumber;

    var params = { voomeProductId: voomeProductId, reference: weekNumber };

    return httpClient.get('/v3/members/' + memberId + '/completed', { params: params }).then(function (_ref2) {
      var data = _ref2.data;
      return data;
    }).then(function (payload) {
      return dispatch({ type: FETCH_SUCCESS, payload: payload, weekNumber: weekNumber });
    }).catch(function () {
      return dispatch({ type: FETCH_ERROR, error: true });
    }).then(function () {
      return done();
    });
  }
});

var completedFetchSuccessLogic = (0, _reduxLogic.createLogic)({
  type: FETCH_SUCCESS,
  transform: function transform(_ref3, next) {
    var action = _ref3.action;
    var payload = action.payload,
        weekNumber = action.weekNumber;

    var completions = {};

    (0, _each3.default)(payload, function (completion) {
      return complete(completions, completion);
    });

    next(_extends({}, action, { payload: { completions: completions } }));
  }
});

var workoutCompleteLogic = (0, _reduxLogic.createLogic)({
  type: WORKOUT_COMPLETE,
  processOptions: {
    successType: COMPLETE_SUCCESS,
    failType: COMPLETE_ERROR
  },
  process: function process(_ref4) {
    var action = _ref4.action,
        httpClient = _ref4.httpClient;
    var payload = action.payload;
    var exercisePlanId = payload.exercisePlanId,
        dayId = payload.dayId,
        voomeProductId = payload.voomeProductId,
        weekNumber = payload.weekNumber;


    return httpClient.put('/v1/voome/exercise-plans/' + exercisePlanId + '/days/' + dayId + '/complete', {
      voomeProductId: voomeProductId,
      reference: weekNumber
    }).then(function (response) {
      return _extends({}, response.data.success, payload);
    });
  }
});

var workoutUncompleteLogic = (0, _reduxLogic.createLogic)({
  type: WORKOUT_UNCOMPLETE,
  processOptions: {
    successType: UNCOMPLETE_SUCCESS,
    failType: UNCOMPLETE_ERROR
  },
  process: function process(_ref5) {
    var action = _ref5.action,
        httpClient = _ref5.httpClient;
    var payload = action.payload;
    var exercisePlanId = payload.exercisePlanId,
        dayId = payload.dayId,
        voomeProductId = payload.voomeProductId,
        weekNumber = payload.weekNumber;

    var data = { voomeProductId: voomeProductId, reference: weekNumber };

    return httpClient.delete('/v1/voome/exercise-plans/' + exercisePlanId + '/days/' + dayId + '/uncomplete', { data: data }).then(function (response) {
      var success = (0, _first3.default)(response.data.success);
      return _extends({}, success, payload);
    });
  }
});

var mealPlanCompleteLogic = (0, _reduxLogic.createLogic)({
  type: MEAL_PLAN_COMPLETE,
  processOptions: {
    successType: COMPLETE_SUCCESS,
    failType: COMPLETE_ERROR
  },
  process: function process(_ref6) {
    var action = _ref6.action,
        httpClient = _ref6.httpClient;
    var payload = action.payload;
    var mealPlanId = payload.mealPlanId,
        day = payload.day,
        voomeProductId = payload.voomeProductId,
        weekNumber = payload.weekNumber;


    return httpClient.put('/v1/voome/meal-plans/' + mealPlanId + '/complete', {
      voomeProductId: voomeProductId,
      reference: weekNumber,
      day: day
    }).then(function (response) {
      var success = (0, _first3.default)(response.data.success);
      return _extends({}, success, payload);
    });
  }
});

var mealPlanUncompleteLogic = (0, _reduxLogic.createLogic)({
  type: MEAL_PLAN_UNCOMPLETE,
  processOptions: {
    successType: UNCOMPLETE_SUCCESS,
    failType: UNCOMPLETE_ERROR
  },
  process: function process(_ref7) {
    var action = _ref7.action,
        httpClient = _ref7.httpClient;
    var payload = action.payload;
    var mealPlanId = payload.mealPlanId,
        day = payload.day,
        voomeProductId = payload.voomeProductId,
        weekNumber = payload.weekNumber;

    var data = { voomeProductId: voomeProductId, reference: weekNumber, day: day };

    return httpClient.delete('/v1/voome/meal-plans/' + mealPlanId + '/uncomplete', { data: data }).then(function (response) {
      var success = (0, _first3.default)(response.data.success);
      return _extends({}, success, payload);
    });
  }
});

var completeSuccessLogic = (0, _reduxLogic.createLogic)({
  type: COMPLETE_SUCCESS,
  transform: function transform(_ref8, next) {
    var action = _ref8.action,
        getState = _ref8.getState;
    var payload = action.payload;

    var completions = selectCompletions(getState());

    complete(completions, payload);
    next(_extends({}, action));
  }
});

var uncompleteSuccessLogic = (0, _reduxLogic.createLogic)({
  type: UNCOMPLETE_SUCCESS,
  transform: function transform(_ref9, next) {
    var action = _ref9.action,
        getState = _ref9.getState;
    var payload = action.payload;

    var completions = selectCompletions(getState());

    uncomplete(completions, payload);
    next(_extends({}, action));
  }
});

var completionsLogic = exports.completionsLogic = [completedFetchLogic, completedFetchSuccessLogic, mealPlanCompleteLogic, mealPlanUncompleteLogic, workoutCompleteLogic, workoutUncompleteLogic, completeSuccessLogic, uncompleteSuccessLogic];

// Selectors
var selectCompletions = exports.selectCompletions = function selectCompletions(state) {
  var weekNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var completions = (0, _get3.default)(state, 'completions.entities.completions');

  if (weekNumber) {
    completions = (0, _get3.default)(completions, weekNumber);
  }

  return completions;
};

var selectRecentlyCompleted = exports.selectRecentlyCompleted = function selectRecentlyCompleted(state) {
  return (0, _get3.default)(state, 'completions.recentlyCompleted');
};

var selectWorkoutIsComplete = exports.selectWorkoutIsComplete = function selectWorkoutIsComplete(state) {
  var workout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return (0, _get3.default)(selectCompletions(state, workout.week), ['items', 'workouts', workout.id], false);
};

// Action Creators
function completionsFetch(memberId, voomeProductId, weekNumber) {
  return { type: FETCH, payload: { memberId: memberId, voomeProductId: voomeProductId, weekNumber: weekNumber } };
}

function workoutComplete(exercisePlanId, dayId, voomeProductId, weekNumber, title) {
  return {
    type: WORKOUT_COMPLETE,
    payload: { exercisePlanId: exercisePlanId, dayId: dayId, voomeProductId: voomeProductId, weekNumber: weekNumber, title: title }
  };
}

function workoutUncomplete(exercisePlanId, dayId, voomeProductId, weekNumber) {
  return {
    type: WORKOUT_UNCOMPLETE,
    payload: { exercisePlanId: exercisePlanId, dayId: dayId, voomeProductId: voomeProductId, weekNumber: weekNumber }
  };
}

function workoutToggleComplete(exercisePlanId, dayId, voomeProductId, weekNumber, title, isComplete) {
  if (isComplete) {
    return workoutUncomplete(exercisePlanId, dayId, voomeProductId, weekNumber);
  } else {
    return workoutComplete(exercisePlanId, dayId, voomeProductId, weekNumber, title);
  }
}

function mealPlanComplete(mealPlanId, day, voomeProductId, weekNumber, title) {
  return {
    type: MEAL_PLAN_COMPLETE,
    payload: { mealPlanId: mealPlanId, day: day, voomeProductId: voomeProductId, weekNumber: weekNumber, title: title }
  };
}

function mealPlanUncomplete(mealPlanId, day, voomeProductId, weekNumber) {
  return {
    type: MEAL_PLAN_UNCOMPLETE,
    payload: { mealPlanId: mealPlanId, day: day, voomeProductId: voomeProductId, weekNumber: weekNumber }
  };
}

function mealPlanToggleComplete(mealPlanId, day, voomeProductId, weekNumber, title, isComplete) {
  if (isComplete) {
    return mealPlanUncomplete(mealPlanId, day, voomeProductId, weekNumber);
  } else {
    return mealPlanComplete(mealPlanId, day, voomeProductId, weekNumber, title);
  }
}

function clearComplete() {
  return { type: COMPLETE_CLEAR };
}

// Reducer
function completionReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case FETCH_SUCCESS:
      return _extends({}, state, {
        entities: payload
      });

    case COMPLETE_SUCCESS:
      return _extends({}, state, {
        recentlyCompleted: payload
      });

    case COMPLETE_CLEAR:
      return _extends({}, state, {
        recentlyCompleted: null
      });

    default:
      return _extends({}, state);
  }
}

/***/ }),

/***/ "XPnL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DashboardWorkoutUpgrade = exports.DashboardWorkoutUpgrade = {
  bindings: {
    member: '<',
    workoutCollection: '<'
  },

  template: '\n    <div class="dashboard-workout-upgrade">\n      <section class="dashboard-cards">\n        <div class="container">\n          <div class="row">\n            <div class="card-wrapper card-sm col pointer active">\n              <card-image\n                card-class="text-center bg-teal-dark"\n                img="$ctrl.workoutCollection.coverImageUrl.magazine">\n                <small class="tagline">\n                  This week on <span class="text-orange">Voome Workouts</span>\n                </small>\n                <h4 class="card-title">\n                  {{ $ctrl.workoutCollection.title }}\n                </h4>\n              </card-image>\n              <box-arrow-row color="white"></box-arrow-row>\n              <div class="d-md-none" ng-switch-when="2">\n                <dashboard-workout-hack\n                  title="$ctrl.workoutCollection.title"\n                  description="$ctrl.workoutCollection.strapLine"\n                  items="$ctrl.workoutCollection.workouts"\n                  member="$ctrl.member">\n                </dashboard-workout-hack>\n              </div>\n            </div>\n        </div>\n      </section>\n      <dashboard-workout-hack\n        title="$ctrl.workoutCollection.title"\n        description="$ctrl.workoutCollection.strapLine"\n        items="$ctrl.workoutCollection.workouts"\n        member="$ctrl.member">\n      </dashboard-workout-hack>\n      <div class="container">\n        <div class="row">\n          <div class="card-wrapper col pointer active">\n            <a class="d-block text-center p-3 mt-3 mb-sm-0 btn-unstyled bg-teal-dark"\n              ng-click="$ctrl.onClick()">\n              <h5 class="text-white">Workouts at your fingertips</h5>\n              <p class="text-white">\n                Get full access to workouts and over 30 workouts collections for only $3/week.\n              </p>\n              <button class="btn btn-pill theme-btn btn-md"\n                type="button"\n                ng-click="$ctrl.onClick()">\n                Learn More\n              </button>\n            </a>\n          </div>\n        </div>\n      </div>\n    </div>',

  controller: ["$state", function controller($state) {
    'ngInject';

    return {
      onClick: function onClick() {
        $state.go('workouts');
      }
    };
  }]
};

/***/ }),

/***/ "XWIQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ProgramWeekVideos = exports.ProgramWeekVideos = {
  bindings: {
    weekNumber: '<',
    items: '<',
    videoResume: '<'
  },

  template: '\n    <div class="container program-week-videos">\n      <section class="section-carousel">\n        <h4>\n          <span class="aside">\n            Week {{ $ctrl.weekNumber }}\n          </span>\n          Videos\n        </h4>\n        <carousel\n          list="$ctrl.items"\n          settings="{ slidesToShow: 3 }"\n          ng-if="$ctrl.items">\n          <div class="carousel-slide-wrapper"\n            ng-repeat="item in $ctrl.items track by item.id">\n            <div class="carousel-slide">\n              <card-video\n                image="item.thumbnailUrl.large"\n                data-toggle="modal"\n                data-target="#modalVideoProgram"\n                on-click="$ctrl.loadModalVideo(item)">\n              </card-video>\n            </div>\n          </div>\n        </carousel>\n      </section>\n      <modal\n        size="lg"\n        target="modalVideoProgram"\n        on-hidden="$ctrl.onHideModal()">\n        <modal-title>\n          <span class="text-center">{{ $ctrl.modalTitle }}</span>\n        </modal-title>\n        <modal-body>\n          <video-player-resumable\n            on-load="$ctrl.onLoadPlayer(player)"\n            autoplay="!this.videoResume[this.modalVideoId]"\n            video-id="$ctrl.modalVideoId">\n          </video-player-resumable>\n        </modal-body>\n      </modal>\n    </div>',

  controller: function controller() {
    'ngInject';

    return {
      loadModalVideo: function loadModalVideo(item) {
        this.modalTitle = item.title;
        this.modalVideoId = item.brightcoveId;
      },
      onLoadPlayer: function onLoadPlayer(player) {
        this.player = player;

        if (!this.videoResume[this.modalVideoId]) {
          this.player.play();
        }
      },
      onHideModal: function onHideModal() {
        if (this.player) {
          this.player.pause();
        }
      }
    };
  }
};

/***/ }),

/***/ "Xcm0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavLogo = undefined;

var _logo = __webpack_require__("zxL1");

var _logo2 = _interopRequireDefault(_logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavLogo = exports.NavLogo = {
  template: '\n    <div class="nav-logo">\n      <img class="img-fluid" src="https://belgravia-group.s3-ap-southeast-2.amazonaws.com/coaching-zone/cz_horizontal.jpg">\n      <span class="sr-only">Voome</span>\n    </div>'
};

/***/ }),

/***/ "XiiV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgramMealPlan = undefined;

var _reduxUiRouter = __webpack_require__("Zb/7");

var _mealPlan = __webpack_require__("KLwp");

var _member = __webpack_require__("1OIp");

var ProgramMealPlan = exports.ProgramMealPlan = {
  template: '\n    <div class="program-meal-plan">\n      <nav-page>\n        <nav-left>\n          <button-back\n            on-click="$ctrl.stateGo(\'program.week\', { weekNumber: $ctrl.weekNumber })">\n            Week {{ $ctrl.weekNumber }}\n          </button-back>\n        </nav-left>\n      </nav-page>\n      <div class="program-meal-plan-container">\n        <header class="container text-center pt-4 pb-3"\n          ng-hide="$ctrl.name === \'program.week.mealPlan.edit\'">\n          <h2>Week {{ $ctrl.weekNumber }} Meal Plan</h2>\n          <meal-plan-nav\n            name="$ctrl.name"\n            meal-plan-name="program.week.mealPlan"\n            shopping-list-name="program.week.mealPlan.shoppingList"\n            is-disabled="!$ctrl.hasMealPlanRecipe"\n            on-click="$ctrl.stateGo(name)">\n          </meal-plan-nav>\n        </header>\n        <ui-view>\n          <div ng-if="$ctrl.hasWeekly">\n            <meal-plan></meal-plan>\n          </div>\n          <div ng-if="!$ctrl.hasWeekly">\n            <meal-plan-basic></meal-plan-basic>\n          </div>\n        </ui-view>\n      </div>\n    </div>',

  controller: ["$ngRedux", "$anchorScroll", function controller($ngRedux, $anchorScroll) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);
        $anchorScroll();
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();
      },
      mapState: function mapState(_ref) {
        var mealPlan = _ref.mealPlan,
            member = _ref.member,
            router = _ref.router;
        var mealPlanId = router.currentParams.mealPlanId;


        return {
          hasWeekly: (0, _member.selectHasWeeklySubscription)(member),
          weekNumber: router.currentParams.weekNumber,
          name: router.currentState.name,
          hasMealPlanRecipe: (0, _mealPlan.selectHasMealPlanRecipe)(mealPlan, mealPlanId)
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          stateGo: _reduxUiRouter.stateGo
        };
      }
    };
  }]
};

/***/ }),

/***/ "Xpbu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Modal = exports.Modal = {
  bindings: {
    target: '@',
    size: '@',
    onHide: '&',
    onHidden: '&',
    onShow: '&',
    onShown: '&'
  },

  transclude: {
    body: '?modalBody',
    title: '?modalTitle'
  },

  template: '\n    <div\n      id="{{ $ctrl.target }}"\n      class="modal fade"\n      tabindex="-1"\n      role="dialog"\n      aria-labelledby="{{ $ctrl.target }}"\n      aria-hidden="true">\n      <div class="modal-dialog modal-{{ $ctrl.size || \'md\' }}" role="document">\n        <div class="modal-content">\n          <div class="modal-header">\n            <h4 class="modal-title w-100 text-center"\n              ng-transclude="title">\n            </h4>\n            <button\n              type="button"\n              class="close"\n              data-dismiss="modal"\n              aria-label="Close">\n              <span aria-hidden="true">&times;</span>\n            </button>\n          </div>\n          <div class="modal-body" ng-transclude="body"></div>\n        </div>\n      </div>\n    </div>',

  controller: ["$timeout", function controller($timeout) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var _this = this;

        if (this.target) {
          $timeout(function () {
            $('#' + _this.target).on('hide.bs.modal', _this.hide).on('hidden.bs.modal', _this.onHidden).on('show.bs.modal', _this.onShow).on('shown.bs.modal', _this.onShown);
          });
        }
      },
      $onDestroy: function $onDestroy() {
        $('.modal-backdrop').remove();

        if (this.target) {
          $('#' + this.target).off('hide.bs.modal', this.hide).off('hidden.bs.modal', this.onHidden).off('show.bs.modal', this.onShow).off('shown.bs.modal', this.onShown);
        }
      }
    };
  }]
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "Xra4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DashboardWorkoutUpgrade = exports.DashboardWorkoutInspiration = exports.DashboardWorkoutContainer = exports.DashboardWorkoutHack = exports.DashboardNutritionMealPlan = exports.DashboardNutritionUpgrade = exports.DashboardNutritionInspiration = exports.DashboardNutritionContainer = exports.DashboardNutritionHack = exports.DashboardCarousel = undefined;

var _Carousel = __webpack_require__("3/7M");

Object.defineProperty(exports, 'DashboardCarousel', {
  enumerable: true,
  get: function get() {
    return _Carousel.DashboardCarousel;
  }
});

var _NutritionHack = __webpack_require__("rAUk");

Object.defineProperty(exports, 'DashboardNutritionHack', {
  enumerable: true,
  get: function get() {
    return _NutritionHack.DashboardNutritionHack;
  }
});

var _NutritionContainer = __webpack_require__("by8k");

Object.defineProperty(exports, 'DashboardNutritionContainer', {
  enumerable: true,
  get: function get() {
    return _NutritionContainer.DashboardNutritionContainer;
  }
});

var _NutritionInspiration = __webpack_require__("VMvO");

Object.defineProperty(exports, 'DashboardNutritionInspiration', {
  enumerable: true,
  get: function get() {
    return _NutritionInspiration.DashboardNutritionInspiration;
  }
});

var _NutritionUpgrade = __webpack_require__("mw5s");

Object.defineProperty(exports, 'DashboardNutritionUpgrade', {
  enumerable: true,
  get: function get() {
    return _NutritionUpgrade.DashboardNutritionUpgrade;
  }
});

var _NutritionMealPlan = __webpack_require__("O00g");

Object.defineProperty(exports, 'DashboardNutritionMealPlan', {
  enumerable: true,
  get: function get() {
    return _NutritionMealPlan.DashboardNutritionMealPlan;
  }
});

var _WorkoutHack = __webpack_require__("bk+O");

Object.defineProperty(exports, 'DashboardWorkoutHack', {
  enumerable: true,
  get: function get() {
    return _WorkoutHack.DashboardWorkoutHack;
  }
});

var _WorkoutContainer = __webpack_require__("za+p");

Object.defineProperty(exports, 'DashboardWorkoutContainer', {
  enumerable: true,
  get: function get() {
    return _WorkoutContainer.DashboardWorkoutContainer;
  }
});

var _WorkoutInspiration = __webpack_require__("mCdB");

Object.defineProperty(exports, 'DashboardWorkoutInspiration', {
  enumerable: true,
  get: function get() {
    return _WorkoutInspiration.DashboardWorkoutInspiration;
  }
});

var _WorkoutUpgrade = __webpack_require__("XPnL");

Object.defineProperty(exports, 'DashboardWorkoutUpgrade', {
  enumerable: true,
  get: function get() {
    return _WorkoutUpgrade.DashboardWorkoutUpgrade;
  }
});

__webpack_require__("AYAf");

/***/ }),

/***/ "YQdJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FormLabel = exports.FormLabel = {
  transclude: true,

  bindings: {
    for: '@'
  },

  template: '\n    <label class="text-gray-900"\n      for="{{ $ctrl.for }}"\n      ng-transclude>\n    </label>'
};

/***/ }),

/***/ "YRlT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WelcomeStepBundle = exports.WelcomeStepBundle = {
  transclude: true,

  bindings: {
    isLoading: '<',
    member: '<',
    scrollTo: '&',
    onSubmit: '&',
    onUpdate: '&'
  },

  template: '\n    <div class="welcome-step-bundle">\n      <welcome-step-nutrition\n        ng-hide="$ctrl.isComplete"\n        member="$ctrl.member"\n        is-loading="$ctrl.isLoading"\n        on-update="$ctrl.onUpdate({ key: key, value: value })"\n        on-submit="$ctrl.scrollTo({ id: \'\' }); $ctrl.isComplete = true;"\n        scroll-to="$ctrl.scrollTo({ id: id })">\n        <welcome-step-actions\n          on-cancel="$ctrl.onCancel()"\n          is-loading="$ctrl.isLoading">\n          Done\n        </welcome-step-actions>\n      </welcome-step-nutrition>\n      <welcome-step-workout\n        ng-show="$ctrl.isComplete"\n        member="$ctrl.member"\n        is-loading="$ctrl.isLoading"\n        on-update="$ctrl.onUpdate({ key: key, value: value })"\n        on-submit="$ctrl.onSubmit({ data: data })"\n        scroll-to="$ctrl.scrollTo({ id: id })">\n        <welcome-step-actions\n          on-cancel="$ctrl.onCancel()"\n          is-loading="$ctrl.isLoading">\n          Let\'s Start\n        </welcome-step-actions>\n      </welcome-step-workout>\n    </div>'
};

/***/ }),

/***/ "YcV4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var dataLayer = exports.dataLayer = {
  track: function track(event) {
    var eventData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    try {
      window.dataLayer.push(_extends({ event: event }, eventData));
    } catch (e) {}
  }
};

/***/ }),

/***/ "Yq9a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WorkoutList = exports.WorkoutList = {
  bindings: {
    exercises: '<',
    member: '<',
    params: '<',
    workout: '<',
    onStart: '&'
  },

  template: '\n    <div class="workout-list">\n      <workout-meta\n        workout="$ctrl.workout"\n        member="$ctrl.member">\n      </workout-meta>\n      <workout-section\n        ng-repeat="item in $ctrl.workout.items track by $index"\n        section="item"\n        workout="$ctrl.workout"\n        exercises="$ctrl.exercises"\n        gender="$ctrl.member.profile.gender"\n        params="$ctrl.params"\n        on-show-modal="$ctrl.onShowModal(item)">\n      </workout-section>\n      <modal\n        size="md"\n        target="modalVideoExercise"\n        on-hidden="$ctrl.onHidden()">\n        <modal-title>\n          <span class="text-center">{{ $ctrl.modalTitle }}</span>\n        </modal-title>\n        <modal-body>\n          <video-player\n            video-id="$ctrl.modalVideoId"\n            autoplay="\'true\'">\n          </video-player>\n        </modal-body>\n      </modal>\n    </div>',

  controller: function controller() {
    'ngInject';

    return {
      onShowModal: function onShowModal(item) {
        this.modalTitle = item.title;
        this.modalVideoId = item.brightcoveId;
      },
      onHidden: function onHidden() {
        this.modalTitle = undefined;
        this.modalVideoId = undefined;
      }
    };
  }
};

/***/ }),

/***/ "Yt7d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FavouritesWorkouts = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxUiRouter = __webpack_require__("Zb/7");

var _utils = __webpack_require__("0xDb");

var _filters = __webpack_require__("ZTBt");

var _member = __webpack_require__("1OIp");

var _favourite = __webpack_require__("GfAe");

var FavouritesWorkouts = exports.FavouritesWorkouts = {
  template: '\n    <ui-view>\n      <div class="favourite-workouts py-3 py-md-4">\n        <div class="container pb-3">\n          <div class="d-flex align-items-center justify-content-end">\n            <search-order\n              ng-show="$ctrl.pagination.result.length"\n              title="Sort by:"\n              list="$ctrl.sortBy"\n              on-click="$ctrl.onUpdateOrder(value)">\n            </search-order>\n          </div>\n          <div class="row pt-2">\n            <div class="col-sm-6 col-md-4 col-lg-3 pb-3"\n              ng-repeat="item in $ctrl.pagination.result track by $index">\n              <card-workout\n                workout="item"\n                member="$ctrl.member"\n                on-click="$ctrl.onClick(item)">\n              </card-workout>\n            </div>\n            <div class="col-sm-5 mx-auto mt-3"\n              ng-hide="$ctrl.pagination.result.length">\n              <favourite-no-result\n                is-loading="$ctrl.isLoading">\n              </favourite-no-result>\n            </div>\n          </div>\n          <pagination-row\n            on-update-param="$ctrl.onUpdatePage(value)"\n            pagination="$ctrl.pagination">\n          </pagination-row>\n        </div>\n      </div>\n    </ui-view>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        if (this.shouldFetch) {
          this.fetchFavouriteWorkouts(this.params);
        }
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();
      },
      onClick: function onClick(_ref) {
        var id = _ref.id,
            exercisePlanId = _ref.exercisePlanId,
            name = _ref.name;

        this.stateGo('favourites.workouts.detail', {
          id: id,
          exercisePlanId: exercisePlanId,
          page: undefined,
          order: undefined
        });

        _utils.anchorStorage.set($ngRedux.getState(), name);
      },
      onUpdateOrder: function onUpdateOrder(order) {
        this.stateGo('favourites.workouts', { order: order, page: undefined });
      },
      onUpdatePage: function onUpdatePage(page) {
        this.stateGo('favourites.workouts', { page: page });
      },
      mapState: function mapState(_ref2) {
        var favourite = _ref2.favourite,
            filters = _ref2.filters,
            member = _ref2.member,
            router = _ref2.router;

        var stateMember = (0, _member.selectMember)(member);

        var params = _extends({}, router.currentParams, {
          memberId: stateMember.id
        });

        var pagination = (0, _favourite.selectFavouriteWorkouts)(favourite, params);
        var result = pagination.result;
        var isLoading = favourite.isLoading;


        return {
          isLoading: isLoading,
          pagination: pagination,
          params: params,
          member: stateMember,
          shouldFetch: (0, _favourite.selectFavouriteWorkoutsReload)(favourite, result),
          sortBy: (0, _filters.selectSortByWorkouts)(filters, params.order)
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          fetchFavouriteWorkouts: _favourite.fetchFavouriteWorkouts,
          stateGo: _reduxUiRouter.stateGo
        };
      }
    };
  }]
};

/***/ }),

/***/ "YtHA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Spinner = exports.Spinner = {
  transclude: true,

  bindings: {
    isLoading: '<'
  },

  template: '\n    <i class="fa fa-spin fa-circle-o-notch mr-1" ng-show="$ctrl.isLoading"></i>\n    <span ng-transclude></span>'
};

/***/ }),

/***/ "Z6Nm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CardImage = exports.CardImage = {
  transclude: true,

  bindings: {
    img: '<',
    linkText: '<',
    cardClass: '@'
  },

  template: '\n    <div class="card card-plain card-inverse card-borderless card-image"\n      ng-class="$ctrl.cardClass">\n      <image-background src="$ctrl.img">\n        <div class="card-block mb-0 align-items-center text-center card-block--tint">\n          <ng-transclude></ng-transclude>\n        </div>\n        <p class="card-link theme-btn--highlight" ng-if="$ctrl.linkText">\n          <i class="fa fa-plus-circle"></i>\n          {{ $ctrl.linkText }}\n        </p>\n      </image-background>\n    </div>'
};

/***/ }),

/***/ "ZBVT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ProgramStartModal = exports.ProgramStartModal = {
  bindings: {
    datesForWeek: '<',
    subscription: '<',
    onSubmit: '&'
  },

  template: '\n    <div\n      id="modalStartProgram"\n      class="modal fade"\n      tabindex="-1"\n      role="dialog"\n      aria-labelledby="Start Program"\n      aria-hidden="true">\n      <div class="modal-dialog" role="document">\n        <form\n          name="form"\n          ng-submit="$ctrl.onSubmit({ data: form.data })"\n          novalidate>\n          <form-input\n            form="form"\n            type="hidden"\n            name="id"\n            value="$ctrl.subscription.id"/>\n          <form-input\n            form="form"\n            type="hidden"\n            name="voomeProductId"\n            value="$ctrl.subscription.voomeProductId"/>\n          <div class="modal-content">\n            <div class="modal-header text-center">\n              <h5 class="modal-title m-auto">\n                Start Program\n              </h5>\n              <button type="button" class="close" data-dismiss="modal" aria-label="Close">\n                <span aria-hidden="true">&times;</span>\n              </button>\n            </div>\n            <div class="modal-body text-left">\n              <p>Pick the day you would like to start the program.</p>\n              <form-radio-list\n                form="form"\n                name="startDate"\n                value="form.data.startDate"\n                list="$ctrl.datesForWeek"\n                list-item-key="startDate"\n                list-item-title="title"\n                list-item-class="list-inline-item w-100 btn-radio-list"\n                on-update="form.data.startDate = value">\n              </form-radio-list>\n            </div>\n            <div class="modal-footer d-flex justify-content-center">\n              <button-primary is-inverse="true" data-dismiss="modal">\n                Cancel\n              </button-primary>\n              <button-primary\n                ng-type="submit"\n                ng-disabled="!form.data.startDate">\n                Submit\n              </button-primary>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>'
};

/***/ }),

/***/ "ZID5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
// Action Types
var SET_THEME = '@@app/theme/SET_THEME';
var SET_NAV_TYPE = '@@app/theme/SET_NAV_TYPE';
var SET_NAV_MAIN = '@@app/theme/SET_NAV_MAIN';
var SET_NAV_CHILDREN = '@@app/theme/SET_NAV_CHILDREN';

// Initial State
var initialState = {
  base: 'theme-base-weekly',
  slug: 'theme-weekly',
  navType: 'plain',
  navMain: [],
  navChildren: []
};

var mainItems = {
  dashboard: {
    title: 'Home',
    path: 'dashboard'
  },
  recipes: {
    title: 'Recipes',
    path: 'nutrition.recipes'
  },
  mealPlans: {
    title: 'Meal Plans',
    path: 'nutrition.mealPlans'
  },
  hacks: {
    title: 'Tips',
    path: 'nutrition.hacks'
  },
  favouritesRecipes: {
    title: 'Favourite Recipes',
    path: 'nutrition.favouritesRecipes'
  }
};

// Actions
var setTheme = exports.setTheme = function setTheme(isWeekly, slug, status) {
  var isWorkout = slug.includes('workout');
  // const isNutrition = slug.includes('nutrition');

  var dashboard = _extends({}, mainItems.dashboard);

  var recipes = _extends({}, mainItems.recipes);

  var mealPlans = _extends({}, mainItems.mealPlans);

  var hacks = _extends({}, mainItems.hacks);

  var favouritesRecipes = _extends({}, mainItems.favouritesRecipes);

  return {
    type: SET_THEME,
    payload: {
      base: 'theme-base-' + (isWeekly ? 'weekly' : 'program'),
      slug: 'theme-' + (isWeekly ? 'weekly' : slug),
      navMain: isWeekly && !/cancelled|suspended/.test(status) ? isWorkout ? [dashboard, recipes, mealPlans, hacks, favouritesRecipes] : [dashboard, recipes, mealPlans, hacks, favouritesRecipes] : []
    }
  };
};

var setNavType = exports.setNavType = function setNavType(navType) {
  return { type: SET_NAV_TYPE, payload: { navType: navType } };
};

var setNavChildren = exports.setNavChildren = function setNavChildren(key) {
  var subscriptionTitle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var items = childItems[key] || [];

  var navChildren = /Workouts|Nutrition/.test(subscriptionTitle) ? items.filter(function (item) {
    return item.subscriptionTitle === subscriptionTitle;
  }) : items;

  return {
    type: SET_NAV_CHILDREN,
    payload: { navChildren: navChildren }
  };
};

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case SET_THEME:
      return _extends({}, state, {
        base: payload.base,
        slug: payload.slug,
        navMain: payload.navMain
      });

    case SET_NAV_TYPE:
      return _extends({}, state, {
        navType: payload.navType
      });

    case SET_NAV_CHILDREN:
      return _extends({}, state, {
        navChildren: payload.navChildren
      });

    default:
      return _extends({}, state);
  }
}

/***/ }),

/***/ "ZKJ1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CardVideo = exports.CardVideo = {
  bindings: {
    durationInMins: '<',
    heading: '<',
    image: '<',
    isFavourite: '<',
    onClick: '&',
    onFavourite: '&'
  },

  template: '\n    <div class="card-video card-wrapper pointer"\n      id="{{ $ctrl.heading | kebabCase }}">\n      <card\n        heading="$ctrl.heading"\n        img="$ctrl.image"\n        is-favourite="$ctrl.isFavourite"\n        on-click="$ctrl.onClick()"\n        on-favourite="$ctrl.onFavourite()">\n        <badges>\n          <button-play></button-play>\n        </badges>\n        <footer-left ng-if="$ctrl.durationInMins >= 0">\n          <i class="icon icon-time"></i>\n          <span>{{ $ctrl.durationInMins }} min</span>\n        </footer-left>\n      </card>\n    </div>'
};

/***/ }),

/***/ "ZTBt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleFiltersIsActive = exports.fetchFiltersWorkouts = exports.fetchFiltersRecipes = exports.updateFiltersCheckbox = exports.updateFiltersRadio = exports.updateFilters = exports.toString = exports.toArray = exports.setChecked = exports.isChecked = exports.selectFiltersVideosChecked = exports.selectFiltersVideosGrouped = exports.selectFiltersVideos = exports.selectFiltersWorkoutsGrouped = exports.selectFiltersWorkoutsChecked = exports.selectFiltersWorkouts = exports.selectFiltersServes = exports.selectFiltersRecipesGrouped = exports.selectFiltersRecipesChecked = exports.selectFiltersRecipes = exports.selectFiltersChecked = exports.selectSortByVideos = exports.selectSortByWorkouts = exports.selectSortByRecipes = exports.selectSort = exports.selectFilters = exports.filtersLogic = exports.initialState = undefined;

var _reject2 = __webpack_require__("YqDm");

var _reject3 = _interopRequireDefault(_reject2);

var _includes2 = __webpack_require__("q+Dy");

var _includes3 = _interopRequireDefault(_includes2);

var _groupBy2 = __webpack_require__("swUc");

var _groupBy3 = _interopRequireDefault(_groupBy2);

var _find2 = __webpack_require__("kbi+");

var _find3 = _interopRequireDefault(_find2);

var _filter2 = __webpack_require__("RyI1");

var _filter3 = _interopRequireDefault(_filter2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;

var _reduxLogic = __webpack_require__("E0Bt");

var _reduxUiRouter = __webpack_require__("Zb/7");

var _reduxUiRouter2 = _interopRequireDefault(_reduxUiRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Action Types
var CANCEL = '@@app/filters/CANCEL';
var FETCH = '@@app/filters/FETCH';
var FETCH_SUCCESS = '@@app/filters/FETCH_SUCCESS';
var FETCH_ERROR = '@@app/filters/FETCH_ERROR';
var TOGGLE_IS_ACTIVE = '@@app/filters/TOGGLE_IS_ACTIVE';

// Initial State
var initialState = exports.initialState = {
  loading: false,
  isActive: false,
  message: '',
  recipes: [],
  workouts: [],
  videos: [{ name: 'Cardio', key: 'type', value: 'cardio' }, { name: 'Strength', key: 'type', value: 'strength' }, { name: 'Stretch', key: 'type', value: 'stretch' }, { name: 'Dance', key: 'type', value: 'dance' }, { name: 'Equipment Required', key: 'equipmentRequired', value: '1' }, { name: 'No Equipment', key: 'equipmentRequired', value: '0' }, { name: 'Full Length', key: 'time', value: 'full length' }, { name: 'Blaster', key: 'time', value: 'blaster' }],
  serves: [{ id: 1, name: '1 serve', type: 'Serves' }, { id: 2, name: '2 serves', type: 'Serves' }, { id: 3, name: '3 serves', type: 'Serves' }, { id: 4, name: '4 serves', type: 'Serves' }, { id: 5, name: '> 4 serves', type: 'Serves' }],
  order: {
    recipes: [{ id: 1, name: 'Our Picks', value: 'our_picks' }, { id: 2, name: 'Popular', value: 'popular' }, { id: 3, name: 'Name', value: 'name' }, { id: 4, name: 'Time', value: 'time_asc' }, { id: 5, name: 'Newest', value: 'new' }],
    workouts: [{ id: 6, name: 'Our Picks', value: 'our_picks' }, { id: 7, name: 'Name', value: 'name' }, { id: 8, name: 'Newest', value: 'new' }, { id: 9, name: 'Shortest', value: 'time_asc' }, { id: 10, name: 'Longest', value: 'time_desc' }, { id: 11, name: 'Low Intensity', value: 'intensity_asc' }, { id: 12, name: 'High Intensity', value: 'intensity_desc' }],
    videos: [{ id: 13, name: 'Our Picks', value: 'our_picks' }, { id: 14, name: 'Popular', value: 'popular' }, { id: 15, name: 'Name', value: 'name' }, { id: 16, name: 'Newest', value: 'new' }, { id: 17, name: 'Shortest', value: 'time_asc' }, { id: 18, name: 'Longest', value: 'time_desc' }]
  }
};

// Observables
var fetchLogic = (0, _reduxLogic.createLogic)({
  type: FETCH,
  cancelType: CANCEL,
  processOptions: {
    successType: FETCH_SUCCESS,
    failType: FETCH_ERROR
  },
  process: function process(_ref) {
    var action = _ref.action,
        getState = _ref.getState,
        httpClient = _ref.httpClient;
    var _action$payload = action.payload,
        endpoint = _action$payload.endpoint,
        key = _action$payload.key;


    return httpClient.get(endpoint).then(function (_ref2) {
      var data = _ref2.data;

      return { data: data, key: key };
    });
  }
});

var filtersLogic = exports.filtersLogic = [fetchLogic];

// Selectors
var selectFilters = exports.selectFilters = function selectFilters(state, key, checked) {
  return state[key].map(function (item) {
    return setChecked(item, 'id', toArray(checked));
  });
};

var selectSort = exports.selectSort = function selectSort(state) {
  var checked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'our_picks';
  var key = arguments[2];

  return state.order[key].map(function (item) {
    return setChecked(item, 'value', [checked]);
  });
};

var selectSortByRecipes = exports.selectSortByRecipes = function selectSortByRecipes(state, checked) {
  return selectSort(state, checked, 'recipes');
};

var selectSortByWorkouts = exports.selectSortByWorkouts = function selectSortByWorkouts(state, checked) {
  return selectSort(state, checked, 'workouts');
};

var selectSortByVideos = exports.selectSortByVideos = function selectSortByVideos(state, checked) {
  return selectSort(state, checked, 'videos');
};

var selectFiltersChecked = exports.selectFiltersChecked = function selectFiltersChecked(state, key, filters, serves) {
  var checked = [];

  if (filters) {
    var ids = filters.split(',').map(function (i) {
      return parseInt(i, 10);
    });
    checked = (0, _reject3.default)(state[key], function (item) {
      return ids.indexOf(item.id) < 0;
    });
  }

  if (serves) {
    var serving = (0, _find3.default)(state.serves, ['id', parseInt(serves)]);
    checked.push(serving);
  }

  return checked;
};

var selectFiltersRecipes = exports.selectFiltersRecipes = function selectFiltersRecipes(state, checked) {
  return selectFilters(state, 'recipes', checked);
};

var selectFiltersRecipesChecked = exports.selectFiltersRecipesChecked = function selectFiltersRecipesChecked(state, filters, serves) {
  return selectFiltersChecked(state, 'recipes', filters, serves);
};

var selectFiltersRecipesGrouped = exports.selectFiltersRecipesGrouped = function selectFiltersRecipesGrouped(state, checkedRecipes, checkedServes) {
  return _extends({}, (0, _groupBy3.default)(selectFiltersRecipes(state, checkedRecipes), 'type'), {
    Serves: selectFiltersServes(state, checkedServes)
  });
};

var selectFiltersServes = exports.selectFiltersServes = function selectFiltersServes(state, checked) {
  return selectFilters(state, 'serves', checked);
};

var selectFiltersWorkouts = exports.selectFiltersWorkouts = function selectFiltersWorkouts(state, checked) {
  return selectFilters(state, 'workouts', checked);
};

var selectFiltersWorkoutsChecked = exports.selectFiltersWorkoutsChecked = function selectFiltersWorkoutsChecked(state, filters) {
  return selectFiltersChecked(state, 'workouts', filters);
};

var selectFiltersWorkoutsGrouped = exports.selectFiltersWorkoutsGrouped = function selectFiltersWorkoutsGrouped(state, checkedWorkouts) {
  return (0, _groupBy3.default)(selectFiltersWorkouts(state, checkedWorkouts), 'type');
};

var selectFiltersVideos = exports.selectFiltersVideos = function selectFiltersVideos(state, params) {
  return state.videos.map(function (filter) {
    return _extends({}, filter, {
      checked: (0, _includes3.default)(params, filter.value)
    });
  });
};

var selectFiltersVideosGrouped = exports.selectFiltersVideosGrouped = function selectFiltersVideosGrouped(state, params) {
  return (0, _groupBy3.default)(selectFiltersVideos(state, params), 'key');
};

var selectFiltersVideosChecked = exports.selectFiltersVideosChecked = function selectFiltersVideosChecked(state, params) {
  return (0, _filter3.default)(selectFiltersVideos(state, params), 'checked');
};

// Helpers
var isChecked = exports.isChecked = function isChecked(key, array) {
  return array.indexOf(key) >= 0;
};

var setChecked = exports.setChecked = function setChecked(item, key, checkedIds) {
  return _extends({}, item, {
    checked: isChecked(item[key], checkedIds)
  });
};

var toArray = exports.toArray = function toArray(filters) {
  if (typeof filters === 'string' && filters.length) {
    return filters.split(',').map(Number);
  }

  return [];
};

var toString = exports.toString = function toString(filters) {
  return filters.join(',');
};

var updateFilters = exports.updateFilters = function updateFilters(id, type, params) {
  var list = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  var checkedIds = toArray(params);

  if (type === 'radio') {
    return toString(updateFiltersRadio(id, checkedIds, list));
  } else {
    return toString(updateFiltersCheckbox(id, checkedIds));
  }
};

var updateFiltersRadio = exports.updateFiltersRadio = function updateFiltersRadio(id, checkedIds) {
  var radioGroup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var inRadioGroup = function inRadioGroup(filterId) {
    return (0, _find3.default)(radioGroup, ['id', filterId]);
  };
  var filteredIds = (0, _reject3.default)(checkedIds, inRadioGroup);

  return isChecked(id, checkedIds) ? checkedIds.filter(function (i) {
    return i !== id;
  }) : [].concat(_toConsumableArray(filteredIds), [id]);
};

var updateFiltersCheckbox = exports.updateFiltersCheckbox = function updateFiltersCheckbox(id, checkedIds) {
  return isChecked(id, checkedIds) ? checkedIds.filter(function (i) {
    return i !== id;
  }) : [].concat(_toConsumableArray(checkedIds), [id]);
};

// Action Creators
var fetchFiltersRecipes = exports.fetchFiltersRecipes = function fetchFiltersRecipes() {
  return {
    type: FETCH,
    payload: {
      endpoint: '/v1/voome/recipe-categories',
      key: 'recipes'
    }
  };
};

var fetchFiltersWorkouts = exports.fetchFiltersWorkouts = function fetchFiltersWorkouts() {
  return {
    type: FETCH,
    payload: {
      endpoint: '/v1/voome/workout-collections/filters',
      key: 'workouts'
    }
  };
};

var toggleFiltersIsActive = exports.toggleFiltersIsActive = function toggleFiltersIsActive() {
  return { type: TOGGLE_IS_ACTIVE };
};

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case FETCH:
      return _extends({}, state, {
        loading: true,
        message: ''
      });

    case FETCH_SUCCESS:
      return _extends({}, state, _defineProperty({
        loading: false
      }, payload.key, payload.data));

    case FETCH_ERROR:
      return _extends({}, state, {
        loading: false,
        message: 'An error occured fetching the filters.'
      });

    case TOGGLE_IS_ACTIVE:
      return _extends({}, state, {
        isActive: !state.isActive
      });

    default:
      return state;
  }
}

/***/ }),

/***/ "Zv82":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CollectionHeader = exports.CollectionHeader = {
  bindings: {
    collection: '<',
    isLoading: '<'
  },

  template: '\n    <div class="collection-header bg-white"\n      ng-class="{ \'active\': $ctrl.readMore }"\n      ng-init="$ctrl.readMore = false">\n      <div class="content-wrapper container py-3 pt-md-5">\n        <div class="header-img bg-mask-overlay bg-mask-overlay--lg position-md-absolute">\n          <image-background src="$ctrl.collection.coverImageUrl.magazine"></image-background>\n        </div>\n        <div class="row">\n          <div class="col-md-8 collapse-left">\n            <section class="pb-3">\n              <header class="card-title mb-4">\n              <h3 class="h3 mt-2 mt-sm-0">\n                <spinner is-loading="$ctrl.isLoading">\n                  {{ $ctrl.collection.title || \'Loading...\' }}\n                </spinner>\n              </h3>\n              <p class="lead">{{ $ctrl.collection.strapLine }}</p>\n              </header>\n              <div class="lead my-3 pt-3 border border-y border-blue-cz text-blue-cz-mid"\n                ng-bind-html="$ctrl.collection.skimHtml"\n                ng-if="$ctrl.collection.skimHtml">\n              </div>\n              <div ng-bind-html="$ctrl.collection.theWhatHtml"></div>\n              <div ng-bind-html="$ctrl.collection.theWhyHtml"></div>\n            </section>\n          </div>\n          <div class="col-md-4 collapse-right pr-0">\n            <section class="bg-cz-theme text-white p-3"\n              ng-bind-html="$ctrl.collection.theElseHtml">\n            </section>\n          </div>\n        </div>\n      </div>\n      <div class="toggle-row"\n        ng-class="{\n          \'bg-white\': !$ctrl.readMore,\n          \'position-relative pt-0\': $ctrl.readMore\n        }">\n        <div class="container">\n          <button-link ng-click="$ctrl.readMore = !$ctrl.readMore">\n            Read\n            <span ng-if="!$ctrl.readMore">more <i class="fa -down"></i></span>\n            <span ng-if="$ctrl.readMore">less <i class="fa -up"></i></span>\n          </button-link>\n        </div>\n      </div>\n    </div>'
};

/***/ }),

/***/ "a7WM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MealPlanDayIcon = exports.MealPlanDayIcon = {
  transclude: true,

  bindings: {
    count: '<',
    isSwapping: '<',
    isActive: '<'
  },

  template: '\n    <div class="meal-plan-day-icon text-white"\n      ng-class="{ \'bg-cz-theme-tertiary\': $ctrl.isActive }">\n      <span class="text-uppercase ml-1"\n        ng-hide="$ctrl.isSwapping"\n        ng-transclude>\n      </span>\n      <small>\n        <i ng-show="$ctrl.isSwapping" class="fa fa-refresh fa-spin fa-2x"></i>\n      </small>\n      <span class="badge badge-pill badge-success text-center">\n         {{ $ctrl.count }}\n      </span>\n    </div>\n  </div>'
};

/***/ }),

/***/ "aFSo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NutritionInformation = exports.NutritionBmi = undefined;

var _NutritionBmi = __webpack_require__("jNVY");

Object.defineProperty(exports, 'NutritionBmi', {
  enumerable: true,
  get: function get() {
    return _NutritionBmi.NutritionBmi;
  }
});

var _NutritionInformation = __webpack_require__("iAmj");

Object.defineProperty(exports, 'NutritionInformation', {
  enumerable: true,
  get: function get() {
    return _NutritionInformation.NutritionInformation;
  }
});

__webpack_require__("8q0z");

/***/ }),

/***/ "aGQT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgramGraduation = undefined;

var _settings = __webpack_require__("Ll2K");

var _member = __webpack_require__("1OIp");

var _product = __webpack_require__("5AvL");

var _reviews = __webpack_require__("jnnR");

var _utils = __webpack_require__("0xDb");

var ProgramGraduation = exports.ProgramGraduation = {
  template: '\n    <section class="program-graduation">\n      <program-nav></program-nav>\n      <section class="py-3 py-md-5 mt-3 mt-md-0 overview">\n        <div class="container">\n          <div class="row">\n            <div class="col-lg-6 mx-auto">\n              <video-player-resumable\n                video-id="$ctrl.program.productMeta.graduationVideo.brightcoveId || $ctrl.program.productMeta.introVideo.brightcoveId">\n              </video-player-resumable>\n            </div>\n            <div class="col-lg-6 mx-auto">\n              <h2 class="heading h1">\n                <span ng-if="$ctrl.member.screenName">\n                  {{ $ctrl.member.screenName }},\n                </span>\n                you have come so far in {{ $ctrl.program.weeks.length }} weeks!\n              </h2>\n              <p ng-bind="$ctrl.program.productMeta.graduationMessage"></p>\n              <ul class="trophy-cabinet trophy-cabinet--bordered fa-ul ml-0">\n                <li ng-repeat="item in $ctrl.graduationData.achievements track by $index">\n                  <i class="fa-li fa fa-trophy"></i> {{ item }}\n                </li>\n              </ul>\n            </div>\n          </div>\n        </div>\n        <div id="confetti-widget"></div>\n      </section>\n      <section class="py-3 py-md-5 bg-gray-100">\n        <div class="graduation-more-programs container text-center">\n          <header>\n            <h3 class="mb-0">Love {{ $ctrl.program.name }}?</h3>\n            <p>Why not try something new:</p>\n          </header>\n          <div class="row justify-content-center">\n            <div class="col-md-6 p-0 graduation-tile-divider">\n              <div class="bg-img-voome-programs">\n                <div class="graduation-more-tile bg-darken p-0">\n                  <span class="logo logo-voome-programs"></span>\n                  <div class="bg-white w-100 px-3 py-5">\n                    <div class="row justify-content-center">\n                      <p>\n                        Short 4-week step-by-step programs led by an expert\n                        trainer. Each program includes 3x 30 minute workouts per\n                        week, and meal plans to complement your training. Access\n                        forever, for only $39.95.\n                      </p>\n                    </div>\n                    <a class="btn theme-btn theme-btn--inverse rounded w-100"\n                      href="' + _settings.hosts.public + '/programs">\n                      <span>View all Coaching Zone Programs ></span>\n                    </a>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-6 p-0">\n              <div class="bg-img-voome">\n                <div class="graduation-more-tile bg-darken p-0">\n                  <span class="logo logo-voome-weekly"></span>\n                  <div class="bg-white w-100 px-3 py-5">\n                    <div class="row justify-content-center">\n                      <p>\n                        A workout and meal planning tool which gives you access\n                        to over 1000 recipes and over 150 workouts to create\n                        your own weekly health plan. 24/7 access for only $6.99\n                        per week. Cancel anytime.\n                      </p>\n                    </div>\n                    <a class="btn theme-btn theme-btn--inverse rounded w-100"\n                      href="' + _settings.hosts.public + '">\n                      <span>Find out more ></span>\n                    </a>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </section>\n      <button-full-width\n        modal-target="#modalRestartProgram">\n        <span>Loved {{ $ctrl.program.name }}? Restart Now!</span>\n      </button-full-width>\n      <div class="my-3 my-md-5 container">\n        <div class="row">\n          <div class="col-md-8 mb-5">\n            <div class="graduation-certificate theme-program-graduation theme-border text-center">\n              <div class="certificate-content px-3 px-md-4">\n                <div class="d-flex justify-content-center mb-md-3">\n                  <image-circle src="$ctrl.member.profile.avatarUrl.thumb">\n                  </image-circle>\n                </div>\n                <h4 class="heading">\n                  I just smashed the Coaching Zone Program\n                </h4>\n                <h2 class="theme-program-logo theme-program-logo--dark my-1 my-md-3 mx-3">\n                  <span class="text-white">{{ $ctrl.program.name }}</span>\n                </h2>\n                <ul class="trophy-cabinet trophy-cabinet text-left fa-ul ml-0 mb-2">\n                  <li ng-repeat="item in $ctrl.graduationData.achievements track by $index">\n                    <i class="fa-li fa fa-trophy"></i> {{ item }}\n                  </li>\n                </ul>\n              </div>\n              <div class="certificate-logo navbar-brand">\n                <nav-logo></nav-logo>\n              </div>\n            </div>\n          </div>\n          <div class="col-md-4 text-center">\n            <div class="graduation-feedback">\n              <div class="share-icon">\n                <i class="fa fa-heart"></i> 1\n              </div>\n              <h4>\n                Screenshot and share your success!\n              </h4>\n              <p class="mb-0">\n                You\'ve just smashed through a 4 Week Coaching Zone Program!! Screenshot\n                and share this image to inspire your friends, using the hashtag.\n                <b>{{ $ctrl.graduationData.hashtag }}</b>\n              </p>\n            </div>\n            <div class="graduation-feedback">\n              <div class="rate-us-stars d-flex justify-content-center align-items-center">\n                <i class="fa fa-star" ng-repeat="n in [1,2,3,4,5] track by $index"></i>\n              </div>\n              <h4>\n                How do you rate this program?\n              </h4>\n              <p>\n                We think you\'re 5 stars.<br>\n                How many stars would you give us?\n              </p>\n              <button-link data-toggle="modal" data-target="#modalFeedback">\n                Rate us now\n              </button-link>\n              <modal target="modalFeedback">\n                <modal-title>\n                  <span ng-hide="$ctrl.hasReviewed">Give us feedback</span>\n                  <span ng-show="$ctrl.hasReviewed">Thank you!</span>\n                </modal-title>\n                <modal-body>\n                  <form-feedback\n                    is-complete="$ctrl.hasReviewed"\n                    on-submit="$ctrl.createProgramReview(\n                      $ctrl.member.id,\n                      $ctrl.voomeProductId,\n                      data.description,\n                      data.rating\n                    )">\n                  </form-feedback>\n                </modal-body>\n              </modal>\n            </div>\n          </div>\n        </div>\n      </div>\n    </section>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.unsubscribe = connect(this);
        (0, _utils.confettiWidget)().startAnimation();
      },
      $onDestroy: function $onDestroy() {
        this.unsubscribe();
        (0, _utils.confettiWidget)().cancelAnimation();
      },
      mapState: function mapState(_ref) {
        var member = _ref.member,
            product = _ref.product,
            reviews = _ref.reviews,
            router = _ref.router;
        var voomeProductId = router.currentParams.voomeProductId;
        var hasReviewed = reviews.hasReviewed;

        var program = (0, _product.selectProduct)(product);

        return {
          program: program,
          hasReviewed: hasReviewed,
          voomeProductId: voomeProductId,
          graduationData: (0, _product.getGraduationData)(program.name),
          member: (0, _member.selectMember)(member)
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          createProgramReview: _reviews.createProgramReview
        };
      }
    };
  }]
};

/***/ }),

/***/ "as7P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectShoppingListMeta = exports.selectShoppingListIsLoading = exports.selectShoppingListHasChecked = exports.selectShoppingListChecked = exports.selectShoppingList = exports.shoppingListUncheckAll = exports.shoppingListToggleCheck = exports.shoppingListFetch = exports.shoppingListLogic = exports.initialState = undefined;

var _size2 = __webpack_require__("4Fgk");

var _size3 = _interopRequireDefault(_size2);

var _mapValues2 = __webpack_require__("94Kh");

var _mapValues3 = _interopRequireDefault(_mapValues2);

var _flatMap2 = __webpack_require__("nfWN");

var _flatMap3 = _interopRequireDefault(_flatMap2);

var _find2 = __webpack_require__("kbi+");

var _find3 = _interopRequireDefault(_find2);

var _filter2 = __webpack_require__("RyI1");

var _filter3 = _interopRequireDefault(_filter2);

var _each2 = __webpack_require__("9uKM");

var _each3 = _interopRequireDefault(_each2);

var _countBy2 = __webpack_require__("X5N3");

var _countBy3 = _interopRequireDefault(_countBy2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;

var _reduxLogic = __webpack_require__("E0Bt");

var _normalizr = __webpack_require__("vNPR");

var _humps = __webpack_require__("qJdz");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Action Types
var FETCH = '@@app/shopping-list/FETCH';
var FETCH_SUCCESS = '@@app/shopping-list/FETCH_SUCCESS';
var FETCH_ERROR = '@@app/shopping-list/FETCH_ERROR';

var TOGGLE = '@@app/shopping-list/TOGGLE';
var TOGGLE_SUCCESS = '@@app/shopping-list/TOGGLE_SUCCESS';
var TOGGLE_ERROR = '@@app/shopping-list/TOGGLE_ERROR';

var UNCHECK_ALL = '@@app/shopping-list/UNCHECK_ALL';
var UNCHECK_SUCCESS = '@@app/shopping-list/UNCHECK_SUCCESS';
var UNCHECK_ERROR = '@@app/shopping-list/UNCHECK_ERROR';

// Initial State
var initialState = exports.initialState = {
  isLoading: false,
  entities: {},
  checked: []
};

// Observables
var fetchLogic = (0, _reduxLogic.createLogic)({
  type: FETCH,
  name: 'shoppingListFetchLogic',
  processOptions: {
    successType: FETCH_SUCCESS,
    failType: FETCH_ERROR
  },
  process: function process(_ref) {
    var action = _ref.action,
        httpClient = _ref.httpClient;
    var _action$payload = action.payload,
        level = _action$payload.level,
        memberId = _action$payload.memberId,
        recipeIds = _action$payload.recipeIds,
        sort = _action$payload.sort;

    var endpoint = '/v2/shopping-lists/by-' + sort;
    var params = { level: level, memberId: memberId, recipeIds: recipeIds };

    return httpClient.get(endpoint, { skipCamelize: true, params: params }).then(function (_ref2) {
      var data = _ref2.data;

      return (0, _mapValues3.default)(data, function (ingredients) {
        return (0, _humps.camelizeKeys)(ingredients);
      });
    });
  }
});

var fetchSuccessLogic = (0, _reduxLogic.createLogic)({
  type: FETCH_SUCCESS,
  name: 'shoppingListFetchSuccessLogic',
  transform: function transform(_ref3, next) {
    var action = _ref3.action;

    var payload = action.payload;
    var checked = {};

    (0, _each3.default)((0, _filter3.default)((0, _flatMap3.default)(payload), { checked: true }), function (item) {
      checked[item.foodId] = true;
    });

    next(_extends({}, action, { payload: { entities: payload, checked: checked } }));
  }
});

var toggleLogic = (0, _reduxLogic.createLogic)({
  type: TOGGLE,
  name: 'shoppingListToggleLogic',
  processOptions: {
    successType: TOGGLE_SUCCESS,
    failType: TOGGLE_ERROR
  },
  process: function process(_ref4) {
    var action = _ref4.action,
        httpClient = _ref4.httpClient;
    var _action$payload2 = action.payload,
        food = _action$payload2.food,
        memberId = _action$payload2.memberId;
    var foodId = food.foodId,
        checked = food.checked;

    var type = checked ? 'uncheck' : 'check';
    var endpoint = '/v2/shopping-lists/' + type + '-ingredient?member_id=' + memberId + '&food_id=' + foodId;

    return httpClient.put(endpoint).then(function () {
      return food;
    });
  }
});

var uncheckAllLogic = (0, _reduxLogic.createLogic)({
  type: UNCHECK_ALL,
  name: 'shoppingListUncheckAllLogic',
  processOptions: {
    successType: UNCHECK_SUCCESS,
    failType: UNCHECK_ERROR
  },
  process: function process(_ref5) {
    var action = _ref5.action,
        getState = _ref5.getState,
        httpClient = _ref5.httpClient;
    var memberId = action.payload.memberId;

    var endpoint = '/v2/shopping-lists/uncheck-all-ingredients?member_id=' + memberId;

    return httpClient.put(endpoint).then(function () {
      return action.payload;
    });
  }
});

var shoppingListLogic = exports.shoppingListLogic = [fetchLogic, fetchSuccessLogic, toggleLogic, uncheckAllLogic];

// Action Creators
var shoppingListFetch = exports.shoppingListFetch = function shoppingListFetch(recipeIds, memberId) {
  var sort = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'category';
  var level = arguments[3];

  return { type: FETCH, payload: { recipeIds: recipeIds, memberId: memberId, sort: sort, level: level } };
};

var shoppingListToggleCheck = exports.shoppingListToggleCheck = function shoppingListToggleCheck(food, memberId) {
  return { type: TOGGLE, payload: { food: food, memberId: memberId } };
};

var shoppingListUncheckAll = exports.shoppingListUncheckAll = function shoppingListUncheckAll(memberId) {
  return { type: UNCHECK_ALL, payload: { memberId: memberId } };
};

// Selectors
var selectShoppingList = exports.selectShoppingList = function selectShoppingList(state) {
  return state.entities;
};

var selectShoppingListChecked = exports.selectShoppingListChecked = function selectShoppingListChecked(state) {
  return state.checked;
};

var selectShoppingListHasChecked = exports.selectShoppingListHasChecked = function selectShoppingListHasChecked(state) {
  return (0, _size3.default)(selectShoppingListChecked(state)) > 0;
};

var selectShoppingListIsLoading = exports.selectShoppingListIsLoading = function selectShoppingListIsLoading(state) {
  return state.isLoading;
};

var selectShoppingListMeta = exports.selectShoppingListMeta = function selectShoppingListMeta(state, recipes) {
  return (0, _mapValues3.default)(state.entities, function (value, name) {
    return {
      serves: ((0, _find3.default)(recipes, { name: name }) || {}).serves || 0,
      count: (0, _countBy3.default)(recipes, { name: name }).true
    };
  });
};

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case FETCH:
      return _extends({}, state, {
        isLoading: true
      });

    case FETCH_SUCCESS:
      return _extends({}, state, payload, {
        isLoading: false
      });

    case TOGGLE:
    case UNCHECK_ALL:
      return _extends({}, state, {
        isChecking: true
      });

    case TOGGLE_SUCCESS:
      var checked = _extends({}, state.checked);

      if (checked[payload.foodId]) {
        delete checked[payload.foodId];
      } else {
        checked[payload.foodId] = true;
      }

      return _extends({}, state, {
        checked: checked,
        isChecking: false
      });

    case UNCHECK_SUCCESS:
      return _extends({}, state, {
        checked: {},
        isChecking: false
      });

    default:
      return state;
  }
}

/***/ }),

/***/ "avPJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MealPlanRecipeSwap = exports.MealPlanRecipeSwap = {
  bindings: {
    meal: '<',
    voomeProductId: '<',
    isProductLowFodmap: '<',
    onSwap: '&',
    onRemove: '&',
    onRevert: '&',
    onPreview: '&',
    onLearnMore: '&'
  },

  template: '\n    <div class="meal-plan-recipe-row">\n      <recipe-row\n        recipe="($ctrl.meal.recipeId && $ctrl.meal.recipe) || $ctrl.meal.originalRecipe"\n        left-overs="$ctrl.meal.leftOvers"\n        cookup="$ctrl.meal.cookup"\n        disabled="!$ctrl.meal.recipeId"\n        on-preview="$ctrl.onPreview({ recipe: recipe })">\n        <button class="btn btn-pill btn-sm theme-btn"\n          type="button"\n          ng-click="$ctrl.loadSwaps = true; $ctrl.showSwaps = !$ctrl.showSwaps">\n          <span ng-hide="$ctrl.showSwaps">Swap</span>\n          <span ng-show="$ctrl.showSwaps">Done</span>\n        </button>\n      </recipe-row>\n    </div>\n    <div class="py-4 bg-gray-100"\n      ng-show="$ctrl.showSwaps"\n      ng-if="$ctrl.loadSwaps">\n      <p class="meal-plan-swap-instruction text-md-center mb-2">\n        <b class="d-block d-md-inline">\n          Looking for something different?\n        </b>\n        <span ng-hide="$ctrl.isSwapped">\n          Swap this week\'s {{ $ctrl.meal.recipe.name }}\n        </span>\n      </p>\n      <div class="meal-plan-swap-scroll">\n        <meal-plan-swaps\n          voome-product-id="$ctrl.voomeProductId"\n          recipe="$ctrl.meal.originalRecipe || $ctrl.meal.recipe"\n          selected="$ctrl.meal.recipeId && $ctrl.meal.recipe"\n          on-preview="$ctrl.onPreview({ recipe: recipe })"\n          on-remove="$ctrl.onRemove({ meal: $ctrl.meal })"\n          on-revert="$ctrl.onRevert({ meal: $ctrl.meal })"\n          on-swap="$ctrl.onSwap({\n            mealPlanRecipeId: $ctrl.meal.id,\n            recipeContainerId: recipeContainerId\n          })">\n        </meal-plan-swaps>\n        <div class="text-center bg-green-light py-4 mt-3"\n          ng-if="!$ctrl.isProductLowFodmap">\n          <h4>Want over 1000 recipes to choose from?</h4>\n          <h5 class="mb-0">\n            Subscribe to Coaching Zone Nutrition today.\n            <a href="/nutrition" ng-click="$ctrl.onLearnMore()">Learn more</a>\n          </h5>\n        </div>\n      </div>\n    </div>'
};

/***/ }),

/***/ "bDkE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHARGIFY_ERROR_CODES = exports.CREDIT_CARD_FIELDS = exports.SIGNUP_FIELDS = exports.SIGNUP_FIELDS_SECURE = exports.SIGNUP_REDIRECT_LIST = exports.SIGNUP_TEXT_COUPON = exports.SIGNUP_TEXT = exports.CREDIT_CARD_REDIRECT_URI = exports.SIGNUP_REDIRECT_URI = exports.SIGNUP_IS_DEV = exports.SIGNUP_YEARS = exports.SIGNUP_MONTHS = exports.SIGNUP_TYPES = undefined;

var _range2 = __webpack_require__("tVBY");

var _range3 = _interopRequireDefault(_range2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _settings = __webpack_require__("Ll2K");

var _timeFormat = __webpack_require__("RxC4");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var SIGNUP_TYPES = exports.SIGNUP_TYPES = ['program', 'bundle', 'nutrition', 'workouts'];
var SIGNUP_MONTHS = exports.SIGNUP_MONTHS = (0, _range3.default)(1, 13);
var SIGNUP_YEARS = exports.SIGNUP_YEARS = (0, _range3.default)(_timeFormat.yearDigits, _timeFormat.yearDigits + 11);
var SIGNUP_IS_DEV = exports.SIGNUP_IS_DEV = "production" === 'development';
var SIGNUP_REDIRECT_URI = exports.SIGNUP_REDIRECT_URI = _settings.hosts.go + '/sign-up/verify';
var CREDIT_CARD_REDIRECT_URI = exports.CREDIT_CARD_REDIRECT_URI = _settings.hosts.go + '/profile/credit-card/verify';

var SIGNUP_TEXT = exports.SIGNUP_TEXT = {
  program: {
    title: 'Purchase a Coaching Zone Program',
    discountText: 'Use your Coaching Zone Nutrition or Coaching Zone Workouts login and receive <strong>15%</strong> off.',
    discountApplied: 'Coaching Zone member discount applied.',
    firstPaymentInDays: 0,
    included: ['Yours to keep', 'Start anytime', 'Exercise and nutrition', 'Designed by experts']
  },

  weekly: {
    title: 'Sign up to Coaching Zone',
    byline: 'First week free. No contract, cancel any time.',
    firstPaymentInDays: 7,
    included: ['First week free', 'No contract, cancel any time', 'Huge library of recipes and workouts', 'Weekly insights from our expert team', 'From the same team that brought you 12WBT'],
    'Coaching Zone Workouts': {
      abbrev: 'Wo',
      icon: 'icon-workouts',
      byline: 'Workouts with a side of nutrition',
      bundle: 'Add Coaching Zone Nutrition and save 25%.',
      color: 'teal-dark'
    },
    'Coaching Zone Nutrition': {
      abbrev: 'Nu',
      icon: 'icon-recipes',
      byline: 'Nutrition with a side of workouts',
      bundle: 'Add Coaching Zone Workouts and save 25%.',
      color: 'green-mid'
    }
  }
};

var SIGNUP_TEXT_COUPON = exports.SIGNUP_TEXT_COUPON = {
  MPORT: _extends({}, SIGNUP_TEXT.weekly, {
    firstPaymentInDays: 31,
    couponTitle: 'mPort',
    couponTermsUri: 'https://mport.com/terms-and-conditions.html',
    included: ['<strong>Get 1 month free</strong>'].concat(_toConsumableArray(SIGNUP_TEXT.weekly.included.slice(1)))
  }),

  NIMBLE: _extends({}, SIGNUP_TEXT.weekly, {
    firstPaymentInDays: 31,
    couponTitle: 'Nimble',
    couponTermsUri: 'https://nimbleactivewear.com/pages/terms',
    included: ['<strong>Get 1 month free</strong>'].concat(_toConsumableArray(SIGNUP_TEXT.weekly.included.slice(1)))
  }),

  'SUPER-BUNDLE': _extends({}, SIGNUP_TEXT.weekly, {
    couponTitle: 'super-bundle'
  }),

  'PROGRAM-UPGRADE': _extends({}, SIGNUP_TEXT.weekly, {
    couponTitle: 'program-upgrade'
  })
};

var SIGNUP_REDIRECT_LIST = exports.SIGNUP_REDIRECT_LIST = ['PROGRAM-UPGRADE'];

// Chargify Parameters
// https://developer.chargify.com/content/chargify-direct/overview.html#resource-parameters
var SIGNUP_FIELDS_SECURE = exports.SIGNUP_FIELDS_SECURE = {
  apiId: 'secure[api_id]',
  timestamp: 'secure[timestamp]',
  nonce: 'secure[nonce]',
  data: 'secure[data]',
  signature: 'secure[signature]'
};

// Fields required for sign up
var SIGNUP_FIELDS = exports.SIGNUP_FIELDS = _extends({}, SIGNUP_FIELDS_SECURE, {
  email: 'signup[customer][email]',
  firstName: 'signup[customer][first_name]',
  lastName: 'signup[customer][last_name]',
  cardNumber: 'signup[payment_profile][card_number]',
  expirationMonth: 'signup[payment_profile][expiration_month]',
  expirationYear: 'signup[payment_profile][expiration_year]'
});

// Fields required for updating credit card
var CREDIT_CARD_FIELDS = exports.CREDIT_CARD_FIELDS = _extends({}, SIGNUP_FIELDS_SECURE, {
  cardNumber: 'payment_profile[card_number]',
  expirationMonth: 'payment_profile[expiration_month]',
  expirationYear: 'payment_profile[expiration_year]'
});

// Chargify Error Codes
// https://developer.chargify.com/content/chargify-direct/overview.html#result-codes
var CHARGIFY_ERROR_CODES = exports.CHARGIFY_ERROR_CODES = {
  4000: 'Submission error',
  4001: 'Authentiction failed',
  4011: 'Authentication failed due to missing nonce value',
  4040: 'The requested subscription could not be found',
  4220: 'One or more validation errors on input',
  4221: 'Duplicate submission',
  4300: 'Card declined',
  5000: 'An error has occured',
  5001: 'The requested resource does not exist',
  5002: 'Verification error'
};

/***/ }),

/***/ "bGai":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Components = undefined;

var _Alert = __webpack_require__("5tcl");

var _Box = __webpack_require__("0uvG");

var _Carousel = __webpack_require__("1nGQ");

var _Collection = __webpack_require__("AFkJ");

var _Completer = __webpack_require__("JrrQ");

var _CurrentDay = __webpack_require__("/Xzk");

var _Dividers = __webpack_require__("GLK9");

var _Exercise = __webpack_require__("2O33");

var _Favourite = __webpack_require__("zQQk");

var _Footer = __webpack_require__("+qIz");

var _FormFeedback = __webpack_require__("d+HJ");

var _FormLogin = __webpack_require__("11wa");

var _FormResetPassword = __webpack_require__("S101");

var _FormReview = __webpack_require__("BTk+");

var _Image = __webpack_require__("X/jt");

var _Modal = __webpack_require__("/MvA");

var _Nutrition = __webpack_require__("aFSo");

var _Pagination = __webpack_require__("2ZKt");

var _Progress = __webpack_require__("z+Wp");

var _RatingStars = __webpack_require__("9qtj");

var _Review = __webpack_require__("CMyD");

var _ScrollTopOnChange = __webpack_require__("/H0G");

var _Spinner = __webpack_require__("0qr5");

var _TermsConditions = __webpack_require__("J8ve");

var _Validators = __webpack_require__("BZr3");

var _Button = __webpack_require__("AZVq");

var _Card = __webpack_require__("AqLc");

var _Dashboard = __webpack_require__("Xra4");

var _FormElements = __webpack_require__("mDm2");

var _Ingredients = __webpack_require__("qcpF");

var _MealPlan = __webpack_require__("xFdZ");

var _Nav = __webpack_require__("AjmZ");

var _Program = __webpack_require__("liYl");

var _Profile = __webpack_require__("1YcG");

var _Recipe = __webpack_require__("2ft5");

var _Search = __webpack_require__("m0zx");

var _Signup = __webpack_require__("8uL4");

var _SpeechBubble = __webpack_require__("oUay");

var _Video = __webpack_require__("X/VX");

var _WelcomeSteps = __webpack_require__("C+C0");

var _Workout = __webpack_require__("tGHz");

var _WorkoutPlayer = __webpack_require__("0AY2");

var Components = exports.Components = angular.module('App.Components', [])

// Components
.component('alert', _Alert.Alert).component('boxArrowRow', _Box.BoxArrowRow).component('boxCorner', _Box.BoxCorner).component('buttonBack', _Button.ButtonBack).component('buttonBlock', _Button.ButtonBlock).component('buttonFullWidth', _Button.ButtonFullWidth).component('buttonLink', _Button.ButtonLink).component('buttonPlay', _Button.ButtonPlay).component('buttonPrimary', _Button.ButtonPrimary).component('buttonPrint', _Button.ButtonPrint).component('card', _Card.Card).component('cardBadge', _Card.CardBadge).component('cardBadgeFlame', _Card.CardBadgeFlame).component('cardBook', _Card.CardBook).component('cardCollection', _Card.CardCollection).component('cardImage', _Card.CardImage).component('cardPlain', _Card.CardPlain).component('cardRecipe', _Card.CardRecipe).component('cardVideo', _Card.CardVideo).component('cardWorkout', _Card.CardWorkout).component('carousel', _Carousel.Carousel).component('collectionHeader', _Collection.CollectionHeader).component('completer', _Completer.Completer).component('completerNotification', _Completer.CompleterNotification).component('currentDay', _CurrentDay.CurrentDay).component('dashboardCarousel', _Dashboard.DashboardCarousel).component('dashboardNutritionHack', _Dashboard.DashboardNutritionHack).component('dashboardNutritionContainer', _Dashboard.DashboardNutritionContainer).component('dashboardNutritionInspiration', _Dashboard.DashboardNutritionInspiration).component('dashboardNutritionUpgrade', _Dashboard.DashboardNutritionUpgrade).component('dashboardNutritionMealPlan', _Dashboard.DashboardNutritionMealPlan).component('dashboardWorkoutHack', _Dashboard.DashboardWorkoutHack).component('dashboardWorkoutContainer', _Dashboard.DashboardWorkoutContainer).component('dashboardWorkoutInspiration', _Dashboard.DashboardWorkoutInspiration).component('dashboardWorkoutUpgrade', _Dashboard.DashboardWorkoutUpgrade).component('dividerHr', _Dividers.DividerHr).component('dividerZigZag', _Dividers.DividerZigZag).component('exercise', _Exercise.Exercise).component('exerciseSet', _Exercise.ExerciseSet).component('favouriteButton', _Favourite.FavouriteButton).component('favouriteNoResult', _Favourite.FavouriteNoResult).component('footerDashboard', _Footer.FooterDashboard).component('footerMain', _Footer.FooterMain).component('formCheckboxToggle', _FormElements.FormCheckboxToggle).component('formErrors', _FormElements.FormErrors).component('formFieldset', _FormElements.FormFieldset).component('formGroupRow', _FormElements.FormGroupRow).component('formInput', _FormElements.FormInput).component('formLabel', _FormElements.FormLabel).component('formLabelCheckbox', _FormElements.FormLabelCheckbox).component('formRadio', _FormElements.FormRadio).component('formRadioList', _FormElements.FormRadioList).component('formSelect', _FormElements.FormSelect).component('formSelectDate', _FormElements.FormSelectDate).component('formTextarea', _FormElements.FormTextarea).component('formFeedback', _FormFeedback.FormFeedback).component('formLogin', _FormLogin.FormLogin).component('formResetPassword', _FormResetPassword.FormResetPassword).component('formReview', _FormReview.FormReview).component('imageBackground', _Image.ImageBackground).component('imageCircle', _Image.ImageCircle).component('ingredientsList', _Ingredients.IngredientsList).component('ingredientsCheck', _Ingredients.IngredientsCheck).component('ingredientsChecklist', _Ingredients.IngredientsChecklist).component('mealPlanAside', _MealPlan.MealPlanAside).component('mealPlanCard', _MealPlan.MealPlanCard).component('mealPlanCookMore', _MealPlan.MealPlanCookMore).component('mealPlanCreateButton', _MealPlan.MealPlanCreateButton).component('mealPlanDayCalories', _MealPlan.MealPlanDayCalories).component('mealPlanDayIcon', _MealPlan.MealPlanDayIcon).component('mealPlanDays', _MealPlan.MealPlanDays).component('mealPlanHelp', _MealPlan.MealPlanHelp).component('mealPlanNav', _MealPlan.MealPlanNav).component('mealPlanPrint', _MealPlan.MealPlanPrint).component('mealPlanRecipe', _MealPlan.MealPlanRecipe).component('mealPlanRecipeSwap', _MealPlan.MealPlanRecipeSwap).component('mealPlanServes', _MealPlan.MealPlanServes).component('mealPlanSwap', _MealPlan.MealPlanSwap).component('mealPlanSwaps', _MealPlan.MealPlanSwaps).component('mealPlanTags', _MealPlan.MealPlanTags).component('modal', _Modal.Modal).component('modalPopup', _Modal.ModalPopup).component('modalUpgrade', _Modal.ModalUpgrade).component('navChildren', _Nav.NavChildren).component('navDropdown', _Nav.NavDropdown).component('navFullscreen', _Nav.NavFullscreen).component('navItem', _Nav.NavItem).component('navLogo', _Nav.NavLogo).component('navMain', _Nav.NavMain).component('navPage', _Nav.NavPage).component('navPlain', _Nav.NavPlain).component('navProductTitle', _Nav.NavProductTitle).component('navMobileSidebar', _Nav.NavMobileSidebar).component('navSub', _Nav.NavSub).component('nutritionInformation', _Nutrition.NutritionInformation).component('paginationRow', _Pagination.PaginationRow).component('profileActions', _Profile.ProfileActions).component('profileBilling', _Profile.ProfileBilling).component('profileContainer', _Profile.ProfileContainer).component('profileFields', _Profile.ProfileFields).component('profileFieldsCancel', _Profile.ProfileFieldsCancel).component('profileFieldsDowngrade', _Profile.ProfileFieldsDowngrade).component('profileFieldsMore', _Profile.ProfileFieldsMore).component('profileFieldsNutrition', _Profile.ProfileFieldsNutrition).component('profileFieldsPassword', _Profile.ProfileFieldsPassword).component('profileFieldsWorkout', _Profile.ProfileFieldsWorkout).component('progressBadge', _Progress.ProgressBadge).component('progressBar', _Progress.ProgressBar).component('programNotStarted', _Program.ProgramNotStarted).component('programRestartModal', _Program.ProgramRestartModal).component('programStartModal', _Program.ProgramStartModal).component('programWeekMealPlan', _Program.ProgramWeekMealPlan).component('programWeekOverview', _Program.ProgramWeekOverview).component('programWeekVideos', _Program.ProgramWeekVideos).component('programWeekWorkouts', _Program.ProgramWeekWorkouts).component('ratingStars', _RatingStars.RatingStars).component('recipeDetail', _Recipe.RecipeDetail).component('recipeOptions', _Recipe.RecipeOptions).component('recipePreview', _Recipe.RecipePreview).component('recipeRow', _Recipe.RecipeRow).component('review', _Review.Review).component('reviewReply', _Review.ReviewReply).component('searchFilter', _Search.SearchFilter).component('searchFilterBadge', _Search.SearchFilterBadge).component('searchFilterRecipes', _Search.SearchFilterRecipes).component('searchFilterResults', _Search.SearchFilterResults).component('searchFilterWorkouts', _Search.SearchFilterWorkouts).component('searchFilterVideos', _Search.SearchFilterVideos).component('searchForm', _Search.SearchForm).component('searchOrder', _Search.SearchOrder).component('searchResults', _Search.SearchResults).component('signupAside', _Signup.SignupAside).component('signupFooter', _Signup.SignupFooter).component('signupFormBilling', _Signup.SignupFormBilling).component('signupFormPersonal', _Signup.SignupFormPersonal).component('signupIcon', _Signup.SignupIcon).component('signupPrice', _Signup.SignupPrice).component('signupSelectorProgram', _Signup.SignupSelectorProgram).component('signupSelectorWeekly', _Signup.SignupSelectorWeekly).component('signupTileProgram', _Signup.SignupTileProgram).component('signupTileWeekly', _Signup.SignupTileWeekly).component('signupVerifying', _Signup.SignupVerifying).component('speechBubble', _SpeechBubble.SpeechBubble).component('speechBubbleNutrition', _SpeechBubble.SpeechBubbleNutrition).component('speechBubbleWorkout', _SpeechBubble.SpeechBubbleWorkout).component('spinner', _Spinner.Spinner).component('termsConditions', _TermsConditions.TermsConditions).component('videoPlayer', _Video.VideoPlayer).component('videoPlayerResumable', _Video.VideoPlayerResumable).component('videoPlaylist', _Video.VideoPlaylist).component('videoProgress', _Video.VideoProgress).component('welcomeStepActions', _WelcomeSteps.WelcomeStepActions).component('welcomeStepBundle', _WelcomeSteps.WelcomeStepBundle).component('welcomeStepNutrition', _WelcomeSteps.WelcomeStepNutrition).component('welcomeStepPassword', _WelcomeSteps.WelcomeStepPassword).component('welcomeStepProfile', _WelcomeSteps.WelcomeStepProfile).component('welcomeStepPrograms', _WelcomeSteps.WelcomeStepPrograms).component('welcomeStepWorkout', _WelcomeSteps.WelcomeStepWorkout).component('workoutCaloriesBurnt', _Workout.WorkoutCaloriesBurnt).component('workoutIntro', _Workout.WorkoutIntro).component('workoutList', _Workout.WorkoutList).component('workoutMeta', _Workout.WorkoutMeta).component('workoutRatings', _Workout.WorkoutRatings).component('workoutSection', _Workout.WorkoutSection).component('workoutPlayerContextPanel', _WorkoutPlayer.WorkoutPlayerContextPanel).component('workoutPlayerContextItem', _WorkoutPlayer.WorkoutPlayerContextItem).component('workoutPlayerControls', _WorkoutPlayer.WorkoutPlayerControls).component('workoutPlayerCountdown', _WorkoutPlayer.WorkoutPlayerCountdown).component('workoutPlayerFinished', _WorkoutPlayer.WorkoutPlayerFinished).component('workoutPlayerFinishModal', _WorkoutPlayer.WorkoutPlayerFinishModal).component('workoutPlayerHeader', _WorkoutPlayer.WorkoutPlayerHeader).component('workoutPlayerInstructions', _WorkoutPlayer.WorkoutPlayerInstructions).component('workoutPlayerProgressBar', _WorkoutPlayer.WorkoutPlayerProgressBar).component('workoutPlayerSleeper', _WorkoutPlayer.WorkoutPlayerSleeper).component('workoutPlayerTimer', _WorkoutPlayer.WorkoutPlayerTimer)

// Directives
.directive('nutritionBmi', _Nutrition.NutritionBmi).directive('scrollTopOnChange', _ScrollTopOnChange.ScrollTopOnChange).directive('creditCardNumber', _Validators.CreditCardNumber).directive('creditCardDate', _Validators.CreditCardDate).directive('workoutPlayerVideo', _WorkoutPlayer.WorkoutPlayerVideo).name;

/***/ }),

/***/ "bLnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Nutrition = undefined;

var _theme = __webpack_require__("ZID5");

var _member = __webpack_require__("1OIp");

var Nutrition = exports.Nutrition = {
  template: '\n    <div class="nutrition pb-4 bg-gray-100">\n      <ui-view autoscroll="false"></ui-view>\n    </div>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);
        this.setNavChildren('nutrition');
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();
        this.setNavChildren();
      },
      mapState: function mapState(_ref) {
        var member = _ref.member;

        return {
          hasAccess: (0, _member.selectHasNutritionSubscription)(member)
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          setNavChildren: _theme.setNavChildren
        };
      }
    };
  }]
};

/***/ }),

/***/ "bk+O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DashboardWorkoutHack = exports.DashboardWorkoutHack = {
  bindings: {
    title: '<',
    description: '<',
    items: '<',
    member: '<'
  },

  template: '\n    <div class="dashboard-workout-hack">\n      <dashboard-carousel>\n        <dashboard-carousel-header>\n          <h4>{{ $ctrl.title }}</h4>\n        </dashboard-carousel-header>\n        <dashboard-carousel-body>\n          <p>{{ $ctrl.description }}</p>\n          <carousel list="$ctrl.items">\n            <div class="carousel-slide-wrapper"\n              ng-repeat="item in $ctrl.items track by $index">\n              <div class="carousel-slide">\n                <card-workout\n                  workout="item"\n                  member="$ctrl.member"\n                  on-click="$ctrl.onClick(item.id, item.exercisePlanId)">\n                </card-workout>\n              </div>\n            </div>\n          </carousel>\n        </dashboard-carousel-body>\n        <dashboard-carousel-footer>\n          <a ui-sref="workouts.hacks">\n            View More Tips\n          </a>\n        </dashboard-carousel-footer>\n      </dashboard-carousel>\n    </div>',

  controller: ["$state", function controller($state) {
    'ngInject';

    return {
      onClick: function onClick(id, exercisePlanId) {
        $state.go('workouts.express.detail', { id: id, exercisePlanId: exercisePlanId });
      }
    };
  }]
};

/***/ }),

/***/ "by8k":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DashboardNutritionContainer = exports.DashboardNutritionContainer = {
  bindings: {
    activeCard: '@',
    isLoading: '<',
    index: '<',
    recipeInspiration: '<',
    recipeCollection: '<',
    mealPlan: '<',
    mealPlanList: '<',
    mealPlansCurrent: '<',
    mealPlansTotal: '<',
    subscriptionId: '<'
  },

  template: '\n    <div class="dashboard-nutrition-container border-bottom-gray bg-gray-dashboard pt-3" ng-switch="$ctrl.activeCard">\n      <section class="dashboard-cards">\n        <div class="container">\n          <div class="row">\n            <div class="card-wrapper mb-3 mb-md-0 col-md-4 pointer"\n              ng-class="{ active: $ctrl.activeCard === \'1\' }">\n              <card-image\n                card-class="text-center nutrition-{{ $ctrl.index }}-bg"\n                link-text="\'Discover\'"\n                ng-click="$ctrl.activeCard = \'1\'">\n                <h4 class="card-title">\n                  <current-day></current-day><br>\n                  #FoodInspiration\n                </h4>\n              </card-image>\n              <box-arrow-row color="white"></box-arrow-row>\n              <div class="d-md-none" ng-switch-when="1">\n                <dashboard-nutrition-inspiration items="$ctrl.recipeInspiration">\n                </dashboard-nutrition-inspiration>\n              </div>\n            </div>\n            <div class="card-wrapper mb-3 mb-md-0 col-md-4 pointer"\n              ng-class="{ active: $ctrl.activeCard === \'2\' }">\n              <card-image\n                card-class="text-center bg-cz-theme-tertiary"\n                link-text="\'View\'"\n                img="$ctrl.mealPlan.heroImage.magazine"\n                ng-click="$ctrl.activeCard = \'2\'"\n                ng-if="$ctrl.mealPlan.id">\n                <i class="card-icon theme-color-secondary icon icon-meal-planner"></i>\n                <small class="tagline">\n                  Following Plan\n                </small>\n                <h4 class="card-title">\n                  {{ $ctrl.mealPlan.title }}\n                </h4>\n              </card-image>\n              <card-plain\n                card-class="text-center bg-cz-theme-tertiary"\n                link-text="\'Discover\'"\n                ng-click="$ctrl.activeCard = \'2\'"\n                ng-if="!$ctrl.mealPlan.id">\n                <i class="card-icon theme-color-secondary icon icon-meal-planner d-none d-md-block"></i>\n                <small class="tagline">\n                  Ready to plan your week?\n                </small>\n                <h4 class="card-title" ng-show="$ctrl.mealPlansTotal">\n                  {{ $ctrl.mealPlansTotal }} Ready-made Plans\n                </h4>\n              </card-plain>\n              <box-arrow-row color="white"></box-arrow-row>\n              <div class="d-md-none" ng-switch-when="2">\n                <dashboard-nutrition-meal-plan\n                  meal-plan="$ctrl.mealPlan"\n                  meal-plan-list="$ctrl.mealPlanList"\n                  meal-plans-current="$ctrl.mealPlansCurrent"\n                  meal-plans-total="$ctrl.mealPlansTotal"\n                  subscription-id="$ctrl.subscriptionId">\n                </dashboard-nutrition-meal-plan>\n              </div>\n            </div>\n            <div class="card-wrapper col-md-4 pointer"\n              ng-class="{ active: $ctrl.activeCard === \'3\' }">\n              <card-image\n                card-class="text-center bg-cz-theme-tertiary"\n                link-text="\'View\'"\n                img="$ctrl.recipeCollection.coverImageUrl.magazine"\n                ng-click="$ctrl.activeCard = \'3\'">\n                <small class="tagline">\n                  Featured\n                </small>\n                <h4 class="card-title">\n                  {{ $ctrl.recipeCollection.title }}\n                </h4>\n              </card-image>\n              <box-arrow-row color="white"></box-arrow-row>\n              <div class="d-md-none" ng-switch-when="3">\n                <dashboard-nutrition-hack\n                  title="$ctrl.recipeCollection.title"\n                  description="$ctrl.recipeCollection.strapLine"\n                  items="$ctrl.recipeCollection.recipes"\n                  hack-id="$ctrl.recipeCollection.id">\n                </dashboard-nutrition-hack>\n              </div>\n            </div>\n          </div>\n        </div>\n      </section>\n      <div class="d-none d-md-block">\n        <dashboard-nutrition-inspiration\n          ng-switch-when="1"\n          items="$ctrl.recipeInspiration">\n        </dashboard-nutrition-inspiration>\n        <dashboard-nutrition-meal-plan\n          ng-switch-when="2"\n          meal-plan="$ctrl.mealPlan"\n          meal-plan-list="$ctrl.mealPlanList"\n          meal-plans-current="$ctrl.mealPlansCurrent"\n          meal-plans-total="$ctrl.mealPlansTotal"\n          subscription-id="$ctrl.subscriptionId">\n        </dashboard-nutrition-meal-plan>\n        <dashboard-nutrition-hack\n          ng-switch-when="3"\n          title="$ctrl.recipeCollection.title"\n          description="$ctrl.recipeCollection.strapLine"\n          items="$ctrl.recipeCollection.recipes"\n          hack-id="$ctrl.recipeCollection.id">\n        </dashboard-nutrition-hack>\n      </div>\n    </div>'
};

/***/ }),

/***/ "c/8m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FormFeedback = exports.FormFeedback = {
  bindings: {
    isComplete: '<',
    onSubmit: '&'
  },

  template: '\n    <div ng-hide="$ctrl.isComplete">\n      <form\n        name="form"\n        ng-submit="$ctrl.onSubmit({ data: form.data })"\n        novalidate>\n        <p>\n          We think you\'re 5 stars.<br>\n          How many stars would you give us?\n        </p>\n        <form-input\n          form="form"\n          type="hidden"\n          name="rating"\n          value="form.data.rating">\n        </form-input>\n        <p>\n          <rating-stars\n            size="lg"\n            rating="form.data.rating"\n            is-enabled="true"\n            on-click="form.data.rating = value">\n          </rating-stars>\n        </p>\n        <div class="mb-4">\n          <form-textarea\n            custom-class="w-100 btn text-left rounded bg-gray-100"\n            form="form"\n            name="description"\n            placeholder="Your comments here."\n            rows="4"\n            value="form.data.description">\n          </form-textarea>\n        </div>\n        <div class="mb-2">\n          <button-primary\n            data-dismiss="modal"\n            is-inverse="true">\n            Cancel\n          </button-primary>\n          <button-primary ng-type="submit">\n            Submit\n          </button-primary>\n        </div>\n      </form>\n    </div>\n    <div ng-show="$ctrl.isComplete">\n      <p>\n        Thanks for taking the time to send your ratings and feedback to us,\n        we\'re listening and will keep improving the program and experience on\n        the Coaching Zone website.\n      </p>\n      <div class="d-flex justify-content-center border-0">\n        <button-primary\n          data-dismiss="modal"\n          is-inverse="true">\n          Close\n        </button-primary>\n      </div>\n    </div>'
};

/***/ }),

/***/ "cCsY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cCvp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProfileFields = undefined;

var _each2 = __webpack_require__("9uKM");

var _each3 = _interopRequireDefault(_each2);

var _settings = __webpack_require__("Ll2K");

var _countryList = __webpack_require__("yJMp");

var _countryList2 = _interopRequireDefault(_countryList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO
// - screenName exists validation
// - move uploader to a generic component

var ProfileFields = exports.ProfileFields = {
  bindings: {
    form: '<',
    member: '<',
    isEditing: '<',
    onUpdate: '&',
    onUploadComplete: '&'
  },

  template: '\n    <div class="d-block d-md-flex justify-content-center" ng-hide="$ctrl.isEditing">\n      <span class="d-block d-md-inline pr-4">\n        <i class="fa fa-user text-pink-cz-mid"></i>\n        {{ $ctrl.member.screenName }}\n      </span>\n      <span class="d-block d-md-inline pr-4">\n        <i class="fa fa-envelope text-pink-cz-mid"></i>\n        {{ $ctrl.member.email }}\n      </span>\n      <span class="d-block d-md-inline">\n        <i class="fa fa-map-marker text-pink-cz-mid"></i>\n        <span>{{ $ctrl.member.postcode }},</span>\n        {{ $ctrl.member.country }}\n      </span>\n    </div>\n    <div class="row" ng-show="$ctrl.isEditing">\n      <div class="col-md-4 d-flex flex-column align-items-center">\n        <div ng-hide="true" class="avatar avatar--lg mb-2">\n          <image-circle src="$ctrl.member.profile.avatarUrl.original">\n        </div>\n        <label class="btn btn-link">\n          <h4>\n            Your details\n          </h4>\n          <input\n            class="d-none"\n            type="file"\n            uploader="$ctrl.uploader"\n            nv-file-select\n            ng-hide="true" />\n        </label>\n      </div>\n      <div class="col-md-8">\n        <form-group-row>\n          <form-group-left>\n            <form-label for="screenName">\n              Screen Name\n            </form-label>\n          </form-group-left>\n          <form-group-right>\n            <form-input\n              form="$ctrl.form"\n              type="text"\n              name="screenName"\n              value="$ctrl.member.screenName"\n              pattern="[\\w\\d\\-_]+"\n              required="true"\n              on-update="$ctrl.onUpdate({ key: key, value: value })"\n              errors="{\n                required: \'This is a required field.\',\n                pattern: \'Only letters, numbers, dashes or underscores allowed.\',\n                exists: \'Screen name used by another member.\',\n              }">\n            </form-input>\n          </form-group-right>\n        </form-group-row>\n        <hr>\n        <form-group-row>\n          <form-group-left>\n            <form-label for="email">\n              Email\n            </form-label>\n          </form-group-left>\n          <form-group-right>\n            <form-input\n              form="$ctrl.form"\n              type="email"\n              name="email"\n              value="$ctrl.member.email"\n              required="true"\n              on-update="$ctrl.onUpdate({ key: key, value: value })"\n              errors="{\n                required: \'This is a required field.\',\n                email: \'Must be a valid email address.\',\n              }">\n            </form-input>\n          </form-group-right>\n        </form-group-row>\n        <hr>\n        <form-group-row>\n          <form-group-left>\n            <form-label for="firstName">\n              First Name\n            </form-label>\n          </form-group-left>\n          <form-group-right>\n            <form-input\n              form="$ctrl.form"\n              type="text"\n              name="firstName"\n              value="$ctrl.member.firstName"\n              required="true"\n              on-update="$ctrl.onUpdate({ key: key, value: value })"\n              errors="{ required: \'This is a required field.\' }">\n            </form-input>\n          </form-group-right>\n        </form-group-row>\n        <hr>\n        <form-group-row>\n          <form-group-left>\n            <form-label for="lastName">\n              Last Name\n            </form-label>\n          </form-group-left>\n          <form-group-right>\n            <form-input\n              form="$ctrl.form"\n              type="text"\n              name="lastName"\n              value="$ctrl.member.lastName"\n              required="true"\n              on-update="$ctrl.onUpdate({ key: key, value: value })"\n              errors="{ required: \'This is a required field.\' }">\n            </form-input>\n          </form-group-right>\n        </form-group-row>\n        <hr>\n        <form-group-row>\n          <form-group-left>\n            <form-label for="postcode">\n              Postcode\n            </form-label>\n          </form-group-left>\n          <form-group-right>\n            <form-input\n              form="$ctrl.form"\n              type="text"\n              name="postcode"\n              value="$ctrl.member.postcode"\n              required="true"\n              on-update="$ctrl.onUpdate({ key: key, value: value })"\n              errors="{ required: \'This is a required field.\' }">\n            </form-input>\n          </form-group-right>\n        </form-group-row>\n        <hr>\n        <form-group-row>\n          <form-group-left>\n            <form-label for="country">\n              Country\n            </form-label>\n          </form-group-left>\n          <form-group-right>\n            <form-select\n              form="$ctrl.form"\n              name="country"\n              value="$ctrl.member.country"\n              required="true"\n              on-update="$ctrl.onUpdate({ key: key, value: value })"\n              errors="{ required: \'This is a required field.\' }">\n              <option value="">-- Select --</option>\n              <optgroup label="---------------">\n                <option value="Australia">Australia</option>\n                <option value="New Zealand">New Zealand</option>\n              </optgroup>\n              <optgroup label="---------------">\n                <option\n                  value="{{ country }}"\n                  ng-repeat="country in $ctrl.countries track by $index">\n                  {{ country }}\n                </option>\n              </optgroup>\n            </form-select>\n          </form-group-right>\n        </form-group-row>\n      </div>\n    </div>',

  controller: ["$timeout", "FileUploader", function controller($timeout, FileUploader) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var _this = this;

        this.countries = (0, _countryList2.default)().getNames();

        $timeout(function () {
          // Field validation on init
          (0, _each3.default)(_this.form.data, function (value, key) {
            if (_this.form[key]) {
              _this.form[key].$setTouched();
            }
          });

          // D.O.B. field validation
          $('select.form-control').trigger('change');
        });
      },
      $onChanges: function $onChanges() {
        var _this2 = this;

        if (!this.uploader) {
          this.uploader = new FileUploader({
            alias: 'member_profile[avatar]',
            autoUpload: true,
            method: 'PUT',
            onCompleteAll: function onCompleteAll() {
              return _this2.onUploadComplete();
            },
            removeAfterUpload: true,
            withCredentials: true
          });
        }

        if (this.member) {
          this.uploader.url = _settings.hosts.api + '/v1/members/' + this.member.id + '/profile';
        }
      }
    };
  }]
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "cMck":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WelcomeStepNutrition = exports.WelcomeStepNutrition = {
  transclude: true,

  bindings: {
    isLoading: '<',
    isShowModal: '<',
    member: '<',
    scrollTo: '&',
    onSubmit: '&',
    onUpdate: '&'
  },

  template: '\n    <div class="welcome-step-nutrition">\n      <h1 class="h2 text-center text-white my-4">\n        Your Nutrition Profile\n      </h1>\n      <section class="theme-light p-3 mb-5">\n        <form class="voome-form"\n          name="form"\n          ng-submit="$ctrl.onSubmit({ data: $ctrl.member })"\n          novalidate>\n          <speech-bubble-nutrition\n            form="form"\n            member="$ctrl.member"\n            scroll-to="$ctrl.scrollTo({ id: id })"\n            on-complete="$ctrl.isComplete = true"\n            on-update="$ctrl.onUpdate({ key: key, value: value })">\n          </speech-bubble-nutrition>\n          <div class="d-flex justify-content-center pt-4"\n            ng-show="$ctrl.isComplete">\n            <ng-transclude></ng-transclude>\n          </div>\n        </form>\n      </section>\n      <modal-popup\n        size="lg"\n        ng-if="$ctrl.isShowModal">\n        <modal-body>\n          <div class="p-3">\n            <div class="meal-plan-day-icon icon-lg text-center">\n              <i class="icon-recipes text-white fa-3x"></i>\n            </div>\n            <h3 class="text-center mt-3">Welcome to Coaching Zone Nutrition!</h3>\n            <p class="text-center mb-0">\n              To get you started we have a few questions about your dietary preferences.\n            </p>\n          </div>\n        </modal-body>\n      </modal-popup>\n    </div>'
};

/***/ }),

/***/ "cPwT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SearchResults = exports.SearchResults = {
  transclude: true,

  bindings: {
    onUpdateParam: '&',
    order: '<',
    pagination: '<',
    type: '@'
  },

  template: '\n    <header class="d-flex justify-content-between align-items-center py-2">\n      <small class="py-3"\n        ng-hide="$ctrl.pagination.total">\n        No results found.\n      </small>\n      <small ng-show="$ctrl.pagination.total">\n        {{ $ctrl.pagination.total || 0 }} {{ $ctrl.type }} found.\n      </small>\n      <search-order\n        title="Sort by:"\n        list="$ctrl.order"\n        on-click="$ctrl.onUpdateParam({ key: \'order\', value: value })"\n        ng-show="$ctrl.pagination.total">\n      </search-order>\n    </header>\n    <div class="search-results" ng-transclude></div>\n    <pagination-row\n      on-update-param="$ctrl.onUpdateParam({ key: key, value: value })"\n      pagination="$ctrl.pagination">\n    </pagination-row>\n  '
};

/***/ }),

/***/ "cQwx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Favourites = __webpack_require__("HTVa");

Object.defineProperty(exports, 'Favourites', {
  enumerable: true,
  get: function get() {
    return _Favourites.Favourites;
  }
});

var _Recipes = __webpack_require__("9u01");

Object.defineProperty(exports, 'FavouritesRecipes', {
  enumerable: true,
  get: function get() {
    return _Recipes.FavouritesRecipes;
  }
});

var _Videos = __webpack_require__("3nT6");

Object.defineProperty(exports, 'FavouritesVideos', {
  enumerable: true,
  get: function get() {
    return _Videos.FavouritesVideos;
  }
});

var _Workouts = __webpack_require__("Yt7d");

Object.defineProperty(exports, 'FavouritesWorkouts', {
  enumerable: true,
  get: function get() {
    return _Workouts.FavouritesWorkouts;
  }
});

/***/ }),

/***/ "chzE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectNutritionProgramIdForBmi = exports.selectNutritionPrograms = exports.selectNutritionProgram = exports.programIsDisabled = undefined;

var _map2 = __webpack_require__("2247");

var _map3 = _interopRequireDefault(_map2);

var _find2 = __webpack_require__("kbi+");

var _find3 = _interopRequireDefault(_find2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nutritionPrograms = {
  1: {
    id: 1,
    level: 0,
    gender: 'F',
    title: '1200 calories per day',
    description: 'For women wanting to lose a moderate amount of weight.',
    goal: 'I want to lose weight'
  },
  2: {
    id: 2,
    level: 1,
    gender: 'F',
    title: '1500 calories per day',
    description: 'For women wanting to maintain their weight.',
    goal: 'I want to maintain my current weight'
  },
  3: {
    id: 3,
    level: 2,
    gender: 'F',
    title: '1700 calories per day',
    description: 'For pregnant women. Recipes are specifically tailored to meet\n      the pregnancy food safety recommendations.',
    goal: 'I am pregnant'
  },
  4: {
    id: 4,
    level: 3,
    gender: 'M',
    title: '1800 calories per day',
    description: 'For men wanting to lose a moderate amount of weight.',
    goal: 'I want to lose weight'
  },
  5: {
    id: 5,
    level: 4,
    gender: 'M',
    title: '2000 calories per day',
    description: 'For men trying to maintain their weight OR for men with a BMI\n      of 30+ wanting to lose weight.',
    goal: 'I want to maintain my current weight'
  },
  6: {
    id: 6,
    level: 3,
    gender: 'F',
    title: '1800 calories per day',
    description: 'For breastfeeding women OR for women with a BMI of 30+ wanting\n      to lose weight.',
    goal: 'I am breastfeeding'
  },
  8: {
    id: 8,
    level: 4,
    gender: 'F',
    title: '2000 calories per day',
    description: 'For women undertaking a highly active exercise routine,\n     wanting to maintain their weight.',
    goal: 'Female, wanting to Maintain Weight'
  }
};

var programsFor = {
  M: {
    goals: [4, 5],
    programs: [4, 5]
  },

  F: {
    goals: [1, 2, 3, 6],
    programs: [1, 2, 3, 6, 8]
  }
};

var programIsDisabled = exports.programIsDisabled = function programIsDisabled(program, goal) {
  var isDisabled = false;

  if (goal === 'I am pregnant' || goal === 'I am breastfeeding') {
    isDisabled = program.goal !== goal;
  }

  return _extends({}, program, { isDisabled: isDisabled });
};

var selectNutritionProgram = exports.selectNutritionProgram = function selectNutritionProgram(params) {
  if (params.id) {
    return nutritionPrograms[params.id];
  } else {
    return (0, _find3.default)(nutritionPrograms, params);
  }
};

var selectNutritionPrograms = exports.selectNutritionPrograms = function selectNutritionPrograms(gender, goal) {
  var goals = (0, _map3.default)(programsFor[gender].goals, function (key) {
    return nutritionPrograms[key];
  });

  var programs = (0, _map3.default)(programsFor[gender].programs, function (key) {
    return programIsDisabled(nutritionPrograms[key], goal);
  });

  return { goals: goals, programs: programs };
};

var selectNutritionProgramIdForBmi = exports.selectNutritionProgramIdForBmi = function selectNutritionProgramIdForBmi(id, bmi) {
  if (bmi > 30) {
    switch (id) {
      // Females default to progam 6
      case 1:
        return 6;

      // Males default to progam 5
      case 4:
        return 5;
    }
  }

  return id;
};

/***/ }),

/***/ "cmZC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.humanize = undefined;

var _startCase2 = __webpack_require__("GMGH");

var _startCase3 = _interopRequireDefault(_startCase2);

var _memoize2 = __webpack_require__("zGZ6");

var _memoize3 = _interopRequireDefault(_memoize2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var humanize = exports.humanize = function humanize() {
  return (0, _memoize3.default)(_startCase3.default);
};

/***/ }),

/***/ "csWH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizePagination = exports.schemaPagination = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _normalizr = __webpack_require__("vNPR");

var schemaPagination = exports.schemaPagination = function schemaPagination(key, _idAttribute) {
  return new _normalizr.schema.Entity('pagination', { result: [new _normalizr.schema.Entity(key)] }, { idAttribute: function idAttribute() {
      return _idAttribute;
    } });
};

var normalizePagination = exports.normalizePagination = function normalizePagination(params) {
  var pagination = params.pagination,
      data = params.data,
      key = params.key,
      idAttribute = params.idAttribute;


  return (0, _normalizr.normalize)(_extends({}, pagination, { result: data }), schemaPagination(key, idAttribute));
};

/***/ }),

/***/ "d+HJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormFeedback = __webpack_require__("c/8m");

Object.defineProperty(exports, 'FormFeedback', {
  enumerable: true,
  get: function get() {
    return _FormFeedback.FormFeedback;
  }
});

/***/ }),

/***/ "d1/9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SignupTileWeekly = exports.SignupTileWeekly = {
  bindings: {
    color: '<',
    icon: '<',
    isBundle: '<',
    isCoupon: '<',
    priceInCents: '<',
    title: '<',
    onClick: '&'
  },

  template: '\n    <div class="signup-tile-weekly pr-md-4">\n      <div class="d-flex">\n        <signup-icon color="$ctrl.color">\n          <i class="fa fa-lg text-white" ng-class="$ctrl.icon"></i>\n        </signup-icon>\n        <div class="d-flex justify-content-between align-items-center ml-3 w-100">\n          <div class="details">\n            <h5 class="text-black mb-0" ng-bind="$ctrl.title"></h5>\n            <button class="btn btn-md btn-link p-0"\n              ng-click="$ctrl.onClick()"\n              ng-show="$ctrl.isBundle && !$ctrl.isCoupon">\n              Remove\n            </button>\n          </div>\n          <div class="d-flex justify-content-between">\n            <signup-price value="$ctrl.priceInCents"></signup-price>\n          </div>\n        </div>\n      </div>\n    </div>'
};

/***/ }),

/***/ "d6NY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Program = __webpack_require__("k34O");

Object.defineProperty(exports, 'Program', {
  enumerable: true,
  get: function get() {
    return _Program.Program;
  }
});

var _Graduation = __webpack_require__("aGQT");

Object.defineProperty(exports, 'ProgramGraduation', {
  enumerable: true,
  get: function get() {
    return _Graduation.ProgramGraduation;
  }
});

var _Intro = __webpack_require__("1BYA");

Object.defineProperty(exports, 'ProgramIntro', {
  enumerable: true,
  get: function get() {
    return _Intro.ProgramIntro;
  }
});

var _MealPlan = __webpack_require__("XiiV");

Object.defineProperty(exports, 'ProgramMealPlan', {
  enumerable: true,
  get: function get() {
    return _MealPlan.ProgramMealPlan;
  }
});

var _Nav = __webpack_require__("zXzg");

Object.defineProperty(exports, 'ProgramNav', {
  enumerable: true,
  get: function get() {
    return _Nav.ProgramNav;
  }
});

var _Recipe = __webpack_require__("er95");

Object.defineProperty(exports, 'ProgramRecipe', {
  enumerable: true,
  get: function get() {
    return _Recipe.ProgramRecipe;
  }
});

var _Redirect = __webpack_require__("R26J");

Object.defineProperty(exports, 'ProgramRedirect', {
  enumerable: true,
  get: function get() {
    return _Redirect.ProgramRedirect;
  }
});

var _Week = __webpack_require__("1yqr");

Object.defineProperty(exports, 'ProgramWeek', {
  enumerable: true,
  get: function get() {
    return _Week.ProgramWeek;
  }
});

var _Workout = __webpack_require__("+IQY");

Object.defineProperty(exports, 'ProgramWorkout', {
  enumerable: true,
  get: function get() {
    return _Workout.ProgramWorkout;
  }
});

/***/ }),

/***/ "eAOE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WelcomeStepPassword = exports.WelcomeStepPassword = {
  bindings: {
    member: '<',
    isLoading: '<',
    onSubmit: '&'
  },

  template: '\n    <div class="py-5">\n      <h1 class="h2 text-center text-white mb-3">\n        Welcome {{ $ctrl.member.firstName }}\n      </h1>\n      <div class="row pb-5">\n        <div class="mx-auto col-lg-6">\n          <section class="theme-light p-3">\n            <profile-container is-editing="true">\n              <p class="text-center mb-4">\n                Create a password for your account.\n              </p>\n              <form class="voome-form"\n                name="form"\n                ng-submit="$ctrl.onSubmit({ data: form.data })"\n                novalidate>\n                <profile-fields-password\n                  form="form"\n                  is-update="false">\n                </profile-fields-password>\n                <div class="form-row justify-content-end">\n                  <div class="col-sm-8">\n                    <button-primary\n                      ng-type="submit"\n                      ng-disabled="$ctrl.isLoading || form.$invalid">\n                      <spinner is-loading="$ctrl.isLoading">\n                        Submit\n                      </spinner>\n                    </button-primary>\n                  </div>\n                </div>\n              </form>\n            </profile-container>\n          </section>\n        </div>\n      </div>\n    </div>'
};

/***/ }),

/***/ "eDzR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var NutritionRecipe = exports.NutritionRecipe = {
  template: "\n    <div class=\"nutrition-recipe bg-white\">\n      <recipe>\n        <recipe-nav-left>\n          <button-back></button-back>\n        </recipe-nav-left>\n      </recipe>\n    </div>"
};

/***/ }),

/***/ "eEKx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreditCardUpdate = undefined;

var _kebabCase2 = __webpack_require__("Ex7i");

var _kebabCase3 = _interopRequireDefault(_kebabCase2);

var _reduxUiRouter = __webpack_require__("Zb/7");

var _constants = __webpack_require__("qI5z");

var _utils = __webpack_require__("0xDb");

var _member2 = __webpack_require__("1OIp");

var _signup = __webpack_require__("FQ9i");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreditCardUpdate = exports.CreditCardUpdate = {
  template: '\n    <div class="signup">\n      <main class="main-content theme-mid">\n        <div class="container align-items-center justify-content-center py-4"\n          ng-switch="$ctrl.action">\n          <div ng-switch-when="verify">\n            <signup-verifying\n              is-loading="$ctrl.isLoading"\n              message="$ctrl.message">\n              Verifying Credit Card\n            </signup-verifying>\n          </div>\n          <div class="row" ng-switch-default>\n            <div class="col-md-8 mx-auto pb-4">\n              <header class="text-center text-white">\n                <div ng-show="$ctrl.action === \'resume\' && $ctrl.subscription.status === \'cancelled\'">\n                  <h1 class="h2 text-white">\n                    Welcome back {{ $ctrl.member.firstName }}\n                  </h1>\n                  <p class="mb-4">\n                    Start Vooming again!<br>\n                    Please update your billing details below.\n                  </p>\n                </div>\n                <div ng-hide="$ctrl.action === \'resume\'">\n                  <h1 class="h2 text-white">\n                    Update Credit Card\n                  </h1>\n                  <p class="mb-4">\n                    Please update your billing details below.\n                  </p>\n                </div>\n              </header>\n              <div class="theme-light p-3">\n                <div class="signup-content bg-white py-3 py-lg-5"\n                  scroll-top-on-change="$ctrl.message">\n                  <div class="px-3 px-md-5">\n                    <alert type="danger" ng-show="$ctrl.message">\n                      <div ng-bind-html="$ctrl.message"></div>\n                    </alert>\n                    <alert type="danger" ng-show="$ctrl.isDisabled">\n                      Sorry team! Due to site maintenance, updates cannot be\n                      accepted right now. Please try again in an hour.\n                    </alert>\n                  </div>\n                  <div class="px-3 px-md-5"\n                    ng-show="$ctrl.action === \'resume\' && $ctrl.subscription.isWeekly && !$ctrl.message">\n                    <alert type="danger"\n                      ng-show="$ctrl.subscription.status === \'suspended\'">\n                      We had a problem processing one or more of your Voome\n                      payments. Please update your credit card details below. If\n                      problems persist, please contact us at\n                      <a href="mailto:support@voome.com.au">support@voome.com.au</a>.\n                    </alert>\n                  </div>\n                  <signup-selector-weekly\n                    is-active="true"\n                    product="$ctrl.product"\n                    products="$ctrl.products"\n                    text="$ctrl.text"\n                    on-change="$ctrl.onChangeWeekly(product)"\n                    on-select-bundle="$ctrl.onChangeWeekly({ name: \'Voome Bundle\' })">\n                  </signup-selector-weekly>\n                  <div ng-hide="$ctrl.isDisabled">\n                    <div class="px-3 px-md-5">\n                      <signup-form-billing\n                        is-loading="$ctrl.isLoading"\n                        chargify-data="$ctrl.chargifyData"\n                        chargify-fields="$ctrl.chargifyFields"\n                        chargify-subscription-id="$ctrl.subscription.chargifySubscriptionId"\n                        product="$ctrl.product"\n                        title="Billing Details"\n                        on-cancel="$ctrl.onCancel()"\n                        on-update="$ctrl.updateChargifyData(key, value)">\n                      </signup-form-billing>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </main>\n    </div>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        // Set the fields to submit
        this.chargifyFields = _constants.CREDIT_CARD_FIELDS;

        // Get the params and set the sction type
        var currentParams = $ngRedux.getState().router.currentParams;

        this.action = currentParams.action;

        // Handle the action
        this.action === 'verify' ? this.handleVerify(currentParams) : this.handleSetUp(currentParams);

        // Fetch all products.
        this.fetchProducts();
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();
      },
      runSetUp: function runSetUp(productId) {
        var _member = this.member,
            email = _member.email,
            firstName = _member.firstName,
            lastName = _member.lastName;
        var chargifySubscriptionId = this.subscription.chargifySubscriptionId;

        var redirectUri = _constants.CREDIT_CARD_REDIRECT_URI + '?voome_product_id=' + productId;

        this.checkStatus();

        // Update chargify data with product id
        this.setup({
          voomeProductId: productId,
          chargifyData: {
            email: email,
            firstName: firstName,
            lastName: lastName,
            redirectUri: redirectUri,
            subscriptionId: chargifySubscriptionId
          }
        });
      },
      handleSetUp: function handleSetUp(_ref) {
        var slug = _ref.slug;

        // Init form with the current subscription's product
        var voomeProductId = this.subscription.voomeProductId;

        var product = (0, _signup.selectProductBySlug)(this.signup, slug);
        var productId = product ? product.id : voomeProductId;

        if (this.chargifyData && !this.chargifyData.voomeProductId) {
          this.runSetUp(productId);
        }
      },
      handleVerify: function handleVerify(params) {
        var _memberStorage$get = _utils.memberStorage.get(),
            voomeProductId = _memberStorage$get.voomeProductId;

        var verifyProductId = parseInt(params.voome_product_id);

        if (voomeProductId !== verifyProductId) {
          _utils.memberStorage.set({ voomeProductId: verifyProductId });
        }

        params.status_code === '200' ? this.verifyCreditCard(params, { name: 'dashboard' }) : this.setupChargifyError(params);
      },
      onCancel: function onCancel() {
        if (this.action === 'update') {
          this.stateGo('profile');
        }

        this.reset();
      },
      onChangeWeekly: function onChangeWeekly(_ref2) {
        var name = _ref2.name;

        var toggle = (0, _kebabCase3.default)(name);
        var slug = toggle === 'voome-bundle' ? toggle : toggle === 'voome-workouts' ? 'voome-nutrition' : 'voome-workouts';
        var product = (0, _signup.selectProductBySlug)(this.signup, slug);

        // Update signup state with new product id
        this.runSetUp(product.id);

        // Update page
        this.stateGo('profileCreditCard', { slug: slug });
      },
      mapState: function mapState(_ref3) {
        var member = _ref3.member,
            signup = _ref3.signup;
        var chargifyData = signup.chargifyData,
            isDisabled = signup.isDisabled,
            isLoading = signup.isLoading,
            message = signup.message,
            step = signup.step,
            type = signup.type;

        var subscription = (0, _member2.selectSubscription)(member);

        var slug = $ngRedux.getState().router.currentParams.slug;

        var product = slug ? (0, _signup.selectProductBySlug)(signup, slug) : (0, _signup.selectProduct)(signup, subscription.voomeProductId) || {};

        return {
          chargifyData: chargifyData,
          isDisabled: isDisabled,
          isLoading: isLoading,
          message: message,
          slug: slug,
          step: step,
          signup: signup,
          subscription: subscription,
          product: product,
          member: (0, _member2.selectMember)(member),
          products: (0, _signup.selectProductsByType)(signup, type),
          productsText: (0, _signup.getWeeklyProductText)(product),
          text: _constants.SIGNUP_TEXT['weekly']
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          checkStatus: _signup.checkStatus,
          fetchProducts: _signup.fetchProducts,
          reset: _signup.reset,
          setup: _signup.setup,
          setupChargifyError: _signup.setupChargifyError,
          stateGo: _reduxUiRouter.stateGo,
          updateChargifyData: _signup.updateChargifyData,
          verifyCreditCard: _signup.verifyCreditCard
        };
      }
    };
  }]
};

/***/ }),

/***/ "eU0z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ProgramWeekOverview = exports.ProgramWeekOverview = {
  bindings: {
    isLoading: '<',
    heading: '<',
    description: '<',
    videoId: '<',
    commentsCount: '<',
    commentsNewCount: '<',
    repliesCount: '<',
    toggleComments: '&'
  },

  template: '\n    <section class="container program-week-overview">\n      <div class="row d-flex">\n        <div class="col-lg pl-lg-0 order-lg-2">\n          <video-player-resumable video-id="$ctrl.videoId">\n          </video-player-resumable>\n        </div>\n        <div class="col-lg pr-lg-0 d-flex">\n          <div class="program-week-overview-content bg-gray-corner flex-column w-100 justify-content-center text-center">\n            <h3>{{ $ctrl.heading }}</h3>\n            <p>{{ $ctrl.description | limitTo: 320 }}{{ $ctrl.description.length > 320 ? \'...\' : \'\' }}</p>\n            <div class="program-week-comments-stats border border-top border-gray-300"\n              ng-click="$ctrl.toggleComments()">\n              <div class="row py-3" ng-show="$ctrl.isLoading">\n                <div class="col-12">\n                  <spinner is-loading="true"></spinner>\n                </div>\n              </div>\n              <div class="row" ng-hide="$ctrl.isLoading">\n                <div class="col-sm-6 pl-3 pr-0 py-2 theme-btn"\n                  ng-hide="$ctrl.commentsCount">\n                  <span class="info">\n                    <i class="icon icon-comment mr-2"></i>\n                    Add a Comment\n                  </span>\n                </div>\n                <div class="col-sm-8 pl-md-5 pr-0 py-2 text-md-left"\n                  ng-show="$ctrl.commentsCount > 0">\n                  <span class="info text-teal">\n                    <i class="icon icon-comment mr-2"></i>\n                    {{ $ctrl.commentsCount }}\n                    Comments\n                  </span>\n                </div>\n                <div class="col-sm-4 pl-0 pr-2 py-2 theme-btn"\n                  ng-show="$ctrl.commentsNewCount > 0 || $ctrl.repliesCount > 0">\n                  <span class="info" ng-show="$ctrl.commentsNewCount > 0">\n                    {{ $ctrl.commentsNewCount }} New\n                  </span>\n                  <span class="mx-1 theme-color-secondary" ng-show="$ctrl.commentsNewCount > 0 && $ctrl.repliesCount > 0">|</span>\n                  <span class="info" ng-show="$ctrl.repliesCount > 0">\n                    {{ $ctrl.repliesCount }} Replies\n                  </span>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </section>'
};

/***/ }),

/***/ "ehyk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var RecipeOptions = exports.RecipeOptions = {
  bindings: {
    serves: '<',
    variations: '<',
    prepTime: '<',
    cookingTime: '<',
    calories: '<',
    isMarinated: '<',
    onClickVariation: '&'
  },

  template: '\n    <div class="d-flex justify-content-between bg-gray-100 border border-y border-gray-300 py-3 px-3">\n      <small ng-if="!$ctrl.variations || $ctrl.variations.length <= 1">\n        <i class="fa-lg icon-serves text-pink-cz-mid"></i>\n        x{{ $ctrl.serves }}\n      </small>\n      <small ng-if="$ctrl.variations && $ctrl.variations.length > 1">\n        <button class="btn btn-link dropdown-toggle d-flex align-items-center p-0 border-0"\n          type="button"\n          data-toggle="dropdown">\n          <small>\n            <i class="fa-lg icon-serves mr-1 text-pink-cz-mid"></i>\n            x{{ $ctrl.serves }}\n          </small>\n        </button>\n        <div class="dropdown-menu mt-2">\n          <a class="dropdown-item"\n            href="#"\n            ng-click="$ctrl.onClickVariation({ recipeId: item.id })"\n            ng-repeat="item in $ctrl.variations">\n            x{{ item.serves }}\n          </a>\n        </div>\n      </small>\n      <small ng-if="$ctrl.prepTime">\n        <i class="fa-lg icon-prep-time text-pink-cz-mid"></i>\n        {{ $ctrl.prepTime }}\n        <span class="unit">\n          m<span class="d-none d-md-inline-block">in prep</span>\n        </span>\n      </small>\n      <small ng-if="$ctrl.cookingTime">\n        <i class="fa-lg icon-cook-time text-pink-cz-mid"></i>\n        {{ $ctrl.cookingTime }}\n        <span class="unit">\n          m<span class="d-none d-md-inline-block">in cooking</span>\n        </span>\n      </small>\n      <small ng-if="$ctrl.calories">\n        <i class="fa-lg icon-calories text-pink-cz-mid"></i>\n        {{ $ctrl.calories }}\n        <span class="unit">\n          Cal<span class="d-none d-md-inline-block"> / serve</span>\n        </span>\n      </small>\n      <small ng-if="$ctrl.isMarinated">\n        <i class="fa-lg icon-time"></i>\n        <span class="unit">Marinating required</span>\n      </small>\n    </div>'
};

/***/ }),

/***/ "er95":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ProgramRecipe = exports.ProgramRecipe = {
  template: "\n    <div class=\"program-recipe\">\n      <recipe>\n        <recipe-nav-left>\n          <button-back>\n            Week {{ $ctrl.weekNumber }}\n          </button-back>\n        </recipe-nav-left>\n      </recipe>\n    </div>"
};

/***/ }),

/***/ "fD+P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ButtonPlay = exports.ButtonPlay = {
  bindings: {
    onClick: '&'
  },

  template: '\n    <button class="btn btn-play rounded-circle d-flex align-items-center justify-content-center"\n      type="button"\n      ng-click="$ctrl.onClick()">\n      <i class="fa fa-lg fa-play text-white"></i>\n    </button>'
};

/***/ }),

/***/ "fIwf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var NavSub = exports.NavSub = {
  transclude: {
    left: '?navLeft',
    right: '?navRight'
  },

  bindings: {
    active: '@'
  },

  template: '\n    <nav class="navbar navbar-sub bg-gray-100 border border-y">\n      <div class="container">\n        <div class="d-flex justify-content-between w-100">\n          <div ng-transclude="left"></div>\n          <div ng-transclude="right"></div>\n        </div>\n      </div>\n    </nav>'
};

/***/ }),

/***/ "fJ9R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WorkoutPlayerVideo = undefined;

var _reject2 = __webpack_require__("YqDm");

var _reject3 = _interopRequireDefault(_reject2);

var _settings = __webpack_require__("Ll2K");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WorkoutPlayerVideo = exports.WorkoutPlayerVideo = ["$q", "$timeout", "$window", "$log", function WorkoutPlayerVideo($q, $timeout, $window, $log) {
  'ngInject';

  return {
    link: link,

    scope: {
      autoplay: '=',
      countdownComplete: '=',
      playing: '=',
      waiting: '=',
      onPlay: '&',
      onResume: '&',
      onWait: '&'
    },

    template: '\n      <div class="workout-player-video">\n        <video class="video-js"\n          id="brightcove-workout-player"\n          data-account="' + _settings.brightcove.accountId + '"\n          data-player="' + _settings.brightcove.playerId + '"\n          data-embed="default"\n          playsinline\n          muted\n          controls>\n        </video>\n        <div class="cover-screen" ng-class="{ \'on\': coverOn }"></div>\n        <div loading-spinner="!$ctrl.waiting && !coverOn"></div>\n      </div>'
  };

  function link(scope, element, attrs) {
    var $video_el;

    scope.isLoaded = false;

    scope.init = function () {
      $($window).resize(function () {
        scope.setScale();
      });

      attrs.$observe('videoScale', function () {
        scope.setScale();
      });

      attrs.$observe('videoId', function () {
        scope.setExperience();
      });

      scope.$watch('playing', function (playing) {
        if (playing) {
          scope.onWait();

          scope.loadVideo().then(function () {
            scope.onResume();
            scope.play();
          }).catch(function () {});
        } else {
          scope.pauseVideo();
        }
      });

      scope.$watch('countdownComplete', function () {
        scope.play();
      });

      scope.$on('$destroy', function () {
        if (scope.player) {
          scope.player.dispose();
          scope.player = undefined;

          $('.workout-player-video').remove();
        }
      });

      return scope.injectBrightcoveScript();
    };

    scope.injectBrightcoveScript = function () {
      var deferred = $q.defer();

      if (scope.player) {
        deferred.resolve();
      } else {
        var script = document.createElement('script');

        script.src = $window.location.protocol + '//players.brightcove.net/' + _settings.brightcove.accountId + '/' + _settings.brightcove.playerId + '_default/index.min.js';

        script.onload = function () {
          deferred.resolve();
        };

        document.body.appendChild(script);
      }

      return deferred.promise;
    };

    scope.setPlayer = function () {
      scope.player = $window.videojs('brightcove-workout-player');

      // Manually loop when the video ends to fix issues with Safari
      scope.player.on('ended', function () {
        return scope.playVideo();
      });

      // If the browser can't play the video type (MEDIA_ERR_SRC_NOT_SUPPORTED)
      // then remove that type from the sources and try again.
      // This has been ripped from brightcove.video, the aim is to get
      // this directive updated to use brightcove.video.
      scope.player.on('error', function () {
        var playerError = scope.player.error();
        var playerType = scope.player.currentType();

        if (playerError && playerError.code === 4) {
          scope.video_data.sources = (0, _reject3.default)(scope.video_data.sources, function (source) {
            return source.type === playerType;
          });

          scope.isLoaded = false;
          scope.player.src(scope.video_data.sources);
          scope.player.load();
        }
      });

      element.find('.vjs-big-play-button').off('click').on('click', function () {
        return scope.onPlay();
      });

      $video_el = element.find('.video-js');

      $('.vjs-loading-spinner').remove();
    };

    scope.setVideoData = function () {
      var deferred = $q.defer();
      var id = attrs.videoId;

      if (scope.player && id) {
        scope.player.catalog.getVideo(id, function (error, video_data) {
          scope.video_data = video_data;
          deferred.resolve();
        });
      } else {
        deferred.reject();
      }

      return deferred.promise;
    };

    scope.loadVideo = function () {
      var deferred = $q.defer();

      if (!scope.autoplay) {
        deferred.resolve();
      } else if (scope.player && scope.video_data && !scope.video_data.video_loaded) {
        scope.player.one('loadeddata', function () {
          scope.$emit('video-player:loadeddata');
          scope.video_data.video_loaded = true;
          scope.player.pause();
          deferred.resolve();
        });
        scope.$emit('video-player:loaddata');
        scope.player.src(scope.video_data.sources);
        scope.player.load();
      } else if (scope.player && scope.video_data && scope.video_data.video_loaded) {
        deferred.resolve();
      } else {
        deferred.reject();
      }

      return deferred.promise;
    };

    scope.loadPoster = function () {
      var deferred = $q.defer();

      if (scope.player && scope.video_data) {
        scope.video_data.poster = scope.video_data.poster.replace('/original/', '/large/');

        $timeout(function () {
          $('<img>').attr('src', scope.video_data.poster).on('load', function () {
            return deferred.resolve();
          });
        });
      } else {
        deferred.reject();
      }

      return deferred.promise;
    };

    scope.setPoster = function () {
      if ($video_el && $video_el.length > 0) {
        $video_el.toggleClass('vjs-has-started', false);
      }

      scope.player.poster(scope.video_data.poster);
    };

    scope.clearPoster = function () {
      scope.player.poster('');
    };

    scope.playVideo = function () {
      if (scope.player && scope.autoplay) {
        $timeout(function () {
          var videoPromise = scope.player.play();

          // Shut the error messages up.
          if (videoPromise && videoPromise.then) {
            videoPromise.then(function () {
              return scope.isLoaded = true;
            }).catch(function () {});
          } else {
            scope.isLoaded = true;
          }
        });
      }
    };

    scope.pauseVideo = function () {
      if (scope.player && scope.autoplay && scope.isLoaded) {
        $timeout(function () {
          return scope.player.pause();
        });
      }
    };

    scope.setScale = function () {
      if ($video_el && $video_el.length > 0) {
        var w = $video_el.width(),
            h = $video_el.height() + 10,
            aspect = w / h,
            base_scale = 1 / aspect * 16 / 9,
            scale = parseFloat(attrs.videoScale || 1) * base_scale * 100,
            offset = (100 - scale) / 2;

        $('.vjs-tech, .vjs-poster').css({
          height: scale + '%',
          width: scale + '%',
          top: offset + '%',
          left: offset + '%'
        });
      }
    };

    scope.setExperience = function () {
      scope.coverOn = true;
      scope.onWait();

      if (scope.player) {
        scope.player.reset();
        scope.setScale();
      }

      scope.setVideoData().then(function () {
        scope.loadPoster().then(function () {
          scope.setPoster();
          scope.coverOn = false;
          scope.onResume();

          if (!scope.autoplay) {
            scope.player.src(scope.video_data.sources);
          } else if (scope.playing) {
            scope.loadVideo().then(function () {
              scope.clearPoster();
              scope.play();
            }).catch(function () {});
          }
        });
      }).catch(function () {});
    };

    scope.play = function () {
      if (scope.countdownComplete) {
        scope.playVideo();
      }
    };

    scope.init().then(function () {
      scope.setPlayer();
      scope.setScale();
      scope.setExperience();
    });
  }
}]; // This needs to either be replaced entirely by brightcove video or wrap and
// extend to continue using some of the listeners/watches within this directive.
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "fNHm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NutritionHack = undefined;

var _reduxUiRouter = __webpack_require__("Zb/7");

var _utils = __webpack_require__("0xDb");

var _member = __webpack_require__("1OIp");

var _recipe = __webpack_require__("mew7");

var _favourite = __webpack_require__("GfAe");

var NutritionHack = exports.NutritionHack = {
  template: '\n    <div class="nutrition-collection pb-3">\n      <collection-header\n        collection="$ctrl.collection"\n        is-loading="$ctrl.isLoading">\n      </collection-header>\n      <div class="container pb-3">\n        <div class="row">\n          <div class="col-md-6 pt-4"\n            ng-repeat="item in $ctrl.collection.recipes track by $index">\n            <card-recipe\n              description="item.collectionDescriptionHtml"\n              recipe="item"\n              type="horizontal"\n              on-click="$ctrl.onClick($ctrl.hackId, item)">\n            </card-recipe>\n          </div>\n        </div>\n      </div>\n    </div>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var _this = this;

        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        // Wait for parent hacks collection to finish loading before fetching
        this.interval = setInterval(function () {
          if (!_this.isLoading) {
            clearInterval(_this.interval);

            if (!_this.collection || !_this.collection.recipes.length) {
              _this.fetchRecipeCollection(_this.hackId);
            }
          }
        }, 500);
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();

        if (this.interval) {
          clearInterval(this.interval);
        }
      },
      onClick: function onClick(hackId, _ref) {
        var id = _ref.id,
            name = _ref.name;

        this.stateGo('nutrition.hacks.recipe', {
          hackId: hackId,
          recipeId: id
        });

        _utils.anchorStorage.set($ngRedux.getState(), name);
      },
      mapState: function mapState(_ref2) {
        var favourite = _ref2.favourite,
            member = _ref2.member,
            recipe = _ref2.recipe,
            router = _ref2.router;
        var hackId = router.currentParams.hackId;

        var collection = (0, _favourite.mapIsFavouriteRecipes)((0, _recipe.selectRecipeCollection)(recipe, hackId), (0, _favourite.selectFavouriteRecipeIds)(favourite));
        var newSkimHtml = void 0;
        var newTheWhatHtml = void 0;
        var newTheElseHtml = void 0;
        var newTheWhyHtml = void 0;
        collection && collection.skimHtml ? newSkimHtml = collection.skimHtml.replace(new RegExp('Voome', 'g'), 'Coaching-Zone') : null;
        collection && collection.skimHtml ? collection.skimHtml = newSkimHtml : null;
        collection && collection.theWhatHtml ? newTheWhatHtml = collection.theWhatHtml.replace(new RegExp('Voome', 'g'), 'Coaching-Zone') : null;
        collection && collection.theWhatHtml ? collection.theWhatHtml = newTheWhatHtml : null;
        collection && collection.theElseHtml ? newTheElseHtml = collection.theElseHtml.replace(new RegExp('Voome', 'g'), 'Coaching-Zone') : null;
        collection && collection.theElseHtml ? collection.theElseHtml = newTheElseHtml : null;
        collection && collection.theWhyHtml ? newTheWhyHtml = collection.theWhyHtml.replace(new RegExp('Voome', 'g'), 'Coaching-Zone') : null;
        collection && collection.theWhyHtml ? collection.theWhyHtml = newTheWhyHtml : null;
        return {
          hackId: hackId,
          isLoading: recipe.isLoading,
          collection: collection
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          fetchRecipeCollection: _recipe.fetchRecipeCollection,
          stateGo: _reduxUiRouter.stateGo
        };
      }
    };
  }]
};

/***/ }),

/***/ "fQFf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.snakeCase = undefined;

var _snakeCase3 = __webpack_require__("OAqO");

var _snakeCase4 = _interopRequireDefault(_snakeCase3);

var _memoize2 = __webpack_require__("zGZ6");

var _memoize3 = _interopRequireDefault(_memoize2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var snakeCase = exports.snakeCase = function snakeCase() {
  return (0, _memoize3.default)(_snakeCase4.default);
};

/***/ }),

/***/ "fXn8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.raven = undefined;

var _angular = __webpack_require__("/jXN");

var _angular2 = _interopRequireDefault(_angular);

var _ravenJs = __webpack_require__("/Hyb");

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _angular3 = __webpack_require__("BY2X");

var _angular4 = _interopRequireDefault(_angular3);

var _settings = __webpack_require__("Ll2K");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (_settings.hosts.sentry) {
  var options = {
    release: _settings.version,
    ignoreErrors: ['top.GLOBALS', 'originalCreateNotification', 'canvas.contentDocument', 'fb_xd_fragment', 'bmi_SafeAddOnload', 'EBCallBackMessageReceived', 'conduitPage', 'ntp is not defined'],
    ignoreUrls: [/graph\.facebook\.com/i, /connect\.facebook\.net\/en_US\/all\.js/i, /extensions\//i, /^chrome:\/\//i, /metrics\.itunes\.apple\.com\.edgesuite\.net\//i],
    whitelistUrls: [/https?:\/\/((dev|uat)-)?programs\.voome\.com\.au/],
    shouldSendCallback: function shouldSendCallback() {
      // only send 10% of errors
      return Math.random() * 100 <= 10;
    }
  };

  _ravenJs2.default.config(_settings.hosts.sentry, options).addPlugin(_angular4.default, _angular2.default).install();
}

var raven = exports.raven = _ravenJs2.default;

/***/ }),

/***/ "ftdg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Workouts = undefined;

var _theme = __webpack_require__("ZID5");

var _member = __webpack_require__("1OIp");

var Workouts = exports.Workouts = {
  template: '\n    <div class="workouts bg-gray-100">\n      <ui-view autoscroll="false"></ui-view>\n    </div>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);
        this.setNavChildren('workouts');
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();
        this.setNavChildren();
      },
      mapState: function mapState(_ref) {
        var member = _ref.member,
            router = _ref.router;

        return {
          hasAccess: (0, _member.selectHasWorkoutSubscription)(member)
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          setNavChildren: _theme.setNavChildren
        };
      }
    };
  }]
};

/***/ }),

/***/ "g+GI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var NavProductTitle = exports.NavProductTitle = {
  bindings: {
    title: '<',
    firstName: '<',
    lastName: '<'
  },

  template: '\n    <div class="nav-product-title">\n      <div class="d-flex flex-column align-items-md-end text-white">\n        <span ng-bind="$ctrl.title"></span>\n        <small ng-if="$ctrl.firstName" class="d-none d-md-inline">\n          by {{ $ctrl.firstName }}\n          <span ng-if="$ctrl.firstName !== \'Voome\'">\n            {{ $ctrl.lastName }}\n          </span>\n        </small>\n      </div>\n    </div>'
};

/***/ }),

/***/ "gPEb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecipePreview = undefined;

var _get2 = __webpack_require__("Q7hp");

var _get3 = _interopRequireDefault(_get2);

var _recipe = __webpack_require__("mew7");

var _favourite = __webpack_require__("GfAe");

var _member = __webpack_require__("1OIp");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RecipePreview = exports.RecipePreview = {
  bindings: {
    recipeId: '<',
    showOn: '<'
  },

  template: '\n    <div\n      id="modalRecipePreview"\n      class="modal fade"\n      tabindex="-1"\n      role="dialog"\n      aria-labelledby="Preview Recipe"\n      aria-hidden="true">\n      <div class="modal-dialog" role="document">\n        <div class="modal-content">\n          <div class="modal-header d-flex align-items-center mx-1">\n            <h2 class="modal-title mb-0">\n              {{ $ctrl.recipe.name }}\n            </h2>\n            <button-print\n              uri="{{ $ctrl.printUri }}"\n              tooltip="$ctrl.tooltip"\n              ng-click="$ctrl.refetchMember()"\n              ng-if="$ctrl.subscription.canPrint">\n            </button-print>\n          </div>\n          <div class="modal-body text-left">\n            <recipe-detail\n              recipe="$ctrl.recipe"\n              is-favourite="$ctrl.recipe.isFavourite"\n              on-favourite="$ctrl.toggleFavouriteRecipe({\n                memberId: $ctrl.member.id,\n                recipeId: $ctrl.recipe.id,\n                isFavourite: $ctrl.recipe.isFavourite,\n              })">\n            </recipe-detail>\n          </div>\n          <div class="modal-footer">\n            <button-primary data-dismiss="modal">\n              Close\n            </button-primary>\n          </div>\n        </div>\n      </div>\n    </div>',

  controller: ["$element", "$ngRedux", "$timeout", function controller($element, $ngRedux, $timeout) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState.bind(this), this.mapDispatch());

        this.unsubscribe = connect(this);
        this.modal = $element.find('#modalRecipePreview');
      },
      $onChanges: function $onChanges(changes) {
        if ((0, _get3.default)(changes, 'showOn.currentValue') === true) {
          this.show();
        }
      },
      $onDestroy: function $onDestroy() {
        this.unsubscribe();
      },
      refetchMember: function refetchMember() {
        var _this = this;

        this.tooltip && $timeout(function () {
          return _this.fetchMember(_this.member.id);
        }, 500);
      },
      show: function show() {
        if (this.recipe.id !== this.recipeId || !this.recipe.nutritionSummary) {
          this.fetchRecipe(this.recipeId);
        }

        this.modal.modal('show');
      },
      hide: function hide() {
        this.modal.modal('hide');
      },
      mapState: function mapState(_ref) {
        var favourite = _ref.favourite,
            member = _ref.member,
            recipe = _ref.recipe;

        var subscription = (0, _member.selectSubscription)(member);

        return {
          subscription: subscription,
          member: (0, _member.selectMember)(member),
          tooltip: (0, _member.selectPrintTooltip)(member),
          printUri: subscription.canPrint && (0, _recipe.recipePrintUri)(this.recipeId, subscription.id),
          recipe: (0, _favourite.mapIsFavouriteRecipes)((0, _recipe.selectRecipe)(recipe, this.recipeId), (0, _favourite.selectFavouriteRecipeIds)(favourite))
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          fetchMember: _member.fetchMember,
          fetchRecipe: _recipe.fetchRecipe,
          toggleFavouriteRecipe: _favourite.toggleFavouriteRecipe
        };
      }
    };
  }]
};

/***/ }),

/***/ "gYly":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ngReduxProvider = undefined;

var _reduxLogic = __webpack_require__("E0Bt");

var _reduxLogger = __webpack_require__("oSVy");

var _logic = __webpack_require__("2P+a");

var _utils = __webpack_require__("0xDb");

var ngReduxProvider = exports.ngReduxProvider = ["$ngReduxProvider", function ngReduxProvider($ngReduxProvider) {
  'ngInject';

  var logic = (0, _reduxLogic.createLogicMiddleware)(_logic.rootLogic, {
    dataLayer: _utils.dataLayer,
    httpClient: _utils.httpClient,
    memberStorage: _utils.memberStorage
  });

  var middleware = ['ngUiRouterMiddleware', logic];
  var enhancers = [];

  // Add logger and devtools in development
  if (false) {
    var logger = (0, _reduxLogger.createLogger)({
      level: 'info',
      collapsed: true
    });

    middleware.push(logger);

    var _require = require('redux-devtools-extension/developmentOnly'),
        devToolsEnhancer = _require.devToolsEnhancer;

    enhancers.push(devToolsEnhancer());
  }

  $ngReduxProvider.createStoreWith(_logic.rootReducer, middleware, enhancers);
}];

/***/ }),

/***/ "ggN2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WorkoutPlayerContextItem = exports.WorkoutPlayerContextItem = {
  bindings: {
    data: '<'
  },

  template: '\n    <i class="fa fa-chevron-right"></i>\n    {{ $ctrl.data.name }}\n    <i class="fa fa-info-circle" ng-if="$ctrl.data.contentHtml"></i>'
};

/***/ }),

/***/ "hKzP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MealPlanSwap = exports.MealPlanSwap = {
  bindings: {
    recipe: '<',
    selected: '<',
    onSwap: '&',
    onPreview: '&'
  },

  template: '\n    <div class="meal-plan-swap card-wrapper"\n      ng-class="{ \'theme-border\': $ctrl.recipe.id === $ctrl.selected.id }">\n      <card\n        heading="$ctrl.recipe.name"\n        img="$ctrl.recipe.imageUrl.magazine"\n        ng-click="$ctrl.onSwap()">\n      </card>\n      <button class="meal-plan-preview btn btn-link w-100"\n        type="button"\n        ng-click="$ctrl.onPreview()">\n        Preview\n      </button>\n    </div>'
};

/***/ }),

/***/ "hMSj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FormSelect = exports.FormSelect = {
  transclude: true,

  bindings: {
    errors: '<',
    form: '<',
    name: '@',
    onUpdate: '&',
    required: '@',
    value: '<'
  },

  template: '\n    <select class="form-control"\n      ng-class="{\n        \'is-valid\': $ctrl.form[$ctrl.name].$touched && $ctrl.form[$ctrl.name].$valid,\n        \'is-invalid\': $ctrl.form[$ctrl.name].$touched && $ctrl.form[$ctrl.name].$invalid,\n      }"\n      id="{{ $ctrl.name }}"\n      name="{{ $ctrl.name }}"\n      ng-value="$ctrl.value"\n      ng-model="$ctrl.form.data[$ctrl.name]"\n      ng-init="$ctrl.form.data[$ctrl.name] = $ctrl.value"\n      ng-required="{{ $ctrl.required }}"\n      ng-change="$ctrl.onChange()"\n      ng-transclude>\n    </select>\n    <form-errors\n      field="$ctrl.form[$ctrl.name]"\n      errors="$ctrl.errors"/>',

  controller: function controller() {
    return {
      // For some reason ng-value is not updating ng-model when $ctrl.value
      // resolves. $onChanges is essentially doing this manually.
      $onChanges: function $onChanges() {
        var field = this.form[this.name];

        if (this.value && field && !field.$viewValue) {
          field.$setViewValue(this.value);
        }
      },


      // The $setViewValue within $onChanges will fire the ng-change so only
      // call onUpdate when $ctrl.value has actually changed.
      onChange: function onChange() {
        var key = this.name;
        var value = this.form.data[this.name];
        var field = this.form[this.name];

        if (field.$valid && value !== this.value) {
          this.onUpdate({ key: key, value: value });
        }
      }
    };
  }
};

/***/ }),

/***/ "i/0x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.videoStorage = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _store = __webpack_require__("Y4FN");

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var KEY = 'videos';

var get = function get() {
  return _store2.default.get(KEY) || {};
};

var set = function set(id, currentTime) {
  if (id && currentTime) {
    _store2.default.set(KEY, _extends({}, get(), _defineProperty({}, id, currentTime)));
  }
};

var remove = function remove(id) {
  if (id) {
    _store2.default.set(KEY, _extends({}, get(), _defineProperty({}, id, undefined)));
  }
};

var videoStorage = exports.videoStorage = {
  get: get,
  set: set,
  remove: remove
};

/***/ }),

/***/ "i6qM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iAmj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var NutritionInformation = exports.NutritionInformation = {
  bindings: {
    data: '<',
    serves: '<'
  },

  template: '\n    <div class="nutrition-information card bg-gray-100 p-3">\n      <h5>Nutritional Information</h5>\n      <div class="pill-toggle d-flex w-100 mt-2">\n        <button class="btn btn-sm btn-pill w-100"\n          type="button"\n          ng-class="{ \'btn-primary text-white\': $ctrl.mode == \'per_serve\' }"\n          ng-click="$ctrl.mode = \'per_serve\'">\n          Per Serve<span ng-show="$ctrl.serves">*</span>\n        </button>\n        <button class="btn btn-sm btn-pill w-100"\n          type="button"\n          ng-class="{ \'btn-primary\': $ctrl.mode == \'per_grams\' }"\n          ng-click="$ctrl.mode = \'per_grams\'">\n          Per 100g\n        </button>\n      </div>\n      <table class="table table-sm">\n        <tr>\n          <td class="border-top-0"><strong>Calories</strong></td>\n          <td class="border-top-0 text-right">\n            <strong ng-if="$ctrl.mode == \'per_serve\'">{{ $ctrl.calculatePerServe($ctrl.data.calculatedCalories, $ctrl.serves) | number:1 }} Cal</strong>\n            <strong ng-if="$ctrl.mode == \'per_grams\'">{{ $ctrl.calculatePerGrams($ctrl.data.calculatedCalories, $ctrl.data.calculatedWeight) | number:1 }} Cal</strong>\n          </td>\n        </tr>\n        <tr>\n          <td>Protein</td>\n          <td class="text-right">\n            <span ng-if="$ctrl.mode == \'per_serve\'">{{ $ctrl.calculatePerServe($ctrl.data.proteinInG, $ctrl.serves) | number:1 }}g</span>\n            <span ng-if="$ctrl.mode == \'per_grams\'">{{ $ctrl.calculatePerGrams($ctrl.data.proteinInG, $ctrl.data.calculatedWeight) | number:1 }}g</span>\n          </td>\n        </tr>\n        <tr>\n          <td>Fat Total</td>\n          <td class="text-right">\n            <span ng-if="$ctrl.mode == \'per_serve\'">{{ $ctrl.calculatePerServe($ctrl.data.fatTotalInG, $ctrl.serves) | number:1 }}g</span>\n            <span ng-if="$ctrl.mode == \'per_grams\'">{{ $ctrl.calculatePerGrams($ctrl.data.fatTotalInG, $ctrl.data.calculatedWeight) | number:1 }}g</span>\n          </td>\n        </tr>\n        <tr>\n          <td>Fat Saturated</td>\n          <td class="text-right">\n            <span ng-if="$ctrl.mode == \'per_serve\'">{{ $ctrl.calculatePerServe($ctrl.data.fatSaturatedInG, $ctrl.serves) | number:1 }}g</span>\n            <span ng-if="$ctrl.mode == \'per_grams\'">{{ $ctrl.calculatePerGrams($ctrl.data.fatSaturatedInG, $ctrl.data.calculatedWeight) | number:1 }}g</span>\n          </td>\n        </tr>\n        <tr>\n          <td>Carbohydrates</td>\n          <td class="text-right">\n            <span ng-if="$ctrl.mode == \'per_serve\'">{{ $ctrl.calculatePerServe($ctrl.data.carbohydratesInG, $ctrl.serves) | number:1 }}g</span>\n            <span ng-if="$ctrl.mode == \'per_grams\'">{{ $ctrl.calculatePerGrams($ctrl.data.carbohydratesInG, $ctrl.data.calculatedWeight) | number:1 }}g</span>\n          </td>\n        </tr>\n        <tr>\n          <td>Sugars</td>\n          <td class="text-right">\n            <span ng-if="$ctrl.mode == \'per_serve\'">{{ $ctrl.calculatePerServe($ctrl.data.sugarsInG, $ctrl.serves) | number:1 }}g</span>\n            <span ng-if="$ctrl.mode == \'per_grams\'">{{ $ctrl.calculatePerGrams($ctrl.data.sugarsInG, $ctrl.data.calculatedWeight) | number:1 }}g</span>\n          </td>\n        </tr>\n        <tr>\n          <td>Sodium</td>\n          <td class="text-right">\n            <span ng-if="$ctrl.mode == \'per_serve\'">{{ $ctrl.calculatePerServe($ctrl.data.sodiumInMg, $ctrl.serves) | number:1 }}mg</span>\n            <span ng-if="$ctrl.mode == \'per_grams\'">{{ $ctrl.calculatePerGrams($ctrl.data.sodiumInMg, $ctrl.data.calculatedWeight) | number:1 }}mg</span>\n          </td>\n        </tr>\n        <tr ng-="$ctrl.data.fibreInG > 0">\n          <td>Dietary Fibre</td>\n          <td class="text-right">\n            <span ng-if="$ctrl.mode == \'per_serve\'">{{ $ctrl.calculatePerServe($ctrl.data.fibreInG, $ctrl.serves) | number:1 }}g</span>\n            <span ng-if="$ctrl.mode == \'per_grams\'">{{ $ctrl.calculatePerGrams($ctrl.data.fibreInG, $ctrl.data.calculatedWeight) | number:1 }}g</span>\n          </td>\n        </tr>\n        <tr ng-show="$ctrl.serves" class="text-right">\n          <td colspan="2">\n            * This recipe has\n            <strong ng-pluralize count="$ctrl.serves" when="{\'one\': \'1 serve.\', \'other\': \'{} serves\'}"></strong>.\n          </td>\n        </tr>\n        <tr ng-show="$ctrl.data[\'highProtein?\']">\n          <td colspan="2">\n            <a href="#" ng-click="show_protein = !show_protein">\n              High in Protein\n              <span class="float-right">\n                <i class="fa" ng-class="{ \'fa-angle-up\': show_protein, \'fa-angle-down\': !show_protein }"></i>\n              </span>\n            </a>\n            <div\n              class="mt-2"\n              ng-show="show_protein">\n              <div class="details">\n                <p><em>Protein is used by the body to build, grown, repair and maintain every part of your body.</em></p>\n                <p>When we start exercising our body requires extra protein to help repair the muscle damage we cause (this is good damage!) and to grow new muscle. Ladies you need 45-60g protein per day. Blokes, you need more, approximately 65-80g per day. </p>\n                <p>Muscle is like an engine, it burns through energy (Calories) - so the more muscle we have the more energy we burn. Stock up on high protein meals (15g protein per serve) and snacks (5g protein per serve) after a hard training session.</p>\n                <p>Protein also helps keep you feeling fuller for longer, so try to include some in every meal.</p>\n                <p><button ng-click="show_protein=false" type="button" class="btn btn-pill btn-sm btn-primary">Close</button></p>\n              </div>\n            </div>\n          </td>\n        </tr>\n        <tr ng-show="$ctrl.data[\'highCarb?\']">\n          <td colspan="2">\n            <a href="#" ng-click="show_carbs = !show_carbs">\n              High in Carbohydrates\n              <span class="float-right">\n                <i class="fa" ng-class="{ \'fa-angle-up\': show_carbs, \'fa-angle-down\': !show_carbs }"></i>\n              </span>\n            </a>\n            <div\n              class="mt-2"\n              ng-show="show_carbs">\n              <div class="details">\n                <p><em>Carbohydrates are the primary source of energy for your body.</em></p>\n                <p>Our body needs carbohydrate for brain function, red blood cell health and to burn fat! Carbohydrates are found in breads & cereals, rice, pasta, starchy veggies such as potato, fruit & dairy foods.</p>\n                <p>When choosing foods that contain carbohydrates consider the ingredients. For example, if a breakfast cereal contains dried fruit, it should have a slightly higher sugar level that one that does not. Choose grainy breads- the more grains you can see the better and look for Low GI (Glycemic Index) foods as these will provide you longer lasting energy and will help keep you feeling fuller for longer. Note not all foods have been tested nor display their Glycemic Index.</p>\n                <p>A high carb meal contains at least 70g carbs per serve and a high carb snack, 20g or more. For those looking for a low carb option, a low carb meal contains 40g or less carbs per serve and a snack contains 15g or less carbs per serve.</p>\n                <p><button ng-click="show_carbs=false" type="button" class="btn btn-pill btn-sm btn-primary">Close</button></p>\n              </div>\n            </div>\n          </td>\n        </tr>\n        <tr ng-show="$ctrl.data[\'lowCarb?\']">\n          <td colspan="2">\n            <a href="#" ng-click="show_carbs = !show_carbs">\n              Low in Carbohydrates\n              <span class="float-right">\n                <i class="fa" ng-class="{ \'fa-angle-up\': show_carbs, \'fa-angle-down\': !show_carbs }"></i>\n              </span>\n            </a>\n            <div\n              class="mt-2"\n              ng-show="show_carbs">\n              <div class="details">\n                <p><em>Carbohydrates are the primary source of energy for your body.</em></p>\n                <p>Our body needs carbohydrate for brain function, red blood cell health and to burn fat! Carbohydrates are found in breads & cereals, rice, pasta, starchy veggies such as potato, fruit & dairy foods.</p>\n                <p>When choosing foods that contain carbohydrates consider the ingredients. For example, if a breakfast cereal contains dried fruit, it should have a slightly higher sugar level that one that does not. Choose grainy breads- the more grains you can see the better and look for Low GI (Glycemic Index) foods as these will provide you longer lasting energy and will help keep you feeling fuller for longer. Note not all foods have been tested nor display their Glycemic Index.</p>\n                <p>A high carb meal contains at least 70g carbs per serve and a high carb snack, 20g or more. For those looking for a low carb option, a low carb meal contains 40g or less carbs per serve and a snack contains 15g or less carbs per serve.</p>\n                <p><button ng-click="show_carbs=false" type="button" class="btn btn-pill btn-sm btn-primary">Close</button></p>\n              </div>\n            </div>\n          </td>\n        </tr>\n        <tr ng-show="$ctrl.data[\'highFibre?\']">\n          <td colspan="2">\n            <a href="#" ng-click="show_fibre = !show_fibre">\n              High in Fibre\n              <span class="float-right">\n                <i class="fa" ng-class="{ \'fa-angle-up\': show_fibre, \'fa-angle-down\': !show_fibre }"></i>\n              </span>\n            </a>\n            <div\n              class="mt-2"\n              ng-show="show_fibre">\n              <div class="details">\n                <p><em>Fibre is what keeps our guts happy.</em></p>\n                <p>Fibre is essential to good gut health. It is what all the bacteria in your gut feasts on to help keep your bowel in good shape. Ladies should be aiming for 25g fibre per day and blokes should be going for 30g.</p>\n                <p>A high fibre meal contains 6g or more fibre per serve. A high fibre snack has 3g or more fibre.</p>\n                <p><button ng-click="show_fibre=false" type="button" class="btn btn-pill btn-sm btn-primary">Close</button></p>\n              </div>\n            </div>\n          </td>\n        </tr>\n        <tr ng-show="$ctrl.data[\'lowFat?\']">\n          <td colspan="2">\n            <a href="#" ng-click="show_fat = !show_fat">\n              Low in Fat\n              <span class="float-right">\n                <i class="fa" ng-class="{ \'fa-angle-up\': low_fat, \'fa-angle-down\': !low_fat }"></i>\n              </span>\n            </a>\n            <div\n              class="mt-2"\n              ng-show="show_fat">\n              <div class="details">\n                <p><em>Fat is the most concentrated energy source in our diet.</em></p>\n                <p>There are three different types of fat- mono-unsaturated, poly-unsaturated and saturated. The unsaturated fat is actually great for our bodies (in small amounts) and helps to protect against elevated cholesterol and other lifestyle diseases. Saturated fat, on the other hand, is the stuff that helps increase our risk of developing all of these lifestyle diseases. Fat is the last source of energy that our bodies tap into after carbohydrate and protein, so eating foods that are high in fat helps us add to the collection of fat already in our bodies that we need to burn. From a heart health and a weight management perspective, try to limit fat intake to no more than 70g per day.</p>\n                <p>A meal that is low in fat contains less than 10g fat per serve and a low fat snack contains less than 3g fat per serve.</p>\n                <p><button ng-click="show_fat=false" type="button" class="btn btn-pill btn-sm btn-primary">Close</button></p>\n              </div>\n            </div>\n          </td>\n        </tr>\n        <tr ng-show="$ctrl.data[\'lowSodium?\']">\n          <td colspan="2">\n            <a href="#" ng-click="show_sodium = !show_sodium">\n              Low in Sodium\n              <span class="float-right">\n                <i class="fa" ng-class="{ \'fa-angle-up\': low_sodium, \'fa-angle-down\': !low_sodium }"></i>\n              </span>\n            </a>\n            <div\n              class="mt-2"\n              ng-show="show_sodium">\n              <div class="details">\n                <p><em>Too much sodium can lead to high blood pressure.</em></p>\n                <p>The most common source of sodium in our diet is from salt, whether it be added at the table, during the cooking process or even in the manufacturing stage. Research has shown that as our intake of sodium increases, so too does our risk of developing high blood pressure and other heart related diseases. Often salt is found in foods that you would never imagine were salty such as bread, breakfast cereals and some meats. When looking for a low salt product aim for less than 500mg per serve for a meal and 200mg or less for a snack. Try to limit your daily sodium intake to 2300mg.</p>\n                <p><button ng-click="show_sodium=false" type="button" class="btn btn-pill btn-sm btn-primary">Close</button></p>\n              </div>\n            </div>\n          </td>\n        </tr>\n        <tr ng-show="$ctrl.data[\'lactoseFree?\']">\n          <td colspan="2" class="text-green-dark">\n            Lactose Free\n          </td>\n        </tr>\n        <tr ng-show="$ctrl.data[\'glutenFree?\']">\n          <td colspan="2" class="text-green-dark">\n            Gluten Free\n          </td>\n        </tr>\n      </table>\n      <p class="small text-gray mb-0">\n        Nutritional information provided on Coaching Zone is taken from sources provided by\n        third parties, including the Food Standards Australia New Zealand (FSANZ)\n        NUTTAB 2010 guide to nutrient content. Refer to site\n        <a href="https://voome.com.au/terms">Terms &amp; Conditions</a>\n        for further information.\n      </p>\n    </div>',

  controller: function controller() {
    return {
      $onInit: function $onInit() {
        this.mode = 'per_serve';
      },
      calculatePerServe: function calculatePerServe(value, serves) {
        return value * 1 / serves;
      },
      calculatePerGrams: function calculatePerGrams(value, weight) {
        return value * 100 / weight;
      }
    };
  }
};

/***/ }),

/***/ "iKpI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iaqb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ProfileActions = exports.ProfileActions = {
  bindings: {
    isLoading: '<',
    isDisabled: '<',
    ngType: '@',
    onCancel: '&',
    onSubmit: '&'
  },

  template: '\n    <div class="form-row justify-content-end">\n      <div class="col-md-8" ng-switch="$ctrl.ngType">\n        <hr class="mt-0 mb-4">\n        <span class="mr-2">\n          <button class="btn btn-link"\n            type="button"\n            ng-disabled="$ctrl.isLoading"\n            ng-click="$ctrl.onCancel()">\n            Cancel\n          </button>\n        </span>\n        <span ng-switch-when="button">\n          <button-primary\n            ng-type="button"\n            ng-disabled="$ctrl.isDisabled"\n            on-click="$ctrl.onSubmit()">\n            <spinner is-loading="$ctrl.isLoading">\n              Submit\n            </spinner>\n          </button-primary>\n        </span>\n        <span ng-switch-default>\n          <button-primary\n            ng-type="submit"\n            ng-disabled="$ctrl.isDisabled">\n            <spinner is-loading="$ctrl.isLoading">\n              Submit\n            </spinner>\n          </button-primary>\n        </span>\n      </div>\n    </div>'
};

/***/ }),

/***/ "ikrk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PROFILE_CANCELLATION_REASONS = exports.PROFILE_CANCELLATION_REASONS = ["I'm taking a break", 'I have an injury/illness', "I'm using a different app or site", "It's not value for money", "It's not what I expected", "I'm bored with Voome", 'Another reason'];

var PROFILE_NUTRITION = exports.PROFILE_NUTRITION = [{
  key: 'proteinList',
  label: 'Proteins',
  question: 'What proteins do you prefer to eat?',
  type: 'checkbox'
}, {
  key: 'mealTypeList',
  label: 'Meal Types',
  question: 'What sort of food do you enjoy? You may pick a few.',
  type: 'checkbox'
}, {
  key: 'mealList',
  label: 'Meal List',
  question: 'Which meals are you thinking of cooking with Coaching Zone recipes?',
  type: 'checkbox'
}, {
  key: 'allergyList',
  label: 'Food Allergies',
  question: 'Specific dietary needs?',
  type: 'checkbox'
}];

var PROFILE_WORKOUT = exports.PROFILE_WORKOUT = [{
  key: 'fitnessLevelList',
  label: 'Fitness Level',
  question: 'How would you rate your fitness?',
  type: 'radio'
}, {
  key: 'fitnessLocationList',
  label: 'Workout Location',
  question: 'Where do you like to workout? You can pick more than one.',
  type: 'checkbox'
}, {
  key: 'fitnessTypeList',
  label: 'Focus',
  question: 'What would you like to focus or improve on?',
  type: 'checkbox'
}];

/***/ }),

/***/ "j94E":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateParam = exports.searchAppend = exports.resetSearch = exports.searchWorkouts = exports.searchRecipes = exports.parseParams = exports.parseAllowedParams = exports.selectSearchParams = exports.selectSearchPagination = exports.selectSearchResults = exports.searchLogic = undefined;

var _identity2 = __webpack_require__("wSKX");

var _identity3 = _interopRequireDefault(_identity2);

var _pickBy2 = __webpack_require__("6PBa");

var _pickBy3 = _interopRequireDefault(_pickBy2);

var _pick2 = __webpack_require__("w9Mt");

var _pick3 = _interopRequireDefault(_pick2);

var _keys2 = __webpack_require__("ktak");

var _keys3 = _interopRequireDefault(_keys2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;

var _reduxLogic = __webpack_require__("E0Bt");

var _decorators = __webpack_require__("SPxS");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Action Types
var CANCEL = '@@app/search/CANCEL';
var FETCH = '@@app/search/FETCH';
var FETCH_SUCCESS = '@@app/search/FETCH_SUCCESS';
var FETCH_ERROR = '@@app/search/FETCH_ERROR';
var RESET = '@@app/search/RESET';
var UPDATE_PARAM = '@@app/search/UPDATE_PARAM';
var UPDATE_PARAM_ERROR = '@@app/search/UPDATE_PARAM_ERROR';
var UPDATE_APPEND = '@@app/search/UPDATE_APPEND';

// Initial State
var initialState = {
  loading: false,
  append: false,
  message: '',
  results: [],
  pagination: {},
  params: {
    filters: '',
    level: '1',
    order: '',
    q: '',
    page: '1',
    serves: ''
  }
};

// Observables
var fetchLogic = (0, _reduxLogic.createLogic)({
  type: FETCH,
  cancelType: CANCEL,
  processOptions: {
    successType: FETCH_SUCCESS,
    failType: FETCH_ERROR
  },
  process: function process(_ref) {
    var action = _ref.action,
        httpClient = _ref.httpClient;
    var _action$payload = action.payload,
        endpoint = _action$payload.endpoint,
        key = _action$payload.key,
        params = _action$payload.params;


    return httpClient.get(endpoint, { params: params }).then(function (response) {
      var data = response.data[key];

      if (key === 'recipes') {
        data = data.map(addRecipeVariations);
        data = (0, _decorators.decorateRecipes)(data);
      }

      return _extends({}, response, { data: data });
    });
  }
});

var validateParamLogic = (0, _reduxLogic.createLogic)({
  type: UPDATE_PARAM,
  validate: function validate(_ref2, allow, reject) {
    var action = _ref2.action;

    if (initialState.params[action.payload.key]) {
      allow(action);
    } else {
      reject({ type: UPDATE_PARAM_ERROR, error: true });
    }
  }
});

var searchLogic = exports.searchLogic = [fetchLogic, validateParamLogic];

// Selectors
var selectSearchResults = exports.selectSearchResults = function selectSearchResults(state) {
  return state.results;
};

var selectSearchPagination = exports.selectSearchPagination = function selectSearchPagination(state) {
  return state.pagination;
};

var selectSearchParams = exports.selectSearchParams = function selectSearchParams(state) {
  return state.params;
};

// Helpers
var parseAllowedParams = exports.parseAllowedParams = function parseAllowedParams() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return parseParams((0, _pick3.default)(params, (0, _keys3.default)(initialState.params)));
};

var parseParams = exports.parseParams = function parseParams() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return (0, _pickBy3.default)(params, _identity3.default);
};

// Action Creators
var searchRecipes = exports.searchRecipes = function searchRecipes() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    type: FETCH,
    payload: {
      endpoint: '/v1/voome/recipe-collections/master',
      key: 'recipes',
      params: parseAllowedParams(params)
    }
  };
};

var searchWorkouts = exports.searchWorkouts = function searchWorkouts() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    type: FETCH,
    payload: {
      endpoint: '/v1/voome/workout-collections/master',
      key: 'workouts',
      params: parseAllowedParams(params)
    }
  };
};

var resetSearch = exports.resetSearch = function resetSearch() {
  return { type: RESET };
};

var searchAppend = exports.searchAppend = function searchAppend(payload) {
  return { type: UPDATE_APPEND, payload: payload };
};

var updateParam = exports.updateParam = function updateParam(key, value) {
  return {
    type: UPDATE_PARAM,
    payload: { key: key, value: String(value) }
  };
};

// Helpers
// The API will return this at some point
// https://redant.jira.com/browse/MB-19764
var addRecipeVariations = function addRecipeVariations(recipe) {
  var id = recipe.id,
      multiServeVariationId = recipe.multiServeVariationId,
      serves = recipe.serves;

  var variations = [{ id: id, serves: serves }];

  if (multiServeVariationId) {
    variations.push({ id: multiServeVariationId, serves: 1 });
  }

  return _extends({}, recipe, { variations: variations });
};

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case RESET:
      return _extends({}, initialState);

    case FETCH:
      return _extends({}, state, {
        loading: true,
        message: '',
        params: _extends({}, initialState.params, payload.params)
      });

    case FETCH_SUCCESS:
      return _extends({}, state, {
        loading: false,
        results: [].concat(_toConsumableArray(state.append ? state.results : []), _toConsumableArray(payload.data)),
        pagination: payload.pagination
      });

    case FETCH_ERROR:
      return _extends({}, state, {
        loading: false,
        message: 'An error occured performing the search.'
      });

    case UPDATE_APPEND:
      return _extends({}, state, {
        append: payload
      });

    case UPDATE_PARAM:
      return _extends({}, state, {
        params: _extends({}, state.params, _defineProperty({}, payload.key, payload.value))
      });

    case UPDATE_PARAM_ERROR:
      return _extends({}, state, {
        message: 'An error occured setting a param.'
      });

    default:
      return state;
  }
}

/***/ }),

/***/ "jJK1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormResetPassword = undefined;

var _settings = __webpack_require__("Ll2K");

var FormResetPassword = exports.FormResetPassword = {
  bindings: {
    email: '<',
    isUpdate: '<',
    member: '<',
    onSubmit: '&',
    resetPasswordToken: '<'
  },

  template: '\n    <form class="voome-form"\n      name="form"\n      autocomplete="off"\n      ng-submit="$ctrl.onSubmit({ data: form.data })"\n      novalidate>\n      <div ng-hide="$ctrl.member.success">\n        <div ng-if="!$ctrl.isUpdate">\n          <p class="pb-4">\n            Enter your email address to recover your password.\n          </p>\n          <form-group-row>\n            <form-group-left>\n              <form-label for="email">Your Email</form-label>\n            </form-group-left>\n            <form-group-right>\n              <form-input\n                form="form"\n                type="email"\n                name="email"\n                value="$ctrl.email"\n                required="true"\n                errors="{\n                  required: \'This is a required field.\',\n                  email: \'Must be a valid email address.\',\n                }">\n              </form-input>\n            </form-group-right>\n          </form-group-row>\n          <form-input\n            form="form"\n            type="hidden"\n            name="callbackUrl"\n            value="\'' + _settings.hosts.go + '/reset-password\'">\n          </form-input>\n          <form-input\n            form="form"\n            type="hidden"\n            name="theme"\n            value="\'voome\'">\n          </form-input>\n        </div>\n        <div ng-if="$ctrl.isUpdate">\n          <p>Create you new password.</p>\n          <form-input\n            form="form"\n            type="hidden"\n            name="email"\n            value="$ctrl.email">\n          </form-input>\n          <form-input\n            form="form"\n            type="hidden"\n            name="resetPasswordToken"\n            value="$ctrl.resetPasswordToken">\n          </form-input>\n          <form-group-row>\n            <form-group-left>\n              <form-label>Email</form-label>\n            </form-group-left>\n            <form-group-right>\n              <div class="pt-1 pl-3">{{ $ctrl.email }}</div>\n            </form-group-right>\n          </form-group-row>\n          <profile-fields-password form="form"></profile-fields-password>\n        </div>\n      </div>\n      <div class="form-group form-row justify-content-end">\n        <div ng-class="{\n          \'col-sm-8\': !$ctrl.member.success,\n          \'w-100 text-center\': $ctrl.member.success\n        }">\n          <span ng-hide="$ctrl.member.success">\n            <button-primary ng-type="submit" ng-disabled="form.$invalid">\n              Submit\n            </button-primary>\n            <span class="px-3">|</span>\n          </span>\n          <a ui-sref="login">Back to login</a>\n        </div>\n      </div>\n    </form>'
};

/***/ }),

/***/ "jNVY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// TODO: refactor to a component.
var NutritionBmi = exports.NutritionBmi = ["$timeout", function NutritionBmi($timeout) {
  'ngInject';

  var Controller = function Controller() {
    this.bmi = 0;
    this.markers = [0, 18.5, 25, 30, 50];
    this.styles = ['under', 'healthy', 'over', 'obese'];
  };

  Controller.prototype.bmiMarkerPercent = function () {
    var offset,
        prev,
        curr,
        range,
        width = 100 / (this.markers.length - 1);

    for (var i = 1; i < this.markers.length; i++) {
      offset = (i - 1) * width;
      prev = this.markers[i - 1];
      curr = this.markers[i];
      range = curr - prev;

      if (this.bmi <= curr) {
        return (offset + (this.bmi - prev) / range * width).toFixed(1);
      }
    }

    return 100;
  };

  Controller.prototype.bmiClassName = function () {
    var className = '';

    if (this.bmi < this.markers[4]) {
      className = this.styles[3];
    }

    if (this.bmi < this.markers[3]) {
      className = this.styles[2];
    }

    if (this.bmi < this.markers[2]) {
      className = this.styles[1];
    }

    if (this.bmi < this.markers[1]) {
      className = this.styles[0];
    }

    return className;
  };

  return {
    restrict: 'A',
    controller: Controller,
    controllerAs: 'vm',

    template: '<div class="nutrition-bmi">' + '  <div class="pop-over">' + '    Your BMI: {{ vm.bmi }}' + '    <div class="pop-over-arrow"></div>' + '  </div>' + '  <ul class="description">' + '    <li class="under">Underweight</li>' + '    <li class="healthy">Healthy</li>' + '    <li class="over">Overweight</li>' + '    <li class="obese">Obese</li>' + '  </ul>' + '  <ul class="value">' + '    <li class="low">18.5 BMI</li>' + '    <li class="medium">25 BMI</li>' + '    <li class="high">30 BMI</li>' + '  </ul>' + '</div>',

    scope: {
      bmi: '=nutritionBmi'
    },

    link: function link(scope, element, attrs, controller) {
      var deregWatch = scope.$watch('bmi', function (value) {
        if (value) {
          $timeout(function () {
            var pop_over = element.find('.pop-over'),
                offset = pop_over.outerWidth() / element.outerWidth() * 100 / 2;

            controller.bmi = value;

            pop_over.css('margin-left', controller.bmiMarkerPercent() - offset + '%').addClass(controller.bmiClassName());

            deregWatch();
          });
        }
      });
    }
  };
}];

/***/ }),

/***/ "jbEX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jkIW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectVideo = exports.selectVideos = exports.updateVideo = exports.fetchVideo = exports.destroyVideo = exports.videoResumeLogic = exports.initialState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;

var _reduxLogic = __webpack_require__("E0Bt");

var _utils = __webpack_require__("0xDb");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Action Types
var FETCH = '@@app/videoResume/FETCH';
var FETCH_SUCCESS = '@@app/videoResume/FETCH_SUCCESS';
var FETCH_ERROR = '@@app/videoResume/FETCH_ERROR';
var UPDATE = '@@app/videoResume/UPDATE';
var DESTROY = '@@app/videoResume/DESTROY';

// Initial State
var initialState = exports.initialState = {
  loading: false,
  data: {}
};

// Observables
var fetchLogic = (0, _reduxLogic.createLogic)({
  type: FETCH,
  processOptions: {
    successType: FETCH_SUCCESS,
    failType: FETCH_ERROR
  },
  process: function process() {
    return _utils.videoStorage.get();
  }
});

var updateLogic = (0, _reduxLogic.createLogic)({
  type: UPDATE,
  process: function process(_ref) {
    var action = _ref.action;
    var _action$payload = action.payload,
        videoId = _action$payload.videoId,
        currentTime = _action$payload.currentTime;

    return _utils.videoStorage.set(videoId, currentTime);
  }
});

var destroyLogic = (0, _reduxLogic.createLogic)({
  type: DESTROY,
  process: function process(_ref2) {
    var action = _ref2.action;

    return _utils.videoStorage.remove(action.payload.videoId);
  }
});

var videoResumeLogic = exports.videoResumeLogic = [fetchLogic, updateLogic, destroyLogic];

// Action Creators
var destroyVideo = exports.destroyVideo = function destroyVideo(videoId) {
  return { type: DESTROY, payload: { videoId: videoId } };
};

var fetchVideo = exports.fetchVideo = function fetchVideo() {
  return { type: FETCH };
};

var updateVideo = exports.updateVideo = function updateVideo(videoId, currentTime) {
  return { type: UPDATE, payload: { videoId: videoId, currentTime: currentTime } };
};

// Selectors
var selectVideos = exports.selectVideos = function selectVideos(_ref3) {
  var data = _ref3.data;

  return data || {};
};

var selectVideo = exports.selectVideo = function selectVideo(state, videoId) {
  return selectVideos(state)[videoId];
};

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case FETCH:
      {
        return _extends({}, state, {
          loading: true
        });
      }

    case FETCH_SUCCESS:
      {
        return _extends({}, state, {
          loading: false,
          data: payload
        });
      }

    case UPDATE:
      {
        var videoId = payload.videoId,
            currentTime = payload.currentTime;


        return _extends({}, state, {
          loading: false,
          data: _extends({}, state.data, _defineProperty({}, videoId, currentTime))
        });
      }

    case DESTROY:
      {
        var _videoId = payload.videoId;

        var data = _extends({}, state.data);

        delete data[_videoId];

        return _extends({}, state, {
          loading: false,
          data: data
        });
      }

    default:
      return state;
  }
}

/***/ }),

/***/ "jnnR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchReviewsStats = exports.likeReview = exports.createProgramReview = exports.createReview = exports.fetchReplies = exports.fetchReviews = exports.selectReviewsStats = exports.selectReviewsPages = exports.selectReviewsPagination = exports.selectReplies = exports.selectReview = exports.selectReviews = exports.reviewsLogic = exports.initialState = undefined;

var _size2 = __webpack_require__("4Fgk");

var _size3 = _interopRequireDefault(_size2);

var _set2 = __webpack_require__("4yG7");

var _set3 = _interopRequireDefault(_set2);

var _mapKeys2 = __webpack_require__("g7Do");

var _mapKeys3 = _interopRequireDefault(_mapKeys2);

var _map2 = __webpack_require__("2247");

var _map3 = _interopRequireDefault(_map2);

var _get2 = __webpack_require__("Q7hp");

var _get3 = _interopRequireDefault(_get2);

var _flatten2 = __webpack_require__("rCVp");

var _flatten3 = _interopRequireDefault(_flatten2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;

var _reduxLogic = __webpack_require__("E0Bt");

var _normalizr = __webpack_require__("vNPR");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = exports.initialState = {
  entities: {},
  pages: {},
  pagination: {},
  stats: {},
  hasReviewed: false,
  isLoading: false
};

//
// Actions

var FETCH = '@@app/reviews/FETCH';
var FETCH_SUCCESS = '@@app/reviews/FETCH_SUCCESS';
var FETCH_ERROR = '@@app/reviews/FETCH_ERROR';

var FETCH_REPLIES = '@@app/reviews/FETCH_REPLIES';
var FETCH_REPLIES_SUCCESS = '@@app/reviews/FETCH_REPLIES_SUCCESS';
var FETCH_REPLIES_ERROR = '@@app/reviews/FETCH_REPLIES_ERROR';

var REVIEW = '@@app/reviews/REVIEW';
var REVIEW_SUCCESS = '@@app/reviews/REVIEW_SUCCESS';
var REVIEW_ERROR = '@@app/reviews/REVIEW_ERROR';

var LIKE = '@@app/reviews/LIKE';
var LIKE_SUCCESS = '@@app/reviews/LIKE_SUCCESS';
var LIKE_ERROR = '@@app/reviews/LIKE_ERROR';

var STATS = '@@app/reviews/STATS';
var STATS_SUCCESS = '@@app/reviews/STATS_SUCCESS';
var STATS_ERROR = '@@app/reviews/STATS_ERROR';

var scopeKey = function scopeKey(type, id) {
  return type + '_' + id;
};

var scope = function scope(obj, type, id) {
  return _defineProperty({}, scopeKey(type, id), obj);
};

var paginate = function paginate(items, pagination, type, id) {
  var pages = _defineProperty({}, pagination.page, items);
  return scope(pages, type, id);
};

//
// Observables

var fetchReviewsLogic = (0, _reduxLogic.createLogic)({
  type: FETCH,
  processOptions: {
    successType: FETCH_SUCCESS,
    failType: FETCH_ERROR
  },
  process: function process(_ref2) {
    var action = _ref2.action,
        httpClient = _ref2.httpClient;
    var _action$payload = action.payload,
        memberId = _action$payload.memberId,
        voomeProductId = _action$payload.voomeProductId,
        reviewableId = _action$payload.reviewableId,
        reviewableType = _action$payload.reviewableType,
        page = _action$payload.page;

    var params = {
      reviewableId: reviewableId,
      reviewableType: reviewableType,
      page: page
    };

    return httpClient.get('/v3/members/' + memberId + '/voome-products/' + voomeProductId + '/reviews', {
      params: params
    }).then(function (_ref3) {
      var data = _ref3.data,
          pagination = _ref3.pagination;

      var reviews = (0, _normalizr.normalize)(data, [new _normalizr.schema.Entity('reviews')]);
      var pages = paginate(reviews.result, pagination, reviewableType, reviewableId);

      return {
        reviews: reviews,
        pagination: scope(pagination, reviewableType, reviewableId),
        pages: pages,
        reviewableType: reviewableType,
        reviewableId: reviewableId,
        voomeProductId: voomeProductId
      };
    });
  }
});

var repliesFetchLogic = (0, _reduxLogic.createLogic)({
  type: FETCH_REPLIES,
  processOptions: {
    successType: FETCH_REPLIES_SUCCESS,
    failType: FETCH_REPLIES_ERROR
  },
  process: function process(_ref4) {
    var action = _ref4.action,
        httpClient = _ref4.httpClient;
    var _action$payload2 = action.payload,
        memberId = _action$payload2.memberId,
        voomeProductId = _action$payload2.voomeProductId,
        reviewableId = _action$payload2.reviewableId,
        reviewableType = _action$payload2.reviewableType,
        parentId = _action$payload2.parentId;


    var params = {
      reviewableId: reviewableId,
      reviewableType: reviewableType,
      parentId: parentId
    };

    return httpClient.get('/v3/members/' + memberId + '/voome-products/' + voomeProductId + '/reviews', {
      params: params
    }).then(function (response) {
      var data = response.data;
      var replies = (0, _mapKeys3.default)((0, _flatten3.default)(data), 'id');
      var keys = (0, _map3.default)(replies, function (_ref5) {
        var id = _ref5.id;
        return id;
      });

      return { replies: replies, keys: keys, parentId: parentId };
    });
  }
});

var reviewLogic = (0, _reduxLogic.createLogic)({
  type: REVIEW,
  processOptions: {
    successType: REVIEW_SUCCESS,
    failType: REVIEW_ERROR
  },
  process: function process(_ref6) {
    var action = _ref6.action,
        httpClient = _ref6.httpClient;
    var _action$payload3 = action.payload,
        memberId = _action$payload3.memberId,
        voomeProductId = _action$payload3.voomeProductId,
        review = _action$payload3.review;

    var endpoint = '/v3/members/' + memberId + '/voome-products/' + voomeProductId + '/reviews';
    var params = { review: review };
    var onSuccess = function onSuccess(response) {
      return response.data;
    };
    return httpClient.post(endpoint, params).then(onSuccess);
  }
});

var reviewLikeLogic = (0, _reduxLogic.createLogic)({
  type: LIKE,
  processOptions: {
    successType: LIKE_SUCCESS,
    failType: LIKE_ERROR
  },
  process: function process(_ref7) {
    var action = _ref7.action,
        httpClient = _ref7.httpClient,
        getState = _ref7.getState;
    var _action$payload4 = action.payload,
        memberId = _action$payload4.memberId,
        data = _action$payload4.data;

    var review = selectReview(getState().reviews, data.subjectId);
    var endpoint = '/v1/members/' + memberId + '/activities';

    return httpClient.post(endpoint, data).then(function () {
      return _extends({}, review, {
        liked: true,
        likesCount: review.likesCount + 1
      });
    });
  }
});

var reviewsStatsLogic = (0, _reduxLogic.createLogic)({
  type: STATS,
  processOptions: {
    successType: STATS_SUCCESS,
    failType: STATS_ERROR
  },
  process: function process(_ref8) {
    var action = _ref8.action,
        httpClient = _ref8.httpClient;
    var _action$payload5 = action.payload,
        memberId = _action$payload5.memberId,
        voomeProductId = _action$payload5.voomeProductId,
        reviewableId = _action$payload5.reviewableId,
        reviewableType = _action$payload5.reviewableType;


    var params = {
      reviewableId: reviewableId,
      reviewableType: reviewableType
    };

    var endpoint = '/v3/members/' + memberId + '/voome-products/' + voomeProductId + '/reviews/stats';

    return httpClient.get(endpoint, { params: params }).then(function (response) {
      return { stats: response.data };
    });
  }
});

var reviewsLogic = exports.reviewsLogic = [fetchReviewsLogic, repliesFetchLogic, reviewLogic, reviewLikeLogic, reviewsStatsLogic];

//
// Selectors

var selectReviews = exports.selectReviews = function selectReviews(state) {
  return state.entities.reviews;
};

var selectReview = exports.selectReview = function selectReview(state, id) {
  var reviews = selectReviews(state);
  return reviews ? reviews[id] : undefined;
};

var selectReplies = exports.selectReplies = function selectReplies(state) {
  return state.entities.replies;
};

var selectReviewsPagination = exports.selectReviewsPagination = function selectReviewsPagination(state, _ref9) {
  var id = _ref9.id,
      type = _ref9.type;

  return state.pagination[scopeKey(type, id)];
};

var selectReviewsPages = exports.selectReviewsPages = function selectReviewsPages(state, _ref10) {
  var id = _ref10.id,
      type = _ref10.type;

  return state.pages[scopeKey(type, id)];
};

var selectReviewsStats = exports.selectReviewsStats = function selectReviewsStats(state) {
  return state.stats;
};

//
// Action Creators

var fetchReviews = exports.fetchReviews = function fetchReviews(memberId, voomeProductId, reviewableId, reviewableType) {
  var page = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

  return {
    type: FETCH,
    payload: { memberId: memberId, voomeProductId: voomeProductId, reviewableId: reviewableId, reviewableType: reviewableType, page: page }
  };
};

var fetchReplies = exports.fetchReplies = function fetchReplies(memberId, voomeProductId, reviewableId, reviewableType, parentId) {
  return {
    type: FETCH_REPLIES,
    payload: {
      memberId: memberId,
      voomeProductId: voomeProductId,
      reviewableId: reviewableId,
      reviewableType: reviewableType,
      parentId: parentId
    }
  };
};

var createReview = exports.createReview = function createReview(memberId, voomeProductId, params) {
  var reviewableId = params.reviewableId,
      reviewableType = params.reviewableType,
      review = params.review,
      rating = params.rating,
      parentId = params.parentId;


  return {
    type: REVIEW,
    payload: {
      memberId: memberId,
      voomeProductId: voomeProductId,
      review: {
        parentId: parentId,
        rating: rating,
        reviewableId: reviewableId,
        reviewableType: reviewableType,
        review: review
      }
    }
  };
};

var createProgramReview = exports.createProgramReview = function createProgramReview(memberId, voomeProductId, review, rating) {
  return {
    type: REVIEW,
    payload: {
      memberId: memberId,
      voomeProductId: voomeProductId,
      review: {
        reviewableId: voomeProductId,
        reviewableType: 'Voome::Product',
        review: review,
        rating: rating
      }
    }
  };
};

var likeReview = exports.likeReview = function likeReview(memberId, subjectId, associatedId) {
  return {
    type: LIKE,
    payload: {
      memberId: memberId,
      data: {
        subjectType: 'Review',
        activity: 'like',
        associatedType: 'VoomeProgram',
        subjectId: subjectId,
        associatedId: associatedId
      }
    }
  };
};

var fetchReviewsStats = exports.fetchReviewsStats = function fetchReviewsStats(memberId, voomeProductId, reviewableId, reviewableType) {
  return {
    type: STATS,
    payload: { memberId: memberId, voomeProductId: voomeProductId, reviewableId: reviewableId, reviewableType: reviewableType }
  };
};

//
// Reducer

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type,
      payload = action.payload;


  var entities = void 0;
  var key = void 0;

  switch (type) {
    case FETCH:
    case STATS:
      return _extends({}, state, {
        isLoading: true
      });

    case FETCH_SUCCESS:
      {
        var _reviews = payload.reviews,
            pagination = payload.pagination;

        key = scopeKey(payload.reviewableType, payload.reviewableId);

        var pages = payload.pages;

        pages = _extends({}, (0, _get3.default)(state.pages, key), (0, _get3.default)(pages, key));
        pages = scope(pages, payload.reviewableType, payload.reviewableId);

        return _extends({}, state, {
          isLoading: false,
          entities: _extends({}, state.entities, {
            reviews: _extends({}, (0, _get3.default)(state, 'entities.reviews'), (0, _get3.default)(_reviews, 'entities.reviews'))
          }),
          pages: _extends({}, state.pages, pages),
          pagination: _extends({}, state.pagination, pagination)
        });
      }

    case FETCH_ERROR:
    case STATS_ERROR:
      return _extends({}, state, {
        isLoading: false
      });

    case FETCH_REPLIES_SUCCESS:
      {
        var replies = payload.replies,
            keys = payload.keys,
            _parentId = payload.parentId;

        var _reviews2 = _extends({}, (0, _get3.default)(state, 'entities.reviews'));
        _reviews2[_parentId].replies = keys;
        _reviews2[_parentId].isLoading = false;

        return _extends({}, state, {
          entities: _extends({}, state.entities, {
            replies: _extends({}, (0, _get3.default)(state, 'entities.replies', {}), payload.replies)
          })
        });
      }

    case FETCH_REPLIES:
      var parentId = payload.parentId;

      var reviews = _extends({}, (0, _get3.default)(state, 'entities.reviews'));
      reviews[parentId].isLoading = true;

      return _extends({}, state);

    case REVIEW:
      return _extends({}, state, {
        hasReviewed: false
      });

    case REVIEW_SUCCESS:
      {
        var pageState = _extends({}, state);
        var entity = _extends({}, payload, { highlight: true });
        var _reviews3 = _extends({}, (0, _get3.default)(state, 'entities.reviews'));
        var _replies = _extends({}, (0, _get3.default)(state, 'entities.replies'));

        if (payload.parentId) {
          var parentReplies = _reviews3[payload.parentId].replies || [];
          _reviews3[payload.parentId].replies = [].concat(_toConsumableArray(parentReplies), [payload.id]);
          _replies[payload.id] = entity;
        } else {
          // This payload is a review
          if ((0, _size3.default)(pageState.pagination) > 0) {
            var _key = scopeKey(payload.reviewableType, payload.reviewableId);
            var page = pageState.pages[_key] && pageState.pages[_key][1];

            if (page) {
              page.unshift(payload.id);
            }
          }

          _reviews3[payload.id] = entity;
        }

        return _extends({}, pageState, {
          entities: _extends({}, state.entities, {
            reviews: _reviews3,
            replies: _replies
          }),
          hasReviewed: true
        });
      }

    case LIKE_SUCCESS:
      var newState = _extends({}, state);
      return (0, _set3.default)(newState, 'entities.reviews.' + payload.id, payload);

    case STATS_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        stats: payload.stats
      });

    default:
      return state;
  }
}

/***/ }),

/***/ "jynZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k34O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Program = undefined;

var _reduxUiRouter = __webpack_require__("Zb/7");

var _utils = __webpack_require__("0xDb");

var _product = __webpack_require__("5AvL");

var _completions = __webpack_require__("XI2E");

var _member = __webpack_require__("1OIp");

var Program = exports.Program = {
  template: '\n    <div class="program-container">\n      <div ng-if="$ctrl.product && $ctrl.subscription">\n        <ui-view autoscroll="false"></ui-view>\n        <program-start-modal\n          subscription="$ctrl.subscription"\n          dates-for-week="$ctrl.datesForWeek"\n          on-submit="$ctrl.startSubscription(data)"\n          ng-if="!$ctrl.hasStarted || ($ctrl.product.daysElapsed < 0)">\n        </program-start-modal>\n        <program-restart-modal\n          subscription="$ctrl.subscription"\n          weeks="$ctrl.weeks"\n          on-submit="$ctrl.restartSubscription(data)"\n          ng-if="$ctrl.hasStarted && ($ctrl.product.daysElapsed >= 0)">\n        </program-restart-modal>\n      </div>\n    </div>',

  controller: ["$ngRedux", "$timeout", function controller($ngRedux, $timeout) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        this.fetchProduct(this.voomeProductId, this.subscription.startedAt);
        this.completionsFetch(this.member.id, this.voomeProductId);
        this.datesForWeek = (0, _utils.datesForWeek)();
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();
      },
      mapState: function mapState(state) {
        var member = state.member,
            product = state.product,
            router = state.router;
        var voomeProductId = router.currentParams.voomeProductId;


        return {
          voomeProductId: voomeProductId,
          hasStarted: (0, _member.selectSubscriptionHasStarted)(member, voomeProductId),
          member: (0, _member.selectMember)(member),
          product: (0, _product.selectProduct)(product),
          subscription: (0, _member.selectSubscription)(member, voomeProductId),
          weeks: (0, _product.selectWeeks)(product)
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          changeSubscription: _member.changeSubscription,
          completionsFetch: _completions.completionsFetch,
          fetchProduct: _product.fetchProduct,
          startSubscription: _member.startSubscription,
          stateGo: _reduxUiRouter.stateGo,
          restartSubscription: _member.restartSubscription
        };
      }
    };
  }]
};

/***/ }),

/***/ "k5Y8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Reviews = undefined;

var _range2 = __webpack_require__("tVBY");

var _range3 = _interopRequireDefault(_range2);

var _member = __webpack_require__("1OIp");

var _reviews = __webpack_require__("jnnR");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Reviews = exports.Reviews = {
  bindings: {
    formTop: '<',
    reviewableId: '<',
    reviewableType: '@',
    wordingPlural: '@',
    wordingRating: '@',
    wordingSingular: '@',
    onCancel: '&'
  },

  template: '\n    <section class="reviews">\n      <div class="d-flex flex-column" ng-hide="$ctrl.isLoading">\n        <div ng-class="{ \'order-1 mb-4\': !$ctrl.formTop, \'order-2\': $ctrl.formTop }"\n          ng-show="$ctrl.reviews">\n          <header class="reviews-header">\n            <h4>{{ $ctrl.wordingPlural }}</h4>\n          </header>\n          <div ng-repeat="page in $ctrl.pageRange() track by $index">\n            <review\n              review="$ctrl.reviews[reviewId]"\n              replies="$ctrl.replies"\n              member-id="$ctrl.member.id"\n              on-like="$ctrl.onLike(reviewId)"\n              on-submit="$ctrl.onSubmit(data, parentId)"\n              on-show-replies="$ctrl.onShowReplies(parentId)"\n              ng-repeat="reviewId in $ctrl.pages[page] track by $index">\n            </review>\n          </div>\n          <div ng-hide="$ctrl.pagination">\n            No <span class="text-lowercase">{{ $ctrl.wordingPlural }}</span> yet.\n            Add one own below.\n          </div>\n          <hr>\n          <div class="mt-4 ml-4" ng-show="$ctrl.pagination.totalPages > 1 && !$ctrl.pagination.lastPage">\n            <button class="btn btn-pill theme-btn ml-4"\n              type="button"\n              ng-click="$ctrl.loadMore()">\n              Load more\n            </button>\n          </div>\n        </div>\n        <div ng-class="{ \'order-1 mb-4\': $ctrl.formTop, \'order-2\': !$ctrl.formTop }">\n          <form-review\n            wording-rating="{{ $ctrl.wordingRating }}"\n            wording-singular="{{ $ctrl.wordingSingular }}"\n            on-submit="$ctrl.onSubmit(data)"\n            on-cancel="$ctrl.onCancel()">\n          </form-review>\n        </div>\n      </div>\n    </section>',

  controller: ["$ngRedux", "$element", "$state", function controller($ngRedux, $element, $state) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState.bind(this), this.mapDispatch());

        this.unsubscribe = connect(this);
        this.page = 1;

        this.fetchReviews(this.member.id, this.voomeProductId, this.reviewableId, this.reviewableType);
      },
      $onDestroy: function $onDestroy() {
        this.unsubscribe();
      },
      onLike: function onLike(reviewId) {
        this.likeReview(this.member.id, reviewId, this.voomeProductId);
      },
      onSubmit: function onSubmit(_ref, parentId) {
        var review = _ref.review,
            rating = _ref.rating;

        var params = {
          reviewableId: this.reviewableId,
          reviewableType: this.reviewableType,
          review: review,
          rating: rating,
          parentId: parentId
        };

        this.createReview(this.member.id, this.voomeProductId, params);
        this.scrollToTop();
      },
      onShowReplies: function onShowReplies(parentId) {
        this.fetchReplies(this.member.id, this.voomeProductId, this.reviewableId, this.reviewableType, parentId);
      },
      loadMore: function loadMore() {
        this.page = this.page + 1;
        this.fetchReviews(this.member.id, this.voomeProductId, this.reviewableId, this.reviewableType, this.page);
      },
      pageRange: function pageRange() {
        if (this.pagination) {
          return (0, _range3.default)(1, this.pagination.page + 1);
        } else {
          return [];
        }
      },
      scrollToTop: function scrollToTop() {
        $('html, body').animate({
          scrollTop: $($element).offset().top
        });
      },
      mapState: function mapState(_ref2) {
        var member = _ref2.member,
            reviews = _ref2.reviews;

        var params = {
          id: this.reviewableId,
          type: this.reviewableType
        };

        return {
          isLoading: reviews.isLoading,
          member: (0, _member.selectMember)(member),
          pages: (0, _reviews.selectReviewsPages)(reviews, params),
          pagination: (0, _reviews.selectReviewsPagination)(reviews, params),
          replies: (0, _reviews.selectReplies)(reviews),
          reviews: (0, _reviews.selectReviews)(reviews),
          voomeProductId: (0, _member.selectSubscription)(member).voomeProductId
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          fetchReviews: _reviews.fetchReviews,
          fetchReplies: _reviews.fetchReplies,
          createReview: _reviews.createReview,
          likeReview: _reviews.likeReview
        };
      }
    };
  }]
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "kBHq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decorateMember = undefined;

var _size2 = __webpack_require__("4Fgk");

var _size3 = _interopRequireDefault(_size2);

var _map2 = __webpack_require__("2247");

var _map3 = _interopRequireDefault(_map2);

var _flatten2 = __webpack_require__("rCVp");

var _flatten3 = _interopRequireDefault(_flatten2);

var _filter2 = __webpack_require__("RyI1");

var _filter3 = _interopRequireDefault(_filter2);

var _kebabCase2 = __webpack_require__("Ex7i");

var _kebabCase3 = _interopRequireDefault(_kebabCase2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__("0xDb");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var decorateMember = exports.decorateMember = function decorateMember(member) {
  // Ensure startWeightInKg & height is null when 0 so forms validate.
  var height = member.profile.height ? parseFloat(member.profile.height) : null;

  var startWeightInKg = member.startWeightInKg ? parseFloat(member.startWeightInKg) : null;

  // Add the members bmi
  var bmi = (0, _utils.calculateBmi)(startWeightInKg, height);

  // Ensure subscription step is a Number
  var subscriptions = (0, _map3.default)(member.subscriptions, function (item) {
    var step = parseInt(item.step, 10);

    return _extends({}, item, {
      slug: (0, _kebabCase3.default)(item.title),
      // If user has multiple subscriptions, then skip profile welcome step
      step: (0, _size3.default)(member.subscriptions) > 1 && step === 1 ? 2 : step
    });
  });

  // Create a simple list of active preferences
  var isActive = function isActive(item) {
    return (0, _filter3.default)(item, 'active');
  };
  var isActivePreference = function isActivePreference(items) {
    return (0, _flatten3.default)((0, _map3.default)(items, isActive));
  };
  var preferenceNames = member.voomeProfile ? (0, _map3.default)(isActivePreference(member.voomeProfile.preferences), 'name') : [];

  return _extends({}, member, {
    startWeightInKg: startWeightInKg,
    bmi: bmi,
    subscriptions: subscriptions,
    profile: _extends({}, member.profile, {
      height: height
    }),
    voomeProfile: _extends({}, member.voomeProfile, {
      preferenceNames: preferenceNames
    })
  });
};

/***/ }),

/***/ "kQjX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SignupAside = exports.SignupAside = {
  bindings: {
    list: '<',
    coupon: '<'
  },

  template: '\n    <div class="signup-aside p-3 p-lg-4">\n      <div class="pt-lg-4">\n        <div ng-if="$ctrl.coupon"\n          ng-class="{ \'logo logo-{{ $ctrl.coupon | lowercase }}\': $ctrl.coupon }">\n          {{ $ctrl.coupon }}\n        </div>\n        <h5 class="h5 mb-3">\n          What\'s included?\n        </h5>\n        <ul class="fa-ul mb-4">\n          <li class="list-item"\n            ng-repeat="item in $ctrl.list track by $index">\n            <i class="fa-li fa fa-check theme-color"></i>\n            <span ng-bind-html="item"></span>\n          </li>\n        </ul>\n        <ul class="fa-ul icon-ul ml-0">\n          <li class="list-item d-flex align-items-top p-0 m-1">\n            <i class="fa fa-2x fa-lixx icon-secure theme-color"></i>\n            <span class="mt-2 ml-2 text-dark">\n              Secure SSL Payment\n            </span>\n          </li>\n          <li class="list-item d-flex align-items-top p-0 m-1">\n            <i class="fa fa-2x fa-lixx icon-privacy theme-color"></i>\n            <span class="mt-2 ml-2 text-dark">\n              We\'ll always keep your details private\n            </span>\n          </li>\n        </ul>\n      </div>\n    </div>'
};

/***/ }),

/***/ "kxj+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WorkoutSection = exports.WorkoutSection = {
  bindings: {
    workout: '<',
    section: '<',
    exercises: '<',
    params: '<',
    gender: '<',
    onShowModal: '&'
  },

  template: '\n    <div class="card card-workout mb-5 mb-sm-4"\n      ng-class="{ \'card-workout-stretch\': $ctrl.section.name == \'Stretch\' }"\n      ng-if="$ctrl.section.name != \'Transition\'">\n      <h3 class="card-header d-flex align-items-center">\n        {{ $ctrl.section.name }}\n        <small class="label ml-auto text-gray"\n          ng-show="$ctrl.section.totalTimeSet">\n          <i class="fa fa-lg icon-time text-green-dark"></i>\n          {{ $ctrl.section.totalTimeMinutes }}\n        </small>\n      </h3>\n      <div class="card-block pt-4 pb-0 pl-sm-4 pr-sm-0">\n        <p class="note"\n          ng-show="$ctrl.section.note"\n          ng-bind-html="$ctrl.section.note">\n        </p>\n        <div class="exercise-container w-100"\n          ng-repeat="item in $ctrl.section.items track by $index"\n          ng-if="item.name !== \'Transition\'">\n          <div class="exercise-pad" ng-if="item.exerciseId">\n            <exercise\n              index="$index"\n              data="item"\n              workout="$ctrl.workout"\n              exercise="$ctrl.exercises[item.exerciseId]"\n              gender="$ctrl.gender"\n              params="$ctrl.params"\n              on-click="$ctrl.onShowModal({ item: item })">\n            </exercise>\n          </div>\n          <exercise-set\n            data="item"\n            workout="$ctrl.workout"\n            exercises="$ctrl.exercises"\n            gender="$ctrl.gender"\n            params="$ctrl.params"\n            on-show-modal="$ctrl.onShowModal({ item: item })"\n            ng-if="!item.exerciseId">\n          </exercise-set>\n        </div>\n      </div>\n    </div>'
};

/***/ }),

/***/ "lBa9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NutritionRecipes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxUiRouter = __webpack_require__("Zb/7");

var _utils = __webpack_require__("0xDb");

var _favourite = __webpack_require__("GfAe");

var _filters = __webpack_require__("ZTBt");

var _member = __webpack_require__("1OIp");

var _search = __webpack_require__("j94E");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NutritionRecipes = exports.NutritionRecipes = {
  template: '\n    <ui-view>\n      <div class="nutrition-recipes container pt-3">\n        <div class="row">\n          <div class="col-md-3 pt-md-2">\n            <nav-mobile-sidebar\n              heading="Filter"\n              is-active="$ctrl.filtersIsActive"\n              on-click="$ctrl.toggleFiltersIsActive()">\n              <search-form class="d-none d-md-block mb-2"\n                placeholder="find recipes"\n                query="$ctrl.params.q"\n                on-submit="$ctrl.onUpdateParam(\'q\', query)">\n              </search-form>\n              <search-filter-recipes\n                filters="$ctrl.filters"\n                on-click="$ctrl.onUpdateFilter(item, type, key, list)">\n              </search-filter-recipes>\n            </nav-mobile-sidebar>\n          </div>\n          <div class="col-md-9">\n            <div class="mobile-filter-row row d-flex d-md-none py-2 px-3 bg-white">\n              <button class="btn btn-link p-0 d-inline-flex"\n                ng-click="$ctrl.toggleFiltersIsActive()">\n                <i class="fa fa-sliders"></i>\n                <span class="h6 text-green-dark mb-0">Filter</span>\n              </button>\n              <search-form\n                class="d-inline-flex ml-auto"\n                placeholder="find recipes"\n                query="$ctrl.params.q"\n                on-submit="$ctrl.onUpdateParam(\'q\', query)">\n              </search-form>\n            </div>\n            <search-filter-results\n              query="$ctrl.search.params.q"\n              filters="$ctrl.checkedFilters"\n              on-clear-all="$ctrl.onClearAll()"\n              on-update-param="$ctrl.onUpdateParam(key, value)"\n              on-update-filter="$ctrl.onUpdateFilter(item, type, key)">\n            </search-filter-results>\n            <search-results\n              on-update-param="$ctrl.onUpdateParam(key, value)"\n              order="$ctrl.sortBy"\n              pagination="$ctrl.pagination"\n              type="recipes">\n              <div class="row">\n                <div class="col-sm-6 col-lg-4 pb-3"\n                  ng-repeat="item in $ctrl.results track by $index">\n                  <card-recipe\n                    recipe="item"\n                    on-click="$ctrl.onClick(item)">\n                  </card-recipe>\n                </div>\n              </div>\n            </search-results>\n          </div>\n        </div>\n      </div>\n    </ui-view>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.unsubscribe = connect(this);

        var _$ngRedux$getState = $ngRedux.getState(),
            filters = _$ngRedux$getState.filters,
            member = _$ngRedux$getState.member,
            router = _$ngRedux$getState.router;

        var currentParams = router.currentParams;

        var searchParams = _extends({}, currentParams, {
          level: this.level
        });

        // Search for recipes using the current route params.
        this.searchRecipes(searchParams);

        // Fetch the filters
        if (!filters.recipes.length) {
          this.fetchFiltersRecipes();
        }

        // Hide mobile sidebar
        this.showMobileSidebar = false;
      },
      $onDestroy: function $onDestroy() {
        this.unsubscribe();
      },
      onClearAll: function onClearAll() {
        this.stateGo('nutrition.recipes', {
          filters: undefined,
          level: undefined,
          order: undefined,
          page: undefined,
          q: undefined,
          serves: undefined
        });
      },
      onClick: function onClick(_ref) {
        var id = _ref.id,
            name = _ref.name;

        this.stateGo('nutrition.recipes.detail', {
          recipeId: id
        });

        _utils.anchorStorage.set($ngRedux.getState(), name);
      },
      onUpdateFilter: function onUpdateFilter(item, type, key) {
        var list = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

        this.onUpdateParam(key, (0, _filters.updateFilters)(item.id, type, this.params[key], list));
      },
      onUpdateParam: function onUpdateParam(key) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        var pathKey = 'nutrition.recipes';
        var page = value !== this.params[key] || key === 'q' ? undefined : this.params.page;

        this.stateGo(pathKey, _extends({}, this.params, _defineProperty({
          page: page,
          level: this.level
        }, key, value)));
      },
      mapState: function mapState(state) {
        var favourite = state.favourite,
            member = state.member,
            router = state.router,
            search = state.search;
        var _router$currentParams = router.currentParams,
            filters = _router$currentParams.filters,
            order = _router$currentParams.order,
            serves = _router$currentParams.serves;


        return {
          search: search,
          member: (0, _member.selectMember)(member),
          level: (0, _member.selectMemberLevel)(member),
          hasAccess: (0, _member.selectHasNutritionSubscription)(member),

          // Search
          filters: (0, _filters.selectFiltersRecipesGrouped)(state.filters, filters, serves),
          filtersIsActive: state.filters.isActive,
          checkedFilters: (0, _filters.selectFiltersRecipesChecked)(state.filters, filters, serves),
          sortBy: (0, _filters.selectSortByRecipes)(state.filters, order),
          pagination: (0, _search.selectSearchPagination)(search),
          params: (0, _search.selectSearchParams)(search),
          results: (0, _favourite.mapIsFavouriteRecipes)((0, _search.selectSearchResults)(search), (0, _favourite.selectFavouriteRecipeIds)(favourite))
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          fetchFiltersRecipes: _filters.fetchFiltersRecipes,
          resetSearch: _search.resetSearch,
          searchRecipes: _search.searchRecipes,
          stateGo: _reduxUiRouter.stateGo,
          toggleFiltersIsActive: _filters.toggleFiltersIsActive
        };
      }
    };
  }]
};

/***/ }),

/***/ "lCsa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CardPlain = exports.CardPlain = {
  transclude: true,

  bindings: {
    linkText: '<',
    applyTint: '<',
    cardClass: '@'
  },

  template: '\n    <div class="card-plain card card-inverse card-borderless"\n      ng-class="$ctrl.cardClass">\n      <div class="card-block mb-0 align-items-center text-center"\n        ng-class="{ \'card-block--tint\': $ctrl.applyTint }">\n        <ng-transclude></ng-transclude>\n      </div>\n      <p class="card-link theme-btn--highlight" ng-if="$ctrl.linkText">\n        <i class="fa fa-plus-circle"></i>\n        {{ $ctrl.linkText }}\n      </p>\n    </div>'
};

/***/ }),

/***/ "lN3W":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Workout = undefined;

var _reduxUiRouter = __webpack_require__("Zb/7");

var _favourite = __webpack_require__("GfAe");

var _member = __webpack_require__("1OIp");

var _workout = __webpack_require__("Toxe");

var Workout = exports.Workout = {
  transclude: {
    navLeft: '?workoutNavLeft',
    header: '?workoutHeader'
  },

  template: '\n    <div class="workout">\n      <nav-page>\n        <nav-left ng-transclude="navLeft"></nav-left>\n        <nav-right>\n          <button-print\n            uri="{{ $ctrl.printUri }}"\n            tooltip="$ctrl.tooltip"\n            ng-click="$ctrl.refetchMember()"\n            ng-if="$ctrl.subscription.canPrint">\n          </button-print>\n        </nav-right>\n      </nav-page>\n      <div ng-transclude="header">\n      </div>\n      <main class="main-content">\n        <div class="container">\n          <workout-intro\n            title="$ctrl.workout.name"\n            sub-title="$ctrl.workout.subTitle"\n            description="$ctrl.workout.description"\n            video-id="$ctrl.workout.introVideo.brightcoveId"\n            ng-if="$ctrl.workout.introVideo.brightcoveId">\n          </workout-intro>\n          <div class="my-3" ng-hide="$ctrl.workout.introVideo.brightcoveId">\n            <h3 ng-bind-html="$ctrl.workout.name"></h3>\n            <h5 class="text-gray" ng-bind-html="$ctrl.workout.subTitle"></h5>\n          </div>\n          <div class="row flex-md-row-reverse"\n            ng-if="!$ctrl.workout.playlistVideo">\n            <div class="col-md-4">\n              <div ng-hide="$ctrl.workout.introVideo.brightcoveId">\n                <div class="img-wrapper mb-3">\n                  <favourite-button\n                    is-favourite="$ctrl.workout.isFavourite"\n                    ng-if="$ctrl.workout.isFavourite !== undefined"\n                    ng-click="$ctrl.toggleFavouriteWorkout({\n                      memberId: $ctrl.member.id,\n                      workoutId: $ctrl.workout.id,\n                      isFavourite: $ctrl.workout.isFavourite\n                    })">\n                  </favourite-button>\n                  <img class="img-fluid"\n                    ng-src="{{ ($ctrl.workout.imageUrl.magazine || $ctrl.workout.image.magazine) | assetSrc }}" />\n                </div>\n                <div class="mb-3 d-flex justify-content-center">\n                  <span class="mr-3">Member Rating:</span>\n                  <rating-stars\n                    size="md"\n                    rating="$ctrl.workout.averageRating">\n                  </rating-stars>\n                </div>\n                <div class="mb-3 d-flex justify-content-center">\n                  <button-primary\n                    on-click="$ctrl.stateGo(\'workoutPlayer\', { exercisePlanId: $ctrl.params.exercisePlanId, id: $ctrl.params.id })"\n                    ng-show="$ctrl.workout.autoplayable">\n                    Start Workout</span>!\n                  </button-primary>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-8">\n              <div class="d-flex align-items-center justify-content-between my-3"\n                ng-show="$ctrl.workout.introVideo.brightcoveId">\n                <h3>The Workout</h3>\n                <button-primary\n                  on-click="$ctrl.stateGo(\'workoutPlayer\', { exercisePlanId: $ctrl.params.exercisePlanId, id: $ctrl.params.id })"\n                  ng-show="$ctrl.workout.autoplayable">\n                  Start <span class="d-none d-md-inline">Workout</span>!\n                </button-primary>\n              </div>\n              <workout-list\n                exercises="$ctrl.exercises"\n                member="$ctrl.member"\n                params="$ctrl.params"\n                workout="$ctrl.workout">\n              </workout-list>\n              <div class="my-5"\n                ng-if="$ctrl.subscription.isWeekly && $ctrl.workout.id">\n                <reviews\n                  wording-plural="Reviews"\n                  wording-rating="Rate this Exercise Plan"\n                  wording-singular="Review"\n                  reviewable-type="ExercisePlanDayV2"\n                  reviewable-id="$ctrl.workout.id">\n                </reviews>\n              </div>\n            </div>\n          </div>\n          <video-playlist\n            ng-if="$ctrl.workout.playlistVideo"\n            list="$ctrl.workout.playlistVideo.items"\n            autoplay="false"\n            continuous="true"\n            loop="false">\n          </video-playlist>\n        </div>\n      </main>\n    </div>',

  controller: ["$ngRedux", "$timeout", function controller($ngRedux, $timeout) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.unsubscribe = connect(this);
        this.fetchWorkout(this.exercisePlanId, this.id);
      },
      $onDestroy: function $onDestroy() {
        this.unsubscribe();
      },
      refetchMember: function refetchMember() {
        var _this = this;

        this.tooltip && $timeout(function () {
          return _this.fetchMember(_this.member.id);
        }, 500);
      },
      setDemo: function setDemo(exercise) {
        this.demo = {
          id: exercise.video.brightcoveId,
          title: exercise.name
        };
      },
      mapState: function mapState(_ref) {
        var favourite = _ref.favourite,
            member = _ref.member,
            router = _ref.router,
            workout = _ref.workout;
        var _router$currentParams = router.currentParams,
            exercisePlanId = _router$currentParams.exercisePlanId,
            id = _router$currentParams.id;

        var subscription = (0, _member.selectSubscription)(member);

        return {
          exercisePlanId: exercisePlanId,
          id: id,
          subscription: subscription,
          tooltip: (0, _member.selectPrintTooltip)(member),
          printUri: (0, _workout.workoutPrintUri)(id, exercisePlanId, subscription && subscription.id),
          exercises: (0, _workout.selectExercises)(workout),
          member: (0, _member.selectMember)(member),
          params: { exercisePlanId: exercisePlanId, id: id },
          workout: (0, _favourite.mapIsFavouriteWorkouts)((0, _workout.selectWorkout)(workout, id), (0, _favourite.selectFavouriteWorkoutIds)(favourite))
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          toggleFavouriteWorkout: _favourite.toggleFavouriteWorkout,
          stateGo: _reduxUiRouter.stateGo,
          fetchMember: _member.fetchMember,
          fetchWorkout: _workout.fetchWorkout
        };
      }
    };
  }]
};

/***/ }),

/***/ "lQ93":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ReviewReply = exports.ReviewReply = {
  bindings: {
    data: '<',
    isUser: '<',
    onLike: '&',
    onReply: '&',
    onShowReplies: '&'
  },

  template: '\n    <div class="review-reply d-flex py-3 px-2" ng-class="{ \'bg-cz-light-theme\': $ctrl.data.highlight }">\n      <div class="review-avatar mr-3">\n        <image-circle src="$ctrl.data.member.avatarUrl.thumb"></image-circle>\n      </div>\n      <div class="review-body">\n        <h5>{{ $ctrl.data.member.screenName }}</h5>\n        <div class="review-content pb-3" ng-bind-html="$ctrl.data.review"></div>\n        <div class="pb-2" ng-show="$ctrl.data.rating">\n          <rating-stars rating="$ctrl.data.rating"></rating-stars>\n        </div>\n        <div class="review-options">\n          <spinner is-loading="$ctrl.data.isLoading"></spinner>\n          <button class="btn-link plain"\n            ng-click="$ctrl.onShowReplies({ reviewId: $ctrl.data.id })"\n            ng-show="$ctrl.data.repliesCount > 0">\n            {{ $ctrl.data.repliesCount }}\n            <span ng-show="$ctrl.data.repliesCount > 1">replies</span>\n            <span ng-show="$ctrl.data.repliesCount == 1">reply</span>\n          </button>\n          <button class="btn-link plain"\n            ng-click="$ctrl.onLike({ reviewId: $ctrl.data.id })"\n            ng-hide="$ctrl.isUser">\n            Like\n          </button>\n          <button class="btn-link plain"\n            ng-click="$ctrl.onReply()">\n            Reply\n          </button>\n          <span class="meta"\n            ng-show="$ctrl.data.liked">\n            {{ $ctrl.data.likesCount }}\n            like<span ng-show="$ctrl.data.likesCount > 1">s</span>\n          </span>\n          <span class="meta">\n            {{ $ctrl.data.createdAt | daysElapsed }}\n          </span>\n        </div>\n      </div>\n    </div>'
};

/***/ }),

/***/ "lVK7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__("/jXN");

var _angular2 = _interopRequireDefault(_angular);

var _angularMessages = __webpack_require__("QX3n");

var _angularMessages2 = _interopRequireDefault(_angularMessages);

var _angularSanitize = __webpack_require__("AFu3");

var _angularSanitize2 = _interopRequireDefault(_angularSanitize);

var _angularValidationMatch = __webpack_require__("uZ+5");

var _angularValidationMatch2 = _interopRequireDefault(_angularValidationMatch);

var _ngRedux = __webpack_require__("tfhA");

var _ngRedux2 = _interopRequireDefault(_ngRedux);

var _reduxUiRouter = __webpack_require__("Zb/7");

var _reduxUiRouter2 = _interopRequireDefault(_reduxUiRouter);

__webpack_require__("v2oE");

__webpack_require__("vkoT");

__webpack_require__("OdT9");

__webpack_require__("6txZ");

var _containers = __webpack_require__("/pf/");

var _components = __webpack_require__("bGai");

var _filters = __webpack_require__("Q0Ca");

var _providers = __webpack_require__("s6Dm");

var _utils = __webpack_require__("0xDb");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Modules


// App styles
var modules = [_ngRedux2.default, _reduxUiRouter2.default, _angularMessages2.default, _angularSanitize2.default, _angularValidationMatch2.default, 'angularFileUpload', 'focus-if', 'rb.select-all-on-focus', _containers.Containers, _components.Components, _filters.Filters, _providers.Providers];

// Main App


// Utilities


// Application
exports.default = _angular2.default.module('App', modules).run(_utils.facebookInit).run(_utils.authCheck).run(_utils.proxyCookie).run(_utils.virtualPageview).run(_utils.clearModal).run(_utils.transitionAnchorScroll);

/***/ }),

/***/ "lcW8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ButtonPrimary = exports.ButtonPrimary = {
  transclude: true,

  bindings: {
    isInverse: '<',
    ngDisabled: '<',
    ngType: '@',
    size: '@',
    onClick: '&'
  },

  template: '\n    <button class="btn btn-pill theme-btn"\n      ng-class="{\n        \'btn-sm\': $ctrl.size === \'sm\',\n        \'btn-md\': $ctrl.size === \'md\',\n        \'btn-lg\': $ctrl.size === \'lg\' || !$ctrl.size,\n        \'theme-btn--inverse\': $ctrl.isInverse\n      }"\n      type="{{ $ctrl.ngType || \'button\' }}"\n      ng-click="$ctrl.onClick()"\n      ng-disabled="$ctrl.ngDisabled"\n      ng-transclude>\n    </button>'
};

/***/ }),

/***/ "lcmv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SearchForm = exports.SearchForm = {
  bindings: {
    placeholder: '@',
    query: '<',
    onSubmit: '&'
  },

  template: '\n    <form class="search-form"\n      ng-submit="$ctrl.onSubmit({ query: $ctrl.query })">\n      <div class="input-group">\n        <input class="form-control"\n          type="text"\n          ng-model="$ctrl.query"\n          placeholder="{{ $ctrl.placeholder }}..."\n          aria-label="{{ $ctrl.placeholder }}...">\n        <div class="input-group-addon">\n          <button class="btn btn-link p-2" type="submit">\n            <i class="fa fa-search"></i>\n          </button>\n        </div>\n      </div>\n    </form>'
};

/***/ }),

/***/ "liYl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgramWeekWorkouts = exports.ProgramWeekVideos = exports.ProgramWeekOverview = exports.ProgramWeekMealPlan = exports.ProgramStartModal = exports.ProgramRestartModal = exports.ProgramNotStarted = undefined;

var _ProgramNotStarted = __webpack_require__("+IY6");

Object.defineProperty(exports, 'ProgramNotStarted', {
  enumerable: true,
  get: function get() {
    return _ProgramNotStarted.ProgramNotStarted;
  }
});

var _ProgramRestartModal = __webpack_require__("1Fbq");

Object.defineProperty(exports, 'ProgramRestartModal', {
  enumerable: true,
  get: function get() {
    return _ProgramRestartModal.ProgramRestartModal;
  }
});

var _ProgramStartModal = __webpack_require__("ZBVT");

Object.defineProperty(exports, 'ProgramStartModal', {
  enumerable: true,
  get: function get() {
    return _ProgramStartModal.ProgramStartModal;
  }
});

var _ProgramWeekMealPlan = __webpack_require__("ngPO");

Object.defineProperty(exports, 'ProgramWeekMealPlan', {
  enumerable: true,
  get: function get() {
    return _ProgramWeekMealPlan.ProgramWeekMealPlan;
  }
});

var _ProgramWeekOverview = __webpack_require__("eU0z");

Object.defineProperty(exports, 'ProgramWeekOverview', {
  enumerable: true,
  get: function get() {
    return _ProgramWeekOverview.ProgramWeekOverview;
  }
});

var _ProgramWeekVideos = __webpack_require__("XWIQ");

Object.defineProperty(exports, 'ProgramWeekVideos', {
  enumerable: true,
  get: function get() {
    return _ProgramWeekVideos.ProgramWeekVideos;
  }
});

var _ProgramWeekWorkouts = __webpack_require__("w893");

Object.defineProperty(exports, 'ProgramWeekWorkouts', {
  enumerable: true,
  get: function get() {
    return _ProgramWeekWorkouts.ProgramWeekWorkouts;
  }
});

__webpack_require__("vowo");

/***/ }),

/***/ "m0zx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchResults = exports.SearchOrder = exports.SearchForm = exports.SearchFilterVideos = exports.SearchFilterWorkouts = exports.SearchFilterResults = exports.SearchFilterRecipes = exports.SearchFilterBadge = exports.SearchFilter = undefined;

var _SearchFilter = __webpack_require__("mGlX");

Object.defineProperty(exports, 'SearchFilter', {
  enumerable: true,
  get: function get() {
    return _SearchFilter.SearchFilter;
  }
});

var _SearchFilterBadge = __webpack_require__("0TMH");

Object.defineProperty(exports, 'SearchFilterBadge', {
  enumerable: true,
  get: function get() {
    return _SearchFilterBadge.SearchFilterBadge;
  }
});

var _SearchFilterRecipes = __webpack_require__("5Fjo");

Object.defineProperty(exports, 'SearchFilterRecipes', {
  enumerable: true,
  get: function get() {
    return _SearchFilterRecipes.SearchFilterRecipes;
  }
});

var _SearchFilterResults = __webpack_require__("Pnbr");

Object.defineProperty(exports, 'SearchFilterResults', {
  enumerable: true,
  get: function get() {
    return _SearchFilterResults.SearchFilterResults;
  }
});

var _SearchFilterWorkouts = __webpack_require__("DzvN");

Object.defineProperty(exports, 'SearchFilterWorkouts', {
  enumerable: true,
  get: function get() {
    return _SearchFilterWorkouts.SearchFilterWorkouts;
  }
});

var _SearchFilterVideos = __webpack_require__("yI+r");

Object.defineProperty(exports, 'SearchFilterVideos', {
  enumerable: true,
  get: function get() {
    return _SearchFilterVideos.SearchFilterVideos;
  }
});

var _SearchForm = __webpack_require__("lcmv");

Object.defineProperty(exports, 'SearchForm', {
  enumerable: true,
  get: function get() {
    return _SearchForm.SearchForm;
  }
});

var _SearchOrder = __webpack_require__("3ITV");

Object.defineProperty(exports, 'SearchOrder', {
  enumerable: true,
  get: function get() {
    return _SearchOrder.SearchOrder;
  }
});

var _SearchResults = __webpack_require__("cPwT");

Object.defineProperty(exports, 'SearchResults', {
  enumerable: true,
  get: function get() {
    return _SearchResults.SearchResults;
  }
});

__webpack_require__("jynZ");

/***/ }),

/***/ "mCdB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DashboardWorkoutInspiration = exports.DashboardWorkoutInspiration = {
  bindings: {
    items: '<',
    member: '<'
  },

  template: '\n    <div class="dashboard-workout-inspiration">\n      <dashboard-carousel>\n        <dashboard-carousel-header>\n          <h4>\n            <current-day>#WorkoutInspiration</current-day>\n          </h4>\n        </dashboard-carousel-header>\n        <dashboard-carousel-body>\n          <carousel list="$ctrl.items">\n            <div class="carousel-slide-wrapper"\n              ng-repeat="item in $ctrl.items track by $index">\n              <div class="carousel-slide">\n                <card-workout\n                  workout="item"\n                  member="$ctrl.member"\n                  on-click="$ctrl.onClick(item.id, item.exercisePlanId)">\n                </card-workout>\n              </div>\n            </div>\n          </carousel>\n        </dashboard-carousel-body>\n        <dashboard-carousel-footer>\n          <span class="pl-2 small font-size-sm-base">\n            Based on your <a ui-sref="profile">Profile</a>\n            <span class="px-2 text-gray">|</span>\n            <a ui-sref="workouts.express">All Workouts</a>\n          </span>\n        </dashboard-carousel-footer>\n      </dashboard-carousel>\n    </div>',

  controller: ["$state", function controller($state) {
    'ngInject';

    return {
      onClick: function onClick(id, exercisePlanId) {
        $state.go('workouts.express.detail', { id: id, exercisePlanId: exercisePlanId });
      }
    };
  }]
};

/***/ }),

/***/ "mDm2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormTextarea = exports.FormSelectDate = exports.FormSelect = exports.FormRadioList = exports.FormRadio = exports.FormLabelCheckbox = exports.FormLabel = exports.FormInput = exports.FormGroupRow = exports.FormFieldset = exports.FormErrors = exports.FormCheckboxToggle = undefined;

var _FormCheckboxToggle = __webpack_require__("Kh7Q");

Object.defineProperty(exports, 'FormCheckboxToggle', {
  enumerable: true,
  get: function get() {
    return _FormCheckboxToggle.FormCheckboxToggle;
  }
});

var _FormErrors = __webpack_require__("wBN+");

Object.defineProperty(exports, 'FormErrors', {
  enumerable: true,
  get: function get() {
    return _FormErrors.FormErrors;
  }
});

var _FormFieldset = __webpack_require__("ox6d");

Object.defineProperty(exports, 'FormFieldset', {
  enumerable: true,
  get: function get() {
    return _FormFieldset.FormFieldset;
  }
});

var _FormGroupRow = __webpack_require__("o0vP");

Object.defineProperty(exports, 'FormGroupRow', {
  enumerable: true,
  get: function get() {
    return _FormGroupRow.FormGroupRow;
  }
});

var _FormInput = __webpack_require__("niWw");

Object.defineProperty(exports, 'FormInput', {
  enumerable: true,
  get: function get() {
    return _FormInput.FormInput;
  }
});

var _FormLabel = __webpack_require__("YQdJ");

Object.defineProperty(exports, 'FormLabel', {
  enumerable: true,
  get: function get() {
    return _FormLabel.FormLabel;
  }
});

var _FormLabelCheckbox = __webpack_require__("Ltgl");

Object.defineProperty(exports, 'FormLabelCheckbox', {
  enumerable: true,
  get: function get() {
    return _FormLabelCheckbox.FormLabelCheckbox;
  }
});

var _FormRadio = __webpack_require__("Fp91");

Object.defineProperty(exports, 'FormRadio', {
  enumerable: true,
  get: function get() {
    return _FormRadio.FormRadio;
  }
});

var _FormRadioList = __webpack_require__("w1jy");

Object.defineProperty(exports, 'FormRadioList', {
  enumerable: true,
  get: function get() {
    return _FormRadioList.FormRadioList;
  }
});

var _FormSelect = __webpack_require__("hMSj");

Object.defineProperty(exports, 'FormSelect', {
  enumerable: true,
  get: function get() {
    return _FormSelect.FormSelect;
  }
});

var _FormSelectDate = __webpack_require__("VPKl");

Object.defineProperty(exports, 'FormSelectDate', {
  enumerable: true,
  get: function get() {
    return _FormSelectDate.FormSelectDate;
  }
});

var _FormTextarea = __webpack_require__("+JvR");

Object.defineProperty(exports, 'FormTextarea', {
  enumerable: true,
  get: function get() {
    return _FormTextarea.FormTextarea;
  }
});

__webpack_require__("3Bl9");

/***/ }),

/***/ "mGlX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchFilter = undefined;

var _some2 = __webpack_require__("mGzp");

var _some3 = _interopRequireDefault(_some2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchFilter = exports.SearchFilter = {
  bindings: {
    list: '<',
    title: '@',
    type: '@',
    onClick: '&'
  },

  template: '\n    <section class="search-filters p-2 border border-bottom">\n      <header class="d-flex justify-content-between align-items-center pointer"\n        data-toggle="collapse"\n        data-target="#{{ $ctrl.title | kebabCase }}"\n        ng-click="isOpen = !isOpen">\n        {{ $ctrl.title }}\n        <i class="fa fa-lg"\n          ng-class="{ \'fa-angle-up\': isOpen, \'fa-angle-down\': !isOpen}">\n        </i>\n      </header>\n      <ul class="collapse list-inline mt-2 mb-0"\n        ng-class="{ \'show\': $ctrl.show }"\n        id="{{ $ctrl.title | kebabCase }}">\n        <li class="list-inline-item d-flex"\n          ng-repeat="item in $ctrl.list track by $index">\n          <label class="pointer"\n            ng-class="{ \'checked\' : item.checked  }">\n            <input class="d-none"\n              type="radio"\n              name="{{ $ctrl.title | kebabCase }}"\n              ng-checked="item.checked"\n              ng-click="$ctrl.onClick({ item: item, type: $ctrl.type, list: $ctrl.list })">\n            <i class="fa"\n              ng-class="{\n                \'fa-circle-o\': $ctrl.type == \'radio\' && !item.checked,\n                \'fa-dot-circle-o\': $ctrl.type == \'radio\' && item.checked,\n                \'fa-square-o\': $ctrl.type == \'checkbox\' && !item.checked,\n                \'fa-check-square\': $ctrl.type == \'checkbox\' && item.checked,\n                \'text-gray-400\': !item.checked,\n                \'text-purple-cz-mid\': item.checked\n              }"></i>\n            <span>{{ item.name }}</span>\n          </label>\n        </li>\n      </ul>\n    </section>',

  controller: function controller() {
    return {
      $onChanges: function $onChanges(changes) {
        this.show = (0, _some3.default)(changes.list.currentValue, 'checked');
      }
    };
  }
};

/***/ }),

/***/ "mHPY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mHZh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var NavDropdown = exports.NavDropdown = {
  bindings: {
    product: '<',
    subscriptions: '<',
    onClick: '&'
  },

  template: '\n    <button class="nav-link dropdown-toggle btn btn-link px-0 d-flex align-items-center"\n      type="button"\n      data-toggle="dropdown">\n      <nav-product-title\n        title="$ctrl.product.name"\n        first-name="$ctrl.product.author.firstName"\n        last-name="$ctrl.product.author.lastName">\n      <nav-product-title>\n    </button>\n    <div class="dropdown-menu dropdown-menu-right rounded-0">\n      <button class="btn-link dropdown-item btn btn-link rounded-0"\n        type="button"\n        ng-repeat="subscription in $ctrl.subscriptions track by $index"\n        ng-click="$ctrl.onClick({ subscription: subscription })">\n        {{ subscription.title }}\n        <i class="fa fa-sm fa-check text-black"\n          ng-if="subscription.voomeProductId === $ctrl.product.id">\n        </i>\n      </button>\n    </div>'
};

/***/ }),

/***/ "mew7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recipePrintUri = exports.selectRecipeInspiration = exports.selectRecipeCollectionsPagination = exports.selectRecipeCollection = exports.selectRecipeCollections = exports.selectRecipesByIds = exports.selectRecipe = exports.selectRecipes = exports.recipeLogic = exports.initialState = undefined;

var _map2 = __webpack_require__("2247");

var _map3 = _interopRequireDefault(_map2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.fetchRecipe = fetchRecipe;
exports.fetchRecipeCollections = fetchRecipeCollections;
exports.fetchRecipeCollection = fetchRecipeCollection;
exports.fetchRecipeInspiration = fetchRecipeInspiration;
exports.default = reducer;

var _normalizr = __webpack_require__("vNPR");

var _reduxLogic = __webpack_require__("E0Bt");

var _settings = __webpack_require__("Ll2K");

var _decorators = __webpack_require__("SPxS");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Action Types
var FETCH = '@@app/recipe/FETCH';
var FETCH_COLLECTION = '@@app/recipe/FETCH_COLLECTION';
var FETCH_COLLECTIONS = '@@app/recipe/FETCH_COLLECTIONS';
var FETCH_SUCCESS = '@@app/recipe/FETCH_SUCCESS';
var FETCH_ERROR = '@@app/recipe/FETCH_ERROR';
var FETCH_INSPIRATION = '@@app/recipe/FETCH_INSPIRATION';
var FETCH_INSPIRATION_SUCCESS = '@@app/recipe/FETCH_INSPIRATION_SUCCESS';
var CANCEL = '@@app/recipe/CANCEL';

// Initial State
var initialState = exports.initialState = {
  isLoading: false,
  result: undefined,
  pagination: {},
  entities: {
    recipes: {},
    collections: {},
    inspiration: []
  }
};

// Observables
var fetchRecipeLogic = (0, _reduxLogic.createLogic)({
  type: FETCH,
  cancelType: CANCEL,
  processOptions: {
    successType: FETCH_SUCCESS,
    failType: FETCH_ERROR
  },
  process: function process(_ref) {
    var action = _ref.action,
        httpClient = _ref.httpClient;
    var recipeId = action.payload.recipeId;

    var recipesSchema = new _normalizr.schema.Entity('recipes');

    return httpClient.get('/v1/voome/recipes/' + recipeId).then(function (response) {
      return (0, _normalizr.normalize)((0, _decorators.decorateRecipe)(response.data), recipesSchema);
    });
  }
});

var fetchCollectionsLogic = (0, _reduxLogic.createLogic)({
  type: FETCH_COLLECTIONS,
  cancelType: CANCEL,
  processOptions: {
    successType: FETCH_SUCCESS,
    failType: FETCH_ERROR
  },
  process: function process(_ref2) {
    var action = _ref2.action,
        httpClient = _ref2.httpClient;
    var _action$payload = action.payload,
        subscriptionId = _action$payload.subscriptionId,
        page = _action$payload.page;

    var endpoint = '/v1/voome/recipe-collections/all-ids';
    var params = { subscriptionId: subscriptionId, page: page };
    var collection = new _normalizr.schema.Entity('collections');

    return httpClient.get(endpoint, { params: params }).then(function (response) {
      var data = response.data,
          pagination = response.pagination;

      var _normalize = (0, _normalizr.normalize)(data, [collection]),
          entities = _normalize.entities,
          result = _normalize.result;

      return {
        entities: entities,
        pagination: _defineProperty({}, page, _extends({}, pagination, { result: result }))
      };
    });
  }
});

var fetchCollectionLogic = (0, _reduxLogic.createLogic)({
  type: FETCH_COLLECTION,
  cancelType: CANCEL,
  processOptions: {
    successType: FETCH_SUCCESS,
    failType: FETCH_ERROR
  },
  process: function process(_ref3) {
    var action = _ref3.action,
        httpClient = _ref3.httpClient;
    var _action$payload2 = action.payload,
        key = _action$payload2.key,
        voomeProductId = _action$payload2.voomeProductId;

    var endpoint = '/v1/voome/recipe-collections/' + key;
    var params = { voomeProductId: voomeProductId };

    var onSuccess = function onSuccess(response) {
      var data = _extends({}, response.data, {
        recipes: (0, _decorators.decorateRecipes)(response.data.recipes)
      });

      var recipe = new _normalizr.schema.Entity('recipes');
      var collection = new _normalizr.schema.Entity('collections', {
        recipes: [recipe]
      });

      return (0, _normalizr.normalize)(data, collection);
    };

    return httpClient.get(endpoint, { params: params }).then(onSuccess);
  }
});

var fetchInspirationLogic = (0, _reduxLogic.createLogic)({
  type: FETCH_INSPIRATION,
  cancelType: CANCEL,
  processOptions: {
    successType: FETCH_INSPIRATION_SUCCESS,
    failType: FETCH_ERROR
  },
  process: function process(_ref4) {
    var action = _ref4.action,
        httpClient = _ref4.httpClient;
    var _action$payload3 = action.payload,
        memberId = _action$payload3.memberId,
        params = _action$payload3.params;

    var recipes = [new _normalizr.schema.Entity('recipes')];

    return httpClient.get('/v1/members/' + memberId + '/voome-profile/recipe-inspo', { params: params }).then(function (response) {
      return (0, _normalizr.normalize)((0, _decorators.decorateRecipes)(response.data), recipes);
    });
  }
});

var recipeLogic = exports.recipeLogic = [fetchRecipeLogic, fetchCollectionsLogic, fetchCollectionLogic, fetchInspirationLogic];

// Selectors
var selectRecipes = exports.selectRecipes = function selectRecipes(state) {
  return state.entities.recipes;
};

var selectRecipe = exports.selectRecipe = function selectRecipe(state, recipeId) {
  return selectRecipes(state)[recipeId] || {};
};

var selectRecipesByIds = exports.selectRecipesByIds = function selectRecipesByIds(state, ids) {
  return (0, _map3.default)(ids, function (id) {
    return selectRecipe(state, id);
  });
};

var selectRecipeCollections = exports.selectRecipeCollections = function selectRecipeCollections(state) {
  return state.entities.collections;
};

var selectRecipeCollection = exports.selectRecipeCollection = function selectRecipeCollection(state, hackId) {
  var collection = state.entities.collections[hackId];

  return collection ? _extends({}, collection, {
    recipes: selectRecipesByIds(state, collection.recipes)
  }) : undefined;
};

var selectRecipeCollectionsPagination = exports.selectRecipeCollectionsPagination = function selectRecipeCollectionsPagination(state, page) {
  var pagination = state.pagination && state.pagination[page];

  return pagination ? _extends({}, pagination, {
    result: pagination.result.map(function (id) {
      return state.entities.collections[id];
    })
  }) : {};
};

var selectRecipeInspiration = exports.selectRecipeInspiration = function selectRecipeInspiration(state) {
  return selectRecipesByIds(state, state.entities.inspiration);
};

// Helpers
var recipePrintUri = exports.recipePrintUri = function recipePrintUri(recipeId, subscriptionId) {
  return recipeId && subscriptionId ? _settings.hosts.api + '/v1/voome/recipes/' + recipeId + '/print?subscription_id=' + subscriptionId : '#';
};

// Action Creators
function fetchRecipe(recipeId) {
  return { type: FETCH, payload: { recipeId: recipeId } };
}

function fetchRecipeCollections(subscriptionId, page) {
  return { type: FETCH_COLLECTIONS, payload: { subscriptionId: subscriptionId, page: page } };
}

function fetchRecipeCollection(key, voomeProductId) {
  return { type: FETCH_COLLECTION, payload: { key: key, voomeProductId: voomeProductId } };
}

function fetchRecipeInspiration(memberId) {
  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var params = { level: level };
  return { type: FETCH_INSPIRATION, payload: { memberId: memberId, params: params } };
}

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case FETCH:
    case FETCH_COLLECTIONS:
    case FETCH_COLLECTION:
      return _extends({}, state, {
        isLoading: true
      });

    case FETCH_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        result: payload.result,
        pagination: _extends({}, state.pagination, payload.pagination),
        entities: _extends({}, state.entities, {
          recipes: _extends({}, state.entities.recipes, payload.entities.recipes),
          collections: _extends({}, state.entities.collections, payload.entities.collections)
        })
      });

    case FETCH_INSPIRATION_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        entities: _extends({}, state.entities, {
          inspiration: payload.result,
          recipes: _extends({}, state.entities.recipes, payload.entities.recipes)
        })
      });

    default:
      return state;
  }
}

/***/ }),

/***/ "mw5s":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DashboardNutritionUpgrade = exports.DashboardNutritionUpgrade = {
  bindings: {
    recipeCollection: '<'
  },

  template: '\n    <div class="dashboard-nutrition-upgrade">\n      <section class="dashboard-cards">\n        <div class="container">\n          <div class="row">\n            <div class="card-wrapper card-sm col pointer active">\n              <card-image\n                card-class="text-center bg-teal-dark"\n                img="$ctrl.recipeCollection.coverImageUrl.magazine">\n                <small class="tagline">\n                  This week on <span class="text-orange">Coaching Zone Nutrition</span>\n                </small>\n                <h4 class="card-title">\n                  {{ $ctrl.recipeCollection.title }}\n                </h4>\n              </card-image>\n              <box-arrow-row color="white"></box-arrow-row>\n              <div class="d-md-none" ng-switch-when="3">\n                <dashboard-nutrition-hack\n                  title="$ctrl.recipeCollection.title"\n                  description="$ctrl.recipeCollection.strapLine"\n                  items="$ctrl.recipeCollection.recipes">\n                </dashboard-nutrition-hack>\n              </div>\n            </div>\n          </div>\n        </div>\n      </section>\n      <dashboard-nutrition-hack\n        title="$ctrl.recipeCollection.title"\n        description="$ctrl.recipeCollection.strapLine"\n        items="$ctrl.recipeCollection.recipes">\n      </dashboard-nutrition-hack>\n      <div class="container">\n        <div class="row">\n          <div class="card-wrapper col pointer active">\n            <a class="d-block text-center p-4 mt-3 mb-sm-0 btn-unstyled bg-teal-dark"\n              ng-click="$ctrl.onClick()">\n              <h5 class="text-white">Recipes at your fingertips</h5>\n              <p class="text-white">\n                Get full access to 20,000 recipes and over 30 recipes collections for only $3/week.\n              </p>\n              <button class="btn btn-pill theme-btn btn-md"\n                type="button"\n                ng-click="$ctrl.onClick()">\n                Learn More\n              </button>\n            </a>\n          </div>\n        </div>\n      </div>\n    </div>',

  controller: ["$state", function controller($state) {
    'ngInject';

    return {
      onClick: function onClick() {
        $state.go('nutrition');
      }
    };
  }]
};

/***/ }),

/***/ "nFAY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nVnU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignupVerifying = undefined;

var _settings = __webpack_require__("Ll2K");

var SignupVerifying = exports.SignupVerifying = {
  transclude: true,
  bindings: {
    isLoading: '<',
    message: '<'
  },

  template: '\n    <div class="signup-verifying">\n      <h1 class="h2 text-center text-white mb-4">\n        <spinner is-loading="$ctrl.isLoading">\n          <ng-transclude></ng-transclude>\n        </spinner>\n      </h1>\n      <div class="col-md-8 mx-auto">\n        <alert type="success" ng-hide="$ctrl.message">\n          <span class="text-dark">\n            We\'re verifying your transaction, please do not refresh the\n            page.\n          </span>\n        </alert>\n        <alert type="danger" ng-show="$ctrl.message">\n          <div ng-bind-html="$ctrl.message"></div>\n        </alert>\n      </div>\n    </div>'
};

/***/ }),

/***/ "ngPO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ProgramWeekMealPlan = exports.ProgramWeekMealPlan = {
  bindings: {
    completions: '<',
    isLoading: '<',
    mealPlanId: '<',
    mealPlanList: '<',
    onCardClick: '&',
    onCompleterToggle: '&',
    program: '<',
    weekNumber: '<'
  },

  template: '\n    <div class="container program-week-meal-plan">\n      <section class="section-carousel carousel-mealplan">\n        <h4>\n          <span class="aside">Week {{ $ctrl.weekNumber }}</span> Meal Plan\n          <a class="btn btn-pill btn-sm theme-btn px-2 ml-2 font-weight-semibold float-right float-sm-none"\n            ui-sref="program.week.mealPlan({ mealPlanId: $ctrl.mealPlanId })">\n            View and Edit\n          </a>\n        </h4>\n        <carousel\n          list="$ctrl.mealPlanList"\n          is-loading="$ctrl.isLoading">\n          <div class="carousel-slide-wrapper"\n            ng-class="item.mealsInGroup > 0 ? \'carousel-slide-group carousel-slide-group-\' + item.mealsInGroup : \'\'"\n            ng-repeat="item in $ctrl.mealPlanList track by $index">\n            <div class="carousel-slide"\n              ng-class="{ selected: $ctrl.program.currentWeek === $ctrl.weekNumber && $ctrl.program.currentDay === item.day }">\n              <completer\n                title="{{ \'Day \' + item.day }}"\n                is-complete="$ctrl.completions[item.dayString]"\n                on-toggle="$ctrl.onCompleterToggle({\n                  mealPlanId: $ctrl.mealPlanId,\n                  dayString: item.dayString,\n                  voomeProductId: $ctrl.program.id,\n                  weekNumber: $ctrl.weekNumber,\n                  title: \'Day \' + item.day,\n                  isComplete: $ctrl.completions[item.id]\n                })">\n              </completer>\n              <card-recipe\n                recipe="item.recipe"\n                is-leftover="item.leftOvers"\n                on-click="$ctrl.onCardClick({ recipeId: item.recipe.id })">\n              </card-recipe>\n            </div>\n          </div>\n        </carousel>\n        <div class="row mt-4">\n          <div class="col-md-9 text-md-left">\n            <ul class="fa-ul">\n              <li>\n                <i class="fa-li fa icon-recipes"></i> Stick to the plan! Have no\n                more than 2 snacks a day of dairy, fruit or nuts.\n              </li>\n            </ul>\n          </div>\n          <div class="col-md-3 text-center text-md-right">\n            <a class="link ml-3"\n              ui-sref="program.week.mealPlan.shoppingList({ mealPlanId: $ctrl.mealPlanId })">\n              Shopping list\n            </a>\n          </div>\n        </div>\n      </section>\n    </div>'
};

/***/ }),

/***/ "niWw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FormInput = exports.FormInput = {
  bindings: {
    errors: '<',
    form: '<',
    name: '@',
    minlength: '@',
    onUpdate: '&',
    pattern: '@',
    required: '@',
    type: '@',
    value: '<',
    isFocus: '<'
  },

  template: '\n    <input class="form-control"\n      ng-class="{\n        \'is-valid\': $ctrl.form[$ctrl.name].$touched && $ctrl.form[$ctrl.name].$valid,\n        \'is-invalid\': $ctrl.form[$ctrl.name].$touched && $ctrl.form[$ctrl.name].$invalid,\n      }"\n      id="{{ $ctrl.name }}"\n      type="{{ $ctrl.type }}"\n      name="{{ $ctrl.name }}"\n      pattern="{{ $ctrl.pattern }}"\n      minlength="{{ $ctrl.minlength }}"\n      focus-if="$ctrl.isFocus"\n      rb-select-all-on-focus="$ctrl.type === \'text\'"\n      ng-value="$ctrl.value"\n      ng-model="$ctrl.form.data[$ctrl.name]"\n      ng-init="$ctrl.form.data[$ctrl.name] = $ctrl.value"\n      ng-required="{{ $ctrl.required }}"\n      ng-change="$ctrl.onChange()"\n      ng-attr-autocomplete="{{ ($ctrl.type === \'password\') && \'new-password\' || undefined }}">\n    <form-errors\n      field="$ctrl.form[$ctrl.name]"\n      errors="$ctrl.errors">\n    </form-errors>',

  controller: function controller() {
    return {
      // For some reason ng-value is not updating ng-model when $ctrl.value
      // resolves. $onChanges is essentially doing this manually.
      $onChanges: function $onChanges() {
        var field = this.form[this.name];

        if (this.value && field && !field.$viewValue) {
          field.$setViewValue(this.value);

          // minlength isn't validating on load.
          if (this.minlength) {
            var minlength = parseInt(this.minlength, 10);
            var length = this.value.toString().length;

            if (length >= minlength) {
              field.$setValidity('minlength', true);
            }
          }
        }
      },


      // The $setViewValue within $onChanges will fire the ng-change so only
      // call onUpdate when $ctrl.value has actually changed.
      onChange: function onChange() {
        var key = this.name;
        var value = this.form.data[this.name];
        var field = this.form[this.name];

        if (field.$valid && value !== this.value) {
          this.onUpdate({ key: key, value: value });
        }
      }
    };
  }
};

/***/ }),

/***/ "nnql":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CardBadge = exports.CardBadge = {
  bindings: {
    icon: '@',
    text: '@'
  },

  template: '\n    <div class="card-badge badge rounded bg-cz-theme-secondary text-white p-0">\n      <i ng-if="$ctrl.icon" class="fa {{ $ctrl.icon }} text-white"></i>\n      <span ng-if="$ctrl.text">{{ $ctrl.text }}</span>\n    </div>'
};

/***/ }),

/***/ "nnw8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterDashboard = undefined;

var _settings = __webpack_require__("Ll2K");

var FooterDashboard = exports.FooterDashboard = {
  template: '\n    <footer class="footer-dashboard">\n      <div class="container">\n        <div class="row text-center">\n          <div class="col-6 pr-2">\n            <a class="d-block text-center p-3 btn-unstyled bg-cz-theme"\n              ui-sref="nutrition.favouritesRecipes">\n              <i class="icon icon-favourites fa-5x text-white d-inline-block"></i>\n              <h5 class="text-white mt-1 font-size-small font-size-sm-base">\n                Favourite Recipes\n              </h5>\n            </a>\n          </div>\n          <div class="col-6 px-2">\n            <a class="d-block text-center p-3 btn-unstyled bg-cz-theme-secondary"\n              ui-sref="profile">\n              <i class="icon icon-profile fa-5x text-white d-inline-block"></i>\n              <h5 class="text-white mt-1 font-size-small font-size-sm-base">\n                Profile\n              </h5>\n            </a>\n          </div>\n        </div>\n      </div>\n    </footer>'
};

/***/ }),

/***/ "o/Dv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FavouriteNoResult = exports.FavouriteNoResult = {
  bindings: {
    isLoading: '<',
    isFavourite: '<',
    onClick: '&'
  },

  template: '\n    <div class="favourite-no-results card rounded text-center py-3 px-4 mb-5">\n      <i class="fa fa-3x icon-favourites text-pink-cz-mid"></i>\n      <h4 class="text-gray">\n        <span ng-show="$ctrl.isLoading">\n          <spinner is-loading="true"></spinner>\n          Loading favourites...\n        </span>\n        <span ng-hide="$ctrl.isLoading">\n          You don\'t have any favourites\n        </span>\n      </h4>\n      <p class="mb-1" ng-hide="$ctrl.isLoading">\n        Items that you have selected as your favourite will appear\n        in this list.\n      </p>\n    </div>'
};

/***/ }),

/***/ "o0vP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FormGroupRow = exports.FormGroupRow = {
  transclude: {
    left: '?formGroupLeft',
    right: '?formGroupRight'
  },

  template: '\n    <div class="form-group">\n      <div class="form-row">\n        <div class="col-sm-4">\n          <div class="col-form-label pb-0" ng-transclude="left"></div>\n        </div>\n        <div class="col-sm-8" ng-transclude="right"></div>\n      </div>\n    </div>'
};

/***/ }),

/***/ "oJFC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WorkoutIntro = exports.WorkoutIntro = {
  bindings: {
    title: '<',
    subTitle: '<',
    description: '<',
    videoId: '<'
  },

  template: '\n    <div class="workout-intro bg-gray-100">\n      <div class="row">\n        <div class="col-lg-8">\n          <video-player-resumable video-id="$ctrl.videoId">\n          </video-player-resumable>\n        </div>\n        <div class="col-lg-4">\n          <div class="p-4 pl-lg-0">\n            <h2 ng-bind-html="$ctrl.title"></h2>\n            <h5 class="text-gray" ng-bind-html="$ctrl.subTitle"></h5>\n            <p class="mb-0" ng-bind-html="$ctrl.description"></p>\n          </div>\n        </div>\n      </div>\n    </div>'
};

/***/ }),

/***/ "oUay":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpeechBubbleWorkout = exports.SpeechBubbleNutrition = exports.SpeechBubble = undefined;

var _SpeechBubble = __webpack_require__("Pb7N");

Object.defineProperty(exports, 'SpeechBubble', {
  enumerable: true,
  get: function get() {
    return _SpeechBubble.SpeechBubble;
  }
});

var _SpeechBubbleNutrition = __webpack_require__("yfzx");

Object.defineProperty(exports, 'SpeechBubbleNutrition', {
  enumerable: true,
  get: function get() {
    return _SpeechBubbleNutrition.SpeechBubbleNutrition;
  }
});

var _SpeechBubbleWorkout = __webpack_require__("ryCf");

Object.defineProperty(exports, 'SpeechBubbleWorkout', {
  enumerable: true,
  get: function get() {
    return _SpeechBubbleWorkout.SpeechBubbleWorkout;
  }
});

__webpack_require__("uyiQ");

/***/ }),

/***/ "obSp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var RecipeDetail = exports.RecipeDetail = {
  bindings: {
    recipe: '<',
    isFavourite: '<',
    onFavourite: '&',
    onClickVariation: '&'
  },

  template: '\n    <div class="row">\n      <div class="col-md-8">\n        <recipe-options\n          serves="$ctrl.recipe.serves"\n          variations="$ctrl.recipe.variations"\n          prep-time="$ctrl.recipe.prepTimeMins"\n          cooking-time="$ctrl.recipe.cookingTimeMins"\n          calories="$ctrl.recipe.caloriesPerServe"\n          is-marinated="$ctrl.recipe.marinatingRequired"\n          on-click-variation="$ctrl.onClickVariation({ recipeId: recipeId })">\n        </recipe-options>\n        <div class="img-wrapper d-block d-md-none">\n          <favourite-button\n            is-favourite="$ctrl.isFavourite"\n            ng-click="$ctrl.onFavourite()"\n            ng-if="$ctrl.isFavourite !== undefined">\n          </favourite-button>\n          <img class="img-fluid"\n            ng-src="{{ $ctrl.recipe.imageUrl.large | assetSrc }}"\n            ng-if="$ctrl.recipe.imageUrl" />\n          <img class="img-fluid"\n            ng-src="{{ $ctrl.recipe.image.large | assetSrc }}"\n            ng-if="$ctrl.recipe.image" />\n        </div>\n        <section class="pt-3" ng-show="$ctrl.recipe.summary">\n          <p ng-bind="$ctrl.recipe.summary"></p>\n        </section>\n        <section class="pt-3">\n          <h5>Ingredients</h5>\n          <ingredients-list\n            ingredients="$ctrl.recipe.ingredientsList">\n          </ingredients-list>\n        </section>\n        <section class="pt-3">\n          <h5>Method</h5>\n          <div ng-bind-html="$ctrl.recipe.cookingMethodHtml"></div>\n        </section>\n        <section\n          ng-if="$ctrl.recipe.mishTipsHtml">\n          <h5>Coaching Zone Tips</h5>\n          <div ng-bind-html="$ctrl.recipe.mishTipsHtml"></div>\n        </section>\n        <div class="my-5"\n          ng-if="$ctrl.recipe.id">\n          <reviews\n            wording-plural="Reviews"\n            wording-rating="Rate this Recipe"\n            wording-singular="Review"\n            reviewable-type="Recipe"\n            reviewable-id="$ctrl.recipe.id">\n          </reviews>\n        </div>\n      </div>\n      <div class="col-md-4">\n        <div class="img-wrapper d-none d-md-block">\n          <favourite-button\n            is-favourite="$ctrl.isFavourite"\n            ng-click="$ctrl.onFavourite()"\n            ng-if="$ctrl.isFavourite !== undefined">\n          </favourite-button>\n          <img class="img-fluid"\n            ng-src="{{ $ctrl.recipe.imageUrl.large | assetSrc }}"\n            ng-if="$ctrl.recipe.imageUrl" />\n          <img class="img-fluid"\n            ng-src="{{ $ctrl.recipe.image.large | assetSrc }}"\n            ng-if="$ctrl.recipe.image" />\n          </div>\n        <div class="small text-gray my-3">\n          <p>\n            Image serve size is indicative only. Follow your recipe\n            serving size instructions and method.\n          </p>\n          <p>\n            All recipes are written for conventional ovens. If you have a\n            fan-forced oven, please decrease the stated temperature by\n            20&deg;C.\n          </p>\n        </div>\n        <nutrition-information\n          data="$ctrl.recipe.nutritionSummary"\n          serves="$ctrl.recipe.serves">\n        </nutrition-information>\n      </div>\n    </div>'
};

/***/ }),

/***/ "oqTz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var WorkoutPlayerSleeper = exports.WorkoutPlayerSleeper = {
  bindings: {
    playing: '<',
    onPlay: '&',
    onPause: '&'
  },

  template: '\n    <div class="modal fade"\n      tabindex="-1"\n      role="dialog"\n      aria-hidden="true">\n      <div class="modal-dialog" role="document">\n        <div class="modal-content">\n          <div class="modal-header text-center">\n            <h5 class="modal-title m-auto">\n              Resume workout?\n            </h5>\n          </div>\n          <div class="modal-footer justify-content-center">\n            <button class="btn btn-lg btn-pill btn-primary-inverse"\n              type="button"\n              data-dismiss="modal">\n              No\n            </button>\n            <button class="btn btn-lg btn-pill btn-primary"\n              type="button"\n              ng-click="$ctrl.resume()">\n              Yes\n            </button>\n          </div>\n        </div>\n      </div>\n    </div>',

  controller: ["$element", "$scope", function controller($element, $scope) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var _this = this;

        this.modal = $element.find('.modal');

        $(document).on('visibilitychange.sleeper', function (event) {
          $scope.$apply(function () {
            return _this.visibilityChanged(event);
          });
        });
      },
      $onDestroy: function $onDestroy() {
        $(document).off('visibilitychange.sleeper');
      },
      visibilityChanged: function visibilityChanged(event) {
        if (event.target.hidden) {
          this.backgroundMode = this.playing;
        } else if (this.backgroundMode) {
          this.backgroundMode = false;
          this.onPause();
          this.show();
        }
      },
      show: function show() {
        this.modal.modal();
      },
      resume: function resume() {
        this.onPlay();
        this.modal.modal('hide');
      }
    };
  }]
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "or7O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var NavItem = exports.NavItem = {
  bindings: {
    childPath: '<',
    icon: '<',
    path: '<',
    title: '<'
  },

  template: '\n    <a class="nav-link d-flex align-items-end"\n      ng-class="{ \'nav-link--active\': $ctrl.state.includes($ctrl.path), \'dashboard-big\': $ctrl.title == \'Dashboard\' }"\n      ng-click="$ctrl.onClick($event, $ctrl.childPath)"\n      ng-href="{{ $ctrl.state.href($ctrl.path, { \'#\': undefined }) }}">\n      <i class="nav-item mr-3 d-none d-lg-inline {{ $ctrl.icon }}"\n        ng-if="$ctrl.icon">\n      </i>\n      {{ $ctrl.title.toUpperCase() }}\n    </a>',

  controller: ["$state", function controller($state) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        this.state = $state;
      },
      onClick: function onClick(event, path) {
        if (path) {
          event.preventDefault();
          $state.go(path);
        }
      }
    };
  }]
};

/***/ }),

/***/ "ox6d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var FormFieldset = exports.FormFieldset = {
  bindings: {
    key: '@',
    type: '@',
    form: '<',
    list: '<',
    name: '<',
    onUpdate: '&'
  },

  template: '\n    <fieldset class="form-group preference-answer">\n      <ul class="d-flex flex-wrap list-inline m-0">\n        <li class="col-4 col-lg-2 col-md-3 col-sm-3 px-1 m-0 list-inline-item text-center"\n          ng-repeat="item in $ctrl.list track by $index">\n          <form-label-checkbox\n            active="item.active"\n            value="item"\n            name="$ctrl.name"\n            on-click="$ctrl.onClick($ctrl.list, $index)">\n            <i class="d-block fa fa-3x icon-voome-flame"\n              ng-class="{\n                \'text-gray-lighter\': !item.active,\n                \'text-white\': item.active\n              }">\n            </i>\n            <small ng-class="{ \'text-white\': item.active }">\n              {{ item.name }}\n            </small>\n          </form-label-checkbox>\n        </li>\n      </ul>\n    </fieldset>',

  controller: function controller() {
    return {
      onClick: function onClick(list, index) {
        var value = this.type === 'checkbox' ? this.asCheckbox(list, index) : this.asRadio(list, index);

        this.onUpdate({ key: this.key, value: value });
      },
      asCheckbox: function asCheckbox(list, $index) {
        return list.map(function (item, index) {
          return index === $index ? _extends({}, item, { active: !item.active }) : item;
        });
      },
      asRadio: function asRadio(list, $index) {
        return list.map(function (item, index) {
          return _extends({}, item, { active: index === $index ? !item.active : false });
        });
      }
    };
  }
};

/***/ }),

/***/ "ox8e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var IngredientsList = exports.IngredientsList = {
  bindings: {
    ingredients: '<'
  },

  transclude: true,

  template: '\n    <div class="ingredients-list text-left">\n      <div class="row">\n        <div class="col-md-6">\n          <ul class="fa-ul">\n            <li\n              ng-repeat="ingredient in $ctrl.ingredients track by $index"\n              ng-if="$index < ($ctrl.ingredients.length / 2)">\n                <i class="fa fa-li fa-square-o"></i>\n                {{ ingredient }}\n            </li>\n          </ul>\n        </div>\n        <div class="col-md-6">\n          <ul class="fa-ul">\n            <li\n              ng-repeat="ingredient in $ctrl.ingredients track by $index"\n              ng-if="$index >= ($ctrl.ingredients.length / 2)">\n                <i class="fa fa-li fa-square-o"></i>\n                {{ ingredient }}\n            </li>\n          </ul>\n        </div>\n      </div>\n    </div>'
};

/***/ }),

/***/ "p0QZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.facebookInit = undefined;

var _settings = __webpack_require__("Ll2K");

var facebookInit = exports.facebookInit = function facebookInit() {
  'ngInject';

  window.fbAsyncInit = function () {
    window.FB.init({
      appId: _settings.facebook.appId,
      cookie: true,
      xfbml: true,
      version: 'v2.12'
    });
  };

  // prettier-ignore
  (function (d, s, id) {
    var js,
        fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    js = d.createElement(s);js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
  })(document, 'script', 'facebook-jssdk');
};

/***/ }),

/***/ "pC/s":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var RecipeRow = exports.RecipeRow = {
  transclude: true,

  bindings: {
    recipe: '<',
    leftOvers: '<',
    cookup: '<',
    disabled: '<',
    onPreview: '&'
  },

  template: '\n    <div class="recipe-row align-items-center"\n      ng-class="{ \'recipe-row--disabled\': $ctrl.disabled }">\n      <img class="recipe-row-thumb mr-3 pointer"\n        ng-click="$ctrl.onPreview({ recipe: $ctrl.recipe })"\n        ng-src="{{ ($ctrl.recipe.imageUrl.thumb2x || $ctrl.recipe.image.thumb2x) | assetSrc }}" />\n      <a ui-sref="recipes({ recipeId: $ctrl.recipe.id })"\n        ng-disabled="$ctrl.disabled"\n        class="recipe-row-title d-flex align-items-center pr-2">\n        <h6 class="recipe-name d-inline-block font-weight-semibold m-0">\n          {{ $ctrl.recipe.name }}\n        </h6>\n        <small class="badge badge-primary text-white ml-2" ng-show="$ctrl.leftOvers">\n          Leftovers\n        </small>\n        <span class="badge fa-badge ml-2" ng-show="$ctrl.cookup">\n          <i class="fa fa-lg icon-cookup text-teal-dark"></i>\n        </span>\n      </a>\n      <ul class="recipe-row-meta mb-0 mr-2 pl-0 d-flex align-items-center">\n        <li ng-hide="$ctrl.disabled">\n          <i class="icon-serves"></i>\n          &times;{{ $ctrl.recipe.serves }}\n        </li>\n        <li ng-hide="$ctrl.disabled">\n          <i class="icon-cook-time"></i>\n          {{ $ctrl.recipe.prepTimeMins + $ctrl.recipe.cookingTimeMins }}\n          <span class="d-none d-md-inline">min</span>\n        </li>\n        <li ng-hide="$ctrl.disabled">\n          <i class="icon-calories"></i>\n          {{ $ctrl.recipe.caloriesPerServe }}\n          <span class="d-none d-md-inline">Cal</span>\n        </li>\n        <li class="last" ng-transclude></li>\n      </ul>\n    </div>'
};

/***/ }),

/***/ "pfqY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Recipe = undefined;

var _reduxUiRouter = __webpack_require__("Zb/7");

var _recipe = __webpack_require__("mew7");

var _favourite = __webpack_require__("GfAe");

var _member = __webpack_require__("1OIp");

var Recipe = exports.Recipe = {
  transclude: {
    navLeft: '?recipeNavLeft'
  },

  template: '\n    <div class="recipe">\n      <nav-page>\n        <nav-left ng-transclude="navLeft"></nav-left>\n        <nav-right>\n          <button-print\n            uri="{{ $ctrl.printUri }}"\n            tooltip="$ctrl.tooltip"\n            ng-click="$ctrl.refetchMember()"\n            ng-if="$ctrl.subscription.canPrint">\n          </button-print>\n        </nav-right>\n      </nav-page>\n      <main class="main-content">\n        <div class="container">\n          <header class="pt-4 pb-3">\n            <h2 class="mb-0">\n              {{ $ctrl.recipe.name }}\n            </h2>\n          </header>\n          <div class="pb-5">\n            <recipe-detail\n              recipe="$ctrl.recipe"\n              is-favourite="$ctrl.recipe.isFavourite"\n              on-click-variation="$ctrl.stateGo($ctrl.name, { recipeId: recipeId })"\n              on-favourite="$ctrl.toggleFavouriteRecipe({\n                memberId: $ctrl.member.id,\n                recipeId: $ctrl.recipe.id,\n                isFavourite: $ctrl.recipe.isFavourite,\n              })">\n            </recipe-detail>\n          </div>\n        </div>\n      </main>\n    </div>',

  controller: ["$ngRedux", "$timeout", function controller($ngRedux, $timeout) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.unsubscribe = connect(this);

        if (!this.recipe || !this.recipe.id || !this.recipe.nutritionSummary) {
          this.fetchRecipe(this.recipeId);
        }
      },
      $onDestroy: function $onDestroy() {
        this.unsubscribe();
      },
      refetchMember: function refetchMember() {
        var _this = this;

        this.tooltip && $timeout(function () {
          return _this.fetchMember(_this.member.id);
        }, 500);
      },
      mapState: function mapState(_ref) {
        var favourite = _ref.favourite,
            member = _ref.member,
            recipe = _ref.recipe,
            router = _ref.router;
        var recipeId = router.currentParams.recipeId;
        var name = router.currentState.name;

        var subscription = (0, _member.selectSubscription)(member);

        return {
          name: name,
          recipeId: recipeId,
          subscription: subscription,
          tooltip: (0, _member.selectPrintTooltip)(member),
          member: (0, _member.selectMember)(member),
          printUri: (0, _recipe.recipePrintUri)(recipeId, subscription.id),
          recipe: (0, _favourite.mapIsFavouriteRecipes)((0, _recipe.selectRecipe)(recipe, recipeId), (0, _favourite.selectFavouriteRecipeIds)(favourite))
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          fetchMember: _member.fetchMember,
          fetchRecipe: _recipe.fetchRecipe,
          stateGo: _reduxUiRouter.stateGo,
          toggleFavouriteRecipe: _favourite.toggleFavouriteRecipe
        };
      }
    };
  }]
};

/***/ }),

/***/ "pxBL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FormLogin = exports.FormLogin = {
  bindings: {
    isLoading: '<',
    onSubmit: '&'
  },

  template: '\n    <form class="voome-form"\n      name="form"\n      ng-submit="$ctrl.onSubmit({ data: form.data })"\n      novalidate>\n      <form-group-row>\n        <form-group-left>\n          <form-label for="email">Email</form-label>\n        </form-group-left>\n        <form-group-right>\n          <form-input\n            form="form"\n            type="email"\n            name="email"\n            required="true"\n            is-focus="true"\n            errors="{\n              required: \'This is a required field.\',\n              email: \'Must be a valid email address.\',\n            }">\n          </form-input>\n        </form-group-right>\n      </form-group-row>\n      <form-group-row>\n        <form-group-left>\n          <form-label for="password">Password</form-label>\n        </form-group-left>\n        <form-group-right>\n          <form-input\n            form="form"\n            type="password"\n            name="password"\n            required="true"\n            errors="{ required: \'This is a required field.\' }">\n          </form-input>\n        </form-group-right>\n      </form-group-row>\n      <div class="form-group form-row justify-content-end">\n        <div class="col-sm-8">\n          <label class="checkbox p-2 small font-size-sm-base">\n            <input class="mr-2" type="checkbox" ng-model="form.data.rememberMe">\n            Remember me on this device\n          </label>\n          <div class="d-flex justify-content-between justify-content-sm-start align-items-center">\n            <button-primary\n              ng-type="submit"\n              ng-disabled="form.$invalid || $ctrl.isLoading">\n              <spinner is-loading="$ctrl.isLoading">Login</spinner>\n            </button-primary>\n            <span class="px-3 text-gray-400">|</span>\n            <a class="small font-size-sm-base"\n              ui-sref="resetPassword">Forgot Password?</a>\n          </div>\n        </div>\n      </div>\n    </form>',

  controller: ["$timeout", "$scope", function controller($timeout, $scope) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var _this = this;

        $timeout(function () {
          ['email', 'password'].forEach(function (field) {
            return _this.autoFillSetValidate($scope.form[field]);
          });
        }, 1000);
      },
      autoFillSetValidate: function autoFillSetValidate(input) {
        input.$setValidity('required', input.$$element.is('*:-webkit-autofill'));
      }
    };
  }]
};

/***/ }),

/***/ "py1b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavPlain = undefined;

var _settings = __webpack_require__("Ll2K");

var NavPlain = exports.NavPlain = {
  template: '\n    <nav class="navbar navbar-light theme-light navbar--main justify-content-center">\n      <a class="navbar-brand--icon">\n        <nav-logo></nav-logo>\n      </a>\n    </nav>',

  controller: function controller() {
    return {
      $onInit: function $onInit() {
        this.publicUri = /programs/.test(window.location.href) ? _settings.hosts.public + '/programs' : '' + _settings.hosts.public;
      }
    };
  }
};

/***/ }),

/***/ "qEui":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MealPlanEdit = undefined;

var _find2 = __webpack_require__("kbi+");

var _find3 = _interopRequireDefault(_find2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxUiRouter = __webpack_require__("Zb/7");

var _utils = __webpack_require__("0xDb");

var _favourite = __webpack_require__("GfAe");

var _member = __webpack_require__("1OIp");

var _filters = __webpack_require__("ZTBt");

var _mealPlan = __webpack_require__("KLwp");

var _search = __webpack_require__("j94E");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MealPlanEdit = exports.MealPlanEdit = {
  template: '\n    <div class="meal-plan-edit">\n      <div class="overlay bg-gray-100">\n        <nav-fullscreen\n          title="\'Add Meal\'"\n          on-click="$ctrl.onDone($ctrl.mealPlanId)">\n        </nav-fullscreen>\n        <div class="container">\n          <div class="row">\n            <div class="col-2 col-md-3 px-0 pl-md-1">\n              <meal-plan-days\n                day="$ctrl.day"\n                days="$ctrl.days"\n                is-swapping="$ctrl.isSwapping"\n                is-swapping-day="$ctrl.isSwappingDay"\n                on-update="$ctrl.onUpdateParam(\'day\', dayString)"\n                on-remove="$ctrl.deleteMeal($ctrl.mealPlanId, mealId, day)">\n              </meal-plan-days>\n            </div>\n            <div class="col-10 col-md-9">\n              <div class="row">\n                <div class="col-md-8 px-0 px-md-3 bg-white">\n                  <div class="d-flex d-md-none p-2 p-md-3 border border-bottom">\n                    <button class="btn btn-link p-0"\n                      type="button"\n                      ng-click="$ctrl.toggleFiltersIsActive()">\n                      <i class="fa fa-2x fa-sliders"></i>\n                    </button>\n                    <button class="btn btn-link p-0 ml-3"\n                      type="button"\n                      ng-click="$ctrl.onToggleFavourites()">\n                      <i class="fa fa-2x icon-favourites"\n                        ng-class="{ \'text-teal-dark\': $ctrl.isFavourites }">\n                      </i>\n                    </button>\n                    <search-form\n                      class="d-inline-flex ml-auto"\n                      placeholder="find recipes"\n                      query="$ctrl.params.q"\n                      on-submit="$ctrl.onUpdateParam(\'q\', query)">\n                    </search-form>\n                  </div>\n                  <div class="pl-2 p-md-0">\n                    <div class="alert alert-warning mt-3 mb-0"\n                      ng-if="$ctrl.isProductRequirements">\n                      Please be aware that if you choose to swap recipes into your plan, they may not be suitable for\n                      {{ $ctrl.isProductLowFodmap ? "Low FODMAP" : "your Program\'s" }}\n                      dietary requirements, and you will need to adapt ingredients accordingly.\n                    </div>\n                    <search-filter-results\n                      query="$ctrl.search.params.q"\n                      filters="$ctrl.checkedFilters"\n                      on-clear-all="$ctrl.onClearAll()"\n                      on-update-param="$ctrl.onUpdateParam(key, value)"\n                      on-update-filter="$ctrl.onUpdateFilter(item, type, key)">\n                    </search-filter-results>\n                    <search-results\n                      on-update-param="$ctrl.onUpdateParam(key, value)"\n                      order="$ctrl.sortBy"\n                      pagination="$ctrl.pagination"\n                      type="recipes">\n                      <div class="border border-bottom w-100"></div>\n                      <div class="meal-plan-recipe-row recipe-row-sm"\n                        ng-repeat="recipe in $ctrl.results track by $index">\n                        <meal-plan-serves\n                          recipe="recipe"\n                          on-add-recipe="$ctrl.createMeal(\n                            $ctrl.dayKey,\n                            $ctrl.mealPlanId,\n                            recipeId,\n                            leftOvers\n                          ); $ctrl.active = undefined"\n                          on-close="$ctrl.active = undefined"\n                          ng-show="$ctrl.active === recipe.id">\n                        </meal-plan-serves>\n                        <recipe-row\n                          recipe="recipe"\n                          on-preview="$ctrl.onPreview(recipe)">\n                          <button class="btn btn-link p-0"\n                            ng-click="$ctrl.active = recipe.id">\n                            <i class="fa fa-2x fa-plus-circle"></i>\n                          </button>\n                        </recipe-row>\n                      </div>\n                    </search-results>\n                  </div>\n                </div>\n                <div class="col-md-4 pt-3">\n                  <nav-mobile-sidebar\n                    heading="Filter"\n                    is-active="$ctrl.filtersIsActive"\n                    on-click="$ctrl.toggleFiltersIsActive()">\n                    <div class="d-none d-md-block">\n                      <div class="border border-bottom pb-3">\n                        <search-form\n                          placeholder="find recipes"\n                          query="$ctrl.params.q"\n                          on-submit="$ctrl.onUpdateParam(\'q\', query)">\n                        </search-form>\n                      </div>\n                      <div class="d-flex justify-content-between align-items-center border border-bottom p-2 mb-2">\n                        Favourites\n                        <button class="btn btn-link p-0 border-0"\n                          type="button"\n                          ng-click="$ctrl.onToggleFavourites()">\n                          <i class="fa fa-2x mr-0" ng-class="{\n                            \'fa-toggle-on\': $ctrl.isFavourites,\n                            \'fa-toggle-off\': !$ctrl.isFavourites\n                          }"></i>\n                        </button>\n                      </div>\n                    </div>\n                    <search-filter-recipes\n                      filters="$ctrl.filters"\n                      on-click="$ctrl.onUpdateFilter(item, type, key, list)">\n                    </search-filter-recipes>\n                  </nav-mobile-sidebar>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <recipe-preview\n        recipe-id="$ctrl.previewId"\n        show-on="$ctrl.previewShow">\n      </recipe-preview>\n    </div>',

  controller: ["$ngRedux", "$state", "$timeout", function controller($ngRedux, $state, $timeout) {
    'ngInject';

    var EMPTY_PARAMS = {
      page: undefined,
      filters: undefined,
      order: undefined,
      q: undefined,
      serves: undefined
    };

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        var _$ngRedux$getState = $ngRedux.getState(),
            filters = _$ngRedux$getState.filters,
            router = _$ngRedux$getState.router;

        var currentParams = router.currentParams;

        var _memberStorage$get = _utils.memberStorage.get(),
            mealPlanHelpModal = _memberStorage$get.mealPlanHelpModal;

        // Search for recipes using the current route params.


        this.isFavourites ? this.fetchFavouriteRecipes(_extends({}, currentParams, {
          memberId: this.member.id
        })) : this.searchRecipes(currentParams);

        // Fetch mealPlans
        if (!this.days.length) {
          this.fetchMealPlan(this.mealPlanId, this.level);
        }

        // Fetch filters
        if (!filters.recipes.length) {
          this.fetchFiltersRecipes();
        }

        // Hide mobile sidebar
        this.showMobileSidebar = false;

        // Show or hide Help Modal
        if (!mealPlanHelpModal) {
          this.showHelpModal = true;
          _utils.memberStorage.setKey('mealPlanHelpModal', true);
        }
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();
      },
      onToggleFavourites: function onToggleFavourites() {
        var pathKey = this.getPathKey('edit');
        var _params = this.params,
            level = _params.level,
            order = _params.order,
            page = _params.page;

        var favourites = this.isFavourites ? undefined : true;

        if (favourites) {
          this.fetchFavouriteRecipes(_extends({}, this.params, {
            memberId: this.member.id
          }));
        }

        this.stateGo(pathKey, _extends({}, EMPTY_PARAMS, {
          day: this.day,
          level: level,
          page: 1,
          favourites: favourites
        }));
      },
      onUpdateFilter: function onUpdateFilter(item, type, key) {
        var list = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

        this.onUpdateParam(key, (0, _filters.updateFilters)(item.id, type, this.params[key], list));
      },
      onUpdateParam: function onUpdateParam(key) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        var pathKey = this.getPathKey('edit');
        var page = value !== this.params[key] || key === 'q' ? undefined : this.params.page;

        this.stateGo(pathKey, _extends({}, this.params, _defineProperty({
          page: page,
          level: this.level
        }, key, value)));
      },
      onClearAll: function onClearAll() {
        this.stateGo(this.getPathKey('edit'), EMPTY_PARAMS);
      },
      onDone: function onDone(mealPlanId) {
        this.resetSearch();

        // TODO: do a hard redirect to edit, due to some issues with the state
        // updating and a race condition.
        window.location.assign($state.href(this.getPathKey(), _extends({}, EMPTY_PARAMS, { mealPlanId: mealPlanId })));

        // this.stateGo(this.getPathKey(), { ...EMPTY_PARAMS, mealPlanId });
      },
      onPreview: function onPreview(recipe) {
        var _this = this;

        this.previewId = recipe.id;
        this.previewShow = true;
        $timeout(function () {
          return _this.previewShow = false;
        });
      },
      getPathKey: function getPathKey(append) {
        var weekNumber = $ngRedux.getState().router.currentParams.weekNumber;

        var parts = weekNumber ? ['program', 'week', 'mealPlan'] : ['nutrition', 'mealPlans', 'detail'];

        if (append) {
          parts.push(append);
        }

        return parts.join('.');
      },
      mapState: function mapState(state) {
        var favourite = state.favourite,
            filters = state.filters,
            mealPlan = state.mealPlan,
            member = state.member,
            router = state.router,
            recipe = state.recipe,
            search = state.search;
        var _router$currentParams = router.currentParams,
            day = _router$currentParams.day,
            favourites = _router$currentParams.favourites,
            mealPlanId = _router$currentParams.mealPlanId,
            order = _router$currentParams.order,
            page = _router$currentParams.page,
            serves = _router$currentParams.serves,
            voomeProductId = _router$currentParams.voomeProductId;


        var filterParams = router.currentParams.filters;
        var isSwapping = mealPlan.isSwapping,
            isSwappingDay = mealPlan.isSwappingDay;

        var days = (0, _mealPlan.selectDays)(mealPlan, mealPlanId);
        var dayKey = ((0, _find3.default)(days, { dayString: day }) || {}).day;
        var isFavourites = favourites === 'true';
        var level = (0, _member.selectMemberLevel)(member);

        var pagination = isFavourites ? (0, _favourite.selectFavouriteRecipes)(favourite, { page: page, level: level, order: order }) : (0, _search.selectSearchPagination)(search);

        var results = isFavourites ? pagination.result : (0, _search.selectSearchResults)(search);

        return {
          day: day,
          days: days,
          dayKey: dayKey,
          isFavourites: isFavourites,
          isSwapping: isSwapping,
          isSwappingDay: isSwappingDay,
          level: level,
          mealPlanId: mealPlanId,
          pagination: pagination,
          results: results,
          search: search,
          member: (0, _member.selectMember)(member),
          isProductLowFodmap: (0, _member.selectIsProductLowFodmap)(member, voomeProductId),
          isProductRequirements: (0, _member.selectIsProductWithRequirements)(member, voomeProductId),

          // Search
          filters: (0, _filters.selectFiltersRecipesGrouped)(filters, filterParams, serves),
          filtersIsActive: filters.isActive,
          checkedFilters: (0, _filters.selectFiltersRecipesChecked)(filters, filterParams, serves),
          sortBy: (0, _filters.selectSortByRecipes)(filters, order),
          params: (0, _search.selectSearchParams)(search)
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          createMeal: _mealPlan.createMeal,
          deleteMeal: _mealPlan.deleteMeal,
          fetchFavouriteRecipes: _favourite.fetchFavouriteRecipes,
          fetchFiltersRecipes: _filters.fetchFiltersRecipes,
          fetchMealPlan: _mealPlan.fetchMealPlan,
          resetSearch: _search.resetSearch,
          searchRecipes: _search.searchRecipes,
          stateGo: _reduxUiRouter.stateGo,
          swapRemove: _mealPlan.swapRemove,
          toggleFiltersIsActive: _filters.toggleFiltersIsActive
        };
      }
    };
  }]
};

/***/ }),

/***/ "qI5z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Member = __webpack_require__("ikrk");

Object.defineProperty(exports, 'PROFILE_CANCELLATION_REASONS', {
  enumerable: true,
  get: function get() {
    return _Member.PROFILE_CANCELLATION_REASONS;
  }
});
Object.defineProperty(exports, 'PROFILE_NUTRITION', {
  enumerable: true,
  get: function get() {
    return _Member.PROFILE_NUTRITION;
  }
});
Object.defineProperty(exports, 'PROFILE_WORKOUT', {
  enumerable: true,
  get: function get() {
    return _Member.PROFILE_WORKOUT;
  }
});

var _Product = __webpack_require__("zC1G");

Object.defineProperty(exports, 'GRADUATION_DATA', {
  enumerable: true,
  get: function get() {
    return _Product.GRADUATION_DATA;
  }
});
Object.defineProperty(exports, 'SPECIAL_REQUIREMENT_PRODUCTS', {
  enumerable: true,
  get: function get() {
    return _Product.SPECIAL_REQUIREMENT_PRODUCTS;
  }
});

var _Upgrade = __webpack_require__("+HSI");

Object.defineProperty(exports, 'UPGRADE_TEXT', {
  enumerable: true,
  get: function get() {
    return _Upgrade.UPGRADE_TEXT;
  }
});

var _Signup = __webpack_require__("bDkE");

Object.defineProperty(exports, 'CHARGIFY_ERROR_CODES', {
  enumerable: true,
  get: function get() {
    return _Signup.CHARGIFY_ERROR_CODES;
  }
});
Object.defineProperty(exports, 'CREDIT_CARD_FIELDS', {
  enumerable: true,
  get: function get() {
    return _Signup.CREDIT_CARD_FIELDS;
  }
});
Object.defineProperty(exports, 'CREDIT_CARD_REDIRECT_URI', {
  enumerable: true,
  get: function get() {
    return _Signup.CREDIT_CARD_REDIRECT_URI;
  }
});
Object.defineProperty(exports, 'SIGNUP_FIELDS_SECURE', {
  enumerable: true,
  get: function get() {
    return _Signup.SIGNUP_FIELDS_SECURE;
  }
});
Object.defineProperty(exports, 'SIGNUP_FIELDS', {
  enumerable: true,
  get: function get() {
    return _Signup.SIGNUP_FIELDS;
  }
});
Object.defineProperty(exports, 'SIGNUP_IS_DEV', {
  enumerable: true,
  get: function get() {
    return _Signup.SIGNUP_IS_DEV;
  }
});
Object.defineProperty(exports, 'SIGNUP_REDIRECT_LIST', {
  enumerable: true,
  get: function get() {
    return _Signup.SIGNUP_REDIRECT_LIST;
  }
});
Object.defineProperty(exports, 'SIGNUP_MONTHS', {
  enumerable: true,
  get: function get() {
    return _Signup.SIGNUP_MONTHS;
  }
});
Object.defineProperty(exports, 'SIGNUP_REDIRECT_URI', {
  enumerable: true,
  get: function get() {
    return _Signup.SIGNUP_REDIRECT_URI;
  }
});
Object.defineProperty(exports, 'SIGNUP_TEXT', {
  enumerable: true,
  get: function get() {
    return _Signup.SIGNUP_TEXT;
  }
});
Object.defineProperty(exports, 'SIGNUP_TEXT_COUPON', {
  enumerable: true,
  get: function get() {
    return _Signup.SIGNUP_TEXT_COUPON;
  }
});
Object.defineProperty(exports, 'SIGNUP_TYPES', {
  enumerable: true,
  get: function get() {
    return _Signup.SIGNUP_TYPES;
  }
});
Object.defineProperty(exports, 'SIGNUP_YEARS', {
  enumerable: true,
  get: function get() {
    return _Signup.SIGNUP_YEARS;
  }
});

/***/ }),

/***/ "qcpF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IngredientsList = exports.IngredientsChecklist = exports.IngredientsCheck = undefined;

var _IngredientsCheck = __webpack_require__("3o3y");

Object.defineProperty(exports, 'IngredientsCheck', {
  enumerable: true,
  get: function get() {
    return _IngredientsCheck.IngredientsCheck;
  }
});

var _IngredientsChecklist = __webpack_require__("TdT7");

Object.defineProperty(exports, 'IngredientsChecklist', {
  enumerable: true,
  get: function get() {
    return _IngredientsChecklist.IngredientsChecklist;
  }
});

var _IngredientsList = __webpack_require__("ox8e");

Object.defineProperty(exports, 'IngredientsList', {
  enumerable: true,
  get: function get() {
    return _IngredientsList.IngredientsList;
  }
});

__webpack_require__("Gttd");

/***/ }),

/***/ "qe1y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShoppingList = undefined;

var _map2 = __webpack_require__("2247");

var _map3 = _interopRequireDefault(_map2);

var _member = __webpack_require__("1OIp");

var _mealPlan = __webpack_require__("KLwp");

var _shoppingList = __webpack_require__("as7P");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShoppingList = exports.ShoppingList = {
  template: '\n    <section class="shopping-list pt-3 pb-5 bg-gray-100 border border-y">\n      <div class="container pb-3">\n        <div class="row">\n          <div class="col-md-5 order-2 order-md-1">\n            <span class="d-table-cell text-nowrap pr-2">\n              Group By:\n            </span>\n            <div class="d-table-cell w-100">\n              <div class="pill-toggle d-flex">\n                <button\n                  type="button"\n                  class="btn btn-sm btn-pill w-100"\n                  ng-class="{ \'btn-primary\': $ctrl.sort === \'category\' }"\n                  ng-click="$ctrl.onToggle(\'category\')">\n                  Category\n                </button>\n                <button\n                  type="button"\n                  class="btn btn-sm btn-pill w-100"\n                  ng-class="{ \'btn-primary\': $ctrl.sort === \'recipe\' }"\n                  ng-click="$ctrl.onToggle(\'recipe\')">\n                  Recipes\n                </button>\n              </div>\n            </div>\n          </div>\n          <div class="col-md-7 order-1 order-md-2">\n            <div class="d-flex align-items-center pb-3 pb-md-0"\n              ng-class="{\n                \'justify-content-between\': $ctrl.hasChecked,\n                \'justify-content-end\': !$ctrl.hasChecked\n              }">\n              <button-link\n                ng-show="$ctrl.hasChecked"\n                ng-click="$ctrl.shoppingListUncheckAll($ctrl.member.id)">\n                <span class="font-size-small font-size-md-base">\n                  Reset Shopping List\n                </span>\n              </button-link>\n              <button-print\n                uri="{{ $ctrl.pdfs.shoppingList }}?level={{ $ctrl.level }}&group_by={{ $ctrl.sort }}"\n                tooltip="$ctrl.tooltip"\n                ng-click="$ctrl.refetchMember()"\n                ng-if="$ctrl.subscription.canPrint">\n              </button-print>\n            </div>\n          </div>\n        </div>\n        <div class="pt-4"\n          ng-repeat="(name, ingredients) in $ctrl.shoppingList track by $index"\n          ng-hide="$ctrl.isLoading || ingredients.length === 0">\n          <h4>\n            <span class="mr-2">\n              {{ name }}\n            </span>\n            <span class="text-gray"\n              ng-if="$ctrl.sort === \'recipe\' && $ctrl.recipes">\n              <i class="icon-serves text-purple-cz-mid"></i>\n              x{{ $ctrl.shoppingListMeta[name].serves }}\n            </span>\n          </h4>\n          <div class="py-3 bg-white border border-y">\n            <strong class="ml-4"\n              ng-if="$ctrl.sort === \'recipe\' && $ctrl.shoppingListMeta[name].count > 1">\n              Appears {{ $ctrl.shoppingListMeta[name].count }}x, ingredients adjusted.\n            </strong>\n            <ingredients-checklist\n              ingredients="ingredients"\n              checked="$ctrl.checked"\n              on-toggle="$ctrl.shoppingListToggleCheck(item, $ctrl.member.id)">\n            </ingredients-checklist>\n          </div>\n        </div>\n      </div>\n    </section>',

  controller: ["$ngRedux", "$timeout", function controller($ngRedux, $timeout) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        if (!this.mealPlan.id) {
          this.fetchMealPlan(this.mealPlanId, this.level);
        }

        this.recipes.length ? this.onToggle('category') : this.onLoaded();
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();

        if (this.unsubscribe) {
          this.unsubscribe();
        }
      },
      onLoaded: function onLoaded() {
        var _this = this;

        this.unsubscribe = $ngRedux.subscribe(function () {
          if (_this.recipes.length) {
            _this.unsubscribe();
            _this.onToggle('category');
          }
        });
      },
      onToggle: function onToggle(sort) {
        this.sort = sort;
        this.shoppingListFetch((0, _map3.default)(this.recipes, 'id').join(), this.member.id, sort, this.level);
      },
      refetchMember: function refetchMember() {
        var _this2 = this;

        this.tooltip && $timeout(function () {
          return _this2.fetchMember(_this2.member.id);
        }, 500);
      },
      mapState: function mapState(_ref) {
        var mealPlan = _ref.mealPlan,
            member = _ref.member,
            router = _ref.router,
            shoppingList = _ref.shoppingList;
        var mealPlanId = router.currentParams.mealPlanId;

        var subscription = (0, _member.selectSubscription)(member);
        var recipes = (0, _mealPlan.selectShoppingListRecipes)(mealPlan, mealPlanId);

        return {
          mealPlanId: mealPlanId,
          recipes: recipes,
          subscription: subscription,

          // Member
          member: (0, _member.selectMember)(member),
          level: (0, _member.selectMemberLevel)(member),
          tooltip: (0, _member.selectPrintTooltip)(member),

          // Meal plan
          mealPlan: (0, _mealPlan.selectMealPlan)(mealPlan, mealPlanId),
          pdfs: (0, _mealPlan.selectMealPlanPdfs)(mealPlan, mealPlanId, subscription.id),

          // Shoppinglist
          isLoading: (0, _shoppingList.selectShoppingListIsLoading)(shoppingList),
          checked: (0, _shoppingList.selectShoppingListChecked)(shoppingList),
          hasChecked: (0, _shoppingList.selectShoppingListHasChecked)(shoppingList),
          shoppingList: (0, _shoppingList.selectShoppingList)(shoppingList),
          shoppingListMeta: (0, _shoppingList.selectShoppingListMeta)(shoppingList, recipes)
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          fetchMealPlan: _mealPlan.fetchMealPlan,
          fetchMember: _member.fetchMember,
          shoppingListFetch: _shoppingList.shoppingListFetch,
          shoppingListToggleCheck: _shoppingList.shoppingListToggleCheck,
          shoppingListUncheckAll: _shoppingList.shoppingListUncheckAll
        };
      }
    };
  }]
};

/***/ }),

/***/ "qhmN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MealPlanHelp = exports.MealPlanHelp = {
  template: '\n    <div\n      id="modalMealPlanHelp"\n      class="meal-plan-help modal fade"\n      data-backdrop="static"\n      tabindex="-1"\n      role="dialog"\n      aria-labelledby="Meal Plan Help"\n      aria-hidden="true">\n      <div class="modal-dialog modal-lg" role="document">\n        <div class="modal-content">\n          <div class="modal-header d-flex align-items-center mx-1">\n            <h5 class="modal-title m-auto">\n              How to create a new meal plan\n            </h5>\n          </div>\n          <div class="modal-body container p-0">\n            <div class="row no-gutters">\n              <div class="col-lg-6">\n                <div class="tab-content">\n                  <div class="tab-pane active" id="help-1" role="tabpanel">\n                    <h5 class="tab-pane-title d-md-none d-lg-none d-xl-none">1. Pick the day you wish to add meals to</h5>\n                    <div class="meal-plan-help-img help-1"></div>\n                  </div>\n\n                  <div class="tab-pane" id="help-2" role="tabpanel">\n                    <h5 class="tab-pane-title d-md-none d-lg-none d-xl-none">2. Search for the meal</h5>\n                    <div class="meal-plan-help-img help-2"></div>\n                  </div>\n\n                  <div class="tab-pane" id="help-3" role="tabpanel">\n                    <h5 class="tab-pane-title d-md-none d-lg-none d-xl-none">3. Click <i class="fa fa-plus-circle"></i> and select number of serves</h5>\n                    <div class="meal-plan-help-img help-3"></div>\n                  </div>\n\n                  <div class="tab-pane" id="help-4" role="tabpanel">\n                    <h5 class="tab-pane-title d-md-none d-lg-none d-xl-none">4. Click Done</h5>\n                    <div class="meal-plan-help-img help-4"></div>\n                  </div>\n\n                  <div class="tab-pane" id="help-5" role="tabpanel">\n                    <h5 class="tab-pane-title d-md-none d-lg-none d-xl-none">Enjoy your Meal Plan and Shopping List</h5>\n                    <div class="meal-plan-help-img help-5"></div>\n                  </div>\n                </div>\n              </div>\n              <div class="col-lg-6 border-left">\n                <ul class="nav nav-tabs nav-tabs-vertical" role="tablist">\n                  <li class="nav-item">\n                    <a href="#help-1" class="nav-link active" data-toggle="tab" role="tab" ng-click="$ctrl.step = 1">\n                      1. Pick the day you wish to add meals to\n                    </a>\n                  </li>\n\n                  <li class="nav-item">\n                    <a href="#help-2" class="nav-link" data-toggle="tab" role="tab" ng-click="$ctrl.step = 2">\n                      2. Search for the meal\n                    </a>\n                  </li>\n\n                  <li class="nav-item">\n                    <a href="#help-3" class="nav-link" data-toggle="tab" role="tab" ng-click="$ctrl.step = 3">\n                      3. Click <i class="fa fa-plus-circle"></i> and select number of serves\n                    </a>\n                  </li>\n\n                  <li class="nav-item">\n                    <a href="#help-4" class="nav-link" data-toggle="tab" role="tab" ng-click="$ctrl.step = 4">\n                      4. Click Done\n                    </a>\n                  </li>\n\n                  <li class="nav-item">\n                    <a href="#help-5" class="nav-link" data-toggle="tab" role="tab" ng-click="$ctrl.step = 5">\n                      Enjoy your Meal Plan and Shopping List\n                    </a>\n                  </li>\n                </ul>\n              </div>\n            </div>\n          </div>\n          <div class="modal-footer justify-content-between">\n            <button-primary\n              size="md"\n              data-dismiss="modal"\n              is-inverse="true">\n              Close\n            </button-primary>\n            <button-primary\n              class="d-none d-md-block"\n              size="md"\n              is-inverse="true"\n              on-click="$ctrl.onHelpNext()"\n              ng-if="$ctrl.step !== 5">\n              Next\n            </button-primary>\n            <button-primary\n              class="d-none d-md-block"\n              data-dismiss="modal"\n              size="md"\n              ng-if="$ctrl.step === 5">\n              Done\n            </button-primary>\n            <button-primary\n              class="d-md-none"\n              size="md"\n              data-dismiss="modal">\n              Done\n            </button-primary>\n          </div>\n        </div>\n      </div>\n    </div>',

  controller: ["$element", "$timeout", function controller($element, $timeout) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        this.modal = $element.find('#modalMealPlanHelp');
        this.modal.modal('show');
        this.step = 1;
      },
      onHelpNext: function onHelpNext() {
        var _this = this;

        $timeout(function () {
          _this.step += 1;
          $element.find('[href="#help-' + _this.step + '"]').click();
        });
      }
    };
  }]
};

/***/ }),

/***/ "r93F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rAUk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DashboardNutritionHack = exports.DashboardNutritionHack = {
  bindings: {
    description: '<',
    items: '<',
    hackId: '<',
    title: '<'
  },

  template: '\n    <div class="dashboard-nutrition-hack">\n      <dashboard-carousel>\n        <dashboard-carousel-header>\n          <h4>{{ $ctrl.title }}</h4>\n          <p>\n            {{ $ctrl.description }}\n            <a ui-sref="nutrition.hacks.recipes({ hackId: $ctrl.hackId})">\n              Read Article.\n            </a>\n          </p>\n        </dashboard-carousel-header>\n        <dashboard-carousel-body>\n          <carousel list="$ctrl.items">\n            <div class="carousel-slide-wrapper"\n              ng-repeat="item in $ctrl.items track by $index">\n              <div class="carousel-slide">\n                <card-recipe\n                  recipe="item"\n                  on-click="$ctrl.onClick(item.id)">\n                </card-recipe>\n              </div>\n            </div>\n          </carousel>\n        </dashboard-carousel-body>\n        <dashboard-carousel-footer>\n          <a ui-sref="nutrition.hacks">\n            View More Tips\n          </a>\n        </dashboard-carousel-footer>\n      </dashboard-carousel>\n    </div>',

  controller: ["$state", function controller($state) {
    'ngInject';

    return {
      onClick: function onClick(recipeId) {
        $state.go('nutrition.recipes.detail', { recipeId: recipeId });
      }
    };
  }]
};

/***/ }),

/***/ "rEmd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CardCollection = exports.CardCollection = {
  transclude: true,

  bindings: {
    heading: '<',
    description: '<',
    img: '<'
  },

  template: '\n    <div class="card card-collection border-0 pointer">\n      <div class="card-img-wrapper bg-mask-overlay">\n        <image-background src="$ctrl.img"></image-background>\n      </div>\n      <div class="card-block text-left p-1 pl-4 pt-4">\n        <header>\n          <h4 class="card-title word-wrap mb-2">{{ $ctrl.heading }}</h4>\n        </header>\n        <p class="card-text">{{ $ctrl.description }}</p>\n        <ng-transclude></ng-transclude>\n      </div>\n    </div>'
};

/***/ }),

/***/ "rGR2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MealPlanPrint = exports.MealPlanPrint = {
  bindings: {
    pdfs: '<',
    level: '<',
    tooltip: '<'
  },

  template: '\n    <div class="dropdown meal-plan-print">\n      <button class="btn btn-link dropdown-toggle d-flex align-items-center pr-1"\n        data-toggle="dropdown"\n        id="meal-plan-print">\n        <i class="fa fa-lg icon-print"></i>\n        <span class="font-size-small font-size-md-base">\n          Print\n        </span>\n      </button>\n      <div class="dropdown-menu dropdown-menu-right"\n        aria-labelledby="meal-plan-print">\n        <a class="dropdown-item"\n          data-toggle="tooltip-print"\n          ng-href="{{ $ctrl.pdfs.mealPlan }}?level={{ $ctrl.level }}">\n          Meal Plan\n        </a>\n        <a class="dropdown-item"\n          data-toggle="tooltip-print"\n          ng-href="{{ $ctrl.pdfs.recipes }}?level={{ $ctrl.level }}">\n          Recipes\n        </a>\n      </div>\n    </div>',

  controller: function controller() {
    'ngInject';

    return {
      $onChanges: function $onChanges(_ref) {
        var tooltip = _ref.tooltip;

        if (tooltip && tooltip.currentValue) {
          $('[data-toggle="tooltip-print"]').tooltip('dispose');
          $('[data-toggle="tooltip-print"]').tooltip({
            placement: 'left',
            title: tooltip.currentValue
          });
        }
      },
      $onDestroy: function $onDestroy() {
        $('[data-toggle="tooltip-print"]').tooltip('hide');
      }
    };
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "rPD4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Workouts = __webpack_require__("ftdg");

Object.defineProperty(exports, 'Workouts', {
  enumerable: true,
  get: function get() {
    return _Workouts.Workouts;
  }
});

var _Detail = __webpack_require__("Esjb");

Object.defineProperty(exports, 'WorkoutsDetail', {
  enumerable: true,
  get: function get() {
    return _Detail.WorkoutsDetail;
  }
});

var _Express = __webpack_require__("VvkJ");

Object.defineProperty(exports, 'WorkoutsExpress', {
  enumerable: true,
  get: function get() {
    return _Express.WorkoutsExpress;
  }
});

var _Hack = __webpack_require__("2kdB");

Object.defineProperty(exports, 'workoutsHack', {
  enumerable: true,
  get: function get() {
    return _Hack.workoutsHack;
  }
});

var _Hacks = __webpack_require__("wyfv");

Object.defineProperty(exports, 'workoutsHacks', {
  enumerable: true,
  get: function get() {
    return _Hacks.workoutsHacks;
  }
});

var _Video = __webpack_require__("wka4");

Object.defineProperty(exports, 'WorkoutsVideo', {
  enumerable: true,
  get: function get() {
    return _Video.WorkoutsVideo;
  }
});

var _Videos = __webpack_require__("6MmS");

Object.defineProperty(exports, 'WorkoutsVideos', {
  enumerable: true,
  get: function get() {
    return _Videos.WorkoutsVideos;
  }
});

/***/ }),

/***/ "rixY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ModalPopup = exports.ModalPopup = {
  bindings: {
    size: '@',
    isLoading: '<'
  },

  transclude: {
    body: '?modalBody'
  },

  template: '\n    <div class="modal modal-popup"\n      data-show="true"\n      data-keyboard="false"\n      data-backdrop="false"\n      tabindex="-1"\n      role="dialog"\n      aria-hidden="true">\n      <div class="modal-dialog modal-dialog-centered modal-{{ $ctrl.size || \'md\' }}" role="document">\n        <div class="modal-content">\n          <div class="modal-body" ng-transclude="body"></div>\n          <button\n            class="close border-top font-weight-normal text-green-dark p-3"\n            type="button"\n            data-dismiss="modal"\n            aria-label="Close">\n            <span aria-hidden="true">Close</span>\n          </button>\n        </div>\n      </div>\n    </div>',

  controller: ["$element", function controller($element) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var $el = $element.find('.modal');

        // Display the modal
        $el.modal();
      }
    };
  }]
};

/***/ }),

/***/ "ryCf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpeechBubbleWorkout = undefined;

var _some2 = __webpack_require__("mGzp");

var _some3 = _interopRequireDefault(_some2);

var _map2 = __webpack_require__("2247");

var _map3 = _interopRequireDefault(_map2);

var _filter2 = __webpack_require__("RyI1");

var _filter3 = _interopRequireDefault(_filter2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__("qI5z");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SpeechBubbleWorkout = exports.SpeechBubbleWorkout = {
  transclude: true,

  bindings: {
    form: '<',
    member: '<',
    scrollTo: '&',
    onComplete: '&',
    onUpdate: '&'
  },

  template: '\n    <div class="speech-bubble-nutrition py-4 bg-white">\n      <div class="speech-bubble-step">\n        <speech-bubble class="fade-in-1">\n          Now let\'s set up your workout profile by answering 3 easy questions.\n        </speech-bubble>\n      </div>\n      <div class="pt-1" id="scroll-{{ $index }}"\n        ng-repeat="item in $ctrl.questions track by $index">\n        <div class="speech-bubble-step"\n          ng-if="$ctrl.index >= $index">\n          <speech-bubble class="fade-in-1"\n            ng-if="$index === 1">\n            Great!\n          </speech-bubble>\n          <speech-bubble\n            ng-class="{\n              \'fade-in-2\': ($index <= 1) && ($ctrl.index === $index),\n              \'fade-in-1\': ($index > 1) && ($ctrl.index === $index)\n            }">\n            <strong>{{ item.question }}</strong>\n          </speech-bubble>\n          <speech-bubble class="text-right"\n            is-answer="true"\n            ng-hide="item.isActive">\n            {{ item.answer || \'None Selected\' }}\n          </speech-bubble>\n          <div class="speech-bubble-row text-right"\n            ng-hide="item.isActive">\n            <button class="btn btn-link"\n              type="button"\n              ng-click="item.isActive = true">\n              Change\n            </button>\n          </div>\n          <div class="speech-bubble-row pt-3"\n            ng-show="item.isActive"\n            ng-class="{\n              \'fade-in-3\': ($index <= 1) && ($ctrl.index === $index),\n              \'fade-in-2\': ($index > 1) && ($ctrl.index === $index)\n            }">\n            <form-fieldset\n              form="$ctrl.form"\n              name="item.key"\n              key="voomeProfile.preferences.{{ item.key }}"\n              list="$ctrl.member.voomeProfile.preferences[item.key]"\n              type="{{ item.type }}"\n              on-update="$ctrl.onUpdate({ key: key, value: value })">\n            </form-fieldset>\n          </div>\n          <div class="speech-bubble-row full-width"\n            ng-class="{\n              \'fade-in-4\': ($index <= 1) && ($ctrl.index === $index),\n              \'fade-in-3\': ($index > 1) && ($ctrl.index === $index)\n            }">\n            <button class="btn-link btn-continue"\n              type="button"\n              ng-click="$ctrl.onClick($index, item)"\n              ng-disabled="$ctrl.isDisabled(item.key)"\n              ng-show="item.isActive">\n              <span>Continue</span>\n            </button>\n          </div>\n        </div>\n      </div>\n      <div class="speech-bubble-step fade-in-1"\n        ng-if="$ctrl.index >= $ctrl.questions.length">\n        <speech-bubble>\n          Great, we have everything we need for your workout profile.\n        </speech-bubble>\n      </div>\n    </div>',

  controller: ["$timeout", function controller($timeout) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        this.index = 0;
        this.questions = this.reduceQuestions(_constants.PROFILE_WORKOUT);
      },
      reduceQuestions: function reduceQuestions(questions) {
        var _this = this;

        return questions.map(function (item, index) {
          return _extends({}, item, {
            isActive: index === _this.index,
            answer: _this.answersAsString(item.key)
          });
        });
      },
      answersAsString: function answersAsString(key) {
        var answers = (0, _map3.default)((0, _filter3.default)(this.member.voomeProfile.preferences[key], 'active'), 'name');

        return answers ? answers.length > 1 ? answers.join(', ') : answers[0] : null;
      },
      onClick: function onClick($index, item) {
        var _this2 = this;

        if ($index <= this.index) {
          this.index = $index + 1;
          this.scrollTo({ id: 'scroll-' + this.index });
        }

        if ($index >= this.questions.length - 1) {
          $timeout(function () {
            return _this2.onComplete();
          }, 1000);
        }

        this.questions = this.reduceQuestions(this.questions);
      },
      isDisabled: function isDisabled(key) {
        return !(0, _some3.default)(this.member.voomeProfile.preferences[key], 'active');
      }
    };
  }]
};

/***/ }),

/***/ "s6Dm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Providers = undefined;

var _compileProvider = __webpack_require__("xoRb");

var _locationProvider = __webpack_require__("Dlh9");

var _ngReduxProvider = __webpack_require__("gYly");

var _stateProvider = __webpack_require__("xkmy");

var Providers = exports.Providers = angular.module('App.providers', []).config(_compileProvider.compileProvider).config(_locationProvider.locationProvider).config(_stateProvider.stateProvider).config(_ngReduxProvider.ngReduxProvider).name;
//.factory('redirectMiddleware', redirectMiddleware).name;

//import { redirectMiddleware } from './redirect-middleware';

/***/ }),

/***/ "sAsw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ButtonBlock = exports.ButtonBlock = {
  transclude: true,

  bindings: {
    ngDisabled: '<',
    onClick: '&'
  },

  template: '\n    <button class="btn p-3 theme-btn"\n      type="button"\n      ng-disabled="$ctrl.ngDisabled"\n      ng-click="$ctrl.onClick()"\n      ng-transclude>\n    </button>'
};

/***/ }),

/***/ "se24":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decorateRecipes = exports.decorateRecipe = undefined;

var _map2 = __webpack_require__("2247");

var _map3 = _interopRequireDefault(_map2);

var _includes2 = __webpack_require__("q+Dy");

var _includes3 = _interopRequireDefault(_includes2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var decorateRecipe = exports.decorateRecipe = function decorateRecipe(recipe) {
  var hasCategory = function hasCategory(key) {
    return (0, _includes3.default)(recipe.categories, key);
  };

  return recipe ? _extends({}, recipe, {
    isVegetarian: hasCategory('Vegetarian'),
    isFreezable: hasCategory('Freezable'),
    isLactoseFree: hasCategory('Lactose free'),
    isGlutenFree: hasCategory('Gluten free'),
    isMarinatingRequired: hasCategory('Marinating required'),
    isDiabeticFriendly: hasCategory('Diabetic friendly'),
    isLowFodmap: hasCategory('Low FODMAP')
  }) : undefined;
};

var decorateRecipes = exports.decorateRecipes = function decorateRecipes(recipes) {
  return (0, _map3.default)(recipes, decorateRecipe);
};

/***/ }),

/***/ "seb2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WorkoutCaloriesBurnt = undefined;

var _utils = __webpack_require__("0xDb");

var WorkoutCaloriesBurnt = exports.WorkoutCaloriesBurnt = {
  bindings: {
    member: '<',
    met: '<',
    totalTime: '<'
  },

  template: '{{ $ctrl.caloriesBurnt | number: 0 }}',

  controller: function controller() {
    'ngInject';

    return {
      $onChanges: function $onChanges() {
        if (this.member && this.met && this.totalTime) {
          this.caloriesBurnt = (0, _utils.calculateMetFor)(this.member, this.met, this.totalTime);
        }
      }
    };
  }
};

/***/ }),

/***/ "tGHz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WorkoutSection = exports.WorkoutRatings = exports.WorkoutMeta = exports.WorkoutList = exports.WorkoutIntro = exports.WorkoutCaloriesBurnt = undefined;

var _WorkoutCaloriesBurnt = __webpack_require__("seb2");

Object.defineProperty(exports, 'WorkoutCaloriesBurnt', {
  enumerable: true,
  get: function get() {
    return _WorkoutCaloriesBurnt.WorkoutCaloriesBurnt;
  }
});

var _WorkoutIntro = __webpack_require__("oJFC");

Object.defineProperty(exports, 'WorkoutIntro', {
  enumerable: true,
  get: function get() {
    return _WorkoutIntro.WorkoutIntro;
  }
});

var _WorkoutList = __webpack_require__("Yq9a");

Object.defineProperty(exports, 'WorkoutList', {
  enumerable: true,
  get: function get() {
    return _WorkoutList.WorkoutList;
  }
});

var _WorkoutMeta = __webpack_require__("wcA+");

Object.defineProperty(exports, 'WorkoutMeta', {
  enumerable: true,
  get: function get() {
    return _WorkoutMeta.WorkoutMeta;
  }
});

var _WorkoutRatings = __webpack_require__("UT8x");

Object.defineProperty(exports, 'WorkoutRatings', {
  enumerable: true,
  get: function get() {
    return _WorkoutRatings.WorkoutRatings;
  }
});

var _WorkoutSection = __webpack_require__("kxj+");

Object.defineProperty(exports, 'WorkoutSection', {
  enumerable: true,
  get: function get() {
    return _WorkoutSection.WorkoutSection;
  }
});

__webpack_require__("CQlg");

/***/ }),

/***/ "tdVs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var NavMobileSidebar = exports.NavMobileSidebar = {
  transclude: true,

  bindings: {
    heading: '@',
    isActive: '<',
    onClick: '&'
  },

  template: '\n    <nav class="nav-mobile-sidebar"\n      ng-class="{ \'sidebar--show\' : $ctrl.isActive }">\n      <div class="navbar-sidebar-content p-3 p-md-0 bg-whitesmoke">\n        <div class="d-flex d-md-none pb-2 border border-bottom">\n          <strong class="mr-auto">\n            <i class="fa fa-sliders"></i>\n            {{ $ctrl.heading }}\n          </strong>\n          <button class="btn btn-link p-0 d-inline-flex"\n            ng-click="$ctrl.onClick()">\n            Done\n          </button>\n        </div>\n        <ng-transclude></ng-transclude>\n      </div>\n      <div class="navbar-sidebar-overlay bg-black-opaque"\n        ng-click="$ctrl.onClick()">\n      </div>\n    </nav>'
};

/***/ }),

/***/ "tmhC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterMain = undefined;

var _settings = __webpack_require__("Ll2K");

var FooterMain = exports.FooterMain = {
  template: '\n    <footer class="footer-main pb-2">\n      <div class="footer-edge">\n        <div class="edge-inner">\n          <div class="edge-left"></div>\n          <div class="edge-shape"></div>\n          <div class="edge-right"></div>\n        </div>\n      </div>\n      <div class="footer-content col-lg-8 mx-auto text-center pt-2">\n        <p class="text-teal-dark d-flex justify-content-center align-items-center mb-1 font-weight-semibold">\n          from the team at <i class="logo logo-12wbt ml-1">12WBT</i>\n        </p>\n        <p>\n          Consult your healthcare professional before beginning any diet or\n          fitness regime.\n        </p>\n      </div>\n    </footer>'
};

/***/ }),

/***/ "tz8s":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignupFormPersonal = undefined;

var _settings = __webpack_require__("Ll2K");

var SignupFormPersonal = exports.SignupFormPersonal = {
  bindings: {
    isDisabled: '<',
    isLoading: '<',
    chargifyData: '<',
    product: '<',
    text: '<',
    member: '<',
    onSubmit: '&',
    onUpdate: '&'
  },

  template: '\n    <form class="voome-form"\n      name="form"\n      ng-submit="$ctrl.onSubmit()"\n      novalidate>\n      <fieldset class="mb-5"\n        ng-class="{ \'disabled\': $ctrl.isDisabled }">\n        <strong>1. Personal Details</strong>\n        <hr class="mt-1">\n        <div class="mb-3">\n          <form-group-row>\n            <form-group-left>\n              <form-label for="email">\n                Email\n              </form-label>\n            </form-group-left>\n            <form-group-right>\n              <input class="form-control"\n                ng-class="{\n                  \'is-valid\': !$ctrl.isDisabled && form.email.$touched && form.email.$valid,\n                  \'is-invalid\': form.email.$touched && form.email.$invalid,\n                }"\n                id="email"\n                name="email"\n                type="email"\n                required\n                ng-init="email = $ctrl.chargifyData.email"\n                ng-model="email"\n                ng-disabled ="$ctrl.isDisabled"\n                ng-change="$ctrl.onUpdate({\n                  key: \'email\',\n                  value: form.email.$viewValue\n                })">\n              <form-errors\n                field="form.email"\n                errors="{\n                  required: \'This is a required field.\',\n                  email: \'Must be a valid email address.\',\n                }">\n              </form-errors>\n              <div\n                class="help-text pl-2 pt-2"\n                ng-if="$ctrl.text.discountText"\n                ng-bind-html="$ctrl.text.discountText">\n              </div>\n            </form-group-right>\n          </form-group-row>\n          <form-group-row>\n            <form-group-left>\n              <form-label for="emailConfirmation">\n                Email Confirmation\n              </form-label>\n            </form-group-left>\n            <form-group-right>\n              <input class="form-control"\n                ng-class="{\n                  \'is-valid\': !$ctrl.isDisabled && form.emailConfirmation.$touched && form.emailConfirmation.$valid,\n                  \'is-invalid\': form.emailConfirmation.$touched && form.emailConfirmation.$invalid,\n                }"\n                id="emailConfirmation"\n                name="emailConfirmation"\n                type="email"\n                match="form.email"\n                required\n                ng-init="emailConfirmation = $ctrl.chargifyData.emailConfirmation"\n                ng-model="emailConfirmation"\n                ng-disabled ="$ctrl.isDisabled"\n                ng-change="$ctrl.onUpdate({\n                  key: \'emailConfirmation\',\n                  value: form.emailConfirmation.$viewValue\n                })">\n              <form-errors\n                field="form.emailConfirmation"\n                errors="{\n                  required: \'This is a required field.\',\n                  email: \'Must be a valid email address.\',\n                  match: \'Email & confirmation must match.\',\n                }">\n              </form-errors>\n            </form-group-right>\n          </form-group-row>\n          <form-group-row>\n            <form-group-left>\n              <form-label for="firstName">\n                First Name\n              </form-label>\n            </form-group-left>\n            <form-group-right>\n              <input class="form-control"\n                ng-class="{\n                  \'is-valid\': !$ctrl.isDisabled && form.firstName.$touched && form.firstName.$valid,\n                  \'is-invalid\': form.firstName.$touched && form.firstName.$invalid,\n                }"\n                id="firstName"\n                name="firstName"\n                type="text"\n                rb-select-all-on-focus="true"\n                required\n                ng-init="firstName = $ctrl.chargifyData.firstName"\n                ng-model="firstName"\n                ng-disabled ="$ctrl.isDisabled"\n                ng-change="$ctrl.onUpdate({\n                  key: \'firstName\',\n                  value: form.firstName.$viewValue\n                })">\n              <form-errors\n                field="form.firstName"\n                errors="{ required: \'This is a required field.\' }">\n              </form-errors>\n            </form-group-right>\n          </form-group-row>\n          <form-group-row>\n            <form-group-left>\n              <form-label for="lastName">\n                Last Name\n              </form-label>\n            </form-group-left>\n            <form-group-right>\n              <input class="form-control"\n                ng-class="{\n                  \'is-valid\': !$ctrl.isDisabled && form.lastName.$touched && form.lastName.$valid,\n                  \'is-invalid\': form.lastName.$touched && form.lastName.$invalid,\n                }"\n                id="lastName"\n                name="lastName"\n                type="text"\n                rb-select-all-on-focus="true"\n                required\n                ng-init="lastName = $ctrl.chargifyData.lastName"\n                ng-model="lastName"\n                ng-disabled ="$ctrl.isDisabled"\n                ng-change="$ctrl.onUpdate({\n                  key: \'lastName\',\n                  value: form.lastName.$viewValue\n                })">\n              <form-errors\n                field="form.lastName"\n                errors="{ required: \'This is a required field.\' }">\n              </form-errors>\n            </form-group-right>\n          </form-group-row>\n          <hr>\n        </div>\n        <div class="row justify-content-end">\n          <div class="col-md-12 text-center">\n            <button class="btn btn-lg btn-pill theme-btn"\n              type="submit"\n              ng-hide="$ctrl.isDisabled"\n              ng-disabled="$ctrl.isDisabled || form.$invalid">\n              <spinner is-loading="$ctrl.isLoading && form.$valid">\n                Submit\n              </spinner>\n            </button>\n          </div>\n        </div>\n      </fieldset>\n    </form>',

  controller: ["$scope", "$timeout", "$http", function controller($scope, $timeout, $http) {
    'ngInject';

    $scope.programs = [], $scope.couponCodeFunction = {
      loading: false,
      validate: function validate() {
        var couponCodeValue = $scope.form.couponCode.$viewValue;
        if (couponCodeValue) {
          $scope.couponCodeFunction.loading = true;
          var value = $scope.form.couponCode.$viewValue,
              valid = false;
          // CouponCode.validate_code({ code: couponCodeValue }, $scope.couponCodeFunction.success);
          $http.get(_settings.hosts.api + '/v3/affiliations/verify?code=' + couponCodeValue).then(function successCallback(response) {
            $scope.programs = ['6 weeks body transformation', 'coaching zone program'];
          }, function errorCallback(response) {
            $scope.programs = ['6 weeks body transformation', 'coaching zone program'];
          });
          value == 'COUPON' ? valid = true : valid = false;
          this.validated = true;
          $scope.form.couponCode.$setValidity('couponValidation', valid);
        }
      },

      success: function success(response) {
        $scope.couponCode.loading = false;
      }
    };

    return {
      $onChanges: function $onChanges() {
        var _this = this;

        if (this.member && this.member.email && $scope.form && !$scope.form.email.$modelValue) {
          ['email', 'firstName', 'lastName'].map(function (key) {
            $scope.form[key].$setViewValue(_this.member[key]);
            $scope.form[key].$render();
          });

          $scope.form['emailConfirmation'].$setViewValue(this.member['email']);
          $scope.form['emailConfirmation'].$render();
        }
      }
    };
  }]
};

/***/ }),

/***/ "uyiQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vK7p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vM9E":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MealPlanAside = exports.MealPlanAside = {
  bindings: {
    active: '<',
    subscriptionId: '<',
    totalByVoome: '<',
    totalMine: '<',
    onClick: '&'
  },

  template: '\n    <div>\n      <div class="mb-3 pl-2 pt-2 pb-2 pointer icon rounded"\n        ng-class="{ \'bg-white border\': $ctrl.active === \'byVoome\' }"\n        ng-click="$ctrl.onClick({ type: \'byVoome\' })">\n        <h6 class="mb-1">Ready-made Plans</h6>\n        <small class="text-dark">\n          Start with one of our {{ $ctrl.totalByVoome }} plans,\n          and build from there.\n        </small>\n      </div>\n      <div class="mb-3 pl-2 pt-2 pb-2 pointer icon rounded"\n        ng-class="{ \'bg-white border border\': $ctrl.active === \'mine\' }"\n        ng-click="$ctrl.onClick({ type: \'mine\' })">\n        <h6 class="mb-1">My Plans</h6>\n        <small class="text-dark">\n          <span ng-if="!$ctrl.totalMine">\n            No plans have been created.\n          </span>\n          <span ng-if="$ctrl.totalMine == 1">\n            View the plan you\'ve created.\n          </span>\n          <span ng-if="$ctrl.totalMine > 1">\n            View the {{ $ctrl.totalMine }} plans you\'ve created.\n          </span>\n        </small>\n      </div>\n      <div class="mb-3 text-center">\n        <meal-plan-create-button\n          style="button"\n          subscription-id="$ctrl.subscriptionId"\n          count="$ctrl.totalMine">\n          New Plan\n        </meal-plan-create-button>\n      </div>\n    </div>'
};

/***/ }),

/***/ "vlms":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.kebabCase = undefined;

var _kebabCase3 = __webpack_require__("Ex7i");

var _kebabCase4 = _interopRequireDefault(_kebabCase3);

var _memoize2 = __webpack_require__("zGZ6");

var _memoize3 = _interopRequireDefault(_memoize2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var kebabCase = exports.kebabCase = function kebabCase() {
  return (0, _memoize3.default)(function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return (0, _kebabCase4.default)(value);
  });
};

/***/ }),

/***/ "vowo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("GL9b");

__webpack_require__("Sfd5");

__webpack_require__("mHPY");

__webpack_require__("nFAY");

__webpack_require__("GmxU");

/***/ }),

/***/ "vsDG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WorkoutPlayerCountdown = undefined;

var _threeBeeps = __webpack_require__("XC7J");

var _threeBeeps2 = _interopRequireDefault(_threeBeeps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WorkoutPlayerCountdown = exports.WorkoutPlayerCountdown = {
  bindings: {
    countdown: '<',
    waiting: '<',
    playing: '<'
  },

  template: '\n    <div class="workout-player-countdown animated-progress-bar-container"\n      ng-class="{ \'visible\': $ctrl.visible }">\n      <div class="progress-bar animated-progress-bar"\n        ng-class="{ \'animation-on\': $ctrl.animating }">\n      </div>\n      <div class="get-ready-text text-uppercase">\n        Get Ready!\n        <span class="time-remaining">\n          {{ $ctrl.countdown === 0 ? \'GO!\' : $ctrl.countdown }}\n        </span>\n      </div>\n    </div>',

  controller: ["$element", "$timeout", function controller($element, $timeout) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        this.visible = false;
        this.animating = false;
        this.audio = new Audio(_threeBeeps2.default);
      },
      $onChanges: function $onChanges(changesObj) {
        this.clear();
        this.animate();
      },
      progressBar: function progressBar() {
        return $element.find('.progress-bar');
      },
      animate: function animate() {
        var _this = this;

        if (this.countdown === undefined) {
          return;
        }

        this.visible = this.countdown > 0 && this.playing;
        this.animating = this.visible && !this.waiting;

        if (this.countdown === 3) {
          $timeout(function () {
            var audioPromise = _this.audio.play();

            // Shut the error messages up.
            if (audioPromise && audioPromise.catch) {
              audioPromise.catch(function () {});
            }
          });
        }
      },
      clear: function clear() {
        this.progressBar().attr('style', '');
      },
      matrix: function matrix(value) {
        return String(value).match(/(-?[0-9\.]+)/g);
      },
      set: function set() {
        var $el = this.progressBar();
        var matrix = this.matrix($el.css('transform'));

        var translateX = matrix && matrix[4];
        translateX = translateX / $element.width() * 100;

        var transform = 'translate3d(' + translateX + '%, 0, 0)';

        $el.css({
          '-webkit-transform': transform,
          '-moz-transform': transform,
          '-ms-transform': transform,
          '-o-transform': transform,
          transform: transform
        });
      }
    };
  }]
};

/***/ }),

/***/ "w1jy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormRadioList = undefined;

var _set2 = __webpack_require__("4yG7");

var _set3 = _interopRequireDefault(_set2);

var _get2 = __webpack_require__("Q7hp");

var _get3 = _interopRequireDefault(_get2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormRadioList = exports.FormRadioList = {
  transclude: true,

  bindings: {
    isDisabled: '<',
    form: '<',
    name: '@',
    key: '@',
    value: '<',
    list: '<',
    listItemKey: '@',
    listItemTitle: '@',
    listItemClass: '@',
    required: '@',
    onUpdate: '&',
    isSelectable: '<'
  },

  template: '\n    <ul class="list-inline">\n      <li\n        class="px-1 m-0 {{ $ctrl.listItemClass }}"\n        ng-repeat="item in $ctrl.list track by $index">\n        <label\n          class="d-flex justify-content-center align-items-center py-2 px-3 btn rounded word-wrap"\n          ng-class="{\n            \'bg-cz-theme-secondary text-white\': item[$ctrl.listItemKey] == $ctrl.value,\n            \'bg-gray-100\': item[$ctrl.listItemKey] != $ctrl.value,\n            \'disabled text-gray\': item.isDisabled || $ctrl.isDisabled,\n          }">\n          <input class="d-none"\n            type="radio"\n            name="{{ $ctrl.name }}"\n            value="{{ item[$ctrl.listItemKey] }}"\n            ng-model="$ctrl.form.data[$ctrl.name]"\n            ng-disabled="!$ctrl.isSelectable && (item.isDisabled || $ctrl.isDisabled)"\n            ng-required="$ctrl.required"\n            ng-click="$ctrl.onUpdate({\n              key: $ctrl.key || $ctrl.name,\n              value: item[$ctrl.listItemKey],\n            })">\n          {{ item[$ctrl.listItemTitle] }}\n        </label>\n      </li>\n    </ul>',

  controller: function controller() {
    return {
      $onInit: function $onInit() {
        this.setValue(this.value);
      },
      $onChanges: function $onChanges(changes) {
        var newValue = (0, _get3.default)(changes, 'value.currentValue');
        var oldValue = (0, _get3.default)(this.form.data, this.name);

        if (newValue && newValue !== oldValue) {
          this.setValue(newValue);
        }
      },
      setValue: function setValue(value) {
        (0, _set3.default)(this.form, ['data', this.name], value ? value.toString() : value);
      }
    };
  }
};

/***/ }),

/***/ "w893":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ProgramWeekWorkouts = exports.ProgramWeekWorkouts = {
  bindings: {
    completions: '<',
    member: '<',
    onCardClick: '&',
    onCompleterToggle: '&',
    voomeProductId: '<',
    weekNumber: '<',
    items: '<'
  },

  template: '\n    <div class="container program-week-workouts">\n      <section class="section-carousel">\n        <h4>\n          <span class="aside">\n            Week {{ $ctrl.weekNumber }}\n          </span>\n          Workouts\n        </h4>\n        <carousel\n          list="$ctrl.items"\n          settings="{ slidesToShow: 3 }">\n          <div class="carousel-slide-wrapper"\n            ng-repeat="item in $ctrl.items track by item.dayString + item.id">\n            <div class="carousel-slide">\n              <completer\n                title="{{ \'Session \' + ($index + 1) }}"\n                is-complete="$ctrl.completions[item.id]"\n                on-toggle="$ctrl.onCompleterToggle({\n                  exercisePlanId: item.exercisePlanId,\n                  dayId: item.id,\n                  voomeProductId: $ctrl.voomeProductId,\n                  weekNumber: $ctrl.weekNumber,\n                  title: \'Session \' + ($index + 1),\n                  isComplete: $ctrl.completions[item.id]\n                })">\n              </completer>\n              <card-workout\n                workout="item"\n                member="$ctrl.member"\n                on-click="$ctrl.onCardClick({ id: item.id, exercisePlanId: item.exercisePlanId })">\n              </card-workout>\n            </div>\n          </div>\n        </carousel>\n      </section>\n    </div>'
};

/***/ }),

/***/ "wBN+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FormErrors = exports.FormErrors = {
  bindings: {
    field: '<',
    errors: '<'
  },

  template: '\n    <div class="invalid-feedback d-flex px-2"\n      ng-show="$ctrl.field.$touched && $ctrl.field.$invalid && $ctrl.errors"\n      ng-messages="$ctrl.field.$error">\n      <span\n        ng-repeat="(key, value) in $ctrl.errors track by $index"\n        ng-message="{{ key }}">\n        {{ value }}\n      </span>\n    </div>'
};

/***/ }),

/***/ "wUEi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WelcomeStepPrograms = exports.WelcomeStepPrograms = {
  transclude: true,

  bindings: {
    isLoading: '<',
    member: '<',
    scrollTo: '&',
    onSubmit: '&',
    onUpdate: '&'
  },

  template: '\n    <div class="welcome welcome--profile">\n      <h1 class="h2 text-center text-white my-4">\n        Your Nutrition Profile\n      </h1>\n      <section class="bg-teal p-3 mb-5">\n        <form class="voome-form voome-form--nutrition"\n          name="form"\n          ng-submit="$ctrl.onSubmit({ data: $ctrl.member })"\n          novalidate>\n          <div class="mb-3">\n            <profile-container is-editing="true">\n              <profile-fields-nutrition\n                form="form"\n                member="$ctrl.member"\n                is-editing="true"\n                on-update="$ctrl.onUpdate({ key: key, value: value })">\n              </profile-fields-nutrition>\n            </profile-container>\n          </div>\n          <div class="d-flex justify-content-center pt-4">\n            <ng-transclude></ng-transclude>\n          </div>\n        </form>\n      </section>\n    </div>'
};

/***/ }),

/***/ "wV5X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wcA+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WorkoutMeta = exports.WorkoutMeta = {
  bindings: {
    workout: '<',
    member: '<'
  },

  template: '\n    <ul class="list-unstyled d-flex justify-content-between p-3 mb-3 bg-gray-100 workout-meta small font-size-sm-base">\n      <li ng-if="$ctrl.workout.meta.equipmentRequired">\n        Equipment required\n      </li>\n      <li ng-if="$ctrl.workout.met">\n        <i class="fa fa-lg icon-calories-burnt text-green-dark"></i>\n        <workout-calories-burnt\n          member="$ctrl.member"\n          met="$ctrl.workout.met"\n          total-time="$ctrl.workout.totalTime">\n        </workout-calories-burnt> Cal\n      </li>\n      <li>\n        <i class="fa fa-lg icon-time text-green-dark"></i>\n        {{ $ctrl.workout.totalTimeMinutes }}\n      </li>\n      <li>\n        <i class="fa fa-lg icon-location text-green-dark"></i>\n        {{ $ctrl.workout.location }}\n      </li>\n    </ul>'
};

/***/ }),

/***/ "wka4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WorkoutsVideo = undefined;

var _favourite = __webpack_require__("GfAe");

var _workout = __webpack_require__("Toxe");

var WorkoutsVideo = exports.WorkoutsVideo = {
  template: '\n    <div class="workouts-video bg-white">\n      <nav-page>\n        <nav-left>\n          <button-back></button-back>\n        </nav-left>\n      </nav-page>\n      <main class="main-content">\n        <div class="container pt-4">\n          <h3 class="mb-3">{{ $ctrl.video.title }}</h3>\n          <div class="row">\n            <div class="col-lg-8">\n              <ul class="list-unstyled d-flex justify-content-between p-3 m-0 bg-gray-100 small font-size-sm-base workout-meta">\n                <li ng-if="$ctrl.video.equipmentRequired">\n                  Equipment required\n                </li>\n                <li ng-if="$ctrl.video.met">\n                  <i class="fa fa-lg icon-calories-burnt text-green-dark"></i>\n                  <workout-calories-burnt\n                    member="$ctrl.member"\n                    met="$ctrl.video.met"\n                    total-time="$ctrl.video.totalTimeInSeconds">\n                  </workout-calories-burnt> Cal\n                </li>\n                <li>\n                  <i class="fa fa-lg icon-time text-green-dark"></i>\n                  {{ $ctrl.video.time }} mins\n                </li>\n                <li ng-if="$ctrl.video.location">\n                  <i class="fa fa-lg icon-location text-green-dark"></i>\n                  {{ $ctrl.video.location }}\n                </li>\n                <li ng-if="$ctrl.video.isFavourite">\n                  <i class="fa fa-lg icon-favourites text-green-dark"></i>\n                  Favourite\n                </li>\n              </ul>\n            </div>\n            <div class="col-lg-4">\n              <ul class="list-unstyled p-3 m-0 bg-gray-100 small font-size-sm-base workout-meta">\n                <li class="d-flex justify-content-between">\n                  <span>Member Rating:</span>\n                  <rating-stars\n                    rating="$ctrl.video.averageRating"\n                    size="md">\n                  </rating-stars>\n                </li>\n              </ul>\n            </div>\n          </div>\n          <div class="pt-3 pb-5">\n            <video-playlist\n              list="$ctrl.video.items"\n              autoplay="false"\n              continuous="true"\n              loop="false">\n              <p>{{ $ctrl.video.description }}</p>\n            </video-playlist>\n          </div>\n          <div class="row mb-4">\n            <div class="col-lg-8" ng-if="$ctrl.video">\n              <reviews\n                wording-plural="Reviews"\n                wording-rating="Rate this video"\n                wording-singular="Review"\n                reviewable-type="PlaylistVideo"\n                reviewable-id="$ctrl.video.id">\n              </reviews>\n            </div>\n          </div>\n        </div>\n      </main>\n    </div>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        if (!this.video || !this.video.items) {
          this.fetchWorkoutVideo(this.videoId);
        }
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();
      },
      mapState: function mapState(_ref) {
        var router = _ref.router,
            workout = _ref.workout,
            favourite = _ref.favourite;
        var videoId = router.currentParams.videoId;
        var isLoading = workout.isLoading;


        return {
          videoId: videoId,
          isLoading: isLoading,
          video: (0, _favourite.mapIsFavouriteVideos)((0, _workout.selectWorkoutVideo)(workout, videoId), (0, _favourite.selectFavouriteVideoIds)(favourite))
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          fetchWorkoutVideo: _workout.fetchWorkoutVideo
        };
      }
    };
  }]
};

/***/ }),

/***/ "wnLK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authLoginFacebook = exports.authLogout = exports.authLogin = exports.authLogic = exports.initialState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;

var _reduxLogic = __webpack_require__("E0Bt");

var _reduxUiRouter = __webpack_require__("Zb/7");

var _settings = __webpack_require__("Ll2K");

var _member = __webpack_require__("1OIp");

var _utils = __webpack_require__("0xDb");

// Actions
var LOGIN = '@@app/auth/LOGIN';
var LOGIN_SUCCESS = '@@app/auth/LOGIN_SUCCESS';
var LOGIN_ERROR = '@@app/auth/LOGIN_ERROR';

var LOGIN_FACEBOOK = '@@app/auth/LOGIN_FACEBOOK';
var LOGIN_FACEBOOK_SUCCESS = '@@app/auth/LOGIN_FACEBOOK_SUCCESS';
var LOGIN_FACEBOOK_ERROR = '@@app/auth/LOGIN_FACEBOOK_ERROR';

var LOGOUT = '@@app/auth/LOGOUT';
var LOGOUT_SUCCESS = '@@app/auth/LOGOUT_SUCCESS';

var CANCEL = '@@app/auth/CANCEL';

// Initial State
var initialState = exports.initialState = {
  error: false,
  isLoading: false,
  message: '',
  facebookAccessToken: null
};

// Observables
var facebookLogic = (0, _reduxLogic.createLogic)({
  type: LOGIN_FACEBOOK,
  cancelType: CANCEL,
  process: function process(_ref, dispatch, done) {
    var httpClient = _ref.httpClient;

    var onSuccess = function onSuccess(authResponse) {
      var endpoint = '/v1/login-with-facebook';
      var params = {
        token: authResponse.accessToken,
        rememberMe: true,
        callbackUrl: window.location.href
      };

      httpClient.post(endpoint, params).then(function (response) {
        return dispatch({ type: LOGIN_SUCCESS, payload: response.data });
      }).catch(function () {
        return dispatch({ type: LOGIN_FACEBOOK_SUCCESS, payload: authResponse });
      }).then(done);
    };

    var onFail = function onFail(message) {
      dispatch({ type: LOGIN_FACEBOOK_ERROR, payload: { message: message } });
      done();
    };

    try {
      window.FB.getLoginStatus(function (response) {
        response.status === 'connected' ? onSuccess(response.authResponse) : onFail('Failed to login to Facebook.');
      });
    } catch (e) {
      onFail('Failed to access Facebook.');
    }
  }
});

var loginLogic = (0, _reduxLogic.createLogic)({
  type: LOGIN,
  cancelType: CANCEL,
  processOptions: {
    successType: LOGIN_SUCCESS,
    failType: LOGIN_ERROR
  },
  process: function process(_ref2) {
    var action = _ref2.action,
        httpClient = _ref2.httpClient;

    // TODO: Implement when we get the new endpoint
    // const endpoint = action.payload.facebookAccessToken
    //   ? '/v1/login/new-facebook-endpoint'
    //   : '/v1/login';

    // return (
    //   httpClient
    //     .post(endpoint, action.payload)
    //     .then(response => response.data);
    // );

    var _action$payload = action.payload,
        email = _action$payload.email,
        password = _action$payload.password,
        rememberMe = _action$payload.rememberMe,
        facebookAccessToken = _action$payload.facebookAccessToken;

    var params = { email: email, password: password, rememberMe: rememberMe };

    return httpClient.post('/v1/login', params).then(function (response) {
      if (facebookAccessToken) {
        httpClient.post('/v2/facebook-profile', {
          callbackUrl: window.location.href,
          token: facebookAccessToken
        });
      }

      return response.data;
    });
  }
});

var logoutLogic = (0, _reduxLogic.createLogic)({
  type: LOGOUT,
  cancelType: CANCEL,
  processOptions: {
    successType: LOGOUT_SUCCESS,
    failType: LOGOUT_SUCCESS
  },
  process: function process(_ref3) {
    var httpClient = _ref3.httpClient;

    return httpClient.get('/v1/logout');
  }
});

var onSuccessLogic = (0, _reduxLogic.createLogic)({
  type: [LOGIN_SUCCESS, LOGOUT_SUCCESS],
  process: function process(_ref4, dispatch, done) {
    var action = _ref4.action,
        memberStorage = _ref4.memberStorage;
    var payload = action.payload,
        type = action.type;


    switch (type) {
      case LOGIN_SUCCESS:
        {
          // authCheck will redirect member to correct page.
          dispatch((0, _member.fetchMember)(payload.memberId));
          break;
        }

      case LOGOUT_SUCCESS:
        {
          var _memberStorage$get = memberStorage.get(),
              redirectTo = _memberStorage$get.redirectTo;

          if (redirectTo && redirectTo.name === 'welcome') {
            dispatch((0, _reduxUiRouter.stateGo)('login'));
          } else {
            memberStorage.remove();
            setTimeout(function () {
              return window.location.assign('/');
            });
          }

          break;
        }
    }

    done();
  }
});

var authLogic = exports.authLogic = [facebookLogic, loginLogic, logoutLogic, onSuccessLogic];

// Action Creators
var authLogin = exports.authLogin = function authLogin(params, facebookAccessToken) {
  var email = params.email,
      password = params.password,
      rememberMe = params.rememberMe;

  return {
    type: LOGIN,
    payload: { email: email, password: password, rememberMe: rememberMe, facebookAccessToken: facebookAccessToken }
  };
};

var authLogout = exports.authLogout = function authLogout(message) {
  return { type: LOGOUT, payload: { message: message } };
};

var authLoginFacebook = exports.authLoginFacebook = function authLoginFacebook() {
  return { type: LOGIN_FACEBOOK };
};

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case LOGIN:
    case LOGIN_FACEBOOK:
      return _extends({}, state, {
        error: false,
        isLoading: true,
        message: ''
      });

    case LOGIN_SUCCESS:
      return _extends({}, state, {
        error: false,
        isLoading: false,
        message: ''
      });

    case LOGIN_FACEBOOK_SUCCESS:
      return _extends({}, state, {
        error: false,
        isLoading: false,
        message: '',
        facebookAccessToken: payload.accessToken
      });

    case LOGIN_ERROR:
      return _extends({}, state, {
        error: true,
        isLoading: false,
        message: 'Incorrect email or password.'
      });

    case LOGIN_FACEBOOK_ERROR:
      return _extends({}, state, {
        error: true,
        isLoading: false,
        message: payload.message
      });

    case LOGOUT:
      return _extends({}, state, {
        isLoading: true,
        message: payload.message
      });

    case LOGOUT_SUCCESS:
      return _extends({}, state, {
        isLoading: false
      });

    default:
      return state;
  }
}

/***/ }),

/***/ "wyfv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.workoutsHacks = undefined;

var _reduxUiRouter = __webpack_require__("Zb/7");

var _member = __webpack_require__("1OIp");

var _workout = __webpack_require__("Toxe");

var workoutsHacks = exports.workoutsHacks = {
  template: '\n    <ui-view>\n      <div class="py-3 py-md-4">\n        <div class="container">\n          <div class="row mb-2">\n            <div class="col-md-6 pb-3"\n              ng-repeat="item in $ctrl.pagination.result track by $index">\n              <card-collection\n                heading="item.title"\n                description="item.strapLine"\n                img="item.coverImageUrl.magazine"\n                ng-click="$ctrl.onClick(item)">\n              </card-collection>\n            </div>\n          </div>\n          <div class="row mb-2">\n            <div class="col">\n              <pagination-row\n                on-update-param="$ctrl.onUpdatePage(value)"\n                pagination="$ctrl.pagination">\n              </pagination-row>\n            </div>\n          </div>\n        </div>\n      </div>\n    </ui-view>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        if (!this.pagination.page) {
          this.fetchWorkoutCollections(this.subscriptionId, this.page);
        }
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();
      },
      onClick: function onClick(_ref) {
        var id = _ref.id;

        this.stateGo('workouts.hacks.exercises', { hackId: id });
      },
      onUpdatePage: function onUpdatePage(page) {
        this.stateGo('workouts.hacks', { page: page });
      },
      mapState: function mapState(_ref2) {
        var member = _ref2.member,
            router = _ref2.router,
            workout = _ref2.workout;

        var page = router.currentParams.page || 1;

        return {
          page: page,
          hasAccess: (0, _member.selectHasWorkoutSubscription)(member),
          pagination: (0, _workout.selectWorkoutCollectionsPagination)(workout, page),
          subscriptionId: (0, _member.selectSubscription)(member).id
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          fetchWorkoutCollections: _workout.fetchWorkoutCollections,
          stateGo: _reduxUiRouter.stateGo
        };
      }
    };
  }]
};

/***/ }),

/***/ "xA6u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearModal = undefined;

var _forEach2 = __webpack_require__("309y");

var _forEach3 = _interopRequireDefault(_forEach2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clearModal = exports.clearModal = ["$transitions", function clearModal($transitions) {
  'ngInject';

  $transitions.onStart('*', function () {
    var items = document.getElementsByClassName('modal-open');

    (0, _forEach3.default)(items, function (item) {
      item.classList.remove('modal-open');
    });
  });
}];

/***/ }),

/***/ "xFdZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MealPlanTags = exports.MealPlanSwaps = exports.MealPlanSwap = exports.MealPlanServes = exports.MealPlanRecipeSwap = exports.MealPlanRecipe = exports.MealPlanPrint = exports.MealPlanNav = exports.MealPlanHelp = exports.MealPlanDays = exports.MealPlanDayIcon = exports.MealPlanDayCalories = exports.MealPlanCreateButton = exports.MealPlanCookMore = exports.MealPlanCard = exports.MealPlanAside = undefined;

var _MealPlanAside = __webpack_require__("vM9E");

Object.defineProperty(exports, 'MealPlanAside', {
  enumerable: true,
  get: function get() {
    return _MealPlanAside.MealPlanAside;
  }
});

var _MealPlanCard = __webpack_require__("OT8N");

Object.defineProperty(exports, 'MealPlanCard', {
  enumerable: true,
  get: function get() {
    return _MealPlanCard.MealPlanCard;
  }
});

var _MealPlanCookMore = __webpack_require__("WOni");

Object.defineProperty(exports, 'MealPlanCookMore', {
  enumerable: true,
  get: function get() {
    return _MealPlanCookMore.MealPlanCookMore;
  }
});

var _MealPlanCreateButton = __webpack_require__("A83q");

Object.defineProperty(exports, 'MealPlanCreateButton', {
  enumerable: true,
  get: function get() {
    return _MealPlanCreateButton.MealPlanCreateButton;
  }
});

var _MealPlanDayCalories = __webpack_require__("42VI");

Object.defineProperty(exports, 'MealPlanDayCalories', {
  enumerable: true,
  get: function get() {
    return _MealPlanDayCalories.MealPlanDayCalories;
  }
});

var _MealPlanDayIcon = __webpack_require__("a7WM");

Object.defineProperty(exports, 'MealPlanDayIcon', {
  enumerable: true,
  get: function get() {
    return _MealPlanDayIcon.MealPlanDayIcon;
  }
});

var _MealPlanDays = __webpack_require__("ICZV");

Object.defineProperty(exports, 'MealPlanDays', {
  enumerable: true,
  get: function get() {
    return _MealPlanDays.MealPlanDays;
  }
});

var _MealPlanHelp = __webpack_require__("qhmN");

Object.defineProperty(exports, 'MealPlanHelp', {
  enumerable: true,
  get: function get() {
    return _MealPlanHelp.MealPlanHelp;
  }
});

var _MealPlanNav = __webpack_require__("L1S1");

Object.defineProperty(exports, 'MealPlanNav', {
  enumerable: true,
  get: function get() {
    return _MealPlanNav.MealPlanNav;
  }
});

var _MealPlanPrint = __webpack_require__("rGR2");

Object.defineProperty(exports, 'MealPlanPrint', {
  enumerable: true,
  get: function get() {
    return _MealPlanPrint.MealPlanPrint;
  }
});

var _MealPlanRecipe = __webpack_require__("2zOm");

Object.defineProperty(exports, 'MealPlanRecipe', {
  enumerable: true,
  get: function get() {
    return _MealPlanRecipe.MealPlanRecipe;
  }
});

var _MealPlanRecipeSwap = __webpack_require__("avPJ");

Object.defineProperty(exports, 'MealPlanRecipeSwap', {
  enumerable: true,
  get: function get() {
    return _MealPlanRecipeSwap.MealPlanRecipeSwap;
  }
});

var _MealPlanServes = __webpack_require__("WbE4");

Object.defineProperty(exports, 'MealPlanServes', {
  enumerable: true,
  get: function get() {
    return _MealPlanServes.MealPlanServes;
  }
});

var _MealPlanSwap = __webpack_require__("hKzP");

Object.defineProperty(exports, 'MealPlanSwap', {
  enumerable: true,
  get: function get() {
    return _MealPlanSwap.MealPlanSwap;
  }
});

var _MealPlanSwaps = __webpack_require__("I8RL");

Object.defineProperty(exports, 'MealPlanSwaps', {
  enumerable: true,
  get: function get() {
    return _MealPlanSwaps.MealPlanSwaps;
  }
});

var _MealPlanTags = __webpack_require__("3w8S");

Object.defineProperty(exports, 'MealPlanTags', {
  enumerable: true,
  get: function get() {
    return _MealPlanTags.MealPlanTags;
  }
});

__webpack_require__("jbEX");

/***/ }),

/***/ "xkTB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var NavChildren = exports.NavChildren = {
  bindings: {
    items: '<'
  },

  template: '\n    <nav class="navbar navbar--children bg-white p-0">\n      <div class="container">\n        <ul class="navbar-nav navbar-nav--list w-100 flex-row justify-content-around justify-content-md-start">\n          <li class="nav-item mt-1 mr-md-3"\n            ng-repeat="item in $ctrl.items track by $index">\n            <nav-item\n              title="item.title"\n              icon="item.icon"\n              path="item.path">\n            </nav-item>\n          </li>\n        </ul>\n      </div>\n    </nav>'
};

/***/ }),

/***/ "xkmy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stateProvider = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__("0xDb");

var stateProvider = exports.stateProvider = ["$stateProvider", "$urlServiceProvider", function stateProvider($stateProvider, $urlServiceProvider) {
  'ngInject';

  $urlServiceProvider.rules.otherwise({ state: 'login' });

  $stateProvider
  // Shared sections
  .state('login', {
    url: '/',
    component: 'login'
  }).state('logout', {
    url: '/logout',
    component: 'logout'
  }).state('resetPassword', {
    url: '/reset-password?email&reset_password_token',
    component: 'resetPassword'
  }).state('welcome', {
    url: '/welcome',
    component: 'welcomeSteps',
    authenticate: true
  }).state('welcomeUpgrade', {
    url: '/welcome/upgrade/{slug:string}',
    component: 'welcomeSteps',
    authenticate: true
  })

  // SignUp
  .state('signup', {
    url: '/sign-up?programId&voomeProductId&coupon&coupon_code&utm_params&campaign_channel_medium',
    onEnter: ["$state", function onEnter($state) {
      var redirect = function redirect() {
        var _$state$params = $state.params,
            utm_params = _$state$params.utm_params,
            campaign_channel_medium = _$state$params.campaign_channel_medium,
            coupon = _$state$params.coupon,
            coupon_code = _$state$params.coupon_code,
            programId = _$state$params.programId,
            voomeProductId = _$state$params.voomeProductId;


        var params = {
          utm_params: utm_params,
          campaign_channel_medium: campaign_channel_medium,
          coupon: coupon || coupon_code,
          voomeProductId: programId || voomeProductId
        };

        if (params.voomeProductId) {
          $state.go('signupProgramsDetail', params);
        } else {
          $state.go('signupWeekly', _extends({}, params, { slug: 'coaching-zone' }));
        }
      };

      window.setTimeout(redirect, 1);
    }]
  }).state('signupVerify', {
    url: '/sign-up/verify?api_id&call_id&nonce&result_code&signature&status_code&timestamp&voome_product_id',
    component: 'signup'
  }).state('signupPrograms', {
    url: '/sign-up/programs?utm_params&campaign_channel_medium',
    redirectTo: {
      state: 'signupProgramsDetail',
      params: { voomeProductId: 1 }
    }
  }).state('signupProgramsDetail', {
    url: '/sign-up/programs/{voomeProductId:int}?utm_params&campaign_channel_medium',
    component: 'signup'
  }).state('signupProgram', {
    url: '/sign-up/program/{voomeProductId:int}?utm_params&campaign_channel_medium',
    component: 'signup'
  }).state('signupWeekly', {
    url: '/sign-up/{slug:string}?coupon&utm_params&campaign_channel_medium',
    component: 'signup'
  })

  // Weekly
  .state('dashboard', {
    url: '/dashboard',
    component: 'dashboard',
    authenticate: true
  }).state('profile', {
    url: '/profile',
    component: 'profile',
    authenticate: true
  }).state('profileCreditCard', {
    url: '/profile/credit-card/{action:string}?api_id&call_id&nonce&result_code&signature&status_code&timestamp&slug&voome_product_id',
    component: 'creditCardUpdate',
    authenticate: true
  })

  // Weekly Nutrition
  .state('nutrition', {
    url: '/nutrition',
    component: 'nutrition',
    authenticate: true,
    redirectTo: 'nutrition.recipes'
  }).state('nutrition.recipes', {
    url: '/recipes?day&filters&level&page&q&serves&order',
    component: 'nutritionRecipes',
    authenticate: true
  }).state('nutrition.recipes.detail', {
    url: '/{recipeId:int}',
    component: 'nutritionRecipe',
    authenticate: true
  }).state('nutrition.hacks', {
    url: '/tips?page',
    component: 'nutritionHacks',
    authenticate: true
  }).state('nutrition.hacks.recipes', {
    url: '/{hackId:int}/recipes',
    component: 'nutritionHack',
    authenticate: true
  }).state('nutrition.hacks.recipe', {
    url: '/{hackId:int}/recipes/{recipeId:int}',
    component: 'nutritionRecipe',
    authenticate: true
  }).state('nutrition.mealPlans', {
    url: '/meal-plans?type&page',
    component: 'nutritionMealPlans',
    authenticate: true
  }).state('nutrition.mealPlans.detail', {
    url: '/{mealPlanId:int}',
    component: 'nutritionMealPlan',
    authenticate: true
  }).state('nutrition.mealPlans.detail.shoppingList', {
    url: '/shopping-list',
    component: 'shoppingList',
    authenticate: true
  }).state('nutrition.mealPlans.detail.edit', {
    url: '/edit?day&filters&level&q&serves&order&favourites',
    component: 'mealPlanEdit',
    authenticate: true
  }).state('nutrition.favouritesRecipes', {
    url: '/favourites/recipes',
    component: 'favouritesRecipes',
    authenticate: true
  }).state('nutrition.favouritesRecipes.detail', {
    url: '/{recipeId:int}',
    component: 'nutritionRecipe',
    authenticate: true
  })

  // Weekly Favourites
  .state('favourites', {
    url: '/favourites',
    component: 'favourites',
    authenticate: true
  }).state('favourites.recipes', {
    url: '/recipes?order&page',
    component: 'favouritesRecipes',
    authenticate: true
  }).state('favourites.recipes.detail', {
    url: '/{recipeId:int}',
    component: 'nutritionRecipe',
    authenticate: true
  })

  // Programs
  .state('program', {
    url: '/program/{voomeProductId:int}',
    component: 'program',
    redirectTo: 'dashboard',
    authenticate: true
  }).state('program.intro', {
    url: '',
    component: 'programIntro',
    redirectTo: 'dashboard',
    authenticate: true
  }).state('program.graduation', {
    url: '/graduation',
    component: 'programGraduation',
    redirectTo: 'dashboard',
    authenticate: true
  }).state('program.profile', {
    url: '/profile',
    component: 'profile',
    authenticate: true
  }).state('program.week', {
    url: '/week/{weekNumber:int}',
    redirectTo: 'program.week.detail',
    authenticate: true
  }).state('program.week.detail', {
    component: 'programWeek',
    authenticate: true
  }).state('program.week.mealPlan', {
    url: '/meal-plan/{mealPlanId:int}',
    component: 'programMealPlan',
    authenticate: true
  }).state('program.week.mealPlan.shoppingList', {
    url: '/shopping-list',
    component: 'shoppingList',
    authenticate: true
  }).state('program.week.mealPlan.edit', {
    url: '/edit?day&filters&level&page&q&serves&order&favourites',
    component: 'mealPlanEdit',
    authenticate: true
  }).state('program.week.workout', {
    url: '/workout/{exercisePlanId:int}/{id:int}',
    component: 'programWorkout',
    authenticate: true
  }).state('program.week.recipe', {
    url: '/recipe/{recipeId:int}',
    component: 'programRecipe',
    authenticate: true
  })

  // Program Redirects - confirm if we still need this
  .state('program.week.mealPlanRedirect', {
    url: '/meal-plan',
    component: 'programRedirect',
    authenticate: true
  }).state('program.week.shoppingListRedirect', {
    url: '/shopping-list',
    component: 'programRedirect',
    authenticate: true
  })

  // Legacy Redirects
  .state('legacy-meal-planner', {
    url: '/meal-planner',
    redirectTo: 'nutrition.mealPlans',
    authenticate: true
  }).state('legacy-recipes', {
    url: '/recipes',
    redirectTo: 'nutrition.recipes',
    authenticate: true
  }).state('legacy-recipes-detail', {
    url: '/recipes/{recipeId:string}',
    authenticate: true,
    onEnter: ["$state", function onEnter($state) {
      var redirect = function redirect() {
        var recipeId = parseInt($state.params.recipeId, 10);

        recipeId ? $state.go('nutrition.recipes.detail', { recipeId: recipeId }) : $state.go('nutrition.recipes');
      };

      window.setTimeout(redirect, 1);
    }]
  }).state('legacy-workouts', {
    url: '/workouts',
    redirectTo: 'workouts.videos',
    authenticate: true
  }).state('legacy-workouts-detail', {
    url: '/workouts/{exercisePlanId:int}/plan/{id:int}',
    authenticate: true,
    onEnter: ["$state", function onEnter($state) {
      var redirect = function redirect() {
        var _$state$params2 = $state.params,
            exercisePlanId = _$state$params2.exercisePlanId,
            id = _$state$params2.id;


        exercisePlanId && id ? $state.go('workouts.express.detail', { exercisePlanId: exercisePlanId, id: id }) : $state.go('workouts.videos');
      };

      window.setTimeout(redirect, 1);
    }]
  });
}];

/***/ }),

/***/ "xoRb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Only enable debug info in development
var compileProvider = exports.compileProvider = ["$compileProvider", function compileProvider($compileProvider) {
  'ngInject';

  var isEnabled = /dev|test/.test("production");
  $compileProvider.debugInfoEnabled(isEnabled);
}];

/***/ }),

/***/ "xopG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.memberStorage = undefined;

var _isEmpty2 = __webpack_require__("lHK6");

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _pick2 = __webpack_require__("w9Mt");

var _pick3 = _interopRequireDefault(_pick2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _store = __webpack_require__("Y4FN");

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var KEY = 'member';

var ALLOWED_KEYS = ['hasSetCookie', 'memberId', 'voomeProductId', 'redirectTo', 'mealPlanHelpModal', 'mealPlanWelcomeModal'];

var get = function get() {
  return _store2.default.get(KEY) || {};
};

var set = function set(obj) {
  var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var params = (0, _pick3.default)(obj, ALLOWED_KEYS);

  if (!(0, _isEmpty3.default)(params)) {
    if (!reset) {
      params = _extends({}, get(), params);
    }

    _store2.default.set(KEY, params);
  }
};

var setKey = function setKey(key, value) {
  if (ALLOWED_KEYS.indexOf(key) >= 0) {
    set(_defineProperty({}, key, value));
  }
};

var remove = function remove() {
  var _get = get(),
      hasSetCookie = _get.hasSetCookie,
      voomeProductId = _get.voomeProductId,
      mealPlanHelpModal = _get.mealPlanHelpModal,
      mealPlanWelcomeModal = _get.mealPlanWelcomeModal;

  set({ hasSetCookie: hasSetCookie, voomeProductId: voomeProductId, mealPlanHelpModal: mealPlanHelpModal, mealPlanWelcomeModal: mealPlanWelcomeModal }, true);
};

var memberStorage = exports.memberStorage = {
  get: get,
  set: set,
  setKey: setKey,
  remove: remove
};

/***/ }),

/***/ "xv9u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ProfileContainer = exports.ProfileContainer = {
  transclude: true,

  bindings: {
    isEditing: '<',
    onClick: '&'
  },

  template: '\n    <div class="container container--profile p-3 p-md-4 bg-white">\n      <box-corner\n        icon="pencil"\n        ng-click="$ctrl.onClick()"\n        ng-hide="$ctrl.isEditing">\n      </box-corner>\n      <ng-transclude></ng-transclude>\n    </div>'
};

/***/ }),

/***/ "yI+r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SearchFilterVideos = exports.SearchFilterVideos = {
  bindings: {
    filters: '<',
    onClick: '&'
  },

  template: '\n    <div class="search-filter-videos">\n      <search-filter\n        title="Type"\n        type="radio"\n        list="$ctrl.filters[\'type\']"\n        on-click="$ctrl.onClick({ key: \'type\', value: item.value })">\n      </search-filter>\n      <search-filter\n        title="Equipment"\n        type="radio"\n        list="$ctrl.filters[\'equipmentRequired\']"\n        on-click="$ctrl.onClick({ key: \'equipmentRequired\', value: item.value })">\n      </search-filter>\n      <search-filter\n        title="Time"\n        type="radio"\n        list="$ctrl.filters[\'time\']"\n        on-click="$ctrl.onClick({ key: \'time\', value: item.value })">\n      </search-filter>\n    </div>'
};

/***/ }),

/***/ "yY4h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.daysElapsed = undefined;

var _memoize2 = __webpack_require__("zGZ6");

var _memoize3 = _interopRequireDefault(_memoize2);

var _upperFirst2 = __webpack_require__("xdPp");

var _upperFirst3 = _interopRequireDefault(_upperFirst2);

var _sAgo = __webpack_require__("wiDh");

var _sAgo2 = _interopRequireDefault(_sAgo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var daysElapsed = exports.daysElapsed = function daysElapsed() {
  return (0, _memoize3.default)(function (date) {
    var formattedDate = new Date(date);
    return (0, _upperFirst3.default)((0, _sAgo2.default)(formattedDate));
  });
};

/***/ }),

/***/ "yfcf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authCheck = undefined;

var _utils = __webpack_require__("0xDb");

var _signup = __webpack_require__("FQ9i");

var _theme = __webpack_require__("ZID5");

var _favourite = __webpack_require__("GfAe");

var _member = __webpack_require__("1OIp");

var authCheck = exports.authCheck = ["$ngRedux", "$state", "$transitions", function authCheck($ngRedux, $state, $transitions) {
  'ngInject';

  var authenticatedPage = function authenticatedPage(_ref) {
    var name = _ref.name,
        authenticate = _ref.authenticate;

    return authenticate;
  };

  var loginPage = function loginPage(_ref2) {
    var name = _ref2.name;

    return name === 'login';
  };

  var authenticatedPageRedirectTo = function authenticatedPageRedirectTo(_ref3) {
    var name = _ref3.name,
        authenticate = _ref3.authenticate;

    return authenticate && !/welcome|profileCreditCard|workoutPlayer/.test(name);
  };

  // Redirect after login.
  $transitions.onBefore({ to: loginPage }, function ($transition$) {
    var _memberStorage$get = _utils.memberStorage.get(),
        memberId = _memberStorage$get.memberId,
        redirectTo = _memberStorage$get.redirectTo;

    var unsubscribe = $ngRedux.subscribe(function () {
      var _$ngRedux$getState = $ngRedux.getState(),
          member = _$ngRedux$getState.member;

      var subscription = (0, _member.selectSubscriptionWithFallback)(member);
      var voomeProductId = subscription.voomeProductId;

      // Only run once when the member has been set.

      if (voomeProductId) {
        unsubscribe();

        var _stateParamsForSubscr = (0, _utils.stateParamsForSubscription)(subscription, redirectTo),
            name = _stateParamsForSubscr.name,
            params = _stateParamsForSubscr.params;

        var stateMember = (0, _member.selectMember)(member);

        // Store the memberId && voomeProductId.
        _utils.memberStorage.set({
          memberId: stateMember.id,
          voomeProductId: voomeProductId
        });

        // Load the favourite
        $ngRedux.dispatch((0, _favourite.initFavourites)(stateMember.id));

        // Redirect to the appropriate page.
        $state.transitionTo(name, params);
        return false;
      }
    });

    // Refetch member if memberId exists in local storage.
    if (memberId) {
      $ngRedux.dispatch((0, _member.fetchMember)(memberId));
      return false;
    }
  });

  // Logout & save the current location for unauthenticated users.
  $transitions.onBefore({ to: authenticatedPage }, function ($transition$) {
    var _memberStorage$get2 = _utils.memberStorage.get(),
        memberId = _memberStorage$get2.memberId;

    if (!memberId) {
      _utils.memberStorage.setKey('redirectTo', {
        name: $transition$.targetState().name(),
        params: $transition$.targetState().params()
      });

      $state.transitionTo('login');
      return false;
    }
  });

  // Refetch a member that has lost state.
  $transitions.onBefore({ to: authenticatedPage }, function ($transition$) {
    var voomeProductId = $transition$.params().voomeProductId || _utils.memberStorage.get().voomeProductId;

    var _$ngRedux$getState2 = $ngRedux.getState(),
        member = _$ngRedux$getState2.member,
        signup = _$ngRedux$getState2.signup;

    // Refetch Products if undefined.


    if (!(0, _signup.selectProduct)(signup, voomeProductId)) {
      $ngRedux.dispatch((0, _signup.fetchProducts)());
    }

    // Refetch Member if undefined.
    if (!(0, _member.selectSubscription)(member, voomeProductId).id) {
      var _memberStorage$get3 = _utils.memberStorage.get(),
          memberId = _memberStorage$get3.memberId;

      var unsubscribe = $ngRedux.subscribe(function () {
        var _$ngRedux$getState3 = $ngRedux.getState(),
            member = _$ngRedux$getState3.member;

        if ((0, _member.selectSubscription)(member, voomeProductId).id) {
          unsubscribe();
          $ngRedux.dispatch((0, _favourite.initFavourites)(memberId));
          $state.transitionTo($transition$.to().name, $transition$.params());
        }
      });

      // Load the member
      $ngRedux.dispatch((0, _member.fetchMember)(memberId));

      $transition$.abort();
    }
  });

  // Set the navigation.
  $transitions.onBefore({ to: authenticatedPage }, function ($transition$) {
    var voomeProductId = $transition$.params().voomeProductId || _utils.memberStorage.get().voomeProductId;

    var _$ngRedux$getState4 = $ngRedux.getState(),
        theme = _$ngRedux$getState4.theme,
        member = _$ngRedux$getState4.member;

    var _selectSubscription = (0, _member.selectSubscription)(member, voomeProductId),
        isWeekly = _selectSubscription.isWeekly,
        slug = _selectSubscription.slug,
        status = _selectSubscription.status;

    var _$transition$$to = $transition$.to(),
        name = _$transition$$to.name;

    if (slug && theme.slug.indexOf(slug) < 0) {
      $ngRedux.dispatch((0, _theme.setNavType)(name === 'welcome' ? 'plain' : 'main'));
      $ngRedux.dispatch((0, _theme.setTheme)(isWeekly, slug, status));
    }
  });

  // Save the route. $state returns the correct params for abstract routes.
  $transitions.onSuccess({ to: authenticatedPageRedirectTo }, function ($transition$) {
    if (_utils.memberStorage.get().memberId) {
      _utils.memberStorage.setKey('redirectTo', {
        name: $state.current.name,
        params: $state.params
      });
    }
  });
}];

/***/ }),

/***/ "yfzx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpeechBubbleNutrition = undefined;

var _map2 = __webpack_require__("2247");

var _map3 = _interopRequireDefault(_map2);

var _find2 = __webpack_require__("kbi+");

var _find3 = _interopRequireDefault(_find2);

var _filter2 = __webpack_require__("RyI1");

var _filter3 = _interopRequireDefault(_filter2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__("qI5z");

var _nutritionPrograms = __webpack_require__("chzE");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SpeechBubbleNutrition = exports.SpeechBubbleNutrition = {
  transclude: true,

  bindings: {
    form: '<',
    member: '<',
    scrollTo: '&',
    onComplete: '&',
    onUpdate: '&'
  },

  template: '\n    <div class="speech-bubble-nutrition py-4 bg-white">\n      <!-- Step 1: What best describes you? -->\n      <div class="speech-bubble-step" id="step-1">\n        <speech-bubble class="fade-in-1">\n          Hello!\n        </speech-bubble>\n        <speech-bubble class="fade-in-2">\n          Now that the boring bit is done, let\'s set up your nutrition profile\n          by answering 4 easy questions.\n        </speech-bubble>\n        <speech-bubble class="fade-in-3">\n          <strong>What best describes you?</strong>\n        </speech-bubble>\n        <div class="text-right"\n          ng-hide="$ctrl.isEditingStep1">\n          <speech-bubble is-answer="true">\n            {{ $ctrl.currentGoal }}\n          </speech-bubble>\n          <button type="button" class="btn btn-link mr-4"\n            ng-click="$ctrl.isEditingStep1 = true">\n            Change\n          </button>\n        </div>\n        <div ng-class="{\'fade-in-4\': $ctrl.step === 1}">\n          <div class="speech-bubble-row pt-3"\n            ng-show="$ctrl.isEditingStep1">\n            <form-radio-list\n              form="$ctrl.form"\n              name="goal"\n              value="$ctrl.currentGoal"\n              list="$ctrl.nutritionPrograms.goals"\n              list-item-key="goal"\n              list-item-title="goal"\n              list-item-class="list-inline-item col-md-6"\n              on-update="$ctrl.onSetProgram(key, value)">\n            </form-radio-list>\n          </div>\n          <div class="speech-bubble-row w-100 p-0"\n            ng-show="$ctrl.isEditingStep1">\n            <button class="btn-link btn-continue"\n              type="button"\n              ng-click="$ctrl.onContinueStep(1)"\n              ng-disabled="!$ctrl.currentGoal">\n              <span>Continue</span>\n            </button>\n          </div>\n        </div>\n      </div>\n\n      <!-- Step 2: Calorie Level -->\n      <div class="speech-bubble-step" id="step-2" ng-if="$ctrl.step >= 2">\n        <speech-bubble class="fade-in-1">\n          Thanks, based on that and your BMI of {{ $ctrl.member.bmi }}, I picked\n          <strong>{{ $ctrl.defaultTitle }}</strong> for you\n          <span ng-if="$ctrl.currentLevel.title !== $ctrl.defaultTitle">,\n            but you have chosen <strong>{{ $ctrl.currentLevel.title }}</strong>\n          </span>.\n        </speech-bubble>\n        <div class="speech-bubble-row fade-in-1"\n          ng-hide="$ctrl.isEditingStep2">\n          <button class="btn btn-link"\n            type="button"\n            ng-click="$ctrl.isEditingStep2 = true">\n            Change\n          </button>\n        </div>\n        <div ng-class="{\'fade-in-2\': $ctrl.step === 2}">\n          <div class="speech-bubble-row pt-3"\n            ng-show="$ctrl.isEditingStep2">\n            <div nutrition-bmi="$ctrl.member.bmi"></div>\n            <form-radio-list\n              is-selectable="true"\n              form="$ctrl.form"\n              list="$ctrl.nutritionPrograms.programs"\n              name="level"\n              key="voomeProfile.level"\n              value="$ctrl.currentLevel.id"\n              list-item-key="id"\n              list-item-title="title"\n              list-item-class="list-inline-item col-md-6"\n              on-update="$ctrl.onSetCalorieLevel(key, value)"\n              required="true">\n            </form-radio-list>\n            <p>{{ $ctrl.currentLevel.description }}</p>\n          </div>\n          <div class="speech-bubble-row w-100 p-0"\n            ng-show="$ctrl.isEditingStep2">\n            <button class="btn btn-link btn-continue"\n              type="button"\n              ng-click="$ctrl.onContinueStep(2)">\n              <span>Continue</span>\n            </button>\n          </div>\n        </div>\n      </div>\n\n      <!-- Step 3: Nutrition questions -->\n      <div class="speech-bubble-step" id="step-3" ng-if="$ctrl.step >= 3">\n        <div class="pt-1" id="index-{{ $index }}"\n          ng-repeat="item in $ctrl.questions track by $index">\n          <div class="speech-bubble-step"\n            ng-if="$ctrl.index >= $index">\n            <speech-bubble class="fade-in-1"\n              ng-show="$index === 1">\n              Great!\n            </speech-bubble>\n            <speech-bubble class="fade-in-1"\n              ng-show="$index === 2">\n              Awesome! Based on that, we will provide you with some great suggestions and inspiration!\n            </speech-bubble>\n            <speech-bubble class="fade-in-1"\n              ng-show="$index === 3">\n              Great, we have everything we need for your nutrition profile.\n            </speech-bubble>\n            <speech-bubble\n              ng-show="$index < 3"\n              ng-class="{\n                \'fade-in-2\': ($index <= 1) && ($ctrl.index === $index),\n                \'fade-in-1\': ($index > 1) && ($ctrl.index === $index)\n              }">\n              <strong >{{ item.question }}</strong>\n            </speech-bubble>\n            <button\n              class="btn btn-link ml-4 mt-1 fade-in-2"\n              type="button"\n              ng-click="showAllergies = true"\n              ng-show="$index === 3">\n              {{ item.question }}\n            </button>\n            <speech-bubble class="text-right"\n              is-answer="true"\n              ng-hide="item.isActive">\n              {{ item.answer || \'None Selected\' }}\n            </speech-bubble>\n            <div class="speech-bubble-row text-right"\n              ng-hide="item.isActive">\n              <button class="btn btn-link"\n                type="button"\n                ng-click="item.isActive = true">\n                Change\n              </button>\n            </div>\n            <div class="speech-bubble-row pt-3"\n              ng-show="item.isActive"\n              ng-class="{\n                \'fade-in-3\': ($index <= 1) && ($ctrl.index === $index),\n                \'fade-in-2\': ($index > 1) && ($ctrl.index === $index)\n              }">\n              <form-fieldset\n                ng-hide="$index === 3 && !showAllergies"\n                form="$ctrl.form"\n                name="key"\n                key="voomeProfile.preferences.{{ item.key }}"\n                list="$ctrl.member.voomeProfile.preferences[item.key]"\n                type="{{ item.type }}"\n                on-update="$ctrl.onUpdate({ key: key, value: value })">\n              </form-fieldset>\n            </div>\n            <div class="speech-bubble-row full-width"\n              ng-class="{\n                \'fade-in-3\': ($index <= 1) && ($ctrl.index === $index),\n                \'fade-in-2\': ($index > 1) && ($ctrl.index === $index)\n              }">\n              <button class="btn-link btn-continue"\n                type="button"\n                ng-click="$ctrl.onContinueIndex($index, item)"\n                ng-show="item.isActive && $index < 3">\n                <span>Continue</span>\n              </button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>',

  controller: ["$timeout", function controller($timeout) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        this.step = 1;
        this.index = 0;
        this.currentLevel = null;
        this.currentGoal = null;
        this.defaultTitle = null;

        // Set the editing state
        this.toggleEditingSteps();

        // Content for Question 1 & 2
        this.nutritionPrograms = (0, _nutritionPrograms.selectNutritionPrograms)(this.member.profile.gender, this.currentGoal);

        // Content for Question 3 & 4
        this.questions = this.reduceQuestions(_constants.PROFILE_NUTRITION);
      },
      reduceQuestions: function reduceQuestions(questions) {
        var _this = this;

        return questions.map(function (item, index) {
          return _extends({}, item, {
            isActive: index === _this.index,
            answer: _this.answersAsString(item.key)
          });
        });
      },
      answersAsString: function answersAsString(key) {
        var answers = (0, _map3.default)((0, _filter3.default)(this.member.voomeProfile.preferences[key], 'active'), 'name');

        return answers ? answers.length > 1 ? answers.join(', ') : answers[0] : null;
      },
      toggleEditingSteps: function toggleEditingSteps() {
        var _this2 = this;

        [1, 2, 3, 4].forEach(function (i) {
          return _this2['isEditingStep' + i] = i === _this2.step;
        });
      },
      onContinueStep: function onContinueStep(step) {
        var _this3 = this;

        if (step === this.step) {
          this.step = step + 1;
          this.scrollTo({ id: 'step-' + this.step });
        }

        this.toggleEditingSteps();

        if (this.step >= 4) {
          $timeout(function () {
            return _this3.onComplete();
          }, 1000);
        }
      },
      onContinueIndex: function onContinueIndex($index, item) {
        if ($index === this.index) {
          this.index = $index + 1;
          this.index === 3 ? this.onContinueStep(3) : this.scrollTo({ id: 'index-' + this.index });
        }

        this.questions = this.reduceQuestions(this.questions);
      },
      onSetProgram: function onSetProgram(key, goal) {
        var bmi = this.member.bmi;
        var gender = this.member.profile.gender;


        this.currentLevel = (0, _nutritionPrograms.selectNutritionProgram)({ goal: goal, gender: gender });
        this.currentGoal = this.currentLevel.goal;
        this.defaultTitle = this.currentLevel.title;

        this.onUpdate({
          key: 'voomeProfile.nutritionProgramId',
          value: (0, _nutritionPrograms.selectNutritionProgramIdForBmi)(this.currentLevel.id, bmi)
        });
      },
      onSetCalorieLevel: function onSetCalorieLevel(key, level) {
        this.currentLevel = (0, _find3.default)(this.nutritionPrograms.programs, {
          id: level
        });

        this.onUpdate({ key: key, value: level });
      }
    };
  }]
};

/***/ }),

/***/ "z+Wp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBar = exports.ProgressBadge = undefined;

var _ProgressBadge = __webpack_require__("z/nV");

Object.defineProperty(exports, 'ProgressBadge', {
  enumerable: true,
  get: function get() {
    return _ProgressBadge.ProgressBadge;
  }
});

var _ProgressBar = __webpack_require__("NCZo");

Object.defineProperty(exports, 'ProgressBar', {
  enumerable: true,
  get: function get() {
    return _ProgressBar.ProgressBar;
  }
});

__webpack_require__("0KaM");

/***/ }),

/***/ "z/nV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ProgressBadge = exports.ProgressBadge = {
  bindings: {
    number: '<',
    count: '<',
    total: '<',
    size: '@'
  },

  template: '\n    <div\n      ng-class="$ctrl.size ? \'progress-badge-\' + $ctrl.size : \'\'"\n      class="progress-badge">\n      <div class="progress-badge-text">\n        <small>Week</small>\n        <span>{{ $ctrl.number }}</span>\n      </div>\n      <div\n        class="progress-badge-bg theme-bg"\n        style="height: {{ $ctrl.percentage }}%">\n      </div>\n    </div>',

  controller: function controller() {
    'ngInject';

    return {
      $onInit: function $onInit() {
        this.count = 0;
        this.total = 0;
        this.percentage = 0;
      },
      $onChanges: function $onChanges(changes) {
        if (this.total > 0) {
          this.percentage = Math.round(this.count / this.total * 100);
        }
      }
    };
  }
};

/***/ }),

/***/ "z6qu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.padStart = undefined;

var _padStart3 = __webpack_require__("alKx");

var _padStart4 = _interopRequireDefault(_padStart3);

var _memoize2 = __webpack_require__("zGZ6");

var _memoize3 = _interopRequireDefault(_memoize2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var padStart = exports.padStart = function padStart() {
  return (0, _memoize3.default)(_padStart4.default);
};

/***/ }),

/***/ "zC1G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GRADUATION_DATA = exports.GRADUATION_DATA = {
  fallback: {
    achievements: ['Worked out for over 6 hours', 'Prepared over 80 nutritious meals'],
    hashtag: '#voomeprograms'
  },
  kickstarter: {
    achievements: ['Squatted 300 times', 'Planked for 10 minutes', 'Wall sat for 10 minutes', 'Walked over 15kms'],
    hashtag: '#voomekickstarter'
  },
  kickstarter2: {
    achievements: ['Over 2.5 hours of walking and jogging', 'Over 330 Squats, including squats with lunges', '300 Push Ups using 5 unique styles', 'Over 2 hours spent rolling and releasing knots', 'PLUS an additional 40 minutes of stretching!'],
    hashtag: '#voomekickstarter2'
  },
  energyPerformance: {
    achievements: ['Squatted & Lunged for over 30 mins', 'Crunched over 1 hour of abs', 'Over 14 minutes of push ups', 'Smashed over 20 minutes of cardio'],
    hashtag: '#voomeenergy'
  },
  timesaver: {
    achievements: ['Planked for over 10 minutes', 'Smashed up to 100 burpees', 'Lunged over 130 times', 'Up to 500 squats done & dusted'],
    hashtag: '#voometimesaver'
  },
  barbellProgressions: {
    achievements: ['Lunged over 150 lunges', 'Killed over 229 deadlifts', 'Smashed over 222 squats', 'Powered through 84 overhead presses'],
    hashtag: '#voomebarbellprogressions'
  },
  easeFlow: {
    achievements: ['Lengthened your spine', 'Worked through 75 Downward dogs', 'Relaxed your mind', 'Held 55 Planks', 'Stretched every muscle'],
    hashtag: '#voomeeaseflow'
  },
  stabiliseCoreGlutes: {
    achievements: ['Mastered 9 different animal poses', 'Rocked a plank 215 times', 'Smashed 350 squats in 7 variation', 'Built a titanium-strength core'],
    hashtag: '#voomestabilise'
  },
  lowFodmap: {
    achievements: ['Conquered Meatless Mondays for 1 month', 'Blitzed up to 24 cups of lactose free milk', 'Cracked, scrambled & baked approx 3 dozen eggs', 'Pumped along your digestive system with 62 push ups', 'Smashed through 3 varieties of 46 dips', 'Walked, hill climbed & jogged for 2.5 hours'],
    hashtag: '#voomeFODMAP'
  },
  lowImpactWeightloss: {
    achievements: ['Smashed 600 squats, 10 different ways', 'Conquered a mountain with 400 mountain climbers', 'Toned your abs with 185 planks', 'Became a burpee champion with over 600 burpees', 'Pushed your way through over 500 push ups'],
    hashtag: '#voomelowimpact'
  },
  athleticConditioning: {
    achievements: ['Squatted the equivalent of a small car', 'Deadlifted the equivalent of a small tank', 'Mastered 10 CrossFit moves and 3 Olympic Lifts', 'Dominated 8 Different Styles of Squats', 'Smashed 3 hours of high intensity conditioning'],
    hashtag: '#voomeathletic'
  },
  fireUp: {
    achievements: ['Burnt over 10,000 calories', 'Created amazing shoulder mobility', 'Rocket boosted your metabolism to an ultimate fat-burning zone', 'Smashed out over 200 squats', 'Mastered 8 Athletic moves with Dumbbells'],
    hashtag: '#voomefireup'
  },
  '50FitFiring': {
    achievements: ['Punched and twisted over 160 reps', 'Lengthened and untwisted your body with over 20 different stretches', 'Mastered an entire workout using a Swiss Ball', 'Experienced just how good the human body can feel'],
    hashtag: '#voome50fitfiring'
  },
  healthyOnABudget: {
    achievements: ['Made meals for $15 per day per person', "Smashed over 2 hours of AMRAP's", 'Shopped smarter, meal prepped and batch cooked', 'Sculpted your legs with 100’s of lunges', 'Learnt money saving healthy hacks and tips'],
    hashtag: '#voomehealthybudget'
  },
  healthyFamilies: {
    achievements: ['You enhanced your gut microbiome', 'Clocked up 6 hours of walking and/or jogging', 'You consumed plenty of superb antioxidants', 'Smashed over 2 hours of escalating circuts', 'Baked, sliced, rolled and blitzed nourishing snacks', 'Completed over 3 hours of awesome AMRAP’s'],
    hashtag: '#voomehealthyfamilies'
  },
  powerThroughPregnancy: {
    achievements: ['Activated your Pelvic Floor over 150 times', 'Stabilised and strengthened your lower back', 'Kept your posture strong', 'Worked through over 3 hours of cardio', 'Nurtured yourself and your baby'],
    hashtag: '#voomepregnancy'
  }
};

var SPECIAL_REQUIREMENT_PRODUCTS = exports.SPECIAL_REQUIREMENT_PRODUCTS = ['healthy-on-a-budget', 'power-through-pregnancy'];

/***/ }),

/***/ "zGDm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MealPlan = undefined;

var _reduxUiRouter = __webpack_require__("Zb/7");

var _product = __webpack_require__("5AvL");

var _member = __webpack_require__("1OIp");

var _mealPlan = __webpack_require__("KLwp");

var MealPlan = exports.MealPlan = {
  template: '\n    <div class="meal-plan">\n      <main class="main-content border border-y bg-gray-100 pt-3 pb-5">\n        <div class="container mb-3">\n          <div class="row">\n            <div class="col-md-10 mx-auto">\n              <div class="meal-plan-meta"\n                ng-hide="$ctrl.isLoading">\n                <div class="alert alert-warning"\n                  ng-if="$ctrl.isProductRequirements">\n                  Please be aware that if you choose to swap recipes into your plan, they may not be suitable for\n                  {{ $ctrl.isProductLowFodmap ? "Low FODMAP" : "your Program\'s" }}\n                  dietary requirements, and you will need to adapt ingredients accordingly.\n                </div>\n                <div class="d-md-flex justify-content-between align-items-center flex-row-reverse mb-3">\n                  <div class="text-right mb-2 mb-md-0">\n                    <meal-plan-print\n                      pdfs="$ctrl.pdfs"\n                      level="$ctrl.level"\n                      tooltip="$ctrl.tooltip"\n                      ng-click="$ctrl.refetchMember()"\n                      ng-if="$ctrl.subscription.canPrint">\n                    </meal-plan-print>\n                  </div>\n                  <div class="d-flex align-items-center justify-content-between">\n                    <button class="btn btn-pill bg-cz-theme text-white"\n                      type="button"\n                      ng-show="$ctrl.isClone"\n                      ng-click="$ctrl.onEdit($ctrl.mealPlan.id, $ctrl.level, $ctrl.week.id)">\n                      <i class="fa fa-lg icon-pencil text-white"></i>\n                      Edit Meal Plan\n                    </button>\n                    <button class="btn btn-pill bg-cz-theme text-white"\n                      type="button"\n                      ng-hide="$ctrl.isClone"\n                      ng-click="$ctrl.onClone($ctrl.mealPlan.id, $ctrl.subscription.id, $ctrl.level, $ctrl.week.id)">\n                      <i class="fa fa-lg icon-pencil text-white"></i>\n                      <span ng-hide="$ctrl.isCreating">Edit</span>\n                      <span ng-show="$ctrl.isCreating">\n                        <spinner is-loading="$ctrl.isCreating">Saving</spinner>\n                      </span>\n                      Meal Plan\n                    </button>\n                    <span class="d-block d-sm-inline pl-1 pl-sm-3"\n                      ng-hide="$ctrl.weekNumber">\n                      <button class="btn btn-pill bg-cz-theme text-white"\n                        type="button"\n                        ng-hide="$ctrl.mealPlan.id === $ctrl.active"\n                        ng-click="$ctrl.activateMealPlan($ctrl.mealPlan.id)">\n                        <spinner is-loading="$ctrl.isActivating">\n                          Add to Dashboard\n                        </spinner>\n                      </button>\n                      <button-link\n                        ng-show="$ctrl.mealPlan.id === $ctrl.active"\n                        ng-click="$ctrl.deactivateMealPlan($ctrl.mealPlan.id)">\n                        <spinner is-loading="$ctrl.isActivating">\n                          <span class="font-size-small font-size-md-base">\n                            Remove from Dashboard\n                          </span>\n                        </spinner>\n                      </button-link>\n                    </span>\n                  </div>\n                </div>\n                <div class="mb-3" ng-show="$ctrl.hasCookup">\n                  <meal-plan-cook-more></meal-plan-cook-more>\n                </div>\n              </div>\n              <div class="d-md-flex mb-4"\n                ng-repeat="day in $ctrl.days track by $index">\n                <div class="meal-plan-day pr-md-4 text-center">\n                  <meal-plan-day-icon count="day.meals.length" is-active="true">\n                    <span ng-show="$ctrl.week">\n                      Day {{ $index + 1 }}\n                    </span>\n                    <span ng-hide="$ctrl.week">\n                      {{ day.dayString | limitTo: 3 }}\n                    </span>\n                  </meal-plan-day-icon>\n                  <small class="meal-plan-day-cals d-block text-purple-cz-mid font-weight-semibold mt-md-1">\n                    {{ day.calories }} Cal\n                  </small>\n                </div>\n                <div class="meal-plan-recipes">\n                  <div class="bg-white"\n                    ng-repeat="meal in day.meals track by $index">\n                    <meal-plan-recipe\n                      meal="meal"\n                      is-active="$ctrl.isClone"\n                      on-preview="$ctrl.onPreview(recipe)"\n                      on-remove="$ctrl.deleteMeal($ctrl.mealPlan.id, meal.id, day.day)">\n                    </meal-plan-recipe>\n                  </div>\n                  <div class="bg-white h-100 d-flex justify-content-center align-items-center"\n                    ng-show="day.meals.length === 0">\n                    <strong>\n                      No meals added for\n                      <span ng-show="$ctrl.week">day {{ $index + 1 }}</span>\n                      <span ng-hide="$ctrl.week">{{ day.dayString }}</span>\n                    </strong>\n                  </div>\n                </div>\n              </div>\n              <div class="text-right mr-md-3" ng-show="$ctrl.isClone">\n                <button-link ng-click="$ctrl.onDelete($ctrl.mealPlan.id, $ctrl.subscription.id, $ctrl.week.id)">\n                  <span class="text-warning">\n                    <i class="fa fa-times-circle"></i>\n                    Delete <span ng-show="$ctrl.week">custom</span> meal plan\n                  </span>\n                </button-link>\n              </div>\n            </div>\n          </div>\n        </div>\n        <recipe-preview\n          recipe-id="$ctrl.recipePreviewId"\n          show-on="$ctrl.recipePreviewShow">\n        </recipe-preview>\n      </main>\n    </div>',

  controller: ["$anchorScroll", "$ngRedux", "$state", "$timeout", function controller($anchorScroll, $ngRedux, $state, $timeout) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);
        $anchorScroll();

        if (!this.mealPlan.recipes) {
          this.fetchMealPlan(this.mealPlanId, this.level);
        }

        if (!this.active) {
          this.fetchMealPlanActive();
        }
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();

        if (this.unsubscribe) {
          this.unsubscribe();
        }
      },
      onClone: function onClone(mealPlanId, subscriptionId, level, weekId) {
        var _this = this;

        this.unsubscribe = $ngRedux.subscribe(function () {
          return _this.unsubscribeOnClone(level, weekId);
        });

        this.cloneMealPlan(mealPlanId, subscriptionId, weekId);
      },
      onDelete: function onDelete(mealPlanId, subscriptionId, weekId) {
        var _this2 = this;

        this.unsubscribe = $ngRedux.subscribe(function () {
          return _this2.unsubscribeOnDelete(mealPlanId, subscriptionId, weekId);
        });

        this.deleteMealPlan(mealPlanId);
      },
      onEdit: function onEdit(mealPlanId, level, weekId, hardReload) {
        var day = 'Monday';
        var path = weekId ? 'program.week.mealPlan.edit' : 'nutrition.mealPlans.detail.edit';

        // TODO: do a hard redirect to edit, due to some issues with the state
        // updating and a race condition.
        hardReload ? window.location.assign($state.href(path, { day: day, level: level, mealPlanId: mealPlanId })) : this.stateGo(path, { day: day, level: level, mealPlanId: mealPlanId });
      },
      onPreview: function onPreview(recipe) {
        var _this3 = this;

        this.recipePreviewId = recipe.id;
        this.recipePreviewShow = true;
        $timeout(function () {
          return _this3.recipePreviewShow = false;
        });
      },
      refetchMember: function refetchMember() {
        var _this4 = this;

        this.tooltip && $timeout(function () {
          return _this4.fetchMember(_this4.member.id);
        }, 500);
      },
      unsubscribeOnClone: function unsubscribeOnClone(level, weekId) {
        var result = $ngRedux.getState().mealPlan.result;


        if (result) {
          this.unsubscribe();
          this.onEdit(result, level, weekId, true);
        }
      },
      unsubscribeOnDelete: function unsubscribeOnDelete(mealPlanId, subscriptionId, weekId) {
        var _$ngRedux$getState = $ngRedux.getState(),
            mealPlan = _$ngRedux$getState.mealPlan;

        var isDeleted = !(0, _mealPlan.selectMealPlan)(mealPlan, mealPlanId).id;

        if (isDeleted) {
          this.unsubscribe();

          // TODO: do a hard redirect to edit, due to some issues with the state
          // updating and a race condition.
          window.location.assign($state.href(weekId ? 'program.week' : 'nutrition.mealPlans', {
            type: 'mine'
          }));

          // const page = selectPageForMealPlanId(mealPlan, mealPlanId, 'mine');
          // this.fetchMealPlansMine(subscriptionId, page, weekId);
          // this.stateGo(weekId ? 'program.week' : 'nutrition.mealPlans');
        }
      },
      mapState: function mapState(_ref) {
        var mealPlan = _ref.mealPlan,
            member = _ref.member,
            product = _ref.product,
            router = _ref.router;
        var _router$currentParams = router.currentParams,
            mealPlanId = _router$currentParams.mealPlanId,
            voomeProductId = _router$currentParams.voomeProductId,
            weekNumber = _router$currentParams.weekNumber;
        var active = mealPlan.active,
            isActivating = mealPlan.isActivating,
            isCreating = mealPlan.isCreating,
            isLoading = mealPlan.isLoading;

        var subscription = (0, _member.selectSubscription)(member);

        return {
          active: active,
          isActivating: isActivating,
          isCreating: isCreating,
          isLoading: isLoading,
          mealPlanId: mealPlanId,
          subscription: subscription,
          voomeProductId: voomeProductId,
          weekNumber: weekNumber,
          tooltip: (0, _member.selectPrintTooltip)(member),
          member: (0, _member.selectMember)(member),
          days: (0, _mealPlan.selectDays)(mealPlan, mealPlanId),
          hasCookup: (0, _mealPlan.selectMealsHasCookup)(mealPlan, mealPlanId),
          isClone: (0, _mealPlan.selectMealPlanIsClone)(mealPlan, mealPlanId),
          level: (0, _member.selectMemberLevel)(member),
          mealPlan: (0, _mealPlan.selectMealPlan)(mealPlan, mealPlanId),
          pdfs: (0, _mealPlan.selectMealPlanPdfs)(mealPlan, mealPlanId, subscription.id),
          week: (0, _product.selectWeek)(product, weekNumber),
          isProductLowFodmap: (0, _member.selectIsProductLowFodmap)(member, voomeProductId),
          isProductRequirements: (0, _member.selectIsProductWithRequirements)(member, voomeProductId)
        };
      },
      mapDispatch: function mapDispatch() {
        return {
          activateMealPlan: _mealPlan.activateMealPlan,
          cloneMealPlan: _mealPlan.cloneMealPlan,
          deactivateMealPlan: _mealPlan.deactivateMealPlan,
          fetchMember: _member.fetchMember,
          fetchMealPlan: _mealPlan.fetchMealPlan,
          fetchMealPlanActive: _mealPlan.fetchMealPlanActive,
          fetchMealPlansMine: _mealPlan.fetchMealPlansMine,
          deleteMeal: _mealPlan.deleteMeal,
          deleteMealPlan: _mealPlan.deleteMealPlan,
          stateGo: _reduxUiRouter.stateGo
        };
      }
    };
  }]
};

/***/ }),

/***/ "zQQk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FavouriteNoResult = exports.FavouriteButton = undefined;

var _FavouriteButton = __webpack_require__("JY6D");

Object.defineProperty(exports, 'FavouriteButton', {
  enumerable: true,
  get: function get() {
    return _FavouriteButton.FavouriteButton;
  }
});

var _FavouriteNoResult = __webpack_require__("o/Dv");

Object.defineProperty(exports, 'FavouriteNoResult', {
  enumerable: true,
  get: function get() {
    return _FavouriteNoResult.FavouriteNoResult;
  }
});

__webpack_require__("wV5X");

/***/ }),

/***/ "zXzg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgramNav = undefined;

var _member = __webpack_require__("1OIp");

var _product = __webpack_require__("5AvL");

var _completions = __webpack_require__("XI2E");

var ProgramNav = exports.ProgramNav = {
  template: '\n    <nav class="program-nav">\n      <div class="container arrow-row-container">\n        <div class="row nav-scroll-wrapper">\n          <div class="nav-scroll-content">\n            <div class="content-row">\n              <div class="d-table px-3 py-3 bg-teal-dark">\n                <div class="d-table-cell">\n                  <div class="modal-toggle">\n                    <button\n                      class="btn btn-pill btn-sm theme-btn"\n                      data-toggle="modal"\n                      data-target="#modalStartProgram"\n                      ng-if="!$ctrl.hasStarted || ($ctrl.program.daysElapsed < 0)">\n                      <span class="text-uppercase font-weight-bold">\n                        Start\n                        <span ng-if="$ctrl.program.daysElapsed < 0">now</span>\n                      </span>\n                    </button>\n                    <button-link\n                      data-toggle="modal"\n                      data-target="#modalRestartProgram"\n                      ng-if="$ctrl.hasStarted && ($ctrl.program.daysElapsed >= 0)">\n                      <span class="text-white">Restart?</span>\n                    </button-link>\n                  </div>\n                </div>\n                <div class="d-table-cell nav-progress-row">\n                  <div class="nav-progress-wrapper">\n                    <progress-bar\n                      weeks="$ctrl.weeks"\n                      percentage="$ctrl.program.percentElapsed"\n                      img-src="$ctrl.member.profile.avatarUrl.thumb">\n                    </progress-bar>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class="content-row nav-week-tiles">\n              <a class="week-tile-wrapper pl-3 bg-teal-dark"\n                ui-sref="program.intro({ voomeProductId: $ctrl.program.id })"\n                ui-sref-active="active">\n                <div class="nav-tile nav-tile--intro">\n                  <span class="theme-border-hover"></span>\n                  <div class="nav-tile-content">\n                    <span class="theme-program-logo w-100 h-100 mx-3">\n                      <span>{{ $ctrl.program.name }}</span>\n                    </span>\n                  </div>\n                </div>\n                <box-arrow-row></box-arrow-row>\n              </a>\n              <a class="week-tile-wrapper bg-teal-dark"\n                ng-repeat="week in $ctrl.weeks track by $index"\n                ng-class="{ \'active\': $ctrl.weekNumber === week.weekNumber }"\n                ui-sref="program.week.detail({ weekNumber: week.weekNumber })">\n                <div class="nav-tile">\n                  <span class="theme-border-hover"></span>\n                  <div class="nav-tile-content"\n                    style="background-image: url(\'{{ week.introVideo.thumbnailUrl.magazine | assetSrc }}\')">\n                    <progress-badge\n                      count="$ctrl.completions[week.weekNumber].total"\n                      total="week.workouts.length + week.mealPlan.daysCount"\n                      number="week.weekNumber">\n                    </progress-badge>\n                    <div class="nav-tile-title">\n                      <span>{{ week.title }}</span>\n                    </div>\n                  </div>\n                </div>\n                <box-arrow-row></box-arrow-row>\n              </a>\n              <a class="week-tile-wrapper last-tile pr-3 bg-teal-dark"\n                ng-class="{ \'disabled\' : !$ctrl.program.isGraduated }"\n                ui-sref="program.graduation"\n                ui-sref-active="active">\n                <div class="nav-tile nav-tile--graduation">\n                  <span class="theme-border-hover"></span>\n                  <div class="nav-tile-content">\n                    <i class="fa fa-trophy"></i>\n                  </div>\n                </div>\n                <box-arrow-row></box-arrow-row>\n              </a>\n            </div>\n          </div>\n        </div>\n      </div>\n    </nav>',

  controller: ["$ngRedux", function controller($ngRedux) {
    'ngInject';

    return {
      $onInit: function $onInit() {
        var connect = $ngRedux.connect(this.mapState, {});
        this.disconnect = connect(this);
      },
      $onDestroy: function $onDestroy() {
        this.disconnect();
      },
      mapState: function mapState(state) {
        var member = state.member,
            product = state.product,
            router = state.router;
        var _router$currentParams = router.currentParams,
            voomeProductId = _router$currentParams.voomeProductId,
            weekNumber = _router$currentParams.weekNumber;


        return {
          weekNumber: weekNumber,
          completions: (0, _completions.selectCompletions)(state, weekNumber),
          hasStarted: (0, _member.selectSubscriptionHasStarted)(member, voomeProductId),
          member: (0, _member.selectMember)(member),
          program: (0, _product.selectProduct)(product),
          weeks: (0, _product.selectWeeks)(product)
        };
      }
    };
  }]
};

/***/ }),

/***/ "za+p":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DashboardWorkoutContainer = exports.DashboardWorkoutContainer = {
  bindings: {
    activeCard: '@',
    index: '<',
    member: '<',
    workoutInspiration: '<',
    workoutCollection: '<',
    workoutVideo: '<'
  },

  template: '\n    <div class="dashboard-workout-container" ng-switch="$ctrl.activeCard">\n      <section class="dashboard-cards">\n        <div class="container">\n          <div class="row">\n            <div class="card-wrapper mb-3 mb-md-0 col-md-4 pointer"\n              ng-class="{ active: $ctrl.activeCard === \'1\' }">\n              <card-plain\n                card-class="text-center workouts-{{ $ctrl.index }}-bg"\n                link-text="\'Discover\'"\n                ng-click="$ctrl.activeCard = \'1\'">\n                <h4 class="card-title">\n                  <current-day></current-day><br>\n                  #WorkoutInspiration\n                </h4>\n              </card-plain>\n              <box-arrow-row color="white"></box-arrow-row>\n              <div class="d-md-none" ng-switch-when="1">\n                <dashboard-workout-inspiration\n                  items="$ctrl.workoutInspiration"\n                  member="$ctrl.member">\n                </dashboard-workout-inspiration>\n              </div>\n            </div>\n            <div class="card-wrapper mb-3 mb-md-0 col-md-4 pointer"\n              ng-class="{ active: $ctrl.activeCard === \'2\' }">\n              <card-image\n                card-class="text-center bg-teal-dark"\n                link-text="\'View\'"\n                img="$ctrl.workoutCollection.coverImageUrl.magazine"\n                ng-click="$ctrl.activeCard = \'2\'">\n                <small class="tagline">\n                  Featured\n                </small>\n                <h4 class="card-title">\n                  {{ $ctrl.workoutCollection.title }}\n                </h4>\n              </card-image>\n              <box-arrow-row color="white"></box-arrow-row>\n              <div class="d-md-none" ng-switch-when="2">\n                <dashboard-workout-hack\n                  title="$ctrl.workoutCollection.title"\n                  description="$ctrl.workoutCollection.strapLine"\n                  items="$ctrl.workoutCollection.workouts"\n                  member="$ctrl.member">\n                </dashboard-workout-hack>\n              </div>\n            </div>\n            <div class="card-wrapper col-md-4 pointer">\n              <card-image\n                card-class="text-center bg-teal-dark bg-position-unset"\n                link-text="\'Watch\'"\n                img="$ctrl.workoutVideo.thumbnailUrl.magazine"\n                ng-click="$ctrl.onClick($ctrl.workoutVideo.id)">\n                <small class="tagline">\n                  Workout Video\n                </small>\n                <h4 class="card-title">\n                  {{ $ctrl.workoutVideo.title }}\n                </h4>\n              </card-image>\n            </div>\n          </div>\n        </div>\n      </section>\n      <div class="d-none d-md-block">\n        <dashboard-workout-inspiration ng-switch-when="1"\n          items="$ctrl.workoutInspiration"\n          member="$ctrl.member">\n        </dashboard-workout-inspiration>\n        <dashboard-workout-hack ng-switch-when="2"\n          title="$ctrl.workoutCollection.title"\n          description="$ctrl.workoutCollection.strapLine"\n          items="$ctrl.workoutCollection.workouts"\n          member="$ctrl.member">\n        </dashboard-workout-hack>\n      </div>\n    </div>',

  controller: ["$state", function controller($state) {
    'ngInject';

    return {
      onClick: function onClick(videoId) {
        $state.go('workouts.videos.detail', { videoId: videoId });
      }
    };
  }]
};

/***/ }),

/***/ "zxL1":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 320.1 124.4\"><path d=\"M69.7 68c-3.9 11.5-7.7 22.9-10.3 30.5 -1.4 4.3-2.5 7.5-3 9 -3.6 10.4-6.4 16.6-16 16.6l0 0c0 0 0 0 0 0 0 0 0 0 0 0h0c-10.1 0-12.8-7.7-15.9-16.6 -0.9-2.5-4.7-13.8-8-23.8 -2.7-8.1-5.1-15.2-5.3-15.8 -0.3-0.8-1.9-4.6-6.1-4.6H0.7c-0.4 0-0.7-0.3-0.7-0.7V52.2c0-0.4 0.3-0.7 0.7-0.7h30.3c0.4 0 0.7 0.3 0.7 0.7v10.5c0 0.4-0.3 0.7-0.7 0.7h-9.6c2.1 1.5 3.4 4 4.1 6.2 2.4 7.2 6.4 19.4 9.4 28.3 1.4 4.1 2.5 7.5 3.1 9.2 0.7 2.2 1.7 2.4 2.4 2.4 0.7 0 1.7-0.3 2.4-2.4 1.8-5.5 11.1-33 12.6-37.4 1.1-2.9 2.4-5.1 4.1-6.3h-9.7c-0.4 0-0.7-0.3-0.7-0.7V52.2c0-0.4 0.3-0.7 0.7-0.7h30.3c0.4 0 0.7 0.3 0.7 0.7v10.5c0 0.4-0.3 0.7-0.7 0.7h-4.3C71.4 63.4 69.8 67.5 69.7 68M36.9 38.9c0 3.4 2.6 7.6 7.8 7.6h0c9.8 0 13.7-9.7 13.7-15.7 0-0.5 0-1-0.1-1.5 -0.1-3.6-1.3-7.3-4-10.4 0 0 0 0 0 0 0 0 0 0 0 0l0 0c-6.8 6.6-15 14.6-15 14.6S36.9 35.5 36.9 38.9M31 45.3c0.9 0.4 1.7-0.6 1.2-1.4 -2-2.8-2.1-5.4-2.1-7.3 0 0-0.1-4.8 3.7-8.5 3.8-3.7 10.2-9.9 10.5-10.2 2.5-2.5 5.2-9.4 0-14.5 -1.7-1.7-2.7-2.6-3.3-3.2 -0.4-0.4-0.9-0.3-1.3 0L25.6 13.9c0 0-5.7 5.1-5.7 14C20 35.5 25 42.2 31 45.3M267.3 112h-1.7c-0.8 0-3.6-0.3-3.6-3.5V88.3c0-13.8-10.8-21.3-21-21.3 -5.8 0-11.3 2.4-15 6.5 -4-4.2-9.3-6.5-15-6.5 -3.7 0-10.5 0.8-14.9 5.8 -2.5-3.3-6.4-5-11.5-5H181.3c-0.4 0-0.7 0.3-0.7 0.7v10.2c0 0.4 0.3 0.7 0.7 0.7l1.3 0c2.8 0 4.1 2.2 4.1 4.4v24.3c0 2-1.9 3.9-4 3.9H181.3c-0.4 0-0.7 0.3-0.7 0.7v10.3c0 0.4 0.3 0.7 0.7 0.7h23.4c0.4 0 0.7-0.3 0.7-0.7V112.7c0-0.4-0.3-0.7-0.7-0.7h-6.6c0.9-0.8 1.6-2 1.6-3.9V95.5c0-12.6 2.2-16.1 10-16.1 6.7 0 9.1 3 9.1 10.9v17.5c0 2-1.1 4.2-3.6 4.2h-1.7c-0.4 0-0.7 0.3-0.7 0.7v10.2c0 0.4 0.3 0.7 0.7 0.7h23.4c0.4 0 0.7-0.3 0.7-0.7V112.7c0-0.4-0.3-0.7-0.7-0.7h-6.4c1.1-1.2 1.4-3 1.4-3.9v-20.5c0-5.3 3-8.3 8.5-8.3 6.2 0 8.6 3.1 8.6 11.2v18.6c0 9.7 5.2 14.4 15.8 14.4h2.5c0.4 0 0.7-0.3 0.7-0.7V112.7C268 112.3 267.7 112 267.3 112M115 75.7c4.7 5.3 7.3 12.5 7.3 20.3 0 16.7-10.9 28.4-26.6 28.4 -16.5 0-27.2-11.2-27.2-28.5 0-7.9 2.5-15 7.1-20.2 4.9-5.5 11.9-8.4 20.1-8.4C103.3 67.3 110.1 70.3 115 75.7M108.9 95.9c0-10.1-5.2-16.4-13.4-16.4 -8.9 0-13.4 5.5-13.4 16.3 0 10.1 5.2 16.4 13.7 16.4C103.8 112.2 108.9 106 108.9 95.9M317.8 114.9c0.1 0.1 0.2 0.3 0.2 0.5 0 0.2-0.1 0.4-0.2 0.5 -0.2 0.2-0.4 0.4-0.6 0.5 -6.3 5.1-13.7 7.9-20.7 7.9 -16.6 0-27.4-11.2-27.4-28.5 0-19.7 13.6-28.6 26.3-28.6 14.2 0 24.9 10.7 24.9 25 0 4.9-4.1 10.2-11.6 10.2h-20.7c-1.8 0-3.3-0.2-4.7-0.5 1 3.8 3.9 10.3 12.4 10.3 5.2 0 9.5-1.7 14.2-5.6 0.3-0.2 0.7-0.2 1 0.1 3.3 3.8 3.7 4.3 3.9 4.5C314.7 111.4 314.8 111.5 317.8 114.9M283.2 89.6c0 0.5 1 0.8 3.1 0.8h18c3.2 0 3.2-0.6 3.2-0.8 0-4.9-4.8-10.2-12.5-10.2C288 79.4 283.2 84.8 283.2 89.6M172.3 75.7c4.7 5.3 7.3 12.5 7.3 20.3 0 16.7-10.9 28.4-26.6 28.4 -16.5 0-27.2-11.2-27.2-28.5 0-7.9 2.5-15 7.1-20.2 4.9-5.5 11.9-8.4 20.1-8.4C160.6 67.3 167.5 70.3 172.3 75.7M166.3 95.9c0-10.1-5.2-16.4-13.4-16.4 -8.9 0-13.4 5.5-13.4 16.3 0 10.1 5.2 16.4 13.7 16.4C161.2 112.2 166.3 106 166.3 95.9\"></path></svg>"

/***/ })

},["lVK7"]);


// WEBPACK FOOTER //
// assets/app.8a09862b80663e8ece7c.js